// Generated by Haxe 4.1.5
(function ($hx_exports, $global) { "use strict";
$hx_exports["Validator"] = $hx_exports["Validator"] || {};
$hx_exports["com"] = $hx_exports["com"] || {};
$hx_exports["com"]["nevosoft"] = $hx_exports["com"]["nevosoft"] || {};
$hx_exports["com"]["nevosoft"]["waw"] = $hx_exports["com"]["nevosoft"]["waw"] || {};
$hx_exports["com"]["nevosoft"]["waw"]["data"] = $hx_exports["com"]["nevosoft"]["waw"]["data"] || {};
var $estr = function() { return js_Boot.__string_rec(this,''); },$hxEnums = $hxEnums || {},$_;
function $extend(from, fields) {
	var proto = Object.create(from);
	for (var name in fields) proto[name] = fields[name];
	if( fields.toString !== Object.prototype.toString ) proto.toString = fields.toString;
	return proto;
}
var EReg = function(r,opt) {
	this.r = new RegExp(r,opt.split("u").join(""));
};
EReg.__name__ = true;
EReg.prototype = {
	match: function(s) {
		if(this.r.global) {
			this.r.lastIndex = 0;
		}
		this.r.m = this.r.exec(s);
		this.r.s = s;
		return this.r.m != null;
	}
	,matched: function(n) {
		if(this.r.m != null && n >= 0 && n < this.r.m.length) {
			return this.r.m[n];
		} else {
			throw haxe_Exception.thrown("EReg::matched");
		}
	}
	,matchedRight: function() {
		if(this.r.m == null) {
			throw haxe_Exception.thrown("No string matched");
		}
		var sz = this.r.m.index + this.r.m[0].length;
		return HxOverrides.substr(this.r.s,sz,this.r.s.length - sz);
	}
	,matchedPos: function() {
		if(this.r.m == null) {
			throw haxe_Exception.thrown("No string matched");
		}
		return { pos : this.r.m.index, len : this.r.m[0].length};
	}
	,__class__: EReg
};
var HxOverrides = function() { };
HxOverrides.__name__ = true;
HxOverrides.cca = function(s,index) {
	var x = s.charCodeAt(index);
	if(x != x) {
		return undefined;
	}
	return x;
};
HxOverrides.substr = function(s,pos,len) {
	if(len == null) {
		len = s.length;
	} else if(len < 0) {
		if(pos == 0) {
			len = s.length + len;
		} else {
			return "";
		}
	}
	return s.substr(pos,len);
};
HxOverrides.remove = function(a,obj) {
	var i = a.indexOf(obj);
	if(i == -1) {
		return false;
	}
	a.splice(i,1);
	return true;
};
HxOverrides.now = function() {
	return Date.now();
};
var Lambda = function() { };
Lambda.__name__ = true;
Lambda.foreach = function(it,f) {
	var x = $getIterator(it);
	while(x.hasNext()) {
		var x1 = x.next();
		if(!f(x1)) {
			return false;
		}
	}
	return true;
};
Lambda.fold = function(it,f,first) {
	var x = $getIterator(it);
	while(x.hasNext()) {
		var x1 = x.next();
		first = f(x1,first);
	}
	return first;
};
Lambda.count = function(it,pred) {
	var n = 0;
	if(pred == null) {
		var _ = $getIterator(it);
		while(_.hasNext()) {
			var _1 = _.next();
			++n;
		}
	} else {
		var x = $getIterator(it);
		while(x.hasNext()) {
			var x1 = x.next();
			if(pred(x1)) {
				++n;
			}
		}
	}
	return n;
};
var Log = function() { };
Log.__name__ = true;
Log.info = function(message,p_posInfo) {
};
Log.error = function(message,p_posInfo) {
};
Log.warning = function(message,p_posInfo) {
};
Log.debug = function(message,p_posInfo) {
};
Log.logImpl = function(level,message,p_posInfo) {
	var pos = "" + p_posInfo.fileName + ":" + p_posInfo.lineNumber;
	console.log("src/Log.hx:43:","[" + pos + "]: " + message);
};
Math.__name__ = true;
var Maybe = {};
Maybe.exists = function(this1) {
	return this1 != null;
};
Maybe.sure = function(this1,errorMessage) {
	if(errorMessage == null) {
		errorMessage = "No value";
	}
	return this1;
};
Maybe.or = function(this1,def) {
	if(this1 != null) {
		return this1;
	} else {
		return def;
	}
};
Maybe.may = function(this1,fn) {
	if(this1 != null) {
		fn(this1);
	}
};
Maybe.map = function(this1,fn) {
	if(this1 != null) {
		return fn(this1);
	} else {
		return null;
	}
};
Maybe.mapDefault = function(this1,fn,def) {
	if(this1 != null) {
		return fn(this1);
	} else {
		return def;
	}
};
var Reflect = function() { };
Reflect.__name__ = true;
Reflect.field = function(o,field) {
	try {
		return o[field];
	} catch( _g ) {
		return null;
	}
};
Reflect.getProperty = function(o,field) {
	var tmp;
	if(o == null) {
		return null;
	} else {
		var tmp1;
		if(o.__properties__) {
			tmp = o.__properties__["get_" + field];
			tmp1 = tmp;
		} else {
			tmp1 = false;
		}
		if(tmp1) {
			return o[tmp]();
		} else {
			return o[field];
		}
	}
};
Reflect.fields = function(o) {
	var a = [];
	if(o != null) {
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		for( var f in o ) {
		if(f != "__id__" && f != "hx__closures__" && hasOwnProperty.call(o,f)) {
			a.push(f);
		}
		}
	}
	return a;
};
Reflect.isFunction = function(f) {
	if(typeof(f) == "function") {
		return !(f.__name__ || f.__ename__);
	} else {
		return false;
	}
};
Reflect.compareMethods = function(f1,f2) {
	if(f1 == f2) {
		return true;
	}
	if(!Reflect.isFunction(f1) || !Reflect.isFunction(f2)) {
		return false;
	}
	if(f1.scope == f2.scope && f1.method == f2.method) {
		return f1.method != null;
	} else {
		return false;
	}
};
Reflect.deleteField = function(o,field) {
	if(!Object.prototype.hasOwnProperty.call(o,field)) {
		return false;
	}
	delete(o[field]);
	return true;
};
Reflect.copy = function(o) {
	if(o == null) {
		return null;
	}
	var o2 = { };
	var _g = 0;
	var _g1 = Reflect.fields(o);
	while(_g < _g1.length) {
		var f = _g1[_g];
		++_g;
		o2[f] = Reflect.field(o,f);
	}
	return o2;
};
var Std = function() { };
Std.__name__ = true;
Std.string = function(s) {
	return js_Boot.__string_rec(s,"");
};
Std.parseInt = function(x) {
	if(x != null) {
		var _g = 0;
		var _g1 = x.length;
		while(_g < _g1) {
			var i = _g++;
			var c = x.charCodeAt(i);
			if(c <= 8 || c >= 14 && c != 32 && c != 45) {
				var nc = x.charCodeAt(i + 1);
				var v = parseInt(x,nc == 120 || nc == 88 ? 16 : 10);
				if(isNaN(v)) {
					return null;
				} else {
					return v;
				}
			}
		}
	}
	return null;
};
var StringBuf = function() {
	this.b = "";
};
StringBuf.__name__ = true;
StringBuf.prototype = {
	__class__: StringBuf
};
var ValueType = $hxEnums["ValueType"] = { __ename__ : true, __constructs__ : ["TNull","TInt","TFloat","TBool","TObject","TFunction","TClass","TEnum","TUnknown"]
	,TNull: {_hx_index:0,__enum__:"ValueType",toString:$estr}
	,TInt: {_hx_index:1,__enum__:"ValueType",toString:$estr}
	,TFloat: {_hx_index:2,__enum__:"ValueType",toString:$estr}
	,TBool: {_hx_index:3,__enum__:"ValueType",toString:$estr}
	,TObject: {_hx_index:4,__enum__:"ValueType",toString:$estr}
	,TFunction: {_hx_index:5,__enum__:"ValueType",toString:$estr}
	,TClass: ($_=function(c) { return {_hx_index:6,c:c,__enum__:"ValueType",toString:$estr}; },$_.__params__ = ["c"],$_)
	,TEnum: ($_=function(e) { return {_hx_index:7,e:e,__enum__:"ValueType",toString:$estr}; },$_.__params__ = ["e"],$_)
	,TUnknown: {_hx_index:8,__enum__:"ValueType",toString:$estr}
};
var Type = function() { };
Type.__name__ = true;
Type.getEnum = function(o) {
	if(o == null) {
		return null;
	}
	return $hxEnums[o.__enum__];
};
Type.typeof = function(v) {
	switch(typeof(v)) {
	case "boolean":
		return ValueType.TBool;
	case "function":
		if(v.__name__ || v.__ename__) {
			return ValueType.TObject;
		}
		return ValueType.TFunction;
	case "number":
		if(Math.ceil(v) == v % 2147483648.0) {
			return ValueType.TInt;
		}
		return ValueType.TFloat;
	case "object":
		if(v == null) {
			return ValueType.TNull;
		}
		var e = v.__enum__;
		if(e != null) {
			return ValueType.TEnum($hxEnums[e]);
		}
		var c = js_Boot.getClass(v);
		if(c != null) {
			return ValueType.TClass(c);
		}
		return ValueType.TObject;
	case "string":
		return ValueType.TClass(String);
	case "undefined":
		return ValueType.TNull;
	default:
		return ValueType.TUnknown;
	}
};
Type.enumParameters = function(e) {
	var enm = $hxEnums[e.__enum__];
	var ctorName = enm.__constructs__[e._hx_index];
	var params = enm[ctorName].__params__;
	if(params != null) {
		var _g = [];
		var _g1 = 0;
		while(_g1 < params.length) {
			var p = params[_g1];
			++_g1;
			_g.push(e[p]);
		}
		return _g;
	} else {
		return [];
	}
};
var UInt = {};
UInt.toFloat = function(this1) {
	var int = this1;
	if(int < 0) {
		return 4294967296.0 + int;
	} else {
		return int + 0.0;
	}
};
var Validator = function() { };
Validator.__name__ = true;
Validator.validate = $hx_exports["Validator"]["validate"] = function(spineFiles,category,object) {
	var errors = [];
	var imgs_h = Object.create(null);
	var allUsedImages = [];
	var availableSkeletonAnimations = new haxe_ds_StringMap();
	var availableBoundingBoxes_h = Object.create(null);
	var availableTBBs_h = Object.create(null);
	var availableSlots_h = Object.create(null);
	var usedBlendModes_h = Object.create(null);
	var meshes = [];
	var rootPositions_h = Object.create(null);
	var _g = 0;
	while(_g < spineFiles.length) {
		var file = spineFiles[_g];
		++_g;
		var fileName = file.fileName;
		var fileNameLen = fileName.length;
		var _g1 = 0;
		var _g2 = fileNameLen;
		while(_g1 < _g2) {
			var i = _g1++;
			var charCode = HxOverrides.cca(fileName,i);
			if(charCode < 32 || charCode > 126) {
				errors.push("Incorrect fileName: " + fileName + " - contains symbol " + HxOverrides.substr(fileName,i,1) + " at " + i);
			}
		}
		var path = new haxe_io_Path(fileName);
		var ext = path.ext.toUpperCase();
		switch(ext) {
		case "JSON":case "SKEL":
			var dataExtractor = null;
			if(ext == "JSON") {
				if(file.content == null) {
					errors.push("skeleton is null: " + fileName);
				} else {
					dataExtractor = new utils_JsonSpineDataExtractor(file.content);
				}
			} else if(ext == "SKEL") {
				if(file.content == null) {
					errors.push("skeleton is null: " + fileName);
				} else {
					dataExtractor = new utils_BinarySpineDataExtractor(haxe_crypto_Base64.decode(file.content));
				}
			}
			if(dataExtractor != null) {
				allUsedImages = allUsedImages.concat(dataExtractor.images);
				var skeleton = path.file;
				if(!Object.prototype.hasOwnProperty.call(availableSkeletonAnimations.h,skeleton)) {
					var v = [];
					availableSkeletonAnimations.h[skeleton] = v;
				}
				var v1 = availableSkeletonAnimations.h[skeleton].concat(dataExtractor.animations);
				availableSkeletonAnimations.h[skeleton] = v1;
				var v2 = dataExtractor.boundingBoxes;
				availableBoundingBoxes_h[skeleton] = v2;
				var v3 = dataExtractor.slots;
				availableSlots_h[skeleton] = v3;
				var v4 = dataExtractor.blendModes;
				usedBlendModes_h[skeleton] = v4;
				meshes = dataExtractor.meshes;
				var v5 = dataExtractor.rootPosition;
				rootPositions_h[skeleton] = v5;
				if(dataExtractor.tBBPoints != null) {
					var v6 = dataExtractor.tBBPoints;
					availableTBBs_h[skeleton] = v6;
				}
			}
			break;
		case "PNG":
			imgs_h[fileName] = file;
			break;
		default:
		}
	}
	var _g = 0;
	var _g1 = allUsedImages.length;
	while(_g < _g1) {
		var i = _g++;
		var img = allUsedImages[i];
		allUsedImages[i] = "" + img + ".png";
	}
	var _g = 0;
	while(_g < allUsedImages.length) {
		var img = allUsedImages[_g];
		++_g;
		if(!Object.prototype.hasOwnProperty.call(imgs_h,img)) {
			errors.push("No attachment: " + img);
		}
	}
	var img = haxe_ds_StringMap.keysIterator(imgs_h);
	while(img.hasNext()) {
		var img1 = img.next();
		if(allUsedImages.indexOf(img1) < 0) {
			errors.push("Unnecessary image: " + img1);
		}
	}
	var animConfig = utils_AnimationDataGenerator.getAnimationData(category,object);
	if(animConfig.animationData.length == 0) {
		return errors;
	}
	var missingSkeletons = [];
	var missingAnimations_h = Object.create(null);
	var _g = 0;
	var _g1 = animConfig.animationData;
	while(_g < _g1.length) {
		var anim = _g1[_g];
		++_g;
		var useFallback = animConfig.useFallback && (anim.needFallback == null || anim.needFallback == true);
		if(anim.skeletonName == null) {
			errors.push("Configuration error: skeletonName not specified");
			continue;
		} else if(anim.animationName == null) {
			errors.push("Configuration error: animationName not specified");
			continue;
		}
		if(!Validator.hasSkeletonAnimation(anim.skeletonName,anim.animationName,availableSkeletonAnimations)) {
			if(useFallback) {
				if(anim.fallbackSkeletonName == null) {
					errors.push("Configuration error: fallbackSkeletonName not specified");
				} else if(anim.fallbackAnimationName == null) {
					errors.push("Configuration error: fallbackAnimationName not specified");
				} else if(!Validator.hasSkeleton(anim.fallbackSkeletonName,availableSkeletonAnimations)) {
					if(missingSkeletons.indexOf(anim.fallbackSkeletonName) < 0) {
						missingSkeletons.push(anim.fallbackSkeletonName);
					}
				} else if(!Validator.hasSkeletonAnimation(anim.fallbackSkeletonName,anim.fallbackAnimationName,availableSkeletonAnimations)) {
					if(!Object.prototype.hasOwnProperty.call(missingAnimations_h,anim.fallbackSkeletonName)) {
						missingAnimations_h[anim.fallbackSkeletonName] = [];
					}
					if(missingAnimations_h[anim.fallbackSkeletonName].indexOf(anim.fallbackAnimationName) < 0) {
						missingAnimations_h[anim.fallbackSkeletonName].push(anim.fallbackAnimationName);
					}
				}
			} else if(anim.needFallback == null || anim.needFallback == true) {
				if(!Validator.hasSkeleton(anim.skeletonName,availableSkeletonAnimations)) {
					if(missingSkeletons.indexOf(anim.skeletonName) < 0) {
						missingSkeletons.push(anim.skeletonName);
					}
				} else {
					if(!Object.prototype.hasOwnProperty.call(missingAnimations_h,anim.skeletonName)) {
						missingAnimations_h[anim.skeletonName] = [];
					}
					if(missingAnimations_h[anim.skeletonName].indexOf(anim.animationName) < 0) {
						missingAnimations_h[anim.skeletonName].push(anim.animationName);
					}
				}
			}
		}
	}
	var _g = 0;
	while(_g < missingSkeletons.length) {
		var skeleton = missingSkeletons[_g];
		++_g;
		errors.push("No skeleton: " + skeleton);
	}
	var skeleton = haxe_ds_StringMap.keysIterator(missingAnimations_h);
	while(skeleton.hasNext()) {
		var skeleton1 = skeleton.next();
		var animations = missingAnimations_h[skeleton1];
		var _g = 0;
		while(_g < animations.length) {
			var animation = animations[_g];
			++_g;
			errors.push("No animation: " + animation + " in " + skeleton1);
		}
	}
	if(animConfig.hasVBB) {
		var skeleton = haxe_ds_StringMap.keysIterator(availableBoundingBoxes_h);
		while(skeleton.hasNext()) {
			var skeleton1 = skeleton.next();
			var skeletonBoxes = availableBoundingBoxes_h[skeleton1];
			if(skeletonBoxes.indexOf("VBB") < 0) {
				errors.push("No VBB for skeleton " + skeleton1);
			}
		}
	}
	if(animConfig.hasTBB) {
		var skeleton = haxe_ds_StringMap.keysIterator(availableBoundingBoxes_h);
		while(skeleton.hasNext()) {
			var skeleton1 = skeleton.next();
			var skeletonBoxes = availableBoundingBoxes_h[skeleton1];
			if(skeletonBoxes.indexOf("TBB") < 0) {
				errors.push("No TBB for skeleton " + skeleton1);
			}
			if(Object.prototype.hasOwnProperty.call(availableTBBs_h,skeleton1)) {
				var vertices = availableTBBs_h[skeleton1];
				var count = vertices.length / 2 | 0;
				var sign = 0.0;
				var r = 0.0;
				var _g = 0;
				var _g1 = count;
				while(_g < _g1) {
					var i = _g++;
					var index1 = i;
					var index2 = (i + 1) % count;
					var index3 = (i + 2) % count;
					var x1 = vertices[index1 * 2];
					var y1 = vertices[index1 * 2 + 1];
					var x2 = vertices[index2 * 2];
					var y2 = vertices[index2 * 2 + 1];
					var x3 = vertices[index3 * 2];
					var y3 = vertices[index3 * 2 + 1];
					var ABx = x2 - x1;
					var ABy = y2 - y1;
					var BCx = x3 - x2;
					var BCy = y3 - y2;
					var prod = ABx * BCy - ABy * BCx;
					if(prod != 0.0 && sign == 0.0) {
						sign = prod;
					}
					if(prod != 0.0 && sign != 0.0 && prod * sign < 0.0) {
						errors.push("TBB for skeleton " + skeleton1 + " is not convex");
						break;
					}
				}
			}
		}
	}
	var allSkeletonsFromConfig = Validator.getAllSkeletonsFromConfig(animConfig);
	var skeleton = haxe_ds_StringMap.keysIterator(availableSkeletonAnimations.h);
	while(skeleton.hasNext()) {
		var skeleton1 = skeleton.next();
		if(allSkeletonsFromConfig.indexOf(skeleton1) < 0) {
			errors.push("Unnecessary skeleton " + skeleton1);
		}
	}
	if(animConfig.requiredSlots != null) {
		var _g = 0;
		var _g1 = animConfig.requiredSlots;
		while(_g < _g1.length) {
			var requiredSlot = _g1[_g];
			++_g;
			var requiredSlotNames = requiredSlot.requiredSlotNames;
			var availableSlotNames = availableSlots_h[requiredSlot.skeletonName];
			if(availableSlotNames == null) {
				errors.push("Missing skeleton " + requiredSlot.skeletonName);
			} else {
				var _g2 = 0;
				while(_g2 < requiredSlotNames.length) {
					var slotName = requiredSlotNames[_g2];
					++_g2;
					if(availableSlotNames.indexOf(slotName) < 0) {
						errors.push("No slot " + slotName + " for skeleton " + requiredSlot.skeletonName);
					}
				}
			}
		}
	}
	if(animConfig.format == 1 || animConfig.format == 3) {
		if(meshes.length > 0) {
			errors.push("Unexpected mesh attachments: " + Std.string(meshes));
		}
	}
	var skeleton = haxe_ds_StringMap.keysIterator(usedBlendModes_h);
	while(skeleton.hasNext()) {
		var skeleton1 = skeleton.next();
		var blendModes = usedBlendModes_h[skeleton1];
		var blendMode = blendModes.iterator();
		while(blendMode.hasNext()) {
			var blendMode1 = blendMode.next();
			if(blendMode1 != 0 && blendMode1 != 1) {
				errors.push("Unsupported blend mode " + blendMode1 + " in " + skeleton1);
			}
		}
	}
	var skeleton = haxe_ds_StringMap.keysIterator(rootPositions_h);
	while(skeleton.hasNext()) {
		var skeleton1 = skeleton.next();
		var rootPosition = rootPositions_h[skeleton1];
		if(Math.abs(rootPosition.x) > 2 || Math.abs(rootPosition.y) > 2) {
			errors.push("Incorrect root bone position in " + skeleton1 + ": (" + rootPosition.x + "; " + rootPosition.y + ") (it should be at 0; 0)");
		}
	}
	return errors;
};
Validator.getEvents = function(spineFiles) {
	var events = [];
	var _g = 0;
	while(_g < spineFiles.length) {
		var file = spineFiles[_g];
		++_g;
		var path = new haxe_io_Path(file.fileName);
		var ext = path.ext.toUpperCase();
		switch(ext) {
		case "JSON":case "SKEL":
			var dataExtractor = null;
			if(ext == "JSON") {
				if(file.content != null) {
					dataExtractor = new utils_JsonSpineDataExtractor(file.content);
				}
			} else if(ext == "SKEL") {
				if(file.content != null) {
					dataExtractor = new utils_BinarySpineDataExtractor(haxe_crypto_Base64.decode(file.content));
				}
			}
			if(dataExtractor != null) {
				var _g1 = 0;
				var _g2 = dataExtractor.events;
				while(_g1 < _g2.length) {
					var event = _g2[_g1];
					++_g1;
					if(events.indexOf(event) < 0) {
						events.push(event);
					}
				}
			}
			break;
		default:
		}
	}
	return events;
};
Validator.hasSkeletonAnimation = function(skeleton,animation,availableSkeletonAnimations) {
	if(Object.prototype.hasOwnProperty.call(availableSkeletonAnimations.h,skeleton)) {
		return availableSkeletonAnimations.h[skeleton].indexOf(animation) >= 0;
	} else {
		return false;
	}
};
Validator.hasSkeleton = function(skeleton,availableSkeletonAnimations) {
	return Object.prototype.hasOwnProperty.call(availableSkeletonAnimations.h,skeleton);
};
Validator.getAllSkeletonsFromConfig = function(config) {
	var result = [];
	var _g = 0;
	var _g1 = config.animationData;
	while(_g < _g1.length) {
		var animData = _g1[_g];
		++_g;
		result.push(animData.skeletonName);
		if(animData.fallbackSkeletonName != null) {
			result.push(animData.fallbackSkeletonName);
		}
	}
	return result;
};
var com_nevosoft_isoframework_ICleanable = function() { };
com_nevosoft_isoframework_ICleanable.__name__ = true;
com_nevosoft_isoframework_ICleanable.__isInterface__ = true;
com_nevosoft_isoframework_ICleanable.prototype = {
	__class__: com_nevosoft_isoframework_ICleanable
};
var com_nevosoft_isoframework_Point3D = function(x,y,z) {
	if(z == null) {
		z = 0;
	}
	if(y == null) {
		y = 0;
	}
	if(x == null) {
		x = 0;
	}
	this.x = x;
	this.y = y;
	this.z = z;
};
com_nevosoft_isoframework_Point3D.__name__ = true;
com_nevosoft_isoframework_Point3D.sum = function(a,b,result) {
	var res = result == null ? new com_nevosoft_isoframework_Point3D() : result;
	res.setTo(a.x + b.x,a.y + b.y,a.z + b.z);
	return res;
};
com_nevosoft_isoframework_Point3D.difference = function(a,b,result) {
	var res = result == null ? new com_nevosoft_isoframework_Point3D() : result;
	res.setTo(a.x - b.x,a.y - b.y,a.z - b.z);
	return res;
};
com_nevosoft_isoframework_Point3D.middle = function(a,b,result) {
	var res = result == null ? new com_nevosoft_isoframework_Point3D() : result;
	res.setTo((a.x + b.x) / 2,(a.y + b.y) / 2,(a.z + b.z) / 2);
	return res;
};
com_nevosoft_isoframework_Point3D.dot = function(a,b) {
	return a.x * b.x + a.y * b.y;
};
com_nevosoft_isoframework_Point3D.prototype = {
	setTo: function(nx,ny,nz) {
		this.x = nx;
		this.y = ny;
		this.z = nz;
	}
	,rotate: function(deg,result) {
		if(deg == -90) {
			this.perp(result,true);
		} else if(deg == 90) {
			this.perp(result,false);
		}
		var rad = deg * Math.PI / 180;
		var sin = Math.sin(rad);
		var cos = Math.cos(rad);
		var rx = cos * this.x - sin * this.y;
		var ry = sin * this.x + cos * this.y;
		result.x = rx;
		result.y = ry;
	}
	,perp: function(result,right) {
		result.setTo(right ? this.y : -this.y,right ? -this.x : this.x,0);
	}
	,isEqual: function(p) {
		if(this.x == p.x && this.y == p.y) {
			return this.z == p.z;
		} else {
			return false;
		}
	}
	,clone: function() {
		return new com_nevosoft_isoframework_Point3D(this.x,this.y,this.z);
	}
	,copy: function(p) {
		this.x = p.x;
		this.y = p.y;
		this.z = p.z;
	}
	,length: function(squared) {
		if(squared == null) {
			squared = false;
		}
		var squaredLength = this.x * this.x + this.y * this.y + this.z * this.z;
		if(squared) {
			return squaredLength;
		} else {
			return Math.sqrt(squaredLength);
		}
	}
	,normalize: function() {
		var l = this.length();
		if(l == 0) {
			return;
		}
		this.x /= l;
		this.y /= l;
		this.z /= l;
	}
	,subtract: function(p) {
		this.x -= p.x;
		this.y -= p.y;
		this.z -= p.z;
	}
	,add: function(p) {
		this.x += p.x;
		this.y += p.y;
		this.z += p.z;
	}
	,offset: function(x,y,z) {
		this.x += x;
		this.y += y;
		this.z += z;
	}
	,scale: function(s) {
		this.x *= s;
		this.y *= s;
		this.z *= s;
	}
	,floor: function() {
		this.x = Math.floor(this.x);
		this.y = Math.floor(this.y);
		this.z = Math.floor(this.z);
	}
	,toString: function() {
		return "x: " + this.x + ", y: " + this.y;
	}
	,__class__: com_nevosoft_isoframework_Point3D
};
var com_nevosoft_isoframework_WorkerTask = function(work,cb) {
	this.work = work;
	this.cb = cb;
	this.sessionId = com_nevosoft_isoframework_WorkManager.get_instance().sessionId;
};
com_nevosoft_isoframework_WorkerTask.__name__ = true;
com_nevosoft_isoframework_WorkerTask.prototype = {
	__class__: com_nevosoft_isoframework_WorkerTask
};
var com_nevosoft_isoframework_WorkManager = function() {
	this.tickTimeQuota = 0.016;
	this.sessionId = -1;
	this._queue = [];
};
com_nevosoft_isoframework_WorkManager.__name__ = true;
com_nevosoft_isoframework_WorkManager.__properties__ = {get_instance:"get_instance"};
com_nevosoft_isoframework_WorkManager.get_instance = function() {
	if(com_nevosoft_isoframework_WorkManager.instance == null) {
		com_nevosoft_isoframework_WorkManager.instance = new com_nevosoft_isoframework_WorkManager();
	}
	return com_nevosoft_isoframework_WorkManager.instance;
};
com_nevosoft_isoframework_WorkManager.prototype = {
	initMainThread: function() {
	}
	,queueOnMainThread: function(work) {
		this._queue.push(work);
	}
	,queueOnWorkThread: function(task,threadId) {
		if(threadId == null) {
			threadId = 0;
		}
		this._queue.push(task.work);
		this._queue.push(task.cb);
	}
	,update: function() {
		var work = this._queue.shift();
		if(work != null) {
			work();
		}
	}
	,setTickTimeQuota: function(value) {
		this.tickTimeQuota = value;
	}
	,pause: function() {
		if(this.timer != null) {
			this.timer.stop();
			this.timer = null;
		}
	}
	,resume: function() {
		this.timer = new haxe_Timer(16);
		this.timer.run = $bind(this,this.update);
	}
	,stop: function() {
		this.sessionId = -1;
		if(this.timer != null) {
			this.timer.stop();
			this.timer = null;
		}
	}
	,start: function() {
		if(this.sessionId >= 0) {
			throw haxe_Exception.thrown("WorkManager already started");
		}
		com_nevosoft_isoframework_WorkManager._lastSessionID++;
		this.sessionId = com_nevosoft_isoframework_WorkManager._lastSessionID;
		this.timer = new haxe_Timer(16);
		this.timer.run = $bind(this,this.update);
	}
	,addWorkThread: function(threadId) {
	}
	,isActiveSessionTask: function(task) {
		return task.sessionId == this.sessionId;
	}
	,__class__: com_nevosoft_isoframework_WorkManager
};
var com_nevosoft_isoframework_loader_ILoader = function() { };
com_nevosoft_isoframework_loader_ILoader.__name__ = true;
com_nevosoft_isoframework_loader_ILoader.__isInterface__ = true;
com_nevosoft_isoframework_loader_ILoader.__interfaces__ = [com_nevosoft_isoframework_ICleanable];
com_nevosoft_isoframework_loader_ILoader.prototype = {
	__class__: com_nevosoft_isoframework_loader_ILoader
	,__properties__: {set_content:"set_content",set_url:"set_url"}
};
var com_nevosoft_isoframework_loader_LoaderEventType = $hxEnums["com.nevosoft.isoframework.loader.LoaderEventType"] = { __ename__ : true, __constructs__ : ["Cancel","Complete","Fail"]
	,Cancel: {_hx_index:0,__enum__:"com.nevosoft.isoframework.loader.LoaderEventType",toString:$estr}
	,Complete: {_hx_index:1,__enum__:"com.nevosoft.isoframework.loader.LoaderEventType",toString:$estr}
	,Fail: ($_=function(error) { return {_hx_index:2,error:error,__enum__:"com.nevosoft.isoframework.loader.LoaderEventType",toString:$estr}; },$_.__params__ = ["error"],$_)
};
var com_nevosoft_isoframework_loader_LoaderErrorType = $hxEnums["com.nevosoft.isoframework.loader.LoaderErrorType"] = { __ename__ : true, __constructs__ : ["IO","Security","Format","Api"]
	,IO: ($_=function(info) { return {_hx_index:0,info:info,__enum__:"com.nevosoft.isoframework.loader.LoaderErrorType",toString:$estr}; },$_.__params__ = ["info"],$_)
	,Security: ($_=function(info) { return {_hx_index:1,info:info,__enum__:"com.nevosoft.isoframework.loader.LoaderErrorType",toString:$estr}; },$_.__params__ = ["info"],$_)
	,Format: ($_=function(info) { return {_hx_index:2,info:info,__enum__:"com.nevosoft.isoframework.loader.LoaderErrorType",toString:$estr}; },$_.__params__ = ["info"],$_)
	,Api: ($_=function(info,data) { return {_hx_index:3,info:info,data:data,__enum__:"com.nevosoft.isoframework.loader.LoaderErrorType",toString:$estr}; },$_.__params__ = ["info","data"],$_)
};
var com_nevosoft_isoframework_loader_LoaderError = function(errType,url) {
	this.isDefaultPrevented = false;
	this.errorType = errType;
	this.url = url;
};
com_nevosoft_isoframework_loader_LoaderError.__name__ = true;
com_nevosoft_isoframework_loader_LoaderError.prototype = {
	preventDefault: function(val) {
		this.isDefaultPrevented = val;
	}
	,statEventParams: function(reason) {
		var errorTypeStr;
		var errorInfo;
		var errorDataCode = 0;
		var errorDataMessage = "";
		var _g = this.errorType;
		switch(_g._hx_index) {
		case 0:
			var info = _g.info;
			errorTypeStr = "IO";
			errorInfo = info;
			break;
		case 1:
			var info = _g.info;
			errorTypeStr = "Security";
			errorInfo = info;
			break;
		case 2:
			var info = _g.info;
			errorTypeStr = "Format";
			errorInfo = info;
			break;
		case 3:
			var data = _g.data;
			var info = _g.info;
			errorTypeStr = "Api";
			errorInfo = info;
			errorDataCode = data.code;
			errorDataMessage = data.message;
			break;
		}
		var params = { reason : reason, isDefaultPrevented : this.isDefaultPrevented, url : this.url, errorTypeStr : errorTypeStr, errorInfo : errorInfo, errorDataCode : errorDataCode, errorDataMessage : errorDataMessage};
		return params;
	}
	,__class__: com_nevosoft_isoframework_loader_LoaderError
};
var com_nevosoft_isoframework_script_Action = function() { };
com_nevosoft_isoframework_script_Action.__name__ = true;
com_nevosoft_isoframework_script_Action.__isInterface__ = true;
com_nevosoft_isoframework_script_Action.__interfaces__ = [com_nevosoft_isoframework_ICleanable];
com_nevosoft_isoframework_script_Action.prototype = {
	__class__: com_nevosoft_isoframework_script_Action
};
var com_nevosoft_isoframework_space__$CollisionMap_RowContext = function() {
};
com_nevosoft_isoframework_space__$CollisionMap_RowContext.__name__ = true;
com_nevosoft_isoframework_space__$CollisionMap_RowContext.allocate = function(idx,startX,endX) {
	var row;
	if(com_nevosoft_isoframework_space__$CollisionMap_RowContext._pool != null) {
		row = com_nevosoft_isoframework_space__$CollisionMap_RowContext._pool;
		com_nevosoft_isoframework_space__$CollisionMap_RowContext._pool = com_nevosoft_isoframework_space__$CollisionMap_RowContext._pool.next;
		row.next = null;
	} else {
		row = new com_nevosoft_isoframework_space__$CollisionMap_RowContext();
	}
	row.idx = idx;
	row.startX = startX;
	row.endX = endX;
	return row;
};
com_nevosoft_isoframework_space__$CollisionMap_RowContext.free = function(row) {
	row.next = com_nevosoft_isoframework_space__$CollisionMap_RowContext._pool;
	com_nevosoft_isoframework_space__$CollisionMap_RowContext._pool = row;
	return null;
};
com_nevosoft_isoframework_space__$CollisionMap_RowContext.prototype = {
	cutInterval: function(from,to) {
		if(to <= this.startX || from >= this.endX) {
			return null;
		}
		var row = com_nevosoft_isoframework_space__$CollisionMap_RowContext.allocate(this.idx,Math.floor(Math.min(to,this.endX)),this.endX);
		this.endX = Math.floor(Math.max(this.startX,from));
		return row;
	}
	,__class__: com_nevosoft_isoframework_space__$CollisionMap_RowContext
};
var com_nevosoft_isoframework_space_CollisionMap = function(width,height,tileEdge) {
	this._freeTilesValid = false;
	this._walkableTilesValid = false;
	this._freeBigTileCount = 0;
	this._walkableMiddleTileCount = 0;
	this._helperCoordinatesArray = [];
	this._bigWidth = width;
	this._bigHeight = height;
	this._bigTileEdge = tileEdge;
	this._middleWidth = this._bigWidth << 1;
	this._middleHeight = this._bigHeight << 1;
	this._middleTilesCount = this.get_middleWidth() * this.get_middleHeight();
	this._middleTileEdge = this._bigTileEdge >> 1;
	var this1 = new Array(this.get_middleTilesCount());
	this._tiles = this1;
	var this1 = new Array(this.get_middleTilesCount());
	this.passbilityTiles = this1;
	this._walkableMiddleTilesCoordinates = [];
	this.passabilityValidator = new com_nevosoft_isoframework_space_PassabilityValidator(this);
};
com_nevosoft_isoframework_space_CollisionMap.__name__ = true;
com_nevosoft_isoframework_space_CollisionMap.__interfaces__ = [com_nevosoft_isoframework_ICleanable];
com_nevosoft_isoframework_space_CollisionMap.prototype = {
	init: function() {
		var _g = 0;
		var _g1 = this.get_middleHeight();
		while(_g < _g1) {
			var row = _g++;
			var _g2 = 0;
			var _g3 = this.get_middleWidth();
			while(_g2 < _g3) {
				var col = _g2++;
				if(!(col < 0 || row < 0 || col >= this.get_middleWidth() || row >= this.get_middleHeight())) {
					var _g4 = col + row * this.get_middleWidth();
					this._tiles[_g4] |= 1;
					if(this.canMoveToTile(col,row)) {
						this.passbilityTiles[col + row * this.get_middleWidth()] = 0;
					} else {
						this.passbilityTiles[col + row * this.get_middleWidth()] = 1;
					}
				}
				this._walkableTilesValid = false;
				this._freeTilesValid = false;
			}
		}
	}
	,getPassabilityTiles: function(checkFunction) {
		if(checkFunction == null) {
			checkFunction = $bind(this,this.canMoveToTile);
		}
		var this1 = new Array(this.get_middleTilesCount());
		var tiles = this1;
		var _g = 0;
		var _g1 = this.get_middleWidth();
		while(_g < _g1) {
			var x = _g++;
			var _g2 = 0;
			var _g3 = this.get_middleHeight();
			while(_g2 < _g3) {
				var y = _g2++;
				if(checkFunction(x,y)) {
					tiles[x + y * this.get_middleWidth()] = 0;
				} else {
					tiles[x + y * this.get_middleWidth()] = 1;
				}
			}
		}
		return tiles.slice(0);
	}
	,validatePassbility: function(startX,startY,callback) {
		this.passabilityValidator.vaidate(startX,startY,callback);
	}
	,cleanup: function() {
		this._tiles = null;
		this._helperCoordinatesArray = null;
		this._walkableMiddleTilesCoordinates = null;
		this._freeBigTilesCoordinates = null;
	}
	,reSize: function(dw,dh) {
		var nBigWidth = this._bigWidth + dw;
		var nBigHeight = this._bigHeight + dh;
		var nMiddleWidth = nBigWidth << 1;
		var nMiddleHeight = nBigHeight << 1;
		var nMiddleTilesCount = nMiddleWidth * nMiddleHeight;
		var this1 = new Array(nMiddleTilesCount);
		var nTiles = this1;
		var _g = 0;
		var _g1 = nMiddleHeight;
		while(_g < _g1) {
			var row = _g++;
			var _g2 = 0;
			var _g3 = nMiddleWidth;
			while(_g2 < _g3) {
				var col = _g2++;
				var value = col < 0 || row < 0 || col >= this.get_middleWidth() || row >= this.get_middleHeight() ? -1 : this._tiles[col + row * this.get_middleWidth()];
				nTiles[col + row * nMiddleWidth] = value == -1 ? 1 : value;
			}
		}
		this._bigWidth = nBigWidth;
		this._bigHeight = nBigHeight;
		this._middleWidth = nMiddleWidth;
		this._middleHeight = nMiddleHeight;
		this._middleTilesCount = nMiddleTilesCount;
		this._tiles = nTiles;
	}
	,validate: function() {
		this._validate();
	}
	,canMoveToTile: function(x,y) {
		var unSetValue = com_nevosoft_waw_data_constants_CollisionConst.blockedTileMask;
		var value = x < 0 || y < 0 || x >= this.get_middleWidth() || y >= this.get_middleHeight() ? -1 : this._tiles[x + y * this.get_middleWidth()];
		var allowPartionUnSet = false;
		var allowPartionSet = false;
		if(allowPartionSet == null) {
			allowPartionSet = false;
		}
		if(allowPartionUnSet == null) {
			allowPartionUnSet = false;
		}
		if(value == -1) {
			return false;
		} else {
			var testPassed = !allowPartionSet ? (value & 1) == 1 : (value & 1) != 0;
			testPassed = testPassed && (!allowPartionUnSet ? (value & unSetValue) == 0 : unSetValue != 0 ? (value & unSetValue) != unSetValue : true);
			return testPassed;
		}
	}
	,GetMiddleTileValue: function(x,y) {
		if(x < 0 || y < 0 || x >= this.get_middleWidth() || y >= this.get_middleHeight()) {
			return -1;
		} else {
			return this._tiles[x + y * this.get_middleWidth()];
		}
	}
	,SetMiddleTileValue: function(x,y,value) {
		if(!(x < 0 || y < 0 || x >= this.get_middleWidth() || y >= this.get_middleHeight())) {
			var _g = x + y * this.get_middleWidth();
			this._tiles[_g] |= value;
			if(this.canMoveToTile(x,y)) {
				this.passbilityTiles[x + y * this.get_middleWidth()] = 0;
			} else {
				this.passbilityTiles[x + y * this.get_middleWidth()] = 1;
			}
		}
		this._walkableTilesValid = false;
		this._freeTilesValid = false;
	}
	,UnSetMiddleTileValue: function(x,y,value) {
		if(!(x < 0 || y < 0 || x >= this.get_middleWidth() || y >= this.get_middleHeight())) {
			var _g = x + y * this.get_middleWidth();
			this._tiles[_g] &= ~value;
			if(this.canMoveToTile(x,y)) {
				this.passbilityTiles[x + y * this.get_middleWidth()] = 0;
			} else {
				this.passbilityTiles[x + y * this.get_middleWidth()] = 1;
			}
		}
		this._walkableTilesValid = false;
		this._freeTilesValid = false;
	}
	,GetTileIdx: function(x,y) {
		if(x < 0 || y < 0 || x >= this.get_middleWidth() || y >= this.get_middleHeight()) {
			return -1;
		} else {
			return x + y * this.get_middleWidth();
		}
	}
	,GetBigTileValue: function(x,y) {
		var x1 = (x << 1) + 1;
		var y1 = (y << 1) + 1;
		var x2 = (x << 1) + 1;
		var y2 = y << 1;
		var x3 = x << 1;
		var y3 = (y << 1) + 1;
		var x4 = x << 1;
		var y4 = y << 1;
		return (x1 < 0 || y1 < 0 || x1 >= this.get_middleWidth() || y1 >= this.get_middleHeight() ? -1 : this._tiles[x1 + y1 * this.get_middleWidth()]) | (x2 < 0 || y2 < 0 || x2 >= this.get_middleWidth() || y2 >= this.get_middleHeight() ? -1 : this._tiles[x2 + y2 * this.get_middleWidth()]) | (x3 < 0 || y3 < 0 || x3 >= this.get_middleWidth() || y3 >= this.get_middleHeight() ? -1 : this._tiles[x3 + y3 * this.get_middleWidth()]) | (x4 < 0 || y4 < 0 || x4 >= this.get_middleWidth() || y4 >= this.get_middleHeight() ? -1 : this._tiles[x4 + y4 * this.get_middleWidth()]);
	}
	,GetBasePointOfTile: function(x,y,result) {
		var r = result == null ? new com_nevosoft_isoframework_Point3D() : result;
		r.setTo(x * this.get_middleTileEdge(),y * this.get_middleTileEdge(),0);
		return r;
	}
	,GetTileUnderPoint: function(x,y,result) {
		var r = result == null ? new com_nevosoft_isoframework_utils_IntTile() : result;
		var xx = Math.floor(x / this.get_middleTileEdge());
		var yy = Math.floor(y / this.get_middleTileEdge());
		r.x = xx;
		r.y = yy;
		r.value = xx < 0 || yy < 0 || xx >= this.get_middleWidth() || yy >= this.get_middleHeight() ? -1 : this._tiles[xx + yy * this.get_middleWidth()];
		return r;
	}
	,GetTileInDirection: function(x,y,d,result,scale) {
		if(scale == null) {
			scale = 1;
		}
		var xx = Math.floor(x + d.x * scale + 0.5);
		var yy = Math.floor(y + d.y * scale + 0.5);
		result.x = xx;
		result.y = yy;
		result.value = xx < 0 || yy < 0 || xx >= this.get_middleWidth() || yy >= this.get_middleHeight() ? -1 : this._tiles[xx + yy * this.get_middleWidth()];
	}
	,manipulateRectangle: function(x,y,width,height,unSetValue,setValue) {
		var right = x + width;
		var bottom = y + height;
		var _g = y;
		var _g1 = bottom;
		while(_g < _g1) {
			var row = _g++;
			var _g2 = x;
			var _g3 = right;
			while(_g2 < _g3) {
				var col = _g2++;
				if(unSetValue != 0) {
					if(!(col < 0 || row < 0 || col >= this.get_middleWidth() || row >= this.get_middleHeight())) {
						var _g4 = col + row * this.get_middleWidth();
						this._tiles[_g4] &= ~unSetValue;
						if(this.canMoveToTile(col,row)) {
							this.passbilityTiles[col + row * this.get_middleWidth()] = 0;
						} else {
							this.passbilityTiles[col + row * this.get_middleWidth()] = 1;
						}
					}
					this._walkableTilesValid = false;
					this._freeTilesValid = false;
				}
				if(setValue != 0) {
					if(!(col < 0 || row < 0 || col >= this.get_middleWidth() || row >= this.get_middleHeight())) {
						var _g5 = col + row * this.get_middleWidth();
						this._tiles[_g5] |= setValue;
						if(this.canMoveToTile(col,row)) {
							this.passbilityTiles[col + row * this.get_middleWidth()] = 0;
						} else {
							this.passbilityTiles[col + row * this.get_middleWidth()] = 1;
						}
					}
					this._walkableTilesValid = false;
					this._freeTilesValid = false;
				}
			}
		}
	}
	,checkTileValue: function(x,y,unSetValue,setValue,allowPartionUnSet,allowPartionSet) {
		if(allowPartionSet == null) {
			allowPartionSet = false;
		}
		if(allowPartionUnSet == null) {
			allowPartionUnSet = false;
		}
		var value = x < 0 || y < 0 || x >= this.get_middleWidth() || y >= this.get_middleHeight() ? -1 : this._tiles[x + y * this.get_middleWidth()];
		var allowPartionUnSet1 = allowPartionUnSet;
		var allowPartionSet1 = allowPartionSet;
		if(allowPartionSet1 == null) {
			allowPartionSet1 = false;
		}
		if(allowPartionUnSet1 == null) {
			allowPartionUnSet1 = false;
		}
		if(value == -1) {
			return false;
		} else {
			var testPassed = !allowPartionSet1 ? (value & setValue) == setValue : setValue != 0 ? (value & setValue) != 0 : true;
			testPassed = testPassed && (!allowPartionUnSet1 ? (value & unSetValue) == 0 : unSetValue != 0 ? (value & unSetValue) != unSetValue : true);
			return testPassed;
		}
	}
	,checkValue: function(value,unSetValue,setValue,allowPartionUnSet,allowPartionSet) {
		if(allowPartionSet == null) {
			allowPartionSet = false;
		}
		if(allowPartionUnSet == null) {
			allowPartionUnSet = false;
		}
		if(value == -1) {
			return false;
		}
		var testPassed = !allowPartionSet ? (value & setValue) == setValue : setValue != 0 ? (value & setValue) != 0 : true;
		testPassed = testPassed && (!allowPartionUnSet ? (value & unSetValue) == 0 : unSetValue != 0 ? (value & unSetValue) != unSetValue : true);
		return testPassed;
	}
	,getClosestTileFiltered: function(x,y,filter,result,depth) {
		result.x = -1;
		result.y = -1;
		result.value = -1;
		var minD = Infinity;
		var fy = y - depth;
		var ty = y + depth + 1;
		var fx = x - depth;
		var tx = x + depth + 1;
		var _g = fy;
		var _g1 = ty;
		while(_g < _g1) {
			var row = _g++;
			var _g2 = fx;
			var _g3 = tx;
			while(_g2 < _g3) {
				var col = _g2++;
				if(col == x && row == y) {
					continue;
				}
				var d = com_nevosoft_isoframework_utils_MathUtils.GetDistance2(col,row,x,y,false);
				if(filter(col,row) && d < minD) {
					result.x = col;
					result.y = row;
					result.value = col < 0 || row < 0 || col >= this.get_middleWidth() || row >= this.get_middleHeight() ? -1 : this._tiles[col + row * this.get_middleWidth()];
					minD = d;
				}
			}
		}
	}
	,GetClosestTileWithValue: function(x,y,unSetValue,setValue,result,depth) {
		result.x = -1;
		result.y = -1;
		result.value = -1;
		var minD = Infinity;
		var fy = y - depth;
		var ty = y + depth + 1;
		var fx = x - depth;
		var tx = x + depth + 1;
		var _g = fy;
		var _g1 = ty;
		while(_g < _g1) {
			var row = _g++;
			var _g2 = fx;
			var _g3 = tx;
			while(_g2 < _g3) {
				var col = _g2++;
				if(col == x && row == y) {
					continue;
				}
				var d = com_nevosoft_isoframework_utils_MathUtils.GetDistance2(col,row,x,y,false);
				var value = col < 0 || row < 0 || col >= this.get_middleWidth() || row >= this.get_middleHeight() ? -1 : this._tiles[col + row * this.get_middleWidth()];
				var allowPartionUnSet = false;
				var allowPartionSet = false;
				if(allowPartionSet == null) {
					allowPartionSet = false;
				}
				if(allowPartionUnSet == null) {
					allowPartionUnSet = false;
				}
				var tmp;
				if(value == -1) {
					tmp = false;
				} else {
					var testPassed = !allowPartionSet ? (value & setValue) == setValue : setValue != 0 ? (value & setValue) != 0 : true;
					testPassed = testPassed && (!allowPartionUnSet ? (value & unSetValue) == 0 : unSetValue != 0 ? (value & unSetValue) != unSetValue : true);
					tmp = testPassed;
				}
				if(tmp && d < minD) {
					result.x = col;
					result.y = row;
					result.value = col < 0 || row < 0 || col >= this.get_middleWidth() || row >= this.get_middleHeight() ? -1 : this._tiles[col + row * this.get_middleWidth()];
					minD = d;
				}
			}
		}
	}
	,GetRandomWalkableTile: function(result) {
		var r = result == null ? new com_nevosoft_isoframework_utils_IntTile() : result;
		this._validate();
		r.x = -1;
		r.y = -1;
		r.value = -1;
		var set = this._walkableMiddleTilesCoordinates;
		var idx = this._walkableMiddleTileCount;
		if(idx > 0) {
			var random = com_nevosoft_isoframework_utils_MathUtils.getRandomValue(0,idx - 1,Math.random);
			idx = random << 1;
			r.x = set[idx];
			r.y = set[idx + 1];
			var x = r.x;
			var y = r.y;
			r.value = x < 0 || y < 0 || x >= this.get_middleWidth() || y >= this.get_middleHeight() ? -1 : this._tiles[x + y * this.get_middleWidth()];
		}
		return r;
	}
	,GetAllTilesWithValue: function(x,y,w,h,unSetValue,setValue,result) {
		var coords = 0;
		var _g = y;
		var _g1 = y + h;
		while(_g < _g1) {
			var row = _g++;
			var _g2 = x;
			var _g3 = x + w;
			while(_g2 < _g3) {
				var col = _g2++;
				var value = col < 0 || row < 0 || col >= this.get_middleWidth() || row >= this.get_middleHeight() ? -1 : this._tiles[col + row * this.get_middleWidth()];
				var allowPartionUnSet = false;
				var allowPartionSet = false;
				if(allowPartionSet == null) {
					allowPartionSet = false;
				}
				if(allowPartionUnSet == null) {
					allowPartionUnSet = false;
				}
				var tmp;
				if(value == -1) {
					tmp = false;
				} else {
					var testPassed = !allowPartionSet ? (value & setValue) == setValue : setValue != 0 ? (value & setValue) != 0 : true;
					testPassed = testPassed && (!allowPartionUnSet ? (value & unSetValue) == 0 : unSetValue != 0 ? (value & unSetValue) != unSetValue : true);
					tmp = testPassed;
				}
				if(tmp) {
					result[coords++] = col;
					result[coords++] = row;
				}
			}
		}
		return coords >> 1;
	}
	,getAllDesignableAreasInRegion: function(rPosX,rPosY,rW,rH,areaW,areaH,result) {
		var rPosX2 = rPosX << 1;
		var rPosY2 = rPosY << 1;
		var rW2 = rW << 1;
		var rH2 = rH << 1;
		var areaW2 = areaW << 1;
		var areaH2 = areaH << 1;
		var rEdgeX2 = rPosX2 + rW2;
		var rEdgeY2 = rPosY2 + rH2;
		var head = null;
		var idx = rEdgeY2 - areaH2;
		while(idx >= rPosY2) {
			var row = com_nevosoft_isoframework_space__$CollisionMap_RowContext.allocate(idx,rPosX2,rEdgeX2);
			row.next = head;
			head = row;
			idx -= 2;
		}
		var resultLength = 0;
		while(head != null) {
			var areaX2 = this.getFirstDesignableAreaInRow(head,areaW2,areaH2);
			if(areaX2 != -1) {
				result[resultLength++] = areaX2 >> 1;
				result[resultLength++] = head.idx >> 1;
				var tillRow = head;
				while(tillRow != null && tillRow.idx < head.idx + areaH2) tillRow = tillRow.next;
				var currentRow = head;
				while(currentRow != tillRow) {
					var cutResult = currentRow.cutInterval(areaX2,areaX2 + areaW2);
					if(cutResult != null) {
						cutResult.next = currentRow.next;
						currentRow.next = cutResult;
						currentRow = cutResult;
					}
					currentRow = currentRow.next;
				}
			}
			var trash = head;
			head = head.next;
			trash = com_nevosoft_isoframework_space__$CollisionMap_RowContext.free(trash);
		}
		return resultLength >> 1;
	}
	,getFirstDesignableAreaInRow: function(rowContext,areaW,areaH) {
		var col = rowContext.startX;
		var row = rowContext.idx;
		while(col <= rowContext.endX - areaW) if(this.tryToConstructArea(col,row,areaW,areaH,com_nevosoft_waw_data_constants_CollisionConst.notDesignableTileMask,0,2)) {
			return col;
		} else {
			col += 2;
		}
		return -1;
	}
	,tryToConstructArea: function(fromX,fromY,areaW,areaH,unSetValue,setValue,checkStep) {
		if(checkStep == null) {
			checkStep = 1;
		}
		var toX = fromX + areaW;
		var toY = fromY + areaH;
		var row = fromY;
		while(row < toY) {
			var col = fromX;
			while(col < toX) {
				var value = col < 0 || row < 0 || col >= this.get_middleWidth() || row >= this.get_middleHeight() ? -1 : this._tiles[col + row * this.get_middleWidth()];
				var allowPartionUnSet = false;
				var allowPartionSet = false;
				if(allowPartionSet == null) {
					allowPartionSet = false;
				}
				if(allowPartionUnSet == null) {
					allowPartionUnSet = false;
				}
				var tmp;
				if(value == -1) {
					tmp = false;
				} else {
					var testPassed = !allowPartionSet ? (value & setValue) == setValue : setValue != 0 ? (value & setValue) != 0 : true;
					testPassed = testPassed && (!allowPartionUnSet ? (value & unSetValue) == 0 : unSetValue != 0 ? (value & unSetValue) != unSetValue : true);
					tmp = testPassed;
				}
				if(!tmp) {
					return false;
				}
				col += checkStep;
			}
			row += checkStep;
		}
		return true;
	}
	,getPassabilityGroup: function(x,y) {
		return this.passabilityValidator.getPassabilityGroup(x,y);
	}
	,toArray: function() {
		return this._tiles.slice(0);
	}
	,_coordinatesOutOfMap: function(x,y) {
		if(!(x < 0 || y < 0 || x >= this.get_middleWidth())) {
			return y >= this.get_middleHeight();
		} else {
			return true;
		}
	}
	,_validate: function() {
		this._validateWalkableTiles();
	}
	,_invalidate: function() {
		this._walkableTilesValid = false;
		this._freeTilesValid = false;
	}
	,_validateWalkableTiles: function() {
		if(this._walkableTilesValid) {
			return;
		}
		var idx = 0;
		var _g = 0;
		var _g1 = this.get_middleHeight();
		while(_g < _g1) {
			var row = _g++;
			var _g2 = 0;
			var _g3 = this.get_middleWidth();
			while(_g2 < _g3) {
				var col = _g2++;
				var unSetValue = com_nevosoft_waw_data_constants_CollisionConst.blockedTileMask;
				var value = col < 0 || row < 0 || col >= this.get_middleWidth() || row >= this.get_middleHeight() ? -1 : this._tiles[col + row * this.get_middleWidth()];
				var allowPartionUnSet = false;
				var allowPartionSet = false;
				if(allowPartionSet == null) {
					allowPartionSet = false;
				}
				if(allowPartionUnSet == null) {
					allowPartionUnSet = false;
				}
				var tmp;
				if(value == -1) {
					tmp = false;
				} else {
					var testPassed = !allowPartionSet ? (value & 1) == 1 : (value & 1) != 0;
					testPassed = testPassed && (!allowPartionUnSet ? (value & unSetValue) == 0 : unSetValue != 0 ? (value & unSetValue) != unSetValue : true);
					tmp = testPassed;
				}
				if(tmp) {
					this._walkableMiddleTilesCoordinates[idx++] = col;
					this._walkableMiddleTilesCoordinates[idx++] = row;
				}
			}
		}
		this._walkableMiddleTileCount = idx >> 1;
		this._walkableTilesValid = true;
	}
	,_validateFreeTiles: function() {
		if(this._freeTilesValid) {
			return;
		}
		var idx = 0;
		var row = 0;
		while(row < this._middleHeight) {
			var col = 0;
			while(col < this._middleWidth) {
				var unSetValue = com_nevosoft_waw_data_constants_CollisionConst.blockedTileMask;
				var value = col < 0 || row < 0 || col >= this.get_middleWidth() || row >= this.get_middleHeight() ? -1 : this._tiles[col + row * this.get_middleWidth()];
				var allowPartionUnSet = false;
				var allowPartionSet = false;
				if(allowPartionSet == null) {
					allowPartionSet = false;
				}
				if(allowPartionUnSet == null) {
					allowPartionUnSet = false;
				}
				var tmp;
				if(value == -1) {
					tmp = false;
				} else {
					var testPassed = allowPartionSet || (value & 0) == 0;
					testPassed = testPassed && (!allowPartionUnSet ? (value & unSetValue) == 0 : unSetValue != 0 ? (value & unSetValue) != unSetValue : true);
					tmp = testPassed;
				}
				if(tmp) {
					this._freeBigTilesCoordinates[idx++] = col;
					this._freeBigTilesCoordinates[idx++] = row;
				}
				col += 2;
			}
			row += 2;
		}
		this._freeBigTileCount = idx >> 1;
		this._freeTilesValid = true;
	}
	,print: function(unsetValue,setValue,filter,strictUnset,strictSet) {
		if(strictSet == null) {
			strictSet = true;
		}
		if(strictUnset == null) {
			strictUnset = true;
		}
		console.log("src/com/nevosoft/isoframework/space/CollisionMap.hx:640:","------------------COLLISION MAP---------------------");
		var _g = 0;
		var _g1 = this.get_middleHeight();
		while(_g < _g1) {
			var row = _g++;
			var str = "";
			var _g2 = 0;
			var _g3 = this.get_middleWidth();
			while(_g2 < _g3) {
				var col = _g2++;
				var allowPartionUnSet = !strictUnset;
				var allowPartionSet = !strictSet;
				if(allowPartionSet == null) {
					allowPartionSet = false;
				}
				if(allowPartionUnSet == null) {
					allowPartionUnSet = false;
				}
				var value = col < 0 || row < 0 || col >= this.get_middleWidth() || row >= this.get_middleHeight() ? -1 : this._tiles[col + row * this.get_middleWidth()];
				var allowPartionUnSet1 = allowPartionUnSet;
				var allowPartionSet1 = allowPartionSet;
				if(allowPartionSet1 == null) {
					allowPartionSet1 = false;
				}
				if(allowPartionUnSet1 == null) {
					allowPartionUnSet1 = false;
				}
				var v;
				if(value == -1) {
					v = false;
				} else {
					var testPassed = !allowPartionSet1 ? (value & setValue) == setValue : setValue != 0 ? (value & setValue) != 0 : true;
					testPassed = testPassed && (!allowPartionUnSet1 ? (value & unsetValue) == 0 : unsetValue != 0 ? (value & unsetValue) != unsetValue : true);
					v = testPassed;
				}
				var v1 = v ? 0 : 1;
				if(filter != null && !filter(col,row)) {
					v1 = 1;
				}
				str += "" + v1;
			}
			console.log("src/com/nevosoft/isoframework/space/CollisionMap.hx:654:",str);
		}
	}
	,printPassability: function() {
		console.log("src/com/nevosoft/isoframework/space/CollisionMap.hx:660:","------------------PASSABILITY MAP---------------------");
		var _g = 0;
		var _g1 = this.get_middleHeight();
		while(_g < _g1) {
			var row = _g++;
			var str = "";
			var _g2 = 0;
			var _g3 = this.get_middleWidth();
			while(_g2 < _g3) {
				var col = _g2++;
				var v = this.passbilityTiles[row * this.get_middleWidth() + col];
				str += "" + v;
			}
			console.log("src/com/nevosoft/isoframework/space/CollisionMap.hx:670:",str);
		}
	}
	,printCheckValue: function(x,y,unSetValue,setValue,allowPartionUnSet,allowPartionSet) {
		if(allowPartionSet == null) {
			allowPartionSet = false;
		}
		if(allowPartionUnSet == null) {
			allowPartionUnSet = false;
		}
		console.log("src/com/nevosoft/isoframework/space/CollisionMap.hx:676:","---------------CHECK COLLISION---------------");
		console.log("src/com/nevosoft/isoframework/space/CollisionMap.hx:677:",this.toBinaryString(x < 0 || y < 0 || x >= this.get_middleWidth() || y >= this.get_middleHeight() ? -1 : this._tiles[x + y * this.get_middleWidth()]));
		console.log("src/com/nevosoft/isoframework/space/CollisionMap.hx:678:",this.toBinaryString(unSetValue));
		console.log("src/com/nevosoft/isoframework/space/CollisionMap.hx:679:",this.toBinaryString(setValue));
		var allowPartionUnSet1 = allowPartionUnSet;
		var allowPartionSet1 = allowPartionSet;
		if(allowPartionSet1 == null) {
			allowPartionSet1 = false;
		}
		if(allowPartionUnSet1 == null) {
			allowPartionUnSet1 = false;
		}
		var value = x < 0 || y < 0 || x >= this.get_middleWidth() || y >= this.get_middleHeight() ? -1 : this._tiles[x + y * this.get_middleWidth()];
		var allowPartionUnSet = allowPartionUnSet1;
		var allowPartionSet = allowPartionSet1;
		if(allowPartionSet == null) {
			allowPartionSet = false;
		}
		if(allowPartionUnSet == null) {
			allowPartionUnSet = false;
		}
		var tmp;
		if(value == -1) {
			tmp = false;
		} else {
			var testPassed = !allowPartionSet ? (value & setValue) == setValue : setValue != 0 ? (value & setValue) != 0 : true;
			testPassed = testPassed && (!allowPartionUnSet ? (value & unSetValue) == 0 : unSetValue != 0 ? (value & unSetValue) != unSetValue : true);
			tmp = testPassed;
		}
		console.log("src/com/nevosoft/isoframework/space/CollisionMap.hx:680:",tmp);
	}
	,toBinaryString: function(num) {
		var rem = 0;
		var result = "";
		var i = 8;
		while(i > 0) {
			rem = num % 2;
			num >>= 1;
			result += "" + rem;
			--i;
		}
		return result;
	}
	,get_bigWidth: function() {
		return this._bigWidth;
	}
	,get_bigHeight: function() {
		return this._bigHeight;
	}
	,get_bigTileEdge: function() {
		return this._bigTileEdge;
	}
	,get_middleWidth: function() {
		return this._middleWidth;
	}
	,get_middleHeight: function() {
		return this._middleHeight;
	}
	,get_middleTilesCount: function() {
		return this._middleTilesCount;
	}
	,get_middleTileEdge: function() {
		return this._middleTileEdge;
	}
	,__class__: com_nevosoft_isoframework_space_CollisionMap
	,__properties__: {get_middleTileEdge:"get_middleTileEdge",get_middleTilesCount:"get_middleTilesCount",get_middleHeight:"get_middleHeight",get_middleWidth:"get_middleWidth",get_bigTileEdge:"get_bigTileEdge",get_bigHeight:"get_bigHeight",get_bigWidth:"get_bigWidth"}
};
var com_nevosoft_isoframework_space_PassabilityMap = function(width,height,isPassable) {
	var hrtime = process.hrtime();
	var ts = hrtime[0] + hrtime[1] / 1e9;
	this.isPassable = isPassable;
	this.width = width;
	this.height = height;
	this.tiles = [];
	var _g = 0;
	var _g1 = width;
	while(_g < _g1) {
		var i = _g++;
		var _g2 = 0;
		var _g3 = height;
		while(_g2 < _g3) {
			var j = _g2++;
			this.tiles[i + j * width] = new com_nevosoft_isoframework_space__$PassabilityMap_PassTile(i,j);
		}
	}
	var _g = 0;
	var _g1 = this.tiles;
	while(_g < _g1.length) {
		var t = _g1[_g];
		++_g;
		var nX = -1 + t.x;
		var nY = -1 + t.y;
		if(nX >= 0 && nY >= 0 && nX < width && nY < height) {
			t.neighbours.push(this.getTile(-1 + t.x,-1 + t.y));
		}
		var nX1 = -1 + t.x;
		var nY1 = t.y;
		if(nX1 >= 0 && nY1 >= 0 && nX1 < width && nY1 < height) {
			t.neighbours.push(this.getTile(-1 + t.x,t.y));
		}
		var nX2 = -1 + t.x;
		var nY2 = 1 + t.y;
		if(nX2 >= 0 && nY2 >= 0 && nX2 < width && nY2 < height) {
			t.neighbours.push(this.getTile(-1 + t.x,1 + t.y));
		}
		var nX3 = t.x;
		var nY3 = -1 + t.y;
		if(nX3 >= 0 && nY3 >= 0 && nX3 < width && nY3 < height) {
			t.neighbours.push(this.getTile(t.x,-1 + t.y));
		}
		var nX4 = t.x;
		var nY4 = 1 + t.y;
		if(nX4 >= 0 && nY4 >= 0 && nX4 < width && nY4 < height) {
			t.neighbours.push(this.getTile(t.x,1 + t.y));
		}
		var nX5 = 1 + t.x;
		var nY5 = -1 + t.y;
		if(nX5 >= 0 && nY5 >= 0 && nX5 < width && nY5 < height) {
			t.neighbours.push(this.getTile(1 + t.x,-1 + t.y));
		}
		var nX6 = 1 + t.x;
		var nY6 = t.y;
		if(nX6 >= 0 && nY6 >= 0 && nX6 < width && nY6 < height) {
			t.neighbours.push(this.getTile(1 + t.x,t.y));
		}
		var nX7 = 1 + t.x;
		var nY7 = 1 + t.y;
		if(nX7 >= 0 && nY7 >= 0 && nX7 < width && nY7 < height) {
			t.neighbours.push(this.getTile(1 + t.x,1 + t.y));
		}
	}
	var hrtime = process.hrtime();
	console.log("src/com/nevosoft/isoframework/space/PassabilityMap.hx:55:","pass map init time " + (hrtime[0] + hrtime[1] / 1e9 - ts));
};
com_nevosoft_isoframework_space_PassabilityMap.__name__ = true;
com_nevosoft_isoframework_space_PassabilityMap.prototype = {
	checkTile: function(x,y) {
		if(com_nevosoft_isoframework_space_PassabilityMap.enabled) {
			var t = this.getTile(x,y);
			if(t != null) {
				return t.value == 0;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
	,toArray: function() {
		var arr = [];
		var _g = 0;
		var _g1 = this.tiles;
		while(_g < _g1.length) {
			var t = _g1[_g];
			++_g;
			arr.push(t.value);
		}
		return arr;
	}
	,print: function() {
		console.log("src/com/nevosoft/isoframework/space/PassabilityMap.hx:84:","------------------PASSABILITY MAP---------------------");
		var _g = 0;
		var _g1 = this.height;
		while(_g < _g1) {
			var j = _g++;
			var row = "";
			var _g2 = 0;
			var _g3 = this.width;
			while(_g2 < _g3) {
				var i = _g2++;
				row += "" + this.getTile(i,j).value;
			}
			console.log("src/com/nevosoft/isoframework/space/PassabilityMap.hx:92:",row);
		}
	}
	,validate: function(startX,startY) {
		if(startY == null) {
			startY = 0;
		}
		if(startX == null) {
			startX = 0;
		}
		var hrtime = process.hrtime();
		var ts = hrtime[0] + hrtime[1] / 1e9;
		var _g = 0;
		var _g1 = this.width * this.height;
		while(_g < _g1) {
			var i = _g++;
			this.tiles[i].value = 1;
			this.tiles[i].status = com_nevosoft_isoframework_space__$PassabilityMap_PassTile.UNKNOWN;
		}
		var startPoint = this.getTile(startX,startY);
		this.opened = [];
		this.open(startPoint);
		while(this.opened.length > 0) {
			var curr = this.opened.pop();
			this.close(curr);
			var _g = 0;
			var _g1 = curr.neighbours;
			while(_g < _g1.length) {
				var n = _g1[_g];
				++_g;
				if(n.status == com_nevosoft_isoframework_space__$PassabilityMap_PassTile.UNKNOWN) {
					if(this.isPassable(n.x,n.y)) {
						this.open(n);
					} else {
						this.close(n);
					}
				}
			}
		}
	}
	,getTile: function(x,y) {
		return this.tiles[x + y * this.width];
	}
	,open: function(t) {
		this.opened.push(t);
		t.status = com_nevosoft_isoframework_space__$PassabilityMap_PassTile.OPENED;
		t.value = 0;
	}
	,close: function(t) {
		t.status = com_nevosoft_isoframework_space__$PassabilityMap_PassTile.CLOSED;
	}
	,__class__: com_nevosoft_isoframework_space_PassabilityMap
};
var com_nevosoft_isoframework_space__$PassabilityMap_PassTile = function(x,y) {
	if(y == null) {
		y = 0;
	}
	if(x == null) {
		x = 0;
	}
	this.status = com_nevosoft_isoframework_space__$PassabilityMap_PassTile.UNKNOWN;
	this.value = 0;
	this.x = x;
	this.y = y;
	this.neighbours = [];
};
com_nevosoft_isoframework_space__$PassabilityMap_PassTile.__name__ = true;
com_nevosoft_isoframework_space__$PassabilityMap_PassTile.prototype = {
	__class__: com_nevosoft_isoframework_space__$PassabilityMap_PassTile
};
var com_nevosoft_isoframework_space_PassabilityValidator = function(collisionMap) {
	this.lastGroupKey = 0;
	this.validationProcessing = false;
	this.collisionMap = collisionMap;
	this.passabilityMap = new com_nevosoft_isoframework_space_PassabilityMap(collisionMap.get_middleWidth(),collisionMap.get_middleHeight(),$bind(this,this.isPassable));
	this.validationQueue = [];
};
com_nevosoft_isoframework_space_PassabilityValidator.__name__ = true;
com_nevosoft_isoframework_space_PassabilityValidator.prototype = {
	vaidate: function(startX,startY,callback) {
		console.log("src/com/nevosoft/isoframework/space/PassabilityValidator.hx:25:","VALIDATE PASSABILITY " + startX + " " + startY);
		var hrtime = process.hrtime();
		this.timestamp = hrtime[0] + hrtime[1] / 1e9;
		var tmp = this.validationQueue;
		var _g = ($_=com_nevosoft_isoframework_WorkManager.get_instance(),$bind($_,$_.queueOnWorkThread));
		var _g1 = ($_=this.passabilityMap,$bind($_,$_.validate));
		var startX1 = startX;
		var startY1 = startY;
		var _g2 = $bind(this,this.onPassabilityValid);
		var callback1 = callback;
		var task = new com_nevosoft_isoframework_WorkerTask(function() {
			_g1(startX1,startY1);
		},function() {
			_g2(callback1);
		});
		var threadId = 3;
		tmp.push(function() {
			_g(task,threadId);
		});
		if(!this.validationProcessing) {
			this.processValidationQueue();
		}
	}
	,getPassabilityGroup: function(x,y) {
		return this.notPassableTilesGroups[x + this.collisionMap.get_middleWidth() * y];
	}
	,processValidationQueue: function() {
		if(this.validationQueue.length > 0) {
			this.validationProcessing = true;
			(this.validationQueue.shift())();
		}
	}
	,onPassabilityValid: function(callback) {
		this.notPassableTilesGroups = [];
		this.lastGroupKey = 0;
		var _g = 0;
		var _g1 = this.collisionMap.get_middleHeight();
		while(_g < _g1) {
			var row = _g++;
			var _g2 = 0;
			var _g3 = this.collisionMap.get_middleWidth();
			while(_g2 < _g3) {
				var col = _g2++;
				var _this = this.collisionMap;
				var value = col < 0 || row < 0 || col >= _this.get_middleWidth() || row >= _this.get_middleHeight() ? -1 : _this._tiles[col + row * _this.get_middleWidth()];
				var allowPartionUnSet = false;
				var allowPartionSet = false;
				if(allowPartionSet == null) {
					allowPartionSet = false;
				}
				if(allowPartionUnSet == null) {
					allowPartionUnSet = false;
				}
				var tmp;
				if(value == -1) {
					tmp = false;
				} else {
					var testPassed = !allowPartionSet ? (value & 1) == 1 : (value & 1) != 0;
					testPassed = testPassed && (!allowPartionUnSet ? (value & 6) == 0 : (value & 6) != 6);
					tmp = testPassed;
				}
				if(tmp) {
					if(!this.passabilityMap.checkTile(col,row)) {
						var _this1 = this.collisionMap;
						if(!(col < 0 || row < 0 || col >= _this1.get_middleWidth() || row >= _this1.get_middleHeight())) {
							var _g4 = col + row * _this1.get_middleWidth();
							_this1._tiles[_g4] |= 8;
							if(_this1.canMoveToTile(col,row)) {
								_this1.passbilityTiles[col + row * _this1.get_middleWidth()] = 0;
							} else {
								_this1.passbilityTiles[col + row * _this1.get_middleWidth()] = 1;
							}
						}
						_this1._walkableTilesValid = false;
						_this1._freeTilesValid = false;
						this.notPassableTilesGroups[col + this.collisionMap.get_middleWidth() * row] = this.lastGroupKey;
					} else {
						var _this2 = this.collisionMap;
						if(!(col < 0 || row < 0 || col >= _this2.get_middleWidth() || row >= _this2.get_middleHeight())) {
							var _g5 = col + row * _this2.get_middleWidth();
							_this2._tiles[_g5] &= -9;
							if(_this2.canMoveToTile(col,row)) {
								_this2.passbilityTiles[col + row * _this2.get_middleWidth()] = 0;
							} else {
								_this2.passbilityTiles[col + row * _this2.get_middleWidth()] = 1;
							}
						}
						_this2._walkableTilesValid = false;
						_this2._freeTilesValid = false;
						this.notPassableTilesGroups[col + this.collisionMap.get_middleWidth() * row] = null;
					}
				}
			}
		}
		this.validateNotPassableGroups();
		var hrtime = process.hrtime();
		this.timestamp = hrtime[0] + hrtime[1] / 1e9;
		callback();
	}
	,validateNotPassableGroups: function() {
		var revalidationStarted = false;
		var _g = 0;
		var _g1 = this.collisionMap.get_middleHeight();
		while(_g < _g1) {
			var y = _g++;
			var _g2 = 0;
			var _g3 = this.collisionMap.get_middleWidth();
			while(_g2 < _g3) {
				var x = _g2++;
				var value = this.notPassableTilesGroups[x + this.collisionMap.get_middleWidth() * y];
				if(value != null && value == 0) {
					com_nevosoft_isoframework_WorkManager.get_instance().queueOnWorkThread(new com_nevosoft_isoframework_WorkerTask((function(_g,startY,startX) {
						return function() {
							_g[0](startX[0],startY[0]);
						};
					})([($_=this.passabilityMap,$bind($_,$_.validate))],[y],[x]),$bind(this,this.onNotPassableValidation)),3);
					revalidationStarted = true;
				}
				if(revalidationStarted) {
					break;
				}
			}
			if(revalidationStarted) {
				break;
			}
		}
		if(!revalidationStarted) {
			var hrtime = process.hrtime();
			this.timestamp = hrtime[0] + hrtime[1] / 1e9;
			this.validationProcessing = false;
			this.processValidationQueue();
		}
	}
	,onNotPassableValidation: function() {
		this.lastGroupKey++;
		var _g = 0;
		var _g1 = this.collisionMap.get_middleHeight();
		while(_g < _g1) {
			var row = _g++;
			var _g2 = 0;
			var _g3 = this.collisionMap.get_middleWidth();
			while(_g2 < _g3) {
				var col = _g2++;
				if(this.passabilityMap.checkTile(col,row)) {
					this.notPassableTilesGroups[col + row * this.collisionMap.get_middleWidth()] = this.lastGroupKey;
				}
			}
		}
		if(this.validationQueue.length > 0) {
			this.processValidationQueue();
		} else {
			this.validateNotPassableGroups();
		}
	}
	,isPassable: function(x,y) {
		var _this = this.collisionMap;
		var value = x < 0 || y < 0 || x >= _this.get_middleWidth() || y >= _this.get_middleHeight() ? -1 : _this._tiles[x + y * _this.get_middleWidth()];
		var allowPartionUnSet = false;
		var allowPartionSet = false;
		if(allowPartionSet == null) {
			allowPartionSet = false;
		}
		if(allowPartionUnSet == null) {
			allowPartionUnSet = false;
		}
		if(value == -1) {
			return false;
		} else {
			var testPassed = allowPartionSet || (value & 0) == 0;
			testPassed = testPassed && (!allowPartionUnSet ? (value & 6) == 0 : (value & 6) != 6);
			return testPassed;
		}
	}
	,printPassabilityGroups: function() {
		console.log("src/com/nevosoft/isoframework/space/PassabilityValidator.hx:152:","------------------PASSABILITY GROUPS---------------------");
		var _g = 0;
		var _g1 = this.collisionMap.get_middleHeight();
		while(_g < _g1) {
			var row = _g++;
			var str = "";
			var _g2 = 0;
			var _g3 = this.collisionMap.get_middleWidth();
			while(_g2 < _g3) {
				var col = _g2++;
				var v = -1;
				if(this.notPassableTilesGroups[col + this.collisionMap.get_middleWidth() * row] != null) {
					v = this.notPassableTilesGroups[col + this.collisionMap.get_middleWidth() * row];
				}
				if(v >= 10) {
					v %= 10;
				}
				if(v >= 0) {
					str += "" + v;
				} else {
					str += " ";
				}
			}
			console.log("src/com/nevosoft/isoframework/space/PassabilityValidator.hx:178:",str);
		}
	}
	,__class__: com_nevosoft_isoframework_space_PassabilityValidator
};
var com_nevosoft_isoframework_utils_CleanupUtils = function() { };
com_nevosoft_isoframework_utils_CleanupUtils.__name__ = true;
com_nevosoft_isoframework_utils_CleanupUtils.cleanup = function(object) {
	if(object != null) {
		object.cleanup();
	}
	return null;
};
com_nevosoft_isoframework_utils_CleanupUtils.cleanupArray = function(array) {
	if(array != null) {
		var _g = 0;
		while(_g < array.length) {
			var item = array[_g];
			++_g;
			com_nevosoft_isoframework_utils_CleanupUtils.cleanup(item);
		}
	}
	return null;
};
com_nevosoft_isoframework_utils_CleanupUtils.cleanupSignal0 = function(signal) {
	if(signal != null) {
		signal.removeAll();
	}
	return null;
};
com_nevosoft_isoframework_utils_CleanupUtils.cleanupSignal1 = function(signal) {
	if(signal != null) {
		signal.removeAll();
	}
	return null;
};
com_nevosoft_isoframework_utils_CleanupUtils.cleanupSignal2 = function(signal) {
	if(signal != null) {
		signal.removeAll();
	}
	return null;
};
var com_nevosoft_isoframework_utils_ISorting = function() { };
com_nevosoft_isoframework_utils_ISorting.__name__ = true;
com_nevosoft_isoframework_utils_ISorting.__isInterface__ = true;
com_nevosoft_isoframework_utils_ISorting.prototype = {
	__class__: com_nevosoft_isoframework_utils_ISorting
};
var com_nevosoft_isoframework_utils_IntTile = function(x,y,value) {
	if(value == null) {
		value = 0;
	}
	if(y == null) {
		y = 0;
	}
	if(x == null) {
		x = 0;
	}
	this.x = x;
	this.y = y;
	this.value = value;
};
com_nevosoft_isoframework_utils_IntTile.__name__ = true;
com_nevosoft_isoframework_utils_IntTile.prototype = {
	setByP3d: function(p3d) {
		this.x = Math.floor(p3d.x);
		this.y = Math.floor(p3d.y);
	}
	,__class__: com_nevosoft_isoframework_utils_IntTile
};
var com_nevosoft_isoframework_utils_Clamping = {};
com_nevosoft_isoframework_utils_Clamping.get = function(this1) {
	return this1;
};
com_nevosoft_isoframework_utils_Clamping.moreThan = function(lhv,rhv) {
	return com_nevosoft_isoframework_utils_Clamping.get(lhv) > com_nevosoft_isoframework_utils_Clamping.get(rhv);
};
com_nevosoft_isoframework_utils_Clamping.lessThan = function(lhv,rhv) {
	return com_nevosoft_isoframework_utils_Clamping.get(lhv) < com_nevosoft_isoframework_utils_Clamping.get(rhv);
};
com_nevosoft_isoframework_utils_Clamping.mul = function(lhv,rhv) {
	return com_nevosoft_isoframework_utils_Clamping.get(lhv) * com_nevosoft_isoframework_utils_Clamping.get(rhv);
};
com_nevosoft_isoframework_utils_Clamping.add = function(lhv,rhv) {
	return com_nevosoft_isoframework_utils_Clamping.get(lhv) + com_nevosoft_isoframework_utils_Clamping.get(rhv);
};
com_nevosoft_isoframework_utils_Clamping.sub = function(lhv,rhv) {
	return com_nevosoft_isoframework_utils_Clamping.get(lhv) - com_nevosoft_isoframework_utils_Clamping.get(rhv);
};
com_nevosoft_isoframework_utils_Clamping.toInt = function(f) {
	return Math.floor(f);
};
var com_nevosoft_isoframework_utils_MathUtils = function() { };
com_nevosoft_isoframework_utils_MathUtils.__name__ = true;
com_nevosoft_isoframework_utils_MathUtils.shuffleArray_Int = function(a,length,randomProvider) {
	var i = length - 1;
	var temp;
	while(i > 0) {
		var j = com_nevosoft_isoframework_utils_MathUtils.getRandomValue(0,i,randomProvider);
		temp = a[j];
		a[j] = a[i];
		a[i] = temp;
		--i;
	}
};
com_nevosoft_isoframework_utils_MathUtils.shuffleArray_shuffleAndDistributeArrayToCount_T = function(a,length,randomProvider) {
	var i = length - 1;
	var temp;
	while(i > 0) {
		var j = com_nevosoft_isoframework_utils_MathUtils.getRandomValue(0,i,randomProvider);
		temp = a[j];
		a[j] = a[i];
		a[i] = temp;
		--i;
	}
};
com_nevosoft_isoframework_utils_MathUtils.nextOrFirst = function(s,e,p) {
	if(p >= e) {
		return s;
	} else {
		return p + 1;
	}
};
com_nevosoft_isoframework_utils_MathUtils.prevOrLast = function(s,e,p) {
	if(p <= s) {
		return e;
	} else {
		return p - 1;
	}
};
com_nevosoft_isoframework_utils_MathUtils.maxInteger = function() {
	return Math.floor(UInt.toFloat(js_Boot.__cast(-1 , Int)) / UInt.toFloat(2));
};
com_nevosoft_isoframework_utils_MathUtils.clamp = function(value,low,high) {
	if(isNaN(value)) {
		return low;
	}
	if(com_nevosoft_isoframework_utils_Clamping.lessThan(value,low)) {
		return low;
	} else if(com_nevosoft_isoframework_utils_Clamping.moreThan(value,high)) {
		return high;
	} else {
		return value;
	}
};
com_nevosoft_isoframework_utils_MathUtils.getRandomValue = function(from,to,randomProvider) {
	var interval = to - from + 1;
	return Math.floor(from + randomProvider() * interval);
};
com_nevosoft_isoframework_utils_MathUtils.getRandomValue2 = function(from,to,randomProvider) {
	var randomV = randomProvider();
	var interval = to - from;
	return from + randomProvider() * interval;
};
com_nevosoft_isoframework_utils_MathUtils.MakeMultiple = function(a,base) {
	return Math.floor(a / base) * base;
};
com_nevosoft_isoframework_utils_MathUtils.normalizeAngle = function(angle) {
	var aMod = Math.abs(angle);
	var ones = Math.floor(aMod / 360);
	var a = aMod - ones * 360;
	if(angle < 0) {
		a = 360 - a;
	}
	return a;
};
com_nevosoft_isoframework_utils_MathUtils.GetDistance2 = function(ax,ay,bx,by,sqrt) {
	if(sqrt == null) {
		sqrt = true;
	}
	var d = (bx - ax) * (bx - ax) + (by - ay) * (by - ay);
	if(sqrt) {
		return Math.sqrt(d);
	} else {
		return d;
	}
};
com_nevosoft_isoframework_utils_MathUtils.GetRandomDistribution = function(range,count,result,randomProvider) {
	var interval = Math.floor(range / count);
	var _g = 0;
	var _g1 = count;
	while(_g < _g1) {
		var i = _g++;
		result[i] = Math.floor(i * interval + randomProvider() * interval);
	}
};
com_nevosoft_isoframework_utils_MathUtils.GetRandomDistribution2 = function(range,count,minInterval,result,randomProvider) {
	var interval = Math.floor(range / count);
	var _g = 0;
	var _g1 = count;
	while(_g < _g1) {
		var i = _g++;
		result[i] = Math.floor(i * interval + Math.max(randomProvider() * interval,minInterval));
	}
};
com_nevosoft_isoframework_utils_MathUtils.fillArray = function(from,step,array,length) {
	var value = from;
	var _g = 0;
	var _g1 = length;
	while(_g < _g1) {
		var i = _g++;
		array[i] = value;
		value += step;
	}
};
com_nevosoft_isoframework_utils_MathUtils.randomChoice = function(a,randomProvider) {
	if(a.length == 0) {
		throw haxe_Exception.thrown("randomChoice: can't choice on empty set");
	}
	var ind = Math.floor(a.length * randomProvider());
	return a[ind];
};
com_nevosoft_isoframework_utils_MathUtils.randomWeightedChoice = function(a,weights,randomProvider) {
	if(a.length == 0) {
		throw haxe_Exception.thrown("try to choice on empty set");
	}
	if(a.length != weights.length) {
		throw haxe_Exception.thrown("choice set and weights must have the same length");
	}
	var total = 0.0;
	var _g = 0;
	while(_g < weights.length) {
		var w = weights[_g];
		++_g;
		total += w;
	}
	var intervalPoint = randomProvider() * total;
	var index = 0;
	var acc = 0.0;
	var _g = 0;
	var _g1 = weights.length;
	while(_g < _g1) {
		var i = _g++;
		var w = weights[i];
		acc += w;
		if(intervalPoint < acc) {
			index = i;
			break;
		}
	}
	return a[index];
};
com_nevosoft_isoframework_utils_MathUtils.randomWeightedChoice2 = function(a,weightProvider,randomProvider) {
	if(a.length == 0) {
		throw haxe_Exception.thrown("try to choice on empty set 2");
	}
	var total = 0.0;
	var _g = 0;
	while(_g < a.length) {
		var elm = a[_g];
		++_g;
		total += weightProvider(elm);
	}
	var intervalPoint = randomProvider() * total;
	var index = 0;
	var acc = 0.0;
	var result = null;
	var _g = 0;
	while(_g < a.length) {
		var elm = a[_g];
		++_g;
		var w = weightProvider(elm);
		acc += w;
		if(intervalPoint < acc) {
			result = elm;
			break;
		}
	}
	return result;
};
com_nevosoft_isoframework_utils_MathUtils.radToDeg = function(rad) {
	return rad * 180 / Math.PI;
};
com_nevosoft_isoframework_utils_MathUtils.degToRad = function(deg) {
	return deg * Math.PI / 180;
};
com_nevosoft_isoframework_utils_MathUtils.isInside = function(left,top,right,bottom,x,y) {
	return !(x < left || x > right || y < top || y > bottom);
};
com_nevosoft_isoframework_utils_MathUtils.binarySearch = function(a,e,start,end) {
	if(end == null) {
		end = -1;
	}
	if(start == null) {
		start = -1;
	}
	var first = start < 0 ? 0 : start;
	var last = end < 0 ? a.length : end;
	var mid;
	var depth = e.getValue();
	if(a.length == 0) {
		return 0;
	}
	if(depth < a[first].getValue()) {
		return first;
	}
	if(depth > a[last - 1].getValue()) {
		return last;
	}
	while(first < last) {
		mid = Math.floor(first + (last - first) / 2);
		if(depth <= a[mid].getValue()) {
			last = mid;
		} else {
			first = mid + 1;
		}
	}
	return last;
};
com_nevosoft_isoframework_utils_MathUtils.flerp = function(a,b,ratio) {
	return a + ratio * (b - a);
};
com_nevosoft_isoframework_utils_MathUtils.round = function(number,precision) {
	if(precision == null) {
		precision = 2;
	}
	return Math.floor(number * Math.pow(10,precision)) / Math.pow(10,precision);
};
var com_nevosoft_waw_BaseDataProviderScope = function(storage,dataProvider) {
	this._storage = storage;
	this._metaIndex = dataProvider.getMetaIndex();
	this._profileIndex = dataProvider.getProfileIndex();
	this._dataProvider = dataProvider;
};
com_nevosoft_waw_BaseDataProviderScope.__name__ = true;
com_nevosoft_waw_BaseDataProviderScope.prototype = {
	__class__: com_nevosoft_waw_BaseDataProviderScope
};
var com_nevosoft_waw_ProfileDataProvider = function(storage,dataProvider) {
	com_nevosoft_waw_BaseDataProviderScope.call(this,storage,dataProvider);
};
com_nevosoft_waw_ProfileDataProvider.__name__ = true;
com_nevosoft_waw_ProfileDataProvider.__super__ = com_nevosoft_waw_BaseDataProviderScope;
com_nevosoft_waw_ProfileDataProvider.prototype = $extend(com_nevosoft_waw_BaseDataProviderScope.prototype,{
	getObjectsWithPeriodicalReward: function() {
		return this._profileIndex.objectsWithPeriodicalReward;
	}
	,getSessionDayNum: function() {
		return this._storage.data.sessionDayNum;
	}
	,getIdfaStartSessionNum: function() {
		return this._storage.data.idfaStartSessionNum;
	}
	,getIdfaPermission: function() {
		return this._storage.data.IDFApermission;
	}
	,getDailyBonusPeriod: function() {
		var result = Std.parseInt(this._dataProvider.meta.getConst("dailyBonusPeriod"));
		if(result == null) {
			throw haxe_Exception.thrown("can't parse");
		}
		return result;
	}
	,getExternalIds: function() {
		return this._storage.data.externalIds;
	}
	,buildingAttacksRemain: function() {
		var mdp = this._dataProvider.meta;
		var nutContext = this._profileIndex.nutContext;
		var nutConfig = mdp.getNutConfig();
		var maxBrokenBuildings = nutConfig.maxBrokenBuildings;
		var ratioBrokenBuildings = nutConfig.ratioBrokenBuildings;
		var max = maxBrokenBuildings == -1 ? ratioBrokenBuildings * nutContext.validBuildings : maxBrokenBuildings;
		var current = nutContext.brokenBuildings;
		return Math.floor(Math.max(0,max - current));
	}
	,getId: function() {
		if(this._storage.data._id == null) {
			return "";
		}
		return this._storage.data._id;
	}
	,getUsedLotteryRewardGroups: function() {
		return this._storage.data.dailyBonus.usedLotteryRewardGroups;
	}
	,getDailyBonusStage: function() {
		return this._storage.data.dailyBonus.currentStage;
	}
	,isTimeToIncreaseDailyBonusStage: function(currentTime) {
		var currDayTimestamp = this.getCurrDaiyBonusStageTimestamp(currentTime);
		var nextStageTimestamp = this.getNextDailyBonusStageTimestamp(this._storage.data.dailyBonus.lastIncreaseTime);
		var resetStageTimestamp = this.getResetDailyBonusStageTimestamp(this._storage.data.dailyBonus.lastIncreaseTime);
		if(currDayTimestamp >= nextStageTimestamp) {
			return currDayTimestamp < resetStageTimestamp;
		} else {
			return false;
		}
	}
	,isTimeToResetDailyBonusStage: function(currentTime) {
		var currDayTimestamp = this.getCurrDaiyBonusStageTimestamp(currentTime);
		var resetStageTimestamp = this.getResetDailyBonusStageTimestamp(this._storage.data.dailyBonus.lastIncreaseTime);
		return currDayTimestamp >= resetStageTimestamp;
	}
	,isDailyBonusRewardCollected: function() {
		if(this.getDailyBonusPeriod() == 0) {
			return true;
		}
		return this._storage.data.dailyBonus.isCollected;
	}
	,getCurrDaiyBonusStageTimestamp: function(ts) {
		return this._dataProvider.timeProvider.getToday(ts);
	}
	,getNextDailyBonusStageTimestamp: function(ts) {
		var tomorrowTs = ts;
		var _g = 0;
		var _g1 = this.getDailyBonusPeriod();
		while(_g < _g1) {
			var i = _g++;
			tomorrowTs = this._dataProvider.timeProvider.getTomorrow(tomorrowTs);
		}
		return tomorrowTs;
	}
	,getResetDailyBonusStageTimestamp: function(ts) {
		var tomorrowTs = ts;
		var _g = 0;
		var _g1 = 2 * this.getDailyBonusPeriod();
		while(_g < _g1) {
			var i = _g++;
			tomorrowTs = this._dataProvider.timeProvider.getTomorrow(tomorrowTs);
		}
		return tomorrowTs;
	}
	,getPurchasesCount: function() {
		return this._storage.data.iapHistory.length;
	}
	,lastIAPTime: function() {
		if(this._storage.data.iapHistory.length > 0) {
			return this._storage.data.iapHistory[this._storage.data.iapHistory.length - 1];
		} else {
			return 0;
		}
	}
	,inappSum: function() {
		return this._storage.data.inappSum;
	}
	,inappSumAvg: function() {
		if(this._storage.data.iapHistory.length > 0) {
			return this.inappSum() / this._storage.data.iapHistory.length;
		} else {
			return 0;
		}
	}
	,inappFrequency: function(periodDays) {
		var periodStart = periodDays * 24 * 3600;
		var i = this._storage.data.iapHistory.length;
		while(i > 0 && this._storage.data.iapHistory[i - 1] > periodStart) --i;
		return this._storage.data.iapHistory.length - i;
	}
	,getABTestProps: function(testName) {
		return this._storage.data.abTestProps[testName];
	}
	,getPendingPurchases: function() {
		return this._storage.data.iapCache.pending;
	}
	,getAcknowledgedPurchases: function() {
		return this._storage.data.iapCache.acknowledged;
	}
	,getExpiredPurchases: function() {
		return this._storage.data.iapCache.expired;
	}
	,__class__: com_nevosoft_waw_ProfileDataProvider
});
var com_nevosoft_waw_DataProvider = function(storage,metaIndex,profileIndex,mapIndex,clientResourcesStrategy,serverResourcesStrategy,timeProvider) {
	this.storage = storage;
	this.metaIndex = metaIndex;
	this.profileIndex = profileIndex;
	this.mapIndex = mapIndex;
	this.timeProvider = timeProvider;
	this.restrictions = new com_nevosoft_waw_logic_systems_Restrictions(this);
	this.meta = new com_nevosoft_waw_dpScopes_MetaDataProvider(storage,this);
	this.profile = new com_nevosoft_waw_ProfileDataProvider(storage,this);
	this.gameTasks = new com_nevosoft_waw_dpScopes_GameTaskDataProvider(storage,this);
	this.location = new com_nevosoft_waw_dpScopes_LocationDataProvider(storage,this);
	this.mapObjects = new com_nevosoft_waw_dpScopes_MapObjectsDataProvider(storage,this);
	this.shop = new com_nevosoft_waw_dpScopes_ShopDataProvider(storage,this);
	this.quests = new com_nevosoft_waw_dpScopes_QuestsDataProvider(storage,this);
	this.achievements = new com_nevosoft_waw_dpScopes_AchievementsDataProvider(storage,this);
	this.pointsOfSale = new com_nevosoft_waw_dpScopes_POSDataProvider(storage,this);
	this.buffs = new com_nevosoft_waw_dpScopes_BuffsDataProvider(storage,this);
	this.actions = new com_nevosoft_waw_dpScopes_ActionsDataProvider(storage,this);
	this.story = new com_nevosoft_waw_dpScopes_StoryDataProvider(storage,this);
	this.social = new com_nevosoft_waw_dpScopes_SocialDataProvider(storage,this);
	this.offers = new com_nevosoft_waw_dpScopes_OffersDataProvider(storage,this);
	this.clientResources = new com_nevosoft_waw_dpScopes_ResourcesDataProvider(storage,this,clientResourcesStrategy);
	this.serverResources = new com_nevosoft_waw_dpScopes_ResourcesDataProvider(storage,this,serverResourcesStrategy);
};
com_nevosoft_waw_DataProvider.__name__ = true;
com_nevosoft_waw_DataProvider.__interfaces__ = [com_nevosoft_isoframework_ICleanable];
com_nevosoft_waw_DataProvider.prototype = {
	cleanup: function() {
		this.metaIndex.cleanup();
		this.profileIndex.cleanup();
		this.mapIndex.cleanup();
	}
	,getTime: function() {
		return this.timeProvider.time;
	}
	,getAuthToken: function() {
		return this.storage.data.auth.token;
	}
	,getGameTime: function() {
		return this.storage.data.gameTime;
	}
	,getCurrentLevel: function() {
		return this.storage.homeLocation.level;
	}
	,getPremiumLevel: function() {
		return this.storage.data.premiumLevel;
	}
	,getMaxPremiumLevel: function() {
		return this.storage.meta.premiumXpLevels.length;
	}
	,getCurrentLevelConfig: function() {
		return this.getLevelConfig(this.getCurrentLevel());
	}
	,getCurrentLevelMinXP: function() {
		var current = this.getCurrentLevel();
		if(current <= 1) {
			return 0;
		} else {
			return this.getLevelConfig(current - 1).maxXp;
		}
	}
	,getCurrentLevelMaxXP: function() {
		var current = this.getCurrentLevel();
		return this.getLevelConfig(current).maxXp;
	}
	,getCurrentPremiumLevelConfig: function() {
		return this.getPremiumLevelConfig(this.storage.data.premiumLevel);
	}
	,getCurrentPremiumLevelMinXP: function() {
		var current = this.storage.data.premiumLevel;
		if(current <= 1) {
			return 0;
		} else {
			return this.getPremiumLevelConfig(current - 1).maxXp;
		}
	}
	,getCurrentPremiumLevelMaxXP: function() {
		var current = this.storage.data.premiumLevel;
		return this.getPremiumLevelConfig(current).maxXp;
	}
	,getLevelConfig: function(level) {
		var levels = this.storage.meta.levels;
		var ind = Math.floor(com_nevosoft_isoframework_utils_MathUtils.clamp(level - 1,0,levels.length - 1));
		return levels[ind];
	}
	,getPremiumLevelConfig: function(level) {
		var levels = this.storage.meta.premiumXpLevels;
		var ind = Math.floor(com_nevosoft_isoframework_utils_MathUtils.clamp(level - 1,0,levels.length - 1));
		return levels[ind];
	}
	,isMaxLevelReached: function() {
		var maxXP = this.getLevelConfig(this.storage.meta.levels.length).maxXp;
		var currentXp = this.serverResources.AvailableAmount(-4);
		return currentXp >= maxXP;
	}
	,isMaxPremiumLevelReached: function() {
		return this.getPremiumLevel() >= this.getMaxPremiumLevel();
	}
	,getLastOnlineTime: function() {
		return this.storage.data.locationTime;
	}
	,getTimeOnMapEnter: function() {
		return this.storage.data.gameTimeOnMapEnter;
	}
	,getUnixTimeOnMapExit: function() {
		return this.storage.data.unixTimeOnMapExit;
	}
	,getUnixTimeOnMapEnter: function() {
		return this.storage.data.unixTimeOnMapEnter;
	}
	,getOptions: function() {
		return this.storage.data.options;
	}
	,sessionNum: function() {
		return this.storage.data.sessionNum;
	}
	,getAvailableLocales: function() {
		return this.storage.meta.localesList;
	}
	,getLocaleById: function(localeId) {
		var result = null;
		var _g = 0;
		var _g1 = this.getAvailableLocales();
		while(_g < _g1.length) {
			var l = _g1[_g];
			++_g;
			if(l.id == localeId) {
				result = l;
				break;
			}
		}
		if(result == null) {
			return { id : 2, name : "English", lang : "en"};
		} else {
			return result;
		}
	}
	,getMetaIndex: function() {
		return this.metaIndex;
	}
	,getProfileIndex: function() {
		return this.profileIndex;
	}
	,getMapIndex: function() {
		return this.mapIndex;
	}
	,getTutorChekpoint: function() {
		return this.storage.data.tutorial.checkpoint;
	}
	,isTutorCompleted: function() {
		return this.getTutorChekpoint() >= 13;
	}
	,needToStartTutorialSystem: function() {
		return this.getTutorChekpoint() < 15;
	}
	,isActionAlreadyDone: function(id) {
		return this.storage.data.tutorial.doneActions.indexOf(id) >= 0;
	}
	,actionCounter: function(id) {
		if(this.storage.data.tutorial.actionCounters.length > id && id >= 0) {
			return this.storage.data.tutorial.actionCounters[id];
		} else {
			return 0;
		}
	}
	,getCurrentEventId: function() {
		return this.storage.data.currentGameEventId;
	}
	,isOnMainLocation: function() {
		return this.getCurrentEventId() == this.getHomeLocationEventId();
	}
	,getHomeLocation: function() {
		return this.storage.homeLocation;
	}
	,getHomeLocationEventId: function() {
		return this.storage.homeLocation.eventId;
	}
	,isGameEventActive: function(eventId) {
		var _g = 0;
		var _g1 = this.storage.data.gameEvents;
		while(_g < _g1.length) {
			var ge = _g1[_g];
			++_g;
			if(ge.id == eventId) {
				return ge.isActive;
			}
		}
		return false;
	}
	,getActiveGameEvents: function() {
		var result = [];
		var _g = 0;
		var _g1 = this.storage.data.gameEvents;
		while(_g < _g1.length) {
			var ge = _g1[_g];
			++_g;
			result.push(ge.id);
		}
		return result;
	}
	,isGameEventComplete: function(eventId) {
		return this.storage.data.completeGameEventIds.indexOf(eventId) >= 0;
	}
	,hasCompletedGameEvents: function() {
		return this.storage.data.completeGameEventIds.length > 0;
	}
	,isGameEventWindowWatched: function(eventId) {
		var _g = 0;
		var _g1 = this.storage.data.gameEvents;
		while(_g < _g1.length) {
			var ge = _g1[_g];
			++_g;
			if(ge.id == eventId) {
				return ge.previewWatched;
			}
		}
		return false;
	}
	,getActiveTemporaryResources: function() {
		var result = [];
		var _g = 0;
		var _g1 = this.storage.data.goGameTasks;
		while(_g < _g1.length) {
			var task = _g1[_g];
			++_g;
			if(this.meta.getGameObjectMeta(task.id).category == "STUFF" && task.isActive) {
				result.push(task.id);
			}
		}
		return result;
	}
	,getCommonStorageNewItems: function(storageId) {
		var _g = 0;
		var _g1 = this.storage.currentLocation.objects;
		while(_g < _g1.length) {
			var go = _g1[_g];
			++_g;
			if(go.metaId == storageId) {
				if(go.cStorage.newItems != null) {
					return go.cStorage.newItems;
				} else {
					return [];
				}
			}
		}
		return [];
	}
	,calculateModifiedTime: function(time) {
		var timeModificator = 0.0;
		var _g = 0;
		var _g1 = this.buffs.getActiveBuffs();
		while(_g < _g1.length) {
			var buff = _g1[_g];
			++_g;
			var buffMeta = this.buffs.getBuffMeta(buff.id);
			if(buffMeta.modificator.modificator == 1) {
				timeModificator += buffMeta.modificator.strength;
			}
		}
		return Math.ceil(time * (1 - timeModificator));
	}
	,__class__: com_nevosoft_waw_DataProvider
};
var com_nevosoft_waw_ILogicDispatcher = function() { };
com_nevosoft_waw_ILogicDispatcher.__name__ = true;
com_nevosoft_waw_ILogicDispatcher.__isInterface__ = true;
com_nevosoft_waw_ILogicDispatcher.prototype = {
	__class__: com_nevosoft_waw_ILogicDispatcher
};
var com_nevosoft_waw_LogicDispatcher = function(context,timeProvider,api) {
	this.context = context;
	this.timeProvider = timeProvider;
	this.api = api;
	this.transactionCommitSignal = new msignal_Signal1();
};
com_nevosoft_waw_LogicDispatcher.__name__ = true;
com_nevosoft_waw_LogicDispatcher.__interfaces__ = [com_nevosoft_waw_ILogicDispatcher,com_nevosoft_isoframework_ICleanable];
com_nevosoft_waw_LogicDispatcher.prototype = {
	dispatchCommand: function(command) {
		var resultTransaction = null;
		var t = new com_nevosoft_waw_logic_Transaction(this.context,command,this.timeProvider.time);
		resultTransaction = this.dispatchTransaction(t);
		return resultTransaction;
	}
	,dispatchTransaction: function(t) {
		var handler = this.api.getCommandHandler(t.command);
		try {
			handler(t);
		} catch( _g ) {
			var e = haxe_Exception.caught(_g).unwrap();
			var message = Std.string(e);
			console.log("src/com/nevosoft/waw/LogicDispatcher.hx:49:","LOGIC COMMAND " + Std.string(t.command) + " FAILED WITH ERROR: " + message);
			t.rollback();
			return null;
		}
		this.commitTransaction(t);
		return t;
	}
	,cleanup: function() {
		this.transactionCommitSignal = com_nevosoft_isoframework_utils_CleanupUtils.cleanupSignal1(this.transactionCommitSignal);
		this.context = null;
		this.timeProvider = null;
		this.api = null;
	}
	,commitTransaction: function(t) {
		t.commit();
		this.transactionCommitSignal.dispatch(t);
	}
	,__class__: com_nevosoft_waw_LogicDispatcher
};
var com_nevosoft_waw_ITimeProvider = function() { };
com_nevosoft_waw_ITimeProvider.__name__ = true;
com_nevosoft_waw_ITimeProvider.__isInterface__ = true;
com_nevosoft_waw_ITimeProvider.prototype = {
	__class__: com_nevosoft_waw_ITimeProvider
};
var com_nevosoft_waw_TimeProvider = function(dailyInterval) {
	if(dailyInterval == null) {
		dailyInterval = 1440;
	}
	this.dailyInterval = 1440;
	this.time = -1;
	this.dailyInterval = dailyInterval;
};
com_nevosoft_waw_TimeProvider.__name__ = true;
com_nevosoft_waw_TimeProvider.__interfaces__ = [com_nevosoft_waw_ITimeProvider];
com_nevosoft_waw_TimeProvider.prototype = {
	updateTime: function(value) {
		if(value == null) {
			value = 0;
		}
		if(value == 0) {
			this.time = Math.floor(new Date().getTime() * 0.001);
		} else {
			this.time = value;
		}
	}
	,getTomorrow: function(nowTimestamp) {
		if(nowTimestamp == null) {
			nowTimestamp = this.time;
		}
		var secInDays = this.dailyInterval * 60;
		var days = Math.floor(nowTimestamp / secInDays);
		var nextDayStart = (days + 1) * secInDays;
		return nextDayStart;
	}
	,getToday: function(ts) {
		var secInDays = this.dailyInterval * 60;
		var days = Math.floor(ts / secInDays);
		var dayStart = days * secInDays;
		return dayStart;
	}
	,__class__: com_nevosoft_waw_TimeProvider
};
var com_nevosoft_waw_core_fun_dialogs_tags_ETag = $hxEnums["com.nevosoft.waw.core.fun.dialogs.tags.ETag"] = { __ename__ : true, __constructs__ : ["BOUGHT","CONSTRUCTED","UPGRADED","REMOVED","EXISTS","LOAFING","WORKING","ITEM_PRODUCED","STARVING","FULL","TALKED_TO","SECTOR_UNLOCKED","QUEST_COMPLETED","INV_QUEST_COMPLETED","DAILY_QUEST_COMPLETED","MARKET_ORDER_COMPLETED","AVAILABLE","LEVEL_UP","RUBIES_SPENT","PLAYED_WITH","DIRIGIBLE_ARRIVED","DIRIGIBLE_EXPIRED"]
	,BOUGHT: ($_=function(params) { return {_hx_index:0,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,CONSTRUCTED: ($_=function(params) { return {_hx_index:1,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,UPGRADED: ($_=function(params) { return {_hx_index:2,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,REMOVED: ($_=function(params) { return {_hx_index:3,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EXISTS: ($_=function(params) { return {_hx_index:4,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,LOAFING: ($_=function(params) { return {_hx_index:5,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,WORKING: ($_=function(params) { return {_hx_index:6,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,ITEM_PRODUCED: ($_=function(params) { return {_hx_index:7,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,STARVING: ($_=function(params) { return {_hx_index:8,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,FULL: ($_=function(params) { return {_hx_index:9,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TALKED_TO: ($_=function(params) { return {_hx_index:10,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,SECTOR_UNLOCKED: ($_=function(params) { return {_hx_index:11,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,QUEST_COMPLETED: ($_=function(params) { return {_hx_index:12,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,INV_QUEST_COMPLETED: ($_=function(params) { return {_hx_index:13,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,DAILY_QUEST_COMPLETED: ($_=function(params) { return {_hx_index:14,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,MARKET_ORDER_COMPLETED: ($_=function(params) { return {_hx_index:15,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,AVAILABLE: ($_=function(params) { return {_hx_index:16,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,LEVEL_UP: ($_=function(params) { return {_hx_index:17,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,RUBIES_SPENT: ($_=function(params) { return {_hx_index:18,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,PLAYED_WITH: ($_=function(params) { return {_hx_index:19,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,DIRIGIBLE_ARRIVED: ($_=function(params) { return {_hx_index:20,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
	,DIRIGIBLE_EXPIRED: ($_=function(params) { return {_hx_index:21,params:params,__enum__:"com.nevosoft.waw.core.fun.dialogs.tags.ETag",toString:$estr}; },$_.__params__ = ["params"],$_)
};
var com_nevosoft_waw_core_localization_RuTemplateMacro = function() {
};
com_nevosoft_waw_core_localization_RuTemplateMacro.__name__ = true;
com_nevosoft_waw_core_localization_RuTemplateMacro.prototype = {
	original: function(resolve,key) {
		return com_nevosoft_waw_core_localization_Locale.getForm(key,0);
	}
	,case1: function(resolve,key,count) {
		if(count == null) {
			count = 1;
		}
		var ind = com_nevosoft_waw_core_localization_Locale.getPluralIndex(count);
		return com_nevosoft_waw_core_localization_Locale.getForm(key,1 + ind);
	}
	,case2: function(resolve,key,count) {
		if(count == null) {
			count = 1;
		}
		var ind = 4;
		return com_nevosoft_waw_core_localization_Locale.getForm(key,ind);
	}
	,org: function(resolve,key) {
		return this.original(resolve,key);
	}
	,c1: function(resolve,key,count) {
		if(count == null) {
			count = 1;
		}
		return this.case1(resolve,key,count);
	}
	,c2: function(resolve,key,count) {
		if(count == null) {
			count = 1;
		}
		return this.case2(resolve,key,count);
	}
	,__class__: com_nevosoft_waw_core_localization_RuTemplateMacro
};
var com_nevosoft_waw_core_localization_DefaultTemplateMacro = function() {
};
com_nevosoft_waw_core_localization_DefaultTemplateMacro.__name__ = true;
com_nevosoft_waw_core_localization_DefaultTemplateMacro.prototype = {
	original: function(resolve,key) {
		return com_nevosoft_waw_core_localization_Locale.getForm(key,0);
	}
	,case1: function(resolve,key,count) {
		if(count == null) {
			count = 1;
		}
		var ind = com_nevosoft_waw_core_localization_Locale.getPluralIndex(count);
		return com_nevosoft_waw_core_localization_Locale.getForm(key,1 + ind);
	}
	,case2: function(resolve,key,count) {
		if(count == null) {
			count = 1;
		}
		return this.case1(resolve,key,count);
	}
	,org: function(resolve,key) {
		return this.original(resolve,key);
	}
	,c1: function(resolve,key,count) {
		if(count == null) {
			count = 1;
		}
		return this.case1(resolve,key,count);
	}
	,c2: function(resolve,key,count) {
		if(count == null) {
			count = 1;
		}
		return this.case2(resolve,key,count);
	}
	,__class__: com_nevosoft_waw_core_localization_DefaultTemplateMacro
};
var com_nevosoft_waw_core_localization_TemplateMacroFabric = function() { };
com_nevosoft_waw_core_localization_TemplateMacroFabric.__name__ = true;
com_nevosoft_waw_core_localization_TemplateMacroFabric.create = function(lang) {
	if(lang == "ru") {
		return new com_nevosoft_waw_core_localization_RuTemplateMacro();
	} else {
		return new com_nevosoft_waw_core_localization_DefaultTemplateMacro();
	}
};
var com_nevosoft_waw_core_localization_Locale = function() { };
com_nevosoft_waw_core_localization_Locale.__name__ = true;
com_nevosoft_waw_core_localization_Locale.getErrorTitle = function(error) {
	var key = "remoting/title";
	if(error != null) {
		if(error._hx_index == 3) {
			var _g = error.info;
			var data = error.data;
			if(data.code == 3) {
				key = "remoting/apiVersionMismatchTitle";
			} else {
				key = "remoting/title";
			}
		}
	}
	return com_nevosoft_waw_core_localization_Locale.getUI(key);
};
com_nevosoft_waw_core_localization_Locale.getErrorMessage = function(error) {
	var key = "";
	var errInfo = "";
	switch(error._hx_index) {
	case 0:
		var info = error.info;
		key = "/ui" + "/error" + "/io/text";
		errInfo = info;
		break;
	case 1:
		var info = error.info;
		key = "/ui" + "/error" + "/security/text";
		errInfo = info;
		break;
	case 2:
		var info = error.info;
		key = "/ui" + "/error" + "/format/text";
		errInfo = info;
		break;
	case 3:
		var data = error.data;
		var info = error.info;
		switch(data.code) {
		case -1:
			key = "/ui" + "/error" + "/api/unknown/text";
			break;
		case 1:
			key = "/ui" + "/error" + "/api/gameLogic/text";
			break;
		case 2:
			key = "/ui" + "/error" + "/api/wrongCheckSum/text";
			break;
		case 3:
			key = "/ui" + "/error" + "/api/apiVersionMismatch/text";
			break;
		case 4:
			key = "/ui" + "/error" + "/api/authFailed/text";
			break;
		case 5:
			key = "/ui" + "/error" + "/api/wrongRequest/text";
			break;
		case 6:
			key = "/ui" + "/error" + "/api/metaVersionMismatch/text";
			break;
		case 7:
			key = "/ui" + "/error" + "/api/socialIdAlreadyAttached/text";
			break;
		case 8:
			key = "/ui" + "/error" + "/api/lastTimeIsAhead/text";
			break;
		case 9:
			key = "/ui" + "/error" + "/api/serverTimeIsDifferent/text";
			break;
		}
		errInfo = info;
		break;
	}
	return com_nevosoft_waw_core_localization_Locale.T(key);
};
com_nevosoft_waw_core_localization_Locale.getSlotCustomLabel = function(lotId,labelIndex) {
	return com_nevosoft_waw_core_localization_Locale.T("/offerLots/" + lotId + "/rewardSlots/" + labelIndex + "/customLabel");
};
com_nevosoft_waw_core_localization_Locale.getSlotCustomQuantity = function(lotId,labelIndex) {
	return com_nevosoft_waw_core_localization_Locale.T("/offerLots/" + lotId + "/rewardSlots/" + labelIndex + "/customQuantity");
};
com_nevosoft_waw_core_localization_Locale.getOnmapDialogPhrase = function(dialogId,phraseId) {
	return com_nevosoft_waw_core_localization_Locale.T("/onmapDialogs/" + dialogId + "/phrases/" + phraseId + "/text");
};
com_nevosoft_waw_core_localization_Locale.getNotificationTitle = function(id,buildingName,eventName) {
	if(eventName == null) {
		eventName = "";
	}
	if(buildingName == null) {
		buildingName = "";
	}
	if(buildingName != "" || eventName != "") {
		return com_nevosoft_waw_core_localization_Locale.T("/notifications" + "/" + id + "/title",{ buildingName : buildingName, eventName : eventName});
	}
	return com_nevosoft_waw_core_localization_Locale.T("/notifications" + "/" + id + "/title");
};
com_nevosoft_waw_core_localization_Locale.getNotificationMessage = function(id,buildingName) {
	if(buildingName == null) {
		buildingName = "";
	}
	if(buildingName != "") {
		return com_nevosoft_waw_core_localization_Locale.T("/notifications" + "/" + id + "/text",{ buildingName : buildingName});
	}
	return com_nevosoft_waw_core_localization_Locale.T("/notifications" + "/" + id + "/text");
};
com_nevosoft_waw_core_localization_Locale.getOther = function(id) {
	return com_nevosoft_waw_core_localization_Locale.T("/other" + "/" + id + "/name");
};
com_nevosoft_waw_core_localization_Locale.getUI = function(id,params) {
	return com_nevosoft_waw_core_localization_Locale.T("/ui" + "/" + id + "/text",params);
};
com_nevosoft_waw_core_localization_Locale.hasUI = function(id,params) {
	return com_nevosoft_waw_core_localization_Locale.hasForm("/ui" + "/" + id + "/text",0);
};
com_nevosoft_waw_core_localization_Locale.getGhostEmitter = function(id,params) {
	return com_nevosoft_waw_core_localization_Locale.T("/ui" + "/" + id + "/text",params);
};
com_nevosoft_waw_core_localization_Locale.getTalkingHeadSpeech = function(storyId,sceneId,talkId) {
	if(sceneId == null) {
		sceneId = 0;
	}
	return com_nevosoft_waw_core_localization_Locale.T("/story/" + storyId + "/scenes/" + sceneId + "/params/talk/" + talkId + "/speech");
};
com_nevosoft_waw_core_localization_Locale.getComicsSlideText = function(storyId,sceneId,slideId) {
	return com_nevosoft_waw_core_localization_Locale.T("/story/" + storyId + "/scenes/" + sceneId + "/params/slides/" + slideId + "/text");
};
com_nevosoft_waw_core_localization_Locale.getGameEventName = function(evtId) {
	return com_nevosoft_waw_core_localization_Locale.T("/gameEvents" + "/" + evtId + "/name");
};
com_nevosoft_waw_core_localization_Locale.getGameEventDescription = function(evtId) {
	return com_nevosoft_waw_core_localization_Locale.T("/gameEvents" + "/" + evtId + "/description");
};
com_nevosoft_waw_core_localization_Locale.getGameEventFinishDescription = function(evtId) {
	return com_nevosoft_waw_core_localization_Locale.T("/gameEvents" + "/" + evtId + "/finishDescription");
};
com_nevosoft_waw_core_localization_Locale.getGameEventMarkName = function(markId) {
	return com_nevosoft_waw_core_localization_Locale.T("/gameEventMap" + "/" + markId + "/name");
};
com_nevosoft_waw_core_localization_Locale.getArcName = function(arcId) {
	return com_nevosoft_waw_core_localization_Locale.T("/questArcs" + "/" + arcId + "/name");
};
com_nevosoft_waw_core_localization_Locale.getQuestName = function(qid) {
	return com_nevosoft_waw_core_localization_Locale.T("/quests" + "/" + qid + "/name");
};
com_nevosoft_waw_core_localization_Locale.getQuestDescription = function(qid) {
	return com_nevosoft_waw_core_localization_Locale.T("/quests" + "/" + qid + "/description");
};
com_nevosoft_waw_core_localization_Locale.getQuestStage = function(qid,stageId) {
	return com_nevosoft_waw_core_localization_Locale.T("/quests" + "/" + qid + "/stages/" + stageId + "/name");
};
com_nevosoft_waw_core_localization_Locale.getAchievementName = function(id,level) {
	return com_nevosoft_waw_core_localization_Locale.T("/achievements" + "/" + id + "/stages/" + level + "/name");
};
com_nevosoft_waw_core_localization_Locale.getAchievementDescription = function(id,level,conditionValue) {
	return com_nevosoft_waw_core_localization_Locale.T("/achievements" + "/" + id + "/stages/" + level + "/description",{ conditionValue : conditionValue});
};
com_nevosoft_waw_core_localization_Locale.getOfferName = function(id) {
	return com_nevosoft_waw_core_localization_Locale.T("/offers" + "/" + id + "/name");
};
com_nevosoft_waw_core_localization_Locale.getOfferDescription = function(id) {
	return com_nevosoft_waw_core_localization_Locale.T("/offers" + "/" + id + "/description");
};
com_nevosoft_waw_core_localization_Locale.getBuffName = function(id) {
	return com_nevosoft_waw_core_localization_Locale.T("/buffs" + "/" + id + "/name");
};
com_nevosoft_waw_core_localization_Locale.getBuffDescription = function(id) {
	return com_nevosoft_waw_core_localization_Locale.T("/buffs" + "/" + id + "/description");
};
com_nevosoft_waw_core_localization_Locale.getGameObjectName = function(id) {
	return com_nevosoft_waw_core_localization_Locale.T(com_nevosoft_waw_core_localization_Locale.getGameObjectNameKey(id));
};
com_nevosoft_waw_core_localization_Locale.getGameObjectDescription = function(id) {
	return com_nevosoft_waw_core_localization_Locale.T("/gameObjects" + "/" + id + "/description");
};
com_nevosoft_waw_core_localization_Locale.getGameObjectNameKey = function(id) {
	return "/gameObjects" + "/" + id + "/name";
};
com_nevosoft_waw_core_localization_Locale.getSpellDescription = function(id) {
	return com_nevosoft_waw_core_localization_Locale.T("/spells" + "/" + id + "/description");
};
com_nevosoft_waw_core_localization_Locale.getSpellName = function(id) {
	return com_nevosoft_waw_core_localization_Locale.T("/spells" + "/" + id + "/name");
};
com_nevosoft_waw_core_localization_Locale.getSpellNameKey = function(id) {
	return "/spells" + "/" + id + "/name";
};
com_nevosoft_waw_core_localization_Locale.Init = function(data,lang) {
	console.log("src/com/nevosoft/waw/core/localization/Locale.hx:331:","INIT LOCALE " + lang);
	com_nevosoft_waw_core_localization_Locale.lang = lang;
	com_nevosoft_waw_core_localization_Locale.strings = new haxe_ds_StringMap();
	com_nevosoft_waw_core_localization_Locale.MARKET_ORDER_KEYS = [];
	var _g = 0;
	var _g1 = Reflect.fields(data);
	while(_g < _g1.length) {
		var key = _g1[_g];
		++_g;
		var upKey = key.toUpperCase();
		var marketKey = "/market_orders".toUpperCase();
		if(upKey.indexOf(marketKey) == 0) {
			com_nevosoft_waw_core_localization_Locale.MARKET_ORDER_KEYS.push(upKey);
		}
		com_nevosoft_waw_core_localization_Locale.strings.h[upKey] = data[key];
	}
	com_nevosoft_waw_core_localization_Locale.templateMacro = com_nevosoft_waw_core_localization_TemplateMacroFabric.create(lang);
	com_nevosoft_waw_core_localization_Locale.pluralRules = new haxe_ds_StringMap();
	var v = function(n) {
		if(n > 1) {
			return 1;
		} else {
			return 0;
		}
	};
	com_nevosoft_waw_core_localization_Locale.pluralRules.h["en"] = v;
	var v = function(n) {
		if(n % 10 == 1 && n % 100 != 11) {
			return 0;
		} else if(n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
			return 1;
		} else {
			return 2;
		}
	};
	com_nevosoft_waw_core_localization_Locale.pluralRules.h["ru"] = v;
	var v = function(n) {
		return n;
	};
	com_nevosoft_waw_core_localization_Locale.pluralRules.h["default"] = v;
};
com_nevosoft_waw_core_localization_Locale.getPluralIndex = function(count) {
	var key = Object.prototype.hasOwnProperty.call(com_nevosoft_waw_core_localization_Locale.pluralRules.h,com_nevosoft_waw_core_localization_Locale.lang) ? com_nevosoft_waw_core_localization_Locale.lang : "default";
	return com_nevosoft_waw_core_localization_Locale.pluralRules.h[key](count);
};
com_nevosoft_waw_core_localization_Locale.T = function(key,params,valueIndex) {
	if(valueIndex == null) {
		valueIndex = 0;
	}
	var input = com_nevosoft_waw_core_localization_Locale.getForm(key,valueIndex);
	return com_nevosoft_waw_core_localization_Locale.processTemplate(input,params);
};
com_nevosoft_waw_core_localization_Locale.allKeys = function() {
	return haxe_ds_StringMap.keysIterator(com_nevosoft_waw_core_localization_Locale.strings.h);
};
com_nevosoft_waw_core_localization_Locale.processTemplate = function(input,params) {
	if(params == null) {
		params = { };
	}
	var template = new haxe_Template(input);
	var result = "";
	try {
		result = template.execute(params,com_nevosoft_waw_core_localization_Locale.templateMacro);
	} catch( _g ) {
		var _g1 = haxe_Exception.caught(_g).unwrap();
		if(typeof(_g1) == "string") {
			var e = _g1;
			result = "can't process: " + input + ", error: " + e;
		} else {
			throw _g;
		}
	}
	return result;
};
com_nevosoft_waw_core_localization_Locale.getForm = function(key,index) {
	var forms = com_nevosoft_waw_core_localization_Locale.getStrings(key);
	if(index >= forms.length) {
		return "no_form: " + key + "[" + index + "]";
	}
	return forms[index];
};
com_nevosoft_waw_core_localization_Locale.hasForm = function(key,index) {
	var forms = com_nevosoft_waw_core_localization_Locale.getStrings(key);
	if(com_nevosoft_waw_core_localization_Locale.hasStrings(key)) {
		return index < forms.length;
	} else {
		return false;
	}
};
com_nevosoft_waw_core_localization_Locale.hasStrings = function(key) {
	var storeKey = key.toUpperCase();
	if(com_nevosoft_waw_core_localization_Locale.strings != null) {
		return Object.prototype.hasOwnProperty.call(com_nevosoft_waw_core_localization_Locale.strings.h,storeKey);
	} else {
		return false;
	}
};
com_nevosoft_waw_core_localization_Locale.getStrings = function(key) {
	var storeKey = key.toUpperCase();
	if(com_nevosoft_waw_core_localization_Locale.strings == null) {
		return ["locale not initialized yet"];
	}
	if(!Object.prototype.hasOwnProperty.call(com_nevosoft_waw_core_localization_Locale.strings.h,storeKey)) {
		return ["no_key: " + key];
	}
	return com_nevosoft_waw_core_localization_Locale.strings.h[storeKey];
};
var com_nevosoft_waw_core_utils_AbstractEnumTools = function() { };
com_nevosoft_waw_core_utils_AbstractEnumTools.__name__ = true;
var com_nevosoft_waw_core_utils_ContainerUtils = function() { };
com_nevosoft_waw_core_utils_ContainerUtils.__name__ = true;
com_nevosoft_waw_core_utils_ContainerUtils.sortPred = function(a,b) {
	return com_nevosoft_waw_core_utils_ContainerUtils.intSortPred(a.id,b.id);
};
com_nevosoft_waw_core_utils_ContainerUtils.intSortPred = function(a,b) {
	return a - b;
};
com_nevosoft_waw_core_utils_ContainerUtils.getIndexOf = function(container,id) {
	var _g = 0;
	var _g1 = container.length;
	while(_g < _g1) {
		var i = _g++;
		var o = container[i];
		if(o != null && o.id == id) {
			return i;
		}
	}
	return -1;
};
com_nevosoft_waw_core_utils_ContainerUtils.getObjectById = function(container,id) {
	var _g = 0;
	while(_g < container.length) {
		var o = container[_g];
		++_g;
		if(o.id == id) {
			return o;
		}
	}
	return null;
};
com_nevosoft_waw_core_utils_ContainerUtils.getObjectByKey = function(container,key,val) {
	var _g = 0;
	while(_g < container.length) {
		var o = container[_g];
		++_g;
		if(Reflect.field(o,key) == val) {
			return o;
		}
	}
	return null;
};
com_nevosoft_waw_core_utils_ContainerUtils.removeObjectById = function(container,id) {
	var obj = null;
	var _g = 0;
	while(_g < container.length) {
		var o = container[_g];
		++_g;
		if(o.id == id) {
			obj = o;
			break;
		}
	}
	return HxOverrides.remove(container,obj);
};
com_nevosoft_waw_core_utils_ContainerUtils.setObject = function(container,obj) {
	var i = 0;
	var _g = 0;
	while(_g < container.length) {
		var o = container[_g];
		++_g;
		if(o.id == obj.id) {
			container[i] = obj;
			break;
		}
		++i;
	}
	return null;
};
com_nevosoft_waw_core_utils_ContainerUtils.addObjectWithId = function(container,template) {
	if(template.id <= 0) {
		template.id = com_nevosoft_waw_core_utils_ContainerUtils.getLastId(container) + 1;
	}
	container.push(template);
	return template.id;
};
com_nevosoft_waw_core_utils_ContainerUtils.addObjectNegativeId = function(container,template) {
	if(template.id == 0) {
		template.id = -1 * com_nevosoft_waw_core_utils_ContainerUtils.getLastId(container) - 1;
	}
	container.push(template);
	return template.id;
};
com_nevosoft_waw_core_utils_ContainerUtils.getLastId = function(container) {
	var lastId = 0;
	var _g = 0;
	while(_g < container.length) {
		var obj = container[_g];
		++_g;
		if(Math.abs(obj.id) > Math.abs(lastId)) {
			lastId = obj.id;
		}
	}
	return Math.floor(Math.abs(lastId));
};
com_nevosoft_waw_core_utils_ContainerUtils.getSortedKeys = function(map) {
	var _g = [];
	var k = map.keys();
	while(k.hasNext()) {
		var k1 = k.next();
		_g.push(k1);
	}
	var keys = _g;
	keys.sort(com_nevosoft_waw_core_utils_ContainerUtils.intSortPred);
	return keys;
};
com_nevosoft_waw_core_utils_ContainerUtils.sortedArrayInt = function(data) {
	data.sort(com_nevosoft_waw_core_utils_ContainerUtils.intSortPred);
	return data;
};
var com_nevosoft_waw_core_utils_Macro = function() { };
com_nevosoft_waw_core_utils_Macro.__name__ = true;
var com_nevosoft_waw_core_utils_SeedRandom = function(seed) {
	this.seed = seed;
	this.A = 48271;
	this.M = 2147483647;
	this.Q = Math.floor(this.M / this.A);
	this.R = this.M % this.A;
	this.oneOverM = 1.0 / this.M;
};
com_nevosoft_waw_core_utils_SeedRandom.__name__ = true;
com_nevosoft_waw_core_utils_SeedRandom.prototype = {
	next: function() {
		var b = this.Q;
		var hi = Math.floor(UInt.toFloat(this.seed) / UInt.toFloat(b));
		var b = this.Q;
		var lo = UInt.toFloat(this.seed) % UInt.toFloat(b) | 0;
		var test = this.A * lo - this.R * hi;
		if(test > 0) {
			this.seed = test;
		} else {
			this.seed = test + this.M;
		}
		var b = this.oneOverM;
		var v = UInt.toFloat(this.seed) * b;
		return v;
	}
	,nextInt: function(min,max) {
		return Math.round((max - min) * this.next() + min);
	}
	,__class__: com_nevosoft_waw_core_utils_SeedRandom
};
var com_nevosoft_waw_data_MapIndex = function(map) {
	this.map = map;
	this.idToSectorMap = new haxe_ds_IntMap();
	this.sectorToNeighbours = new haxe_ds_IntMap();
};
com_nevosoft_waw_data_MapIndex.__name__ = true;
com_nevosoft_waw_data_MapIndex.__interfaces__ = [com_nevosoft_isoframework_ICleanable];
com_nevosoft_waw_data_MapIndex.prototype = {
	cleanup: function() {
		this.map = null;
		this.idToSectorMap = null;
		this.sectorToNeighbours = null;
	}
	,build: function() {
		var _g = 0;
		var _g1 = this.map.sectorsConfig.sectors;
		while(_g < _g1.length) {
			var sector = _g1[_g];
			++_g;
			this.idToSectorMap.h[sector.id] = sector;
			this.setSectorNeighboursIds(sector);
		}
	}
	,getSectorById: function(id) {
		return this.idToSectorMap.h[id];
	}
	,getSectorNeighboursIds: function(sectorId) {
		return this.sectorToNeighbours.h[sectorId];
	}
	,setSectorNeighboursIds: function(sector) {
		var _g = 0;
		var _g1 = this.map.sectorsConfig.sectors;
		while(_g < _g1.length) {
			var s = _g1[_g];
			++_g;
			if(this.areNotCornerNeighbours(sector,s)) {
				if(!this.sectorToNeighbours.h.hasOwnProperty(sector.id)) {
					this.sectorToNeighbours.h[sector.id] = [];
				}
				this.sectorToNeighbours.h[sector.id].push(s.id);
			}
		}
	}
	,areNotCornerNeighbours: function(s1,s2) {
		var s1X = s1.x;
		var s1Y = s1.y;
		var s1XW = s1.x + s1.w;
		var s1YH = s1.y + s1.h;
		var s2X = s2.x;
		var s2Y = s2.y;
		var s2XW = s2.x + s2.w;
		var s2YH = s2.y + s2.h;
		if(s1X > s2XW || s2X > s1XW || s1Y > s2YH || s2Y > s1YH) {
			return false;
		}
		if(s1Y == s2YH && s1XW != s2X || s1XW == s2X && s1YH != s2X || s1YH == s2Y && s1X != s2XW || s1X == s2XW && s1Y != s2YH) {
			return true;
		}
		return false;
	}
	,__class__: com_nevosoft_waw_data_MapIndex
};
var com_nevosoft_waw_data_MetaIndex = function() {
	this.houseMetaIds = [];
	this.campingRewardChoiceSet = [];
	this.dailyQuestRewardChoiceSet = [];
	this.commonStorageMt = [];
};
com_nevosoft_waw_data_MetaIndex.__name__ = true;
com_nevosoft_waw_data_MetaIndex.__interfaces__ = [com_nevosoft_isoframework_ICleanable];
com_nevosoft_waw_data_MetaIndex.prototype = {
	cleanup: function() {
		this.marketMt = null;
		this.landingFieldMt = null;
		this.commonStorageMt = null;
		this.gameObjects = null;
		this.stuff = null;
		this.buffs = null;
		this.gameEvents = null;
		this.gameEventMap = null;
		this.quests = null;
		this.questArcs = null;
		this.questToArc = null;
		this.offers = null;
		this.story = null;
		this.saleLeaders = null;
		this.iapLots = null;
		this.goGameTasks = null;
		this.skipByTime = null;
		this.resourceMetrics = com_nevosoft_isoframework_utils_CleanupUtils.cleanup(this.resourceMetrics);
		this.spells = null;
		this.spellSpawnSet = null;
		this.mapObjectActions = null;
		this.actionOwners = null;
		this.locationSettings = null;
		this.marketAttributes = null;
		this.achievements = null;
		this.animalBindings = null;
		this.garbageToSpell = null;
		this.dropToCondition = null;
		this.foodToAnimal = null;
		this.gameObjectUnlocks = null;
		this.productionsUnlocks = null;
		this.questConditionBluePrints = null;
		this.houseMetaIds = null;
		this.posMaxTable = null;
		this.constants = null;
		this.dailyQuestRewardChoiceSet = null;
		this.ordersHostSettings = null;
		this.stuffDropSource = null;
		this.stuffSellSource = null;
		this.stuffProdSource = null;
		this.stuffRemoveSource = null;
	}
	,__class__: com_nevosoft_waw_data_MetaIndex
};
var com_nevosoft_waw_data_NutContext = function() {
	this.validBuildings = 0;
	this.brokenBuildings = 0;
};
com_nevosoft_waw_data_NutContext.__name__ = true;
com_nevosoft_waw_data_NutContext.prototype = {
	__class__: com_nevosoft_waw_data_NutContext
};
var com_nevosoft_waw_data_ProfileIndex = function() {
	this.nutContext = new com_nevosoft_waw_data_NutContext();
	this.activeQuests = [];
	this.achievements = [];
	this.friends = new haxe_ds_StringMap();
	this.achievementsMap = new haxe_ds_IntMap();
	this.animalToPastureIndex = new haxe_ds_IntMap();
	this.objectsWithPeriodicalReward = [];
};
com_nevosoft_waw_data_ProfileIndex.__name__ = true;
com_nevosoft_waw_data_ProfileIndex.__interfaces__ = [com_nevosoft_isoframework_ICleanable];
com_nevosoft_waw_data_ProfileIndex.prototype = {
	getStorageByObjectMetaId: function(metaId) {
		var _g = 0;
		var _g1 = this.commonStorages;
		while(_g < _g1.length) {
			var storage = _g1[_g];
			++_g;
			var storageComponent = storage.getMeta().storageComponent;
			if(storageComponent == null) {
				continue;
			}
			if(storageComponent.metaIds == null) {
				continue;
			}
			if(storageComponent.metaIds.indexOf(metaId) >= 0) {
				return storage;
			}
		}
		return null;
	}
	,getStorageByObjectCategory: function(category) {
		var _g = 0;
		var _g1 = this.commonStorages;
		while(_g < _g1.length) {
			var storage = _g1[_g];
			++_g;
			var storageComponent = storage.getMeta().storageComponent;
			if(storageComponent == null) {
				continue;
			}
			if(storageComponent.categories == null) {
				continue;
			}
			if(storageComponent.categories.indexOf(category) >= 0) {
				return storage;
			}
		}
		return null;
	}
	,getStorageById: function(storageId) {
		var result = null;
		var _g = 0;
		var _g1 = this.commonStorages;
		while(_g < _g1.length) {
			var storage = _g1[_g];
			++_g;
			if(storage.getMeta().id == storageId) {
				result = storage;
			}
		}
		return result;
	}
	,getStorageByTag: function(tag) {
		var result = null;
		var _g = 0;
		var _g1 = this.commonStorages;
		while(_g < _g1.length) {
			var storage = _g1[_g];
			++_g;
			if(com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged(tag,storage.getMeta())) {
				result = storage;
			}
		}
		return result;
	}
	,cleanup: function() {
		this.nutContext = null;
		this.commonStorages = null;
		this.movesBuffer = null;
		this.activeQuests = null;
		this.dailyQuest = null;
		this.achievements = null;
		this.achievementsMap = null;
		this.animalToPastureIndex = null;
		this.friends = null;
		this.objectsWithPeriodicalReward = null;
	}
	,__class__: com_nevosoft_waw_data_ProfileIndex
};
var com_nevosoft_waw_data_RecentMovesBuffer = function() {
	this.moves = [];
	this.costAcc = { };
	this.commonAcc = 0;
	this.manaAcc = 0;
};
com_nevosoft_waw_data_RecentMovesBuffer.__name__ = true;
com_nevosoft_waw_data_RecentMovesBuffer.prototype = {
	confirmAll: function() {
		var i = this.moves.length - 1;
		while(i >= 0) {
			var m = this.moves[i];
			this.confirmMove(m);
			--i;
		}
	}
	,pushMove: function(move) {
		this.moves.push(move);
		this.applyMove(move,true);
	}
	,confirmMove: function(move) {
		HxOverrides.remove(this.moves,move);
		this.applyMove(move,false);
	}
	,getBufferedAmount: function(resourceId) {
		var this1 = this.costAcc;
		if(com_nevosoft_waw_data_types_TCost.hasKey(this1,resourceId)) {
			return Reflect.field(this1,resourceId == null ? "null" : "" + resourceId);
		} else {
			return 0;
		}
	}
	,getBufferedCommon: function() {
		return this.commonAcc;
	}
	,getBufferedMana: function() {
		return this.manaAcc;
	}
	,applyMove: function(move,input) {
		if(move.sign > 0 == input) {
			this.costAcc = com_nevosoft_waw_data_types_TCost.sum(this.costAcc,move.cost);
			this.commonAcc += move.space.common;
			this.manaAcc += move.space.mana;
		} else {
			this.costAcc = com_nevosoft_waw_data_types_TCost.sub(this.costAcc,move.cost);
			this.commonAcc -= move.space.common;
			this.manaAcc -= move.space.mana;
		}
	}
	,__class__: com_nevosoft_waw_data_RecentMovesBuffer
};
var com_nevosoft_waw_data_ResourceMetrics = $hx_exports["com"]["nevosoft"]["waw"]["data"]["ResourceMetrics"] = function(metaIndex) {
	this.skipByTime = metaIndex.skipByTime;
	this.metaIndex = metaIndex;
	this.resourceRelations = new com_nevosoft_waw_data_ResourceRelations();
	this.resourceProdTime = new haxe_ds_IntMap();
	this.resourceDeep = new haxe_ds_IntMap();
	this.resourceBuyCost = new haxe_ds_IntMap();
	this.resourceBaseWeight = new haxe_ds_IntMap();
	this.resourceRecipe = new haxe_ds_IntMap();
};
com_nevosoft_waw_data_ResourceMetrics.__name__ = true;
com_nevosoft_waw_data_ResourceMetrics.__interfaces__ = [com_nevosoft_isoframework_ICleanable];
com_nevosoft_waw_data_ResourceMetrics.prototype = {
	cleanup: function() {
		this.resourceRelations = com_nevosoft_isoframework_utils_CleanupUtils.cleanup(this.resourceRelations);
		this.resourceProdTime = null;
		this.resourceDeep = null;
		this.resourceBuyCost = null;
		this.resourceBaseWeight = null;
		this.skipByTime = null;
		this.resourceRecipe = null;
	}
	,storeMapAction: function(action) {
		var spendingsMain = com_nevosoft_waw_data_types_TCost.getMainResources(action.spendings);
		var rewardsMain = com_nevosoft_waw_data_types_TCost.getMainResources(action.reward);
		if(rewardsMain.length == 0) {
			return;
		}
		this.resourceRelations.addRelations(spendingsMain,rewardsMain);
		var _g = 0;
		var _g1 = com_nevosoft_waw_data_types_TCost.getMainResources(action.reward);
		while(_g < _g1.length) {
			var mainResourceId = _g1[_g];
			++_g;
			if(this.metaIndex.gameObjects.h[mainResourceId].category == "STUFF") {
				var v = action.time;
				this.resourceProdTime.h[mainResourceId] = v;
				var v1 = action.spendings;
				this.resourceRecipe.h[mainResourceId] = v1;
			}
		}
	}
	,calculateAllMetrics: function() {
		this.calculateBuyCost();
		this.calculateDeep();
		this.calculateBaseWeight();
	}
	,calculateAllMetricsAsync: function() {
		haxe_Timer.delay($bind(this,this.calculateBuyCost),0);
		haxe_Timer.delay($bind(this,this.calculateDeep),0);
		haxe_Timer.delay($bind(this,this.calculateBaseWeight),0);
	}
	,getProdTime: function(id) {
		if(!this.resourceProdTime.h.hasOwnProperty(id)) {
			return 0;
		}
		return this.resourceProdTime.h[id];
	}
	,getBuyCost: function(id) {
		if(!this.resourceBuyCost.h.hasOwnProperty(id)) {
			return 0;
		}
		return this.resourceBuyCost.h[id];
	}
	,getDeep: function(id) {
		if(!this.resourceDeep.h.hasOwnProperty(id)) {
			return -1;
		}
		return this.resourceDeep.h[id];
	}
	,hasBaseWeight: function(id) {
		return this.resourceBaseWeight.h.hasOwnProperty(id);
	}
	,getBaseWeight: function(id) {
		if(!this.hasBaseWeight(id)) {
			return 0;
		}
		return this.resourceBaseWeight.h[id];
	}
	,calculateBuyCost: function() {
		var simpleResources = this.resourceRelations.getSimpleResources();
		var _g = 0;
		while(_g < simpleResources.length) {
			var resId = simpleResources[_g];
			++_g;
			this.recursiveCalcBuyCost(resId);
		}
	}
	,calculateDeep: function() {
		var simpleResources = this.resourceRelations.getSimpleResources();
		var _g = 0;
		while(_g < simpleResources.length) {
			var resId = simpleResources[_g];
			++_g;
			this.recursiveStoreDeep(resId,-1);
		}
	}
	,calculateBaseWeight: function() {
		var simpleResources = this.resourceRelations.getSimpleResources();
		var _g = 0;
		while(_g < simpleResources.length) {
			var resId = simpleResources[_g];
			++_g;
			this.recursiveCalcBaseWeight(resId);
		}
	}
	,recursiveStoreDeep: function(resourceId,parentDeep) {
		var currentDeep = parentDeep + 1;
		if(!this.resourceDeep.h.hasOwnProperty(resourceId)) {
			this.resourceDeep.h[resourceId] = currentDeep;
		}
		var _g = 0;
		var _g1 = this.resourceRelations.getResourceOutput(resourceId);
		while(_g < _g1.length) {
			var outResId = _g1[_g];
			++_g;
			if(!this.resourceDeep.h.hasOwnProperty(outResId)) {
				this.recursiveStoreDeep(outResId,currentDeep);
			}
		}
	}
	,recursiveCalcBuyCost: function(resourceId) {
		var allInputHasBuyCost = true;
		var _g = 0;
		var _g1 = this.resourceRelations.getResourceInput(resourceId);
		while(_g < _g1.length) {
			var inputId = _g1[_g];
			++_g;
			if(!this.resourceBuyCost.h.hasOwnProperty(inputId)) {
				allInputHasBuyCost = false;
				break;
			}
		}
		if(allInputHasBuyCost) {
			var resourceRecipe = this.resourceRecipe.h[resourceId];
			var inputBuyCost = 0;
			var _g = 0;
			var _g1 = com_nevosoft_waw_data_types_TCost.getMainResources(resourceRecipe);
			while(_g < _g1.length) {
				var inputId = _g1[_g];
				++_g;
				var this1 = resourceRecipe;
				var amount = com_nevosoft_waw_data_types_TCost.hasKey(this1,inputId) ? Reflect.field(this1,inputId == null ? "null" : "" + inputId) : 0;
				var inputCost = this.getBuyCost(inputId);
				inputBuyCost += inputCost * amount;
			}
			var prodTime = this.getProdTime(resourceId);
			var ownBuyCost = com_nevosoft_waw_data_SkipByTime.getSkipCost(this.skipByTime,prodTime);
			var totalSkipCost = ownBuyCost + inputBuyCost;
			this.resourceBuyCost.h[resourceId] = totalSkipCost;
			var _g = 0;
			var _g1 = this.resourceRelations.getResourceOutput(resourceId);
			while(_g < _g1.length) {
				var outResId = _g1[_g];
				++_g;
				this.recursiveCalcBuyCost(outResId);
			}
		}
	}
	,recursiveCalcBaseWeight: function(resourceId) {
		var allInputHasWeight = true;
		var _g = 0;
		var _g1 = this.resourceRelations.getResourceInput(resourceId);
		while(_g < _g1.length) {
			var inputId = _g1[_g];
			++_g;
			if(!this.resourceBaseWeight.h.hasOwnProperty(inputId)) {
				allInputHasWeight = false;
				break;
			}
		}
		if(allInputHasWeight) {
			var inputWeight = 0;
			var _g = 0;
			var _g1 = this.resourceRelations.getResourceInput(resourceId);
			while(_g < _g1.length) {
				var inputId = _g1[_g];
				++_g;
				inputWeight += this.getBaseWeight(inputId);
			}
			var prodTime = this.getProdTime(resourceId);
			var ownWeight = prodTime * 1.5 / 60;
			var totalWeight = ownWeight + inputWeight;
			this.resourceBaseWeight.h[resourceId] = totalWeight;
			var _g = 0;
			var _g1 = this.resourceRelations.getResourceOutput(resourceId);
			while(_g < _g1.length) {
				var outResId = _g1[_g];
				++_g;
				this.recursiveCalcBaseWeight(outResId);
			}
		}
	}
	,__class__: com_nevosoft_waw_data_ResourceMetrics
};
var com_nevosoft_waw_data_Node = function(id) {
	this.id = id;
	this.inEdges = [];
	this.outEdges = [];
};
com_nevosoft_waw_data_Node.__name__ = true;
com_nevosoft_waw_data_Node.__interfaces__ = [com_nevosoft_isoframework_ICleanable];
com_nevosoft_waw_data_Node.prototype = {
	cleanup: function() {
		this.inEdges = null;
		this.outEdges = null;
	}
	,addOutEdge: function(node) {
		this.outEdges.push(node);
	}
	,addInEdge: function(node) {
		this.inEdges.push(node);
	}
	,__class__: com_nevosoft_waw_data_Node
};
var com_nevosoft_waw_data_Graph = function() {
	this.numNodes = 0;
	this.nodes = new haxe_ds_IntMap();
	this.headNodes = [];
	this.tailNodes = [];
};
com_nevosoft_waw_data_Graph.__name__ = true;
com_nevosoft_waw_data_Graph.__interfaces__ = [com_nevosoft_isoframework_ICleanable];
com_nevosoft_waw_data_Graph.prototype = {
	cleanup: function() {
		if(this.nodes != null) {
			var node = this.nodes.iterator();
			while(node.hasNext()) {
				var node1 = node.next();
				node1.cleanup();
			}
		}
		this.nodes = null;
		this.headNodes = null;
		this.tailNodes = null;
	}
	,addEdge: function(inNodeData,outNodeData) {
		if(!this.hasNode(inNodeData)) {
			this.addNode(inNodeData);
		}
		if(!this.hasNode(outNodeData)) {
			this.addNode(outNodeData);
		}
		var inputNode = this.getNode(inNodeData);
		var outNode = this.getNode(outNodeData);
		inputNode.addOutEdge(outNode);
		outNode.addInEdge(inputNode);
		HxOverrides.remove(this.headNodes,outNode);
		HxOverrides.remove(this.tailNodes,inputNode);
		if(inputNode.inEdges.length == 0) {
			this.addToSet(inputNode,this.headNodes);
		}
		if(outNode.outEdges.length == 0) {
			this.addToSet(outNode,this.tailNodes);
		}
	}
	,addNode: function(id) {
		var node = new com_nevosoft_waw_data_Node(id);
		this.nodes.h[id] = node;
		this.numNodes++;
		return node;
	}
	,getNode: function(id) {
		if(!this.nodes.h.hasOwnProperty(id)) {
			throw haxe_Exception.thrown("node with data[" + id + "] not found");
		}
		return this.nodes.h[id];
	}
	,hasNode: function(id) {
		return this.nodes.h.hasOwnProperty(id);
	}
	,addToSet: function(node,set) {
		if(set.indexOf(node) < 0) {
			set.push(node);
		}
	}
	,__class__: com_nevosoft_waw_data_Graph
};
var com_nevosoft_waw_data_ResourceRelations = function() {
	this.graph = new com_nevosoft_waw_data_Graph();
};
com_nevosoft_waw_data_ResourceRelations.__name__ = true;
com_nevosoft_waw_data_ResourceRelations.__interfaces__ = [com_nevosoft_isoframework_ICleanable];
com_nevosoft_waw_data_ResourceRelations.prototype = {
	cleanup: function() {
		this.graph = com_nevosoft_isoframework_utils_CleanupUtils.cleanup(this.graph);
	}
	,getResourceOutput: function(id) {
		var node = this.graph.getNode(id);
		var _g = [];
		var _g1 = 0;
		var _g2 = node.outEdges;
		while(_g1 < _g2.length) {
			var node = _g2[_g1];
			++_g1;
			_g.push(node.id);
		}
		return _g;
	}
	,getResourceInput: function(id) {
		var node = this.graph.getNode(id);
		var _g = [];
		var _g1 = 0;
		var _g2 = node.inEdges;
		while(_g1 < _g2.length) {
			var node = _g2[_g1];
			++_g1;
			_g.push(node.id);
		}
		return _g;
	}
	,getSimpleResources: function() {
		var _g = [];
		var _g1 = 0;
		var _g2 = this.graph.headNodes;
		while(_g1 < _g2.length) {
			var node = _g2[_g1];
			++_g1;
			_g.push(node.id);
		}
		return _g;
	}
	,getMostDificultResources: function() {
		var _g = [];
		var _g1 = 0;
		var _g2 = this.graph.tailNodes;
		while(_g1 < _g2.length) {
			var node = _g2[_g1];
			++_g1;
			_g.push(node.id);
		}
		return _g;
	}
	,addRelations: function(input,output) {
		var _g = 0;
		while(_g < input.length) {
			var inResourceId = input[_g];
			++_g;
			var _g1 = 0;
			while(_g1 < output.length) {
				var outResourceId = output[_g1];
				++_g1;
				this.graph.addEdge(inResourceId,outResourceId);
			}
		}
	}
	,get_numResources: function() {
		return this.graph.numNodes;
	}
	,__class__: com_nevosoft_waw_data_ResourceRelations
	,__properties__: {get_numResources:"get_numResources"}
};
var com_nevosoft_waw_data_SkipByTime = {};
com_nevosoft_waw_data_SkipByTime._new = function(data) {
	var this1 = data;
	return this1;
};
com_nevosoft_waw_data_SkipByTime.getSkipCost = function(this1,time) {
	var result = 0;
	var _g = 1;
	var _g1 = this1.length;
	while(_g < _g1) {
		var i = _g++;
		if(time < this1[i][0]) {
			var time0 = this1[i - 1][0];
			var time1 = this1[i][0];
			var cost0 = this1[i - 1][1];
			var cost1 = this1[i][1];
			result = Math.round((cost1 - cost0) / (time1 - time0) * (time - time0) + cost0);
			break;
		}
	}
	return result;
};
var com_nevosoft_waw_data_Storage = function(data,socialActions,meta,map) {
	this.newSocialActions = [];
	this.meta = meta;
	this.map = map;
	this.setUserData(data);
	this.currentLocationSocialActions = socialActions;
};
com_nevosoft_waw_data_Storage.__name__ = true;
com_nevosoft_waw_data_Storage.prototype = {
	initCurrentLocation: function() {
		var _g = 0;
		var _g1 = this.data.locations;
		while(_g < _g1.length) {
			var location = _g1[_g];
			++_g;
			if(location.eventId == this.data.currentGameEventId) {
				this.currentLocation = location;
				console.log("src/com/nevosoft/waw/data/Storage.hx:38:","PICK LOCATION FOR " + this.data.currentGameEventId);
				break;
			}
		}
	}
	,pushSocialAction: function(action) {
		this.currentLocationSocialActions.push(action);
		this.newSocialActions.push(action);
	}
	,setUserData: function(data) {
		this.data = data;
		this.homeLocation = data.locations[0];
	}
	,__class__: com_nevosoft_waw_data_Storage
};
var com_nevosoft_waw_data_constants_CmpOp = {};
com_nevosoft_waw_data_constants_CmpOp.compare = function(this1,a,b) {
	switch(this1) {
	case "<=":
		return a <= b;
	case "=":
		return a == b;
	case ">=":
		return a >= b;
	}
	return false;
};
var com_nevosoft_waw_data_constants_CollisionConst = function() { };
com_nevosoft_waw_data_constants_CollisionConst.__name__ = true;
var com_nevosoft_waw_data_constants_ECharacter = {};
com_nevosoft_waw_data_constants_ECharacter.toActuald = function(id) {
	switch(id) {
	case -1:
		return -1;
	case 1:
		return 324;
	case 2:
		return 325;
	case 3:
		return 326;
	case 4:
		return 327;
	default:
		throw haxe_Exception.thrown("not defined");
	}
};
var com_nevosoft_waw_data_constants_EModificatorType = {};
com_nevosoft_waw_data_constants_EModificatorType.sum = function(lhs,rhs) {
	var a = lhs;
	var b = rhs;
	return a + b;
};
var com_nevosoft_waw_data_constants_EWeightType = {};
com_nevosoft_waw_data_constants_EWeightType.getParamType = function(this1) {
	switch(this1) {
	case 11:
		return 2;
	case 12:
		return 4;
	case 13:case 14:case 15:
		return 3;
	default:
		return 5;
	}
};
var com_nevosoft_waw_data_constants_GameConst = function() { };
com_nevosoft_waw_data_constants_GameConst.__name__ = true;
var com_nevosoft_waw_data_constants_GameObjectTag = {};
com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged = function(this1,obj) {
	if(obj != null && obj.tagsComponent != null) {
		return obj.tagsComponent.indexOf(this1) >= 0;
	} else {
		return false;
	}
};
var com_nevosoft_waw_data_constants_GameObjectType = {};
com_nevosoft_waw_data_constants_GameObjectType.isStructure = function(this1) {
	switch(this1) {
	case "FENCE":case "NUT":case "PLANT":case "ROAD":case "SHMU":case "SPELL":case "STUFF":case "STUFF_PACK":
		return false;
	default:
		return true;
	}
};
var com_nevosoft_waw_data_constants_ResourceChangeReason = $hxEnums["com.nevosoft.waw.data.constants.ResourceChangeReason"] = { __ename__ : true, __constructs__ : ["EMapPendingDrop","EStorageSell","ELevelUp","ELevelUpPremium","EAnimal","EMapObject","EVassal","ENut","EBuyStuffBySkipCost","EShopItem","ERoadBuy","EBuff","ESectorBuy","EQuestCleaning","EQuestReward","EDailyQuestMinorReward","EDailyQuestTotalReward","EDailyBonusReward","EAccelerateAction","EStorageSlotBuy","EAchievementReward","EIapLot","EOfferLot","ESpellCast","ESellAtMarket","EVideoShown","EOrdersHost","EZeppelinOrderDone","EZeppelinCompleteLoad","EZeppelinRVChange","ESilent","EPOSSkipCooldown","ELottery","ETutorReward","EActionDrop","EExplorationReward","ECampOrderDone","EStoreToWarehouse","ERestoreFromWarehouse","EExplodeFromSpell","UnknownReason"]
	,EMapPendingDrop: ($_=function(id,x,y) { return {_hx_index:0,id:id,x:x,y:y,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id","x","y"],$_)
	,EStorageSell: {_hx_index:1,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,ELevelUp: {_hx_index:2,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,ELevelUpPremium: {_hx_index:3,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,EAnimal: ($_=function(id,x,y) { return {_hx_index:4,id:id,x:x,y:y,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id","x","y"],$_)
	,EMapObject: ($_=function(id) { return {_hx_index:5,id:id,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,EVassal: ($_=function(id) { return {_hx_index:6,id:id,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,ENut: ($_=function(id) { return {_hx_index:7,id:id,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,EBuyStuffBySkipCost: ($_=function(id) { return {_hx_index:8,id:id,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,EShopItem: ($_=function(id) { return {_hx_index:9,id:id,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,ERoadBuy: ($_=function(id) { return {_hx_index:10,id:id,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,EBuff: ($_=function(id) { return {_hx_index:11,id:id,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,ESectorBuy: ($_=function(id) { return {_hx_index:12,id:id,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,EQuestCleaning: ($_=function(id) { return {_hx_index:13,id:id,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,EQuestReward: ($_=function(id) { return {_hx_index:14,id:id,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,EDailyQuestMinorReward: {_hx_index:15,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,EDailyQuestTotalReward: {_hx_index:16,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,EDailyBonusReward: {_hx_index:17,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,EAccelerateAction: ($_=function(id) { return {_hx_index:18,id:id,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,EStorageSlotBuy: ($_=function(id) { return {_hx_index:19,id:id,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,EAchievementReward: ($_=function(id) { return {_hx_index:20,id:id,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,EIapLot: ($_=function(id) { return {_hx_index:21,id:id,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,EOfferLot: ($_=function(offerId,lotId) { return {_hx_index:22,offerId:offerId,lotId:lotId,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["offerId","lotId"],$_)
	,ESpellCast: ($_=function(id,x,y) { return {_hx_index:23,id:id,x:x,y:y,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id","x","y"],$_)
	,ESellAtMarket: {_hx_index:24,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,EVideoShown: ($_=function(id) { return {_hx_index:25,id:id,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,EOrdersHost: ($_=function(id,metaId) { return {_hx_index:26,id:id,metaId:metaId,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id","metaId"],$_)
	,EZeppelinOrderDone: {_hx_index:27,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,EZeppelinCompleteLoad: {_hx_index:28,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,EZeppelinRVChange: {_hx_index:29,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,ESilent: {_hx_index:30,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,EPOSSkipCooldown: ($_=function(id) { return {_hx_index:31,id:id,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,ELottery: {_hx_index:32,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,ETutorReward: ($_=function(storyId) { return {_hx_index:33,storyId:storyId,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["storyId"],$_)
	,EActionDrop: ($_=function(dropPackId) { return {_hx_index:34,dropPackId:dropPackId,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}; },$_.__params__ = ["dropPackId"],$_)
	,EExplorationReward: {_hx_index:35,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,ECampOrderDone: {_hx_index:36,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,EStoreToWarehouse: {_hx_index:37,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,ERestoreFromWarehouse: {_hx_index:38,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,EExplodeFromSpell: {_hx_index:39,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
	,UnknownReason: {_hx_index:40,__enum__:"com.nevosoft.waw.data.constants.ResourceChangeReason",toString:$estr}
};
var com_nevosoft_waw_data_constants_ResourceType = function() { };
com_nevosoft_waw_data_constants_ResourceType.__name__ = true;
var com_nevosoft_waw_data_serialization_ArrayMapInt = {};
com_nevosoft_waw_data_serialization_ArrayMapInt._new = function(v) {
	var this1 = v;
	return this1;
};
com_nevosoft_waw_data_serialization_ArrayMapInt.get = function(this1,key) {
	var idx = com_nevosoft_waw_data_serialization_ArrayMapInt.getIndex(this1,key);
	if(idx >= 0) {
		return this1[idx * 2 + 1];
	} else {
		return 0;
	}
};
com_nevosoft_waw_data_serialization_ArrayMapInt.set = function(this1,key,v) {
	var idx = com_nevosoft_waw_data_serialization_ArrayMapInt.getIndex(this1,key);
	if(idx < 0) {
		this1.push(key);
		this1.push(v);
	} else {
		this1[idx * 2 + 1] = v;
	}
};
com_nevosoft_waw_data_serialization_ArrayMapInt.remove = function(this1,key) {
	var ind = com_nevosoft_waw_data_serialization_ArrayMapInt.getIndex(this1,key);
	if(ind >= 0) {
		this1.splice(ind * 2,2);
	}
};
com_nevosoft_waw_data_serialization_ArrayMapInt.getIndex = function(this1,key) {
	var _g = 0;
	var _g1 = this1.length >> 1;
	while(_g < _g1) {
		var i = _g++;
		if(this1[i * 2] == key) {
			return i;
		}
	}
	return -1;
};
com_nevosoft_waw_data_serialization_ArrayMapInt.getLength = function(this1) {
	return this1.length >> 1;
};
com_nevosoft_waw_data_serialization_ArrayMapInt.getKey = function(this1,index) {
	return this1[index << 1];
};
var com_nevosoft_waw_data_serialization_TRoadTileData = {};
com_nevosoft_waw_data_serialization_TRoadTileData.__properties__ = {set_type:"set_type",get_type:"get_type",set_orientation:"set_orientation",get_orientation:"get_orientation"};
com_nevosoft_waw_data_serialization_TRoadTileData._new = function(orientation,type) {
	var this1 = 0;
	this1 &= -16;
	this1 |= orientation & 15;
	this1 &= 15;
	this1 |= type << 4;
	return this1;
};
com_nevosoft_waw_data_serialization_TRoadTileData.get_orientation = function(this1) {
	return this1 & 15;
};
com_nevosoft_waw_data_serialization_TRoadTileData.get_type = function(this1) {
	return this1 >> 4 & 268435455;
};
com_nevosoft_waw_data_serialization_TRoadTileData.set_orientation = function(this1,val) {
	this1 &= -16;
	this1 |= val & 15;
	return this1;
};
com_nevosoft_waw_data_serialization_TRoadTileData.set_type = function(this1,val) {
	this1 &= 15;
	this1 |= val << 4;
	return this1;
};
var com_nevosoft_waw_data_serialization_TRoadTilePos = {};
com_nevosoft_waw_data_serialization_TRoadTilePos.__properties__ = {set_y:"set_y",get_y:"get_y",set_x:"set_x",get_x:"get_x"};
com_nevosoft_waw_data_serialization_TRoadTilePos._new = function(x,y) {
	var this1 = 0;
	this1 &= -65536;
	this1 |= x & 65535;
	this1 &= 65535;
	this1 |= (y & 65535) << 16;
	return this1;
};
com_nevosoft_waw_data_serialization_TRoadTilePos.get_x = function(this1) {
	return this1 & 65535;
};
com_nevosoft_waw_data_serialization_TRoadTilePos.get_y = function(this1) {
	return this1 >> 16 & 65535;
};
com_nevosoft_waw_data_serialization_TRoadTilePos.set_x = function(this1,val) {
	this1 &= -65536;
	this1 |= val & 65535;
	return this1;
};
com_nevosoft_waw_data_serialization_TRoadTilePos.set_y = function(this1,val) {
	this1 &= 65535;
	this1 |= (val & 65535) << 16;
	return this1;
};
var com_nevosoft_waw_data_serialization_RoadSerializationOps = function() { };
com_nevosoft_waw_data_serialization_RoadSerializationOps.__name__ = true;
com_nevosoft_waw_data_serialization_RoadSerializationOps.numTiles = function(road) {
	return road.length >> 1;
};
com_nevosoft_waw_data_serialization_RoadSerializationOps.getIdxByPos = function(road,pos) {
	var _g = 0;
	var _g1 = com_nevosoft_waw_data_serialization_RoadSerializationOps.numTiles(road);
	while(_g < _g1) {
		var i = _g++;
		if(road[i << 1] == pos) {
			return i;
		}
	}
	return -1;
};
com_nevosoft_waw_data_serialization_RoadSerializationOps.getTileData = function(road,idx) {
	return road[(idx << 1) + 1];
};
com_nevosoft_waw_data_serialization_RoadSerializationOps.getTilePos = function(road,idx) {
	return road[idx << 1];
};
com_nevosoft_waw_data_serialization_RoadSerializationOps.setTileData = function(road,idx,data) {
	road[(idx << 1) + 1] = data;
};
com_nevosoft_waw_data_serialization_RoadSerializationOps.mergeTileData = function(road,idx,data) {
	var td = com_nevosoft_waw_data_serialization_RoadSerializationOps.getTileData(road,idx);
	var orientation = td & 15 | data & 15;
	td &= -16;
	td |= orientation & 15;
	com_nevosoft_waw_data_serialization_RoadSerializationOps.setTileData(road,idx,td);
};
com_nevosoft_waw_data_serialization_RoadSerializationOps.unMergeTileData = function(road,idx,data) {
	var td = com_nevosoft_waw_data_serialization_RoadSerializationOps.getTileData(road,idx);
	var orientation = td & 15 & ~(data & 15);
	td &= -16;
	td |= orientation & 15;
	com_nevosoft_waw_data_serialization_RoadSerializationOps.setTileData(road,idx,td);
};
com_nevosoft_waw_data_serialization_RoadSerializationOps.pushTile = function(road,data) {
	road.push(data.pos);
	road.push(data.data);
};
com_nevosoft_waw_data_serialization_RoadSerializationOps.removeTile = function(road,idx) {
	road.splice(idx << 1,2);
};
com_nevosoft_waw_data_serialization_RoadSerializationOps.purchaseAndUpdateRoad = function(road,purchased,updated,purchasedPoss,updatedPoss) {
	var _g = 0;
	while(_g < purchased.length) {
		var tile = purchased[_g];
		++_g;
		purchasedPoss.push(tile.pos);
		com_nevosoft_waw_data_serialization_RoadSerializationOps.pushTile(road,tile);
	}
	var updatedMap_h = { };
	var _g = 0;
	while(_g < updated.length) {
		var tile = updated[_g];
		++_g;
		updatedMap_h[tile.pos] = tile;
	}
	var i = 0;
	while(i < com_nevosoft_waw_data_serialization_RoadSerializationOps.numTiles(road)) {
		var pos = com_nevosoft_waw_data_serialization_RoadSerializationOps.getTilePos(road,i);
		if(updatedMap_h.hasOwnProperty(pos)) {
			com_nevosoft_waw_data_serialization_RoadSerializationOps.mergeTileData(road,i,updatedMap_h[pos].data);
			updatedPoss.push(pos);
		}
		++i;
	}
};
com_nevosoft_waw_data_serialization_RoadSerializationOps.removeAndUpdateRoad = function(road,removed,updated,removedPoss,updatedPoss) {
	var updatedMap_h = { };
	var _g = 0;
	while(_g < updated.length) {
		var tile = updated[_g];
		++_g;
		updatedMap_h[tile.pos] = tile;
	}
	var removedMap_h = { };
	var _g = 0;
	while(_g < removed.length) {
		var tile = removed[_g];
		++_g;
		removedMap_h[tile.pos] = tile;
	}
	var i = com_nevosoft_waw_data_serialization_RoadSerializationOps.numTiles(road) - 1;
	while(i >= 0) {
		var pos = com_nevosoft_waw_data_serialization_RoadSerializationOps.getTilePos(road,i);
		if(removedMap_h.hasOwnProperty(pos)) {
			removedPoss.push(pos);
			com_nevosoft_waw_data_serialization_RoadSerializationOps.removeTile(road,i);
		} else if(updatedMap_h.hasOwnProperty(pos)) {
			com_nevosoft_waw_data_serialization_RoadSerializationOps.unMergeTileData(road,i,updatedMap_h[pos].data);
			updatedPoss.push(pos);
		}
		--i;
	}
};
var com_nevosoft_waw_data_serialization_TMarketSlot = {};
com_nevosoft_waw_data_serialization_TMarketSlot.__properties__ = {get_demand:"get_demand"};
com_nevosoft_waw_data_serialization_TMarketSlot.getIndex = function(this1,max) {
	var data = this1.rawData;
	var _e = this1;
	var sum = Lambda.fold(data,function(a,b) {
		return com_nevosoft_waw_data_serialization_TMarketSlot.sum(_e,a,b);
	},0);
	sum += data[0];
	sum *= this1.id + 1;
	return sum % (max + 1);
};
com_nevosoft_waw_data_serialization_TMarketSlot.sum = function(this1,a,b) {
	return a + b;
};
com_nevosoft_waw_data_serialization_TMarketSlot.get_demand = function(this1) {
	var result = { };
	var length = Math.floor(this1.rawData.length / 2);
	var _g = 0;
	var _g1 = length;
	while(_g < _g1) {
		var i = _g++;
		var index = i * 2;
		var resourceId = this1.rawData[index];
		var resourceAmount = this1.rawData[index + 1];
		result[resourceId == null ? "null" : "" + resourceId] = resourceAmount;
	}
	return result;
};
var com_nevosoft_waw_data_serialization_TOrdersHostSlot = {};
com_nevosoft_waw_data_serialization_TOrdersHostSlot.__properties__ = {get_demand:"get_demand"};
com_nevosoft_waw_data_serialization_TOrdersHostSlot.get_demand = function(this1) {
	var result = { };
	var length = Math.floor(this1.rawData.length / 2);
	var _g = 0;
	var _g1 = length;
	while(_g < _g1) {
		var i = _g++;
		var index = i * 2;
		var resourceId = this1.rawData[index];
		var resourceAmount = this1.rawData[index + 1];
		result[resourceId == null ? "null" : "" + resourceId] = resourceAmount;
	}
	return result;
};
var com_nevosoft_waw_data_serialization_TZeppelinSlot = {};
com_nevosoft_waw_data_serialization_TZeppelinSlot.__properties__ = {get_needHelp:"get_needHelp",get_amount:"get_amount",get_resourceId:"get_resourceId"};
com_nevosoft_waw_data_serialization_TZeppelinSlot.askForHelp = function(this1) {
	this1.rawData[2] = 1;
};
com_nevosoft_waw_data_serialization_TZeppelinSlot.get_resourceId = function(this1) {
	return this1.rawData[0];
};
com_nevosoft_waw_data_serialization_TZeppelinSlot.get_amount = function(this1) {
	return this1.rawData[1];
};
com_nevosoft_waw_data_serialization_TZeppelinSlot.get_needHelp = function(this1) {
	return this1.rawData[2] != 0;
};
var com_nevosoft_waw_data_serialization_TCampSlot = {};
com_nevosoft_waw_data_serialization_TCampSlot.__properties__ = {get_demand:"get_demand",get_amount:"get_amount",get_resourceId:"get_resourceId"};
com_nevosoft_waw_data_serialization_TCampSlot.get_resourceId = function(this1) {
	return this1.rawData[0];
};
com_nevosoft_waw_data_serialization_TCampSlot.get_amount = function(this1) {
	return this1.rawData[1];
};
com_nevosoft_waw_data_serialization_TCampSlot.get_demand = function(this1) {
	var result = com_nevosoft_waw_data_types_TCost.fromIdValue(com_nevosoft_waw_data_serialization_TCampSlot.get_resourceId(this1),com_nevosoft_waw_data_serialization_TCampSlot.get_amount(this1));
	return result;
};
var com_nevosoft_waw_data_serialization_TAutoQuestSlot = {};
com_nevosoft_waw_data_serialization_TAutoQuestSlot.__properties__ = {get_amount:"get_amount",get_param:"get_param",get_conditionTypeId:"get_conditionTypeId"};
com_nevosoft_waw_data_serialization_TAutoQuestSlot.get_conditionTypeId = function(this1) {
	return this1.rawData[0];
};
com_nevosoft_waw_data_serialization_TAutoQuestSlot.get_amount = function(this1) {
	return this1.rawData[1];
};
com_nevosoft_waw_data_serialization_TAutoQuestSlot.get_param = function(this1) {
	return this1.rawData[2];
};
var com_nevosoft_waw_data_serialization_ExternalIds = {};
com_nevosoft_waw_data_serialization_ExternalIds._new = function(v) {
	var this1 = v;
	return this1;
};
com_nevosoft_waw_data_serialization_ExternalIds.attach = function(this1,networkId,id) {
	this1[networkId] = id;
};
com_nevosoft_waw_data_serialization_ExternalIds.detach = function(this1,networkId) {
	Reflect.deleteField(this1,networkId);
};
com_nevosoft_waw_data_serialization_ExternalIds.get = function(this1,networkId) {
	return this1[networkId];
};
com_nevosoft_waw_data_serialization_ExternalIds.exists = function(this1,networkId) {
	return Object.prototype.hasOwnProperty.call(this1,networkId);
};
com_nevosoft_waw_data_serialization_ExternalIds.networkIds = function(this1) {
	return Reflect.fields(this1);
};
com_nevosoft_waw_data_serialization_ExternalIds.fromDynamicAccess = function(v) {
	return com_nevosoft_waw_data_serialization_ExternalIds._new(v);
};
com_nevosoft_waw_data_serialization_ExternalIds.sum = function(a,b) {
	var result = com_nevosoft_waw_data_serialization_ExternalIds._new({ });
	var _g = 0;
	var _g1 = com_nevosoft_waw_data_serialization_ExternalIds.networkIds(a);
	while(_g < _g1.length) {
		var netId = _g1[_g];
		++_g;
		com_nevosoft_waw_data_serialization_ExternalIds.attach(result,netId,com_nevosoft_waw_data_serialization_ExternalIds.get(a,netId));
	}
	var _g = 0;
	var _g1 = com_nevosoft_waw_data_serialization_ExternalIds.networkIds(b);
	while(_g < _g1.length) {
		var netId = _g1[_g];
		++_g;
		com_nevosoft_waw_data_serialization_ExternalIds.attach(result,netId,com_nevosoft_waw_data_serialization_ExternalIds.get(b,netId));
	}
	return result;
};
var com_nevosoft_waw_data_serialization_ZeppelinHelp = {};
com_nevosoft_waw_data_serialization_ZeppelinHelp.__properties__ = {get_slotId:"get_slotId"};
com_nevosoft_waw_data_serialization_ZeppelinHelp._new = function(v) {
	if(v.type != "zeppelin") {
		throw haxe_Exception.thrown("wrong action");
	}
	var v1 = v.params[0];
	if(!(typeof(v1) == "number" && ((v1 | 0) === v1))) {
		throw haxe_Exception.thrown("wrong params");
	}
	var this1 = v;
	return this1;
};
com_nevosoft_waw_data_serialization_ZeppelinHelp.get_slotId = function(this1) {
	var slotId = this1.params[0];
	return slotId;
};
var com_nevosoft_waw_data_types_EGameTrigger = $hxEnums["com.nevosoft.waw.data.types.EGameTrigger"] = { __ename__ : true, __constructs__ : ["TriggerQueueAction","TriggerStartAction","TriggerAccelerateAction","TriggerCancelAction","TriggerPrepareAction","TriggerFinishAction","TriggerApplyAction","TriggerActionModificatorAdded","TriggerRoadsTransaction","TriggerCheckShmuStatus","TriggerUpgradeRequest","TriggerShmuAssigned","TriggerShmuReleased","TriggerFreezeMapObject","TriggerUnFreezeMapObject","TriggerNewMapObject","TriggerMoveMapObject","TriggerRemoveMapObject","TriggerMapObjectUpdated","TriggerNewVassal","TriggerNewNut","TriggerKillNut","TriggerRemoveVassal","TriggerBuyBuff","TriggerActivateQuest","TriggerOpenQuest","TriggerDeactivateQuest","TriggerCloseQuest","TriggerActivateOffer","TriggerDeactivateOffer","TriggerCloseOffer","TriggerOfferShown","TriggerGotDailyQuest","TriggerDailyQuestTaskComplete","TriggerDailyQuestStageComplete","TriggerDailyQuestTaskChange","TriggerRemoveDailyQuest","TriggerResourceMove","TriggerTime","TriggerNewLevel","TriggerNewPremiumLevel","TriggerBuyShopItem","TriggerUnlockSector","TriggerPlantPlaced","TriggerHarvest","TriggerStorageSlotBought","TriggerStorageSlotChanged","TriggerActivateStory","TriggerDeactivateStory","TriggerCloseStory","TriggerSpell","TriggerSpellCount","TriggerBuyInAppLot","TriggerZeppelinLoad","TriggerZeppelinLoadHelp","TriggerZeppelinComplete","TriggerActivateBuff","TriggerDeactivateBuff","TriggerPlayWithShmu","TriggerPlayWithAnimal","TriggerPointOfSaleInit","TriggerPointOfSaleExpire","TriggerPointOfSaleSlotState","TriggerMarketSell","TriggerMarketSkip","TriggerLotteryTicketGenerated","TriggerGotDailyBonusReward","TriggerQuestStageUpdated","TriggerDailyQuestSubStageUpdated","TriggerAchievementUpdated","TriggerAchievementGotReward","TriggerCampLoad","TriggerCampComplete","TriggerCampTaskChange","TriggerOrderComplete","TriggerEventChanged","TriggerActivateEvent","TriggerDeactivateEvent","TriggerCloseEvent","TriggerResBoughtByVideo","TriggerTownhallResBoughtByVideo","TriggerEnergyBoughtByVideo","TriggerRewardedVideoStatesUpdated","TriggerOpenEventEnterWindow","TriggerActivateGoGameTask","TriggerDeactivateGoGameTask","TriggerCloseGoGameTask","TriggerPendingPurchaseAdded","TriggerPendingPurchaseRemoved"]
	,TriggerQueueAction: ($_=function(params) { return {_hx_index:0,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerStartAction: ($_=function(params) { return {_hx_index:1,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerAccelerateAction: ($_=function(params) { return {_hx_index:2,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerCancelAction: ($_=function(params) { return {_hx_index:3,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerPrepareAction: ($_=function(params) { return {_hx_index:4,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerFinishAction: ($_=function(params) { return {_hx_index:5,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerApplyAction: ($_=function(params) { return {_hx_index:6,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerActionModificatorAdded: ($_=function(params) { return {_hx_index:7,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerRoadsTransaction: ($_=function(params) { return {_hx_index:8,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerCheckShmuStatus: {_hx_index:9,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}
	,TriggerUpgradeRequest: ($_=function(params) { return {_hx_index:10,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerShmuAssigned: ($_=function(params) { return {_hx_index:11,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerShmuReleased: ($_=function(params) { return {_hx_index:12,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerFreezeMapObject: ($_=function(params) { return {_hx_index:13,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerUnFreezeMapObject: ($_=function(params) { return {_hx_index:14,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerNewMapObject: ($_=function(params) { return {_hx_index:15,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerMoveMapObject: ($_=function(params) { return {_hx_index:16,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerRemoveMapObject: ($_=function(params) { return {_hx_index:17,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerMapObjectUpdated: ($_=function(params) { return {_hx_index:18,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerNewVassal: ($_=function(params) { return {_hx_index:19,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerNewNut: ($_=function(params) { return {_hx_index:20,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerKillNut: ($_=function(id) { return {_hx_index:21,id:id,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["id"],$_)
	,TriggerRemoveVassal: ($_=function(params) { return {_hx_index:22,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerBuyBuff: ($_=function(params) { return {_hx_index:23,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerActivateQuest: ($_=function(params) { return {_hx_index:24,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerOpenQuest: ($_=function(params) { return {_hx_index:25,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerDeactivateQuest: ($_=function(params) { return {_hx_index:26,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerCloseQuest: ($_=function(params) { return {_hx_index:27,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerActivateOffer: ($_=function(params) { return {_hx_index:28,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerDeactivateOffer: ($_=function(params) { return {_hx_index:29,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerCloseOffer: ($_=function(params) { return {_hx_index:30,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerOfferShown: ($_=function(params) { return {_hx_index:31,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerGotDailyQuest: ($_=function(params) { return {_hx_index:32,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerDailyQuestTaskComplete: ($_=function(params) { return {_hx_index:33,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerDailyQuestStageComplete: ($_=function(params) { return {_hx_index:34,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerDailyQuestTaskChange: ($_=function(params) { return {_hx_index:35,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerRemoveDailyQuest: {_hx_index:36,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}
	,TriggerResourceMove: ($_=function(params) { return {_hx_index:37,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerTime: ($_=function(params) { return {_hx_index:38,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerNewLevel: ($_=function(params) { return {_hx_index:39,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerNewPremiumLevel: ($_=function(params) { return {_hx_index:40,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerBuyShopItem: ($_=function(params) { return {_hx_index:41,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerUnlockSector: ($_=function(params) { return {_hx_index:42,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerPlantPlaced: ($_=function(params) { return {_hx_index:43,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerHarvest: ($_=function(params) { return {_hx_index:44,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerStorageSlotBought: ($_=function(params) { return {_hx_index:45,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerStorageSlotChanged: ($_=function(params) { return {_hx_index:46,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerActivateStory: ($_=function(params) { return {_hx_index:47,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerDeactivateStory: ($_=function(params) { return {_hx_index:48,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerCloseStory: ($_=function(params) { return {_hx_index:49,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerSpell: ($_=function(params) { return {_hx_index:50,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerSpellCount: ($_=function(count) { return {_hx_index:51,count:count,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["count"],$_)
	,TriggerBuyInAppLot: ($_=function(params) { return {_hx_index:52,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerZeppelinLoad: ($_=function(params) { return {_hx_index:53,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerZeppelinLoadHelp: ($_=function(params) { return {_hx_index:54,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerZeppelinComplete: ($_=function(params) { return {_hx_index:55,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerActivateBuff: ($_=function(params) { return {_hx_index:56,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerDeactivateBuff: ($_=function(params) { return {_hx_index:57,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerPlayWithShmu: ($_=function(params) { return {_hx_index:58,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerPlayWithAnimal: ($_=function(params) { return {_hx_index:59,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerPointOfSaleInit: ($_=function(params) { return {_hx_index:60,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerPointOfSaleExpire: ($_=function(params) { return {_hx_index:61,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerPointOfSaleSlotState: ($_=function(params) { return {_hx_index:62,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerMarketSell: ($_=function(params) { return {_hx_index:63,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerMarketSkip: ($_=function(params) { return {_hx_index:64,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerLotteryTicketGenerated: ($_=function(ticket) { return {_hx_index:65,ticket:ticket,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["ticket"],$_)
	,TriggerGotDailyBonusReward: {_hx_index:66,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}
	,TriggerQuestStageUpdated: ($_=function(params) { return {_hx_index:67,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerDailyQuestSubStageUpdated: ($_=function(params) { return {_hx_index:68,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerAchievementUpdated: ($_=function(params) { return {_hx_index:69,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerAchievementGotReward: ($_=function(params) { return {_hx_index:70,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerCampLoad: ($_=function(params) { return {_hx_index:71,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerCampComplete: ($_=function(params) { return {_hx_index:72,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerCampTaskChange: ($_=function(params) { return {_hx_index:73,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerOrderComplete: ($_=function(params) { return {_hx_index:74,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerEventChanged: ($_=function(params) { return {_hx_index:75,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerActivateEvent: ($_=function(params) { return {_hx_index:76,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerDeactivateEvent: ($_=function(params) { return {_hx_index:77,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerCloseEvent: ($_=function(params) { return {_hx_index:78,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerResBoughtByVideo: {_hx_index:79,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}
	,TriggerTownhallResBoughtByVideo: {_hx_index:80,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}
	,TriggerEnergyBoughtByVideo: {_hx_index:81,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}
	,TriggerRewardedVideoStatesUpdated: {_hx_index:82,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}
	,TriggerOpenEventEnterWindow: ($_=function(eventId) { return {_hx_index:83,eventId:eventId,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["eventId"],$_)
	,TriggerActivateGoGameTask: ($_=function(params) { return {_hx_index:84,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerDeactivateGoGameTask: ($_=function(params) { return {_hx_index:85,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerCloseGoGameTask: ($_=function(params) { return {_hx_index:86,params:params,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["params"],$_)
	,TriggerPendingPurchaseAdded: ($_=function(lotId) { return {_hx_index:87,lotId:lotId,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["lotId"],$_)
	,TriggerPendingPurchaseRemoved: ($_=function(lotId) { return {_hx_index:88,lotId:lotId,__enum__:"com.nevosoft.waw.data.types.EGameTrigger",toString:$estr}; },$_.__params__ = ["lotId"],$_)
};
var com_nevosoft_waw_data_types_EInAppReason = $hxEnums["com.nevosoft.waw.data.types.EInAppReason"] = { __ename__ : true, __constructs__ : ["None","InsufficientFunds","InsufficientGold","AccelerateAction","ProductionQueueSlot","SkipDailyQuest","SkipCampTask","ReturnZeppelin","SkipMarketCooldown","BuyRoad","BuyBuff","PremiumLot","Offer","AccelerateCamp"]
	,None: {_hx_index:0,__enum__:"com.nevosoft.waw.data.types.EInAppReason",toString:$estr}
	,InsufficientFunds: ($_=function(reason,missingResources) { return {_hx_index:1,reason:reason,missingResources:missingResources,__enum__:"com.nevosoft.waw.data.types.EInAppReason",toString:$estr}; },$_.__params__ = ["reason","missingResources"],$_)
	,InsufficientGold: ($_=function(amount,reason) { return {_hx_index:2,amount:amount,reason:reason,__enum__:"com.nevosoft.waw.data.types.EInAppReason",toString:$estr}; },$_.__params__ = ["amount","reason"],$_)
	,AccelerateAction: ($_=function(objectId,actionDecription) { return {_hx_index:3,objectId:objectId,actionDecription:actionDecription,__enum__:"com.nevosoft.waw.data.types.EInAppReason",toString:$estr}; },$_.__params__ = ["objectId","actionDecription"],$_)
	,ProductionQueueSlot: ($_=function(slotId,objectId) { return {_hx_index:4,slotId:slotId,objectId:objectId,__enum__:"com.nevosoft.waw.data.types.EInAppReason",toString:$estr}; },$_.__params__ = ["slotId","objectId"],$_)
	,SkipDailyQuest: {_hx_index:5,__enum__:"com.nevosoft.waw.data.types.EInAppReason",toString:$estr}
	,SkipCampTask: {_hx_index:6,__enum__:"com.nevosoft.waw.data.types.EInAppReason",toString:$estr}
	,ReturnZeppelin: {_hx_index:7,__enum__:"com.nevosoft.waw.data.types.EInAppReason",toString:$estr}
	,SkipMarketCooldown: {_hx_index:8,__enum__:"com.nevosoft.waw.data.types.EInAppReason",toString:$estr}
	,BuyRoad: ($_=function(id) { return {_hx_index:9,id:id,__enum__:"com.nevosoft.waw.data.types.EInAppReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,BuyBuff: ($_=function(id) { return {_hx_index:10,id:id,__enum__:"com.nevosoft.waw.data.types.EInAppReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,PremiumLot: ($_=function(lotId) { return {_hx_index:11,lotId:lotId,__enum__:"com.nevosoft.waw.data.types.EInAppReason",toString:$estr}; },$_.__params__ = ["lotId"],$_)
	,Offer: ($_=function(offerId) { return {_hx_index:12,offerId:offerId,__enum__:"com.nevosoft.waw.data.types.EInAppReason",toString:$estr}; },$_.__params__ = ["offerId"],$_)
	,AccelerateCamp: {_hx_index:13,__enum__:"com.nevosoft.waw.data.types.EInAppReason",toString:$estr}
};
var com_nevosoft_waw_data_types_EActionDescription = $hxEnums["com.nevosoft.waw.data.types.EActionDescription"] = { __ename__ : true, __constructs__ : ["Production","Build","Upgrade","OrdersHost"]
	,Production: ($_=function(id) { return {_hx_index:0,id:id,__enum__:"com.nevosoft.waw.data.types.EActionDescription",toString:$estr}; },$_.__params__ = ["id"],$_)
	,Build: {_hx_index:1,__enum__:"com.nevosoft.waw.data.types.EActionDescription",toString:$estr}
	,Upgrade: ($_=function(level) { return {_hx_index:2,level:level,__enum__:"com.nevosoft.waw.data.types.EActionDescription",toString:$estr}; },$_.__params__ = ["level"],$_)
	,OrdersHost: ($_=function(id) { return {_hx_index:3,id:id,__enum__:"com.nevosoft.waw.data.types.EActionDescription",toString:$estr}; },$_.__params__ = ["id"],$_)
};
var com_nevosoft_waw_data_types_EInsufficientFundsReason = $hxEnums["com.nevosoft.waw.data.types.EInsufficientFundsReason"] = { __ename__ : true, __constructs__ : ["Production","Upgrade","BuyAnimal","FeedAnimal","BuyBuilding","BuyPlant","ZeppelinLoad","ZeppelinHelp","MarketSell","BuySector","Spell","CampLoad","EventEnter","OrdersHostSell","Offer"]
	,Production: ($_=function(actionId) { return {_hx_index:0,actionId:actionId,__enum__:"com.nevosoft.waw.data.types.EInsufficientFundsReason",toString:$estr}; },$_.__params__ = ["actionId"],$_)
	,Upgrade: ($_=function(actionId) { return {_hx_index:1,actionId:actionId,__enum__:"com.nevosoft.waw.data.types.EInsufficientFundsReason",toString:$estr}; },$_.__params__ = ["actionId"],$_)
	,BuyAnimal: ($_=function(animalId) { return {_hx_index:2,animalId:animalId,__enum__:"com.nevosoft.waw.data.types.EInsufficientFundsReason",toString:$estr}; },$_.__params__ = ["animalId"],$_)
	,FeedAnimal: ($_=function(animalId) { return {_hx_index:3,animalId:animalId,__enum__:"com.nevosoft.waw.data.types.EInsufficientFundsReason",toString:$estr}; },$_.__params__ = ["animalId"],$_)
	,BuyBuilding: ($_=function(buildingId) { return {_hx_index:4,buildingId:buildingId,__enum__:"com.nevosoft.waw.data.types.EInsufficientFundsReason",toString:$estr}; },$_.__params__ = ["buildingId"],$_)
	,BuyPlant: ($_=function(plantId) { return {_hx_index:5,plantId:plantId,__enum__:"com.nevosoft.waw.data.types.EInsufficientFundsReason",toString:$estr}; },$_.__params__ = ["plantId"],$_)
	,ZeppelinLoad: ($_=function(slotId) { return {_hx_index:6,slotId:slotId,__enum__:"com.nevosoft.waw.data.types.EInsufficientFundsReason",toString:$estr}; },$_.__params__ = ["slotId"],$_)
	,ZeppelinHelp: ($_=function(slotId) { return {_hx_index:7,slotId:slotId,__enum__:"com.nevosoft.waw.data.types.EInsufficientFundsReason",toString:$estr}; },$_.__params__ = ["slotId"],$_)
	,MarketSell: ($_=function(slotId) { return {_hx_index:8,slotId:slotId,__enum__:"com.nevosoft.waw.data.types.EInsufficientFundsReason",toString:$estr}; },$_.__params__ = ["slotId"],$_)
	,BuySector: ($_=function(sectorId) { return {_hx_index:9,sectorId:sectorId,__enum__:"com.nevosoft.waw.data.types.EInsufficientFundsReason",toString:$estr}; },$_.__params__ = ["sectorId"],$_)
	,Spell: ($_=function(spellId) { return {_hx_index:10,spellId:spellId,__enum__:"com.nevosoft.waw.data.types.EInsufficientFundsReason",toString:$estr}; },$_.__params__ = ["spellId"],$_)
	,CampLoad: ($_=function(slotId) { return {_hx_index:11,slotId:slotId,__enum__:"com.nevosoft.waw.data.types.EInsufficientFundsReason",toString:$estr}; },$_.__params__ = ["slotId"],$_)
	,EventEnter: ($_=function(eventId) { return {_hx_index:12,eventId:eventId,__enum__:"com.nevosoft.waw.data.types.EInsufficientFundsReason",toString:$estr}; },$_.__params__ = ["eventId"],$_)
	,OrdersHostSell: ($_=function(id) { return {_hx_index:13,id:id,__enum__:"com.nevosoft.waw.data.types.EInsufficientFundsReason",toString:$estr}; },$_.__params__ = ["id"],$_)
	,Offer: ($_=function(offerId) { return {_hx_index:14,offerId:offerId,__enum__:"com.nevosoft.waw.data.types.EInsufficientFundsReason",toString:$estr}; },$_.__params__ = ["offerId"],$_)
};
var com_nevosoft_waw_data_types_EQuestCondition = $hxEnums["com.nevosoft.waw.data.types.EQuestCondition"] = { __ename__ : true, __constructs__ : ["ECollectFromObject","ECollectFromTag","EStartProductionOn","EApplyProductionOn","EQueueAction","EStartAction","EFinishAction","EApplyAction","ESellStuff","ESpendStuffAny","ESpendStuffAnyShop","EBuyInAppLot","ESpell","EOwnSector","EBuff","EVendor","EQuestComplete","EInteractWithAnimal","ESpendStuffShop","EOwnMapObject","EReceiveIncome","ESaveUpResource","EReceiveStuff","ESaveUpAndClean","EBuyStuffCategory","ESpendGoldOnCategory","EAccelerateSpell","ERichDailyQuestStage","ECompleteMarketOrder","ECompleteAnyOfOrders","EEnterGameEvent","EBuildAny","EUpgradeAny","ESectorUnlockAny","ESellAny","ECompleteZeppelinSubOrder","ECompleteZeppelinOrder","EAnySpell","EInteractWithShmu","EInteractWithAnimalAny","EDaylyBonusGot","EOwnLevel","ERichResourceLimit","EGoldLoteryTicket","EQuestDiller","EFriends","EFriendActions","EKillFriendsNuts","EFriendZeppelin","EDailyQuest","EAnimalEscape","EShmuFear","EAnimalFear","EFireBuilding","ENutsOnMap","EShmuOnMap","EBuffAny"]
	,ECollectFromObject: ($_=function(params) { return {_hx_index:0,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,ECollectFromTag: ($_=function(params) { return {_hx_index:1,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EStartProductionOn: ($_=function(params) { return {_hx_index:2,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EApplyProductionOn: ($_=function(params) { return {_hx_index:3,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EQueueAction: ($_=function(params) { return {_hx_index:4,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EStartAction: ($_=function(params) { return {_hx_index:5,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EFinishAction: ($_=function(params) { return {_hx_index:6,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EApplyAction: ($_=function(params) { return {_hx_index:7,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,ESellStuff: ($_=function(params) { return {_hx_index:8,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,ESpendStuffAny: ($_=function(params) { return {_hx_index:9,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,ESpendStuffAnyShop: ($_=function(params) { return {_hx_index:10,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EBuyInAppLot: ($_=function(params) { return {_hx_index:11,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,ESpell: ($_=function(params) { return {_hx_index:12,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EOwnSector: ($_=function(params) { return {_hx_index:13,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EBuff: ($_=function(params) { return {_hx_index:14,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EVendor: ($_=function(params) { return {_hx_index:15,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EQuestComplete: ($_=function(params) { return {_hx_index:16,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EInteractWithAnimal: ($_=function(params) { return {_hx_index:17,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,ESpendStuffShop: ($_=function(params) { return {_hx_index:18,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EOwnMapObject: ($_=function(params) { return {_hx_index:19,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EReceiveIncome: ($_=function(params) { return {_hx_index:20,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,ESaveUpResource: ($_=function(params) { return {_hx_index:21,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EReceiveStuff: ($_=function(params) { return {_hx_index:22,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,ESaveUpAndClean: ($_=function(params) { return {_hx_index:23,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EBuyStuffCategory: ($_=function(params) { return {_hx_index:24,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,ESpendGoldOnCategory: ($_=function(params) { return {_hx_index:25,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EAccelerateSpell: ($_=function(params) { return {_hx_index:26,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,ERichDailyQuestStage: ($_=function(params) { return {_hx_index:27,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,ECompleteMarketOrder: ($_=function(params) { return {_hx_index:28,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,ECompleteAnyOfOrders: ($_=function(params) { return {_hx_index:29,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EEnterGameEvent: ($_=function(params) { return {_hx_index:30,params:params,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}; },$_.__params__ = ["params"],$_)
	,EBuildAny: {_hx_index:31,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EUpgradeAny: {_hx_index:32,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,ESectorUnlockAny: {_hx_index:33,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,ESellAny: {_hx_index:34,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,ECompleteZeppelinSubOrder: {_hx_index:35,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,ECompleteZeppelinOrder: {_hx_index:36,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EAnySpell: {_hx_index:37,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EInteractWithShmu: {_hx_index:38,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EInteractWithAnimalAny: {_hx_index:39,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EDaylyBonusGot: {_hx_index:40,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EOwnLevel: {_hx_index:41,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,ERichResourceLimit: {_hx_index:42,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EGoldLoteryTicket: {_hx_index:43,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EQuestDiller: {_hx_index:44,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EFriends: {_hx_index:45,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EFriendActions: {_hx_index:46,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EKillFriendsNuts: {_hx_index:47,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EFriendZeppelin: {_hx_index:48,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EDailyQuest: {_hx_index:49,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EAnimalEscape: {_hx_index:50,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EShmuFear: {_hx_index:51,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EAnimalFear: {_hx_index:52,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EFireBuilding: {_hx_index:53,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,ENutsOnMap: {_hx_index:54,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EShmuOnMap: {_hx_index:55,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
	,EBuffAny: {_hx_index:56,__enum__:"com.nevosoft.waw.data.types.EQuestCondition",toString:$estr}
};
var com_nevosoft_waw_data_types_ConditionType = {};
com_nevosoft_waw_data_types_ConditionType.toEnum = function(this1,params) {
	switch(this1) {
	case 1:
		return com_nevosoft_waw_data_types_EQuestCondition.ESellStuff(params);
	case 2:
		return com_nevosoft_waw_data_types_EQuestCondition.ESellAny;
	case 3:
		return com_nevosoft_waw_data_types_EQuestCondition.ECompleteMarketOrder(params);
	case 4:
		return com_nevosoft_waw_data_types_EQuestCondition.ECompleteZeppelinSubOrder;
	case 5:
		return com_nevosoft_waw_data_types_EQuestCondition.ECompleteZeppelinOrder;
	case 11:
		return com_nevosoft_waw_data_types_EQuestCondition.EReceiveIncome(params);
	case 12:
		return com_nevosoft_waw_data_types_EQuestCondition.ESaveUpResource(params);
	case 13:
		return com_nevosoft_waw_data_types_EQuestCondition.EAnySpell;
	case 17:
		return com_nevosoft_waw_data_types_EQuestCondition.EAccelerateSpell(params);
	case 19:
		return com_nevosoft_waw_data_types_EQuestCondition.ESpendStuffAny(params);
	case 20:
		return com_nevosoft_waw_data_types_EQuestCondition.EBuyInAppLot(params);
	case 27:
		return com_nevosoft_waw_data_types_EQuestCondition.EOwnSector(params);
	case 28:
		return com_nevosoft_waw_data_types_EQuestCondition.EInteractWithShmu;
	case 29:
		return com_nevosoft_waw_data_types_EQuestCondition.EInteractWithAnimalAny;
	case 30:
		return com_nevosoft_waw_data_types_EQuestCondition.EQuestComplete(params);
	case 31:
		return com_nevosoft_waw_data_types_EQuestCondition.EDaylyBonusGot;
	case 32:
		return com_nevosoft_waw_data_types_EQuestCondition.EOwnLevel;
	case 33:
		return com_nevosoft_waw_data_types_EQuestCondition.ERichResourceLimit;
	case 36:
		return com_nevosoft_waw_data_types_EQuestCondition.EBuyStuffCategory(params);
	case 37:
		return com_nevosoft_waw_data_types_EQuestCondition.EBuff(params);
	case 38:
		return com_nevosoft_waw_data_types_EQuestCondition.EGoldLoteryTicket;
	case 39:
		return com_nevosoft_waw_data_types_EQuestCondition.EQuestDiller;
	case 40:
		return com_nevosoft_waw_data_types_EQuestCondition.EVendor(params);
	case 41:
		return com_nevosoft_waw_data_types_EQuestCondition.EFriends;
	case 42:
		return com_nevosoft_waw_data_types_EQuestCondition.EFriendActions;
	case 43:
		return com_nevosoft_waw_data_types_EQuestCondition.EKillFriendsNuts;
	case 45:
		return com_nevosoft_waw_data_types_EQuestCondition.EFriendZeppelin;
	case 46:
		return com_nevosoft_waw_data_types_EQuestCondition.EDailyQuest;
	case 47:
		return com_nevosoft_waw_data_types_EQuestCondition.EAnimalEscape;
	case 48:
		return com_nevosoft_waw_data_types_EQuestCondition.EShmuFear;
	case 49:
		return com_nevosoft_waw_data_types_EQuestCondition.EAnimalFear;
	case 50:
		return com_nevosoft_waw_data_types_EQuestCondition.EFireBuilding;
	case 51:
		return com_nevosoft_waw_data_types_EQuestCondition.ENutsOnMap;
	case 52:
		return com_nevosoft_waw_data_types_EQuestCondition.EShmuOnMap;
	case 55:
		return com_nevosoft_waw_data_types_EQuestCondition.EInteractWithAnimal(params);
	case 56:
		return com_nevosoft_waw_data_types_EQuestCondition.EReceiveStuff(params);
	case 57:
		return com_nevosoft_waw_data_types_EQuestCondition.ESaveUpAndClean(params);
	case 60:
		return com_nevosoft_waw_data_types_EQuestCondition.EBuffAny;
	case 61:
		return com_nevosoft_waw_data_types_EQuestCondition.ESpell(params);
	case 62:
		return com_nevosoft_waw_data_types_EQuestCondition.ESpendStuffShop(params);
	case 63:
		return com_nevosoft_waw_data_types_EQuestCondition.EStartAction(params);
	case 64:
		return com_nevosoft_waw_data_types_EQuestCondition.EQueueAction(params);
	case 65:
		return com_nevosoft_waw_data_types_EQuestCondition.EFinishAction(params);
	case 66:
		return com_nevosoft_waw_data_types_EQuestCondition.EApplyAction(params);
	case 67:
		return com_nevosoft_waw_data_types_EQuestCondition.EStartProductionOn(params);
	case 68:
		return com_nevosoft_waw_data_types_EQuestCondition.EApplyProductionOn(params);
	case 69:
		return com_nevosoft_waw_data_types_EQuestCondition.EOwnMapObject(params);
	case 70:
		return com_nevosoft_waw_data_types_EQuestCondition.ECollectFromObject(params);
	case 71:
		return com_nevosoft_waw_data_types_EQuestCondition.ESpendGoldOnCategory(params);
	case 72:
		return com_nevosoft_waw_data_types_EQuestCondition.ERichDailyQuestStage(params);
	case 73:
		return com_nevosoft_waw_data_types_EQuestCondition.EBuildAny;
	case 74:
		return com_nevosoft_waw_data_types_EQuestCondition.EUpgradeAny;
	case 75:
		return com_nevosoft_waw_data_types_EQuestCondition.ESectorUnlockAny;
	case 76:
		return com_nevosoft_waw_data_types_EQuestCondition.ECollectFromTag(params);
	case 77:
		return com_nevosoft_waw_data_types_EQuestCondition.ECompleteAnyOfOrders(params);
	case 78:
		return com_nevosoft_waw_data_types_EQuestCondition.EEnterGameEvent(params);
	case 79:
		return com_nevosoft_waw_data_types_EQuestCondition.ESpendStuffAnyShop(params);
	default:
		throw haxe_Exception.thrown("can't convert: " + this1);
	}
};
var com_nevosoft_waw_data_types_ERvAccTarget = $hxEnums["com.nevosoft.waw.data.types.ERvAccTarget"] = { __ename__ : true, __constructs__ : ["Upgrade","Production","Camp","Animal"]
	,Upgrade: {_hx_index:0,__enum__:"com.nevosoft.waw.data.types.ERvAccTarget",toString:$estr}
	,Production: {_hx_index:1,__enum__:"com.nevosoft.waw.data.types.ERvAccTarget",toString:$estr}
	,Camp: {_hx_index:2,__enum__:"com.nevosoft.waw.data.types.ERvAccTarget",toString:$estr}
	,Animal: {_hx_index:3,__enum__:"com.nevosoft.waw.data.types.ERvAccTarget",toString:$estr}
};
var com_nevosoft_waw_data_types_ERewardedVideoReason = $hxEnums["com.nevosoft.waw.data.types.ERewardedVideoReason"] = { __ename__ : true, __constructs__ : ["MarketOrderSkipRV","NpcOrderSkip","TownhallBuyRes","SectorBuyRes","UpgradeBuyRes","BuyEnergy","MarketOrder","MarketBoost","Accelerate","ZeppelinLineChange","Chest","Farm","Tnt"]
	,MarketOrderSkipRV: ($_=function(count) { return {_hx_index:0,count:count,__enum__:"com.nevosoft.waw.data.types.ERewardedVideoReason",toString:$estr}; },$_.__params__ = ["count"],$_)
	,NpcOrderSkip: ($_=function(count) { return {_hx_index:1,count:count,__enum__:"com.nevosoft.waw.data.types.ERewardedVideoReason",toString:$estr}; },$_.__params__ = ["count"],$_)
	,TownhallBuyRes: ($_=function(resId,count) { return {_hx_index:2,resId:resId,count:count,__enum__:"com.nevosoft.waw.data.types.ERewardedVideoReason",toString:$estr}; },$_.__params__ = ["resId","count"],$_)
	,SectorBuyRes: ($_=function(resId,count,sectorId) { return {_hx_index:3,resId:resId,count:count,sectorId:sectorId,__enum__:"com.nevosoft.waw.data.types.ERewardedVideoReason",toString:$estr}; },$_.__params__ = ["resId","count","sectorId"],$_)
	,UpgradeBuyRes: ($_=function(resId,count,actionId) { return {_hx_index:4,resId:resId,count:count,actionId:actionId,__enum__:"com.nevosoft.waw.data.types.ERewardedVideoReason",toString:$estr}; },$_.__params__ = ["resId","count","actionId"],$_)
	,BuyEnergy: ($_=function(resId,count,mapId) { return {_hx_index:5,resId:resId,count:count,mapId:mapId,__enum__:"com.nevosoft.waw.data.types.ERewardedVideoReason",toString:$estr}; },$_.__params__ = ["resId","count","mapId"],$_)
	,MarketOrder: {_hx_index:6,__enum__:"com.nevosoft.waw.data.types.ERewardedVideoReason",toString:$estr}
	,MarketBoost: ($_=function(count) { return {_hx_index:7,count:count,__enum__:"com.nevosoft.waw.data.types.ERewardedVideoReason",toString:$estr}; },$_.__params__ = ["count"],$_)
	,Accelerate: ($_=function(actionId,target,count) { return {_hx_index:8,actionId:actionId,target:target,count:count,__enum__:"com.nevosoft.waw.data.types.ERewardedVideoReason",toString:$estr}; },$_.__params__ = ["actionId","target","count"],$_)
	,ZeppelinLineChange: ($_=function(count) { return {_hx_index:9,count:count,__enum__:"com.nevosoft.waw.data.types.ERewardedVideoReason",toString:$estr}; },$_.__params__ = ["count"],$_)
	,Chest: {_hx_index:10,__enum__:"com.nevosoft.waw.data.types.ERewardedVideoReason",toString:$estr}
	,Farm: {_hx_index:11,__enum__:"com.nevosoft.waw.data.types.ERewardedVideoReason",toString:$estr}
	,Tnt: {_hx_index:12,__enum__:"com.nevosoft.waw.data.types.ERewardedVideoReason",toString:$estr}
};
var com_nevosoft_waw_data_types_TCostIterator = function(data) {
	this.data = data;
	this.current = 0;
	this.keys = com_nevosoft_waw_data_types_TCost.keys(data);
};
com_nevosoft_waw_data_types_TCostIterator.__name__ = true;
com_nevosoft_waw_data_types_TCostIterator.prototype = {
	hasNext: function() {
		return this.current < this.keys.length;
	}
	,next: function() {
		if(!this.hasNext()) {
			return null;
		}
		var key = this.keys[this.current];
		var this1 = this.data;
		var r = { resourceId : key, value : com_nevosoft_waw_data_types_TCost.hasKey(this1,key) ? Reflect.field(this1,key == null ? "null" : "" + key) : 0};
		this.current++;
		return r;
	}
	,__class__: com_nevosoft_waw_data_types_TCostIterator
};
var com_nevosoft_waw_data_types_TCost = {};
com_nevosoft_waw_data_types_TCost.__properties__ = {get_length:"get_length",get_first:"get_first",get_mainResourceId:"get_mainResourceId"};
com_nevosoft_waw_data_types_TCost.fromIdValue = function(id,value) {
	var r = com_nevosoft_waw_data_types_TCost._new({ });
	r[id == null ? "null" : "" + id] = value;
	return r;
};
com_nevosoft_waw_data_types_TCost.toArray = function(value,array) {
	var i = 0;
	var _g = 0;
	var _g1 = com_nevosoft_waw_data_types_TCost.keys(value);
	while(_g < _g1.length) {
		var key = _g1[_g];
		++_g;
		array[i++] = key;
		var this1 = value;
		array[i++] = com_nevosoft_waw_data_types_TCost.hasKey(this1,key) ? Reflect.field(this1,key == null ? "null" : "" + key) : 0;
	}
	return i >> 1;
};
com_nevosoft_waw_data_types_TCost.fromArray = function(array) {
	var result = com_nevosoft_waw_data_types_TCost._new({ });
	var _g = 0;
	var _g1 = Math.floor(array.length / 2);
	while(_g < _g1) {
		var i = _g++;
		var ri = i * 2;
		var key = array[ri];
		var value = array[ri + 1];
		result[key == null ? "null" : "" + key] = value;
	}
	return result;
};
com_nevosoft_waw_data_types_TCost.toArrayMapInt = function(value,array) {
	var i = 0;
	var _g = 0;
	var _g1 = com_nevosoft_waw_data_types_TCost.keys(value);
	while(_g < _g1.length) {
		var key = _g1[_g];
		++_g;
		var this1 = value;
		com_nevosoft_waw_data_serialization_ArrayMapInt.set(array,key,com_nevosoft_waw_data_types_TCost.hasKey(this1,key) ? Reflect.field(this1,key == null ? "null" : "" + key) : 0);
		++i;
	}
	return i;
};
com_nevosoft_waw_data_types_TCost.fromArrayMapInt = function(array) {
	var result = com_nevosoft_waw_data_types_TCost._new({ });
	var l = com_nevosoft_waw_data_serialization_ArrayMapInt.getLength(array);
	var _g = 0;
	var _g1 = l;
	while(_g < _g1) {
		var i = _g++;
		var k = com_nevosoft_waw_data_serialization_ArrayMapInt.getKey(array,i);
		var value = com_nevosoft_waw_data_serialization_ArrayMapInt.get(array,k);
		result[k == null ? "null" : "" + k] = value;
	}
	return result;
};
com_nevosoft_waw_data_types_TCost._new = function(v) {
	var this1 = v;
	return this1;
};
com_nevosoft_waw_data_types_TCost.get_resource = function(this1,key) {
	if(com_nevosoft_waw_data_types_TCost.hasKey(this1,key)) {
		return Reflect.field(this1,key == null ? "null" : "" + key);
	} else {
		return 0;
	}
};
com_nevosoft_waw_data_types_TCost.set_resource = function(this1,key,value) {
	this1[key == null ? "null" : "" + key] = value;
	return value;
};
com_nevosoft_waw_data_types_TCost.sub = function(lhs,rhs) {
	var result = { };
	var _g = 0;
	var _g1 = com_nevosoft_waw_data_types_TCost.keys(lhs);
	while(_g < _g1.length) {
		var key = _g1[_g];
		++_g;
		var this1 = lhs;
		var value = com_nevosoft_waw_data_types_TCost.hasKey(this1,key) ? Reflect.field(this1,key == null ? "null" : "" + key) : 0;
		result[key == null ? "null" : "" + key] = value;
	}
	var rr = new com_nevosoft_waw_data_types_TCostIterator(rhs);
	while(rr.hasNext()) {
		var rr1 = rr.next();
		var key = rr1.resourceId;
		var this1 = lhs;
		var key1 = rr1.resourceId;
		var value = com_nevosoft_waw_data_types_TCost.hasKey(this1,key1) ? Reflect.field(this1,Std.string(key1)) : 0;
		var this2 = rhs;
		var key2 = rr1.resourceId;
		var value1 = value - (com_nevosoft_waw_data_types_TCost.hasKey(this2,key2) ? Reflect.field(this2,Std.string(key2)) : 0);
		result[key == null ? "null" : "" + key] = value1;
	}
	com_nevosoft_waw_data_types_TCost.removeZeros(result);
	return result;
};
com_nevosoft_waw_data_types_TCost.sum = function(lhs,rhs) {
	var result = { };
	var _g = 0;
	var _g1 = com_nevosoft_waw_data_types_TCost.keys(lhs);
	while(_g < _g1.length) {
		var key = _g1[_g];
		++_g;
		var this1 = lhs;
		var value = com_nevosoft_waw_data_types_TCost.hasKey(this1,key) ? Reflect.field(this1,key == null ? "null" : "" + key) : 0;
		result[key == null ? "null" : "" + key] = value;
	}
	var rr = new com_nevosoft_waw_data_types_TCostIterator(rhs);
	while(rr.hasNext()) {
		var rr1 = rr.next();
		var key = rr1.resourceId;
		var this1 = lhs;
		var key1 = rr1.resourceId;
		var value = com_nevosoft_waw_data_types_TCost.hasKey(this1,key1) ? Reflect.field(this1,Std.string(key1)) : 0;
		var this2 = rhs;
		var key2 = rr1.resourceId;
		var value1 = value + (com_nevosoft_waw_data_types_TCost.hasKey(this2,key2) ? Reflect.field(this2,Std.string(key2)) : 0);
		result[key == null ? "null" : "" + key] = value1;
	}
	com_nevosoft_waw_data_types_TCost.removeZeros(result);
	return result;
};
com_nevosoft_waw_data_types_TCost.inject = function(this1,value) {
	var _g = 0;
	var _g1 = com_nevosoft_waw_data_types_TCost.keys(value);
	while(_g < _g1.length) {
		var key = _g1[_g];
		++_g;
		var this2 = this1;
		var current = com_nevosoft_waw_data_types_TCost.hasKey(this2,key) ? Reflect.field(this2,key == null ? "null" : "" + key) : 0;
		var this3 = value;
		var value1 = current + (com_nevosoft_waw_data_types_TCost.hasKey(this3,key) ? Reflect.field(this3,key == null ? "null" : "" + key) : 0);
		this1[key == null ? "null" : "" + key] = value1;
	}
};
com_nevosoft_waw_data_types_TCost.equals = function(this1,cost) {
	var result = true;
	if(com_nevosoft_waw_data_types_TCost.keys(this1).length != com_nevosoft_waw_data_types_TCost.keys(cost).length) {
		result = false;
	}
	var _g = 0;
	var _g1 = com_nevosoft_waw_data_types_TCost.keys(cost);
	while(_g < _g1.length) {
		var id = _g1[_g];
		++_g;
		var this2 = this1;
		var this3 = cost;
		if((com_nevosoft_waw_data_types_TCost.hasKey(this2,id) ? Reflect.field(this2,id == null ? "null" : "" + id) : 0) != (com_nevosoft_waw_data_types_TCost.hasKey(this3,id) ? Reflect.field(this3,id == null ? "null" : "" + id) : 0)) {
			result = false;
			break;
		}
	}
	return result;
};
com_nevosoft_waw_data_types_TCost.serialize = function(this1) {
	var keys = com_nevosoft_waw_data_types_TCost.keys(this1);
	var strs = [];
	var _g = 0;
	while(_g < keys.length) {
		var k = keys[_g];
		++_g;
		var this2 = this1;
		strs.push("" + k + " : " + (com_nevosoft_waw_data_types_TCost.hasKey(this2,k) ? Reflect.field(this2,k == null ? "null" : "" + k) : 0));
	}
	return strs.join(",");
};
com_nevosoft_waw_data_types_TCost.isEmpty = function(this1) {
	return com_nevosoft_waw_data_types_TCost.keys(this1).length == 0;
};
com_nevosoft_waw_data_types_TCost.keys = function(this1) {
	var result;
	if(this1 == null) {
		result = [];
	} else {
		var _g = [];
		var _g1 = 0;
		var _g2 = Reflect.fields(this1);
		while(_g1 < _g2.length) {
			var f = _g2[_g1];
			++_g1;
			_g.push(Std.parseInt(f));
		}
		result = com_nevosoft_waw_core_utils_ContainerUtils.sortedArrayInt(_g);
	}
	return result;
};
com_nevosoft_waw_data_types_TCost.hasKey = function(this1,key) {
	return Object.prototype.hasOwnProperty.call(this1,key == null ? "null" : "" + key);
};
com_nevosoft_waw_data_types_TCost.makeZeros = function(this1) {
	var _g = 0;
	var _g1 = Reflect.fields(this1);
	while(_g < _g1.length) {
		var field = _g1[_g];
		++_g;
		this1[field] = 0;
	}
};
com_nevosoft_waw_data_types_TCost.removeZeros = function(this1) {
	var _g = 0;
	var _g1 = Reflect.fields(this1);
	while(_g < _g1.length) {
		var field = _g1[_g];
		++_g;
		if(Reflect.field(this1,field) == 0) {
			Reflect.deleteField(this1,field);
		}
	}
};
com_nevosoft_waw_data_types_TCost.get_first_items = function(this1,count) {
	if(count == null) {
		count = 1;
	}
	var it = new com_nevosoft_waw_data_types_TCostIterator(this1);
	var _g = [];
	var _g1 = 0;
	var _g2 = count;
	while(_g1 < _g2) {
		var i = _g1++;
		_g.push(it.next());
	}
	return _g;
};
com_nevosoft_waw_data_types_TCost.getMainResources = function(this1) {
	var keys = com_nevosoft_waw_data_types_TCost.keys(this1);
	var _g = [];
	var _g1 = 0;
	while(_g1 < keys.length) {
		var k = keys[_g1];
		++_g1;
		if(com_nevosoft_waw_data_types_TCost.isMainResource(this1,k)) {
			_g.push(k);
		}
	}
	return _g;
};
com_nevosoft_waw_data_types_TCost.get_mainResourceId = function(this1) {
	var keys = com_nevosoft_waw_data_types_TCost.keys(this1);
	var _g = 0;
	while(_g < keys.length) {
		var k = keys[_g];
		++_g;
		if(com_nevosoft_waw_data_types_TCost.isMainResource(this1,k)) {
			return k;
		}
	}
	return null;
};
com_nevosoft_waw_data_types_TCost.push = function(this1,item) {
	var this2 = this1;
	var id = item.resourceId;
	var value = item.value;
	var this1 = this2;
	var current = com_nevosoft_waw_data_types_TCost.hasKey(this1,id) ? Reflect.field(this1,Std.string(id)) : 0;
	var value1 = current + value;
	this2[id == null ? "null" : "" + id] = value1;
};
com_nevosoft_waw_data_types_TCost.push2 = function(this1,id,value) {
	var this2 = this1;
	var current = com_nevosoft_waw_data_types_TCost.hasKey(this2,id) ? Reflect.field(this2,id == null ? "null" : "" + id) : 0;
	var value1 = current + value;
	this1[id == null ? "null" : "" + id] = value1;
};
com_nevosoft_waw_data_types_TCost.remove2 = function(this1,id,value) {
	var this2 = this1;
	var current = com_nevosoft_waw_data_types_TCost.hasKey(this2,id) ? Reflect.field(this2,id == null ? "null" : "" + id) : 0;
	var value1 = current - value;
	this1[id == null ? "null" : "" + id] = value1;
};
com_nevosoft_waw_data_types_TCost.isMainResource = function(this1,id) {
	return id > 0;
};
com_nevosoft_waw_data_types_TCost.copy = function(this1) {
	return com_nevosoft_waw_data_types_TCost._new(Reflect.copy(this1));
};
com_nevosoft_waw_data_types_TCost.iterator = function(this1) {
	return new com_nevosoft_waw_data_types_TCostIterator(this1);
};
com_nevosoft_waw_data_types_TCost.get_length = function(this1) {
	return com_nevosoft_waw_data_types_TCost.keys(this1).length;
};
com_nevosoft_waw_data_types_TCost.get_first = function(this1) {
	return com_nevosoft_waw_data_types_TCost.get_first_items(this1,1)[0];
};
var com_nevosoft_waw_data_types_TRestriction = {};
com_nevosoft_waw_data_types_TRestriction._new = function(v) {
	var this1 = v;
	return this1;
};
com_nevosoft_waw_data_types_TRestriction.keys = function(this1) {
	return Reflect.fields(this1);
};
com_nevosoft_waw_data_types_TRestriction.exists = function(this1,id) {
	return Object.prototype.hasOwnProperty.call(this1,id);
};
com_nevosoft_waw_data_types_TRestriction.extractLevelRestrictionSimple = function(this1) {
	var result = 1;
	if(this1 != null && com_nevosoft_waw_data_types_TRestriction.exists(this1,"1")) {
		var paramsArr = Reflect.field(this1,"1");
		if(paramsArr != null) {
			var _g = 0;
			while(_g < paramsArr.length) {
				var param = paramsArr[_g];
				++_g;
				if(param > result) {
					result = param;
				}
			}
		}
	}
	return result;
};
com_nevosoft_waw_data_types_TRestriction.extractLevelRestrictionAdvanced = function(this1) {
	if(this1 != null) {
		if(com_nevosoft_waw_data_types_TRestriction.exists(this1,"1")) {
			return com_nevosoft_waw_data_types_TRestriction.extractLevelRestrictionSimple(this1);
		} else if(com_nevosoft_waw_data_types_TRestriction.exists(this1,"6")) {
			var result = 1;
			var rangeArr = Reflect.field(this1,"6");
			var _g = 0;
			while(_g < rangeArr.length) {
				var range = rangeArr[_g];
				++_g;
				if(range.min > result) {
					result = range.min;
				}
			}
			return result;
		} else if(com_nevosoft_waw_data_types_TRestriction.exists(this1,"-6")) {
			var result = 1;
			var rangeArr = Reflect.field(this1,"6");
			var _g = 0;
			while(_g < rangeArr.length) {
				var range = rangeArr[_g];
				++_g;
				if(range.max + 1 > result) {
					result = range.max + 1;
				}
			}
			return result;
		}
	}
	return 0;
};
com_nevosoft_waw_data_types_TRestriction.getParams = function(this1,id) {
	return Reflect.field(this1,id);
};
var com_nevosoft_waw_data_types_ContentItem = function(content,unlocksOnLevel) {
	this.content = content;
	this.unlocksOnLevel = unlocksOnLevel;
};
com_nevosoft_waw_data_types_ContentItem.__name__ = true;
com_nevosoft_waw_data_types_ContentItem.prototype = {
	__class__: com_nevosoft_waw_data_types_ContentItem
};
var com_nevosoft_waw_data_types_ContentIterator = function(items,minIndex,maxIndex) {
	this.items = items;
	this.minIndex = minIndex;
	this.maxIndex = maxIndex;
	this.currentIndex = minIndex;
	this.length = maxIndex - minIndex;
};
com_nevosoft_waw_data_types_ContentIterator.__name__ = true;
com_nevosoft_waw_data_types_ContentIterator.prototype = {
	hasNext: function() {
		return this.currentIndex < this.maxIndex;
	}
	,next: function() {
		return this.items[++this.currentIndex].content;
	}
	,__class__: com_nevosoft_waw_data_types_ContentIterator
};
var com_nevosoft_waw_data_types_UnlockableContent = function() {
	this.isDirty = true;
	this.contentItems = [];
	this.levelPointers = [];
	this.dict = new haxe_ds_IntMap();
};
com_nevosoft_waw_data_types_UnlockableContent.__name__ = true;
com_nevosoft_waw_data_types_UnlockableContent.prototype = {
	storeContent: function(content,unlocksOnLevel) {
		var item = new com_nevosoft_waw_data_types_ContentItem(content,unlocksOnLevel);
		this.dict.h[content.id] = item;
		this.contentItems.push(item);
	}
	,hasContent: function(id) {
		return this.dict.h.hasOwnProperty(id);
	}
	,getContent: function(id) {
		if(!this.hasContent(id)) {
			throw haxe_Exception.thrown("no content: " + id);
		}
		return this.dict.h[id].content;
	}
	,getContentItem: function(id) {
		return this.dict.h[id];
	}
	,getUnlockLevel: function(id) {
		if(this.hasContent(id)) {
			return this.getContentItem(id).unlocksOnLevel;
		} else {
			return 0;
		}
	}
	,availableOnLevel: function(level) {
		return this.unlocksOnLevelRange(0,level);
	}
	,unlocksOnLevel: function(level) {
		return this.unlocksOnLevelRange(level,level);
	}
	,unlocksOnLevelRange: function(minLevel,maxLevel) {
		this.validate();
		var minLvlPointerIndex = Math.floor(com_nevosoft_isoframework_utils_MathUtils.clamp(minLevel,0,this.levelPointers.length - 1));
		var maxLvlPointerIndex = Math.floor(com_nevosoft_isoframework_utils_MathUtils.clamp(maxLevel,0,this.levelPointers.length - 1));
		var minInd = minLvlPointerIndex == 0 ? -1 : this.levelPointers[minLvlPointerIndex - 1];
		var maxInd = this.levelPointers[maxLvlPointerIndex];
		return new com_nevosoft_waw_data_types_ContentIterator(this.contentItems,minInd,maxInd);
	}
	,validate: function() {
		if(this.isDirty) {
			this.removeDuplicates();
			this.sortByLevels();
			this.buildLevelPointers();
			this.isDirty = false;
		}
	}
	,sortByLevels: function() {
		this.contentItems.sort(function(a,b) {
			var priority0 = a.unlocksOnLevel - b.unlocksOnLevel;
			var priority1 = a.content.id - b.content.id;
			if(priority0 == 0) {
				return priority1;
			}
			return priority0;
		});
	}
	,removeDuplicates: function() {
		var map_h = { };
		var toRemove = [];
		var _g = 0;
		var _g1 = this.contentItems;
		while(_g < _g1.length) {
			var it = _g1[_g];
			++_g;
			if(map_h.hasOwnProperty(it.content.id)) {
				toRemove.push(it);
				continue;
			}
			map_h[it.content.id] = 1;
		}
		var _g = 0;
		while(_g < toRemove.length) {
			var remove = toRemove[_g];
			++_g;
			HxOverrides.remove(this.contentItems,remove);
		}
	}
	,buildLevelPointers: function() {
		this.levelPointers = [];
		this.levelPointers[0] = 0;
		var lastSetLevel = 0;
		var _g = 0;
		var _g1 = this.contentItems.length;
		while(_g < _g1) {
			var i = _g++;
			var it = this.contentItems[i];
			this.levelPointers[it.unlocksOnLevel] = i;
			var _g2 = lastSetLevel;
			var _g3 = it.unlocksOnLevel;
			while(_g2 < _g3) {
				var j = _g2++;
				this.levelPointers[j] = this.levelPointers[lastSetLevel];
			}
			lastSetLevel = it.unlocksOnLevel;
		}
	}
	,__class__: com_nevosoft_waw_data_types_UnlockableContent
};
var com_nevosoft_waw_data_types_meta_EActionType = {};
com_nevosoft_waw_data_types_meta_EActionType.inUpgradeGroup = function(this1) {
	switch(this1) {
	case 1:case 2:case 4:
		return true;
	default:
		return false;
	}
};
com_nevosoft_waw_data_types_meta_EActionType.inProductionGroup = function(this1) {
	if(this1 != 3) {
		return this1 == 2;
	} else {
		return true;
	}
};
var com_nevosoft_waw_data_types_meta_TMtCommonBuilding = {};
com_nevosoft_waw_data_types_meta_TMtCommonBuilding.__properties__ = {get_initialState:"get_initialState"};
com_nevosoft_waw_data_types_meta_TMtCommonBuilding._new = function(obj) {
	if(obj.category != "COMMON_BUILDING") {
		throw haxe_Exception.thrown("expected category: " + "COMMON_BUILDING" + " but it is " + obj.category);
	}
	var this1 = obj;
	return this1;
};
com_nevosoft_waw_data_types_meta_TMtCommonBuilding.fromGameObject = function(obj) {
	return com_nevosoft_waw_data_types_meta_TMtCommonBuilding._new(obj);
};
com_nevosoft_waw_data_types_meta_TMtCommonBuilding.get_initialState = function(this1) {
	return this1.initialState;
};
var com_nevosoft_waw_data_types_meta_PosMaxTable = {};
com_nevosoft_waw_data_types_meta_PosMaxTable._new = function(v) {
	var this1 = v;
	return this1;
};
com_nevosoft_waw_data_types_meta_PosMaxTable.keyFrom = function(this1,posId,paramType,param) {
	return "" + posId + ":" + paramType + ":" + param;
};
com_nevosoft_waw_data_types_meta_PosMaxTable.isLimited = function(this1,posId,paramType,param) {
	var key = com_nevosoft_waw_data_types_meta_PosMaxTable.keyFrom(this1,posId,paramType,param);
	return Object.prototype.hasOwnProperty.call(this1.h,key);
};
com_nevosoft_waw_data_types_meta_PosMaxTable.getMaxLimit = function(this1,posId,paramType,param) {
	var key = com_nevosoft_waw_data_types_meta_PosMaxTable.keyFrom(this1,posId,paramType,param);
	return this1.h[key];
};
com_nevosoft_waw_data_types_meta_PosMaxTable.setMaxLimit = function(this1,posId,paramType,param,maxValue) {
	var key = com_nevosoft_waw_data_types_meta_PosMaxTable.keyFrom(this1,posId,paramType,param);
	this1.h[key] = maxValue;
};
com_nevosoft_waw_data_types_meta_PosMaxTable.storeMaxRecord = function(this1,maxRecord) {
	com_nevosoft_waw_data_types_meta_PosMaxTable.setMaxLimit(this1,maxRecord.posId,maxRecord.paramType,maxRecord.param,maxRecord.max);
};
com_nevosoft_waw_data_types_meta_PosMaxTable.clampByLimit = function(this1,posId,paramType,param,amount) {
	var key = com_nevosoft_waw_data_types_meta_PosMaxTable.keyFrom(this1,posId,paramType,param);
	var maxLimited = amount;
	if(com_nevosoft_waw_data_types_meta_PosMaxTable.isLimited(this1,posId,paramType,param)) {
		var limit = com_nevosoft_waw_data_types_meta_PosMaxTable.getMaxLimit(this1,posId,paramType,param);
		maxLimited = Math.min(limit,amount);
	}
	return Math.floor(Math.max(1.0,maxLimited));
};
com_nevosoft_waw_data_types_meta_PosMaxTable.isAvailable = function(this1,posId,paramType,param) {
	var result = true;
	if(com_nevosoft_waw_data_types_meta_PosMaxTable.isLimited(this1,posId,paramType,param)) {
		var max = com_nevosoft_waw_data_types_meta_PosMaxTable.getMaxLimit(this1,posId,paramType,param);
		result = max > 0;
	}
	return result;
};
var com_nevosoft_waw_data_types_meta_story_EmotionType = {};
com_nevosoft_waw_data_types_meta_story_EmotionType.toString = function(this1) {
	switch(this1) {
	case 0:
		return "IDLE";
	case 1:
		return "LAUGHING";
	case 2:
		return "HAPPY";
	case 3:
		return "SURPRISED";
	case 4:
		return "DISPLEASED";
	case 5:
		return "THINKING";
	case 6:
		return "PANIC";
	case 7:
		return "SAD";
	default:
		throw haxe_Exception.thrown("not defined");
	}
};
com_nevosoft_waw_data_types_meta_story_EmotionType.fromString = function(v) {
	var _g = 0;
	var _g1 = com_nevosoft_waw_data_types_meta_story_EmotionType.getList();
	while(_g < _g1.length) {
		var ev = _g1[_g];
		++_g;
		if(com_nevosoft_waw_data_types_meta_story_EmotionType.toString(ev) == v) {
			return ev;
		}
	}
	throw haxe_Exception.thrown("not found");
};
com_nevosoft_waw_data_types_meta_story_EmotionType.getSkeletonsString = function() {
	var emotions = com_nevosoft_waw_data_types_meta_story_EmotionType.getStringList();
	var s = [];
	var _g = 0;
	while(_g < emotions.length) {
		var emo = emotions[_g];
		++_g;
		s.push(emo.toLowerCase());
	}
	return s.join(";");
};
com_nevosoft_waw_data_types_meta_story_EmotionType.getStringList = function() {
	var _g = [];
	var _g1 = 0;
	var _g2 = com_nevosoft_waw_data_types_meta_story_EmotionType.getList();
	while(_g1 < _g2.length) {
		var v = _g2[_g1];
		++_g1;
		_g.push(com_nevosoft_waw_data_types_meta_story_EmotionType.toString(v));
	}
	return _g;
};
com_nevosoft_waw_data_types_meta_story_EmotionType.getList = function() {
	return [0,1,2,3,4,5,6,7];
};
var com_nevosoft_waw_data_types_meta_story_SceneTypes = function() { };
com_nevosoft_waw_data_types_meta_story_SceneTypes.__name__ = true;
var com_nevosoft_waw_data_types_meta_story_SceneType = {};
com_nevosoft_waw_data_types_meta_story_SceneType._new = function(sceneType) {
	var this1 = sceneType;
	return this1;
};
var com_nevosoft_waw_data_types_meta_story_StoryVO = {};
com_nevosoft_waw_data_types_meta_story_StoryVO.__properties__ = {get_scenesCount:"get_scenesCount"};
com_nevosoft_waw_data_types_meta_story_StoryVO._new = function(v) {
	var this1 = v;
	return this1;
};
com_nevosoft_waw_data_types_meta_story_StoryVO.getSceneType = function(this1,index) {
	var scene = this1.scenes[index];
	return scene.type;
};
com_nevosoft_waw_data_types_meta_story_StoryVO.getSceneParams = function(this1,index) {
	var scene = this1.scenes[index];
	return scene.params;
};
com_nevosoft_waw_data_types_meta_story_StoryVO.isPreloaderTimeStory = function(this1) {
	return this1.id == 272;
};
com_nevosoft_waw_data_types_meta_story_StoryVO.attachedToQuest = function(this1) {
	if(com_nevosoft_waw_data_types_TRestriction.exists(this1.restrictions,"5")) {
		return Reflect.field(this1.restrictions,"5")[0];
	} else {
		return -1;
	}
};
com_nevosoft_waw_data_types_meta_story_StoryVO.get_scenesCount = function(this1) {
	return this1.scenes.length;
};
var com_nevosoft_waw_data_vo_OnMapStorage = function(data,meta,eventId) {
	this.isClone = false;
	this._counterInited = false;
	this._currentCheckToken = -1;
	this._memory = 0;
	this._data = data;
	this._meta = meta;
	this.currentGameEventId = eventId;
};
com_nevosoft_waw_data_vo_OnMapStorage.__name__ = true;
com_nevosoft_waw_data_vo_OnMapStorage.getCheckToken = function() {
	return com_nevosoft_waw_data_vo_OnMapStorage._checkToken++;
};
com_nevosoft_waw_data_vo_OnMapStorage.prototype = {
	getData: function() {
		return this._data;
	}
	,setData: function(obj) {
		this._data = obj;
	}
	,getMeta: function() {
		return this._meta;
	}
	,initCounter: function(value) {
		if(this._counterInited) {
			throw haxe_Exception.thrown("error! - storageRef: counter already inited");
		}
		this.counter = value;
		this._counterInited = true;
	}
	,check: function(add,checkToken) {
		if(checkToken != this._currentCheckToken) {
			this.forget();
			this._currentCheckToken = checkToken;
		}
		var tmp;
		if(this._meta.gameEventsComponent != null && this._meta.gameEventsComponent.indexOf(this.currentGameEventId) < 0 && this.currentGameEventId != 1) {
			tmp = -1;
		} else {
			var level = this._data == null || this._data.cUpgradable == null ? 1 : this._data.cUpgradable.level;
			tmp = this._meta.storageComponent.limits[level - 1];
		}
		if(tmp < 0) {
			return true;
		}
		var result;
		if(this._meta.gameEventsComponent != null && this._meta.gameEventsComponent.indexOf(this.currentGameEventId) < 0 && this.currentGameEventId != 1) {
			result = -1;
		} else {
			var level = this._data == null || this._data.cUpgradable == null ? 1 : this._data.cUpgradable.level;
			result = this._meta.storageComponent.limits[level - 1];
		}
		var result1 = this.counter + this._memory < result;
		if(result1) {
			this._memory += add;
		}
		return result1;
	}
	,forget: function() {
		this._memory = 0;
	}
	,inc: function(value,allowOverLimit) {
		if(allowOverLimit == null) {
			allowOverLimit = true;
		}
		var tmp;
		var tmp1;
		if(!allowOverLimit) {
			var tmp2;
			if(this._meta.gameEventsComponent != null && this._meta.gameEventsComponent.indexOf(this.currentGameEventId) < 0 && this.currentGameEventId != 1) {
				tmp2 = -1;
			} else {
				var level = this._data == null || this._data.cUpgradable == null ? 1 : this._data.cUpgradable.level;
				tmp2 = this._meta.storageComponent.limits[level - 1];
			}
			tmp1 = tmp2 > 0;
		} else {
			tmp1 = false;
		}
		if(tmp1) {
			var tmp1;
			if(this._meta.gameEventsComponent != null && this._meta.gameEventsComponent.indexOf(this.currentGameEventId) < 0 && this.currentGameEventId != 1) {
				tmp1 = -1;
			} else {
				var level = this._data == null || this._data.cUpgradable == null ? 1 : this._data.cUpgradable.level;
				tmp1 = this._meta.storageComponent.limits[level - 1];
			}
			tmp = this.counter >= tmp1;
		} else {
			tmp = false;
		}
		if(tmp) {
			var tmp;
			if(this._meta.gameEventsComponent != null && this._meta.gameEventsComponent.indexOf(this.currentGameEventId) < 0 && this.currentGameEventId != 1) {
				tmp = -1;
			} else {
				var level = this._data == null || this._data.cUpgradable == null ? 1 : this._data.cUpgradable.level;
				tmp = this._meta.storageComponent.limits[level - 1];
			}
			throw haxe_Exception.thrown("error! - resources " + this._meta.id + ": over limit (" + this.counter + "/" + tmp + ") inc is not allowed!");
		}
		this.counter += value;
	}
	,dec: function(value) {
		this.counter -= value;
		if(this.counter < 0) {
			throw haxe_Exception.thrown("error! - resources " + this._meta.id + ": counter might not be less than zero!");
		}
	}
	,clone: function() {
		var result = new com_nevosoft_waw_data_vo_OnMapStorage(this._data,this._meta,this.currentGameEventId);
		result.initCounter(this.counter);
		result.isClone = true;
		return result;
	}
	,get_limit: function() {
		if(this._meta.gameEventsComponent != null && this._meta.gameEventsComponent.indexOf(this.currentGameEventId) < 0 && this.currentGameEventId != 1) {
			return -1;
		}
		var level = this._data == null || this._data.cUpgradable == null ? 1 : this._data.cUpgradable.level;
		return this._meta.storageComponent.limits[level - 1];
	}
	,get_counter: function() {
		return this.counter;
	}
	,__class__: com_nevosoft_waw_data_vo_OnMapStorage
	,__properties__: {get_counter:"get_counter",get_limit:"get_limit"}
};
var com_nevosoft_waw_dpScopes_AchievementsDataProvider = function(storage,dataProvider) {
	com_nevosoft_waw_BaseDataProviderScope.call(this,storage,dataProvider);
};
com_nevosoft_waw_dpScopes_AchievementsDataProvider.__name__ = true;
com_nevosoft_waw_dpScopes_AchievementsDataProvider.__super__ = com_nevosoft_waw_BaseDataProviderScope;
com_nevosoft_waw_dpScopes_AchievementsDataProvider.prototype = $extend(com_nevosoft_waw_BaseDataProviderScope.prototype,{
	getAll: function() {
		return this._profileIndex.achievements;
	}
	,getAchievementEntity: function(id) {
		if(!this._profileIndex.achievementsMap.h.hasOwnProperty(id)) {
			throw haxe_Exception.thrown("no achievement with id: " + id);
		}
		return this._profileIndex.achievementsMap.h[id];
	}
	,calculateCurrentReward: function(data,meta) {
		var rewards = { };
		var _g = 0;
		var _g1 = meta.stages.length;
		while(_g < _g1) {
			var i = _g++;
			var stage = meta.stages[i];
			if(data.counter < stage.conditionValue) {
				break;
			}
			if(i > data.lastRewardedStage) {
				rewards = stage.rewards;
				break;
			}
		}
		return rewards;
	}
	,isInCurrentEvent: function(achievementId) {
		var achievement = this._metaIndex.achievements.h[achievementId];
		if(achievement.gameEventsComponent != null) {
			return achievement.gameEventsComponent.indexOf(this._storage.data.currentGameEventId) >= 0;
		} else {
			return true;
		}
	}
	,hasReadyRewards: function() {
		var _g = 0;
		var _g1 = this.getAll();
		while(_g < _g1.length) {
			var achievement = _g1[_g];
			++_g;
			if(com_nevosoft_waw_data_types_TCost.keys(achievement.get_currentReward()).length > 0) {
				return true;
			}
		}
		return false;
	}
	,__class__: com_nevosoft_waw_dpScopes_AchievementsDataProvider
});
var com_nevosoft_waw_dpScopes_ActionsDataProvider = function(storage,dataProvider) {
	com_nevosoft_waw_BaseDataProviderScope.call(this,storage,dataProvider);
};
com_nevosoft_waw_dpScopes_ActionsDataProvider.__name__ = true;
com_nevosoft_waw_dpScopes_ActionsDataProvider.__super__ = com_nevosoft_waw_BaseDataProviderScope;
com_nevosoft_waw_dpScopes_ActionsDataProvider.prototype = $extend(com_nevosoft_waw_BaseDataProviderScope.prototype,{
	getActionMeta: function(id) {
		var result = null;
		if(id < 0) {
			result = com_nevosoft_waw_core_utils_ContainerUtils.getObjectById(this._storage.currentLocation.userActions,id);
		} else {
			result = this._metaIndex.mapObjectActions.h[id];
		}
		return result;
	}
	,getActionOwnerId: function(id) {
		if(!this._metaIndex.actionOwners.h.hasOwnProperty(id)) {
			throw haxe_Exception.thrown("no owner info for action: " + id);
		}
		return this._metaIndex.actionOwners.h[id];
	}
	,getActionOwner: function(id) {
		var ownerId = this.getActionOwnerId(id);
		return this._dataProvider.mapObjects.getMeta(ownerId);
	}
	,getBuildActionMeta: function(obj) {
		return this.getUpgradeAtLevel(obj,0);
	}
	,getRepairActionMeta: function(obj) {
		var result = null;
		if(obj.workComponent != null) {
			result = obj.workComponent.repairAction;
		}
		return result;
	}
	,canStartUpgrade: function(obj) {
		return this.getProductionAllStatus(obj).length == 0;
	}
	,hasUpgradeAtLevel: function(obj,level) {
		if(obj.workComponent == null) {
			return false;
		}
		return level < obj.workComponent.upgradeActions.length;
	}
	,getUpgradeAtLevel: function(obj,level) {
		var result = null;
		if(obj == null) {
			return null;
		}
		if(obj.workComponent != null) {
			result = obj.workComponent.upgradeActions[level];
		}
		return result;
	}
	,getAnimalProduction: function(obj) {
		if(obj.category != "ANIMAL") {
			throw haxe_Exception.thrown("not an animal");
		}
		if(obj.workComponent == null) {
			throw haxe_Exception.thrown("must have workComponent");
		}
		if(obj.workComponent.actions.length != 1) {
			throw haxe_Exception.thrown("wrong actions count");
		}
		return obj.workComponent.actions[0];
	}
	,getProductionAtLevel: function(obj,level) {
		var result = null;
		if(obj.workComponent != null) {
			result = obj.workComponent.actions[level - 1];
		}
		return result;
	}
	,getProductionIndex: function(obj,actionId) {
		var productionIndex = 0;
		if(obj.workComponent != null) {
			productionIndex = com_nevosoft_waw_core_utils_ContainerUtils.getIndexOf(obj.workComponent.actions,actionId);
		}
		return productionIndex;
	}
	,getUpgradeIndex: function(obj,actionId) {
		var upgradeIndex = 0;
		if(obj.workComponent != null) {
			upgradeIndex = com_nevosoft_waw_core_utils_ContainerUtils.getIndexOf(obj.workComponent.upgradeActions,actionId);
		}
		return upgradeIndex;
	}
	,getFreeProductionMeta: function(obj) {
		var objMeta = this._metaIndex.gameObjects.h[obj.metaId];
		if(objMeta == null) {
			return null;
		}
		var level = this._dataProvider.mapObjects.getLevel(obj);
		var workComponent = objMeta.workComponent;
		var actionMeta = this.getProductionAtLevel(objMeta,level);
		var result;
		if(actionMeta != null) {
			var aMeta = actionMeta;
			result = aMeta.type == 3 && com_nevosoft_waw_data_types_TCost.keys(aMeta.spendings).length == 0 ? aMeta : null;
		} else {
			result = null;
		}
		return result;
	}
	,getFreeUpgradeMeta: function(obj) {
		if(obj.cUpgradable == null) {
			return null;
		}
		var upgrade = this.getUpgradeAtLevel(this._dataProvider.meta.getGameObjectMeta(obj.metaId),obj.cUpgradable.level);
		if(upgrade == null || com_nevosoft_waw_data_types_TCost.keys(upgrade.spendings).length > 0) {
			return null;
		}
		return upgrade;
	}
	,getCurrentActionState: function(obj,useBGWorkplace) {
		if(useBGWorkplace == null) {
			useBGWorkplace = false;
		}
		var workplace = useBGWorkplace ? obj.cBGWorkplace : obj.cWorkplace;
		var result = null;
		if(workplace != null) {
			var ind = workplace.currentActionIndex;
			if(ind >= 0) {
				result = workplace.actionsQueue[ind];
			}
		}
		return result;
	}
	,getNextActionMeta: function(obj,useBGWorkplace) {
		if(useBGWorkplace == null) {
			useBGWorkplace = false;
		}
		var actionMeta = null;
		var nextIndex = this.getNextActionFromQueue(obj,useBGWorkplace);
		if(nextIndex >= 0) {
			var nextActionState = obj.cWorkplace.actionsQueue[nextIndex];
			if(nextActionState.status != 0) {
				throw haxe_Exception.thrown("not NONE status of next action in queue");
			}
			actionMeta = this.getActionMeta(nextActionState.id);
		}
		return actionMeta;
	}
	,getCurrentActionMeta: function(obj,useBGWorkplace) {
		if(useBGWorkplace == null) {
			useBGWorkplace = false;
		}
		var result = null;
		var state = this.getCurrentActionState(obj,useBGWorkplace);
		if(state != null) {
			result = this.getActionMeta(state.id);
		}
		return result;
	}
	,isUpgrading: function(obj) {
		var currentActionMeta = this.getCurrentActionMeta(obj);
		if(currentActionMeta != null) {
			return com_nevosoft_waw_data_types_meta_EActionType.inUpgradeGroup(currentActionMeta.type);
		} else {
			return false;
		}
	}
	,getProductionAllStatus: function(obj,useBGWorkplace) {
		if(useBGWorkplace == null) {
			useBGWorkplace = false;
		}
		var result = [];
		var workplace = useBGWorkplace ? obj.cBGWorkplace : obj.cWorkplace;
		if(workplace != null) {
			var _g = 0;
			var _g1 = workplace.actionsQueue;
			while(_g < _g1.length) {
				var a = _g1[_g];
				++_g;
				var aMeta = this.getActionMeta(a.id);
				if(aMeta.type == 3) {
					result.push(a);
				}
			}
		}
		return result;
	}
	,getFirstFinishedUpgrade: function(obj,useBGWorkplace) {
		if(useBGWorkplace == null) {
			useBGWorkplace = false;
		}
		var result = null;
		var workplace = useBGWorkplace ? obj.cBGWorkplace : obj.cWorkplace;
		var _g = 0;
		var _g1 = workplace.actionsQueue;
		while(_g < _g1.length) {
			var a = _g1[_g];
			++_g;
			if(a.status == 3) {
				var aMt = this.getActionMeta(a.id);
				if(com_nevosoft_waw_data_types_meta_EActionType.inUpgradeGroup(aMt.type)) {
					result = a;
					break;
				}
			}
		}
		return result;
	}
	,hasUnfinishedActions: function(obj,useBGWorkplace) {
		if(useBGWorkplace == null) {
			useBGWorkplace = false;
		}
		var result = false;
		var workplace = useBGWorkplace ? obj.cBGWorkplace : obj.cWorkplace;
		var _g = 0;
		var _g1 = workplace.actionsQueue;
		while(_g < _g1.length) {
			var a = _g1[_g];
			++_g;
			if(a.status != 3) {
				result = true;
				break;
			}
		}
		return result;
	}
	,getFinishedActions: function(obj,useBGWorkplace) {
		if(useBGWorkplace == null) {
			useBGWorkplace = false;
		}
		var workplace = useBGWorkplace ? obj.cBGWorkplace : obj.cWorkplace;
		var result = [];
		var _g = 0;
		var _g1 = workplace.actionsQueue;
		while(_g < _g1.length) {
			var a = _g1[_g];
			++_g;
			if(a.status == 3) {
				result.push(a);
			}
		}
		return result;
	}
	,getFinishedProduction: function(obj) {
		var result = [];
		var workplace = obj.cWorkplace;
		var _g = 0;
		var _g1 = workplace.actionsQueue;
		while(_g < _g1.length) {
			var a = _g1[_g];
			++_g;
			if(a.status == 3) {
				var aMeta = this.getActionMeta(a.id);
				if(aMeta.type == 3 || aMeta.type == 2) {
					result.push(a);
				}
			}
		}
		return result;
	}
	,getFinishedProductionCached: function(obj,result) {
		var workplace = obj.cWorkplace;
		var count = 0;
		var _g = 0;
		var _g1 = workplace.actionsQueue;
		while(_g < _g1.length) {
			var a = _g1[_g];
			++_g;
			if(a.status == 3) {
				var aMeta = this.getActionMeta(a.id);
				if(aMeta.type == 3 || aMeta.type == 2) {
					result[count] = a;
					++count;
				}
			}
		}
		return count;
	}
	,isProductionQueueIsFull: function(obj,useBGWorkplace) {
		if(useBGWorkplace == null) {
			useBGWorkplace = false;
		}
		var production = this.getProductionAllStatus(obj,useBGWorkplace);
		var workplace = useBGWorkplace ? obj.cBGWorkplace : obj.cWorkplace;
		return production.length >= workplace.slots;
	}
	,getNextActionFromQueue: function(obj,useBGWorkplace) {
		if(useBGWorkplace == null) {
			useBGWorkplace = false;
		}
		var workplace = useBGWorkplace ? obj.cBGWorkplace : obj.cWorkplace;
		var index = -1;
		if(workplace != null) {
			var _g = 0;
			var _g1 = workplace.actionsQueue;
			while(_g < _g1.length) {
				var a = _g1[_g];
				++_g;
				++index;
				if(a.status == 3 || a.status == 2) {
					continue;
				} else if(a.status == 0) {
					return index;
				} else {
					throw haxe_Exception.thrown("has action with wrong status in queue");
				}
			}
		}
		return -1;
	}
	,calculateRewards: function(actionState,actionMeta) {
		if(actionMeta == null) {
			actionMeta = this.getActionMeta(actionState.id);
		}
		var reward = com_nevosoft_waw_data_types_TCost._new(Reflect.copy(actionMeta.reward));
		var _g = 0;
		var _g1 = actionState.modificators;
		while(_g < _g1.length) {
			var m = _g1[_g];
			++_g;
			if(m.modificator == 2) {
				this.multiplyIncome(reward,m.strength,$bind(this,this.exceptGoldPred));
			}
		}
		return reward;
	}
	,calculateTotalTime: function(meta,mods) {
		var timeModificator = 0.0;
		var fixedTimeModificator = 0.0;
		var _g = 0;
		while(_g < mods.length) {
			var m = mods[_g];
			++_g;
			if(m.modificator == 1) {
				timeModificator += m.strength;
			} else if(m.modificator == 5) {
				fixedTimeModificator += m.strength;
			}
		}
		return Math.max(0,meta.time * (1 - timeModificator) - fixedTimeModificator);
	}
	,calculateTimeLeft: function(action,meta,time) {
		var fullTime = this.calculateTotalTime(meta,action.modificators);
		var timeSpent = time - action.time;
		var timeLeft = fullTime - timeSpent;
		return timeLeft;
	}
	,calculateAccelerateCost: function(skipCost,timeLeft,actionModificators) {
		var result = skipCost > 0 ? skipCost : com_nevosoft_waw_data_SkipByTime.getSkipCost(this._metaIndex.skipByTime,timeLeft);
		var mods = actionModificators != null ? actionModificators : [];
		var _g = 0;
		while(_g < mods.length) {
			var m = mods[_g];
			++_g;
			if(m.source == 4 && m.modificator == 4) {
				result -= result * m.strength;
			}
		}
		return Math.floor(result);
	}
	,isActionCancellable: function(actionState) {
		var actionMeta = this.getActionMeta(actionState.id);
		return com_nevosoft_waw_data_types_TCost.keys(actionMeta.spendings).length == 0;
	}
	,isManualStart: function(action) {
		return action.type == 6;
	}
	,isBgAutoApply: function(action) {
		return action.type == 1;
	}
	,canCollectActionReward: function(actionState) {
		var actionMeta = this.getActionMeta(actionState.id);
		var rewards = this.calculateRewards(actionState,actionMeta);
		return this._dataProvider.serverResources.canPutToStorage(rewards);
	}
	,multiplyIncome: function(income,strength,pred) {
		var _g = 0;
		var _g1 = com_nevosoft_waw_data_types_TCost.keys(income);
		while(_g < _g1.length) {
			var k = _g1[_g];
			++_g;
			var stuff = this._dataProvider.meta.getStuffMeta(k);
			if(pred(k)) {
				var _g2 = k;
				var _g3 = income;
				var this1 = _g3;
				var this2 = income;
				var value = (com_nevosoft_waw_data_types_TCost.hasKey(this1,_g2) ? Reflect.field(this1,Std.string(_g2)) : 0) + Math.ceil((com_nevosoft_waw_data_types_TCost.hasKey(this2,k) ? Reflect.field(this2,k == null ? "null" : "" + k) : 0) * strength);
				_g3[_g2 == null ? "null" : "" + _g2] = value;
			}
		}
	}
	,isGoldPred: function(id) {
		switch(id) {
		case -4:case -1:
			return true;
		default:
			return false;
		}
	}
	,exceptGoldPred: function(id) {
		return !this.isGoldPred(id);
	}
	,__class__: com_nevosoft_waw_dpScopes_ActionsDataProvider
});
var com_nevosoft_waw_dpScopes_BuffsDataProvider = function(storage,dataProvider) {
	this.activeBuffs = [];
	com_nevosoft_waw_BaseDataProviderScope.call(this,storage,dataProvider);
};
com_nevosoft_waw_dpScopes_BuffsDataProvider.__name__ = true;
com_nevosoft_waw_dpScopes_BuffsDataProvider.__super__ = com_nevosoft_waw_BaseDataProviderScope;
com_nevosoft_waw_dpScopes_BuffsDataProvider.prototype = $extend(com_nevosoft_waw_BaseDataProviderScope.prototype,{
	getBuffMetaByResource: function(resId) {
		var _g = 0;
		var _g1 = this._storage.meta.buffs;
		while(_g < _g1.length) {
			var b = _g1[_g];
			++_g;
			if(com_nevosoft_waw_data_types_TCost.get_first_items(b.cost,1)[0].resourceId == resId) {
				return b;
			}
		}
		return null;
	}
	,getBuffMeta: function(id) {
		return this._metaIndex.buffs.h[id];
	}
	,getBuffType: function(id) {
		var meta = this.getBuffMeta(id);
		return meta.modificator.modificator;
	}
	,getBuffState: function(id) {
		var _g = 0;
		var _g1 = this._storage.data.buffs;
		while(_g < _g1.length) {
			var b = _g1[_g];
			++_g;
			if(b.id == id) {
				return b;
			}
		}
		return null;
	}
	,getActiveBuffs: function() {
		var _g = 0;
		var _g1 = this._storage.data.buffs;
		while(_g < _g1.length) {
			var b = _g1[_g];
			++_g;
			var bMeta = this.getBuffMeta(b.id);
			var inCurrentEvent = this._dataProvider.gameTasks.isInCurrentEvent(bMeta.gameEventsComponent);
			if(!inCurrentEvent) {
				continue;
			}
			if(b.isActive && this.activeBuffs.indexOf(b) < 0) {
				this.activeBuffs.push(b);
			}
			if(!b.isActive && this.activeBuffs.indexOf(b) >= 0) {
				HxOverrides.remove(this.activeBuffs,b);
			}
		}
		return this.activeBuffs;
	}
	,getBuffs: function() {
		return this._storage.data.buffs;
	}
	,__class__: com_nevosoft_waw_dpScopes_BuffsDataProvider
});
var com_nevosoft_waw_dpScopes_GameTaskDataProvider = function(storage,dataProvider) {
	com_nevosoft_waw_BaseDataProviderScope.call(this,storage,dataProvider);
};
com_nevosoft_waw_dpScopes_GameTaskDataProvider.__name__ = true;
com_nevosoft_waw_dpScopes_GameTaskDataProvider.__super__ = com_nevosoft_waw_BaseDataProviderScope;
com_nevosoft_waw_dpScopes_GameTaskDataProvider.prototype = $extend(com_nevosoft_waw_BaseDataProviderScope.prototype,{
	isInCurrentEvent: function(gameEventsComponent) {
		return this._dataProvider.meta.isAvailableInEvent(gameEventsComponent,this._storage.data.currentGameEventId);
	}
	,getRemainTime: function(meta,receiveTime,time) {
		var timeParameters = meta.timeParameters;
		if(timeParameters != null) {
			var start = timeParameters.activePeriodStart;
			var end = timeParameters.activePeriodEnd;
			var timeout = timeParameters.timeout;
			if(start != null && end != null) {
				if(time < start) {
					return -1;
				} else if(time < end) {
					return end - time;
				} else {
					return 0;
				}
			} else if(timeout != null && receiveTime > 0) {
				if(time < receiveTime + timeout) {
					return receiveTime + timeout - time;
				} else {
					return 0;
				}
			}
		}
		return -1;
	}
	,getRemainPreview: function(meta,time) {
		var timeParameters = meta.timeParameters;
		if(timeParameters != null) {
			var preview = timeParameters.preview;
			var start = timeParameters.activePeriodStart;
			if(preview != null && start != null) {
				var previewBegin = start - preview;
				if(time < previewBegin) {
					return -1;
				} else if(time > start) {
					return 0;
				} else {
					return start - time;
				}
			}
		}
		return -1;
	}
	,couldStartByTime: function(meta,time) {
		if(meta.timeParameters == null || meta.timeParameters.activePeriodStart == null) {
			return true;
		}
		return time >= meta.timeParameters.activePeriodStart;
	}
	,getActiveHistory: function(atTime,type) {
		var result = [];
		var historyToId = new haxe_ds_IntMap();
		var _g = 0;
		var _g1 = this._storage.currentLocation.gameTasksHistory;
		while(_g < _g1.length) {
			var h = _g1[_g];
			++_g;
			if(h.taskType == type && h.isActive && h.time <= atTime) {
				result.push(h);
				historyToId.h[h.taskId] = h;
			}
			if(h.taskType == type && !h.isActive && h.time <= atTime) {
				HxOverrides.remove(result,historyToId.h[h.taskId]);
				historyToId.remove(h.taskId);
			}
		}
		return result;
	}
	,__class__: com_nevosoft_waw_dpScopes_GameTaskDataProvider
});
var com_nevosoft_waw_dpScopes_LocationDataProvider = function(storage,dataProvider) {
	com_nevosoft_waw_BaseDataProviderScope.call(this,storage,dataProvider);
	this.mapIndex = dataProvider.getMapIndex();
};
com_nevosoft_waw_dpScopes_LocationDataProvider.__name__ = true;
com_nevosoft_waw_dpScopes_LocationDataProvider.__super__ = com_nevosoft_waw_BaseDataProviderScope;
com_nevosoft_waw_dpScopes_LocationDataProvider.prototype = $extend(com_nevosoft_waw_BaseDataProviderScope.prototype,{
	getLocations: function() {
		return this._storage.data.locations;
	}
	,getLocationByEventId: function(id) {
		var _g = 0;
		var _g1 = this._storage.data.locations;
		while(_g < _g1.length) {
			var l = _g1[_g];
			++_g;
			if(l.eventId == id) {
				return l;
			}
		}
		return null;
	}
	,getSectorsConfig: function() {
		return this._storage.map.sectorsConfig;
	}
	,getSectorById: function(id) {
		return this.mapIndex.getSectorById(id);
	}
	,isSectorReadyToUnlock: function(sector) {
		if(com_nevosoft_waw_data_types_TCost.isEmpty(sector.cost)) {
			return this._dataProvider.restrictions.FastCheck(sector.restrictions);
		} else {
			return false;
		}
	}
	,getAnimalCount: function(metaId) {
		var animals = this.filterAnimals({ metaId : metaId});
		return animals.length;
	}
	,getNutCount: function() {
		var nuts = this.filterMapObjects({ category : "NUT"});
		return nuts.length;
	}
	,getFarmCount: function() {
		var farms = this._dataProvider.location.filterMapObjects({ category : "FARM_CELL"});
		return farms.length;
	}
	,getFreeShmuCount: function() {
		var shmus = this.filterMapObjects({ category : "SHMU"});
		var result = 0;
		var _g = 0;
		while(_g < shmus.length) {
			var shmu = shmus[_g];
			++_g;
			if(shmu.cWorker.targetId < 0) {
				++result;
			}
		}
		return result;
	}
	,getShmuCount: function() {
		var shmus = this.filterMapObjects({ category : "SHMU"});
		return shmus.length;
	}
	,getCurrentMapObjectsWithUndoneJob: function(useBGWorkplace) {
		if(useBGWorkplace == null) {
			useBGWorkplace = false;
		}
		return this.getObjectsWithUndoneJobByLocation(this._storage.currentLocation,useBGWorkplace);
	}
	,getObjectsWithUndoneJobByLocation: function(location,useBGWorkplace) {
		if(useBGWorkplace == null) {
			useBGWorkplace = false;
		}
		var result = [];
		var _g = 0;
		var _g1 = location.objects;
		while(_g < _g1.length) {
			var obj = _g1[_g];
			++_g;
			var workplace = useBGWorkplace ? obj.cBGWorkplace : obj.cWorkplace;
			if(workplace != null) {
				if(obj.isFrozen) {
					continue;
				}
				var notFinishedActionsCount = 0;
				var _g2 = 0;
				var _g3 = workplace.actionsQueue;
				while(_g2 < _g3.length) {
					var action = _g3[_g2];
					++_g2;
					if(action.status != 3) {
						++notFinishedActionsCount;
					}
				}
				if(notFinishedActionsCount == 0 && this._dataProvider.actions.getFreeProductionMeta(obj) == null && this._dataProvider.actions.getFreeUpgradeMeta(obj) == null) {
					continue;
				}
				result.push(obj);
			}
		}
		return result;
	}
	,filterAnimals: function(filter) {
		return this.filterMapObjects({ metaId : filter.metaId});
	}
	,filterMapObjects: function(filter,location,result) {
		if(result == null) {
			result = [];
		} else {
			result.splice(0,result.length);
		}
		var metaId = filter.metaId;
		var category = filter.category;
		var levelGeThan = filter.levelGeThan;
		var tag = filter.tag;
		var mapObjects = this._dataProvider.mapObjects;
		if(location == null) {
			location = this._storage.currentLocation;
		}
		var _g = 0;
		var _g1 = location.objects;
		while(_g < _g1.length) {
			var obj = _g1[_g];
			++_g;
			if(metaId != null && obj.metaId != metaId) {
				continue;
			}
			if(category != null && mapObjects.getCategory(obj) != category) {
				continue;
			}
			if(levelGeThan != null && levelGeThan > 0 && mapObjects.getLevel(obj) < levelGeThan) {
				continue;
			}
			if(tag != null) {
				var objMeta = mapObjects.getMaybeMeta(obj.metaId);
				if(objMeta == null) {
					continue;
				}
				if(!com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged(tag,objMeta)) {
					continue;
				}
			}
			result.push(obj);
		}
		return result;
	}
	,findLockedSectorByMetaIds: function(metaIds) {
		var sectorData = null;
		var openedSectorsIds = this.getOpenedSectorsIds();
		var _g = 0;
		var _g1 = this.getSectorsConfig().sectors;
		while(_g < _g1.length) {
			var sector = _g1[_g];
			++_g;
			if(openedSectorsIds.indexOf(sector.id) < 0) {
				var _g2 = 0;
				var _g3 = sector.objects;
				while(_g2 < _g3.length) {
					var obj = _g3[_g2];
					++_g2;
					if(metaIds.indexOf(obj.metaId) > -1) {
						sectorData = sector;
						break;
					}
				}
				if(sectorData != null) {
					break;
				}
			}
		}
		return sectorData;
	}
	,applyStructureLimit: function(sectorObjects) {
		var filtered = [];
		var _g = 0;
		while(_g < sectorObjects.length) {
			var obj = sectorObjects[_g];
			++_g;
			var limit = this.getStructureLimit(obj.metaId);
			if(limit == 0) {
				filtered.push(obj);
			} else if(this.getMapObjectCount(obj.metaId) < limit) {
				filtered.push(obj);
			}
		}
		return filtered;
	}
	,getMapObjectCount: function(metaId) {
		return this.filterMapObjects({ metaId : metaId}).length;
	}
	,getStructureShopLimit: function(metaId) {
		var result = 0;
		var mapObjects = this._dataProvider.mapObjects;
		var meta = mapObjects.getMeta(metaId);
		if(meta.limitedComponent != null) {
			result = meta.limitedComponent.shopLimit;
			if(meta.floatingCostComponent != null) {
				var floatingPrice = meta.floatingCostComponent;
				var _g = 0;
				var _g1 = floatingPrice.changes;
				while(_g < _g1.length) {
					var change = _g1[_g];
					++_g;
					if(this._dataProvider.restrictions.FastCheck(change.restrictions)) {
						++result;
					} else {
						break;
					}
				}
			}
		}
		return result;
	}
	,getStructureLimit: function(metaId) {
		var result = 0;
		var mapObjects = this._dataProvider.mapObjects;
		var meta = mapObjects.getMeta(metaId);
		if(meta.limitedComponent != null) {
			result = meta.limitedComponent.limit;
		}
		return result;
	}
	,getAnimalLimit: function(animalMetaId) {
		var mapObjects = this._dataProvider.mapObjects;
		var pastureMeta = mapObjects.getPastureMetaOfAnimal(animalMetaId);
		var pastures = this.filterMapObjects({ metaId : pastureMeta.id});
		if(pastures.length > 0) {
			var pasture = pastures[0];
			var level = pasture.cUpgradable.level;
			var animalLimits = pastureMeta.pastureComponent.animalLimits;
			if(level - 1 >= animalLimits.length) {
				return animalLimits[animalLimits.length - 1];
			} else {
				return animalLimits[level - 1];
			}
		}
		return 0;
	}
	,getMarketRVState: function() {
		return this._storage.currentLocation.marketRVState;
	}
	,getMarketRVSettings: function() {
		return this._dataProvider.meta.getMarketRVSettingsById(this._dataProvider.getCurrentEventId());
	}
	,getVideoAccelerationState: function() {
		return this._storage.currentLocation.videoAccelerationState;
	}
	,getCurrentAccelerationSettings: function() {
		return this._dataProvider.meta.getAccelerationSettingsById(this._dataProvider.getCurrentEventId());
	}
	,getMarketOrderSkipRVState: function() {
		return this._storage.currentLocation.marketOrderSkipRVState;
	}
	,getNpcOrderSkipRVState: function() {
		return this._storage.currentLocation.npcOrderSkipRVState;
	}
	,getZeppelinRVState: function() {
		return this._storage.currentLocation.zeppelinRVState;
	}
	,getZeppelinRVSettings: function() {
		var this1 = this._metaIndex.gameEvents;
		var key = this._dataProvider.getCurrentEventId();
		return this1.h[key].zeppelinRewardedVideoSettings;
	}
	,getPurchaseResourceRVState: function() {
		return this._storage.currentLocation.purchaseResourceRVState;
	}
	,getPurchaseTownhallResourceRVState: function() {
		return this._storage.currentLocation.purchaseTownhallResourceRVState;
	}
	,getPurchaseBlockingGarbageResourceRVState: function() {
		return this._storage.currentLocation.purchaseBlockingGarbageResourceRVState;
	}
	,getComplexGarbageRVState: function() {
		return this._storage.currentLocation.complexGarbageRVState;
	}
	,getPurchaseEnergyRVState: function() {
		return this._storage.currentLocation.purchaseEnergyRVState;
	}
	,getResourceRVSettings: function() {
		return this._dataProvider.meta.getResourceRVSettingsById(this._dataProvider.getCurrentEventId());
	}
	,getTownhallResourceRVSettings: function() {
		return this._dataProvider.meta.getTownhallResourceRVSettingsById(this._dataProvider.getCurrentEventId());
	}
	,getBlockingGarbageResourceRVSettings: function() {
		return this._dataProvider.meta.getBlockingGarbageResourceRVSettingsById(this._dataProvider.getCurrentEventId());
	}
	,getCampRVState: function() {
		return this._storage.currentLocation.campRVState;
	}
	,getCampRVSettings: function() {
		return this._dataProvider.meta.getCampRVSettingsById(this._dataProvider.getCurrentEventId());
	}
	,getAnimalRVSettings: function() {
		return this._dataProvider.meta.getAnimalRVSettingsById(this._dataProvider.getCurrentEventId());
	}
	,getAnimalRVState: function() {
		return this._storage.currentLocation.animalRVState;
	}
	,getComplexGarbageRVSettings: function() {
		return this._dataProvider.meta.getComplexGarbageRVSettingsById(this._dataProvider.getCurrentEventId());
	}
	,isZeppelinRVChangeAvailable: function() {
		var state = this.getZeppelinRVState();
		var settings = this.getZeppelinRVSettings();
		return state.numChanged < settings.attemptsCount;
	}
	,getOpenedSectorsIds: function() {
		return this._storage.currentLocation.openSectorIds.slice();
	}
	,canMoveToSector: function(id) {
		if(this.isSectorOpened(id)) {
			return this.isSectorWalkable(id);
		} else {
			return false;
		}
	}
	,isSectorOpened: function(id) {
		return this._storage.currentLocation.openSectorIds.indexOf(id) >= 0;
	}
	,isHomeSectorOpened: function(id) {
		return this._storage.homeLocation.openSectorIds.indexOf(id) >= 0;
	}
	,isSectorWalkable: function(id) {
		return (this.getSectorById(id).collisionMask & 1) == 1;
	}
	,isSectorDesignAvaliable: function(id) {
		return (this.getSectorById(id).collisionMask & 128) == 0;
	}
	,getPasture: function(animalMetaId) {
		var result = null;
		if(this._profileIndex.animalToPastureIndex.h.hasOwnProperty(animalMetaId)) {
			result = this._profileIndex.animalToPastureIndex.h[animalMetaId];
		}
		return result;
	}
	,isMyLocation: function() {
		return this._storage.currentLocation.ownerId == this._storage.homeLocation.ownerId;
	}
	,getOwnerId: function() {
		return this._storage.currentLocation.ownerId;
	}
	,getSpawnJobs: function() {
		return this._storage.currentLocation.spawnJobs;
	}
	,getGeneratorTime: function(id) {
		var maybeTime = this._storage.currentLocation.generatorTimes[id == null ? "null" : "" + id];
		if(maybeTime != null) {
			return maybeTime;
		} else {
			return -1;
		}
	}
	,getGeneratorPeriods: function(currTime,generatorTime,generatorMeta) {
		var spawnPeriod = generatorMeta.period;
		var periodsPassed = Math.floor((currTime - generatorTime) / spawnPeriod);
		return periodsPassed;
	}
	,getAllUnlockedProductions: function(pendingIncluded) {
		if(pendingIncluded == null) {
			pendingIncluded = false;
		}
		var result = [];
		var _g = 0;
		var _g1 = this._storage.currentLocation.objects;
		while(_g < _g1.length) {
			var obj = _g1[_g];
			++_g;
			var maybeMeta = this._dataProvider.mapObjects.getMaybeMeta(obj.metaId);
			if(maybeMeta == null) {
				continue;
			}
			var meta = maybeMeta;
			if(meta.category != "COMMON_BUILDING") {
				continue;
			}
			if(meta.workComponent != null) {
				var buildingLevel = this._dataProvider.mapObjects.getLevel(obj,pendingIncluded);
				var _g2 = 1;
				var _g3 = buildingLevel + 1;
				while(_g2 < _g3) {
					var lvl = _g2++;
					var production = this._dataProvider.actions.getProductionAtLevel(meta,lvl);
					result.push(production);
				}
			}
		}
		return result;
	}
	,areAllBroken: function(metaId) {
		var _g = 0;
		var _g1 = this.filterMapObjects({ metaId : metaId});
		while(_g < _g1.length) {
			var obj = _g1[_g];
			++_g;
			var buildingLevel = this._dataProvider.mapObjects.getLevel(obj,true);
			if(buildingLevel > 0) {
				return false;
			}
		}
		return true;
	}
	,getCommonStorageLimit: function() {
		var _g = 0;
		var _g1 = this._dataProvider.location.filterMapObjects({ category : "STORAGE_COMMON"});
		while(_g < _g1.length) {
			var storage = _g1[_g];
			++_g;
			var storageComponent = this._dataProvider.meta.getGameObjectMeta(storage.metaId).storageComponent;
			if(storageComponent.categories.indexOf("STUFF") >= 0) {
				var level = storage.cUpgradable.level;
				return storageComponent.limits[level - 1];
			}
		}
		return 0;
	}
	,getDoneActionsCount: function(actionMetaId) {
		return com_nevosoft_waw_data_serialization_ArrayMapInt.get(this._storage.currentLocation.doneActionSet,actionMetaId);
	}
	,updateDoneActionCount: function(actionMetaId) {
		com_nevosoft_waw_data_serialization_ArrayMapInt.set(this._storage.currentLocation.doneActionSet,actionMetaId,com_nevosoft_waw_data_serialization_ArrayMapInt.get(this._storage.currentLocation.doneActionSet,actionMetaId) + 1);
	}
	,getSectorNeighboursIds: function(sectorId) {
		return this.mapIndex.getSectorNeighboursIds(sectorId);
	}
	,__class__: com_nevosoft_waw_dpScopes_LocationDataProvider
});
var com_nevosoft_waw_dpScopes_MapObjectsDataProvider = function(storage,dataProvider) {
	com_nevosoft_waw_BaseDataProviderScope.call(this,storage,dataProvider);
};
com_nevosoft_waw_dpScopes_MapObjectsDataProvider.__name__ = true;
com_nevosoft_waw_dpScopes_MapObjectsDataProvider.__super__ = com_nevosoft_waw_BaseDataProviderScope;
com_nevosoft_waw_dpScopes_MapObjectsDataProvider.prototype = $extend(com_nevosoft_waw_BaseDataProviderScope.prototype,{
	getMeta: function(id) {
		if(!this._metaIndex.gameObjects.h.hasOwnProperty(id)) {
			throw haxe_Exception.thrown("no meta for object: " + id);
		}
		return this._metaIndex.gameObjects.h[id];
	}
	,getMaybeMeta: function(id) {
		return this._metaIndex.gameObjects.h[id];
	}
	,getData: function(id) {
		var obj = com_nevosoft_waw_core_utils_ContainerUtils.getObjectById(this._storage.currentLocation.objects,id);
		return obj;
	}
	,getState: function(data) {
		var meta = this.getMeta(data.metaId);
		if(data.isFrozen) {
			return 4;
		} else if(data.cWorkplace != null) {
			return this.getWorkplaceState(data,meta);
		} else {
			return 0;
		}
	}
	,getCategory: function(data) {
		if(data.cNut != null) {
			return "NUT";
		} else if(data.cWorker != null) {
			return "SHMU";
		} else if(data.metaId == 900) {
			return "ORDERS_HOST";
		} else {
			return this.getMeta(data.metaId).category;
		}
	}
	,getLevel: function(data,pendingIncluded) {
		if(pendingIncluded == null) {
			pendingIncluded = false;
		}
		if(data.cUpgradable != null) {
			var result = data.cUpgradable.level;
			if(pendingIncluded && this._dataProvider.actions.isUpgrading(data)) {
				++result;
			}
			return result;
		}
		return 1;
	}
	,getLockedProductionSlot: function(data) {
		var result = haxe_ds_Option.None;
		var objMeta = this.getMeta(data.metaId);
		var workC = objMeta.workComponent;
		var workplace = data.cWorkplace;
		if(workC != null) {
			var freeSlots = workC.freeSlots;
			var offerSlots = workplace.offerSlots == null ? 0 : workplace.offerSlots;
			var slotsMeta = workC.productionQueueSlots;
			var nextSlotIndex = workplace.slots - freeSlots - offerSlots;
			if(nextSlotIndex >= 0 && nextSlotIndex < slotsMeta.length) {
				result = haxe_ds_Option.Some(slotsMeta[nextSlotIndex]);
			}
		}
		return result;
	}
	,getProdOfferSlotsCount: function(data) {
		if(data.cWorkplace == null) {
			return 0;
		}
		if(data.cWorkplace.offerSlots == null) {
			return 0;
		}
		return data.cWorkplace.offerSlots;
	}
	,getPlacingAction: function(id) {
		var mapObjectMeta = this.getMeta(id);
		if(mapObjectMeta.category == "PLANT") {
			return mapObjectMeta.plantComponent.action;
		} else {
			if(mapObjectMeta.workComponent != null) {
				return mapObjectMeta.workComponent.upgradeActions[0];
			}
			return null;
		}
	}
	,getPlacingTransaction: function(id) {
		var mapObjectMeta = this.getMeta(id);
		return mapObjectMeta.resTransactionComponent;
	}
	,getPlacingRestrictions: function(id) {
		var action = this.getPlacingAction(id);
		if(action != null) {
			return action.restrictions;
		}
		var placingTransaction = this.getPlacingTransaction(id);
		if(placingTransaction != null) {
			return placingTransaction.restrictions;
		}
		return { };
	}
	,getPlacingCost: function(metaId,id) {
		if(id == null) {
			id = 0;
		}
		var objMeta = this.getMeta(metaId);
		var result;
		if(objMeta.resTransactionComponent != null) {
			result = objMeta.resTransactionComponent.spendings;
		} else {
			var placingAction = this.getPlacingAction(metaId);
			result = placingAction != null ? placingAction.spendings : { };
		}
		if(objMeta.floatingCostComponent != null) {
			var buyCostChanges = objMeta.floatingCostComponent.changes;
			var alreadyBuild = this._dataProvider.location.filterMapObjects({ metaId : metaId});
			var buildCount = 0;
			var _g = 0;
			while(_g < alreadyBuild.length) {
				var obj = alreadyBuild[_g];
				++_g;
				if(obj.id != id) {
					++buildCount;
				}
			}
			var index = Math.floor(Math.min(buildCount,buyCostChanges.length) - 1);
			if(index >= 0) {
				result = buyCostChanges[index].spendings;
			}
		}
		return result;
	}
	,getPastureMetaOfAnimal: function(animalMetaId) {
		if(!this._metaIndex.animalBindings.h.hasOwnProperty(animalMetaId)) {
			throw haxe_Exception.thrown("no pasture meta for amimal: " + animalMetaId);
		}
		var pastureMetaId = this._metaIndex.animalBindings.h[animalMetaId];
		var objMt = this.getMeta(pastureMetaId);
		return objMt;
	}
	,getAnimalFoodId: function(animalMetaId) {
		var animalMeta = this.getMeta(animalMetaId);
		return com_nevosoft_waw_data_types_TCost.get_mainResourceId(animalMeta.workComponent.actions[0].spendings);
	}
	,getAnimalCountFoodNeeded: function(animalMetaId) {
		var animalMeta = this.getMeta(animalMetaId);
		return com_nevosoft_waw_data_types_TCost.get_first_items(animalMeta.workComponent.actions[0].spendings,1)[0].value;
	}
	,getNatureObjectTemplate: function(metaId) {
		return com_nevosoft_waw_entity_GameObjectsTemplateFactory.getNatureObjectTemplate(metaId);
	}
	,getBuildingTemplate: function(metaId) {
		var meta = this.getMeta(metaId);
		return com_nevosoft_waw_entity_GameObjectsTemplateFactory.getBuildingTemplate(meta);
	}
	,getAnimalTemplate: function(metaId) {
		var meta = this.getMeta(metaId);
		return com_nevosoft_waw_entity_GameObjectsTemplateFactory.getAnimalTemplate(meta);
	}
	,getNutTemplate: function() {
		return com_nevosoft_waw_entity_GameObjectsTemplateFactory.getNutTemplate();
	}
	,getInitialLevel: function(meta) {
		return com_nevosoft_waw_helpers_GameObjectHelper.getInitialLevel(meta);
	}
	,getWorkplaceState: function(data,meta) {
		if(this._dataProvider.actions.getCurrentActionState(data) != null) {
			return this.getWorkingState(data);
		} else if(this._dataProvider.actions.getFirstFinishedUpgrade(data) != null) {
			return 3;
		} else if(this.getLevel(data) == 0 && this._dataProvider.actions.getRepairActionMeta(meta) != null) {
			return 5;
		} else {
			return 0;
		}
	}
	,getWorkingState: function(data) {
		var currentAction = this._dataProvider.actions.getCurrentActionState(data);
		if(currentAction.time == -1) {
			return 1;
		} else {
			return 2;
		}
	}
	,getObjActions: function(objMeta) {
		if(objMeta.workComponent == null) {
			return [];
		} else {
			return objMeta.workComponent.actions;
		}
	}
	,getObjShopCategory: function(objMeta) {
		if(objMeta.shopComponent == null) {
			return "hidden";
		} else {
			return objMeta.shopComponent.category;
		}
	}
	,getObjUpgradeActions: function(objMeta) {
		if(objMeta.workComponent == null) {
			return [];
		} else {
			return objMeta.workComponent.upgradeActions;
		}
	}
	,getObjProductionQueueSlots: function(objMeta) {
		if(objMeta.workComponent == null) {
			return [];
		} else {
			return objMeta.workComponent.productionQueueSlots;
		}
	}
	,getObjWidth: function(objMeta) {
		if(objMeta.boundsComponent == null) {
			return 0;
		} else {
			return objMeta.boundsComponent.width;
		}
	}
	,getObjHeight: function(objMeta) {
		if(objMeta.boundsComponent == null) {
			return 0;
		} else {
			return objMeta.boundsComponent.height;
		}
	}
	,getObjLimit: function(objMeta) {
		if(objMeta.limitedComponent == null) {
			return 0;
		} else {
			return objMeta.limitedComponent.limit;
		}
	}
	,isInCurrentEvent: function(id) {
		var objMeta = this._metaIndex.gameObjects.h[id];
		if(objMeta.gameEventsComponent != null) {
			return objMeta.gameEventsComponent.indexOf(this._storage.data.currentGameEventId) >= 0;
		} else {
			return true;
		}
	}
	,getMaxProdSlots: function() {
		return 10;
	}
	,getProdSlotsOfferId: function() {
		return 41;
	}
	,canUnlockProdSlotsByOffer: function() {
		return this._dataProvider.serverResources.AvailableAmount(445) > 0;
	}
	,__class__: com_nevosoft_waw_dpScopes_MapObjectsDataProvider
});
var com_nevosoft_waw_dpScopes_MetaDataProvider = function(storage,dataProvider) {
	com_nevosoft_waw_BaseDataProviderScope.call(this,storage,dataProvider);
	this.categoryToMetaIdsCache = new haxe_ds_StringMap();
	this.generatorsCache = new haxe_ds_IntMap();
};
com_nevosoft_waw_dpScopes_MetaDataProvider.__name__ = true;
com_nevosoft_waw_dpScopes_MetaDataProvider.__super__ = com_nevosoft_waw_BaseDataProviderScope;
com_nevosoft_waw_dpScopes_MetaDataProvider.prototype = $extend(com_nevosoft_waw_BaseDataProviderScope.prototype,{
	isInCurrentEvent: function(metaId) {
		var obj = this.getGameObjectMeta(metaId);
		return this.isAvailableInEvent(obj.gameEventsComponent,this._storage.data.currentGameEventId);
	}
	,getNutConfig: function() {
		return this._storage.meta.nutConfig;
	}
	,getDirigibleConfig: function() {
		return this._storage.meta.zeppelinSettings;
	}
	,getGarbageGenerators: function() {
		return this.getGeneratorsByType("GARBAGE_GENERATOR");
	}
	,getNutGenerators: function() {
		return this.getGeneratorsByType("NUT_GENERATOR");
	}
	,getGeneratorsByType: function(type) {
		var generators = [];
		var _g = 0;
		var _g1 = this._storage.meta.generators;
		while(_g < _g1.length) {
			var g = _g1[_g];
			++_g;
			if(!this.generatorsCache.h.hasOwnProperty(g.id)) {
				this.generatorsCache.h[g.id] = g;
			}
			if(g.type == type) {
				generators.push(g);
			}
		}
		return generators;
	}
	,getGeneratorById: function(id) {
		if(!this.generatorsCache.h.hasOwnProperty(id)) {
			var _g = 0;
			var _g1 = this._storage.meta.generators;
			while(_g < _g1.length) {
				var g = _g1[_g];
				++_g;
				if(g.id == id) {
					this.generatorsCache.h[g.id] = g;
				}
				break;
			}
		}
		return this.generatorsCache.h[id];
	}
	,getStuffMeta: function(id) {
		return this._metaIndex.stuff.h[id];
	}
	,getStuffTime: function(id) {
		return this._metaIndex.resourceMetrics.getProdTime(id);
	}
	,getStuffWeight: function(id) {
		var this1 = this.getStuffMeta(id).weightCustom;
		if(this1 != null) {
			return this1;
		} else {
			return 0.0;
		}
	}
	,getAllStuffIds: function() {
		return this._metaIndex.stuff.keys();
	}
	,isStuffStorable: function(id) {
		var resCMt = this.getStuffMeta(id);
		var resMeta = this._dataProvider.meta.getGameObjectMeta(id);
		if(resCMt != null) {
			if(resCMt.storageCategory != "HIDDEN") {
				return !com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged("res_energy",resMeta);
			} else {
				return false;
			}
		} else {
			return false;
		}
	}
	,getGameObjectMeta: function(metaId) {
		var tmp = this._metaIndex == null;
		var tmp = this._metaIndex.gameObjects == null;
		return this._metaIndex.gameObjects.h[metaId];
	}
	,getGameObjects: function() {
		return this._storage.meta.gameObjects;
	}
	,getUnlockLevel: function(id) {
		return this._metaIndex.gameObjectUnlocks.getUnlockLevel(id);
	}
	,getTotalSkipCost: function(stuff) {
		var totalSkipCost = 0;
		var pair = new com_nevosoft_waw_data_types_TCostIterator(stuff);
		while(pair.hasNext()) {
			var pair1 = pair.next();
			var resMeta = this._metaIndex.stuff.h[pair1.resourceId];
			if(resMeta != null && resMeta.explicitBuyCost != null && resMeta.explicitBuyCost >= 0) {
				totalSkipCost += resMeta.explicitBuyCost * pair1.value;
			} else {
				totalSkipCost += this._metaIndex.resourceMetrics.getBuyCost(pair1.resourceId) * pair1.value;
			}
		}
		return totalSkipCost;
	}
	,getStuffProdSource: function(id) {
		if(this._metaIndex.stuffProdSource.h.hasOwnProperty(id)) {
			return this._metaIndex.stuffProdSource.h[id];
		}
		return [];
	}
	,getStuffSellSource: function(id) {
		if(this._metaIndex.stuffSellSource.h.hasOwnProperty(id)) {
			return this._metaIndex.stuffSellSource.h[id];
		}
		return [];
	}
	,getStuffDropSource: function(id) {
		if(this._metaIndex.stuffDropSource.h.hasOwnProperty(id)) {
			return this._metaIndex.stuffDropSource.h[id];
		}
		return [];
	}
	,getStuffRemoveSource: function(id) {
		if(this._metaIndex.stuffRemoveSource.h.hasOwnProperty(id)) {
			return this._metaIndex.stuffRemoveSource.h[id];
		}
		return [];
	}
	,getAnimalByFood: function(foodId) {
		return this._metaIndex.foodToAnimal.h[foodId];
	}
	,getSpellByGarbage: function(garbageId) {
		return this._metaIndex.garbageToSpell.h[garbageId];
	}
	,getDropCondition: function(resourceId) {
		return this._metaIndex.dropToCondition.h[resourceId];
	}
	,getStuffDeep: function(id) {
		return this._metaIndex.resourceMetrics.getDeep(id);
	}
	,getQuestMeta: function(id) {
		if(this._metaIndex.quests.h.hasOwnProperty(id)) {
			return this._metaIndex.quests.h[id];
		}
		return null;
	}
	,getSpellMeta: function(id) {
		var _g = 0;
		var _g1 = this._metaIndex.spells;
		while(_g < _g1.length) {
			var spell = _g1[_g];
			++_g;
			if(spell.id == id) {
				return spell;
			}
		}
		return null;
	}
	,getAllSpells: function() {
		return this._metaIndex.spells;
	}
	,getHouseMetaIds: function() {
		return this._metaIndex.houseMetaIds;
	}
	,getMetaIdsByCategory: function(category) {
		var result;
		if(Object.prototype.hasOwnProperty.call(this.categoryToMetaIdsCache.h,category)) {
			result = this.categoryToMetaIdsCache.h[category];
		} else {
			result = [];
			var mapObject = this._metaIndex.gameObjects.iterator();
			while(mapObject.hasNext()) {
				var mapObject1 = mapObject.next();
				if(mapObject1.category == category) {
					result.push(mapObject1.id);
				}
			}
			this.categoryToMetaIdsCache.h[category] = result;
		}
		return result;
	}
	,getMetaIdsByTag: function(tag) {
		var result = [];
		var mapObject = this._metaIndex.gameObjects.iterator();
		while(mapObject.hasNext()) {
			var mapObject1 = mapObject.next();
			if(com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged(tag,mapObject1)) {
				result.push(mapObject1.id);
			}
		}
		return result;
	}
	,getCategoryByMetaId: function(metaId) {
		return this.getGameObjectMeta(metaId).category;
	}
	,getDailyBonus: function() {
		return this._storage.meta.dailyBonus;
	}
	,getBestLotteryRewardsArray: function() {
		var result = JSON.parse(this.getConst("loteryBestRewards"));
		return result;
	}
	,getConst: function(name) {
		if(!Object.prototype.hasOwnProperty.call(this._metaIndex.constants.h,name)) {
			throw haxe_Exception.thrown("no constant: " + name);
		}
		return this._metaIndex.constants.h[name];
	}
	,isOfferLot: function(lotId) {
		return this._metaIndex.offerLots.h.hasOwnProperty(lotId);
	}
	,getPayMonetayGroupById: function(id) {
		return this._metaIndex.payMonetaryGroupsMap.h[id];
	}
	,getPayRecencyGroupById: function(id) {
		return this._metaIndex.payRecencyGroupsMap.h[id];
	}
	,getPayFrequencyGroupById: function(id) {
		return this._metaIndex.payFrequencyGroupsMap.h[id];
	}
	,getPayMonetayGroups: function() {
		return this._metaIndex.payMonetaryGroups;
	}
	,getPayRecencyGroups: function() {
		return this._metaIndex.payRecencyGroups;
	}
	,getPayFrequencyGroups: function() {
		return this._metaIndex.payFrequencyGroups;
	}
	,getAdsSettings: function() {
		return this._storage.meta.adsSettings[0];
	}
	,objectHasTag: function(obj,tag) {
		return com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged(tag,obj);
	}
	,getDailyQuestRewardChoiceSet: function(copy) {
		if(copy == null) {
			copy = true;
		}
		if(copy) {
			return this._metaIndex.dailyQuestRewardChoiceSet.slice();
		} else {
			return this._metaIndex.dailyQuestRewardChoiceSet;
		}
	}
	,getCampingRewardChoiceSet: function(copy) {
		if(copy == null) {
			copy = true;
		}
		if(copy) {
			return this._metaIndex.campingRewardChoiceSet.slice();
		} else {
			return this._metaIndex.campingRewardChoiceSet;
		}
	}
	,getGameEventMeta: function(id) {
		return this._metaIndex.gameEvents.h[id];
	}
	,isAvailableInEvent: function(gameEventsComponent,eventId) {
		if(gameEventsComponent != null) {
			return gameEventsComponent.indexOf(eventId) >= 0;
		} else {
			return true;
		}
	}
	,getGameEventMark: function(id) {
		return this._metaIndex.gameEventMap.h[id];
	}
	,getGameEventMarks: function() {
		return this._storage.meta.gameEventMap;
	}
	,getAccelerationSettingsById: function(eventId) {
		return this.getGameEventMeta(eventId).accelerationSettings;
	}
	,getResourceRVSettingsById: function(eventId) {
		return this.getGameEventMeta(eventId).resourceRewardedVideoSettings;
	}
	,getTownhallResourceRVSettingsById: function(eventId) {
		return this.getGameEventMeta(eventId).townhallResourceRewardedVideoSettings;
	}
	,getBlockingGarbageResourceRVSettingsById: function(eventId) {
		return this.getGameEventMeta(eventId).smmrRewardedVideoSettings;
	}
	,getMarketRVSettingsById: function(eventId) {
		return this.getGameEventMeta(eventId).marketRewardedVideoSettings;
	}
	,getCampRVSettingsById: function(eventId) {
		return this.getGameEventMeta(eventId).campRewardedVideoSettings;
	}
	,getAnimalRVSettingsById: function(eventId) {
		return this.getGameEventMeta(eventId).animalRewardedVideoSettings;
	}
	,getComplexGarbageRVSettingsById: function(eventId) {
		return this.getGameEventMeta(eventId).complexGarbageRewardedVideoSettings;
	}
	,getEnergyRVSettingsById: function(eventId) {
		return this.getGameEventMeta(eventId).energyRewardedVideoSettings;
	}
	,allowCollectRewardOverLimit: function(sourceMetaId) {
		var meta = this._metaIndex.gameObjects.h[sourceMetaId];
		if(!(meta.category == "TREE" || meta.category == "GARBAGE")) {
			return com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged("go_allow_collect_reward_over_limit",meta);
		} else {
			return true;
		}
	}
	,isExplosive: function(metaId) {
		var meta = this._metaIndex.gameObjects.h[metaId];
		if(meta.influenceSenderComponent != null) {
			return meta.influenceSenderComponent.modificator == 6;
		} else {
			return false;
		}
	}
	,__class__: com_nevosoft_waw_dpScopes_MetaDataProvider
});
var com_nevosoft_waw_dpScopes_OffersDataProvider = function(storage,dataProvider) {
	com_nevosoft_waw_BaseDataProviderScope.call(this,storage,dataProvider);
};
com_nevosoft_waw_dpScopes_OffersDataProvider.__name__ = true;
com_nevosoft_waw_dpScopes_OffersDataProvider.__super__ = com_nevosoft_waw_BaseDataProviderScope;
com_nevosoft_waw_dpScopes_OffersDataProvider.prototype = $extend(com_nevosoft_waw_BaseDataProviderScope.prototype,{
	isClosed: function(offerId) {
		return this._storage.data.completeOfferIds.indexOf(offerId) >= 0;
	}
	,getOffer: function(id) {
		var _g = 0;
		var _g1 = this._storage.data.offers;
		while(_g < _g1.length) {
			var offer = _g1[_g];
			++_g;
			if(offer.id == id) {
				return offer;
			}
		}
		return null;
	}
	,getTimeLeft: function(data,meta,currentTime) {
		var result = Infinity;
		if(meta.timeParameters != null) {
			if(meta.timeParameters.timeout != null) {
				result = data.receiveTime + meta.timeParameters.timeout - currentTime;
			} else if(meta.timeParameters.activePeriodEnd != null) {
				result = meta.timeParameters.activePeriodEnd - currentTime;
			}
		}
		return result;
	}
	,getOfferMeta: function(id) {
		if(!this._metaIndex.offers.h.hasOwnProperty(id)) {
			throw haxe_Exception.thrown("offer meta not found: " + id);
		}
		return this._metaIndex.offers.h[id];
	}
	,getOfferLot: function(lotId) {
		return this._metaIndex.offerLots.h[lotId];
	}
	,getOfferIdByLot: function(lotId) {
		if(!this._metaIndex.lotsToOffer.h.hasOwnProperty(lotId)) {
			throw haxe_Exception.thrown("offer with lot id=" + lotId + " not found");
		}
		return this._metaIndex.lotsToOffer.h[lotId];
	}
	,getPeriodId: function(offerId) {
		var meta = this.getOfferMeta(offerId);
		var timeParameters = meta.timeParameters;
		var periodId = 0;
		if(timeParameters != null) {
			var this1 = timeParameters.activePeriodStart;
			periodId = this1 != null ? this1 : 0;
		}
		return periodId;
	}
	,isStateActiveById: function(id) {
		var offerStateMaybe = this.getOffer(id);
		if(offerStateMaybe == null) {
			return false;
		}
		return offerStateMaybe.isActive;
	}
	,getActive: function() {
		return this._storage.data.offers;
	}
	,isAllLotsBought: function(offer) {
		var numPurchased = 0;
		var _g = 0;
		var _g1 = offer.lots;
		while(_g < _g1.length) {
			var lotState = _g1[_g];
			++_g;
			if(lotState.bought) {
				++numPurchased;
			}
		}
		return offer.lots.length == numPurchased;
	}
	,isLotInOfferBought: function(offer,lotId) {
		var numPurchased = 0;
		var _g = 0;
		var _g1 = offer.lots;
		while(_g < _g1.length) {
			var lotState = _g1[_g];
			++_g;
			if(lotState.id == lotId && lotState.bought) {
				return true;
			}
		}
		return false;
	}
	,isInCurrentEvent: function(offerId) {
		var offer = this._metaIndex.offers.h[offerId];
		return this._dataProvider.gameTasks.isInCurrentEvent(offer.gameEventsComponent);
	}
	,__class__: com_nevosoft_waw_dpScopes_OffersDataProvider
});
var com_nevosoft_waw_dpScopes_POSDataProvider = function(storage,dataProvider) {
	com_nevosoft_waw_BaseDataProviderScope.call(this,storage,dataProvider);
};
com_nevosoft_waw_dpScopes_POSDataProvider.__name__ = true;
com_nevosoft_waw_dpScopes_POSDataProvider.__super__ = com_nevosoft_waw_BaseDataProviderScope;
com_nevosoft_waw_dpScopes_POSDataProvider.prototype = $extend(com_nevosoft_waw_BaseDataProviderScope.prototype,{
	getState: function(type) {
		var posContainer = this._storage.currentLocation.pointsOfSaleStates;
		return com_nevosoft_waw_core_utils_ContainerUtils.getObjectById(posContainer,type);
	}
	,isZeppelinTimeToExpire: function(pointOfSale,time) {
		var posMeta = this.getZeppelinSettings();
		if(posMeta.lifetime <= 0) {
			return false;
		}
		if(this.isZeppelinInCooldownState(pointOfSale)) {
			return false;
		}
		if(time >= pointOfSale.initTime + posMeta.lifetime) {
			var timeToExpireF = (pointOfSale.initTime + posMeta.lifetime) * 1000.0;
			return true;
		}
		return false;
	}
	,isZeppelinInCooldownState: function(pointOfSale) {
		var result = Object.prototype.hasOwnProperty.call(pointOfSale.cooldown,"cooldownState");
		return result;
	}
	,isZeppelinTimeToRegen: function(pointOfSale,time) {
		var posMeta = this.getZeppelinSettings();
		if(!this.isZeppelinInCooldownState(pointOfSale)) {
			return false;
		}
		if(time > pointOfSale.initTime + posMeta.cooldownTime) {
			return true;
		}
		return false;
	}
	,isZeppelinLanded: function() {
		var result = false;
		var zeppelinState = this.getState(2);
		if(zeppelinState != null) {
			result = !this.isZeppelinInCooldownState(zeppelinState);
		}
		return result;
	}
	,isZeppelinAsksForHelp: function() {
		var result = false;
		var zeppelinState = this.getState(2);
		if(zeppelinState != null) {
			var slots = zeppelinState.slots;
			var _g = 0;
			while(_g < slots.length) {
				var slot = slots[_g];
				++_g;
				if(this.isZeppelinSlotLoaded(zeppelinState,slot.id)) {
					continue;
				}
				if(com_nevosoft_waw_data_serialization_TZeppelinSlot.get_needHelp(slot)) {
					result = true;
					break;
				}
			}
		}
		return result;
	}
	,getMarketSettings: function() {
		return this._dataProvider.getMetaIndex().marketMt.ordersComponent;
	}
	,isMarketInTutorMode: function() {
		return this._dataProvider.getTutorChekpoint() < 12;
	}
	,getMarketSlotsCount: function() {
		if(this.isMarketInTutorMode()) {
			return 0;
		}
		var levelConfig = this._dataProvider.getCurrentLevelConfig();
		return levelConfig.ordersGeneration.marketSlotCount;
	}
	,isMarketSlotCooldownActive: function(posState,slotId,time) {
		var this1 = posState.cooldown["" + slotId];
		var cooldownTime = this1 != null ? this1 : 0;
		return time < cooldownTime;
	}
	,getZeppelinTimeExpire: function(pointOfSale,time) {
		var posMeta = this.getZeppelinSettings();
		if(posMeta.lifetime <= 0) {
			return -1;
		}
		if(this.isZeppelinInCooldownState(pointOfSale)) {
			return -1.0;
		}
		if(pointOfSale.initTime + posMeta.lifetime >= time) {
			return pointOfSale.initTime + posMeta.lifetime - time;
		}
		return -1;
	}
	,getZeppelinCooldownRemain: function(pointOfSale,time) {
		var posMeta = this.getZeppelinSettings();
		if(posMeta.lifetime <= 0) {
			return -1.0;
		}
		if(!this.isZeppelinInCooldownState(pointOfSale)) {
			return -1.0;
		}
		return pointOfSale.initTime + posMeta.cooldownTime - time;
	}
	,getZeppelinSpecialRewardCount: function(pointOfSale) {
		var posMeta = this.getZeppelinSettings();
		var specialRewardSettings = posMeta.fullReward;
		var slotsCount = pointOfSale.slots.length;
		return Math.round(specialRewardSettings.countCoefficient * slotsCount);
	}
	,isSlotInCooldown: function(pointOfSale,slotId) {
		return Object.prototype.hasOwnProperty.call(pointOfSale.cooldown,"" + slotId);
	}
	,isZeppelinSlotLoaded: function(pointOfSale,slotId) {
		var zeppelinHelp = this._dataProvider.social.getValidZeppelinHelp(pointOfSale);
		var _g = 0;
		while(_g < zeppelinHelp.length) {
			var row = zeppelinHelp[_g];
			++_g;
			if(com_nevosoft_waw_data_serialization_ZeppelinHelp.get_slotId(row) == slotId) {
				return true;
			}
		}
		return this.isSlotInCooldown(pointOfSale,slotId);
	}
	,isZeppelinLoaded: function(pointOfSale) {
		var result = true;
		var _g = 0;
		var _g1 = pointOfSale.slots;
		while(_g < _g1.length) {
			var slot = _g1[_g];
			++_g;
			if(!this.isZeppelinSlotLoaded(pointOfSale,slot.id)) {
				result = false;
				break;
			}
		}
		return result;
	}
	,getDailyQuestSettings: function() {
		return this._storage.meta.dailyQuestSettings;
	}
	,getCampingSettings: function() {
		return this._storage.meta.campingSettings;
	}
	,getDailyQuestExpireTime: function() {
		var dailyQuestState = this.getState(3);
		var result = -1;
		if(dailyQuestState != null) {
			var posInitTs = dailyQuestState.initTime;
			var nextDayStart = this._dataProvider.timeProvider.getTomorrow(posInitTs);
			result = nextDayStart;
		}
		return result;
	}
	,isDailyQuestExpired: function() {
		return this.getDailyQuestExpireTime() - this._dataProvider.getTime() < 0;
	}
	,getZeppelinSettings: function() {
		return this._storage.meta.zeppelinSettings;
	}
	,getMarketAttributes: function() {
		return this._storage.meta.marketSettings;
	}
	,getZeppelinSlotsCountOnLevel: function(level) {
		var config = this._dataProvider.getLevelConfig(level);
		var orderGeneration = config.ordersGeneration;
		return orderGeneration.zeppelinSlotCount;
	}
	,getCampLoadSlotAction: function(camp,loadedSlotsCount) {
		var metaId = camp.metaId;
		var meta = this._dataProvider.mapObjects.getMeta(metaId);
		var index = loadedSlotsCount - 1;
		var actions = this._dataProvider.mapObjects.getObjActions(meta);
		if(index < 0 || index >= actions.length) {
			throw haxe_Exception.thrown("index out of range: " + index + ", " + actions.length);
		}
		return actions[index];
	}
	,isCampSlotLoaded: function(pointOfSale,slotId) {
		return this.isSlotInCooldown(pointOfSale,slotId);
	}
	,getCampLoadedSlotCount: function(pointOfSale) {
		var _gthis = this;
		var result = Lambda.count(pointOfSale.slots,function(slot) {
			return _gthis.isCampSlotLoaded(pointOfSale,slot.id);
		});
		return result;
	}
	,isReadyToExplore: function(pointOfSale) {
		var _g = 0;
		var _g1 = pointOfSale.slots;
		while(_g < _g1.length) {
			var slot = _g1[_g];
			++_g;
			if(!this.isCampSlotLoaded(pointOfSale,slot.id)) {
				return false;
			}
		}
		return true;
	}
	,getCampSlot: function(pointOfSale,slotId) {
		return pointOfSale.slots[slotId - 1];
	}
	,getCampAccelerateCost: function(time) {
		if(this._dataProvider.actionCounter(11) == 1) {
			return 0;
		}
		return com_nevosoft_waw_data_SkipByTime.getSkipCost(this._metaIndex.campSkipByTime,time);
	}
	,extractMinLevelSlotRestriction: function(slotId) {
		var _g = 0;
		var _g1 = this._storage.meta.levels;
		while(_g < _g1.length) {
			var levelConfig = _g1[_g];
			++_g;
			if(slotId < levelConfig.ordersGeneration.zeppelinSlotCount) {
				return levelConfig.id;
			}
		}
		return -1;
	}
	,isOrdersHostInCooldownState: function(data) {
		var result = Object.prototype.hasOwnProperty.call(data.cooldown,"cooldownState");
		return result;
	}
	,getOrdersHostCooldownRemain: function(data,meta,time) {
		if(data == null) {
			return -1.0;
		}
		if(!this.isOrdersHostInCooldownState(data)) {
			return -1.0;
		}
		return data.cooldown["cooldownState"] + meta.cooldownTime - time;
	}
	,clampValue: function(param,paramType,posId,value) {
		return com_nevosoft_waw_data_types_meta_PosMaxTable.clampByLimit(this._metaIndex.posMaxTable,posId,paramType,param,value);
	}
	,isWeightParamAvailable: function(param,paramType,posId) {
		return com_nevosoft_waw_data_types_meta_PosMaxTable.isAvailable(this._metaIndex.posMaxTable,posId,paramType,param);
	}
	,isWeightAvailable: function(weight,posId) {
		return this.isWeightParamAvailable(weight.param,com_nevosoft_waw_data_constants_EWeightType.getParamType(weight.type),posId);
	}
	,getCampSkipCost: function(posState) {
		if(posState.skips > 0) {
			return this._dataProvider.pointsOfSale.getCampingSettings().skipCost;
		} else {
			return 0;
		}
	}
	,getMarketRvSkipCost: function(posState) {
		if(this._storage.currentLocation.marketOrderSkipRVState.numChanged >= this._dataProvider.pointsOfSale.getMarketAttributes().skipRvDailyLimit) {
			return this._dataProvider.pointsOfSale.getMarketAttributes().skipRvCost;
		} else {
			return 0;
		}
	}
	,getTemplateById: function(posType,templateId) {
		var templates = null;
		switch(posType) {
		case 1:
			templates = this.getMarketSettings().templates;
			break;
		case 2:case 3:
			throw haxe_Exception.thrown("templates not supported for " + posType);
		case 4:
			templates = this.getCampingSettings().orderTemplates;
			break;
		}
		var _g = 0;
		while(_g < templates.length) {
			var t = templates[_g];
			++_g;
			if(t.id == templateId) {
				return t;
			}
		}
		return null;
	}
	,calculateDemand: function() {
		var resIdToDemand = new haxe_ds_IntMap();
		this.calculateDemandForSectors(resIdToDemand);
		this.calculateDemandForUpgrades(resIdToDemand);
		var key = resIdToDemand.keys();
		while(key.hasNext()) {
			var key1 = key.next();
			if(resIdToDemand.h[key1] == 0) {
				resIdToDemand.remove(key1);
			}
		}
		return resIdToDemand;
	}
	,calculateDemandForSectors: function(resIdToDemand) {
		var checkedSectors = [];
		var _g = 0;
		var _g1 = this._dataProvider.location.getOpenedSectorsIds();
		while(_g < _g1.length) {
			var sId = _g1[_g];
			++_g;
			var _g2 = 0;
			var _g3 = this._dataProvider.location.getSectorNeighboursIds(sId);
			while(_g2 < _g3.length) {
				var sNeighbourId = _g3[_g2];
				++_g2;
				var sector = this._dataProvider.location.getSectorById(sNeighbourId);
				if(!this._dataProvider.location.isSectorOpened(sNeighbourId) && this._dataProvider.location.isSectorWalkable(sNeighbourId) && checkedSectors.indexOf(sNeighbourId) < 0 && this._dataProvider.restrictions.FastCheck(sector.restrictions)) {
					checkedSectors.push(sNeighbourId);
					var sectorCost = sector.cost;
					var _g4 = 0;
					var _g5 = com_nevosoft_waw_data_types_TCost.keys(sectorCost);
					while(_g4 < _g5.length) {
						var resId = _g5[_g4];
						++_g4;
						if(this.canBeDemanded(resId)) {
							if(!resIdToDemand.h.hasOwnProperty(resId)) {
								resIdToDemand.h[resId] = 0;
							}
							var this1 = sectorCost;
							var value = resIdToDemand.h[resId] + Math.floor(Math.max(0,(com_nevosoft_waw_data_types_TCost.hasKey(this1,resId) ? Reflect.field(this1,resId == null ? "null" : "" + resId) : 0) - this._dataProvider.serverResources.AvailableAmount(resId)));
							resIdToDemand.h[resId] = value;
						}
					}
				}
			}
		}
	}
	,calculateDemandForUpgrades: function(resIdToDemand) {
		var location = this._dataProvider.location.getLocationByEventId(this._dataProvider.getCurrentEventId());
		var _g = 0;
		var _g1 = location.objects;
		while(_g < _g1.length) {
			var obj = _g1[_g];
			++_g;
			if(obj.metaId != 0) {
				var level = this._dataProvider.mapObjects.getLevel(obj);
				var meta = this._dataProvider.meta.getGameObjectMeta(obj.metaId);
				var upgrade = this._dataProvider.actions.getUpgradeAtLevel(meta,level);
				if(upgrade != null && meta.category != "STORAGE_COMMON" && this._dataProvider.restrictions.FastCheck(upgrade.restrictions)) {
					var upgradeCost = upgrade.spendings;
					var _g2 = 0;
					var _g3 = com_nevosoft_waw_data_types_TCost.keys(upgradeCost);
					while(_g2 < _g3.length) {
						var resId = _g3[_g2];
						++_g2;
						if(this.canBeDemanded(resId)) {
							if(!resIdToDemand.h.hasOwnProperty(resId)) {
								resIdToDemand.h[resId] = 0;
							}
							var this1 = upgradeCost;
							var value = resIdToDemand.h[resId] + Math.floor(Math.max(0,(com_nevosoft_waw_data_types_TCost.hasKey(this1,resId) ? Reflect.field(this1,resId == null ? "null" : "" + resId) : 0) - this._dataProvider.serverResources.AvailableAmount(resId)));
							resIdToDemand.h[resId] = value;
						}
					}
				}
			}
		}
	}
	,canBeDemanded: function(resId) {
		var resMeta = this._dataProvider.meta.getGameObjectMeta(resId);
		return resMeta.resourceComponent.storageCategory == "SPECIAL";
	}
	,__class__: com_nevosoft_waw_dpScopes_POSDataProvider
});
var com_nevosoft_waw_dpScopes_QuestsDataProvider = function(storage,dataProvider) {
	com_nevosoft_waw_BaseDataProviderScope.call(this,storage,dataProvider);
};
com_nevosoft_waw_dpScopes_QuestsDataProvider.__name__ = true;
com_nevosoft_waw_dpScopes_QuestsDataProvider.__super__ = com_nevosoft_waw_BaseDataProviderScope;
com_nevosoft_waw_dpScopes_QuestsDataProvider.prototype = $extend(com_nevosoft_waw_BaseDataProviderScope.prototype,{
	isOpened: function(questId) {
		var entity = this.getQuestEntity(questId);
		return entity.data.opened;
	}
	,isClosed: function(questId) {
		return this._storage.data.completeQuestIds.indexOf(questId) >= 0;
	}
	,getArc: function(arcId) {
		return this._metaIndex.questArcs.h[arcId];
	}
	,getQuestArc: function(questId) {
		var result = null;
		if(this._metaIndex.questToArc.h.hasOwnProperty(questId)) {
			result = this.getArc(this._metaIndex.questToArc.h[questId]);
		}
		return result;
	}
	,getArcActiveQuest: function(arcId) {
		var _g = 0;
		var _g1 = this.getActive();
		while(_g < _g1.length) {
			var a = _g1[_g];
			++_g;
			if(a.arcId == arcId) {
				return a;
			}
		}
		return null;
	}
	,getArcProgress: function(arc) {
		var result = 0;
		var _g = 0;
		var _g1 = arc.questsIds;
		while(_g < _g1.length) {
			var id = _g1[_g];
			++_g;
			if(this.isClosed(id)) {
				++result;
			}
		}
		return result;
	}
	,isArcReadyToComplete: function(arcId) {
		var arc = this.getArc(arcId);
		var closedQuestsCount = this.getArcProgress(arc);
		var totalArcQuestsCount = arc.questsIds.length;
		var lastQuestId = arc.questsIds[totalArcQuestsCount - 1];
		if(closedQuestsCount == totalArcQuestsCount - 1 && !this.isClosed(lastQuestId) && this.isActive(lastQuestId)) {
			return this.isComplete(lastQuestId);
		} else {
			return false;
		}
	}
	,isComplete: function(questId) {
		var entity = this.getQuestEntity(questId);
		return entity.get_isComplete();
	}
	,isActive: function(questId) {
		var active = this._profileIndex.activeQuests;
		var _g = 0;
		while(_g < active.length) {
			var q = active[_g];
			++_g;
			if(q.data.id == questId) {
				return true;
			}
		}
		return false;
	}
	,getQuestEntity: function(questId) {
		var active = this._profileIndex.activeQuests;
		var _g = 0;
		while(_g < active.length) {
			var q = active[_g];
			++_g;
			if(q.data.id == questId) {
				return q;
			}
		}
		throw haxe_Exception.thrown("quest not found: id = " + questId);
	}
	,getActive: function() {
		return this._profileIndex.activeQuests;
	}
	,getLastClosedId: function() {
		return this._storage.data.completeQuestIds[this._storage.data.completeQuestIds.length - 1];
	}
	,getDailyQuest: function() {
		return this._profileIndex.dailyQuest;
	}
	,getDailyQuestData: function() {
		return this._storage.data.dailyQuest;
	}
	,isInCurrentEvent: function(questId) {
		var quest = this._metaIndex.quests.h[questId];
		return this._dataProvider.gameTasks.isInCurrentEvent(quest.gameEventsComponent);
	}
	,isDailyQuestInCurrentEvent: function() {
		return this._storage.data.currentGameEventId == 1;
	}
	,__class__: com_nevosoft_waw_dpScopes_QuestsDataProvider
});
var com_nevosoft_waw_dpScopes_ResourcesStrategy = function(index) {
	this.profileIndex = index;
};
com_nevosoft_waw_dpScopes_ResourcesStrategy.__name__ = true;
com_nevosoft_waw_dpScopes_ResourcesStrategy.prototype = {
	availableAmount: function(storage,resourceId) {
		var resources = storage.data.resources;
		return com_nevosoft_waw_data_serialization_ArrayMapInt.get(resources,resourceId);
	}
	,preservedAmount: function(storage,resourceId) {
		var resources = storage.data.preservedResources;
		return com_nevosoft_waw_data_serialization_ArrayMapInt.get(resources,resourceId);
	}
	,__class__: com_nevosoft_waw_dpScopes_ResourcesStrategy
};
var com_nevosoft_waw_dpScopes_ClientResourcesStrategy = function(index) {
	com_nevosoft_waw_dpScopes_ResourcesStrategy.call(this,index);
};
com_nevosoft_waw_dpScopes_ClientResourcesStrategy.__name__ = true;
com_nevosoft_waw_dpScopes_ClientResourcesStrategy.__super__ = com_nevosoft_waw_dpScopes_ResourcesStrategy;
com_nevosoft_waw_dpScopes_ClientResourcesStrategy.prototype = $extend(com_nevosoft_waw_dpScopes_ResourcesStrategy.prototype,{
	availableAmount: function(storage,resourceId) {
		var result = com_nevosoft_waw_dpScopes_ResourcesStrategy.prototype.availableAmount.call(this,storage,resourceId);
		return result - this.profileIndex.movesBuffer.getBufferedAmount(resourceId);
	}
	,preservedAmount: function(storage,resourceId) {
		var result = com_nevosoft_waw_dpScopes_ResourcesStrategy.prototype.preservedAmount.call(this,storage,resourceId);
		return result - this.profileIndex.movesBuffer.getBufferedAmount(resourceId);
	}
	,__class__: com_nevosoft_waw_dpScopes_ClientResourcesStrategy
});
var com_nevosoft_waw_dpScopes_ResourcesDataProvider = function(storage,dataProvider,resourcesStrategy) {
	com_nevosoft_waw_BaseDataProviderScope.call(this,storage,dataProvider);
	this.signalResourceMove = new msignal_Signal1();
	this.resourcesStrategy = resourcesStrategy;
};
com_nevosoft_waw_dpScopes_ResourcesDataProvider.__name__ = true;
com_nevosoft_waw_dpScopes_ResourcesDataProvider.__super__ = com_nevosoft_waw_BaseDataProviderScope;
com_nevosoft_waw_dpScopes_ResourcesDataProvider.prototype = $extend(com_nevosoft_waw_BaseDataProviderScope.prototype,{
	getAll: function() {
		return com_nevosoft_waw_data_types_TCost.fromArrayMapInt(this._storage.data.resources);
	}
	,ResourcesAmountIsEnough: function(resourcesRequirements) {
		var statuses = this.CheckResourceAmount(resourcesRequirements);
		var status = statuses.iterator();
		while(status.hasNext()) {
			var status1 = status.next();
			if(!status1) {
				return false;
			}
		}
		return true;
	}
	,CheckResourceAmount: function(resourcesRequirements) {
		var result = new haxe_ds_IntMap();
		var rr = new com_nevosoft_waw_data_types_TCostIterator(resourcesRequirements);
		while(rr.hasNext()) {
			var rr1 = rr.next();
			var k = rr1.resourceId;
			var v = rr1.value <= this.resourcesStrategy.availableAmount(this._storage,rr1.resourceId);
			result.h[k] = v;
		}
		return result;
	}
	,GetInsufficientResources: function(resourcesRequirements) {
		var result = { };
		var rr = new com_nevosoft_waw_data_types_TCostIterator(resourcesRequirements);
		while(rr.hasNext()) {
			var rr1 = rr.next();
			if(rr1.resourceId == -5) {
				continue;
			}
			var available = this.resourcesStrategy.availableAmount(this._storage,rr1.resourceId);
			if(rr1.value > available) {
				var key = rr1.resourceId;
				var value = rr1.value - available;
				result[key == null ? "null" : "" + key] = value;
			}
		}
		return result;
	}
	,get_resource: function(key) {
		return this.resourcesStrategy.availableAmount(this._storage,key);
	}
	,AvailableAmount: function(resourceId) {
		return this.resourcesStrategy.availableAmount(this._storage,resourceId);
	}
	,preservedAmount: function(resourceId) {
		return this.resourcesStrategy.preservedAmount(this._storage,resourceId);
	}
	,got: function(id) {
		return com_nevosoft_waw_data_serialization_ArrayMapInt.getIndex(this._storage.data.resources,id) >= 0;
	}
	,isStorable: function(item) {
		if(item.resourceComponent != null) {
			return item.resourceComponent.storageCategory != "HIDDEN";
		} else {
			return true;
		}
	}
	,storageIsFreeEnough: function(id,value,checkToken) {
		var mp = this._dataProvider.meta;
		var objMt = mp.getGameObjectMeta(id);
		if(!this.isStorable(objMt)) {
			return true;
		}
		var storage = this.getStorageByObjectMetaId(id);
		if(storage != null) {
			return storage.check(value,checkToken);
		} else {
			return true;
		}
	}
	,getStorageLimitByObjectMetaId: function(metaId) {
		var storage = this.getStorageByObjectMetaId(metaId);
		if(storage != null) {
			var _this = storage;
			if(_this._meta.gameEventsComponent != null && _this._meta.gameEventsComponent.indexOf(_this.currentGameEventId) < 0 && _this.currentGameEventId != 1) {
				return -1;
			} else {
				var level = _this._data == null || _this._data.cUpgradable == null ? 1 : _this._data.cUpgradable.level;
				return _this._meta.storageComponent.limits[level - 1];
			}
		} else {
			return -1;
		}
	}
	,getStorageLimitByObjectCategory: function(category) {
		var storage = this._profileIndex.getStorageByObjectCategory(category);
		if(storage != null) {
			var _this = storage;
			if(_this._meta.gameEventsComponent != null && _this._meta.gameEventsComponent.indexOf(_this.currentGameEventId) < 0 && _this.currentGameEventId != 1) {
				return -1;
			} else {
				var level = _this._data == null || _this._data.cUpgradable == null ? 1 : _this._data.cUpgradable.level;
				return _this._meta.storageComponent.limits[level - 1];
			}
		} else {
			return -1;
		}
	}
	,getStorageLimitById: function(storageId) {
		var storage = this._profileIndex.getStorageById(storageId);
		if(storage != null) {
			var _this = storage;
			if(_this._meta.gameEventsComponent != null && _this._meta.gameEventsComponent.indexOf(_this.currentGameEventId) < 0 && _this.currentGameEventId != 1) {
				return -1;
			} else {
				var level = _this._data == null || _this._data.cUpgradable == null ? 1 : _this._data.cUpgradable.level;
				return _this._meta.storageComponent.limits[level - 1];
			}
		} else {
			return -1;
		}
	}
	,getStorageCounterByObjectMetaId: function(metaId) {
		var storage = this.getStorageByObjectMetaId(metaId);
		if(storage != null) {
			return storage.counter;
		} else {
			return -1;
		}
	}
	,getStorageCounterByObjectCategory: function(category) {
		var storage = this._profileIndex.getStorageByObjectCategory(category);
		if(storage != null) {
			return storage.counter;
		} else {
			return -1;
		}
	}
	,getStorageCounterById: function(storageId) {
		var storage = this._profileIndex.getStorageById(storageId);
		if(storage != null) {
			return storage.counter;
		} else {
			return -1;
		}
	}
	,getStorageByObjectMetaId: function(metaId) {
		var result = this._profileIndex.getStorageByObjectMetaId(metaId);
		if(result == null) {
			var objMeta = this._metaIndex.gameObjects.h[metaId];
			var category = objMeta.category;
			result = this._profileIndex.getStorageByObjectCategory(category);
		}
		return result;
	}
	,getStorageByObjectCategory: function(category) {
		return this._profileIndex.getStorageByObjectCategory(category);
	}
	,getStorageByTag: function(tag) {
		return this._profileIndex.getStorageByTag(tag);
	}
	,canPutToStorage: function(rewards) {
		var checkToken = com_nevosoft_waw_data_vo_OnMapStorage.getCheckToken();
		var r = new com_nevosoft_waw_data_types_TCostIterator(rewards);
		while(r.hasNext()) {
			var r1 = r.next();
			if(!this.storageIsFreeEnough(r1.resourceId,r1.value,checkToken)) {
				return false;
			}
		}
		return true;
	}
	,isTimeRelated: function(metaId) {
		var meta = this._dataProvider.meta.getGameObjectMeta(metaId);
		if(meta != null && meta.gameTaskComponent != null) {
			return meta.gameTaskComponent.timeParameters != null;
		} else {
			return false;
		}
	}
	,isBuffRelated: function(metaId) {
		var meta = this._dataProvider.meta.getGameObjectMeta(metaId);
		return com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged("res_buff",meta);
	}
	,__class__: com_nevosoft_waw_dpScopes_ResourcesDataProvider
});
var com_nevosoft_waw_dpScopes_ShopDataProvider = function(storage,dataProvider) {
	com_nevosoft_waw_BaseDataProviderScope.call(this,storage,dataProvider);
};
com_nevosoft_waw_dpScopes_ShopDataProvider.__name__ = true;
com_nevosoft_waw_dpScopes_ShopDataProvider.__super__ = com_nevosoft_waw_BaseDataProviderScope;
com_nevosoft_waw_dpScopes_ShopDataProvider.prototype = $extend(com_nevosoft_waw_BaseDataProviderScope.prototype,{
	getLimit: function(item) {
		if(item.category == "ANIMAL") {
			return this._dataProvider.location.getAnimalLimit(item.id);
		} else if(item.category == "STUFF_PACK") {
			return 0;
		} else {
			return this._dataProvider.location.getStructureShopLimit(item.id);
		}
	}
	,getCount: function(item) {
		if(item.category == "STUFF_PACK") {
			var resourceId = com_nevosoft_waw_data_types_TCost.get_first_items(item.resTransactionComponent.reward,1)[0].resourceId;
			var amount = this._dataProvider.clientResources.AvailableAmount(resourceId);
			return amount;
		} else {
			return this._dataProvider.location.getMapObjectCount(item.id);
		}
	}
	,getUnlockedItems: function(level) {
		var result = [];
		var mainEventId = this._dataProvider.getHomeLocationEventId();
		var unlock = this._metaIndex.shopUnlocks.unlocksOnLevel(level);
		while(unlock.hasNext()) {
			var unlock1 = unlock.next();
			var objectMeta = this._dataProvider.meta.getGameObjectMeta(unlock1.objectId);
			if(this._dataProvider.meta.isAvailableInEvent(objectMeta.gameEventsComponent,mainEventId)) {
				result.push(unlock1);
			}
		}
		return result;
	}
	,getUnlockedItemsQuestComplete: function(questId) {
		var _g = [];
		var _g1 = 0;
		var _g2 = this._dataProvider.meta.getGameObjects();
		while(_g1 < _g2.length) {
			var item = _g2[_g1];
			++_g1;
			if(item.shopComponent != null) {
				_g.push(item);
			}
		}
		var shopItems = _g;
		var result = [];
		var _g = 0;
		while(_g < shopItems.length) {
			var item = shopItems[_g];
			++_g;
			var restrictions = this._dataProvider.mapObjects.getPlacingRestrictions(item.id);
			var check = this._dataProvider.restrictions.CheckRestrictions(restrictions);
			if(check.statuses.h["2"]) {
				var params = Reflect.field(restrictions,"2");
				if(params[0] == questId) {
					result.push(item.id);
				}
			}
		}
		return result;
	}
	,getNewItems: function() {
		return this._storage.data.newShopItems;
	}
	,getIAPLots: function() {
		return this._storage.meta.iapLots;
	}
	,getIAPLot: function(id) {
		return this._metaIndex.iapLots.h[id];
	}
	,getIAPTotalSpend: function() {
		return 0;
	}
	,purchaseResourceForVideoLastPurchasedTime: function() {
		return this._dataProvider.location.getPurchaseResourceRVState().lastPurchasedTime;
	}
	,isPurchaseResourceForVideoAvailable: function() {
		var settings = this._dataProvider.location.getResourceRVSettings();
		if(this._dataProvider.location.getPurchaseResourceRVState().numPurchased < settings.attemptsCount) {
			return this._dataProvider.restrictions.FastCheck(settings.restrictions);
		} else {
			return false;
		}
	}
	,purchaseTownhallResourceForVideoLastPurchasedTime: function() {
		return this._dataProvider.location.getPurchaseTownhallResourceRVState().lastPurchasedTime;
	}
	,isPurchaseTownhallResourceForVideoAvailable: function() {
		var settings = this._dataProvider.location.getTownhallResourceRVSettings();
		if(this._dataProvider.location.getPurchaseTownhallResourceRVState().numPurchased < settings.attemptsCount) {
			return this._dataProvider.restrictions.FastCheck(settings.restrictions);
		} else {
			return false;
		}
	}
	,purchaseBlockingGarbageResourceForVideoLastPurchasedTime: function() {
		return this._dataProvider.location.getPurchaseBlockingGarbageResourceRVState().lastPurchasedTime;
	}
	,isPurchaseBlockingGarbageResourceForVideoAvailable: function() {
		var settings = this._dataProvider.location.getBlockingGarbageResourceRVSettings();
		if(this._dataProvider.location.getPurchaseBlockingGarbageResourceRVState().numPurchased < settings.attemptsCount) {
			return this._dataProvider.restrictions.FastCheck(settings.restrictions);
		} else {
			return false;
		}
	}
	,__class__: com_nevosoft_waw_dpScopes_ShopDataProvider
});
var com_nevosoft_waw_dpScopes_SocialDataProvider = function(storage,dataProvider) {
	com_nevosoft_waw_BaseDataProviderScope.call(this,storage,dataProvider);
};
com_nevosoft_waw_dpScopes_SocialDataProvider.__name__ = true;
com_nevosoft_waw_dpScopes_SocialDataProvider.__super__ = com_nevosoft_waw_BaseDataProviderScope;
com_nevosoft_waw_dpScopes_SocialDataProvider.prototype = $extend(com_nevosoft_waw_BaseDataProviderScope.prototype,{
	getValidZeppelinHelp: function(zeppelinState) {
		var result = [];
		var _g = 0;
		var _g1 = this._storage.currentLocationSocialActions;
		while(_g < _g1.length) {
			var action = _g1[_g];
			++_g;
			if(action.type == "zeppelin" && action.time >= zeppelinState.initTime) {
				var zeppelinHelp = com_nevosoft_waw_data_serialization_ZeppelinHelp._new(action);
				result.push(zeppelinHelp);
			}
		}
		return result;
	}
	,createZeppelinHelp: function(slotId,time) {
		return com_nevosoft_waw_data_serialization_ZeppelinHelp._new({ senderId : this._storage.data._id, receiverId : this._storage.currentLocation.ownerId, type : "zeppelin", params : [slotId], time : time});
	}
	,getFriendIds: function() {
		return haxe_ds_StringMap.keysIterator(this._profileIndex.friends.h);
	}
	,getFriend: function(id) {
		return this._profileIndex.friends.h[id];
	}
	,__class__: com_nevosoft_waw_dpScopes_SocialDataProvider
});
var com_nevosoft_waw_dpScopes_StoryDataProvider = function(storage,dataProvider) {
	com_nevosoft_waw_BaseDataProviderScope.call(this,storage,dataProvider);
};
com_nevosoft_waw_dpScopes_StoryDataProvider.__name__ = true;
com_nevosoft_waw_dpScopes_StoryDataProvider.__super__ = com_nevosoft_waw_BaseDataProviderScope;
com_nevosoft_waw_dpScopes_StoryDataProvider.prototype = $extend(com_nevosoft_waw_BaseDataProviderScope.prototype,{
	getStoryVO: function(id) {
		if(!this._metaIndex.story.h.hasOwnProperty(id)) {
			throw haxe_Exception.thrown("story not found: " + id);
		}
		var this1 = this._metaIndex.story.h[id];
		return this1;
	}
	,getStory: function(id) {
		var _g = 0;
		var _g1 = this._storage.data.stories;
		while(_g < _g1.length) {
			var story = _g1[_g];
			++_g;
			if(story.id == id) {
				return story;
			}
		}
		return null;
	}
	,__class__: com_nevosoft_waw_dpScopes_StoryDataProvider
});
var com_nevosoft_waw_entity_GameObjectsTemplateFactory = function() { };
com_nevosoft_waw_entity_GameObjectsTemplateFactory.__name__ = true;
com_nevosoft_waw_entity_GameObjectsTemplateFactory.getNatureObjectTemplate = function(metaId) {
	return { id : 0, metaId : metaId, isFrozen : false, cUpgradable : { level : 0}, cPosition : { x : 0, y : 0, flip : false}, cWorkplace : { slots : 1, currentActionIndex : -1, actionsQueue : [], workers : [], modificators : []}};
};
com_nevosoft_waw_entity_GameObjectsTemplateFactory.getBuildingTemplate = function(meta) {
	var result = { id : 0, metaId : meta.id, cUpgradable : { level : 0}, cPosition : { x : 0, y : 0, flip : false}, isFrozen : false, cWorkplace : { slots : 1, currentActionIndex : -1, actionsQueue : [], workers : [], modificators : []}};
	if(meta.category == "FARM_CELL") {
		result.cFarm = { plantId : -1};
		if(meta.workComponent.repairAction == null && meta.workComponent.upgradeActions.length == 0) {
			Reflect.deleteField(result,"cUpgradable");
		}
	} else if(meta.category == "LAIR") {
		result.cLair = { time : -1};
	} else if(meta.category == "DECOR") {
		Reflect.deleteField(result,"cWorkplace");
	}
	if(meta.storageComponent != null) {
		result.cStorage = { newItems : []};
	}
	if(com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged("go_temporary_building",meta)) {
		result.cBGWorkplace = { slots : 1, currentActionIndex : -1, actionsQueue : [], workers : [], modificators : []};
	}
	return result;
};
com_nevosoft_waw_entity_GameObjectsTemplateFactory.getAnimalTemplate = function(meta) {
	var result = { id : 0, metaId : meta.id, isFrozen : false, cAnimal : { pastureId : 0}};
	if(meta.workComponent != null) {
		result.cWorkplace = { slots : 1, currentActionIndex : -1, actionsQueue : [], workers : [], modificators : []};
	}
	if(meta.periodicalRewardComponent != null) {
		result.cPeriodicalReward = { currentPeriod : 0, isRewardCollected : false, lastIncreaseTime : 0};
	}
	return result;
};
com_nevosoft_waw_entity_GameObjectsTemplateFactory.getNutTemplate = function() {
	return { id : 0, metaId : -1, isFrozen : false, cNut : { timeAttackBuilding : -1, timeAttackShmu : -1, timeAttackAnimal : -1}};
};
var com_nevosoft_waw_helpers_GameObjectHelper = function() { };
com_nevosoft_waw_helpers_GameObjectHelper.__name__ = true;
com_nevosoft_waw_helpers_GameObjectHelper.getInitialLevel = function(meta) {
	var initialStateC = meta.initialState;
	var repairAction = meta.workComponent != null ? meta.workComponent.repairAction : null;
	if(initialStateC != null) {
		return initialStateC.level;
	} else if(repairAction != null) {
		return 0;
	} else if(meta.category == "TREE" || meta.category == "GARBAGE" || meta.category == "LAIR" || meta.category == "EVENT_STARTER") {
		return 0;
	} else {
		return 1;
	}
};
com_nevosoft_waw_helpers_GameObjectHelper.getPlacingModeLevel = function(meta) {
	var level = com_nevosoft_waw_helpers_GameObjectHelper.getInitialLevel(meta);
	if(meta.category == "HOUSE" || meta.category == "COMMON_BUILDING" || meta.category == "ACHIEVEMENT_HOUSE" || meta.category == "EVENT_STARTER" || meta.category == "ORDERS_HOST" || meta.category == "STORAGE_COMMON" || meta.category == "ZEPPELIN" || meta.category == "FARM_CELL") {
		level = 1;
	}
	return level;
};
com_nevosoft_waw_helpers_GameObjectHelper.getNumLevels = function(meta) {
	var numLevels = 1;
	if(meta != null && meta.workComponent != null && meta.workComponent.upgradeActions.length > 0) {
		var upgradesCount = meta.workComponent.upgradeActions.length;
		numLevels += upgradesCount;
	}
	return numLevels;
};
var com_nevosoft_waw_logic_EGameAPICommand = $hxEnums["com.nevosoft.waw.logic.EGameAPICommand"] = { __ename__ : true, __constructs__ : ["STORAGE_SELL_RESOURCE","STORAGE_SET_SHOWN","STORAGE_ADD","MAP_ENTER","MAP_EXIT","MAP_UNLOCK_FREE_SECTOR","MAP_BUY_SECTOR","MAP_SPAWN_NUT","MAP_KILL_NUT","MAP_SET_POSITION","MAP_REMOVE","MAP_REMOVE_UPDATE_ROAD","MAP_ROAD_BUY_UPDATE","MAP_FREEZE_MAP_OBJECT","MAP_CALM_DOWN_ANIMAL","MAP_HEAL_ZOMBIE","MAP_SPELL_BUILDING_FIX","MAP_RETIRE_WORKER","MAP_PREPARE_MAGIC_SPAWN","MAP_PREPARE_GARBAGE_SPAWN","MAP_EXECUTE_SPAWN","MAP_CLEAR_SPAWN","MAP_SPELL_PRODUCTION_TIME","MAP_DESTROY_PRODUCTION","MAP_UNLOCK_PRODUCTION_SLOT","MAP_UNLOCK_PRODOFFER_SLOT","MAP_VENDOR_START","MAP_PLAY_WITH_SHMU","MAP_PLAY_WITH_ANIMAL","MAP_CHECK_SPAWN_CHEST","MAP_QUEUE_ACTION","MAP_PREPARE_ACTION","MAP_ASSIGN_SHMU","MAP_RELEASE_SHMU","MAP_START_ACTION","MAP_FINISH_ACTION_AND_RELEASE","MAP_APPLY_ACTION","MAP_ACCELERATE_ACTION","MAP_ACCELERATE_ACTION_FOR_VIDEO","MAP_CANCEL_ACTION","MAP_EXPLODE","MAP_TNT_SPELL_APPLY","GAME_EVENT_ACTIVATE","GAME_EVENT_DEACTIVATE","GAME_EVENT_ENTER","STORY_ACTIVATE","STORY_DEACTIVATE","STORY_REWARD_APPLY","STORY_CLOSE","PROFILE_SAVE_OPTIONS","PROFILE_LEVELUP","PROFILE_LEVELUP_PREMIUM","PROFILE_GET_LOTERY_TICKET","PROFILE_GET_LOTERY_REWARD","PROFILE_UPDATE_REFERRER","PROFILE_UPDATE_OS_TYPE","PROFILE_ACCEPT_GDPR","PROFILE_IDFA_USER_ANSWER","PROFILE_CREATE_EVENT_LOCATION","PROFILE_ENTITY_WATCHED","PROFILE_EVENT_WATCHED","PROFILE_ADD_ACKNOWLEDGED_PURCHASE","PROFILE_ADD_PENDING_PURCHASE","PROFILE_ADD_EXPIRED_PURCHASE","PROFILE_REMOVE_ACKNOWLEDGED_PURCHASE","PROFILE_REMOVE_EXPIRED_PURCHASE","DAILY_BONUS_GET_REWARD","ZEPPELIN_INIT","ZEPPELIN_LOAD","ZEPPELIN_ASK_HELP","ZEPPELIN_LOAD_HELP","ZEPPELIN_ARRIVE","ZEPPELIN_FLY_AWAY","ZEPPELIN_RETURN_NOW","ZEPPELIN_SET_SHOWN","ZEPPELIN_RV_CHANGE","MARKET_INIT","MARKET_EXPAND","MARKET_SELL","MARKET_REGEN_SLOT","MARKET_SKIP_COOLDOWN","MARKET_RV_SKIP","MARKET_INC_FOR_VIDEO","SHOP_UNLOCK_ITEM","SHOP_BUY_WORKER","SHOP_BUY_BUILDING","SHOP_BUY_PLANT","SHOP_BUY_ANIMAL","SHOP_BUY_BUFF","SHOP_BUY_IAP_LOT","SHOP_SET_SHOWN","SHOP_BUY_STUFF","SHOP_BUY_STUFF_FOR_VIDEO","WAREHOUSE_STORE_BUILDING","WAREHOUSE_RESTORE_BUILDING","WAREHOUSE_RESTORE_ANIMAL","QUESTS_ACTIVATE","QUESTS_DEACTIVATE","QUESTS_OPEN","QUESTS_CLOSE","ACHIEVEMENTS_GET_REWARD","OFFERS_ACTIVATE","OFFERS_DEACTIVATE","OFFER_BUY_LOT","OFFER_SET_SHOWN","DAILY_QUEST_INIT","DAILY_QUEST_CHANGE","DAILY_QUEST_MINOR_REWARD","DAILY_QUEST_GET_REWARD","DAILY_QUEST_SET_SHOWN","BUFFS_ACTIVATE","BUFFS_DEACTIVATE","CAMP_INIT","CAMP_LOAD_SLOT","CAMP_GET_REWARD","CAMP_ACCELERATE","CAMP_TASK_CHANGE","ORDERS_HOST_INIT","ORDERS_HOST_SELL","ORDERS_HOST_SKIP","TUTOR_PROCESS_ACTION","TUTOR_GIVE_QUEST_ACTION","TUTOR_SET_CHECKPOINT","TUTOR_SKIP","TUTOR_COUNT_ACTION","IMMEDIATE_UPGRADE","RV_SHOWN","RV_REFRESH_COUNTERS","RV_UPDATE_STATES","ABTEST_SEND_PROPERTY","GO_GAME_TASK_ACTIVATE","GO_GAME_TASK_DEACTIVATE","GO_GAME_TASK_MAP_SPAWN","GAME_TASK_HISTORY_CLEAR","PERIODICAL_REWARD_COLLECT","PERIODICAL_REWARD_INCREASE_PERIODS"]
	,STORAGE_SELL_RESOURCE: ($_=function(resourceId,sellAmount) { return {_hx_index:0,resourceId:resourceId,sellAmount:sellAmount,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["resourceId","sellAmount"],$_)
	,STORAGE_SET_SHOWN: ($_=function(storageId,itemIds) { return {_hx_index:1,storageId:storageId,itemIds:itemIds,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["storageId","itemIds"],$_)
	,STORAGE_ADD: ($_=function(storageId,itemIds) { return {_hx_index:2,storageId:storageId,itemIds:itemIds,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["storageId","itemIds"],$_)
	,MAP_ENTER: ($_=function(ownerId) { return {_hx_index:3,ownerId:ownerId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["ownerId"],$_)
	,MAP_EXIT: ($_=function(ownerId,newEventId) { return {_hx_index:4,ownerId:ownerId,newEventId:newEventId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["ownerId","newEventId"],$_)
	,MAP_UNLOCK_FREE_SECTOR: ($_=function(sectorId) { return {_hx_index:5,sectorId:sectorId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["sectorId"],$_)
	,MAP_BUY_SECTOR: ($_=function(sectorId) { return {_hx_index:6,sectorId:sectorId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["sectorId"],$_)
	,MAP_SPAWN_NUT: ($_=function(lairId) { return {_hx_index:7,lairId:lairId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["lairId"],$_)
	,MAP_KILL_NUT: ($_=function(id,spellId) { return {_hx_index:8,id:id,spellId:spellId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id","spellId"],$_)
	,MAP_SET_POSITION: ($_=function(targetId,x,y,flip) { return {_hx_index:9,targetId:targetId,x:x,y:y,flip:flip,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId","x","y","flip"],$_)
	,MAP_REMOVE: ($_=function(id) { return {_hx_index:10,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,MAP_REMOVE_UPDATE_ROAD: ($_=function(removed,updated) { return {_hx_index:11,removed:removed,updated:updated,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["removed","updated"],$_)
	,MAP_ROAD_BUY_UPDATE: ($_=function(shopItemId,purchased,constructed) { return {_hx_index:12,shopItemId:shopItemId,purchased:purchased,constructed:constructed,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["shopItemId","purchased","constructed"],$_)
	,MAP_FREEZE_MAP_OBJECT: ($_=function(nutId,targetId) { return {_hx_index:13,nutId:nutId,targetId:targetId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["nutId","targetId"],$_)
	,MAP_CALM_DOWN_ANIMAL: ($_=function(targetId) { return {_hx_index:14,targetId:targetId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId"],$_)
	,MAP_HEAL_ZOMBIE: ($_=function(targetId) { return {_hx_index:15,targetId:targetId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId"],$_)
	,MAP_SPELL_BUILDING_FIX: ($_=function(targetId,spellId) { return {_hx_index:16,targetId:targetId,spellId:spellId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId","spellId"],$_)
	,MAP_RETIRE_WORKER: ($_=function(id) { return {_hx_index:17,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,MAP_PREPARE_MAGIC_SPAWN: ($_=function(spellId,x,y) { return {_hx_index:18,spellId:spellId,x:x,y:y,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["spellId","x","y"],$_)
	,MAP_PREPARE_GARBAGE_SPAWN: {_hx_index:19,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,MAP_EXECUTE_SPAWN: ($_=function(id,x,y) { return {_hx_index:20,id:id,x:x,y:y,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id","x","y"],$_)
	,MAP_CLEAR_SPAWN: ($_=function(id) { return {_hx_index:21,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,MAP_SPELL_PRODUCTION_TIME: ($_=function(targetId,spellId) { return {_hx_index:22,targetId:targetId,spellId:spellId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId","spellId"],$_)
	,MAP_DESTROY_PRODUCTION: ($_=function(targetId) { return {_hx_index:23,targetId:targetId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId"],$_)
	,MAP_UNLOCK_PRODUCTION_SLOT: ($_=function(targetId) { return {_hx_index:24,targetId:targetId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId"],$_)
	,MAP_UNLOCK_PRODOFFER_SLOT: ($_=function(targetId) { return {_hx_index:25,targetId:targetId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId"],$_)
	,MAP_VENDOR_START: ($_=function(targetId,input) { return {_hx_index:26,targetId:targetId,input:input,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId","input"],$_)
	,MAP_PLAY_WITH_SHMU: ($_=function(targetId) { return {_hx_index:27,targetId:targetId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId"],$_)
	,MAP_PLAY_WITH_ANIMAL: ($_=function(targetId) { return {_hx_index:28,targetId:targetId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId"],$_)
	,MAP_CHECK_SPAWN_CHEST: ($_=function(removedX,removedY,removedMetaId,types) { return {_hx_index:29,removedX:removedX,removedY:removedY,removedMetaId:removedMetaId,types:types,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["removedX","removedY","removedMetaId","types"],$_)
	,MAP_QUEUE_ACTION: ($_=function(targetId,actionId,useBGWorkplace) { return {_hx_index:30,targetId:targetId,actionId:actionId,useBGWorkplace:useBGWorkplace,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId","actionId","useBGWorkplace"],$_)
	,MAP_PREPARE_ACTION: ($_=function(targetId,actionId,useBGWorkplace) { return {_hx_index:31,targetId:targetId,actionId:actionId,useBGWorkplace:useBGWorkplace,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId","actionId","useBGWorkplace"],$_)
	,MAP_ASSIGN_SHMU: ($_=function(targetId,vassals,useBGWorkplace) { return {_hx_index:32,targetId:targetId,vassals:vassals,useBGWorkplace:useBGWorkplace,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId","vassals","useBGWorkplace"],$_)
	,MAP_RELEASE_SHMU: ($_=function(targetId,vassals,useBGWorkplace) { return {_hx_index:33,targetId:targetId,vassals:vassals,useBGWorkplace:useBGWorkplace,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId","vassals","useBGWorkplace"],$_)
	,MAP_START_ACTION: ($_=function(targetId,useBGWorkplace) { return {_hx_index:34,targetId:targetId,useBGWorkplace:useBGWorkplace,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId","useBGWorkplace"],$_)
	,MAP_FINISH_ACTION_AND_RELEASE: ($_=function(targetId,shmuIds,useBGWorkplace) { return {_hx_index:35,targetId:targetId,shmuIds:shmuIds,useBGWorkplace:useBGWorkplace,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId","shmuIds","useBGWorkplace"],$_)
	,MAP_APPLY_ACTION: ($_=function(targetId,useBGWorkplace) { return {_hx_index:36,targetId:targetId,useBGWorkplace:useBGWorkplace,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId","useBGWorkplace"],$_)
	,MAP_ACCELERATE_ACTION: ($_=function(targetId,useBGWorkplace) { return {_hx_index:37,targetId:targetId,useBGWorkplace:useBGWorkplace,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId","useBGWorkplace"],$_)
	,MAP_ACCELERATE_ACTION_FOR_VIDEO: ($_=function(targetId) { return {_hx_index:38,targetId:targetId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId"],$_)
	,MAP_CANCEL_ACTION: ($_=function(targetId,useBGWorkplace) { return {_hx_index:39,targetId:targetId,useBGWorkplace:useBGWorkplace,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId","useBGWorkplace"],$_)
	,MAP_EXPLODE: ($_=function(objectIds) { return {_hx_index:40,objectIds:objectIds,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["objectIds"],$_)
	,MAP_TNT_SPELL_APPLY: ($_=function(spellId) { return {_hx_index:41,spellId:spellId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["spellId"],$_)
	,GAME_EVENT_ACTIVATE: ($_=function(id) { return {_hx_index:42,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,GAME_EVENT_DEACTIVATE: ($_=function(id) { return {_hx_index:43,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,GAME_EVENT_ENTER: ($_=function(id) { return {_hx_index:44,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,STORY_ACTIVATE: ($_=function(id) { return {_hx_index:45,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,STORY_DEACTIVATE: ($_=function(id) { return {_hx_index:46,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,STORY_REWARD_APPLY: ($_=function(id) { return {_hx_index:47,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,STORY_CLOSE: ($_=function(id) { return {_hx_index:48,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,PROFILE_SAVE_OPTIONS: ($_=function(musicOn,soundOn,localeId) { return {_hx_index:49,musicOn:musicOn,soundOn:soundOn,localeId:localeId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["musicOn","soundOn","localeId"],$_)
	,PROFILE_LEVELUP: {_hx_index:50,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,PROFILE_LEVELUP_PREMIUM: {_hx_index:51,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,PROFILE_GET_LOTERY_TICKET: {_hx_index:52,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,PROFILE_GET_LOTERY_REWARD: ($_=function(reward,winnerGroupIndex) { return {_hx_index:53,reward:reward,winnerGroupIndex:winnerGroupIndex,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["reward","winnerGroupIndex"],$_)
	,PROFILE_UPDATE_REFERRER: ($_=function(referrer) { return {_hx_index:54,referrer:referrer,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["referrer"],$_)
	,PROFILE_UPDATE_OS_TYPE: ($_=function(osType) { return {_hx_index:55,osType:osType,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["osType"],$_)
	,PROFILE_ACCEPT_GDPR: ($_=function(time) { return {_hx_index:56,time:time,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["time"],$_)
	,PROFILE_IDFA_USER_ANSWER: ($_=function(type) { return {_hx_index:57,type:type,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["type"],$_)
	,PROFILE_CREATE_EVENT_LOCATION: ($_=function(eventId) { return {_hx_index:58,eventId:eventId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["eventId"],$_)
	,PROFILE_ENTITY_WATCHED: ($_=function(entityId) { return {_hx_index:59,entityId:entityId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["entityId"],$_)
	,PROFILE_EVENT_WATCHED: ($_=function(eventId) { return {_hx_index:60,eventId:eventId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["eventId"],$_)
	,PROFILE_ADD_ACKNOWLEDGED_PURCHASE: ($_=function(purchase) { return {_hx_index:61,purchase:purchase,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["purchase"],$_)
	,PROFILE_ADD_PENDING_PURCHASE: ($_=function(purchases) { return {_hx_index:62,purchases:purchases,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["purchases"],$_)
	,PROFILE_ADD_EXPIRED_PURCHASE: ($_=function(purchases) { return {_hx_index:63,purchases:purchases,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["purchases"],$_)
	,PROFILE_REMOVE_ACKNOWLEDGED_PURCHASE: ($_=function(purchases) { return {_hx_index:64,purchases:purchases,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["purchases"],$_)
	,PROFILE_REMOVE_EXPIRED_PURCHASE: ($_=function(purchases) { return {_hx_index:65,purchases:purchases,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["purchases"],$_)
	,DAILY_BONUS_GET_REWARD: ($_=function(stage) { return {_hx_index:66,stage:stage,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["stage"],$_)
	,ZEPPELIN_INIT: {_hx_index:67,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,ZEPPELIN_LOAD: ($_=function(slotId) { return {_hx_index:68,slotId:slotId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["slotId"],$_)
	,ZEPPELIN_ASK_HELP: ($_=function(slotId) { return {_hx_index:69,slotId:slotId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["slotId"],$_)
	,ZEPPELIN_LOAD_HELP: ($_=function(slotId) { return {_hx_index:70,slotId:slotId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["slotId"],$_)
	,ZEPPELIN_ARRIVE: {_hx_index:71,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,ZEPPELIN_FLY_AWAY: {_hx_index:72,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,ZEPPELIN_RETURN_NOW: {_hx_index:73,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,ZEPPELIN_SET_SHOWN: {_hx_index:74,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,ZEPPELIN_RV_CHANGE: ($_=function(line) { return {_hx_index:75,line:line,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["line"],$_)
	,MARKET_INIT: {_hx_index:76,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,MARKET_EXPAND: {_hx_index:77,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,MARKET_SELL: ($_=function(slotId) { return {_hx_index:78,slotId:slotId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["slotId"],$_)
	,MARKET_REGEN_SLOT: ($_=function(slotId) { return {_hx_index:79,slotId:slotId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["slotId"],$_)
	,MARKET_SKIP_COOLDOWN: ($_=function(slotId) { return {_hx_index:80,slotId:slotId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["slotId"],$_)
	,MARKET_RV_SKIP: ($_=function(slotId) { return {_hx_index:81,slotId:slotId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["slotId"],$_)
	,MARKET_INC_FOR_VIDEO: {_hx_index:82,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,SHOP_UNLOCK_ITEM: ($_=function(itemId) { return {_hx_index:83,itemId:itemId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["itemId"],$_)
	,SHOP_BUY_WORKER: {_hx_index:84,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,SHOP_BUY_BUILDING: ($_=function(shopItemId,x,y,flip) { return {_hx_index:85,shopItemId:shopItemId,x:x,y:y,flip:flip,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["shopItemId","x","y","flip"],$_)
	,SHOP_BUY_PLANT: ($_=function(shopItemId,targetId) { return {_hx_index:86,shopItemId:shopItemId,targetId:targetId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["shopItemId","targetId"],$_)
	,SHOP_BUY_ANIMAL: ($_=function(shopItemId,x,y) { return {_hx_index:87,shopItemId:shopItemId,x:x,y:y,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["shopItemId","x","y"],$_)
	,SHOP_BUY_BUFF: ($_=function(buffId) { return {_hx_index:88,buffId:buffId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["buffId"],$_)
	,SHOP_BUY_IAP_LOT: ($_=function(lotId,lotPrice,priceMicros,currency) { return {_hx_index:89,lotId:lotId,lotPrice:lotPrice,priceMicros:priceMicros,currency:currency,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["lotId","lotPrice","priceMicros","currency"],$_)
	,SHOP_SET_SHOWN: ($_=function(ids) { return {_hx_index:90,ids:ids,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["ids"],$_)
	,SHOP_BUY_STUFF: ($_=function(stuff) { return {_hx_index:91,stuff:stuff,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["stuff"],$_)
	,SHOP_BUY_STUFF_FOR_VIDEO: ($_=function(stuff,destination) { return {_hx_index:92,stuff:stuff,destination:destination,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["stuff","destination"],$_)
	,WAREHOUSE_STORE_BUILDING: ($_=function(itemId) { return {_hx_index:93,itemId:itemId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["itemId"],$_)
	,WAREHOUSE_RESTORE_BUILDING: ($_=function(itemId,x,y,flip) { return {_hx_index:94,itemId:itemId,x:x,y:y,flip:flip,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["itemId","x","y","flip"],$_)
	,WAREHOUSE_RESTORE_ANIMAL: ($_=function(shopItemId,x,y) { return {_hx_index:95,shopItemId:shopItemId,x:x,y:y,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["shopItemId","x","y"],$_)
	,QUESTS_ACTIVATE: ($_=function(id) { return {_hx_index:96,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,QUESTS_DEACTIVATE: ($_=function(id) { return {_hx_index:97,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,QUESTS_OPEN: ($_=function(id) { return {_hx_index:98,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,QUESTS_CLOSE: ($_=function(id) { return {_hx_index:99,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,ACHIEVEMENTS_GET_REWARD: ($_=function(id) { return {_hx_index:100,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,OFFERS_ACTIVATE: ($_=function(id) { return {_hx_index:101,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,OFFERS_DEACTIVATE: ($_=function(id) { return {_hx_index:102,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,OFFER_BUY_LOT: ($_=function(lotId,lotPrice,priceMicros,currency) { return {_hx_index:103,lotId:lotId,lotPrice:lotPrice,priceMicros:priceMicros,currency:currency,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["lotId","lotPrice","priceMicros","currency"],$_)
	,OFFER_SET_SHOWN: ($_=function(id) { return {_hx_index:104,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,DAILY_QUEST_INIT: {_hx_index:105,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,DAILY_QUEST_CHANGE: {_hx_index:106,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,DAILY_QUEST_MINOR_REWARD: {_hx_index:107,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,DAILY_QUEST_GET_REWARD: {_hx_index:108,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,DAILY_QUEST_SET_SHOWN: {_hx_index:109,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,BUFFS_ACTIVATE: ($_=function(id,resId) { return {_hx_index:110,id:id,resId:resId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id","resId"],$_)
	,BUFFS_DEACTIVATE: ($_=function(id) { return {_hx_index:111,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,CAMP_INIT: ($_=function(campId) { return {_hx_index:112,campId:campId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["campId"],$_)
	,CAMP_LOAD_SLOT: ($_=function(slotId,campId) { return {_hx_index:113,slotId:slotId,campId:campId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["slotId","campId"],$_)
	,CAMP_GET_REWARD: ($_=function(campId) { return {_hx_index:114,campId:campId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["campId"],$_)
	,CAMP_ACCELERATE: ($_=function(campId) { return {_hx_index:115,campId:campId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["campId"],$_)
	,CAMP_TASK_CHANGE: ($_=function(slotId) { return {_hx_index:116,slotId:slotId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["slotId"],$_)
	,ORDERS_HOST_INIT: ($_=function(hostId) { return {_hx_index:117,hostId:hostId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["hostId"],$_)
	,ORDERS_HOST_SELL: ($_=function(hostId) { return {_hx_index:118,hostId:hostId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["hostId"],$_)
	,ORDERS_HOST_SKIP: ($_=function(hostId) { return {_hx_index:119,hostId:hostId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["hostId"],$_)
	,TUTOR_PROCESS_ACTION: ($_=function(id) { return {_hx_index:120,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,TUTOR_GIVE_QUEST_ACTION: ($_=function(id,questId) { return {_hx_index:121,id:id,questId:questId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id","questId"],$_)
	,TUTOR_SET_CHECKPOINT: ($_=function(id) { return {_hx_index:122,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,TUTOR_SKIP: {_hx_index:123,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,TUTOR_COUNT_ACTION: ($_=function(id,counter) { return {_hx_index:124,id:id,counter:counter,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id","counter"],$_)
	,IMMEDIATE_UPGRADE: ($_=function(targetId,actionId) { return {_hx_index:125,targetId:targetId,actionId:actionId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId","actionId"],$_)
	,RV_SHOWN: ($_=function(slotId) { return {_hx_index:126,slotId:slotId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["slotId"],$_)
	,RV_REFRESH_COUNTERS: {_hx_index:127,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,RV_UPDATE_STATES: {_hx_index:128,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
	,ABTEST_SEND_PROPERTY: ($_=function(propName,propValue) { return {_hx_index:129,propName:propName,propValue:propValue,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["propName","propValue"],$_)
	,GO_GAME_TASK_ACTIVATE: ($_=function(id) { return {_hx_index:130,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,GO_GAME_TASK_DEACTIVATE: ($_=function(id) { return {_hx_index:131,id:id,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id"],$_)
	,GO_GAME_TASK_MAP_SPAWN: ($_=function(id,x,y,flip) { return {_hx_index:132,id:id,x:x,y:y,flip:flip,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["id","x","y","flip"],$_)
	,GAME_TASK_HISTORY_CLEAR: ($_=function(eventId) { return {_hx_index:133,eventId:eventId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["eventId"],$_)
	,PERIODICAL_REWARD_COLLECT: ($_=function(targetId) { return {_hx_index:134,targetId:targetId,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}; },$_.__params__ = ["targetId"],$_)
	,PERIODICAL_REWARD_INCREASE_PERIODS: {_hx_index:135,__enum__:"com.nevosoft.waw.logic.EGameAPICommand",toString:$estr}
};
var com_nevosoft_waw_logic_CommonMatching = function() { };
com_nevosoft_waw_logic_CommonMatching.__name__ = true;
com_nevosoft_waw_logic_CommonMatching._seq = function(matchFncs,input) {
	return Lambda.foreach(matchFncs,function(fn) {
		return fn(input);
	});
};
com_nevosoft_waw_logic_CommonMatching.seq = function(matchFunc) {
	var matchFncs = matchFunc;
	return function(input) {
		return com_nevosoft_waw_logic_CommonMatching._seq(matchFncs,input);
	};
};
com_nevosoft_waw_logic_CommonMatching.idCmp = function(id,paramsExtractor,input) {
	var input1 = paramsExtractor(input);
	return id == input1.id;
};
com_nevosoft_waw_logic_CommonMatching.triggerTypeCmp = function(required,input) {
	return required._hx_index == input._hx_index;
};
com_nevosoft_waw_logic_CommonMatching.idSet = function(required,input) {
	return required.indexOf(input) >= 0;
};
var com_nevosoft_waw_logic_MapObjectMatching = function() { };
com_nevosoft_waw_logic_MapObjectMatching.__name__ = true;
com_nevosoft_waw_logic_MapObjectMatching.levelRestrictions = function(lvlRestrictions,inputParams) {
	var _g = 0;
	while(_g < lvlRestrictions.length) {
		var r = lvlRestrictions[_g];
		++_g;
		if(r.id == inputParams.metaId && com_nevosoft_waw_data_constants_CmpOp.compare(r.cmp,inputParams.level,r.lvl)) {
			return true;
		}
	}
	return false;
};
com_nevosoft_waw_logic_MapObjectMatching.metaIds = function(metaIds,obj) {
	return metaIds.indexOf(obj.metaId) >= 0;
};
com_nevosoft_waw_logic_MapObjectMatching.categories = function(categories,obj) {
	return categories.indexOf(obj.category) >= 0;
};
com_nevosoft_waw_logic_MapObjectMatching.hasAtLeastOneTag = function(objectTags,tagsToMatch) {
	var _g = 0;
	while(_g < objectTags.length) {
		var ot = objectTags[_g];
		++_g;
		if(tagsToMatch.indexOf(ot) >= 0) {
			return true;
		}
	}
	return false;
};
var com_nevosoft_waw_logic_GameTriggerParsing = function() { };
com_nevosoft_waw_logic_GameTriggerParsing.__name__ = true;
com_nevosoft_waw_logic_GameTriggerParsing.getParams = function(trigger) {
	return Type.enumParameters(trigger)[0];
};
var com_nevosoft_waw_logic_ILogicAPI = function() { };
com_nevosoft_waw_logic_ILogicAPI.__name__ = true;
com_nevosoft_waw_logic_ILogicAPI.__isInterface__ = true;
com_nevosoft_waw_logic_ILogicAPI.prototype = {
	__class__: com_nevosoft_waw_logic_ILogicAPI
};
var com_nevosoft_waw_logic_Transaction = function(ctx,command,time) {
	this.proceed = false;
	this.canceled = false;
	this.id = ctx.storage.data.lastCommandId + 1;
	this.command = command;
	this.gameTriggers = [];
	this.questUpdated = [];
	this.questComplete = [];
	this.questStageStatusChanged = this.questUpdated;
	this.achievementsUpdated = [];
	this.checkPoints = [];
	this.time = time;
	this.updateTimeProperties(ctx);
	if(ctx.storage != null) {
		this.randomGenerator = new com_nevosoft_waw_core_utils_SeedRandom(ctx.storage.data.seed);
		this.locationId = ctx.storage.data._id;
	}
	this.context = ctx;
};
com_nevosoft_waw_logic_Transaction.__name__ = true;
com_nevosoft_waw_logic_Transaction.prototype = {
	addTrigger: function(trigger) {
		this.gameTriggers.push(trigger);
	}
	,addCheckPoint: function(cp) {
		this.checkPoints.push(cp);
	}
	,getCheckSumInput: function() {
		return this.checkPoints.join("|");
	}
	,calcCheckSum: function() {
		var input = this.getCheckSumInput();
		return haxe_crypto_Md5.encode(input);
	}
	,traceCheckpoints: function() {
		var e = this.command;
		var name = $hxEnums[e.__enum__].__constructs__[e._hx_index];
		var params = Type.enumParameters(this.command);
		console.log("src/com/nevosoft/waw/logic/Transaction.hx:82:","Command: " + name + ", time: " + this.time + " begin, params: " + JSON.stringify(params));
		var _g = 0;
		var _g1 = this.checkPoints;
		while(_g < _g1.length) {
			var cp = _g1[_g];
			++_g;
			console.log("src/com/nevosoft/waw/logic/Transaction.hx:84:",cp);
		}
		console.log("src/com/nevosoft/waw/logic/Transaction.hx:86:","Command: " + name + ", time: " + this.time + " end");
	}
	,rollback: function() {
		if(this.context == null) {
			return;
		}
		this.context = null;
		this.canceled = true;
	}
	,commit: function() {
		this.process();
		return this;
	}
	,process: function() {
		this.context.actionDropSystem.process(this);
		this.context.questsSystem.process(this);
		this.context.storage.data.seed = this.randomGenerator.seed;
		this.context.storage.data.lastCommandId = this.id;
		this.context = null;
	}
	,updateTimeProperties: function(context) {
		context.storage.data.locationTime = this.time;
		if(context.dataProvider.location.isMyLocation()) {
			context.storage.currentLocation.time = this.time;
		}
		var timeOnMapEnter = context.storage.data.unixTimeOnMapEnter;
		if(timeOnMapEnter > 0) {
			var timeFromMapEnter = this.time - timeOnMapEnter;
			var gameTimeOnMapEnter = context.storage.data.gameTimeOnMapEnter;
			this.gameTime = gameTimeOnMapEnter + timeFromMapEnter;
			context.storage.data.gameTime = this.gameTime;
		}
	}
	,__class__: com_nevosoft_waw_logic_Transaction
};
var com_nevosoft_waw_logic_api_CommonLogic = function() { };
com_nevosoft_waw_logic_api_CommonLogic.__name__ = true;
com_nevosoft_waw_logic_api_CommonLogic.isValidNutTarget = function(objMt) {
	if(objMt != null && objMt.category == "COMMON_BUILDING") {
		var workComponent = objMt.workComponent;
		if(workComponent != null) {
			var actions = workComponent.actions;
			var _g = 0;
			while(_g < actions.length) {
				var action = actions[_g];
				++_g;
				if(!com_nevosoft_waw_data_types_meta_EActionType.inUpgradeGroup(action.type)) {
					return true;
				}
			}
		}
	}
	return false;
};
com_nevosoft_waw_logic_api_CommonLogic.newMapObjectRoutines = function(profileIndex,gameObject,dataProvider) {
	var objMt = dataProvider.mapObjects.getMeta(gameObject.metaId);
	if(objMt.category == "PASTURE") {
		if(objMt.pastureComponent == null) {
			throw haxe_Exception.thrown("A pasture must have a pasture component!");
		}
		var _g = 0;
		var _g1 = objMt.pastureComponent.animalIds.length;
		while(_g < _g1) {
			var i = _g++;
			profileIndex.animalToPastureIndex.h[objMt.pastureComponent.animalIds[i]] = gameObject;
		}
	}
	if(com_nevosoft_waw_logic_api_CommonLogic.isValidNutTarget(objMt)) {
		var nutContext = profileIndex.nutContext;
		nutContext.validBuildings++;
	}
};
var com_nevosoft_waw_logic_api_MapAPI = function() { };
com_nevosoft_waw_logic_api_MapAPI.__name__ = true;
com_nevosoft_waw_logic_api_MapAPI.enter = function(t,ownerId) {
	var ctx = t.context;
	com_nevosoft_waw_logic_api_MapAPI.setupDailyBonus(ctx,t.time);
	com_nevosoft_waw_logic_api_MapAPI.resetRVCountsIfNeeded(ctx,t.time);
	var today = ctx.dataProvider.timeProvider.getToday(t.time);
	var exitTime = ctx.storage.data.unixTimeOnMapExit;
	if(ctx.storage.data.unixTimeOnMapEnter < today) {
		ctx.storage.data.sessionDayNum = 0;
	}
	ctx.storage.data.unixTimeOnMapEnter = t.time;
	ctx.storage.data.gameTimeOnMapEnter = ctx.storage.data.gameTime;
	if(t.time - exitTime > 90) {
		ctx.storage.data.sessionNum++;
		ctx.storage.data.sessionDayNum++;
		ctx.storage.data.idfaStartSessionNum++;
	}
};
com_nevosoft_waw_logic_api_MapAPI.exit = function(t,ownerId,eventId) {
	var ctx = t.context;
	ctx.storage.data.unixTimeOnMapExit = t.time;
	ctx.storage.data.gameTimeOnMapExit = ctx.storage.data.gameTime;
	if(eventId == null) {
		eventId = 1;
	}
	if(eventId != ctx.storage.data.currentGameEventId) {
		t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerEventChanged({ id : eventId}));
	}
	ctx.storage.data.currentGameEventId = eventId;
	console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:90:","LAST EVENT ID " + eventId);
};
com_nevosoft_waw_logic_api_MapAPI.queueAction = function(t,targetId,actionId,useBGWorkplace) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var obj = dp.mapObjects.getData(targetId);
	var workplace = useBGWorkplace ? obj.cBGWorkplace : obj.cWorkplace;
	var meta = dp.mapObjects.getMeta(obj.metaId);
	var currActionState = dp.actions.getCurrentActionState(obj,useBGWorkplace);
	var actionsQueue = workplace.actionsQueue;
	if(currActionState != null) {
		var currAction = dp.actions.getActionMeta(currActionState.id);
		if(com_nevosoft_waw_data_types_meta_EActionType.inUpgradeGroup(currAction.type)) {
			throw haxe_Exception.thrown("upgrade in progress " + currActionState.id);
		}
	}
	if(actionsQueue.length >= workplace.slots) {
		throw haxe_Exception.thrown("queue is full");
	}
	var action = dp.actions.getActionMeta(actionId);
	if(com_nevosoft_waw_data_types_meta_EActionType.inUpgradeGroup(action.type) && actionsQueue.length > 0) {
		throw haxe_Exception.thrown("need collect first");
	}
	var payed;
	var _g = t.command;
	switch(_g._hx_index) {
	case 85:
		var _g1 = _g.flip;
		var _g1 = _g.y;
		var _g1 = _g.x;
		var _g1 = _g.shopItemId;
		payed = true;
		break;
	case 86:
		var _g1 = _g.targetId;
		var _g1 = _g.shopItemId;
		payed = true;
		break;
	default:
		payed = false;
	}
	if(!payed) {
		if(dp.serverResources.ResourcesAmountIsEnough(action.spendings)) {
			com_nevosoft_waw_logic_systems_ResourcesLogic.Withdraw(t,action.spendings,com_nevosoft_waw_data_constants_ResourceChangeReason.EMapObject(targetId));
		} else if(com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged("go_has_rewarded_video",meta)) {
			var tokensAmount = 1;
			if(tokensAmount > 0) {
				var cost = com_nevosoft_waw_data_types_TCost.fromIdValue(com_nevosoft_waw_data_constants_ResourceType.RESOURCE_TYPE_VIDEO_TOKEN,tokensAmount);
				com_nevosoft_waw_logic_systems_ResourcesLogic.Withdraw(t,cost,com_nevosoft_waw_data_constants_ResourceChangeReason.EMapObject(targetId));
			} else {
				throw haxe_Exception.thrown("Cannot withdraw video tokens: no available amount");
			}
		} else {
			throw haxe_Exception.thrown("Cannot withdraw spendings to queue actions");
		}
	}
	workplace.actionsQueue.push({ id : actionId, time : -1, modificators : [], status : 0});
	t.addCheckPoint("queue production: " + actionId);
	if(com_nevosoft_waw_data_types_meta_EActionType.inUpgradeGroup(action.type)) {
		var trigger = com_nevosoft_waw_data_types_EGameTrigger.TriggerUpgradeRequest({ id : obj.id, metaId : obj.metaId, category : meta.category, level : dp.mapObjects.getLevel(obj)});
		t.gameTriggers.push(trigger);
	} else {
		var trigger = com_nevosoft_waw_data_types_EGameTrigger.TriggerQueueAction({ id : obj.id, metaId : obj.metaId, category : meta.category, level : dp.mapObjects.getLevel(obj), actionId : action.id, actionIndex : dp.actions.getProductionIndex(meta,actionId), actionType : action.type});
		t.gameTriggers.push(trigger);
	}
};
com_nevosoft_waw_logic_api_MapAPI.prepareAction = function(t,targetId,actionId,useBGWorkplace) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var obj = dp.mapObjects.getData(targetId);
	var workplace = useBGWorkplace ? obj.cBGWorkplace : obj.cWorkplace;
	var meta = dp.mapObjects.getMeta(obj.metaId);
	var action = dp.actions.getActionMeta(actionId);
	var currentAction = null;
	var currentIndex = dp.actions.getNextActionFromQueue(obj,useBGWorkplace);
	if(currentIndex >= 0) {
		var a = workplace.actionsQueue[currentIndex];
		a.status = 1;
		a.time = -1;
		var mods = a.modificators;
		a.modificators = [];
		if(mods != null) {
			var _g = 0;
			while(_g < mods.length) {
				var mod = mods[_g];
				++_g;
				if(mod.source != 2) {
					a.modificators.push(mod);
				}
			}
		}
		currentAction = a;
		workplace.currentActionIndex = currentIndex;
		if(!useBGWorkplace) {
			var _g = 0;
			var _g1 = dp.gameTasks.getActiveHistory(t.time,"buff");
			while(_g < _g1.length) {
				var h = _g1[_g];
				++_g;
				var buff = dp.buffs.getBuffMeta(h.taskId);
				var modificator = { sourceId : buff.id, source : 2, modificator : buff.modificator.modificator, strength : buff.modificator.strength};
				com_nevosoft_waw_logic_api_MapAPI.modifyActionIfNeeded(t,obj,modificator,{ },com_nevosoft_waw_data_constants_ResourceChangeReason.EBuff(buff.id),[],"activate buff");
			}
		}
	}
	if(currentAction == null) {
		throw haxe_Exception.thrown("nothing to prepare");
	}
	currentAction.modificators.sort(function(a,b) {
		return a.modificator - b.modificator;
	});
	var modificatorsCheckPoint = "";
	var _g = 0;
	var _g1 = currentAction.modificators;
	while(_g < _g1.length) {
		var m = _g1[_g];
		++_g;
		modificatorsCheckPoint += " (" + m.modificator + " " + m.strength + " " + m.source + ")";
	}
	t.addCheckPoint("currentAction - time: " + currentAction.time + ", id: " + currentAction.id + ", " + modificatorsCheckPoint);
	var trigger = com_nevosoft_waw_data_types_EGameTrigger.TriggerPrepareAction({ id : obj.id, actionId : action.id, actionType : action.type, metaId : obj.metaId, category : meta.category, level : dp.mapObjects.getLevel(obj)});
	t.gameTriggers.push(trigger);
};
com_nevosoft_waw_logic_api_MapAPI.startAction = function(t,targetId,useBGWorkplace) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var obj = dp.mapObjects.getData(targetId);
	var meta = dp.mapObjects.getMeta(obj.metaId);
	var actionState = dp.actions.getCurrentActionState(obj,useBGWorkplace);
	var action = dp.actions.getActionMeta(actionState.id);
	if(action == null) {
		throw haxe_Exception.thrown("cannot assign shmu to building without action");
	}
	if(actionState.status == 1) {
		actionState.status = 2;
		actionState.time = t.time;
	} else {
		throw haxe_Exception.thrown("cannot start action with positive time parameter");
	}
	t.addCheckPoint("action time: " + actionState.time);
	var trigger = com_nevosoft_waw_data_types_EGameTrigger.TriggerStartAction({ id : obj.id, metaId : obj.metaId, category : meta.category, level : dp.mapObjects.getLevel(obj), actionId : actionState.id, actionType : action.type});
	t.gameTriggers.push(trigger);
};
com_nevosoft_waw_logic_api_MapAPI.finishActionAndRelease = function(t,targetId,shmuIds,useBGWorkplace) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var obj = dp.mapObjects.getData(targetId);
	var workplace = useBGWorkplace ? obj.cBGWorkplace : obj.cWorkplace;
	var meta = dp.mapObjects.getMeta(obj.metaId);
	var actionState = dp.actions.getCurrentActionState(obj,useBGWorkplace);
	var action = dp.actions.getActionMeta(actionState.id);
	actionState.status = 3;
	var trigger = com_nevosoft_waw_data_types_EGameTrigger.TriggerFinishAction({ id : obj.id, metaId : obj.metaId, category : meta.category, level : dp.mapObjects.getLevel(obj), actionId : actionState.id, actionType : action.type, workers : workplace.workers});
	t.gameTriggers.push(trigger);
	workplace.currentActionIndex = -1;
	if(shmuIds.length > 0) {
		com_nevosoft_waw_logic_api_MapAPI.releaseShmuFromBuilding(t,targetId,shmuIds,useBGWorkplace);
	}
};
com_nevosoft_waw_logic_api_MapAPI.applyAction = function(t,targetId,useBGWorkplace) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var obj = dp.mapObjects.getData(targetId);
	var workplace = useBGWorkplace ? obj.cBGWorkplace : obj.cWorkplace;
	var meta = dp.mapObjects.getMeta(obj.metaId);
	var finishedActions = dp.actions.getFinishedActions(obj,useBGWorkplace);
	if(finishedActions.length > 0) {
		var actionState = finishedActions[0];
		var actionMeta = dp.actions.getActionMeta(actionState.id);
		var reward = dp.actions.calculateRewards(actionState,actionMeta);
		actionState.status = 4;
		HxOverrides.remove(workplace.actionsQueue,actionState);
		workplace.currentActionIndex--;
		if(com_nevosoft_waw_data_types_meta_EActionType.inUpgradeGroup(actionMeta.type)) {
			obj.cUpgradable.level++;
			t.addCheckPoint("Obj level: " + obj.cUpgradable.level);
			if(dp.mapObjects.getLevel(obj) == 1 && meta.houseComponent != null) {
				com_nevosoft_waw_logic_api_MapAPI.spawnShmu(t,meta.houseComponent.livingWorkers,targetId,true);
				t.addCheckPoint("Add shmu");
			}
		} else if(actionMeta.type == 7) {
			obj.cUpgradable.level--;
		}
		var tags = [];
		if(meta.tagsComponent != null) {
			tags = meta.tagsComponent;
		}
		var trigger = com_nevosoft_waw_data_types_EGameTrigger.TriggerApplyAction({ id : obj.id, metaId : obj.metaId, category : meta.category, level : dp.mapObjects.getLevel(obj), actionId : actionState.id, actionType : actionMeta.type, reward : reward, tags : tags});
		t.gameTriggers.push(trigger);
		if(com_nevosoft_waw_data_types_TCost.keys(reward).length > 0) {
			var allowOverLimit = dp.meta.allowCollectRewardOverLimit(meta.id);
			com_nevosoft_waw_logic_systems_ResourcesLogic.Add(t,reward,com_nevosoft_waw_data_constants_ResourceChangeReason.EMapObject(targetId),allowOverLimit,"Reward for applying an action");
		}
		if(actionMeta.type == 2) {
			var isExplosion = false;
			var _g = 0;
			var _g1 = actionState.modificators;
			while(_g < _g1.length) {
				var m = _g1[_g];
				++_g;
				if(m.source == 7) {
					isExplosion = true;
					break;
				}
			}
			if(meta.influenceSenderComponent != null && meta.influenceSenderComponent.modificator == 6) {
				isExplosion = true;
			}
			var obj1 = obj.id;
			var obj2 = obj.metaId;
			var meta1 = meta.category;
			var trigger = dp.mapObjects.getLevel(obj);
			t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerRemoveMapObject({ id : obj1, metaId : obj2, category : meta1, level : trigger, reason : isExplosion ? "explosion" : "action"}));
			t.addCheckPoint("Obj remove: " + obj.id);
			com_nevosoft_waw_core_utils_ContainerUtils.removeObjectById(ctx.storage.currentLocation.objects,obj.id);
		}
		if(obj.cFarm != null && actionMeta.type == 3 && obj.cFarm.plantId > 0) {
			t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerHarvest({ farmId : obj.id, plantId : obj.cFarm.plantId}));
			obj.cFarm.plantId = -1;
		}
		dp.location.updateDoneActionCount(actionMeta.id);
	} else {
		throw new Error("MapAPI: no finished actions to apply!");
	}
};
com_nevosoft_waw_logic_api_MapAPI.cancelAction = function(t,targetId,useBGWorkplace) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var obj = dp.mapObjects.getData(targetId);
	var workplace = useBGWorkplace ? obj.cBGWorkplace : obj.cWorkplace;
	var actionState = dp.actions.getCurrentActionState(obj);
	if(actionState != null) {
		if(dp.actions.isActionCancellable(actionState)) {
			var actionMeta = dp.actions.getActionMeta(actionState.id);
			var meta = dp.mapObjects.getMeta(obj.metaId);
			if(actionState.status == 4) {
				throw haxe_Exception.thrown("wrong action status: applied");
			}
			if(actionState.status == 3) {
				throw haxe_Exception.thrown("wrong action status: finished");
			}
			var trigger = com_nevosoft_waw_data_types_EGameTrigger.TriggerCancelAction({ id : obj.id, actionId : actionState.id, actionType : actionMeta.type, metaId : obj.metaId, category : meta.category, level : dp.mapObjects.getLevel(obj)});
			t.gameTriggers.push(trigger);
			workplace.actionsQueue.splice(workplace.currentActionIndex,1);
			workplace.currentActionIndex = -1;
		} else {
			throw haxe_Exception.thrown("MapAPI: current action is not cancellable!");
		}
	} else {
		throw haxe_Exception.thrown("MapAPI: can not cancel null action!");
	}
};
com_nevosoft_waw_logic_api_MapAPI.assignShmuToBuilding = function(t,targetId,shmuIds,useBGWorkplace) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var obj = dp.mapObjects.getData(targetId);
	var workplace = useBGWorkplace ? obj.cBGWorkplace : obj.cWorkplace;
	var meta = dp.mapObjects.getMeta(obj.metaId);
	var _g = 0;
	while(_g < shmuIds.length) {
		var sId = shmuIds[_g];
		++_g;
		workplace.workers.push(sId);
	}
	var _g = 0;
	while(_g < shmuIds.length) {
		var sId = shmuIds[_g];
		++_g;
		var shmu = dp.mapObjects.getData(sId);
		if(shmu.cWorker.targetId != -1) {
			throw haxe_Exception.thrown("cannot assign shmu that already assigned to another building");
		}
		shmu.cWorker.targetId = targetId;
	}
	var trigger = com_nevosoft_waw_data_types_EGameTrigger.TriggerShmuAssigned({ id : obj.id, metaId : obj.metaId, category : meta.category, level : dp.mapObjects.getLevel(obj)});
	t.gameTriggers.push(trigger);
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerCheckShmuStatus);
};
com_nevosoft_waw_logic_api_MapAPI.releaseShmuFromBuilding = function(t,targetId,shmuIds,useBGWorplace) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var obj = dp.mapObjects.getData(targetId);
	var workplace = useBGWorplace ? obj.cBGWorkplace : obj.cWorkplace;
	var meta = dp.mapObjects.getMeta(obj.metaId);
	var _g = 0;
	while(_g < shmuIds.length) {
		var vId = shmuIds[_g];
		++_g;
		var shmu = dp.mapObjects.getData(vId);
		shmu.cWorker.targetId = -1;
		HxOverrides.remove(workplace.workers,vId);
	}
	var trigger = com_nevosoft_waw_data_types_EGameTrigger.TriggerShmuReleased({ id : obj.id, metaId : obj.metaId, category : meta.category, level : dp.mapObjects.getLevel(obj)});
	t.gameTriggers.push(trigger);
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerCheckShmuStatus);
};
com_nevosoft_waw_logic_api_MapAPI.unlockFreeSector = function(t,sectorId) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var sector = dp.location.getSectorById(sectorId);
	var isReadyToUnlock = dp.location.isSectorReadyToUnlock(sector);
	if(!isReadyToUnlock) {
		throw haxe_Exception.thrown("sector is locked");
	}
	com_nevosoft_waw_logic_api_MapAPI.processSectorUnlocking(t,sectorId);
};
com_nevosoft_waw_logic_api_MapAPI.buySector = function(t,sectorId) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var sector = ctx.dataProvider.location.getSectorById(sectorId);
	var cost = sector.cost;
	if(ctx.storage.currentLocation.openSectorIds.indexOf(sectorId) != -1) {
		throw haxe_Exception.thrown("sector with such id is already bought");
	}
	com_nevosoft_waw_logic_systems_ResourcesLogic.Withdraw(t,cost,com_nevosoft_waw_data_constants_ResourceChangeReason.ESectorBuy(sectorId),"sector buy");
	com_nevosoft_waw_logic_api_MapAPI.processSectorUnlocking(t,sectorId);
};
com_nevosoft_waw_logic_api_MapAPI.spawnNut = function(t,lairId) {
	var ctx = t.context;
	var meta = ctx.storage.meta;
	var dp = ctx.dataProvider;
	var limit = dp.getCurrentLevelConfig().maxNuts;
	var nutCount = ctx.dataProvider.location.getNutCount();
	if(lairId != -1) {
		var lair = dp.mapObjects.getData(lairId);
		var lairMt = dp.meta.getGameObjectMeta(lair.metaId);
		var lairComp = lair.cLair;
		var lairCompMt = lairMt.lairComponent;
		if(lairComp != null && lairCompMt != null) {
			lairComp.time = t.time + lairCompMt.period;
		}
	} else {
		var nutGenMt = dp.meta.getNutGenerators()[0];
		var rndFunc = ($_=t.randomGenerator,$bind($_,$_.next));
		var scatter = nutGenMt.scatter;
		var scatter1 = com_nevosoft_isoframework_utils_MathUtils.getRandomValue(0,scatter,rndFunc) * 2 - scatter;
		ctx.storage.currentLocation.generatorTimes["2"] = t.time + nutGenMt.period + scatter1;
	}
	if(limit > nutCount) {
		var nut = dp.mapObjects.getNutTemplate();
		nut.id = com_nevosoft_waw_logic_api_MapAPI.genObjectId(ctx.storage.currentLocation);
		com_nevosoft_waw_core_utils_ContainerUtils.addObjectWithId(ctx.storage.currentLocation.objects,nut);
		t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerNewNut({ id : nut.id, lairId : lairId}));
	}
};
com_nevosoft_waw_logic_api_MapAPI.spawnShmu = function(t,count,houseId,needFun) {
	if(needFun == null) {
		needFun = false;
	}
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var ids = [];
	var _g = 0;
	var _g1 = count;
	while(_g < _g1) {
		var i = _g++;
		var v = { id : com_nevosoft_waw_logic_api_MapAPI.genObjectId(ctx.storage.currentLocation), metaId : 0, cWorker : { targetId : -1}, isFrozen : false};
		com_nevosoft_waw_core_utils_ContainerUtils.addObjectWithId(ctx.storage.currentLocation.objects,v);
		ids.push(v.id);
	}
	if(count > 0) {
		t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerNewVassal({ ids : ids, houseId : houseId, needFun : needFun}));
		t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerCheckShmuStatus);
	}
};
com_nevosoft_waw_logic_api_MapAPI.killNut = function(t,id,spellId) {
	var ctx = t.context;
	var spell = null;
	var _g = 0;
	var _g1 = ctx.dataProvider.getMetaIndex().spells;
	while(_g < _g1.length) {
		var mSpell = _g1[_g];
		++_g;
		if(mSpell.id == spellId) {
			spell = mSpell;
		}
	}
	com_nevosoft_waw_logic_systems_ResourcesLogic.Withdraw(t,spell.cost,com_nevosoft_waw_data_constants_ResourceChangeReason.ENut(id),"kill nut spell cast");
	var nut = com_nevosoft_waw_core_utils_ContainerUtils.getObjectById(ctx.storage.currentLocation.objects,id);
	com_nevosoft_waw_core_utils_ContainerUtils.removeObjectById(ctx.storage.currentLocation.objects,id);
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerKillNut(nut.id));
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerSpell({ target : id, id : spellId}));
};
com_nevosoft_waw_logic_api_MapAPI.setNewPosition = function(t,targetId,x,y,flip) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var objMaybe = dp.mapObjects.getData(targetId);
	if(objMaybe != null) {
		var obj = objMaybe;
		var meta = dp.mapObjects.getMeta(obj.metaId);
		obj.cPosition.x = x;
		obj.cPosition.y = y;
		obj.cPosition.flip = flip;
		var trigger = com_nevosoft_waw_data_types_EGameTrigger.TriggerMoveMapObject({ id : obj.id, metaId : obj.metaId, category : meta.category, level : dp.mapObjects.getLevel(obj)});
		t.gameTriggers.push(trigger);
	}
};
com_nevosoft_waw_logic_api_MapAPI.roadRemoveUpdate = function(t,removed,updated) {
	var ctx = t.context;
	var roads = ctx.storage.currentLocation.roads;
	var removedPoss = [];
	var updatedPoss = [];
	com_nevosoft_waw_data_serialization_RoadSerializationOps.removeAndUpdateRoad(roads,removed,updated,removedPoss,updatedPoss);
	ctx.storage.currentLocation.roads = roads;
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerRoadsTransaction({ purchased : [], updated : updatedPoss, removed : removedPoss}));
};
com_nevosoft_waw_logic_api_MapAPI.roadBuyUpdate = function(t,shopItemId,purchased,updated) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var shopItem = ctx.dataProvider.getMetaIndex().gameObjects.h[shopItemId];
	var shopItemCat = dp.mapObjects.getObjShopCategory(shopItem);
	var cost = dp.mapObjects.getPlacingCost(shopItemId);
	var fullCost = com_nevosoft_waw_data_types_TCost._new(Reflect.copy(cost));
	com_nevosoft_waw_data_types_TCost.makeZeros(fullCost);
	var _g = 0;
	var _g1 = purchased.length;
	while(_g < _g1) {
		var i = _g++;
		fullCost = com_nevosoft_waw_data_types_TCost.sum(fullCost,cost);
	}
	com_nevosoft_waw_logic_systems_ResourcesLogic.Withdraw(t,fullCost,com_nevosoft_waw_data_constants_ResourceChangeReason.ERoadBuy(shopItem.id),"road buy");
	var roads = ctx.storage.currentLocation.roads;
	var purchasedPoss = [];
	var updatedPoss = [];
	com_nevosoft_waw_data_serialization_RoadSerializationOps.purchaseAndUpdateRoad(roads,purchased,updated,purchasedPoss,updatedPoss);
	ctx.storage.currentLocation.roads = roads;
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerBuyShopItem({ id : shopItemId, category : shopItemCat, cost : fullCost, actionType : shopItem.category, amount : purchased.length}));
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerRoadsTransaction({ purchased : purchasedPoss, updated : updatedPoss, removed : []}));
};
com_nevosoft_waw_logic_api_MapAPI.playWithShmu = function(t,targetId) {
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerPlayWithShmu({ id : targetId}));
};
com_nevosoft_waw_logic_api_MapAPI.playWithAnimal = function(t,targetId) {
	var ctx = t.context;
	var animal = ctx.dataProvider.mapObjects.getData(targetId);
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerPlayWithAnimal({ id : animal.metaId}));
};
com_nevosoft_waw_logic_api_MapAPI.freezeMapObject = function(t,nutId,targetId) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var mapObjects = dp.mapObjects;
	var obj = mapObjects.getData(targetId);
	var nut = mapObjects.getData(nutId);
	var objMt = mapObjects.getMeta(obj.metaId);
	var action = dp.actions.getCurrentActionState(obj);
	if(action != null) {
		if(action.time != -1) {
			action.time = t.time - action.time;
		}
		t.addCheckPoint("action time: " + action.time);
	}
	obj.isFrozen = true;
	var profileIndex = ctx.dataProvider.getProfileIndex();
	var nutContext = profileIndex.nutContext;
	if(com_nevosoft_waw_logic_api_CommonLogic.isValidNutTarget(objMt)) {
		nutContext.brokenBuildings++;
	}
	var nutConfig = ctx.dataProvider.meta.getNutConfig();
	var cNut = nut.cNut;
	if(mapObjects.getCategory(obj) == "COMMON_BUILDING") {
		cNut.timeAttackBuilding = t.time + nutConfig.attackBuildingCooldown;
	} else if(mapObjects.getCategory(obj) == "SHMU") {
		cNut.timeAttackShmu = t.time + nutConfig.attackShmuCooldown;
	} else if(mapObjects.getCategory(obj) == "ANIMAL") {
		cNut.timeAttackAnimal = t.time + nutConfig.attackAnimalCooldown;
	}
	var trigger = com_nevosoft_waw_data_types_EGameTrigger.TriggerFreezeMapObject({ id : obj.id, metaId : obj.metaId, category : dp.mapObjects.getCategory(obj), level : dp.mapObjects.getLevel(obj)});
	t.gameTriggers.push(trigger);
};
com_nevosoft_waw_logic_api_MapAPI.castFixBuildingSpell = function(t,targetId,spellId) {
	var ctx = t.context;
	var profileIndex = ctx.dataProvider.getProfileIndex();
	var nutContext = profileIndex.nutContext;
	var dp = ctx.dataProvider;
	var obj = dp.mapObjects.getData(targetId);
	if(!obj.isFrozen) {
		throw haxe_Exception.thrown("wrong state");
	}
	var spell = null;
	var _g = 0;
	var _g1 = ctx.dataProvider.getMetaIndex().spells;
	while(_g < _g1.length) {
		var mSpell = _g1[_g];
		++_g;
		if(mSpell.id == spellId) {
			spell = mSpell;
		}
	}
	com_nevosoft_waw_logic_systems_ResourcesLogic.Withdraw(t,spell.cost,com_nevosoft_waw_data_constants_ResourceChangeReason.ESpellCast(spell.id,obj.cPosition.x,obj.cPosition.y),"accelerate spell cast");
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerSpell({ target : targetId, id : spellId}));
	com_nevosoft_waw_logic_api_MapAPI.unFreezeMapObject(t,obj);
	nutContext.brokenBuildings--;
};
com_nevosoft_waw_logic_api_MapAPI.calmDownAnimal = function(t,targetId) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var obj = dp.mapObjects.getData(targetId);
	if(!obj.isFrozen) {
		throw haxe_Exception.thrown("wrong state");
	}
	com_nevosoft_waw_logic_api_MapAPI.unFreezeMapObject(t,obj);
};
com_nevosoft_waw_logic_api_MapAPI.healZombie = function(t,targetId) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var obj = dp.mapObjects.getData(targetId);
	if(!obj.isFrozen) {
		throw haxe_Exception.thrown("wrong state");
	}
	com_nevosoft_waw_logic_api_MapAPI.unFreezeMapObject(t,obj);
};
com_nevosoft_waw_logic_api_MapAPI.unFreezeMapObject = function(t,obj) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var action = dp.actions.getCurrentActionState(obj);
	obj.isFrozen = false;
	if(action != null) {
		if(action.time != -1) {
			action.time = t.time - action.time;
		}
		t.addCheckPoint("action time: " + action.time);
	}
	var trigger = com_nevosoft_waw_data_types_EGameTrigger.TriggerUnFreezeMapObject({ id : obj.id, metaId : obj.metaId, category : dp.mapObjects.getCategory(obj), level : dp.mapObjects.getLevel(obj)});
	t.gameTriggers.push(trigger);
};
com_nevosoft_waw_logic_api_MapAPI.retireTemporaryVassal = function(t,id) {
	var ctx = t.context;
	com_nevosoft_waw_core_utils_ContainerUtils.removeObjectById(ctx.storage.currentLocation.objects,id);
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerRemoveVassal({ id : id, reason : "expired"}));
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerCheckShmuStatus);
};
com_nevosoft_waw_logic_api_MapAPI.prepareMagicSpawnJob = function(t,spellId,x,y) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var spell = null;
	var _g = 0;
	var _g1 = ctx.dataProvider.getMetaIndex().spells;
	while(_g < _g1.length) {
		var mSpell = _g1[_g];
		++_g;
		if(mSpell.id == spellId) {
			spell = mSpell;
		}
	}
	if(!dp.serverResources.ResourcesAmountIsEnough(spell.cost)) {
		throw haxe_Exception.thrown("error! - map api: not enought resources to cast spell");
	}
	com_nevosoft_waw_logic_systems_ResourcesLogic.Withdraw(t,spell.cost,com_nevosoft_waw_data_constants_ResourceChangeReason.ESpellCast(spell.id,x,y),"spawn spell cast");
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerSpell({ target : 0, id : spellId}));
	var spawnPretenders = [];
	var currentLevel = dp.getCurrentLevel();
	if(spell.spawnSet == null) {
		throw haxe_Exception.thrown("empty spawn set: " + Std.string(spell) + ".id");
	}
	var _g = 0;
	var _g1 = spell.spawnSet;
	while(_g < _g1.length) {
		var sp = _g1[_g];
		++_g;
		var unlockLevel = dp.meta.getUnlockLevel(sp);
		if(unlockLevel > currentLevel) {
			continue;
		}
		spawnPretenders.push(sp);
	}
	var spawnIdsMap = new haxe_ds_IntMap();
	var count = spell.power;
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerSpellCount(count));
	var _g = 0;
	var _g1 = count;
	while(_g < _g1) {
		var i = _g++;
		var id = spawnPretenders[com_nevosoft_isoframework_utils_MathUtils.getRandomValue(0,spawnPretenders.length - 1,($_=t.randomGenerator,$bind($_,$_.next)))];
		if(spawnIdsMap.h.hasOwnProperty(id)) {
			var _g2 = id;
			var _g3 = spawnIdsMap;
			var v = _g3.h[_g2] + 1;
			_g3.h[_g2] = v;
		} else {
			spawnIdsMap.h[id] = 1;
		}
	}
	var spawnAreaRad = spell.range;
	var keys = com_nevosoft_waw_core_utils_ContainerUtils.getSortedKeys(spawnIdsMap);
	var _g = 0;
	while(_g < keys.length) {
		var key = keys[_g];
		++_g;
		com_nevosoft_waw_logic_api_MapAPI.storeSpawnJob(t,key,spawnIdsMap.h[key],x - spawnAreaRad,y - spawnAreaRad,spawnAreaRad << 1,spawnAreaRad << 1,1);
	}
};
com_nevosoft_waw_logic_api_MapAPI.prepareGarbageSpawnJobs = function(t) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var meta = ctx.storage.meta;
	ctx.storage.currentLocation.generatorTimes["1"] = t.time;
	var generator = null;
	var _g = 0;
	var _g1 = dp.meta.getGarbageGenerators();
	while(_g < _g1.length) {
		var gen = _g1[_g];
		++_g;
		if(com_nevosoft_waw_logic_api_MapAPI.canGeneratorSpawn(ctx,gen)) {
			generator = gen;
			break;
		}
	}
	if(generator == null) {
		return;
	}
	var spawnSets = [];
	var _g = 0;
	var _g1 = generator.sets;
	while(_g < _g1.length) {
		var spSet = _g1[_g];
		++_g;
		if(spSet.minLvl <= ctx.storage.currentLocation.level) {
			spawnSets.push(spSet);
		}
	}
	var openedSectorsIds = dp.location.getOpenedSectorsIds();
	var openedSectors = [];
	var openedSectorsWeights = [];
	var _g = 0;
	var _g1 = ctx.storage.map.sectorsConfig.sectors;
	while(_g < _g1.length) {
		var sector = _g1[_g];
		++_g;
		if(openedSectorsIds.indexOf(sector.id) >= 0) {
			openedSectors.push(sector);
			openedSectorsWeights.push(sector.w * sector.h);
		}
	}
	var randomGenerator = ($_=t.randomGenerator,$bind($_,$_.next));
	var set = com_nevosoft_isoframework_utils_MathUtils.randomChoice(spawnSets,randomGenerator);
	var countTotal = 0;
	var idsToSpawn = [];
	var _g = 0;
	var _g1 = set.counts.length;
	while(_g < _g1) {
		var i = _g++;
		var count = set.counts[i];
		idsToSpawn = idsToSpawn.concat(com_nevosoft_waw_logic_api_MapAPI.shuffleAndDistributeArrayToCount(set.categories[i],count,randomGenerator));
		countTotal += count;
	}
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerSpellCount(countTotal));
	var _g = 0;
	var _g1 = countTotal;
	while(_g < _g1) {
		var i = _g++;
		var id = idsToSpawn[i];
		var sector = com_nevosoft_isoframework_utils_MathUtils.randomWeightedChoice(openedSectors,openedSectorsWeights,randomGenerator);
		com_nevosoft_waw_logic_api_MapAPI.storeSpawnJob(t,id,1,sector.x,sector.y,sector.w,sector.h,0);
	}
};
com_nevosoft_waw_logic_api_MapAPI.shuffleAndDistributeArrayToCount = function(distributeFrom,count,randomGenerator) {
	var ditributeFromCopy = distributeFrom.slice(0,distributeFrom.length);
	com_nevosoft_isoframework_utils_MathUtils.shuffleArray_shuffleAndDistributeArrayToCount_T(ditributeFromCopy,ditributeFromCopy.length,randomGenerator);
	ditributeFromCopy = ditributeFromCopy.splice(0,Math.round(Math.min(ditributeFromCopy.length,count)));
	var distributeTo = [];
	var distStep = Math.round(count / ditributeFromCopy.length);
	var distIdx = 0;
	var _g = 0;
	var _g1 = count;
	while(_g < _g1) {
		var i = _g++;
		if(i == (distIdx + 1) * distStep && distIdx + 1 < ditributeFromCopy.length) {
			++distIdx;
		}
		distributeTo.push(ditributeFromCopy[distIdx]);
	}
	return distributeTo;
};
com_nevosoft_waw_logic_api_MapAPI.executeSpawnJob = function(t,id,x,y) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var job = com_nevosoft_waw_core_utils_ContainerUtils.getObjectById(ctx.storage.currentLocation.spawnJobs,id);
	var metaId = job.objectId;
	if(job.count <= 0) {
		throw haxe_Exception.thrown("error! - map api: count is 0 in spawn job with id " + id);
	}
	job.count--;
	com_nevosoft_waw_logic_api_MapAPI.spawnNatureObject(t,metaId,x,y,job.reason);
};
com_nevosoft_waw_logic_api_MapAPI.clearSpawnJob = function(t,id) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var job = com_nevosoft_waw_core_utils_ContainerUtils.getObjectById(ctx.storage.currentLocation.spawnJobs,id);
	var tmp = job.count > 0;
	com_nevosoft_waw_core_utils_ContainerUtils.removeObjectById(ctx.storage.currentLocation.spawnJobs,id);
};
com_nevosoft_waw_logic_api_MapAPI.storeSpawnJob = function(t,objectId,count,aX,aY,aW,aH,reason) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var objMeta = dp.mapObjects.getMeta(objectId);
	var w = ctx.dataProvider.mapObjects.getObjWidth(objMeta);
	var h = ctx.dataProvider.mapObjects.getObjHeight(objMeta);
	var spawnJobTemplate = { id : com_nevosoft_waw_logic_api_MapAPI.genObjectId(ctx.storage.currentLocation), objectId : objectId, objectArea : Math.floor(w * h), count : count, areaX : aX, areaY : aY, areaW : aW, areaH : aH, reason : reason};
	com_nevosoft_waw_core_utils_ContainerUtils.addObjectWithId(ctx.storage.currentLocation.spawnJobs,spawnJobTemplate);
	var checkpoint = "spawnJob:" + spawnJobTemplate.id + ":" + objectId;
	t.addCheckPoint(checkpoint);
};
com_nevosoft_waw_logic_api_MapAPI.spellProductionTime = function(t,targetId,spellId) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var obj = dp.mapObjects.getData(targetId);
	var spell = dp.meta.getSpellMeta(spellId);
	var modificator = { sourceId : spellId, source : 0, modificator : 1, strength : spell.power * 0.01};
	var reason = com_nevosoft_waw_data_constants_ResourceChangeReason.ESpellCast(spell.id,obj.cPosition.x,obj.cPosition.y);
	var additionalTriggers = [com_nevosoft_waw_data_types_EGameTrigger.TriggerSpell({ target : targetId, id : spellId})];
	com_nevosoft_waw_logic_api_MapAPI.modifyActionIfNeeded(t,obj,modificator,spell.cost,reason,additionalTriggers,"accelerate spell cast");
};
com_nevosoft_waw_logic_api_MapAPI.tntSpellApply = function(t,spellId) {
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerSpell({ target : 0, id : spellId}));
};
com_nevosoft_waw_logic_api_MapAPI.explode = function(t,objectIds) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var modificator = { sourceId : 0, source : 7, modificator : 1, strength : 1.0};
	var _g = 0;
	while(_g < objectIds.length) {
		var targetId = objectIds[_g];
		++_g;
		var maybeObj = dp.mapObjects.getData(targetId);
		if(maybeObj == null) {
			continue;
		}
		var obj = maybeObj;
		var meta = dp.mapObjects.getMeta(obj.metaId);
		if(meta.category != "GARBAGE" && meta.category != "TREE") {
			throw haxe_Exception.thrown("explode: wrong object type");
		}
		var objState = dp.mapObjects.getState(obj);
		var workers = [];
		switch(objState) {
		case 0:
			var level = dp.mapObjects.getLevel(obj);
			var upgrade = dp.actions.getUpgradeAtLevel(meta,level);
			var actionState = { status : 2, time : t.time, modificators : [modificator], id : upgrade.id};
			obj.cWorkplace.actionsQueue = [actionState];
			obj.cWorkplace.currentActionIndex = 0;
			workers = obj.cWorkplace.workers;
			break;
		case 1:
			var currentAction = dp.actions.getCurrentActionState(obj);
			currentAction.status = 2;
			currentAction.time = t.time;
			currentAction.modificators.push(modificator);
			workers = obj.cWorkplace.workers;
			break;
		case 2:
			var currentAction1 = dp.actions.getCurrentActionState(obj);
			currentAction1.modificators.push(modificator);
			workers = obj.cWorkplace.workers;
			break;
		default:
			continue;
		}
		com_nevosoft_waw_logic_api_MapAPI.finishActionAndRelease(t,targetId,workers,false);
	}
};
com_nevosoft_waw_logic_api_MapAPI.accelerateActionTimeForVideo = function(t,targetId) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var maybeObj = dp.mapObjects.getData(targetId);
	if(maybeObj == null) {
		return;
	}
	var obj = maybeObj;
	var objMeta = dp.meta.getGameObjectMeta(obj.metaId);
	var category = dp.meta.getCategoryByMetaId(obj.metaId);
	var isAnimal = category == "ANIMAL";
	var isComplexGarbage = com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged("garbage_complex",objMeta);
	var actionMeta = dp.actions.getCurrentActionMeta(obj);
	var strength = 0;
	if(actionMeta == null) {
		if(isAnimal) {
			ctx.storage.currentLocation.animalRVState.numAcc++;
			ctx.storage.currentLocation.animalRVState.lastAccTime = t.time;
		}
		if(isComplexGarbage) {
			ctx.storage.currentLocation.complexGarbageRVState.numAcc++;
			ctx.storage.currentLocation.complexGarbageRVState.lastAccTime = t.time;
		} else {
			ctx.storage.currentLocation.videoAccelerationState.accProduction++;
			ctx.storage.currentLocation.videoAccelerationState.lastAccProductionTime = t.time;
		}
		console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1201:","no active action");
	} else if(com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged("go_camp",objMeta) && !com_nevosoft_waw_data_types_meta_EActionType.inUpgradeGroup(actionMeta.type)) {
		ctx.storage.currentLocation.campRVState.numAcc++;
		ctx.storage.currentLocation.campRVState.lastAccTime = t.time;
		strength = dp.location.getCampRVSettings().modifier;
	} else {
		var isUpgrade = com_nevosoft_waw_data_types_meta_EActionType.inUpgradeGroup(actionMeta.type);
		if(isAnimal) {
			ctx.storage.currentLocation.animalRVState.numAcc++;
			ctx.storage.currentLocation.animalRVState.lastAccTime = t.time;
			strength = dp.location.getAnimalRVSettings().modifier;
		} else if(isUpgrade) {
			if(isComplexGarbage) {
				ctx.storage.currentLocation.complexGarbageRVState.numAcc++;
				ctx.storage.currentLocation.complexGarbageRVState.lastAccTime = t.time;
			} else {
				ctx.storage.currentLocation.videoAccelerationState.accUpgrade++;
				ctx.storage.currentLocation.videoAccelerationState.lastAccUpgradeTime = t.time;
			}
			strength = dp.location.getCurrentAccelerationSettings().upgradeModifier;
		} else {
			ctx.storage.currentLocation.videoAccelerationState.accProduction++;
			ctx.storage.currentLocation.videoAccelerationState.lastAccProductionTime = t.time;
			strength = dp.location.getCurrentAccelerationSettings().productionModifier;
		}
	}
	var modificator = { sourceId : 0, source : 6, modificator : 5, strength : strength};
	var cost = com_nevosoft_waw_data_types_TCost.fromIdValue(com_nevosoft_waw_data_constants_ResourceType.RESOURCE_TYPE_VIDEO_TOKEN,1);
	var reason = com_nevosoft_waw_data_constants_ResourceChangeReason.EAccelerateAction(targetId);
	com_nevosoft_waw_logic_api_MapAPI.modifyActionIfNeeded(t,obj,modificator,cost,reason,[],"accelerate for video");
};
com_nevosoft_waw_logic_api_MapAPI.accelerateAction = function(t,targetId,useBGWorkplace,customCostCalculator) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var obj = dp.mapObjects.getData(targetId);
	var currentAction = dp.actions.getCurrentActionState(obj,useBGWorkplace);
	if(obj.isFrozen) {
		throw haxe_Exception.thrown("wrong state");
	}
	if(currentAction == null) {
		throw haxe_Exception.thrown("no action to accelerate");
	}
	var action = dp.actions.getActionMeta(currentAction.id);
	var meta = ctx.dataProvider.getMetaIndex().gameObjects.h[obj.metaId];
	var timeLeft = dp.actions.calculateTimeLeft(currentAction,action,t.time);
	var skipCost = customCostCalculator != null ? customCostCalculator(timeLeft) : dp.actions.calculateAccelerateCost(action.accelerateCost,timeLeft,currentAction.modificators);
	if(skipCost > 0) {
		com_nevosoft_waw_logic_systems_ResourcesLogic.Withdraw(t,com_nevosoft_waw_data_types_TCost.fromIdValue(-3,skipCost),com_nevosoft_waw_data_constants_ResourceChangeReason.EAccelerateAction(targetId),"accelerate");
	}
	currentAction.modificators.push({ sourceId : 0, source : 3, modificator : 1, strength : 1.0});
	var trigger = com_nevosoft_waw_data_types_EGameTrigger.TriggerAccelerateAction({ id : obj.id, actionId : currentAction.id, actionType : action.type, metaId : obj.metaId, category : meta.category, level : dp.mapObjects.getLevel(obj)});
	t.gameTriggers.push(trigger);
};
com_nevosoft_waw_logic_api_MapAPI.destroyProduction = function(t,targetId) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var obj = dp.mapObjects.getData(targetId);
};
com_nevosoft_waw_logic_api_MapAPI.unlockProductionSlot = function(t,targetId) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var obj = dp.mapObjects.getData(targetId);
	var objMeta = dp.mapObjects.getMeta(obj.metaId);
	var nextSlotIfExists = dp.mapObjects.getLockedProductionSlot(obj);
	switch(nextSlotIfExists._hx_index) {
	case 0:
		var slot = nextSlotIfExists.v;
		if(dp.serverResources.AvailableAmount(-3) < slot.priceRuby) {
			throw haxe_Exception.thrown("not enough ruby");
		}
		com_nevosoft_waw_logic_systems_ResourcesLogic.Withdraw(t,com_nevosoft_waw_data_types_TCost.fromIdValue(-3,slot.priceRuby),com_nevosoft_waw_data_constants_ResourceChangeReason.EMapObject(targetId));
		obj.cWorkplace.slots++;
		break;
	case 1:
		throw haxe_Exception.thrown("all slots already bought");
	}
	var trigger = com_nevosoft_waw_data_types_EGameTrigger.TriggerMapObjectUpdated({ id : obj.id, metaId : obj.metaId, category : objMeta.category, level : dp.mapObjects.getLevel(obj)});
	t.gameTriggers.push(trigger);
};
com_nevosoft_waw_logic_api_MapAPI.unlockProductionOfferSlot = function(t,targetId) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	if(!dp.mapObjects.canUnlockProdSlotsByOffer()) {
		throw haxe_Exception.thrown("locked by offer");
	}
	var obj = dp.mapObjects.getData(targetId);
	var objMeta = dp.mapObjects.getMeta(obj.metaId);
	var maybeOfferSlots = obj.cWorkplace.offerSlots;
	if(!objMeta.workComponent.hasIapSlot) {
		throw haxe_Exception.thrown("offer slot not allowed");
	}
	if(dp.mapObjects.getProdOfferSlotsCount(obj) > 0) {
		throw haxe_Exception.thrown("already unlocked");
	}
	if(obj.cWorkplace.slots >= dp.mapObjects.getMaxProdSlots()) {
		throw haxe_Exception.thrown("max slots unlocked");
	}
	obj.cWorkplace.offerSlots = 1;
	obj.cWorkplace.slots++;
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerMapObjectUpdated({ id : obj.id, metaId : obj.metaId, category : objMeta.category, level : obj.cUpgradable.level}));
};
com_nevosoft_waw_logic_api_MapAPI.chestSpawnCheck = function(t,removedX,removedY,removedMetaId,types) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var removedObjectMeta = dp.mapObjects.getMeta(removedMetaId);
	var dataProvider = ctx.dataProvider;
	var canSpawnChest = com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged("go_chest_resp",removedObjectMeta);
	if(!canSpawnChest) {
		return;
	}
	var currTime = t.time;
	var chestGeneratorMeta = [];
	var _g = 0;
	while(_g < types.length) {
		var t1 = types[_g];
		++_g;
		chestGeneratorMeta = chestGeneratorMeta.concat(dataProvider.meta.getGeneratorsByType(t1));
	}
	var chestGeneratorMap = new haxe_ds_IntMap();
	var immediateGenerators = [];
	var maxPeriodsPassed = 0;
	var i = chestGeneratorMeta.length;
	var sourceDetected = false;
	var _g = 0;
	while(_g < chestGeneratorMeta.length) {
		var g = chestGeneratorMeta[_g];
		++_g;
		if(com_nevosoft_waw_logic_api_MapAPI.generatorHasSources(g) && g.generatorSources.indexOf(removedMetaId) >= 0) {
			sourceDetected = true;
			console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1407:","" + g.name + " source detected " + removedMetaId);
			break;
		}
	}
	while(i > 0) {
		var g = chestGeneratorMeta[i - 1];
		var spawnCheckPassed = com_nevosoft_waw_logic_api_MapAPI.generatorSourceCheckPassed(sourceDetected,g,removedMetaId) && com_nevosoft_waw_logic_api_MapAPI.canGeneratorSpawn(ctx,g);
		if(!spawnCheckPassed) {
			HxOverrides.remove(chestGeneratorMeta,g);
		} else {
			console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1421:","" + g.name + " can spawn");
			var chestGeneratorTime = dataProvider.location.getGeneratorTime(g.id);
			if(g.period == 0 || chestGeneratorTime < 0) {
				immediateGenerators.push(g);
				console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1426:","" + g.name + " is immediate");
				if(g.period == 0) {
					console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1430:","" + g.name + " has 0 period");
				} else {
					console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1434:","" + g.name + " is first time");
				}
			} else {
				var periodsPassed = dataProvider.location.getGeneratorPeriods(currTime,chestGeneratorTime,g);
				console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1440:","" + g.name + " periods " + periodsPassed);
				if(periodsPassed > 0) {
					console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1443:","" + g.name + " periods " + periodsPassed + " passed");
					chestGeneratorMap.h[periodsPassed] = g;
					console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1445:",chestGeneratorMap.h[periodsPassed]);
				}
				if(periodsPassed > maxPeriodsPassed) {
					maxPeriodsPassed = periodsPassed;
				}
			}
		}
		--i;
	}
	if(Lambda.count(chestGeneratorMap) == 0 && immediateGenerators.length == 0) {
		return;
	}
	var randomGenerator = ($_=t.randomGenerator,$bind($_,$_.next));
	var chestGeneratorSelected = null;
	if(immediateGenerators.length > 0) {
		chestGeneratorSelected = com_nevosoft_isoframework_utils_MathUtils.randomChoice(immediateGenerators,randomGenerator);
	} else {
		chestGeneratorSelected = chestGeneratorMap.h[maxPeriodsPassed];
	}
	console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1470:","pick " + chestGeneratorSelected.name);
	var spawnSets = com_nevosoft_waw_logic_api_MapAPI.getActiveSpawnSets(ctx,chestGeneratorSelected);
	var set = com_nevosoft_isoframework_utils_MathUtils.randomChoice(spawnSets,randomGenerator);
	var _g = [];
	var _g1 = 0;
	var _g2 = set.categories;
	while(_g1 < _g2.length) {
		var ids = _g2[_g1];
		++_g1;
		var _g3 = 0;
		while(_g3 < ids.length) {
			var id = ids[_g3];
			++_g3;
			_g.push(id);
		}
	}
	var flatChoiceSet = _g;
	if(flatChoiceSet.length > 0) {
		var chestMetaId = com_nevosoft_isoframework_utils_MathUtils.randomChoice(flatChoiceSet,randomGenerator);
		com_nevosoft_waw_logic_api_MapAPI.spawnNatureObject(t,chestMetaId,removedX,removedY,3);
		ctx.storage.currentLocation.generatorTimes[chestGeneratorSelected.id == null ? "null" : "" + chestGeneratorSelected.id] = currTime;
	}
};
com_nevosoft_waw_logic_api_MapAPI.vendorStart = function(t,targetId,input) {
};
com_nevosoft_waw_logic_api_MapAPI.genObjectId = function(location) {
	var current = location.lastObjectId;
	var next = current + 1;
	location.lastObjectId = next;
	return next;
};
com_nevosoft_waw_logic_api_MapAPI.modifyActionIfNeeded = function(t,target,modificator,cost,reason,additionalTriggers,comment) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	if(target.isFrozen) {
		throw haxe_Exception.thrown("wrong state");
	}
	var actionState = dp.actions.getCurrentActionState(target);
	if(actionState == null || actionState.status != 1 && actionState.status != 2) {
		throw haxe_Exception.thrown("error! - map api: no action to accelerate!");
	}
	var isAlreadyApplied = false;
	var _g = 0;
	var _g1 = actionState.modificators;
	while(_g < _g1.length) {
		var m = _g1[_g];
		++_g;
		if(modificator.source == 2 && m.sourceId == modificator.sourceId) {
			isAlreadyApplied = true;
			break;
		}
	}
	if(!isAlreadyApplied) {
		com_nevosoft_waw_logic_systems_ResourcesLogic.Withdraw(t,cost,reason,comment);
		var appliedModificator = modificator;
		if(modificator.modificator == 1) {
			var actionMeta = dp.actions.getActionMeta(actionState.id);
			var strength = Math.floor(actionMeta.time * modificator.strength);
			if(actionState.status == 2) {
				strength = Math.floor((actionMeta.time - (dp.timeProvider.time - actionState.time)) * modificator.strength);
			}
			appliedModificator = { source : modificator.source, sourceId : modificator.sourceId, modificator : 5, strength : strength};
		}
		actionState.modificators.push(appliedModificator);
		if(dp.meta.isInCurrentEvent(target.metaId)) {
			t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerActionModificatorAdded({ objId : target.id, actionId : actionState.id, modificatorType : appliedModificator.modificator, modificatorSource : appliedModificator.source}));
			var _g = 0;
			while(_g < additionalTriggers.length) {
				var trigger = additionalTriggers[_g];
				++_g;
				t.gameTriggers.push(trigger);
			}
		}
	}
};
com_nevosoft_waw_logic_api_MapAPI.processSectorUnlocking = function(t,sectorId) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var map = ctx.storage.map;
	if(ctx.storage.currentLocation.openSectorIds.indexOf(sectorId) >= 0) {
		throw haxe_Exception.thrown("already opened!");
	}
	ctx.storage.currentLocation.openSectorIds.push(sectorId);
	var sector = null;
	var _g = 0;
	var _g1 = map.sectorsConfig.sectors;
	while(_g < _g1.length) {
		var s = _g1[_g];
		++_g;
		if(s.id == sectorId) {
			sector = s;
			break;
		}
	}
	var sectorObjs = [];
	var houses = [];
	var _g = 0;
	var _g1 = dp.location.applyStructureLimit(sector.objects);
	while(_g < _g1.length) {
		var obj = _g1[_g];
		++_g;
		var oMt = ctx.dataProvider.getMetaIndex().gameObjects.h[obj.metaId];
		var nObj = dp.mapObjects.getBuildingTemplate(obj.metaId);
		nObj.id = com_nevosoft_waw_logic_api_MapAPI.genObjectId(ctx.storage.currentLocation);
		nObj.cPosition.x = obj.x;
		nObj.cPosition.y = obj.y;
		nObj.cPosition.flip = obj.flip;
		if(nObj.cUpgradable != null) {
			nObj.cUpgradable.level = dp.mapObjects.getInitialLevel(oMt);
		}
		if(oMt.workComponent != null && oMt.workComponent.freeSlots > 1) {
			nObj.cWorkplace.slots = oMt.workComponent.freeSlots;
		}
		com_nevosoft_waw_core_utils_ContainerUtils.addObjectWithId(ctx.storage.currentLocation.objects,nObj);
		com_nevosoft_waw_logic_api_CommonLogic.newMapObjectRoutines(ctx.dataProvider.getProfileIndex(),nObj,ctx.dataProvider);
		sectorObjs.push({ id : nObj.id, metaId : nObj.metaId});
		if(oMt.category == "STORAGE_COMMON") {
			var storage = ctx.dataProvider.getProfileIndex().getStorageById(oMt.id);
			if(storage != null) {
				storage.setData(nObj);
			}
		}
		if(oMt.houseComponent != null) {
			houses.push(nObj);
		}
	}
	if(ctx.storage.currentLocation.openSectorIds.length == 1) {
		com_nevosoft_waw_logic_api_MapAPI.actualizeInvisibleBuildings(t,sectorObjs);
	}
	if(sector.roads == null) {
		sector.roads = [];
	}
	var roads = ctx.storage.currentLocation.roads;
	var purchased = sector.roads;
	var purchasedPoss = [];
	com_nevosoft_waw_data_serialization_RoadSerializationOps.purchaseAndUpdateRoad(roads,purchased,[],purchasedPoss,[]);
	ctx.storage.currentLocation.roads = roads;
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerRoadsTransaction({ purchased : purchasedPoss, updated : [], removed : []}));
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerUnlockSector({ id : sectorId, sectorObjs : sectorObjs}));
	var _g = 0;
	while(_g < houses.length) {
		var h = houses[_g];
		++_g;
		if(h.cUpgradable.level == 1) {
			com_nevosoft_waw_logic_api_MapAPI.spawnShmu(t,dp.meta.getGameObjectMeta(h.metaId).houseComponent.livingWorkers,h.id);
		}
	}
};
com_nevosoft_waw_logic_api_MapAPI.actualizeInvisibleBuildings = function(t,sectorObjs) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var _g = 0;
	var _g1 = com_nevosoft_waw_core_utils_ContainerUtils.getSortedKeys(ctx.dataProvider.getMetaIndex().gameObjects);
	while(_g < _g1.length) {
		var key = _g1[_g];
		++_g;
		var obj = ctx.dataProvider.getMetaIndex().gameObjects.h[key];
		if(obj.renderComponent == null && (obj.gameEventsComponent == null || obj.gameEventsComponent.indexOf(ctx.storage.data.currentGameEventId) >= 0)) {
			var limit = obj.limitedComponent != null ? obj.limitedComponent.limit : 1;
			var current = 0;
			var _g2 = 0;
			var _g3 = ctx.storage.currentLocation.objects;
			while(_g2 < _g3.length) {
				var gameObject = _g3[_g2];
				++_g2;
				if(gameObject.metaId == obj.id) {
					++current;
				}
			}
			var needToAddCounter = limit - current;
			var _g4 = 0;
			var _g5 = needToAddCounter;
			while(_g4 < _g5) {
				var i = _g4++;
				var goTmp = dp.mapObjects.getBuildingTemplate(obj.id);
				goTmp.id = com_nevosoft_waw_logic_api_MapAPI.genObjectId(ctx.storage.currentLocation);
				if(goTmp.cUpgradable != null) {
					goTmp.cUpgradable.level = dp.mapObjects.getInitialLevel(obj);
				}
				com_nevosoft_waw_core_utils_ContainerUtils.addObjectWithId(ctx.storage.currentLocation.objects,goTmp);
				sectorObjs.push({ id : goTmp.id, metaId : goTmp.metaId});
				if(obj.category == "STORAGE_COMMON") {
					var storage = ctx.dataProvider.getProfileIndex().getStorageById(obj.id);
					if(storage != null) {
						storage.setData(goTmp);
					}
				}
			}
		}
	}
};
com_nevosoft_waw_logic_api_MapAPI.resetRVCountsIfNeeded = function(ctx,time) {
	var today = ctx.dataProvider.timeProvider.getToday(time);
	if(ctx.storage.currentLocation.videoAccelerationState.lastAccProductionTime < today && ctx.storage.currentLocation.videoAccelerationState.lastAccUpgradeTime < today) {
		ctx.storage.currentLocation.videoAccelerationState.accUpgrade = 0;
		ctx.storage.currentLocation.videoAccelerationState.accProduction = 0;
	}
	if(ctx.storage.currentLocation.purchaseResourceRVState.lastPurchasedTime < today) {
		ctx.storage.currentLocation.purchaseResourceRVState.numPurchased = 0;
	}
	if(ctx.storage.currentLocation.purchaseTownhallResourceRVState.lastPurchasedTime < today) {
		ctx.storage.currentLocation.purchaseTownhallResourceRVState.numPurchased = 0;
	}
	if(ctx.storage.currentLocation.purchaseBlockingGarbageResourceRVState.lastPurchasedTime < today) {
		ctx.storage.currentLocation.purchaseBlockingGarbageResourceRVState.numPurchased = 0;
	}
	if(ctx.storage.currentLocation.purchaseEnergyRVState.lastPurchasedTime < today) {
		ctx.storage.currentLocation.purchaseEnergyRVState.numPurchased = 0;
	}
	if(ctx.storage.currentLocation.marketRVState.lastIncTime < today) {
		ctx.storage.currentLocation.marketRVState.incReward = 0;
	}
	if(ctx.storage.currentLocation.campRVState.lastAccTime < today) {
		ctx.storage.currentLocation.campRVState.numAcc = 0;
	}
	if(ctx.storage.currentLocation.zeppelinRVState.lastChangedTime < today) {
		ctx.storage.currentLocation.zeppelinRVState.numChanged = 0;
	}
	if(ctx.storage.currentLocation.animalRVState.lastAccTime < today) {
		ctx.storage.currentLocation.animalRVState.numAcc = 0;
	}
	if(ctx.storage.currentLocation.complexGarbageRVState.lastAccTime < today) {
		ctx.storage.currentLocation.complexGarbageRVState.numAcc = 0;
	}
	if(ctx.storage.currentLocation.npcOrderSkipRVState.lastChangedTime < today) {
		ctx.storage.currentLocation.npcOrderSkipRVState.numChanged = 0;
	}
	if(ctx.storage.currentLocation.marketOrderSkipRVState.lastChangedTime < today) {
		ctx.storage.currentLocation.marketOrderSkipRVState.numChanged = 0;
	}
};
com_nevosoft_waw_logic_api_MapAPI.setupDailyBonus = function(ctx,currentTime) {
	var lastIncreaseDate = new Date(ctx.storage.data.dailyBonus.lastIncreaseTime * 1000.0);
	var currentDate = new Date(ctx.dataProvider.profile.getCurrDaiyBonusStageTimestamp(currentTime) * 1000.0);
	var nextStageDate = new Date(ctx.dataProvider.profile.getNextDailyBonusStageTimestamp(ctx.storage.data.dailyBonus.lastIncreaseTime) * 1000.0);
	var resetStageDate = new Date(ctx.dataProvider.profile.getResetDailyBonusStageTimestamp(ctx.storage.data.dailyBonus.lastIncreaseTime) * 1000.0);
	if(ctx.storage.data.dailyBonus.lastIncreaseTime == 0) {
		com_nevosoft_waw_logic_api_MapAPI.initDailyBonus(ctx,currentTime);
	} else if(ctx.dataProvider.profile.isTimeToIncreaseDailyBonusStage(currentTime)) {
		if(ctx.dataProvider.profile.isDailyBonusRewardCollected()) {
			ctx.storage.data.dailyBonus.currentStage++;
			ctx.storage.data.dailyBonus.lastIncreaseTime = ctx.dataProvider.profile.getCurrDaiyBonusStageTimestamp(currentTime);
			ctx.storage.data.dailyBonus.isCollected = false;
			if(ctx.storage.data.dailyBonus.currentStage > 5) {
				ctx.storage.data.dailyBonus.currentStage = 5;
			}
		} else {
			com_nevosoft_waw_logic_api_MapAPI.resetDailyBonus(ctx,currentTime);
		}
	} else if(ctx.dataProvider.profile.isTimeToResetDailyBonusStage(currentTime)) {
		com_nevosoft_waw_logic_api_MapAPI.resetDailyBonus(ctx,currentTime);
	}
};
com_nevosoft_waw_logic_api_MapAPI.initDailyBonus = function(ctx,currentTime) {
	ctx.storage.data.dailyBonus.lastIncreaseTime = ctx.dataProvider.profile.getCurrDaiyBonusStageTimestamp(currentTime);
	ctx.storage.data.dailyBonus.currentStage = 0;
	ctx.storage.data.dailyBonus.isCollected = true;
};
com_nevosoft_waw_logic_api_MapAPI.resetDailyBonus = function(ctx,currentTime) {
	ctx.storage.data.dailyBonus.lastIncreaseTime = ctx.dataProvider.profile.getCurrDaiyBonusStageTimestamp(currentTime);
	ctx.storage.data.dailyBonus.currentStage = 1;
	ctx.storage.data.dailyBonus.isCollected = false;
};
com_nevosoft_waw_logic_api_MapAPI.generatorHasSources = function(generator) {
	if(generator.generatorSources != null) {
		return generator.generatorSources.length > 0;
	} else {
		return false;
	}
};
com_nevosoft_waw_logic_api_MapAPI.generatorSourceCheckPassed = function(sourceDetected,generator,sourceMetaId) {
	if(!sourceDetected) {
		console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1838:","" + generator.name + " source not detected, generator has source: " + Std.string(com_nevosoft_waw_logic_api_MapAPI.generatorHasSources(generator)));
		return !com_nevosoft_waw_logic_api_MapAPI.generatorHasSources(generator);
	}
	if(com_nevosoft_waw_logic_api_MapAPI.generatorHasSources(generator) && generator.generatorSources.indexOf(sourceMetaId) >= 0) {
		console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1843:","" + generator.name + " source check passed " + sourceMetaId);
		return true;
	}
	console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1846:","" + generator.name + " source check failed " + sourceMetaId);
	return false;
};
com_nevosoft_waw_logic_api_MapAPI.canGeneratorSpawn = function(ctx,generator) {
	if(generator.gameEventsComponent != null && generator.gameEventsComponent.indexOf(ctx.storage.data.currentGameEventId) < 0) {
		console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1854:","" + generator.name + " does not belong here");
		return false;
	}
	if(generator.restrictions != null && !ctx.dataProvider.restrictions.FastCheck(generator.restrictions)) {
		console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1859:","" + generator.name + " does not pass restrictions");
		return false;
	}
	var activeSets = com_nevosoft_waw_logic_api_MapAPI.getActiveSpawnSets(ctx,generator);
	if(activeSets.length == 0) {
		console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1865:","" + generator.name + " has no active sets");
		return false;
	}
	var metaIdsToSpawn = [];
	var metaIdsSpawned = 0;
	var _g = 0;
	while(_g < activeSets.length) {
		var set = activeSets[_g];
		++_g;
		var _g1 = 0;
		var _g2 = set.categories;
		while(_g1 < _g2.length) {
			var category = _g2[_g1];
			++_g1;
			var _g3 = 0;
			while(_g3 < category.length) {
				var metaId = category[_g3];
				++_g3;
				if(metaIdsToSpawn.indexOf(metaId) < 0) {
					metaIdsToSpawn.push(metaId);
				}
			}
		}
	}
	var _g = 0;
	while(_g < metaIdsToSpawn.length) {
		var metaId = metaIdsToSpawn[_g];
		++_g;
		var count = ctx.dataProvider.location.filterMapObjects({ metaId : metaId}).length;
		console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1887:","" + count + " of " + metaId + " on map");
		metaIdsSpawned += count;
	}
	if(metaIdsToSpawn.length == 0) {
		console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1893:","" + generator.name + " has no items to spawn");
		return false;
	}
	if(metaIdsSpawned >= generator.maxCount) {
		console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1898:","" + generator.name + " has reached its limit " + metaIdsSpawned);
		return false;
	}
	return true;
};
com_nevosoft_waw_logic_api_MapAPI.getActiveSpawnSets = function(ctx,generator) {
	console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1908:","get sets for " + generator.name);
	var spawnSets = [];
	var _g = 0;
	var _g1 = generator.sets;
	while(_g < _g1.length) {
		var spSet = _g1[_g];
		++_g;
		if(ctx.dataProvider.restrictions.FastCheck(spSet.restrictions)) {
			spawnSets.push(spSet);
		} else {
			console.log("src/com/nevosoft/waw/logic/api/MapAPI.hx:1920:","" + Std.string(spSet.restrictions) + " not satisfied");
		}
	}
	return spawnSets;
};
com_nevosoft_waw_logic_api_MapAPI.spawnNatureObject = function(t,metaId,x,y,reason) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var tmp = dp.mapObjects.getNatureObjectTemplate(metaId);
	var meta = dp.mapObjects.getMeta(metaId);
	tmp.id = com_nevosoft_waw_logic_api_MapAPI.genObjectId(ctx.storage.currentLocation);
	tmp.cPosition.x = x;
	tmp.cPosition.y = y;
	var tmp1 = t.randomGenerator.next();
	tmp.cPosition.flip = tmp1 > 0.49;
	com_nevosoft_waw_core_utils_ContainerUtils.addObjectWithId(ctx.storage.currentLocation.objects,tmp);
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerNewMapObject({ id : tmp.id, metaId : tmp.metaId, category : meta.category, level : 0, reason : reason, x : x, y : y}));
};
var com_nevosoft_waw_logic_api_QuestsAPI = function() { };
com_nevosoft_waw_logic_api_QuestsAPI.__name__ = true;
com_nevosoft_waw_logic_api_QuestsAPI.activate = function(t,id) {
	var ctx = t.context;
	var meta = ctx.dataProvider.getMetaIndex().quests.h[id];
	var questState = null;
	if(com_nevosoft_waw_core_utils_ContainerUtils.getIndexOf(ctx.storage.data.quests,id) < 0) {
		var _g = [];
		var _g1 = 0;
		var _g2 = meta.stages;
		while(_g1 < _g2.length) {
			var stage = _g2[_g1];
			++_g1;
			_g.push(0);
		}
		questState = { id : id, stages : _g, opened : false, receiveTime : t.time, receiveGameTime : t.gameTime, deactivateTime : 0, isActive : true};
		com_nevosoft_waw_core_utils_ContainerUtils.addObjectWithId(ctx.storage.data.quests,questState);
	} else {
		questState = com_nevosoft_waw_core_utils_ContainerUtils.getObjectById(ctx.storage.data.quests,id);
		questState.receiveTime = t.time;
	}
	questState.isActive = true;
	ctx.questsSystem.activate(ctx,questState);
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerActivateQuest({ id : id, taskState : questState}));
};
com_nevosoft_waw_logic_api_QuestsAPI.deactivate = function(t,id) {
	var ctx = t.context;
	var meta = ctx.dataProvider.getMetaIndex().quests.h[id];
	if(ctx.dataProvider.quests.isComplete(id)) {
		com_nevosoft_waw_logic_systems_ResourcesLogic.Add(t,meta.rewards,com_nevosoft_waw_data_constants_ResourceChangeReason.EQuestReward(id));
	}
	ctx.questsSystem.deactivate(t,id);
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerDeactivateQuest({ id : id}));
	var questState = com_nevosoft_waw_core_utils_ContainerUtils.getObjectById(ctx.storage.data.quests,id);
	questState.deactivateTime = t.time;
	questState.isActive = false;
	if(meta.oneTime) {
		com_nevosoft_waw_logic_api_QuestsAPI.close(t,id);
	}
};
com_nevosoft_waw_logic_api_QuestsAPI.open = function(t,id) {
	var ctx = t.context;
	var q = com_nevosoft_waw_core_utils_ContainerUtils.getObjectById(ctx.storage.data.quests,id);
	q.opened = true;
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerOpenQuest({ id : id}));
};
com_nevosoft_waw_logic_api_QuestsAPI.close = function(t,id) {
	var ctx = t.context;
	com_nevosoft_waw_core_utils_ContainerUtils.removeObjectById(ctx.storage.data.quests,id);
	ctx.storage.data.completeQuestIds.push(id);
	var itemsUnlock = ctx.dataProvider.shop.getUnlockedItemsQuestComplete(id);
	if(itemsUnlock != null) {
		var _g = 0;
		while(_g < itemsUnlock.length) {
			var unlock = itemsUnlock[_g];
			++_g;
			ctx.storage.data.newShopItems.push(unlock);
		}
	}
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerCloseQuest({ id : id}));
};
var com_nevosoft_waw_logic_api_TutorAPI = function() { };
com_nevosoft_waw_logic_api_TutorAPI.__name__ = true;
com_nevosoft_waw_logic_api_TutorAPI.processAction = function(t,id,questId) {
	var ctx = t.context;
	var dataProvider = ctx.dataProvider;
	if(questId != null) {
		id += questId;
	}
	if(id > 0) {
		if(ctx.storage.data.tutorial.doneActions.indexOf(id) >= 0) {
			throw haxe_Exception.thrown("this action already done " + Std.string(t.command));
		}
		ctx.storage.data.tutorial.doneActions.push(id);
	}
	switch(id) {
	case -1:
		var marketState = { id : 1, initTime : 1, initGameTime : 0, power : 0, usedGroups : [], usedObjectIds : [], cooldown : { }, slots : [], reward : { }, genCounter : 0, shown : false, skips : 0};
		com_nevosoft_waw_logic_api_TutorAPI.replaceMarketState(ctx.storage.currentLocation.pointsOfSaleStates,marketState);
		break;
	case 12:
		com_nevosoft_waw_logic_api_MapAPI.spawnNut(t,-1);
		break;
	case 1001:
		com_nevosoft_waw_logic_api_TutorAPI.initHutStates(t);
		com_nevosoft_waw_logic_api_TutorAPI.initPlants(t,252,159);
		break;
	case 1002:
		com_nevosoft_waw_logic_api_TutorAPI.generateMarketSlot(89,1,{ "-1" : 20, "-4" : 20},null,t);
		com_nevosoft_waw_logic_api_TutorAPI.fillInAllEmptyMarketSlots(t);
		break;
	case 1006:
		com_nevosoft_waw_logic_api_TutorAPI.generateMarketSlot(5,1,{ "-1" : 19, "-4" : 14},"TutorMarketSlot/elixir",t);
		break;
	case 1007:
		com_nevosoft_waw_logic_api_TutorAPI.generateMarketSlot(36,1,{ "-1" : 7, "-4" : 8},"TutorMarketSlot/tools",t);
		break;
	case 1009:
		com_nevosoft_waw_logic_api_TutorAPI.generateMarketSlot(255,2,{ "-1" : 7, "-4" : 7},"TutorMarketSlot/flax",t);
		break;
	case 1010:
		com_nevosoft_waw_logic_api_TutorAPI.generateMarketSlot(89,1,{ "-1" : 17, "-4" : 21},"TutorMarketSlot/firewood",t);
		break;
	case 1011:
		com_nevosoft_waw_logic_api_TutorAPI.fillInAllEmptyMarketSlots(t);
		break;
	case 1012:
		com_nevosoft_waw_logic_api_TutorAPI.setFreeAccelerateModificatorForFarms(t);
		break;
	case 1013:
		com_nevosoft_waw_logic_api_TutorAPI.setFreeAccelerateModificatorForBuilding(t,106);
		break;
	case 1014:
		com_nevosoft_waw_logic_api_TutorAPI.placeAchievementHouse(t);
		break;
	case 1015:
		com_nevosoft_waw_logic_api_TutorAPI.placeGarbage(t,420,com_nevosoft_waw_logic_api_TutorAPI.GARBAGE_CPOSITIONS);
		break;
	case 1016:
		com_nevosoft_waw_logic_api_TutorAPI.setFreeAccelerateModificatorForBuildingProductions(t,94);
		break;
	case 1017:
		com_nevosoft_waw_logic_api_TutorAPI.setFreeAccelerateModificatorForAnimals(t,171);
		break;
	case 1018:
		com_nevosoft_waw_logic_api_TutorAPI.setFreeAccelerateModificatorForBuildingProductions(t,106);
		break;
	case 1019:
		com_nevosoft_waw_logic_api_TutorAPI.resetGold(t,47);
		break;
	case 1021:
		com_nevosoft_waw_logic_api_TutorAPI.resetGold(t,60);
		break;
	case 1032:
		var i = id;
		if(i == 1008 + questId) {
			com_nevosoft_waw_logic_api_QuestsAPI.activate(t,questId);
		} else {
			com_nevosoft_waw_logic_api_TutorAPI.placeGarbage(t,682,com_nevosoft_waw_logic_api_TutorAPI.EVENT_6_THORN_CPOSITIONS);
		}
		break;
	case 1033:
		com_nevosoft_waw_logic_api_TutorAPI.initPlants(t,691,606);
		break;
	case 1034:
		com_nevosoft_waw_logic_api_TutorAPI.accelerateEnergyProduction(t);
		break;
	default:
		var i = id;
		if(i == 1008 + questId) {
			com_nevosoft_waw_logic_api_QuestsAPI.activate(t,questId);
		}
	}
};
com_nevosoft_waw_logic_api_TutorAPI.buildTutorDailyQuest = function(t,posState) {
	var ctx = t.context;
	var dataProvider = ctx.dataProvider;
	if(posState.slots.length == 9) {
		posState.slots[0].rawData[0] = 61;
		posState.slots[0].rawData[1] = 1;
		posState.slots[0].rawData[2] = 8;
		posState.slots[1].rawData[0] = 66;
		posState.slots[1].rawData[1] = 1;
		posState.slots[1].rawData[2] = 458;
		posState.slots[2].rawData[0] = 12;
		posState.slots[2].rawData[1] = 1;
		posState.slots[2].rawData[2] = 36;
		posState.slots[3].rawData[0] = 66;
		posState.slots[3].rawData[1] = 4;
		posState.slots[3].rawData[2] = 450;
		posState.slots[4].rawData[0] = 66;
		posState.slots[4].rawData[1] = 2;
		posState.slots[4].rawData[2] = 47;
		posState.slots[5].rawData[0] = 3;
		posState.slots[5].rawData[1] = 1;
		posState.slots[5].rawData[2] = -1;
		posState.slots[6].rawData[0] = 66;
		posState.slots[6].rawData[1] = 5;
		posState.slots[6].rawData[2] = 71;
		posState.slots[7].rawData[0] = 66;
		posState.slots[7].rawData[1] = 2;
		posState.slots[7].rawData[2] = 252;
		posState.slots[8].rawData[0] = 66;
		posState.slots[8].rawData[1] = 1;
		posState.slots[8].rawData[2] = 177;
		return true;
	}
	return false;
};
com_nevosoft_waw_logic_api_TutorAPI.buildTutorCampSlotsRewards = function(t,posState,regenSlots) {
	if(regenSlots == null) {
		regenSlots = false;
	}
	var ctx = t.context;
	var dataProvider = ctx.dataProvider;
	var genCounter = dataProvider.actionCounter(11);
	if(regenSlots) {
		--genCounter;
	}
	if(genCounter == 0) {
		posState.slots[0].reward = com_nevosoft_waw_data_types_TCost.fromIdValue(426,1);
		posState.slots[1].reward = com_nevosoft_waw_data_types_TCost.fromIdValue(427,1);
		posState.slots[2].reward = com_nevosoft_waw_data_types_TCost.fromIdValue(-1,286);
	} else if(genCounter == 1) {
		posState.slots[0].reward = com_nevosoft_waw_data_types_TCost.fromIdValue(206,1);
		posState.slots[1].reward = com_nevosoft_waw_data_types_TCost.fromIdValue(-1,324);
		posState.slots[2].reward = com_nevosoft_waw_data_types_TCost.fromIdValue(207,1);
	} else if(genCounter == 2) {
		posState.slots[0].reward = com_nevosoft_waw_data_types_TCost.fromIdValue(207,1);
		posState.slots[1].reward = com_nevosoft_waw_data_types_TCost.fromIdValue(425,1);
		posState.slots[2].reward = com_nevosoft_waw_data_types_TCost.fromIdValue(206,1);
	}
	posState.genCounter = genCounter;
};
com_nevosoft_waw_logic_api_TutorAPI.buildTutorCampSlotsOrders = function(t,posState) {
	var ctx = t.context;
	var dataProvider = ctx.dataProvider;
	var genCounter = dataProvider.actionCounter(11);
	if(genCounter == 0) {
		posState.slots[0].rawData[0] = 5;
		posState.slots[0].rawData[1] = 2;
		posState.slots[1].rawData[0] = 36;
		posState.slots[1].rawData[1] = 3;
		posState.slots[2].rawData[0] = 122;
		posState.slots[2].rawData[1] = 1;
	}
};
com_nevosoft_waw_logic_api_TutorAPI.tutorCountAction = function(t,id,counter) {
	var ctx = t.context;
	var dataProvider = ctx.dataProvider;
	if(id >= 0) {
		ctx.storage.data.tutorial.actionCounters[id] = counter;
	}
};
com_nevosoft_waw_logic_api_TutorAPI.setCheckpoint = function(t,id) {
	var ctx = t.context;
	if(id != ctx.storage.data.tutorial.checkpoint + 1) {
		throw haxe_Exception.thrown("wrong checkpoint! current " + ctx.storage.data.tutorial.checkpoint + ", next " + id);
	}
	ctx.storage.data.tutorial.checkpoint = id;
};
com_nevosoft_waw_logic_api_TutorAPI.skipTutor = function(t) {
	var ctx = t.context;
	var completeCheckpoint = 13;
	if(ctx.storage.data.tutorial.checkpoint < completeCheckpoint) {
		ctx.storage.data.tutorial.checkpoint = completeCheckpoint;
	}
};
com_nevosoft_waw_logic_api_TutorAPI.setFreeAccelerateModificatorForFarms = function(t) {
	var ctx = t.context;
	var dataProvider = ctx.dataProvider;
	var farmCells = dataProvider.location.filterMapObjects({ category : "FARM_CELL"});
	var _g = 0;
	while(_g < farmCells.length) {
		var farm = farmCells[_g];
		++_g;
		var currentAction = dataProvider.actions.getCurrentActionState(farm);
		if(currentAction != null) {
			currentAction.modificators.push({ sourceId : 0, source : 4, modificator : 1, strength : 1.0});
			currentAction.modificators.push({ sourceId : 0, source : 4, modificator : 4, strength : 1.0});
		}
	}
};
com_nevosoft_waw_logic_api_TutorAPI.setFreeAccelerateModificatorForBuilding = function(t,metaId) {
	var ctx = t.context;
	var dataProvider = ctx.dataProvider;
	var id = dataProvider.location.filterMapObjects({ metaId : metaId})[0].id;
	var building = dataProvider.mapObjects.getData(id);
	var currentAction = dataProvider.actions.getCurrentActionState(building);
	if(currentAction != null) {
		currentAction.modificators.push({ sourceId : 0, source : 4, modificator : 4, strength : 1.0});
	}
};
com_nevosoft_waw_logic_api_TutorAPI.setFreeAccelerateModificatorForBuildingProductions = function(t,metaId) {
	var ctx = t.context;
	var dataProvider = ctx.dataProvider;
	var id = dataProvider.location.filterMapObjects({ metaId : metaId})[0].id;
	var building = dataProvider.mapObjects.getData(id);
	var actions = dataProvider.actions.getProductionAllStatus(building);
	var _g = 0;
	while(_g < actions.length) {
		var currentAction = actions[_g];
		++_g;
		if(currentAction != null) {
			currentAction.modificators.push({ sourceId : 0, source : 4, modificator : 4, strength : 1.0});
		}
	}
};
com_nevosoft_waw_logic_api_TutorAPI.setFreeAccelerateModificatorForAnimals = function(t,metaId) {
	var ctx = t.context;
	var dataProvider = ctx.dataProvider;
	var _g = 0;
	var _g1 = dataProvider.location.filterMapObjects({ metaId : metaId});
	while(_g < _g1.length) {
		var mo = _g1[_g];
		++_g;
		var animal = dataProvider.mapObjects.getData(mo.id);
		var currentAction = dataProvider.actions.getCurrentActionState(animal);
		if(currentAction != null) {
			currentAction.modificators.push({ sourceId : 0, source : 4, modificator : 4, strength : 1.0});
		}
	}
};
com_nevosoft_waw_logic_api_TutorAPI.accelerateManaProducing = function(t) {
	var ctx = t.context;
	var dataProvider = ctx.dataProvider;
	var houses = dataProvider.location.filterMapObjects({ metaId : 156, levelGeThan : 1});
	var _g = 0;
	while(_g < houses.length) {
		var house = houses[_g];
		++_g;
		var currentActionState = dataProvider.actions.getCurrentActionState(house);
		if(currentActionState != null) {
			var actionMeta = dataProvider.actions.getCurrentActionMeta(house);
			if(actionMeta.type == 3) {
				currentActionState.modificators.push({ sourceId : 0, source : 4, modificator : 1, strength : 1.0});
				currentActionState.modificators.push({ sourceId : 0, source : 4, modificator : 4, strength : 1.0});
			}
		}
	}
};
com_nevosoft_waw_logic_api_TutorAPI.accelerateEnergyProduction = function(t) {
	var ctx = t.context;
	var dataProvider = ctx.dataProvider;
	var energyPot = dataProvider.location.filterMapObjects({ metaId : 715})[0];
	var currentAction = dataProvider.actions.getCurrentActionState(energyPot);
	if(currentAction != null) {
		currentAction.modificators.push({ sourceId : 0, source : 4, modificator : 1, strength : 1.0});
		currentAction.modificators.push({ sourceId : 0, source : 4, modificator : 4, strength : 1.0});
	}
};
com_nevosoft_waw_logic_api_TutorAPI.fillInAllEmptyMarketSlots = function(t) {
	var ctx = t.context;
	var autoOrdersSystem = ctx.autoOrdersSystem;
	var dataProvider = ctx.dataProvider;
	var posState = dataProvider.pointsOfSale.getState(1);
	if(posState == null) {
		throw haxe_Exception.thrown("no posState while trying to fillInAllEmptySlots");
	}
	var posContext = autoOrdersSystem.getContext(t,posState);
	com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.fillInEmptySlots(t,posContext);
};
com_nevosoft_waw_logic_api_TutorAPI.initHutStates = function(t) {
	var hutMetaId = 156;
	var context = t.context;
	var hutMeta = context.dataProvider.meta.getGameObjectMeta(hutMetaId);
	var _g = 0;
	var _g1 = context.dataProvider.location.filterMapObjects({ metaId : hutMetaId});
	while(_g < _g1.length) {
		var object = _g1[_g];
		++_g;
		if(object.cPosition.x == 2 && object.cPosition.y == 18) {
			continue;
		}
		var meta = context.dataProvider.mapObjects.getMeta(hutMetaId);
		object.cUpgradable.level = 1;
		t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerMapObjectUpdated({ id : object.id, metaId : object.metaId, category : meta.category, level : object.cUpgradable.level}));
		com_nevosoft_waw_logic_api_MapAPI.spawnShmu(t,hutMeta.houseComponent.livingWorkers,object.id);
	}
};
com_nevosoft_waw_logic_api_TutorAPI.initPlants = function(t,plantId,farmCellId) {
	var context = t.context;
	var _g = 0;
	var _g1 = context.dataProvider.location.filterMapObjects({ metaId : farmCellId});
	while(_g < _g1.length) {
		var object = _g1[_g];
		++_g;
		var action = context.dataProvider.mapObjects.getPlacingAction(plantId);
		object.cFarm.plantId = plantId;
		object.cWorkplace.actionsQueue.push({ id : action.id, time : -1, modificators : [], status : 3});
		t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerPlantPlaced({ farmId : object.id, plantId : plantId}));
	}
};
com_nevosoft_waw_logic_api_TutorAPI.generateMarketSlot = function(res_id,amount,reward,name,t) {
	var marketState = { id : 1, initTime : 1, initGameTime : 0, power : 0, usedGroups : [], usedObjectIds : [], cooldown : { }, slots : [{ id : 1, rawData : [res_id,amount], power : 1, reward : reward, name : name}], reward : { }, genCounter : 0, shown : false, skips : 0};
	var ctx = t.context;
	com_nevosoft_waw_logic_api_TutorAPI.replaceMarketState(ctx.storage.currentLocation.pointsOfSaleStates,marketState);
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerPointOfSaleSlotState({ type : 1, slotInd : 0}));
};
com_nevosoft_waw_logic_api_TutorAPI.placeGarbage = function(t,metaId,pos) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var meta = dp.mapObjects.getMeta(metaId);
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerSpellCount(pos.length));
	var _g = 0;
	while(_g < pos.length) {
		var p = pos[_g];
		++_g;
		var tmp = dp.mapObjects.getNatureObjectTemplate(metaId);
		tmp.id = com_nevosoft_waw_logic_api_MapAPI.genObjectId(ctx.storage.currentLocation);
		tmp.cPosition.x = p.x;
		tmp.cPosition.y = p.y;
		tmp.cPosition.flip = false;
		com_nevosoft_waw_core_utils_ContainerUtils.addObjectWithId(ctx.storage.currentLocation.objects,tmp);
		t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerNewMapObject({ id : tmp.id, metaId : tmp.metaId, category : meta.category, level : 0, reason : 2, x : tmp.cPosition.x, y : tmp.cPosition.y}));
	}
};
com_nevosoft_waw_logic_api_TutorAPI.placeAchievementHouse = function(t) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var meta = dp.mapObjects.getMeta(288);
	var tmp = dp.mapObjects.getBuildingTemplate(288);
	tmp.id = com_nevosoft_waw_logic_api_MapAPI.genObjectId(ctx.storage.currentLocation);
	tmp.cPosition.x = 5;
	tmp.cPosition.y = 30;
	tmp.cPosition.flip = false;
	com_nevosoft_waw_core_utils_ContainerUtils.addObjectWithId(ctx.storage.currentLocation.objects,tmp);
	var triggerParams = { id : tmp.id, metaId : tmp.metaId, category : meta.category, level : 0, reason : 2, x : tmp.cPosition.x, y : tmp.cPosition.y};
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerNewMapObject(triggerParams));
};
com_nevosoft_waw_logic_api_TutorAPI.replaceMarketState = function(statesContainer,marketState) {
	var replaced = com_nevosoft_waw_core_utils_ContainerUtils.setObject(statesContainer,marketState);
	if(replaced == null) {
		statesContainer.push(marketState);
	}
};
com_nevosoft_waw_logic_api_TutorAPI.resetGold = function(t,value) {
	var ctx = t.context;
	var dataProvider = ctx.dataProvider;
	var resource = com_nevosoft_waw_data_types_TCost.fromIdValue(-1,value);
	var missingResources = dataProvider.clientResources.GetInsufficientResources(resource);
	if(!com_nevosoft_waw_data_types_TCost.isEmpty(missingResources)) {
		com_nevosoft_waw_logic_systems_ResourcesLogic.Add(t,missingResources,com_nevosoft_waw_data_constants_ResourceChangeReason.ESilent);
	}
};
var com_nevosoft_waw_logic_systems_ActionDrop = function() {
};
com_nevosoft_waw_logic_systems_ActionDrop.__name__ = true;
com_nevosoft_waw_logic_systems_ActionDrop.prototype = {
	process: function(t) {
		var _g = 0;
		var _g1 = t.gameTriggers;
		while(_g < _g1.length) {
			var trigger = _g1[_g];
			++_g;
			this.processTrigger(t,trigger);
		}
	}
	,init: function(ctx) {
		this.packs = [];
		var _g = 0;
		var _g1 = ctx.storage.meta.drop;
		while(_g < _g1.length) {
			var dp = _g1[_g];
			++_g;
			if(dp.gameEventsComponent == null || dp.gameEventsComponent.indexOf(ctx.storage.data.currentGameEventId) >= 0) {
				this.packs.push(new com_nevosoft_waw_logic_systems_drop_DropPack(dp));
			}
		}
	}
	,processTrigger: function(t,trigger) {
		var randomProvider = ($_=t.randomGenerator,$bind($_,$_.next));
		var _g = 0;
		var _g1 = this.packs;
		while(_g < _g1.length) {
			var pack = _g1[_g];
			++_g;
			if(!t.context.restrictions.FastCheck(pack.data.restrictions)) {
				continue;
			}
			if(this.isPackMatchTrigger(pack,trigger)) {
				this.processPack(t,pack);
			}
		}
	}
	,hintIndexing: function(ctx,dp) {
		var _g = 0;
		var _g1 = dp.elements;
		while(_g < _g1.length) {
			var el = _g1[_g];
			++_g;
			if(!ctx.dataProvider.getMetaIndex().dropToCondition.h.hasOwnProperty(el.resourceId)) {
				ctx.dataProvider.getMetaIndex().dropToCondition.h[el.resourceId] = [];
			}
			var conditions = ctx.dataProvider.getMetaIndex().dropToCondition.h[el.resourceId];
			conditions = conditions.concat(this.packs[this.packs.length - 1].conditions);
			ctx.dataProvider.getMetaIndex().dropToCondition.h[el.resourceId] = conditions;
		}
	}
	,isPackMatchTrigger: function(pack,trigger) {
		var _g = 0;
		var _g1 = pack.listeners;
		while(_g < _g1.length) {
			var listener = _g1[_g];
			++_g;
			if(listener(trigger)) {
				return true;
			}
		}
		return false;
	}
	,processPack: function(t,pack) {
		var reward = new com_nevosoft_waw_logic_systems_rewardChoice_RewardStrategyPicker(t.context.dataProvider,($_=t.randomGenerator,$bind($_,$_.next))).forDropPack(pack);
		if(com_nevosoft_waw_data_types_TCost.keys(reward).length > 0) {
			var changeReason = com_nevosoft_waw_data_constants_ResourceChangeReason.EActionDrop(pack.data.id);
			com_nevosoft_waw_logic_systems_ResourcesLogic.Add(t,reward,changeReason,true);
		}
	}
	,__class__: com_nevosoft_waw_logic_systems_ActionDrop
};
var com_nevosoft_waw_logic_systems_AutoOrdersSystem = function(posFactory) {
	this.posFactory = posFactory;
	this.posRegister = new haxe_ds_IntMap();
	this.registerPointOfSales(1);
	this.registerPointOfSales(2);
	this.registerPointOfSales(3);
	this.registerPointOfSales(4);
	var _g = 0;
	var _g1 = posFactory.getOrdersHostsIds();
	while(_g < _g1.length) {
		var hostId = _g1[_g];
		++_g;
		this.registerPointOfSales(hostId);
	}
};
com_nevosoft_waw_logic_systems_AutoOrdersSystem.__name__ = true;
com_nevosoft_waw_logic_systems_AutoOrdersSystem.prototype = {
	registerPointOfSales: function(id) {
		var this1 = this.posRegister;
		var value = this.posFactory.getConfig(id);
		this1.h[id] = value;
	}
	,isActive: function(id) {
		return this.posRegister.h.hasOwnProperty(id);
	}
	,createPOSState: function(context,id,time) {
		var config = this.posRegister.h[id];
		var slotsCount = config.slotsCountProvider.getSlotsCount(context);
		if(slotsCount == 0) {
			throw haxe_Exception.thrown("slotsCount for pointOfSale id=" + id + " must be positive");
		}
		var tmp = context.dataProvider.getGameTime();
		var _g = [];
		var _g1 = 0;
		var _g2 = slotsCount;
		while(_g1 < _g2) {
			var i = _g1++;
			_g.push(null);
		}
		return { id : id, initTime : time, initGameTime : tmp, power : 0, usedGroups : [], usedObjectIds : [], cooldown : { }, slots : _g, reward : { }, genCounter : 0, shown : false, skips : 0};
	}
	,getContext: function(t,posState) {
		return this.posFactory.getContext(t,posState);
	}
	,getConfig: function(id) {
		return this.posRegister.h[id];
	}
	,generateTotalPower: function(context) {
		var config = this.getConfig(context.posState.id);
		var powerGenerator = config.totalPowerGenerator;
		context.posState.power = powerGenerator.generate(context);
	}
	,generateOrdersForEmptySlots: function(context) {
		var posState = context.posState;
		var config = this.getConfig(posState.id);
		if(config == null) {
			throw haxe_Exception.thrown("no config: " + Std.string(posState));
		}
		var _g = [];
		var _g1 = 0;
		var _g2 = posState.slots.length;
		while(_g1 < _g2) {
			var i = _g1++;
			if(context.posState.slots[i] == null) {
				_g.push(i);
			}
		}
		var emptySlotIndexes = _g;
		if(emptySlotIndexes.length == 0) {
			return [];
		}
		var powerDistributor = config.totalPowerDistributor;
		var emptySlotsPower = powerDistributor.distribute(context);
		var orderGenerator = config.orderGenerator;
		orderGenerator.bindContext(context);
		var result = [];
		var _g = 0;
		var _g1 = emptySlotIndexes.length;
		while(_g < _g1) {
			var ii = _g++;
			var i = emptySlotIndexes[ii];
			var slotId = i + 1;
			var order = orderGenerator.generate(slotId,emptySlotsPower[ii]);
			this.applyRVSettings(context,order);
			posState.slots[i] = order;
			result.push(i);
		}
		orderGenerator.unBindContext();
		return result;
	}
	,generateTotalReward: function(context) {
		var posState = context.posState;
		var config = this.getConfig(posState.id);
		var _g = config.totalRewardGenerator;
		if(_g._hx_index == 0) {
			var generator = _g.v;
			posState.reward = generator.generate(context,posState.power);
		}
	}
	,applyRVSettings: function(context,order) {
		if(context.posState.id == 1 && context.dataProvider.location.getMarketRVState().increased) {
			var _g = 0;
			var _g1 = com_nevosoft_waw_data_types_TCost.keys(order.reward);
			while(_g < _g1.length) {
				var rId = _g1[_g];
				++_g;
				if(rId == -1) {
					var this1 = order.reward;
					var this2 = order.reward;
					var value = Math.floor((com_nevosoft_waw_data_types_TCost.hasKey(this2,rId) ? Reflect.field(this2,rId == null ? "null" : "" + rId) : 0) * context.dataProvider.location.getMarketRVSettings().modifier);
					this1[rId == null ? "null" : "" + rId] = value;
				}
			}
		}
	}
	,__class__: com_nevosoft_waw_logic_systems_AutoOrdersSystem
};
var com_nevosoft_waw_logic_systems_Quests = function() {
	this.toCleanUp = [];
	this.firstTransactionHandled = false;
};
com_nevosoft_waw_logic_systems_Quests.__name__ = true;
com_nevosoft_waw_logic_systems_Quests.prototype = {
	init: function(ctx) {
		ctx.storage.data.quests.sort(com_nevosoft_waw_core_utils_ContainerUtils.sortPred);
		ctx.storage.data.achievements.sort(com_nevosoft_waw_core_utils_ContainerUtils.sortPred);
		var _g = 0;
		var _g1 = ctx.storage.data.quests;
		while(_g < _g1.length) {
			var q = _g1[_g];
			++_g;
			if(ctx.dataProvider.quests.isInCurrentEvent(q.id) && q.isActive) {
				var qMeta = ctx.dataProvider.getMetaIndex().quests.h[q.id];
				this.ensurePrevArcQuestsClosed(ctx,q.id);
				this._addQuestEntity(ctx,new com_nevosoft_waw_logic_systems_quests_QuestEntity({ data : q, meta : qMeta},ctx.dataProvider));
			}
		}
		var ids_h = { };
		var _g = 0;
		var _g1 = ctx.storage.data.achievements;
		while(_g < _g1.length) {
			var ach = _g1[_g];
			++_g;
			if(ctx.dataProvider.achievements.isInCurrentEvent(ach.id)) {
				this._addAchievementEntity(ctx,new com_nevosoft_waw_logic_systems_quests_AchievementEntity({ data : ach, meta : ctx.dataProvider.getMetaIndex().achievements.h[ach.id]},ctx.dataProvider));
				ids_h[ach.id] = 1;
			}
		}
		var achievementStates = [];
		var achMeta = ctx.dataProvider.getMetaIndex().achievements.iterator();
		while(achMeta.hasNext()) {
			var achMeta1 = achMeta.next();
			if(ctx.dataProvider.achievements.isInCurrentEvent(achMeta1.id)) {
				if(!ids_h.hasOwnProperty(achMeta1.id)) {
					var ach = { id : achMeta1.id, counter : 0, lastRewardedStage : -1, rewardTime : 0, lastGPSIncrement : 0};
					achievementStates.push(ach);
					this._addAchievementEntity(ctx,new com_nevosoft_waw_logic_systems_quests_AchievementEntity({ data : ach, meta : achMeta1},ctx.dataProvider));
				}
			}
		}
		achievementStates.sort(com_nevosoft_waw_core_utils_ContainerUtils.sortPred);
		var _g = 0;
		while(_g < achievementStates.length) {
			var ach = achievementStates[_g];
			++_g;
			com_nevosoft_waw_core_utils_ContainerUtils.addObjectWithId(ctx.storage.data.achievements,ach);
		}
		if(ctx.storage.data.dailyQuest != null && ctx.dataProvider.pointsOfSale.getState(3) != null) {
			this._addDailyQuest(ctx,new com_nevosoft_waw_logic_systems_quests_DailyQuestEntity(ctx.storage.data.dailyQuest,ctx.dataProvider));
		}
	}
	,process: function(t) {
		if(!this.firstTransactionHandled) {
			this.firstTransactionHandled = true;
			this.validateAchievementsStateHandlers(t);
		}
		var _g = 0;
		var _g1 = t.gameTriggers;
		while(_g < _g1.length) {
			var trigger = _g1[_g];
			++_g;
			var _g2 = 0;
			var _g3 = t.context.dataProvider.quests.getActive();
			while(_g2 < _g3.length) {
				var q = _g3[_g2];
				++_g2;
				if(q.get_isComplete()) {
					continue;
				}
				var prevStage = q.getLastStageCompleted();
				if(q.process(trigger)) {
					var currStage = q.getLastStageCompleted();
					if(prevStage != currStage) {
						var trigger1 = com_nevosoft_waw_data_types_EGameTrigger.TriggerQuestStageUpdated({ id : q.get_id(), stage : currStage});
						t.gameTriggers.push(trigger1);
					}
					t.questUpdated.push(q.data.id);
					if(q.get_isComplete()) {
						t.questComplete.push(q.data.id);
					}
				}
			}
			var _g4 = 0;
			var _g5 = t.context.dataProvider.achievements.getAll();
			while(_g4 < _g5.length) {
				var a = _g5[_g4];
				++_g4;
				if(!a.isComplete) {
					var prevStage1 = a.getLastStageCompleted();
					if(a.process(trigger,t.time)) {
						var currStage1 = a.getLastStageCompleted();
						if(prevStage1 != currStage1) {
							t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerAchievementUpdated(a));
						}
						t.achievementsUpdated.push(a.data.id);
					}
				}
			}
			var dailyQuest = t.context.dataProvider.quests.getDailyQuest();
			if(dailyQuest != null && dailyQuest.get_currentTask() < 9 && !dailyQuest.get_isComplete()) {
				var prevStage2 = dailyQuest.getLatsStageUpdated();
				if(dailyQuest.process(trigger)) {
					var currStage2 = dailyQuest.getLatsStageUpdated();
					if(prevStage2 != currStage2) {
						t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerDailyQuestSubStageUpdated(dailyQuest));
					}
					t.questUpdated.push(dailyQuest.get_id());
					if(dailyQuest.get_isComplete()) {
						t.questComplete.push(dailyQuest.get_id());
					}
				}
			}
		}
	}
	,activate: function(ctx,q) {
		var m = ctx.dataProvider.getMetaIndex().quests.h[q.id];
		this._addQuestEntity(ctx,new com_nevosoft_waw_logic_systems_quests_QuestEntity({ data : q, meta : m},ctx.dataProvider));
	}
	,activateDailyQuest: function(ctx) {
		this._addDailyQuest(ctx,new com_nevosoft_waw_logic_systems_quests_DailyQuestEntity(ctx.storage.data.dailyQuest,ctx.dataProvider));
	}
	,deactivateDailyQuest: function(t) {
		var ctx = t.context;
		ctx.dataProvider.getProfileIndex().dailyQuest.cleanup();
		ctx.storage.data.dailyQuest = null;
		ctx.dataProvider.getProfileIndex().dailyQuest = null;
	}
	,deactivate: function(t,id) {
		var ctx = t.context;
		var qe = ctx.dataProvider.quests.getQuestEntity(id);
		HxOverrides.remove(ctx.dataProvider.quests.getActive(),qe);
		qe.close(t);
		this.toCleanUp.push(qe);
	}
	,cleanup_deactivated: function() {
		var _g = 0;
		var _g1 = this.toCleanUp;
		while(_g < _g1.length) {
			var q = _g1[_g];
			++_g;
			q.cleanup();
		}
		this.toCleanUp = [];
	}
	,ensurePrevArcQuestsClosed: function(ctx,questId) {
		var maybeArc = ctx.dataProvider.quests.getQuestArc(questId);
		if(maybeArc != null) {
			var arc = maybeArc;
			var _g = 0;
			var _g1 = arc.questsIds;
			while(_g < _g1.length) {
				var qId = _g1[_g];
				++_g;
				if(questId == qId) {
					break;
				}
				if(ctx.storage.data.completeQuestIds.indexOf(qId) < 0) {
					ctx.storage.data.completeQuestIds.push(qId);
				}
			}
		}
	}
	,validateAchievementsStateHandlers: function(t) {
		var _g = 0;
		var _g1 = t.context.dataProvider.achievements.getAll();
		while(_g < _g1.length) {
			var a = _g1[_g];
			++_g;
			if(!a.isComplete) {
				a.validateStateHandlers(t.time);
			}
		}
	}
	,_addQuestEntity: function(ctx,qEntity) {
		ctx.dataProvider.quests.getActive().push(qEntity);
		qEntity.validateStateHandlers();
	}
	,_addDailyQuest: function(ctx,qEntity) {
		ctx.dataProvider.getProfileIndex().dailyQuest = qEntity;
		qEntity.validateStateHandlers();
	}
	,_addAchievementEntity: function(ctx,achievementEntity) {
		ctx.dataProvider.getProfileIndex().achievements.push(achievementEntity);
		var this1 = ctx.dataProvider.getProfileIndex().achievementsMap;
		var key = achievementEntity.get_id();
		this1.h[key] = achievementEntity;
	}
	,__class__: com_nevosoft_waw_logic_systems_Quests
};
var com_nevosoft_waw_logic_systems_ResourcesLogic = function() { };
com_nevosoft_waw_logic_systems_ResourcesLogic.__name__ = true;
com_nevosoft_waw_logic_systems_ResourcesLogic.Add = function(t,reward,reason,allowOverLimit,comment) {
	if(allowOverLimit == null) {
		allowOverLimit = true;
	}
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var mp = dp.meta;
	var rdp = dp.serverResources;
	var profile = t.context.storage.data;
	var checkToken = com_nevosoft_waw_data_vo_OnMapStorage.getCheckToken();
	var mana = 0;
	var common = 0;
	var res = new com_nevosoft_waw_data_types_TCostIterator(reward);
	while(res.hasNext()) {
		var res1 = res.next();
		var id = res1.resourceId;
		var current = rdp.AvailableAmount(id);
		var inc = res1.value;
		if(inc == 0) {
			throw haxe_Exception.thrown("reward cannot contain zeros");
		}
		var objMt = mp.getGameObjectMeta(id);
		if(rdp.isStorable(objMt)) {
			var storage = rdp.getStorageByObjectMetaId(objMt.id);
			if(storage != null) {
				storage.inc(inc,allowOverLimit);
				if(storage.getMeta().storageComponent.categories != null && storage.getMeta().storageComponent.categories.indexOf("STUFF") >= 0) {
					common += inc;
				}
			}
		}
		com_nevosoft_waw_data_serialization_ArrayMapInt.set(profile.resources,id,com_nevosoft_waw_data_serialization_ArrayMapInt.get(profile.resources,id) + inc);
		var cost = com_nevosoft_waw_data_types_TCost.fromIdValue(id,inc);
		var space = { mana : mana, common : common};
		var move = { sign : 1, cost : cost, reason : reason, space : space};
		ctx.dataProvider.getProfileIndex().movesBuffer.pushMove(move);
		t.addCheckPoint("+ resourceMove: " + com_nevosoft_waw_data_types_TCost.serialize(move.cost));
		t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerResourceMove(move));
		if(com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged("res_buff",objMt)) {
			var availableAmt = com_nevosoft_waw_data_serialization_ArrayMapInt.get(profile.resources,id);
			var preservedAmt = com_nevosoft_waw_data_serialization_ArrayMapInt.get(profile.preservedResources,id);
			if(preservedAmt == 0) {
				preservedAmt = availableAmt;
			} else {
				preservedAmt = availableAmt + 1;
			}
			com_nevosoft_waw_data_serialization_ArrayMapInt.set(profile.preservedResources,id,preservedAmt);
			console.log("src/com/nevosoft/waw/logic/systems/ResourcesLogic.hx:92:","preserved " + preservedAmt + ", available " + availableAmt);
		}
	}
	return true;
};
com_nevosoft_waw_logic_systems_ResourcesLogic.Withdraw = function(t,cost,reason,comment) {
	var ctx = t.context;
	var dp = ctx.dataProvider;
	var mp = dp.meta;
	var rdp = dp.serverResources;
	var profile = t.context.storage.data;
	var mana = 0;
	var common = 0;
	var rr = new com_nevosoft_waw_data_types_TCostIterator(cost);
	while(rr.hasNext()) {
		var rr1 = rr.next();
		var id = rr1.resourceId;
		var current = rdp.AvailableAmount(id);
		var dec = rr1.value;
		if(dec == 0) {
			throw haxe_Exception.thrown("cost cannot contain zeros");
		}
		if(current - dec < 0) {
			throw haxe_Exception.thrown("error! - resources: not enough resource - " + rr1.resourceId + ", has " + current + ", need " + dec);
		}
		var objMt = mp.getGameObjectMeta(id);
		if(rdp.isStorable(objMt) && ctx.dataProvider.meta.isInCurrentEvent(id)) {
			var storage = rdp.getStorageByObjectMetaId(objMt.id);
			if(storage != null) {
				storage.dec(dec);
				if(objMt.category == "STUFF") {
					common += dec;
				}
			}
		}
		com_nevosoft_waw_data_serialization_ArrayMapInt.set(profile.resources,id,com_nevosoft_waw_data_serialization_ArrayMapInt.get(profile.resources,id) - dec);
		var cost = com_nevosoft_waw_data_types_TCost.fromIdValue(id,dec);
		var space = { mana : mana, common : common};
		var move = { sign : -1, cost : cost, reason : reason, space : space};
		ctx.dataProvider.getProfileIndex().movesBuffer.pushMove(move);
		t.addCheckPoint("- resourceMove: " + com_nevosoft_waw_data_types_TCost.serialize(move.cost));
		t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerResourceMove(move));
	}
	return true;
};
com_nevosoft_waw_logic_systems_ResourcesLogic.BuyIAPLot = function(t,lotMeta,offerId) {
	if(offerId == null) {
		offerId = 0;
	}
	var changeReason = offerId > 0 ? com_nevosoft_waw_data_constants_ResourceChangeReason.EOfferLot(lotMeta.id,offerId) : com_nevosoft_waw_data_constants_ResourceChangeReason.EIapLot(lotMeta.id);
	if(!com_nevosoft_waw_data_types_TCost.isEmpty(lotMeta.spendings)) {
		com_nevosoft_waw_logic_systems_ResourcesLogic.Withdraw(t,lotMeta.spendings,com_nevosoft_waw_data_constants_ResourceChangeReason.EOfferLot(offerId,lotMeta.id));
	}
};
com_nevosoft_waw_logic_systems_ResourcesLogic.clearPreservedIfNeeded = function(t,resId) {
	var ctx = t.context;
	if(com_nevosoft_waw_data_serialization_ArrayMapInt.get(ctx.storage.data.resources,resId) == 0) {
		com_nevosoft_waw_data_serialization_ArrayMapInt.set(ctx.storage.data.preservedResources,resId,0);
		console.log("src/com/nevosoft/waw/logic/systems/ResourcesLogic.hx:171:","clear preserved for " + resId);
	}
};
var com_nevosoft_waw_logic_systems_RestrictionId = {};
com_nevosoft_waw_logic_systems_RestrictionId._new = function(restictionId) {
	var this1 = restictionId;
	return this1;
};
com_nevosoft_waw_logic_systems_RestrictionId.isInverse = function(this1) {
	return HxOverrides.cca(this1,0) == 45;
};
com_nevosoft_waw_logic_systems_RestrictionId.getInversed = function(this1) {
	if(HxOverrides.cca(this1,0) == 45) {
		var this2 = HxOverrides.substr(this1,1,null);
		return this2;
	} else {
		var this2 = "-" + this1;
		return this2;
	}
};
var com_nevosoft_waw_logic_systems_Restrictions = function(dataProvider) {
	this.dataProvider = dataProvider;
	this.searchResults = [];
};
com_nevosoft_waw_logic_systems_Restrictions.__name__ = true;
com_nevosoft_waw_logic_systems_Restrictions.prototype = {
	CheckRestrictions: function(restrictions) {
		var overallStatus = true;
		var statuses = new haxe_ds_StringMap();
		var _g = 0;
		var _g1 = com_nevosoft_waw_data_types_TRestriction.keys(restrictions);
		while(_g < _g1.length) {
			var id = _g1[_g];
			++_g;
			var params = Reflect.field(restrictions,id);
			var status = this.CheckRestrictionAND(id,params);
			statuses.h[id] = status;
			if(!status) {
				overallStatus = false;
			}
		}
		return { statuses : statuses, overallStatus : overallStatus};
	}
	,FastCheck: function(restrictions) {
		var _g = 0;
		var _g1 = com_nevosoft_waw_data_types_TRestriction.keys(restrictions);
		while(_g < _g1.length) {
			var id = _g1[_g];
			++_g;
			if(!this.CheckRestrictionAND(id,Reflect.field(restrictions,id))) {
				return false;
			}
		}
		return true;
	}
	,CheckRestrictionAND: function(id,params) {
		if(params != null) {
			var _g = 0;
			while(_g < params.length) {
				var param = params[_g];
				++_g;
				if(!this.checkSingleParam(id,param)) {
					return false;
				}
			}
		}
		return true;
	}
	,CheckRestrictionOR: function(id,params) {
		if(params != null) {
			var _g = 0;
			while(_g < params.length) {
				var param = params[_g];
				++_g;
				if(this.checkSingleParam(id,param)) {
					return true;
				}
			}
		}
		return params.length == 0;
	}
	,checkSingleParam: function(id,param) {
		var result = false;
		if(HxOverrides.cca(id,0) == 45) {
			var result1;
			if(HxOverrides.cca(id,0) == 45) {
				var this1 = HxOverrides.substr(id,1,null);
				result1 = this1;
			} else {
				var this1 = "-" + id;
				result1 = this1;
			}
			result = !this.checkSingleParam(result1,param);
		} else {
			switch(id) {
			case "1":
				var level = param;
				return this.dataProvider.getCurrentLevel() >= level;
			case "11":
				var sectorId = param;
				return this.dataProvider.location.isSectorOpened(sectorId);
			case "12":
				var resourceId = param;
				return this.dataProvider.clientResources.got(resourceId);
			case "13":
				var checkpointRequired = param;
				return this.dataProvider.getTutorChekpoint() >= checkpointRequired;
			case "14":
				return false;
			case "15":
				var params = param;
				var inapSumAvg = this.dataProvider.profile.inappSumAvg();
				if(inapSumAvg >= params.from) {
					return inapSumAvg <= params.to;
				} else {
					return false;
				}
				break;
			case "16":
				var params = param;
				var fromGroup = this.dataProvider.meta.getPayMonetayGroupById(params.from);
				var toGroup = this.dataProvider.meta.getPayMonetayGroupById(params.to);
				var groups = this.dataProvider.meta.getPayMonetayGroups();
				var inappSum = this.dataProvider.profile.inappSum();
				var _g = 0;
				while(_g < groups.length) {
					var g = groups[_g];
					++_g;
					if(g.rate >= fromGroup.rate && g.rate <= toGroup.rate && inappSum >= g.from && inappSum <= g.to) {
						return true;
					}
				}
				return false;
			case "17":
				var params = param;
				var fromGroup = this.dataProvider.meta.getPayRecencyGroupById(params.from);
				var toGroup = this.dataProvider.meta.getPayRecencyGroupById(params.to);
				var groups = this.dataProvider.meta.getPayRecencyGroups();
				var lastInappTime = this.dataProvider.profile.lastIAPTime();
				var timeSinceLastInapp = this.dataProvider.getTime() - lastInappTime;
				var _g = 0;
				while(_g < groups.length) {
					var g = groups[_g];
					++_g;
					if(g.rate >= fromGroup.rate && g.rate <= toGroup.rate && timeSinceLastInapp >= g.from && timeSinceLastInapp <= g.to) {
						return true;
					}
				}
				return false;
			case "18":
				var params = param;
				var fromGroup = this.dataProvider.meta.getPayFrequencyGroupById(params.from);
				var toGroup = this.dataProvider.meta.getPayFrequencyGroupById(params.to);
				var groups = this.dataProvider.meta.getPayFrequencyGroups();
				var _g = 0;
				while(_g < groups.length) {
					var g = groups[_g];
					++_g;
					var inappFrequency = this.dataProvider.profile.inappFrequency(g.period);
					if(g.rate >= fromGroup.rate && g.rate <= toGroup.rate && inappFrequency >= g.from && inappFrequency <= g.to) {
						return true;
					}
				}
				return false;
			case "19":
				var params = param;
				var maybeOffer = this.dataProvider.offers.getOffer(params.offerId);
				if(maybeOffer != null) {
					return this.dataProvider.offers.isLotInOfferBought(maybeOffer,params.lotId);
				}
				return false;
			case "2":
				var questId = param;
				return this.dataProvider.quests.isClosed(questId);
			case "20":
				var params = param;
				if(this.dataProvider.offers.getOffer(params.id) != null) {
					var offerState = this.dataProvider.offers.getOffer(params.id);
					if(offerState.deactivateTime > 0 && this.dataProvider.getTime() - offerState.deactivateTime >= params.time) {
						return true;
					}
				}
				return false;
			case "21":
				var offlineTime = param;
				return this.dataProvider.getUnixTimeOnMapEnter() - this.dataProvider.getUnixTimeOnMapExit() >= offlineTime;
			case "22":
				var level = param;
				return this.dataProvider.getCurrentLevel() <= level;
			case "23":
				var level = param;
				return this.dataProvider.getCurrentLevel() == level;
			case "24":
				var time = param;
				var lastDeactivatedTime = 0;
				var _g = 0;
				var _g1 = this.dataProvider.offers.getActive();
				while(_g < _g1.length) {
					var offer = _g1[_g];
					++_g;
					if(!this.dataProvider.offers.isStateActiveById(offer.id)) {
						if(lastDeactivatedTime < offer.deactivateTime) {
							lastDeactivatedTime = offer.deactivateTime;
						}
					} else {
						return false;
					}
				}
				if(this.dataProvider.getTime() - lastDeactivatedTime >= time && lastDeactivatedTime != 0) {
					return true;
				}
				return false;
			case "25":
				var params = param;
				var resourceId = params.resourceId;
				var amount = params.amount;
				return this.dataProvider.clientResources.AvailableAmount(params.resourceId) < params.amount;
			case "26":
				var params = param;
				var filter = { metaId : params.object, levelGeThan : params.level};
				this.searchResults = this.dataProvider.location.filterMapObjects(filter,null,this.searchResults);
				var hasComplete = this.searchResults.length > 0;
				var filterPending = { metaId : params.object, levelGeThan : params.level - 1};
				this.searchResults = this.dataProvider.location.filterMapObjects(filterPending,null,this.searchResults);
				var hasPending = false;
				if(!hasComplete) {
					var _g = 0;
					var _g1 = this.searchResults;
					while(_g < _g1.length) {
						var go = _g1[_g];
						++_g;
						if(go.cWorkplace.actionsQueue.length > 0) {
							var currActionState = go.cWorkplace.actionsQueue[0];
							if(com_nevosoft_waw_data_types_meta_EActionType.inUpgradeGroup(this.dataProvider.actions.getActionMeta(currActionState.id).type)) {
								hasPending = true;
								break;
							}
						}
					}
				}
				if(!hasComplete) {
					return hasPending;
				} else {
					return true;
				}
				break;
			case "27":
				var params = param;
				var _g = 0;
				var _g1 = params.levels;
				while(_g < _g1.length) {
					var level = _g1[_g];
					++_g;
					if(this.dataProvider.getCurrentLevel() == level) {
						return true;
					}
				}
				return false;
			case "28":
				var offerId = param;
				var offers = this.dataProvider.offers.getActive();
				var _g = 0;
				while(_g < offers.length) {
					var offer = offers[_g];
					++_g;
					if(offer.id == offerId) {
						return true;
					}
				}
				return false;
			case "29":
				var params = param;
				if(this.dataProvider.offers.getOffer(params.offerId) != null) {
					var offer = this.dataProvider.offers.getOffer(params.offerId);
					var _g = 0;
					var _g1 = offer.lots;
					while(_g < _g1.length) {
						var lot = _g1[_g];
						++_g;
						if(lot.bought && params.lotsIds.indexOf(lot.id) >= 0) {
							return true;
						}
					}
				}
				return false;
			case "3":
				var params = param;
				var filter = { metaId : params.object, levelGeThan : params.level};
				this.searchResults = this.dataProvider.location.filterMapObjects(filter,null,this.searchResults);
				return this.searchResults.length > 0;
			case "30":
				var evtId = param;
				return this.dataProvider.getCurrentEventId() == evtId;
			case "31":
				var metaId = param;
				var filter = { metaId : metaId};
				this.searchResults = this.dataProvider.location.filterMapObjects(filter,null,this.searchResults);
				if(this.searchResults.length <= 0) {
					return this.dataProvider.serverResources.AvailableAmount(metaId) > 0;
				} else {
					return true;
				}
				break;
			case "32":
				var evtId = param;
				return this.dataProvider.isGameEventComplete(evtId);
			case "33":
				var metaId = param;
				var category = this.dataProvider.meta.getCategoryByMetaId(metaId);
				if(category == "ANIMAL") {
					var pastureMeta = this.dataProvider.mapObjects.getPastureMetaOfAnimal(metaId);
					var animalLimits = pastureMeta.pastureComponent.animalLimits;
					var animalsLimit = animalLimits[0];
					var animalsCount = 0;
					var _g = 0;
					var _g1 = pastureMeta.pastureComponent.animalIds;
					while(_g < _g1.length) {
						var animalId = _g1[_g];
						++_g;
						animalsCount += this.dataProvider.location.getAnimalCount(animalId);
						animalsCount += this.dataProvider.serverResources.AvailableAmount(animalId);
					}
					var pastureFilter = { metaId : pastureMeta.id};
					this.searchResults = this.dataProvider.location.filterMapObjects(pastureFilter,null,this.searchResults);
					if(this.searchResults.length > 0) {
						var pasture = this.searchResults[0];
						var pastureLevel = pasture.cUpgradable.level;
						if(pastureLevel - 1 >= animalLimits.length) {
							animalsLimit = animalLimits[animalLimits.length - 1];
						} else {
							animalsLimit = animalLimits[pastureLevel - 1];
						}
					}
					return animalsCount >= animalsLimit;
				}
				var limit = this.dataProvider.location.getStructureShopLimit(metaId);
				var filter = { metaId : metaId};
				this.searchResults = this.dataProvider.location.filterMapObjects(filter,null,this.searchResults);
				if(limit > 0) {
					return this.searchResults.length + this.dataProvider.serverResources.AvailableAmount(metaId) >= limit;
				} else {
					return false;
				}
				break;
			case "34":
				var periodicalRewardObjectId = param;
				var _g = 0;
				var _g1 = this.dataProvider.profile.getObjectsWithPeriodicalReward();
				while(_g < _g1.length) {
					var go = _g1[_g];
					++_g;
					var prData = go.cPeriodicalReward;
					var goMeta = this.dataProvider.meta.getGameObjectMeta(go.metaId);
					var prMeta = goMeta.periodicalRewardComponent;
					if(go.metaId == periodicalRewardObjectId && (prMeta.periods - prData.currentPeriod == 1 && prData.isRewardCollected || prMeta.periods - prData.currentPeriod <= 0)) {
						return true;
					}
				}
				return false;
			case "5":
				var questId = param;
				return this.dataProvider.quests.isActive(questId);
			case "6":
				var params = param;
				var level = this.dataProvider.getCurrentLevel();
				if(level >= params.min) {
					return level <= params.max;
				} else {
					return false;
				}
				break;
			case "7":
				var params = param;
				var id1 = params.resourceId;
				var amount;
				if(id1 == -5) {
					amount = this.dataProvider.location.getFreeShmuCount();
				} else {
					amount = this.dataProvider.clientResources.AvailableAmount(id1);
				}
				return amount >= params.amount;
			case "8":
				var inappSum = this.dataProvider.shop.getIAPTotalSpend();
				return inappSum > 100;
			case "9":
				var inappSum = this.dataProvider.shop.getIAPTotalSpend();
				return inappSum > 1000;
			default:
				throw haxe_Exception.thrown("no handler: " + id);
			}
		}
		return result;
	}
	,NoChanceToPass: function(restrictions) {
		var _g = 0;
		var _g1 = com_nevosoft_waw_data_types_TRestriction.keys(restrictions);
		while(_g < _g1.length) {
			var k = _g1[_g];
			++_g;
			if(!this.hasChanceToPass(k,Reflect.field(restrictions,k))) {
				return true;
			}
		}
		return false;
	}
	,hasChanceToPass: function(id,params) {
		switch(id) {
		case "-1":case "-11":case "-12":case "-2":
			return this.CheckRestrictionAND(id,params);
		case "-19":
			return this.CheckRestrictionAND(id,params);
		case "-3":
			return this.CheckRestrictionAND(id,params);
		case "5":
			return !this.CheckRestrictionAND("2",params);
		case "6":
			var params1 = params;
			var _g = 0;
			while(_g < params1.length) {
				var param = params1[_g];
				++_g;
				if(this.dataProvider.getCurrentLevel() >= param.max) {
					return false;
				}
			}
			return true;
		default:
			return true;
		}
	}
	,CheckTimeParameters: function(timeParameters,receiveTime,deactivateTime,time) {
		if(timeParameters == null) {
			return true;
		}
		var start = timeParameters.activePeriodStart;
		var end = timeParameters.activePeriodEnd;
		var timeout = timeParameters.timeout;
		var coodown = timeParameters.cooldown;
		var preview = timeParameters.preview != null ? timeParameters.preview : 0;
		if(start != null && time < start - preview) {
			return false;
		}
		if(end != null && time > end) {
			return false;
		}
		if(timeout != null && time >= receiveTime + timeout && receiveTime >= deactivateTime) {
			return false;
		}
		if(coodown != null) {
			if(time < deactivateTime + coodown) {
				return false;
			}
		}
		return true;
	}
	,exists: function(restrictions,targetId) {
		var _g = 0;
		var _g1 = com_nevosoft_waw_data_types_TRestriction.keys(restrictions);
		while(_g < _g1.length) {
			var id = _g1[_g];
			++_g;
			if(id == targetId) {
				return true;
			}
		}
		return false;
	}
	,__class__: com_nevosoft_waw_logic_systems_Restrictions
};
var com_nevosoft_waw_logic_systems_autoOrders_ISlotsCountProvider = function() { };
com_nevosoft_waw_logic_systems_autoOrders_ISlotsCountProvider.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_ISlotsCountProvider.__isInterface__ = true;
com_nevosoft_waw_logic_systems_autoOrders_ISlotsCountProvider.prototype = {
	__class__: com_nevosoft_waw_logic_systems_autoOrders_ISlotsCountProvider
};
var com_nevosoft_waw_logic_systems_autoOrders_ConstSlotsCountProvider = function(num) {
	this.num = num;
};
com_nevosoft_waw_logic_systems_autoOrders_ConstSlotsCountProvider.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_ConstSlotsCountProvider.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_ISlotsCountProvider];
com_nevosoft_waw_logic_systems_autoOrders_ConstSlotsCountProvider.prototype = {
	getSlotsCount: function(context) {
		return this.num;
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_ConstSlotsCountProvider
};
var com_nevosoft_waw_logic_systems_autoOrders_IPowerDistributor = function() { };
com_nevosoft_waw_logic_systems_autoOrders_IPowerDistributor.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_IPowerDistributor.__isInterface__ = true;
com_nevosoft_waw_logic_systems_autoOrders_IPowerDistributor.prototype = {
	__class__: com_nevosoft_waw_logic_systems_autoOrders_IPowerDistributor
};
var com_nevosoft_waw_logic_systems_autoOrders_EvenlyPowerDistributor = function() {
};
com_nevosoft_waw_logic_systems_autoOrders_EvenlyPowerDistributor.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_EvenlyPowerDistributor.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_IPowerDistributor];
com_nevosoft_waw_logic_systems_autoOrders_EvenlyPowerDistributor.prototype = {
	distribute: function(context) {
		var posState = context.posState;
		var slotsCount = posState.slots.length;
		var powerForSlot = Math.ceil(posState.power / slotsCount);
		var _g = [];
		var _g1 = 0;
		var _g2 = slotsCount;
		while(_g1 < _g2) {
			var i = _g1++;
			_g.push(powerForSlot);
		}
		return _g;
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_EvenlyPowerDistributor
};
var com_nevosoft_waw_logic_systems_autoOrders_IChoiceSet = function() { };
com_nevosoft_waw_logic_systems_autoOrders_IChoiceSet.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_IChoiceSet.__isInterface__ = true;
com_nevosoft_waw_logic_systems_autoOrders_IChoiceSet.prototype = {
	__class__: com_nevosoft_waw_logic_systems_autoOrders_IChoiceSet
};
var com_nevosoft_waw_logic_systems_autoOrders_IOrderGenerator = function() { };
com_nevosoft_waw_logic_systems_autoOrders_IOrderGenerator.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_IOrderGenerator.__isInterface__ = true;
com_nevosoft_waw_logic_systems_autoOrders_IOrderGenerator.prototype = {
	__class__: com_nevosoft_waw_logic_systems_autoOrders_IOrderGenerator
};
var com_nevosoft_waw_logic_systems_autoOrders_ITotalPowerGenerator = function() { };
com_nevosoft_waw_logic_systems_autoOrders_ITotalPowerGenerator.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_ITotalPowerGenerator.__isInterface__ = true;
com_nevosoft_waw_logic_systems_autoOrders_ITotalPowerGenerator.prototype = {
	__class__: com_nevosoft_waw_logic_systems_autoOrders_ITotalPowerGenerator
};
var com_nevosoft_waw_logic_systems_autoOrders_OrderCalculations = function() { };
com_nevosoft_waw_logic_systems_autoOrders_OrderCalculations.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_OrderCalculations.calculateOrderDemand = function(choice,power) {
	var powerPerItem = power / choice.length;
	var result = [];
	var _g = 0;
	while(_g < choice.length) {
		var item = choice[_g];
		++_g;
		var resId = item.id;
		var resAmount = powerPerItem / item.weight;
		if(item.max > 0) {
			resAmount = Math.max(1.0,Math.min(resAmount,item.max));
		}
		result.push(resId);
		result.push(Math.floor(resAmount));
	}
	return result;
};
com_nevosoft_waw_logic_systems_autoOrders_OrderCalculations.generateReward = function(context,orderInfo,settings,globalParams) {
	var template = orderInfo.template;
	var amounts = orderInfo.amounts;
	var choosenItems = orderInfo.choosenItems;
	var productionTimeBonus = globalParams.productionTimeBonus;
	var goldXpKoeff = globalParams.goldXpKoeff;
	var result = com_nevosoft_waw_logic_systems_autoOrders_OrderTemplate.generateReward(template,context);
	var goldAmount = 0.0;
	var xpAmount = 0.0;
	var metaDataProvider = context.dataProvider.meta;
	var isSuperProfit = context.randomProvider() <= template.superProfitChance;
	var superProfitMult = isSuperProfit ? template.superProfitKoeff : 1.0;
	var _g = 0;
	var _g1 = choosenItems.length;
	while(_g < _g1) {
		var i = _g++;
		var amount = amounts[i];
		var weightedItem = choosenItems[i];
		var resourceId = weightedItem.id;
		var weightCustom = weightedItem.weight;
		var prodTimeInMinutes = metaDataProvider.getStuffTime(resourceId) / 60;
		var deep = metaDataProvider.getStuffDeep(resourceId);
		var deepKoeff = deep > 0 ? parseFloat(metaDataProvider.getConst("deepTable" + deep)) : 1.0;
		var randomizer = com_nevosoft_waw_logic_systems_autoOrders_OrderCalculations.randomInRange(settings.goldKoeffMin,settings.goldKoeffMax,context.randomProvider);
		goldAmount += ((weightCustom + prodTimeInMinutes * productionTimeBonus) * deepKoeff * settings.rewardKoeff + weightCustom) * randomizer * amount * superProfitMult;
		xpAmount += weightCustom * goldXpKoeff * com_nevosoft_waw_logic_systems_autoOrders_OrderCalculations.randomInRange(settings.xpKoeffMin,settings.xpKoeffMax,context.randomProvider) * amount * superProfitMult;
	}
	var autoCaclulateFlag = 1;
	var tmp;
	if(com_nevosoft_waw_data_types_TCost.hasKey(result,-1)) {
		var this1 = result;
		tmp = (com_nevosoft_waw_data_types_TCost.hasKey(this1,-1) ? Reflect.field(this1,"-1") : 0) == autoCaclulateFlag;
	} else {
		tmp = false;
	}
	if(tmp) {
		var value = Math.floor(Math.max(1.0,goldAmount));
		result["" + (-1)] = value;
	}
	var tmp;
	if(com_nevosoft_waw_data_types_TCost.hasKey(result,-4)) {
		var this1 = result;
		tmp = (com_nevosoft_waw_data_types_TCost.hasKey(this1,-4) ? Reflect.field(this1,"-4") : 0) == autoCaclulateFlag;
	} else {
		tmp = false;
	}
	if(tmp) {
		var value = Math.floor(Math.max(1.0,xpAmount));
		result["" + (-4)] = value;
	}
	return result;
};
com_nevosoft_waw_logic_systems_autoOrders_OrderCalculations.randomInRange = function(min,max,randomProvider) {
	return com_nevosoft_isoframework_utils_MathUtils.getRandomValue2(min,max,randomProvider);
};
var com_nevosoft_waw_logic_systems_autoOrders_OrderTemplate = {};
com_nevosoft_waw_logic_systems_autoOrders_OrderTemplate._new = function(v) {
	var this1 = v;
	return this1;
};
com_nevosoft_waw_logic_systems_autoOrders_OrderTemplate.chooseItems = function(this1,choiceSet,randomProvider) {
	var capacity = com_nevosoft_waw_logic_systems_autoOrders_OrderTemplate.calculateDemandCapacity(this1,randomProvider);
	var _g = [];
	var _g1 = 0;
	var _g2 = capacity;
	while(_g1 < _g2) {
		var i = _g1++;
		_g.push(choiceSet.chooseNext());
	}
	return _g;
};
com_nevosoft_waw_logic_systems_autoOrders_OrderTemplate.calculateDemandCapacity = function(this1,randomProvider) {
	return com_nevosoft_isoframework_utils_MathUtils.getRandomValue(this1.min,this1.max,randomProvider);
};
com_nevosoft_waw_logic_systems_autoOrders_OrderTemplate.generateReward = function(this1,context) {
	var rewardStrategy = context.chooseRewardStrategy;
	if(context.posState.id == 4) {
		return rewardStrategy.forCamping(this1);
	} else {
		return rewardStrategy.forMarket(this1);
	}
};
com_nevosoft_waw_logic_systems_autoOrders_OrderTemplate.getChoiceSet = function(this1,context) {
	var cache = context.choiceSetsCache;
	if(cache.exists(this1.templateType)) {
		return cache.get(this1.templateType);
	} else {
		var choiceSet = com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ChoiceSetFactory.createForTemplate(this1.templateType,context);
		cache.set(this1.templateType,choiceSet);
		return choiceSet;
	}
};
var com_nevosoft_waw_logic_systems_autoOrders_OrderTemplates = function(orderTemplates) {
	this.orderTemplates = orderTemplates;
};
com_nevosoft_waw_logic_systems_autoOrders_OrderTemplates.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_OrderTemplates.templateCooldownKey = function(id) {
	return "template" + id;
};
com_nevosoft_waw_logic_systems_autoOrders_OrderTemplates.prototype = {
	chooseTemplate: function(context) {
		var availableTemplates = this.getAvailableTemplates(context);
		var _g = [];
		var _g1 = 0;
		while(_g1 < availableTemplates.length) {
			var t = availableTemplates[_g1];
			++_g1;
			_g.push(t.chance);
		}
		var weights = _g;
		var choosedTemplate = com_nevosoft_isoframework_utils_MathUtils.randomWeightedChoice(availableTemplates,weights,context.randomProvider);
		context.posState.cooldown[com_nevosoft_waw_logic_systems_autoOrders_OrderTemplates.templateCooldownKey(choosedTemplate.id)] = context.dataProvider.getTime();
		return com_nevosoft_waw_logic_systems_autoOrders_OrderTemplate._new(choosedTemplate);
	}
	,calculateDemandCapacity: function(template,randomProvider) {
		return com_nevosoft_isoframework_utils_MathUtils.getRandomValue(template.min,template.max,randomProvider);
	}
	,getAvailableTemplates: function(context) {
		var _gthis = this;
		var dataProvider = context.dataProvider;
		var currentTime = dataProvider.getTime();
		var _g = [];
		var _g1 = 0;
		var _g2 = this.orderTemplates;
		while(_g1 < _g2.length) {
			var v = _g2[_g1];
			++_g1;
			if(!_gthis.checkTemplateCooldown(context,currentTime,v) ? false : dataProvider.restrictions.FastCheck(v.restrictions)) {
				_g.push(v);
			}
		}
		return _g;
	}
	,checkTemplateCooldown: function(context,currentTime,template) {
		var posState = context.posState;
		var cooldownStartedMaybe = posState.cooldown[com_nevosoft_waw_logic_systems_autoOrders_OrderTemplates.templateCooldownKey(template.id)];
		var cooldownTime = template.cooldown;
		var isInCooldown = currentTime - (cooldownStartedMaybe != null ? cooldownStartedMaybe : 0) < cooldownTime;
		if(!isInCooldown && cooldownStartedMaybe != null) {
			Reflect.deleteField(posState.cooldown,com_nevosoft_waw_logic_systems_autoOrders_OrderTemplates.templateCooldownKey(template.id));
		}
		return !isInCooldown;
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_OrderTemplates
};
var com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController = function() { };
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.init = function(t,id) {
	var ctx = t.context;
	var autoOrdersSystem = ctx.autoOrdersSystem;
	if(autoOrdersSystem.isActive(id)) {
		var posContext = autoOrdersSystem.getContext(t,null);
		var newState = autoOrdersSystem.createPOSState(posContext,id,t.time);
		com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.replacePOSState(t,newState);
		var posContext = autoOrdersSystem.getContext(t,newState);
		autoOrdersSystem.generateTotalPower(posContext);
		t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerPointOfSaleInit({ type : id}));
		com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.fillInEmptySlots(t,posContext);
		autoOrdersSystem.generateTotalReward(posContext);
		com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.saveDebugInfoAboutPosState(t,newState);
	}
};
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.initOrdersHost = function(t,id,owner) {
	var ctx = t.context;
	var autoOrdersSystem = ctx.autoOrdersSystem;
	var posContext = autoOrdersSystem.getContext(t,owner.cPointOfSale);
	var maybeOldState = posContext.posState;
	var newState = autoOrdersSystem.createPOSState(posContext,id,t.time);
	if(maybeOldState != null) {
		var oldState = maybeOldState;
		newState.genCounter = oldState.genCounter;
		newState.cooldown = oldState.cooldown;
		newState.shown = oldState.shown;
	}
	owner.cPointOfSale = newState;
	var posContext = autoOrdersSystem.getContext(t,newState);
	autoOrdersSystem.generateTotalPower(posContext);
	t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerPointOfSaleInit({ type : id}));
	com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.fillInEmptySlots(t,posContext);
	autoOrdersSystem.generateTotalReward(posContext);
	com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.saveDebugInfoAboutPosState(t,newState);
};
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.setShown = function(t,id) {
	var ctx = t.context;
	var posState = ctx.dataProvider.pointsOfSale.getState(id);
	if(posState == null) {
		throw haxe_Exception.thrown("no pos state");
	}
	if(posState.shown) {
		throw haxe_Exception.thrown("already shown");
	}
	posState.shown = true;
};
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.fillInEmptySlots = function(t,posContext) {
	var ctx = t.context;
	var autoOrdersSystem = ctx.autoOrdersSystem;
	var updatedSlotIndexes = autoOrdersSystem.generateOrdersForEmptySlots(posContext);
	var _g = 0;
	while(_g < updatedSlotIndexes.length) {
		var slotInd = updatedSlotIndexes[_g];
		++_g;
		t.gameTriggers.push(com_nevosoft_waw_data_types_EGameTrigger.TriggerPointOfSaleSlotState({ type : posContext.posState.id, slotInd : slotInd}));
	}
	return updatedSlotIndexes;
};
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.regenSlot = function(t,id,slotId) {
	var ctx = t.context;
	var dataProvider = ctx.dataProvider;
	var posState = dataProvider.pointsOfSale.getState(id);
	if(posState == null) {
		throw haxe_Exception.thrown("no posState while trying to regen slot");
	}
	if(dataProvider.pointsOfSale.isMarketSlotCooldownActive(posState,slotId,t.time)) {
		throw haxe_Exception.thrown("slot in cooldown state");
	}
	var autoOrdersSystem = ctx.autoOrdersSystem;
	com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.clearCooldown(posState,slotId);
	com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.clearSlot(posState,slotId);
	var posContext = autoOrdersSystem.getContext(t,posState);
	var result = com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.fillInEmptySlots(t,posContext);
	com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.saveDebugInfoAboutPosState(t,posState);
	return result;
};
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.replacePOSState = function(t,posState) {
	var container = t.context.storage.currentLocation.pointsOfSaleStates;
	var oldState = com_nevosoft_waw_core_utils_ContainerUtils.getObjectById(container,posState.id);
	if(oldState != null) {
		com_nevosoft_waw_core_utils_ContainerUtils.setObject(container,posState);
	} else {
		com_nevosoft_waw_core_utils_ContainerUtils.addObjectWithId(container,posState);
	}
};
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.setPOSCooldownState = function(posState,time) {
	posState.cooldown["cooldownState"] = time;
};
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.clearPOSCooldownState = function(posState) {
	Reflect.deleteField(posState.cooldown,"cooldownState");
};
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.clearCooldown = function(posState,slotId) {
	Reflect.deleteField(posState.cooldown,"" + slotId);
};
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.clearAllSlotsCooldown = function(posState) {
	var _g = 0;
	var _g1 = posState.slots;
	while(_g < _g1.length) {
		var slot = _g1[_g];
		++_g;
		if(slot != null) {
			com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.clearCooldown(posState,slot.id);
		}
	}
};
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.setCooldown = function(posState,slotId,time) {
	var slotInd = com_nevosoft_waw_core_utils_ContainerUtils.getIndexOf(posState.slots,slotId);
	posState.cooldown["" + slotId] = time;
	return slotInd;
};
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.clearSlot = function(posState,slotId) {
	var ind = slotId - 1;
	posState.slots[ind] = null;
};
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.clearAllSlots = function(posState) {
	var _g = 0;
	var _g1 = posState.slots;
	while(_g < _g1.length) {
		var slot = _g1[_g];
		++_g;
		if(slot != null) {
			com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.clearSlot(posState,slot.id);
		}
	}
};
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleController.saveDebugInfoAboutPosState = function(t,posState) {
	t.addCheckPoint("PointOfSale: id " + posState.id);
	var resIdToDemand = t.context.dataProvider.pointsOfSale.calculateDemand();
	var genCtx = t.context.autoOrdersSystem.getContext(t,posState);
	var _g = 0;
	var _g1 = posState.slots;
	while(_g < _g1.length) {
		var slot = _g1[_g];
		++_g;
		if(slot != null) {
			t.addCheckPoint("slotId: " + slot.id + " | slotPower: " + Math.floor(slot.power) + " | slotData: " + Std.string(slot.rawData) + " | slotReward: " + com_nevosoft_waw_data_types_TCost.serialize(slot.reward));
		}
	}
	t.traceCheckpoints();
};
var com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleFactory = function(meta,metaIndex) {
	this.metaIndex = metaIndex;
	this.meta = meta;
};
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleFactory.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleFactory.prototype = {
	getConfig: function(id) {
		switch(id) {
		case 1:
			return this.createMarket();
		case 2:
			return this.createZeppelin();
		case 3:
			return this.createDailyQuest();
		case 4:
			return this.createCamping();
		default:
			return this.createOrdersHost(id);
		}
	}
	,getOrdersHostsIds: function() {
		var _g = [];
		var k = this.metaIndex.ordersHostSettings.keys();
		while(k.hasNext()) {
			var k1 = k.next();
			_g.push(k1);
		}
		return _g;
	}
	,getContext: function(t,posState) {
		var dataProvider = t.context.dataProvider;
		var levelConfig = dataProvider.getCurrentLevelConfig();
		var randomProvider = ($_=t.randomGenerator,$bind($_,$_.next));
		return { posState : posState, userLevelConfig : levelConfig.ordersGeneration, dataProvider : dataProvider, choiceSetsCache : new haxe_ds_IntMap(), randomProvider : randomProvider, chooseRewardStrategy : new com_nevosoft_waw_logic_systems_rewardChoice_RewardStrategyPicker(dataProvider,randomProvider)};
	}
	,createMarket: function() {
		var attributes = this.metaIndex.marketAttributes;
		var settings = this.metaIndex.marketMt.ordersComponent;
		var goldXpKoeff = parseFloat(this.metaIndex.constants.h["goldXpKoeff"]);
		var productionTimeBonus = parseFloat(this.metaIndex.constants.h["productionTimeBonus"]);
		return { slotsCountProvider : new com_nevosoft_waw_logic_systems_autoOrders_market_MarketSlotsCountProvider(), totalPowerGenerator : new com_nevosoft_waw_logic_systems_autoOrders_market_MarketPowerGenerator(), totalPowerDistributor : new com_nevosoft_waw_logic_systems_autoOrders_market_MarketPowerDistributor(), orderGenerator : new com_nevosoft_waw_logic_systems_autoOrders_market_MarketOrderGenerator(settings,attributes,goldXpKoeff,productionTimeBonus), totalRewardGenerator : haxe_ds_Option.None};
	}
	,createZeppelin: function() {
		var settings = this.meta.zeppelinSettings;
		var goldXpKoeff = parseFloat(this.metaIndex.constants.h["goldXpKoeff"]);
		var totalRewardGenerator = new com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_ZeppelinTotalRewardGenerator(settings.rewardKoeff,settings.overallRewardKoeff);
		var productionTimeBonus = parseFloat(this.metaIndex.constants.h["productionTimeBonus"]);
		return { slotsCountProvider : new com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinSlotsCountProvider(), totalPowerGenerator : new com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinPowerGenerator(), totalPowerDistributor : new com_nevosoft_waw_logic_systems_autoOrders_EvenlyPowerDistributor(), orderGenerator : new com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinOrderGenerator(settings,goldXpKoeff,productionTimeBonus), totalRewardGenerator : haxe_ds_Option.Some(totalRewardGenerator)};
	}
	,createDailyQuest: function() {
		var settings = this.meta.dailyQuestSettings;
		var totalRewardGenerator = new com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_DailyQuestRewardGenerator();
		var goldXpKoeff = settings.goldXpKoeff;
		return { slotsCountProvider : new com_nevosoft_waw_logic_systems_autoOrders_ConstSlotsCountProvider(9), totalPowerGenerator : new com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestPowerGenerator(1.0), totalPowerDistributor : new com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestPowerDistributor(), orderGenerator : new com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestOrderGenerator(settings,goldXpKoeff), totalRewardGenerator : haxe_ds_Option.Some(totalRewardGenerator)};
	}
	,createCamping: function() {
		var settings = this.meta.campingSettings;
		var goldXpKoeff = parseFloat(this.metaIndex.constants.h["goldXpKoeff"]);
		var productionTimeBonus = parseFloat(this.metaIndex.constants.h["productionTimeBonus"]);
		return { slotsCountProvider : new com_nevosoft_waw_logic_systems_autoOrders_ConstSlotsCountProvider(3), totalPowerGenerator : new com_nevosoft_waw_logic_systems_autoOrders_camping_CampingPowerGenerator(), totalPowerDistributor : new com_nevosoft_waw_logic_systems_autoOrders_EvenlyPowerDistributor(), orderGenerator : new com_nevosoft_waw_logic_systems_autoOrders_camping_CampingOrderGenerator(settings,goldXpKoeff,productionTimeBonus), totalRewardGenerator : haxe_ds_Option.None};
	}
	,createOrdersHost: function(ownerMetaId) {
		var settings = this.metaIndex.ordersHostSettings.h[ownerMetaId];
		var goldXpKoeff = parseFloat(this.metaIndex.constants.h["goldXpKoeff"]);
		var productionTimeBonus = parseFloat(this.metaIndex.constants.h["productionTimeBonus"]);
		return { slotsCountProvider : new com_nevosoft_waw_logic_systems_autoOrders_ConstSlotsCountProvider(1), totalPowerGenerator : new com_nevosoft_waw_logic_systems_autoOrders_market_OrdersHostPowerGenerator(settings.powerKoeff), totalPowerDistributor : new com_nevosoft_waw_logic_systems_autoOrders_EvenlyPowerDistributor(), orderGenerator : new com_nevosoft_waw_logic_systems_autoOrders_market_OrdersHostGenerator(settings,goldXpKoeff,productionTimeBonus), totalRewardGenerator : haxe_ds_Option.None};
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_PointOfSaleFactory
};
var com_nevosoft_waw_logic_systems_autoOrders_camping_CampingOrderGenerator = function(settings,goldXpKoeff,productionTimeBonus) {
	this.settings = settings;
	this.globalParams = { productionTimeBonus : productionTimeBonus, goldXpKoeff : goldXpKoeff};
	this.levelRangeSize = settings.levelRangeSize;
	this.orderTemplates = new com_nevosoft_waw_logic_systems_autoOrders_OrderTemplates(settings.orderTemplates);
};
com_nevosoft_waw_logic_systems_autoOrders_camping_CampingOrderGenerator.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_camping_CampingOrderGenerator.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_IOrderGenerator];
com_nevosoft_waw_logic_systems_autoOrders_camping_CampingOrderGenerator.prototype = {
	bindContext: function(context) {
		this.context = context;
	}
	,unBindContext: function() {
		this.context = null;
	}
	,generate: function(slotId,power) {
		var template = this.orderTemplates.chooseTemplate(this.context);
		var choiceSet = com_nevosoft_waw_logic_systems_autoOrders_OrderTemplate.getChoiceSet(template,this.context);
		var powerAdopted = power * template.powerKoeff;
		var choosenItems = com_nevosoft_waw_logic_systems_autoOrders_OrderTemplate.chooseItems(template,choiceSet,this.context.randomProvider);
		var rawData = com_nevosoft_waw_logic_systems_autoOrders_OrderCalculations.calculateOrderDemand(choosenItems,powerAdopted);
		var _g = [];
		var _g1 = 0;
		var _g2 = choosenItems.length;
		while(_g1 < _g2) {
			var i = _g1++;
			_g.push(rawData[i * 2 + 1]);
		}
		var amounts = _g;
		var orderInfo = { template : template, choosenItems : choosenItems, amounts : amounts};
		var reward = com_nevosoft_waw_logic_systems_autoOrders_OrderCalculations.generateReward(this.context,orderInfo,this.settings,this.globalParams);
		return { id : slotId, rawData : rawData, power : 1.0, reward : reward, templateId : template.id};
	}
	,chooseItems: function(capacity) {
		var _g = [];
		var _g1 = 0;
		var _g2 = capacity;
		while(_g1 < _g2) {
			var i = _g1++;
			_g.push(this.demandChoiceSet.chooseNext());
		}
		return _g;
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_camping_CampingOrderGenerator
};
var com_nevosoft_waw_logic_systems_autoOrders_camping_CampingPowerGenerator = function() {
};
com_nevosoft_waw_logic_systems_autoOrders_camping_CampingPowerGenerator.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_camping_CampingPowerGenerator.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_ITotalPowerGenerator];
com_nevosoft_waw_logic_systems_autoOrders_camping_CampingPowerGenerator.prototype = {
	generate: function(context) {
		var userLevelConfig = context.userLevelConfig;
		var powerKoeff = userLevelConfig.campingPowerKoeff;
		var rangeMin = Math.floor(userLevelConfig.minPower * powerKoeff);
		var rangeMax = Math.floor(userLevelConfig.maxPower * powerKoeff);
		return com_nevosoft_isoframework_utils_MathUtils.getRandomValue(rangeMin,rangeMax,context.randomProvider);
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_camping_CampingPowerGenerator
};
var com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ChoiceSetFactory = function() { };
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ChoiceSetFactory.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ChoiceSetFactory.createForTemplate = function(templateType,context) {
	switch(templateType) {
	case 1:
		return new com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourcesForSale(context);
	case 2:
		if(context.posState.id == 4) {
			return new com_nevosoft_waw_logic_systems_autoOrders_choiceSets_OnLocation(context,new com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourcesForCamping(context));
		} else {
			return new com_nevosoft_waw_logic_systems_autoOrders_choiceSets_OnLocation(context,new com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourcesForSale(context));
		}
		break;
	case 3:
		return new com_nevosoft_waw_logic_systems_autoOrders_choiceSets_VideoToken(context);
	}
};
var com_nevosoft_waw_logic_systems_autoOrders_choiceSets_OnLocation = function(context,choiceSet) {
	this.context = context;
	this.choiceSet = choiceSet;
};
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_OnLocation.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_OnLocation.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_IChoiceSet];
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_OnLocation.prototype = {
	chooseNext: function() {
		var result = null;
		var firstTry = null;
		while(result == null) {
			var candidate = this.choiceSet.chooseNext();
			if(firstTry == candidate) {
				result = firstTry;
			}
			if(firstTry == null) {
				firstTry = candidate;
			}
			var resourceId = candidate.id;
			if(!this.hasSourceOnLocation(resourceId)) {
				continue;
			}
			result = candidate;
		}
		if(result == null) {
			throw haxe_Exception.thrown("NotFound");
		}
		return result;
	}
	,hasSourceOnLocation: function(resourceId) {
		var metaIds = this.context.dataProvider.meta.getStuffProdSource(resourceId);
		var _g = 0;
		while(_g < metaIds.length) {
			var metaId = metaIds[_g];
			++_g;
			var meta = this.context.dataProvider.mapObjects.getMeta(metaId);
			if(meta.category == "PLANT") {
				return true;
			}
			if(meta.category == "ANIMAL") {
				return true;
			}
			var homeLocation = this.context.dataProvider.getHomeLocation();
			var objects = this.context.dataProvider.location.filterMapObjects({ metaId : metaId},homeLocation);
			var _g1 = 0;
			while(_g1 < objects.length) {
				var o = objects[_g1];
				++_g1;
				if(this.canProduceResource(o,meta,resourceId)) {
					return true;
				}
			}
		}
		return false;
	}
	,canProduceResource: function(o,meta,resourceId) {
		var buildingLevel = this.context.dataProvider.mapObjects.getLevel(o);
		var _g = 1;
		var _g1 = buildingLevel + 1;
		while(_g < _g1) {
			var lvl = _g++;
			var production = this.context.dataProvider.actions.getProductionAtLevel(meta,lvl);
			if(com_nevosoft_waw_data_types_TCost.hasKey(production.reward,resourceId)) {
				return true;
			}
		}
		return false;
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_choiceSets_OnLocation
};
var com_nevosoft_waw_logic_systems_autoOrders_choiceSets_QuestConditionBlueprintChoiceSet = function(context,levelRangeSize) {
	this.context = context;
	this.levelRangeSize = levelRangeSize;
	this.choiceSet = [];
	this.buildNotEmptyChoiceSet();
};
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_QuestConditionBlueprintChoiceSet.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_QuestConditionBlueprintChoiceSet.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_IChoiceSet];
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_QuestConditionBlueprintChoiceSet.prototype = {
	chooseNext: function() {
		this.buildNotEmptyChoiceSet();
		var blueprint = com_nevosoft_isoframework_utils_MathUtils.randomChoice(this.choiceSet,this.context.randomProvider);
		this.context.posState.usedObjectIds.push(blueprint.id);
		HxOverrides.remove(this.choiceSet,blueprint);
		return blueprint;
	}
	,buildNotEmptyChoiceSet: function() {
		if(this.choiceSet.length > 0) {
			return;
		}
		this.buildChoiceSet();
		if(this.choiceSet.length == 0) {
			this.context.posState.usedObjectIds = [];
			this.buildNotEmptyChoiceSet();
		}
		this.sortChoiceSet();
	}
	,buildChoiceSet: function() {
		this.choiceSet = [];
		var dataProvider = this.context.dataProvider;
		var posState = this.context.posState;
		var stage = posState.genCounter;
		var level = dataProvider.getCurrentLevel();
		var questConditions = this.context.dataProvider.getMetaIndex().questConditionBluePrints;
		var availableProductions = this.context.dataProvider.location.getAllUnlockedProductions(true);
		var availableProductionsMap_h = { };
		var availableResourcesMap_h = { };
		var availableBuildings_h = { };
		var _g = 0;
		while(_g < availableProductions.length) {
			var p = availableProductions[_g];
			++_g;
			availableProductionsMap_h[p.id] = 1;
			availableBuildings_h[dataProvider.getMetaIndex().actionOwners.h[p.id]] = 1;
			var _g1 = 0;
			var _g2 = com_nevosoft_waw_data_types_TCost.getMainResources(p.reward);
			while(_g1 < _g2.length) {
				var resourceId = _g2[_g1];
				++_g1;
				availableResourcesMap_h[resourceId] = 1;
			}
		}
		var rangeFilteredConditions = questConditions.unlocksOnLevelRange(level - this.levelRangeSize,level);
		var bp = rangeFilteredConditions;
		while(bp.hasNext()) {
			var bp1 = bp.next();
			if(!this.isAvailableOnStage(bp1,stage)) {
				continue;
			}
			if(this.isLevelRangeCondition(bp1.conditionTypeId)) {
				if(this.context.posState.usedObjectIds.indexOf(bp1.id) < 0) {
					switch(bp1.conditionTypeId) {
					case 12:
						if(!availableResourcesMap_h.hasOwnProperty(bp1.param)) {
							continue;
						}
						break;
					case 66:
						if(!availableProductionsMap_h.hasOwnProperty(bp1.param)) {
							continue;
						}
						break;
					default:
					}
					this.choiceSet.push(bp1);
				}
			}
		}
		var otherConditions = questConditions.availableOnLevel(level);
		var bp = otherConditions;
		while(bp.hasNext()) {
			var bp1 = bp.next();
			if(!this.isAvailableOnStage(bp1,stage)) {
				continue;
			}
			if(!this.isLevelRangeCondition(bp1.conditionTypeId)) {
				switch(bp1.conditionTypeId) {
				case 4:
					var metaIds = dataProvider.meta.getMetaIdsByCategory("ZEPPELIN");
					if(metaIds == null || dataProvider.location.areAllBroken(metaIds[0])) {
						continue;
					}
					break;
				case 55:case 68:
					var metaId = bp1.param;
					var objMeta = dataProvider.meta.getGameObjectMeta(metaId);
					if(com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged("go_pet",objMeta) || objMeta != null && objMeta.periodicalRewardComponent != null) {
						continue;
					}
					break;
				case 63:
					var metaId1 = dataProvider.getMetaIndex().actionOwners.h[bp1.param];
					var objMeta1 = dataProvider.meta.getGameObjectMeta(metaId1);
					if(com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged("go_pet",objMeta1) || objMeta1 != null && objMeta1.periodicalRewardComponent != null) {
						continue;
					}
					break;
				case 70:
					var metaId2 = bp1.param;
					if(!availableBuildings_h.hasOwnProperty(metaId2)) {
						continue;
					}
					var objMeta2 = dataProvider.meta.getGameObjectMeta(metaId2);
					if(com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged("go_pet",objMeta2) || objMeta2 != null && objMeta2.periodicalRewardComponent != null) {
						continue;
					}
					break;
				default:
				}
				if(this.context.posState.usedObjectIds.indexOf(bp1.id) < 0) {
					this.choiceSet.push(bp1);
				}
			}
		}
	}
	,sortChoiceSet: function() {
		this.choiceSet.sort(function(a,b) {
			return a.id - b.id;
		});
	}
	,isLevelRangeCondition: function(conditionTypeId) {
		if(!(conditionTypeId == 66 || conditionTypeId == 12)) {
			return conditionTypeId == 57;
		} else {
			return true;
		}
	}
	,isAvailableOnStage: function(blueprint,stage) {
		if(blueprint.stages == null) {
			return true;
		} else {
			return blueprint.stages[stage];
		}
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_choiceSets_QuestConditionBlueprintChoiceSet
};
var com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourceItem = function() {
};
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourceItem.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourceItem.prototype = {
	__class__: com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourceItem
};
var com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourcesForCamping = function(context) {
	this.context = context;
	this.choiceSet = new haxe_ds_IntMap();
	this.buildNotEmptyChoiceSet();
};
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourcesForCamping.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourcesForCamping.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_IChoiceSet];
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourcesForCamping.prototype = {
	chooseNext: function() {
		this.buildNotEmptyChoiceSet();
		var randomDeep = this.getRandomGroup(this.choiceSet,this.context.randomProvider);
		var item = this.getRandomItem(this.choiceSet.h[randomDeep],this.context.randomProvider);
		this.context.posState.usedGroups.push(randomDeep);
		this.context.posState.usedObjectIds.push(item.id);
		if(HxOverrides.remove(this.choiceSet.h[randomDeep],item)) {
			if(this.choiceSet.h[randomDeep].length == 0) {
				this.choiceSet.remove(randomDeep);
			}
		}
		return item;
	}
	,buildNotEmptyChoiceSet: function() {
		if(Lambda.count(this.choiceSet) > 0) {
			return;
		}
		this.buildChoiceSet();
		if(Lambda.count(this.choiceSet) == 0) {
			this.context.posState.usedGroups = [];
			this.buildChoiceSet();
			if(Lambda.count(this.choiceSet) == 0) {
				this.context.posState.usedObjectIds = [];
				this.buildChoiceSet();
			}
			if(Lambda.count(this.choiceSet) == 0) {
				throw haxe_Exception.thrown("no choice at all");
			}
		}
		var k = this.choiceSet.keys();
		while(k.hasNext()) {
			var k1 = k.next();
			this.choiceSet.h[k1].sort(function(a,b) {
				return a.id - b.id;
			});
		}
	}
	,buildChoiceSet: function() {
		this.choiceSet = new haxe_ds_IntMap();
		var dataProvider = this.context.dataProvider;
		var posState = this.context.posState;
		var level = dataProvider.getCurrentLevel();
		var usedDeeps_h = { };
		var _g = 0;
		var _g1 = this.context.posState.usedGroups;
		while(_g < _g1.length) {
			var g = _g1[_g];
			++_g;
			usedDeeps_h[g] = 1;
		}
		var usedObjects_h = { };
		var _g = 0;
		var _g1 = this.context.posState.usedObjectIds;
		while(_g < _g1.length) {
			var o = _g1[_g];
			++_g;
			usedObjects_h[o] = 1;
		}
		var gameObject = this.context.dataProvider.getMetaIndex().gameObjectUnlocks.availableOnLevel(level);
		while(gameObject.hasNext()) {
			var gameObject1 = gameObject.next();
			if(gameObject1.resourceComponent != null) {
				var id = gameObject1.id;
				var max = this.getMaxForPointOfSale(gameObject1.resourceComponent);
				if(max == 0) {
					continue;
				}
				var this1 = dataProvider.meta.getStuffDeep(id);
				var deep = this1 != null ? this1 : 0;
				if(usedDeeps_h.hasOwnProperty(deep) || usedObjects_h.hasOwnProperty(id)) {
					continue;
				}
				var this2 = gameObject1.resourceComponent.weightCustom;
				var weight = this2 != null ? this2 : 0.0;
				if(weight > 0) {
					var item = new com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourceItem();
					item.id = id;
					item.max = max;
					item.weight = weight;
					if(!this.choiceSet.h.hasOwnProperty(deep)) {
						var v = [];
						this.choiceSet.h[deep] = v;
					}
					this.choiceSet.h[deep].push(item);
				}
			}
		}
	}
	,getRandomGroup: function(choiceSet,randomProvider) {
		var groups = com_nevosoft_waw_core_utils_ContainerUtils.getSortedKeys(choiceSet);
		return com_nevosoft_isoframework_utils_MathUtils.randomChoice(groups,randomProvider);
	}
	,getRandomItem: function(items,randomProvider) {
		return com_nevosoft_isoframework_utils_MathUtils.randomChoice(items,randomProvider);
	}
	,getMaxForPointOfSale: function(resource) {
		var this1 = resource.campingMax;
		var maxValue = this1 != null ? this1 : -1;
		return maxValue;
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourcesForCamping
};
var com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourcesForSale = function(context) {
	this.context = context;
	this.choiceSet = new haxe_ds_IntMap();
	this.buildNotEmptyChoiceSet();
};
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourcesForSale.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourcesForSale.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_IChoiceSet];
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourcesForSale.prototype = {
	chooseNext: function() {
		this.buildNotEmptyChoiceSet();
		var randomDeep = this.getRandomGroup(this.choiceSet,this.context.randomProvider);
		var item = this.getRandomItem(this.choiceSet.h[randomDeep],this.context.randomProvider);
		this.context.posState.usedGroups.push(randomDeep);
		this.context.posState.usedObjectIds.push(item.id);
		if(HxOverrides.remove(this.choiceSet.h[randomDeep],item)) {
			if(this.choiceSet.h[randomDeep].length == 0) {
				this.choiceSet.remove(randomDeep);
			}
		}
		return item;
	}
	,buildNotEmptyChoiceSet: function() {
		if(Lambda.count(this.choiceSet) > 0) {
			return;
		}
		this.buildChoiceSet();
		if(Lambda.count(this.choiceSet) == 0) {
			this.context.posState.usedGroups = [];
			this.buildChoiceSet();
			if(Lambda.count(this.choiceSet) == 0) {
				this.context.posState.usedObjectIds = [];
				this.buildChoiceSet();
			}
			if(Lambda.count(this.choiceSet) == 0) {
				throw haxe_Exception.thrown("no choice at all");
			}
		}
		var k = this.choiceSet.keys();
		while(k.hasNext()) {
			var k1 = k.next();
			this.choiceSet.h[k1].sort(function(a,b) {
				return a.id - b.id;
			});
		}
	}
	,buildChoiceSet: function() {
		this.choiceSet = new haxe_ds_IntMap();
		var dataProvider = this.context.dataProvider;
		var posState = this.context.posState;
		var level = dataProvider.getCurrentLevel();
		var usedDeeps_h = { };
		var _g = 0;
		var _g1 = this.context.posState.usedGroups;
		while(_g < _g1.length) {
			var g = _g1[_g];
			++_g;
			usedDeeps_h[g] = 1;
		}
		var usedObjects_h = { };
		var _g = 0;
		var _g1 = this.context.posState.usedObjectIds;
		while(_g < _g1.length) {
			var o = _g1[_g];
			++_g;
			usedObjects_h[o] = 1;
		}
		var gameObject = this.context.dataProvider.getMetaIndex().gameObjectUnlocks.availableOnLevel(level);
		while(gameObject.hasNext()) {
			var gameObject1 = gameObject.next();
			if(gameObject1.resourceComponent != null) {
				var id = gameObject1.id;
				var max = this.getMaxForPointOfSale(gameObject1.resourceComponent,posState.id);
				if(max == 0) {
					continue;
				}
				var this1 = dataProvider.meta.getStuffDeep(id);
				var deep = this1 != null ? this1 : 0;
				if(usedDeeps_h.hasOwnProperty(deep) || usedObjects_h.hasOwnProperty(id)) {
					continue;
				}
				var this2 = gameObject1.resourceComponent.weightCustom;
				var weight = this2 != null ? this2 : 0.0;
				if(weight > 0) {
					var item = new com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourceItem();
					item.id = id;
					item.max = max;
					item.weight = weight;
					if(!this.choiceSet.h.hasOwnProperty(deep)) {
						var v = [];
						this.choiceSet.h[deep] = v;
					}
					this.choiceSet.h[deep].push(item);
				}
			}
		}
	}
	,getRandomGroup: function(choiceSet,randomProvider) {
		var groups = com_nevosoft_waw_core_utils_ContainerUtils.getSortedKeys(choiceSet);
		return com_nevosoft_isoframework_utils_MathUtils.randomChoice(groups,randomProvider);
	}
	,getRandomItem: function(items,randomProvider) {
		return com_nevosoft_isoframework_utils_MathUtils.randomChoice(items,randomProvider);
	}
	,getMaxForPointOfSale: function(resource,posId) {
		var maxValue;
		switch(posId) {
		case 1:
			var this1 = resource.marketMax;
			maxValue = this1 != null ? this1 : -1;
			break;
		case 2:
			var this1 = resource.zeppelinMax;
			maxValue = this1 != null ? this1 : -1;
			break;
		case 4:
			throw haxe_Exception.thrown("camp use his own ResourcesForCamping choice set");
		default:
			var this1 = resource.marketMax;
			maxValue = this1 != null ? this1 : -1;
		}
		return maxValue;
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourcesForSale
};
var com_nevosoft_waw_logic_systems_autoOrders_choiceSets_VideoToken = function(context) {
	this.context = context;
	var resource = this.context.dataProvider.meta.getStuffMeta(com_nevosoft_waw_data_constants_ResourceType.RESOURCE_TYPE_VIDEO_TOKEN);
	this.videoTokenItem = new com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourceItem();
	this.videoTokenItem.id = com_nevosoft_waw_data_constants_ResourceType.RESOURCE_TYPE_VIDEO_TOKEN;
	console.log("src/com/nevosoft/waw/logic/systems/autoOrders/choiceSets/VideoToken.hx:20:",resource);
	var this1 = resource.marketMax;
	this.videoTokenItem.max = this1 != null ? this1 : -1;
	var this1 = resource.weightCustom;
	this.videoTokenItem.weight = this1 != null ? this1 : 1.0;
	console.log("src/com/nevosoft/waw/logic/systems/autoOrders/choiceSets/VideoToken.hx:24:",this.videoTokenItem);
};
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_VideoToken.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_VideoToken.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_IChoiceSet];
com_nevosoft_waw_logic_systems_autoOrders_choiceSets_VideoToken.prototype = {
	chooseNext: function() {
		return this.videoTokenItem;
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_choiceSets_VideoToken
};
var com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestOrderGenerator = function(settings,goldXpKoeff) {
	this.settings = settings;
	this.goldXpKoeff = goldXpKoeff;
	this.levelRangeSize = settings.levelRangeSize;
};
com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestOrderGenerator.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestOrderGenerator.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_IOrderGenerator];
com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestOrderGenerator.prototype = {
	bindContext: function(context) {
		this.context = context;
		this.choiceSet = new com_nevosoft_waw_logic_systems_autoOrders_choiceSets_QuestConditionBlueprintChoiceSet(context,this.levelRangeSize);
	}
	,unBindContext: function() {
		this.context = null;
	}
	,generate: function(slotId,power) {
		var item = this.choiceSet.chooseNext();
		var amount = this.calculateAmount(power,item);
		var rawData = [item.conditionTypeId,amount,item.param];
		var reward = this.generateReward(Math.floor((slotId - 1) / 3));
		return { id : slotId, rawData : rawData, power : power, reward : reward};
	}
	,calculateAmount: function(power,item) {
		var min = 1;
		var max = item.dailyMax > 0 ? item.dailyMax : 100;
		return Math.floor(com_nevosoft_isoframework_utils_MathUtils.clamp(power / item.prodTime,min,max));
	}
	,generateReward: function(stage) {
		var levelConfig = this.context.userLevelConfig;
		var randomizer = this.randomInRange(levelConfig.minPower,levelConfig.maxPower);
		var rewardKoeff = this.settings.stageRewardKoeffs[stage];
		var goldAmount = randomizer * levelConfig.dailyQuestPowerKoeff * rewardKoeff;
		var xpAmount = goldAmount * this.goldXpKoeff;
		var result = { };
		var value = Math.floor(Math.max(1.0,goldAmount));
		result["" + (-1)] = value;
		var value = Math.floor(Math.max(1.0,xpAmount));
		result["" + (-4)] = value;
		return result;
	}
	,randomInRange: function(min,max) {
		return com_nevosoft_isoframework_utils_MathUtils.getRandomValue2(min,max,this.context.randomProvider);
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestOrderGenerator
};
var com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestPowerDistributor = function() {
};
com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestPowerDistributor.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestPowerDistributor.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_IPowerDistributor];
com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestPowerDistributor.prototype = {
	distribute: function(context) {
		var posState = context.posState;
		var stageIndex = posState.genCounter;
		var result = [];
		var settings = context.dataProvider.pointsOfSale.getDailyQuestSettings();
		var daytime = settings.daytime;
		var questKoeff = settings.questKoeffs[0];
		if(posState.slots[0] == null) {
			result.push(Math.floor(daytime * questKoeff));
		}
		var questKoeff = settings.questKoeffs[1];
		if(posState.slots[1] == null) {
			result.push(Math.floor(daytime * questKoeff));
		}
		var questKoeff = settings.questKoeffs[2];
		if(posState.slots[2] == null) {
			result.push(Math.floor(daytime * questKoeff));
		}
		var questKoeff = settings.questKoeffs[3];
		if(posState.slots[3] == null) {
			result.push(Math.floor(daytime * questKoeff));
		}
		var questKoeff = settings.questKoeffs[4];
		if(posState.slots[4] == null) {
			result.push(Math.floor(daytime * questKoeff));
		}
		var questKoeff = settings.questKoeffs[5];
		if(posState.slots[5] == null) {
			result.push(Math.floor(daytime * questKoeff));
		}
		var questKoeff = settings.questKoeffs[6];
		if(posState.slots[6] == null) {
			result.push(Math.floor(daytime * questKoeff));
		}
		var questKoeff = settings.questKoeffs[7];
		if(posState.slots[7] == null) {
			result.push(Math.floor(daytime * questKoeff));
		}
		var questKoeff = settings.questKoeffs[8];
		if(posState.slots[8] == null) {
			result.push(Math.floor(daytime * questKoeff));
		}
		return result;
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestPowerDistributor
};
var com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestPowerGenerator = function(cycleIncreaseKoeff) {
	this.incKoeff = cycleIncreaseKoeff;
};
com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestPowerGenerator.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestPowerGenerator.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_ITotalPowerGenerator];
com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestPowerGenerator.prototype = {
	generate: function(context) {
		var cycle = context.posState.genCounter;
		var userLevelConfig = context.userLevelConfig;
		var powerKoeff = userLevelConfig.dailyQuestPowerKoeff;
		var rangeMin = userLevelConfig.minPower * powerKoeff;
		var rangeMax = userLevelConfig.maxPower * powerKoeff;
		var power = com_nevosoft_isoframework_utils_MathUtils.getRandomValue(rangeMin,rangeMax,context.randomProvider);
		power += cycle * this.incKoeff * power;
		return Math.ceil(power);
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_dailyQuest_DailyQuestPowerGenerator
};
var com_nevosoft_waw_logic_systems_autoOrders_market_MarketOrderGenerator = function(settings,attributes,goldXpKoeff,productionTimeBonus) {
	this.attributes = attributes;
	this.rewardKoeff = attributes.rewardKoeff;
	this.orderTemplates = new com_nevosoft_waw_logic_systems_autoOrders_OrderTemplates(settings.templates);
	this.globalParams = { productionTimeBonus : productionTimeBonus, goldXpKoeff : goldXpKoeff};
};
com_nevosoft_waw_logic_systems_autoOrders_market_MarketOrderGenerator.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_market_MarketOrderGenerator.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_IOrderGenerator];
com_nevosoft_waw_logic_systems_autoOrders_market_MarketOrderGenerator.prototype = {
	bindContext: function(context) {
		this.context = context;
	}
	,unBindContext: function() {
		this.context = null;
	}
	,generate: function(slotId,power) {
		var template = this.orderTemplates.chooseTemplate(this.context);
		var choiceSet = com_nevosoft_waw_logic_systems_autoOrders_OrderTemplate.getChoiceSet(template,this.context);
		var powerAdopted = power * template.powerKoeff;
		var choosenItems = com_nevosoft_waw_logic_systems_autoOrders_OrderTemplate.chooseItems(template,choiceSet,this.context.randomProvider);
		var rawData = com_nevosoft_waw_logic_systems_autoOrders_OrderCalculations.calculateOrderDemand(choosenItems,powerAdopted);
		var _g = [];
		var _g1 = 0;
		var _g2 = choosenItems.length;
		while(_g1 < _g2) {
			var i = _g1++;
			_g.push(rawData[i * 2 + 1]);
		}
		var amounts = _g;
		var orderInfo = { template : template, choosenItems : choosenItems, amounts : amounts};
		var reward = com_nevosoft_waw_logic_systems_autoOrders_OrderCalculations.generateReward(this.context,orderInfo,this.attributes,this.globalParams);
		var result = { id : slotId, rawData : rawData, power : Math.floor(powerAdopted), reward : reward, templateId : template.id};
		return result;
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_market_MarketOrderGenerator
};
var com_nevosoft_waw_logic_systems_autoOrders_market_MarketPowerDistributor = function() {
};
com_nevosoft_waw_logic_systems_autoOrders_market_MarketPowerDistributor.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_market_MarketPowerDistributor.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_IPowerDistributor];
com_nevosoft_waw_logic_systems_autoOrders_market_MarketPowerDistributor.prototype = {
	distribute: function(context) {
		var userLevelConfig = context.userLevelConfig;
		var posState = context.posState;
		var powerKoeff = userLevelConfig.marketPowerKoeff;
		var min = userLevelConfig.minPower * powerKoeff / posState.slots.length;
		var max = userLevelConfig.maxPower * powerKoeff / posState.slots.length;
		var _g = [];
		var _g1 = 0;
		var _g2 = posState.slots;
		while(_g1 < _g2.length) {
			var slot = _g2[_g1];
			++_g1;
			if(slot == null) {
				_g.push(this.getSlotPower(min,max,context.randomProvider));
			}
		}
		return _g;
	}
	,getSlotPower: function(min,max,randomProvider) {
		return Math.floor(com_nevosoft_isoframework_utils_MathUtils.getRandomValue(min,max,randomProvider));
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_market_MarketPowerDistributor
};
var com_nevosoft_waw_logic_systems_autoOrders_market_MarketPowerGenerator = function() {
};
com_nevosoft_waw_logic_systems_autoOrders_market_MarketPowerGenerator.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_market_MarketPowerGenerator.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_ITotalPowerGenerator];
com_nevosoft_waw_logic_systems_autoOrders_market_MarketPowerGenerator.prototype = {
	generate: function(context) {
		var userLevelConfig = context.userLevelConfig;
		var powerKoeff = userLevelConfig.marketPowerKoeff;
		var rangeMin = Math.floor(userLevelConfig.minPower * powerKoeff);
		var rangeMax = Math.floor(userLevelConfig.maxPower * powerKoeff);
		return com_nevosoft_isoframework_utils_MathUtils.getRandomValue(rangeMin,rangeMax,context.randomProvider);
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_market_MarketPowerGenerator
};
var com_nevosoft_waw_logic_systems_autoOrders_market_MarketSlotsCountProvider = function() {
};
com_nevosoft_waw_logic_systems_autoOrders_market_MarketSlotsCountProvider.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_market_MarketSlotsCountProvider.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_ISlotsCountProvider];
com_nevosoft_waw_logic_systems_autoOrders_market_MarketSlotsCountProvider.prototype = {
	getSlotsCount: function(context) {
		return context.dataProvider.pointsOfSale.getMarketSlotsCount();
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_market_MarketSlotsCountProvider
};
var com_nevosoft_waw_logic_systems_autoOrders_market_OrdersHostGenerator = function(settings,goldXpKoeff,productionTimeBonus) {
	this.settings = settings;
	this.orderTemplates = new com_nevosoft_waw_logic_systems_autoOrders_OrderTemplates(settings.templates);
	this.globalParams = { productionTimeBonus : productionTimeBonus, goldXpKoeff : goldXpKoeff};
};
com_nevosoft_waw_logic_systems_autoOrders_market_OrdersHostGenerator.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_market_OrdersHostGenerator.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_IOrderGenerator];
com_nevosoft_waw_logic_systems_autoOrders_market_OrdersHostGenerator.prototype = {
	bindContext: function(context) {
		this.context = context;
	}
	,unBindContext: function() {
		this.context = null;
	}
	,generate: function(slotId,power) {
		var template = this.orderTemplates.chooseTemplate(this.context);
		var choiceSet = com_nevosoft_waw_logic_systems_autoOrders_OrderTemplate.getChoiceSet(template,this.context);
		var powerAdopted = power * template.powerKoeff;
		var choosenItems = com_nevosoft_waw_logic_systems_autoOrders_OrderTemplate.chooseItems(template,choiceSet,this.context.randomProvider);
		var rawData = com_nevosoft_waw_logic_systems_autoOrders_OrderCalculations.calculateOrderDemand(choosenItems,powerAdopted);
		var _g = [];
		var _g1 = 0;
		var _g2 = choosenItems.length;
		while(_g1 < _g2) {
			var i = _g1++;
			_g.push(rawData[i * 2 + 1]);
		}
		var amounts = _g;
		var orderInfo = { template : template, choosenItems : choosenItems, amounts : amounts};
		var rewardSettings = { xpKoeffMin : 0.0, xpKoeffMax : 0.0, rewardKoeff : 0.0, goldKoeffMin : 0.0, goldKoeffMax : 0.0};
		var reward = com_nevosoft_waw_logic_systems_autoOrders_OrderCalculations.generateReward(this.context,orderInfo,rewardSettings,this.globalParams);
		var result = { id : slotId, rawData : rawData, power : Math.floor(powerAdopted), reward : reward, templateId : template.id};
		return result;
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_market_OrdersHostGenerator
};
var com_nevosoft_waw_logic_systems_autoOrders_market_OrdersHostPowerGenerator = function(powerKoeff) {
	this.powerKoeff = powerKoeff;
};
com_nevosoft_waw_logic_systems_autoOrders_market_OrdersHostPowerGenerator.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_market_OrdersHostPowerGenerator.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_ITotalPowerGenerator];
com_nevosoft_waw_logic_systems_autoOrders_market_OrdersHostPowerGenerator.prototype = {
	generate: function(context) {
		var userLevelConfig = context.userLevelConfig;
		var rangeMin = Math.floor(userLevelConfig.minPower * this.powerKoeff);
		var rangeMax = Math.floor(userLevelConfig.maxPower * this.powerKoeff);
		return com_nevosoft_isoframework_utils_MathUtils.getRandomValue(rangeMin,rangeMax,context.randomProvider);
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_market_OrdersHostPowerGenerator
};
var com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_IRewardGenerator = function() { };
com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_IRewardGenerator.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_IRewardGenerator.__isInterface__ = true;
com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_IRewardGenerator.prototype = {
	__class__: com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_IRewardGenerator
};
var com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_DailyQuestRewardGenerator = function() {
};
com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_DailyQuestRewardGenerator.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_DailyQuestRewardGenerator.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_IRewardGenerator];
com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_DailyQuestRewardGenerator.prototype = {
	generate: function(context,power) {
		var posState = context.posState;
		var settings = context.dataProvider.pointsOfSale.getDailyQuestSettings();
		var chests = settings.chests;
		return context.chooseRewardStrategy.forDailyQuest(chests[posState.genCounter]);
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_DailyQuestRewardGenerator
};
var com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_RewardByTemplate = function() { };
com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_RewardByTemplate.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_RewardByTemplate.generate = function(template,randomProvider) {
	var result = { };
	var rewardKeys = com_nevosoft_waw_data_types_TCost.keys(template.reward);
	com_nevosoft_isoframework_utils_MathUtils.shuffleArray_Int(rewardKeys,rewardKeys.length,randomProvider);
	var _g = 0;
	var _g1 = template.slotsCount;
	while(_g < _g1) {
		var i = _g++;
		var resourceId = rewardKeys.pop();
		var this1 = template.reward;
		var value = com_nevosoft_waw_data_types_TCost.hasKey(this1,resourceId) ? Reflect.field(this1,resourceId == null ? "null" : "" + resourceId) : 0;
		result[resourceId == null ? "null" : "" + resourceId] = value;
	}
	return result;
};
var com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_ZeppelinTotalRewardGenerator = function(rewardKoeff,overallRewardKoeff) {
	this.rewardKoeff = rewardKoeff;
	this.overallRewardKoeff = overallRewardKoeff;
};
com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_ZeppelinTotalRewardGenerator.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_ZeppelinTotalRewardGenerator.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_IRewardGenerator];
com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_ZeppelinTotalRewardGenerator.prototype = {
	generate: function(context,power) {
		var posState = context.posState;
		var goldTotal = 0;
		var xpTotal = 0;
		var _g = 0;
		var _g1 = posState.slots;
		while(_g < _g1.length) {
			var slot = _g1[_g];
			++_g;
			if(slot == null) {
				throw haxe_Exception.thrown("all slot must exist for zeppelinTotalReward calculation");
			}
			var reward = slot.reward;
			var this1 = reward;
			goldTotal += com_nevosoft_waw_data_types_TCost.hasKey(this1,-1) ? Reflect.field(this1,"-1") : 0;
			var this2 = reward;
			xpTotal += com_nevosoft_waw_data_types_TCost.hasKey(this2,-4) ? Reflect.field(this2,"-4") : 0;
		}
		var goldAmount = Math.floor(Math.max(1.0,goldTotal * this.overallRewardKoeff / this.rewardKoeff));
		var xpAmount = Math.floor(Math.max(1.0,xpTotal * this.overallRewardKoeff / this.rewardKoeff));
		var result = { };
		result["" + (-1)] = goldAmount;
		result["" + (-4)] = xpAmount;
		return result;
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_ZeppelinTotalRewardGenerator
};
var com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinOrderGenerator = function(settings,goldXpKoeff,productionTimeBonus) {
	this.xpKoeffMax = 1.0;
	this.xpKoeffMin = 1.0;
	this.goldKoeffMax = 1.0;
	this.goldKoeffMin = 1.0;
	this.goldXpKoeff = 1.0;
	this.settings = settings;
	this.goldXpKoeff = goldXpKoeff;
	this.goldKoeffMin = settings.goldKoeffMin;
	this.goldKoeffMax = settings.goldKoeffMax;
	this.xpKoeffMin = settings.xpKoeffMin;
	this.xpKoeffMax = settings.xpKoeffMax;
	this.productionTimeBonus = productionTimeBonus;
};
com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinOrderGenerator.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinOrderGenerator.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_IOrderGenerator];
com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinOrderGenerator.prototype = {
	bindContext: function(context) {
		this.context = context;
		this.lastChoosedItem = null;
		this.demandChoiceSet = new com_nevosoft_waw_logic_systems_autoOrders_choiceSets_ResourcesForSale(context);
	}
	,unBindContext: function() {
		this.context = null;
		this.demandChoiceSet = null;
	}
	,generate: function(slotId,power) {
		var item = this.chooseItemForSlot(slotId);
		var rawOrderData = this.getRawOrderData(item,power);
		var amount = rawOrderData[1];
		var reward = this.generateReward(item,amount);
		var result = { id : slotId, rawData : rawOrderData, power : power, reward : reward};
		return result;
	}
	,generateReward: function(item,amount) {
		var goldAmount = 0.0;
		var xpAmount = 0.0;
		var metaDataProvider = this.context.dataProvider.meta;
		var resourceId = item.id;
		var weightCustom = item.weight;
		var prodTimeInMinutes = metaDataProvider.getStuffTime(resourceId) / 60;
		var deep = metaDataProvider.getStuffDeep(resourceId);
		var deepKoeff = deep > 0 ? parseFloat(metaDataProvider.getConst("deepTable" + deep)) : 1.0;
		goldAmount = (weightCustom + prodTimeInMinutes * this.productionTimeBonus) * deepKoeff * this.settings.rewardKoeff * this.goldRewardRandomizer * amount;
		xpAmount = weightCustom * this.goldXpKoeff * this.settings.rewardKoeff * this.xpRewardRandomizer * amount;
		var result = { };
		var value = Math.floor(Math.max(1.0,goldAmount));
		result["" + (-1)] = value;
		var value = Math.floor(Math.max(1.0,xpAmount));
		result["" + (-4)] = value;
		return result;
	}
	,chooseItemForSlot: function(slotId) {
		var index = slotId - 1;
		if(this.slotSellsNewResource(index)) {
			this.lastChoosedItem = this.demandChoiceSet.chooseNext();
			this.goldRewardRandomizer = this.randomInRange(this.goldKoeffMin,this.goldKoeffMax);
			this.xpRewardRandomizer = this.randomInRange(this.xpKoeffMin,this.xpKoeffMax);
		}
		return this.lastChoosedItem;
	}
	,slotSellsNewResource: function(index) {
		return index % 3 == 0;
	}
	,getRawOrderData: function(item,power) {
		var resId = item.id;
		var resAmount = power / item.weight;
		if(item.max > 0) {
			resAmount = Math.max(1.0,Math.min(resAmount,item.max));
		}
		return [resId,Math.floor(resAmount),0];
	}
	,randomInRange: function(min,max) {
		return com_nevosoft_isoframework_utils_MathUtils.getRandomValue2(min,max,this.context.randomProvider);
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinOrderGenerator
};
var com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinPowerGenerator = function() {
};
com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinPowerGenerator.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinPowerGenerator.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_ITotalPowerGenerator];
com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinPowerGenerator.prototype = {
	generate: function(context) {
		var userLevelConfig = context.userLevelConfig;
		var powerKoeff = userLevelConfig.zeppelinPowerKoeff;
		var rangeMin = Math.floor(userLevelConfig.minPower * powerKoeff);
		var rangeMax = Math.floor(userLevelConfig.maxPower * powerKoeff);
		return com_nevosoft_isoframework_utils_MathUtils.getRandomValue(rangeMin,rangeMax,context.randomProvider);
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinPowerGenerator
};
var com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinSlotsCountProvider = function() {
};
com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinSlotsCountProvider.__name__ = true;
com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinSlotsCountProvider.__interfaces__ = [com_nevosoft_waw_logic_systems_autoOrders_ISlotsCountProvider];
com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinSlotsCountProvider.prototype = {
	getSlotsCount: function(context) {
		return context.userLevelConfig.zeppelinSlotCount;
	}
	,__class__: com_nevosoft_waw_logic_systems_autoOrders_zeppelin_ZeppelinSlotsCountProvider
};
var com_nevosoft_waw_logic_systems_drop_DropPack = function(config) {
	this.data = config;
	this.listeners = [];
	this.conditions = [];
	this._configureListeners();
};
com_nevosoft_waw_logic_systems_drop_DropPack.__name__ = true;
com_nevosoft_waw_logic_systems_drop_DropPack.prototype = {
	_configureListeners: function() {
		var _g = 0;
		var _g1 = this.data.triggers;
		while(_g < _g1.length) {
			var trigger = _g1[_g];
			++_g;
			var conditionType = trigger.type;
			var condition = com_nevosoft_waw_data_types_ConditionType.toEnum(conditionType,trigger.params);
			var matchFunc = com_nevosoft_waw_logic_systems_quests_QuestMatchFuncFactory.get(condition);
			this.conditions.push(condition);
			this.listeners.push(matchFunc);
		}
	}
	,__class__: com_nevosoft_waw_logic_systems_drop_DropPack
};
var com_nevosoft_waw_logic_systems_quests_AchievementEntity = function(input,dataProvider) {
	var _gthis = this;
	this.dataProvider = dataProvider;
	this.data = input.data;
	this.meta = input.meta;
	this.max = 0;
	this.isComplete = false;
	this.prevCounter = this.data.counter;
	var _g = 0;
	var _g1 = this.meta.stages.length;
	while(_g < _g1) {
		var i = _g++;
		var stage = this.meta.stages[i];
		this.max = stage.conditionValue;
	}
	this.isComplete = this.data.counter == this.max;
	if(this.isComplete) {
		return;
	}
	this.qCondition = com_nevosoft_waw_data_types_ConditionType.toEnum(this.meta.condition.type,this.meta.condition.params);
	var matchFunc = com_nevosoft_waw_logic_systems_quests_QuestMatchFuncFactory.get(this.qCondition);
	var handler = com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.create(this.qCondition);
	var isStateMove = com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.isStateMoveHandler(this.qCondition);
	this.listener = function(trigger) {
		if(matchFunc == null) {
			return false;
		}
		if(trigger == null || matchFunc(trigger)) {
			var count = handler(dataProvider,trigger);
			_gthis.data.counter = isStateMove ? count : _gthis.data.counter + count;
			return true;
		}
		return false;
	};
};
com_nevosoft_waw_logic_systems_quests_AchievementEntity.__name__ = true;
com_nevosoft_waw_logic_systems_quests_AchievementEntity.prototype = {
	validateStateHandlers: function(time) {
		if(this.isComplete) {
			return false;
		}
		if(com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.isStateMoveHandler(this.qCondition)) {
			this.listener(null);
		}
		return this.update(time);
	}
	,process: function(trigger,time) {
		if(this.isComplete) {
			return false;
		} else if(this.listener(trigger)) {
			return this.update(time);
		} else {
			return false;
		}
	}
	,getLastStageCompleted: function() {
		var lastStage = -1;
		var _g = 0;
		var _g1 = this.meta.stages.length;
		while(_g < _g1) {
			var i = _g++;
			var stage = this.meta.stages[i];
			if(this.data.counter < stage.conditionValue) {
				lastStage = i - 1;
				break;
			}
		}
		return lastStage;
	}
	,update: function(time) {
		var isUpdated = this.prevCounter != this.data.counter;
		this.prevCounter = this.data.counter;
		if(!com_nevosoft_waw_data_types_TCost.isEmpty(this.get_currentReward())) {
			this.data.rewardTime = time;
		}
		if(this.data.counter >= this.max) {
			this.isComplete = true;
			this.listener = null;
		}
		return isUpdated;
	}
	,get_currentLevel: function() {
		var result = Math.floor(com_nevosoft_isoframework_utils_MathUtils.clamp(this.data.lastRewardedStage + 1,0,this.meta.stages.length - 1));
		return result;
	}
	,get_currentReward: function() {
		return this.dataProvider.achievements.calculateCurrentReward(this.data,this.meta);
	}
	,get_maxOnCurrentLevel: function() {
		return this.meta.stages[this.get_currentLevel()].conditionValue;
	}
	,get_id: function() {
		return this.data.id;
	}
	,__class__: com_nevosoft_waw_logic_systems_quests_AchievementEntity
	,__properties__: {get_currentReward:"get_currentReward",get_currentLevel:"get_currentLevel",get_maxOnCurrentLevel:"get_maxOnCurrentLevel",get_id:"get_id"}
};
var com_nevosoft_waw_logic_systems_quests_CleanUpJobsFactory = function() { };
com_nevosoft_waw_logic_systems_quests_CleanUpJobsFactory.__name__ = true;
com_nevosoft_waw_logic_systems_quests_CleanUpJobsFactory.create = function(condition) {
	if(condition._hx_index == 23) {
		var params = condition.params;
		var resourceId = params.resource;
		return function(quest,index,dataProvider,isComplete,t) {
			com_nevosoft_waw_logic_systems_quests_CleanUpJobsFactory.removeResources(resourceId,quest,index,dataProvider,isComplete,t);
		};
	} else {
		return null;
	}
};
com_nevosoft_waw_logic_systems_quests_CleanUpJobsFactory.removeResources = function(resourceId,quest,index,dataProvider,isComplete,t) {
	if(isComplete) {
		var counter = quest.stages[index];
		com_nevosoft_waw_logic_systems_ResourcesLogic.Withdraw(t,com_nevosoft_waw_data_types_TCost.fromIdValue(resourceId,counter),com_nevosoft_waw_data_constants_ResourceChangeReason.EQuestCleaning(quest.id));
	}
};
var com_nevosoft_waw_logic_systems_quests_DailyQuestEntity = function(data,dataProvider) {
	this.lastStageUpdated = -1;
	this.type = 1;
	this.arcId = -1;
	this.data = data;
	this.dataProvider = dataProvider;
	this.posState = dataProvider.pointsOfSale.getState(3);
	this.posMeta = dataProvider.pointsOfSale.getDailyQuestSettings();
	this.stageStatus = [];
	this.validateOnData();
};
com_nevosoft_waw_logic_systems_quests_DailyQuestEntity.__name__ = true;
com_nevosoft_waw_logic_systems_quests_DailyQuestEntity.prototype = {
	validateOnData: function() {
		var currTaskClamped = this.get_currentTask() < 9 ? this.get_currentTask() : 8;
		var stageConfig = this.data.stages[currTaskClamped];
		this.currentEntity = new com_nevosoft_waw_logic_systems_quests_QuestEntity(stageConfig,this.dataProvider);
		this.validateStateHandlers();
		this.lastStageUpdated = -1;
		var _g = 0;
		var _g1 = this.data.stages.length;
		while(_g < _g1) {
			var i = _g++;
			this.stageStatus[i] = i < currTaskClamped;
			if(this.stageStatus[i]) {
				this.lastStageUpdated++;
			}
		}
		this.stageStatus[currTaskClamped] = this.currentEntity.get_isComplete();
	}
	,process: function(trigger) {
		var status = false;
		if(!this.currentEntity.get_isComplete()) {
			status = this.currentEntity.process(trigger);
		}
		if(this.currentEntity.get_isComplete() && !this.stageStatus[this.get_currentTask()]) {
			this.lastStageUpdated++;
		}
		this.stageStatus[this.get_currentTask()] = this.currentEntity.get_isComplete();
		return status;
	}
	,getLatsStageUpdated: function() {
		return this.lastStageUpdated;
	}
	,validateStateHandlers: function() {
		var status = false;
		if(!this.currentEntity.get_isComplete()) {
			status = this.currentEntity.validateStateHandlers();
		}
		return status;
	}
	,onDataUpdated: function(t,data) {
		this.data = data;
		this.validateOnData();
		t.questUpdated.push(this.get_id());
	}
	,cleanup: function() {
		this.data = null;
		this.stageStatus = null;
		this.currentEntity = com_nevosoft_isoframework_utils_CleanupUtils.cleanup(this.currentEntity);
	}
	,getCompleteTime: function() {
		return this.dataProvider.pointsOfSale.getDailyQuestExpireTime();
	}
	,get_isComplete: function() {
		var _g = this.get_currentStage() * 3;
		var _g1 = (this.get_currentStage() + 1) * 3;
		while(_g < _g1) {
			var i = _g++;
			if(!this.stageStatus[i]) {
				return false;
			}
		}
		return true;
	}
	,get_id: function() {
		return -1;
	}
	,get_currentTask: function() {
		return this.data.currentTask;
	}
	,get_currentStageReward: function() {
		return this.currentEntity.meta.rewards;
	}
	,get_opened: function() {
		return true;
	}
	,get_conditionValue: function() {
		return this.currentEntity.meta.stages[0].conditionValue;
	}
	,get_condition: function() {
		return this.currentEntity.stageConditions[0];
	}
	,get_counter: function() {
		return this.currentEntity.data.stages[0];
	}
	,get_changeCost: function() {
		if(this.posState.skips == 0) {
			return 0;
		} else {
			return this.posMeta.skipCost;
		}
	}
	,get_skips: function() {
		return this.posState.skips;
	}
	,get_currentStage: function() {
		return this.posState.genCounter;
	}
	,get_timeLeft: function() {
		var timeLeft = Math.floor(this.getCompleteTime() - this.dataProvider.getTime());
		if(timeLeft < 0) {
			timeLeft = 0;
		}
		if(this.get_currentTask() >= 9) {
			timeLeft = 0;
		}
		return timeLeft;
	}
	,get_isExpired: function() {
		return this.dataProvider.pointsOfSale.isDailyQuestExpired();
	}
	,get_shown: function() {
		return this.posState.shown;
	}
	,__class__: com_nevosoft_waw_logic_systems_quests_DailyQuestEntity
	,__properties__: {get_shown:"get_shown",get_isExpired:"get_isExpired",get_isComplete:"get_isComplete",get_currentTask:"get_currentTask",get_currentStage:"get_currentStage",get_skips:"get_skips",get_timeLeft:"get_timeLeft",get_changeCost:"get_changeCost",get_counter:"get_counter",get_conditionValue:"get_conditionValue",get_condition:"get_condition",get_currentStageReward:"get_currentStageReward",get_opened:"get_opened",get_id:"get_id"}
};
var com_nevosoft_waw_logic_systems_quests_QuestBuilder = function() { };
com_nevosoft_waw_logic_systems_quests_QuestBuilder.__name__ = true;
com_nevosoft_waw_logic_systems_quests_QuestBuilder.supportedConditionTypes = function() {
	return [3,4,13,61,28,29,55,68,66,12,63,70,57];
};
com_nevosoft_waw_logic_systems_quests_QuestBuilder.buildDailyQuest = function(t,posState) {
	var ctx = t.context;
	var stages = [];
	var _g = 0;
	var _g1 = posState.slots;
	while(_g < _g1.length) {
		var slot = _g1[_g];
		++_g;
		stages.push(com_nevosoft_waw_logic_systems_quests_QuestBuilder.buildDailyQuestStage(t,slot));
	}
	return { currentTask : 0, stages : stages, receiveTime : t.time, receiveGameTime : t.gameTime};
};
com_nevosoft_waw_logic_systems_quests_QuestBuilder.buildDailyQuestStage = function(t,slot) {
	var stage = com_nevosoft_waw_logic_systems_quests_QuestBuilder.stageForSlot(slot,t.context.dataProvider);
	var qMeta = { id : 0, name : "", description : "", restrictions : { }, rewards : slot.reward, stages : [stage], gameEventsComponent : [1], oneTime : true};
	var qState = { id : 0, stages : [0], opened : false, receiveTime : t.time, receiveGameTime : t.gameTime, deactivateTime : 0, isActive : true};
	return { data : qState, meta : qMeta};
};
com_nevosoft_waw_logic_systems_quests_QuestBuilder.stageForSlot = function(slot,dataProvider) {
	var conditionTypeId = slot.rawData[0];
	var param = slot.rawData[2];
	var condition = com_nevosoft_waw_logic_systems_quests_QuestBuilder.buildQuestCondition(conditionTypeId,param);
	var amount = slot.rawData[1];
	var stage = com_nevosoft_waw_logic_systems_quests_QuestBuilder.generateStage(condition,amount);
	return stage;
};
com_nevosoft_waw_logic_systems_quests_QuestBuilder.generateStage = function(condition,amount) {
	return { name : "", description : "", condition : condition, conditionValue : amount, canBeAsked : false, skipCost : 0};
};
com_nevosoft_waw_logic_systems_quests_QuestBuilder.buildQuestCondition = function(conditionTypeId,param) {
	var questConditionType = conditionTypeId;
	switch(conditionTypeId) {
	case 3:
		return { type : questConditionType, params : { }};
	case 4:
		return { type : questConditionType, params : { }};
	case 12:
		return { type : questConditionType, params : { resourceIds : [param]}};
	case 13:
		return { type : questConditionType, params : { }};
	case 28:
		return { type : questConditionType, params : { }};
	case 29:
		return { type : questConditionType, params : { }};
	case 55:
		return { type : questConditionType, params : { id : param}};
	case 57:
		return { type : questConditionType, params : { resource : param}};
	case 61:
		return { type : questConditionType, params : { id : param}};
	case 63:
		return { type : questConditionType, params : { actionIds : [param]}};
	case 66:
		return { type : questConditionType, params : { actionIds : [param]}};
	case 68:
		return { type : questConditionType, params : { categories : [param]}};
	case 70:
		return { type : questConditionType, params : { ids : [param]}};
	default:
		throw haxe_Exception.thrown("unknown condition: " + conditionTypeId);
	}
};
var com_nevosoft_waw_logic_systems_quests_QuestEntity = function(input,dataProvider) {
	this.lastStageCompleted = -1;
	this.type = 0;
	var _gthis = this;
	this.data = input.data;
	this.meta = input.meta;
	this.listeners = [];
	this.prevCounters = [];
	this.stageStatus = [];
	this.cleaners = [];
	this.stageConditions = [];
	this.id = this.data.id;
	var tmp;
	var this1 = dataProvider.getMetaIndex().questToArc;
	var key = this.get_id();
	if(this1.h.hasOwnProperty(key)) {
		var this1 = dataProvider.getMetaIndex().questToArc;
		var key = this.get_id();
		tmp = this1.h[key];
	} else {
		tmp = -1;
	}
	this.arcId = tmp;
	var _g = 0;
	var _g1 = this.data.stages.length;
	while(_g < _g1) {
		var i = [_g++];
		var counter = this.data.stages[i[0]];
		var stageMeta = this.meta.stages[i[0]];
		this.prevCounters.push(counter);
		var condition = com_nevosoft_waw_data_types_ConditionType.toEnum(stageMeta.condition.type,stageMeta.condition.params);
		this.stageConditions.push(condition);
		if(counter < stageMeta.conditionValue) {
			var matchFunc = [com_nevosoft_waw_logic_systems_quests_QuestMatchFuncFactory.get(condition)];
			var handler = [com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.create(condition)];
			var isStateMove = [com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.isStateMoveHandler(condition)];
			var max = stageMeta.conditionValue;
			var listener = (function(isStateMove,handler,matchFunc,i) {
				return function(trigger) {
					if(matchFunc[0] == null) {
						return false;
					}
					if(trigger == null || matchFunc[0](trigger)) {
						var count = handler[0](dataProvider,trigger);
						_gthis.data.stages[i[0]] = isStateMove[0] ? count : _gthis.data.stages[i[0]] + count;
						return true;
					}
					return false;
				};
			})(isStateMove,handler,matchFunc,i);
			var cleaner = com_nevosoft_waw_logic_systems_quests_CleanUpJobsFactory.create(condition);
			if(cleaner != null) {
				var intitializedCleaner = (function(_g,a3,a2,a1) {
					return function(a4,a5) {
						_g[0](a1[0],a2[0],a3[0],a4,a5);
					};
				})([cleaner],[dataProvider],[i[0]],[this.data]);
				this.cleaners.push(intitializedCleaner);
			}
			this.listeners.push(listener);
			this.stageStatus.push(false);
		} else {
			this.listeners.push(null);
			this.stageStatus.push(true);
		}
	}
};
com_nevosoft_waw_logic_systems_quests_QuestEntity.__name__ = true;
com_nevosoft_waw_logic_systems_quests_QuestEntity.__interfaces__ = [com_nevosoft_isoframework_ICleanable];
com_nevosoft_waw_logic_systems_quests_QuestEntity.prototype = {
	validateStateHandlers: function() {
		var _g = 0;
		var _g1 = this.meta.stages.length;
		while(_g < _g1) {
			var i = _g++;
			if(com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.isStateMoveHandler(this.stageConditions[i])) {
				var l = this.listeners[i];
				if(l != null) {
					l(null);
				}
			}
		}
		return this._checkForUpdate();
	}
	,process: function(trigger) {
		var _g = 0;
		var _g1 = this.listeners;
		while(_g < _g1.length) {
			var l = _g1[_g];
			++_g;
			if(l != null) {
				l(trigger);
			}
		}
		return this._checkForUpdate();
	}
	,getConditionValue: function(stageIndex) {
		return this.meta.stages[stageIndex].conditionValue;
	}
	,_checkForUpdate: function() {
		var isUpdated = false;
		var _g = 0;
		var _g1 = this.data.stages.length;
		while(_g < _g1) {
			var i = _g++;
			if(this.prevCounters[i] != this.data.stages[i]) {
				this.prevCounters[i] = this.data.stages[i];
				isUpdated = true;
				var l = this.listeners[i];
				if(l != null) {
					if(this.data.stages[i] >= this.meta.stages[i].conditionValue) {
						this.listeners[i] = null;
						if(!this.stageStatus[i]) {
							this.stageStatus[i] = true;
							this.lastStageCompleted = i;
						}
						this.data.stages[i] = this.meta.stages[i].conditionValue;
					}
				}
			}
		}
		return isUpdated;
	}
	,close: function(t) {
		this.listeners = [];
		var completeFlag = this.get_isComplete();
		if(t != null) {
			var _g = 0;
			var _g1 = this.cleaners;
			while(_g < _g1.length) {
				var cl = _g1[_g];
				++_g;
				cl(completeFlag,t);
			}
		}
		this.cleaners = [];
	}
	,cleanup: function() {
		this.close();
		this.data = null;
		this.meta = null;
		this.prevCounters = null;
		this.stageStatus = null;
	}
	,getLastStageCompleted: function() {
		return this.lastStageCompleted;
	}
	,get_isComplete: function() {
		var _g = 0;
		var _g1 = this.stageStatus;
		while(_g < _g1.length) {
			var s = _g1[_g];
			++_g;
			if(!s) {
				return false;
			}
		}
		return true;
	}
	,get_id: function() {
		return this.id;
	}
	,get_opened: function() {
		return this.data.opened;
	}
	,get_isTimeRelated: function() {
		return this.meta.timeParameters != null;
	}
	,get_condition: function() {
		return this.stageConditions[0];
	}
	,__class__: com_nevosoft_waw_logic_systems_quests_QuestEntity
	,__properties__: {get_isComplete:"get_isComplete",get_isTimeRelated:"get_isTimeRelated",get_condition:"get_condition",get_opened:"get_opened",get_id:"get_id"}
};
var com_nevosoft_waw_logic_systems_quests_QuestMatchFuncFactory = function() { };
com_nevosoft_waw_logic_systems_quests_QuestMatchFuncFactory.__name__ = true;
com_nevosoft_waw_logic_systems_quests_QuestMatchFuncFactory.get = function(condition) {
	switch(condition._hx_index) {
	case 0:
		var params = condition.params;
		return function(trigger) {
			switch(trigger._hx_index) {
			case 6:
				var triggerParams = trigger.params;
				if(com_nevosoft_waw_data_types_meta_EActionType.inProductionGroup(triggerParams.actionType)) {
					return com_nevosoft_waw_logic_CommonMatching.idSet(params.ids,triggerParams.metaId);
				} else {
					return false;
				}
				break;
			case 44:
				var _g = trigger.params;
				var _g1 = _g.farmId;
				var plantId = _g.plantId;
				return com_nevosoft_waw_logic_CommonMatching.idSet(params.ids,plantId);
			default:
				return false;
			}
		};
	case 1:
		var params1 = condition.params;
		return function(trigger) {
			if(trigger._hx_index == 6) {
				var triggerParams = trigger.params;
				if(com_nevosoft_waw_data_types_meta_EActionType.inProductionGroup(triggerParams.actionType)) {
					return com_nevosoft_waw_logic_MapObjectMatching.hasAtLeastOneTag(params1.tags,triggerParams.tags);
				} else {
					return false;
				}
			} else {
				return false;
			}
		};
	case 2:
		var params2 = condition.params;
		return function(trigger) {
			if(trigger._hx_index == 1) {
				var triggerParams = trigger.params;
				if(com_nevosoft_waw_data_types_meta_EActionType.inProductionGroup(triggerParams.actionType)) {
					return com_nevosoft_waw_logic_MapObjectMatching.categories(params2.categories,triggerParams);
				} else {
					return false;
				}
			} else {
				return false;
			}
		};
	case 3:
		var params3 = condition.params;
		return function(trigger) {
			if(trigger._hx_index == 6) {
				var triggerParams = trigger.params;
				if(com_nevosoft_waw_data_types_meta_EActionType.inProductionGroup(triggerParams.actionType)) {
					return com_nevosoft_waw_logic_MapObjectMatching.categories(params3.categories,triggerParams);
				} else {
					return false;
				}
			} else {
				return false;
			}
		};
	case 4:
		var params4 = condition.params;
		return function(trigger) {
			if(trigger._hx_index == 0) {
				var triggerParams = trigger.params;
				return com_nevosoft_waw_logic_CommonMatching.idSet(params4.actionIds,triggerParams.actionId);
			} else {
				return false;
			}
		};
	case 5:
		var params5 = condition.params;
		return function(trigger) {
			if(trigger._hx_index == 1) {
				var triggerParams = trigger.params;
				return com_nevosoft_waw_logic_CommonMatching.idSet(params5.actionIds,triggerParams.actionId);
			} else {
				return false;
			}
		};
	case 6:
		var params6 = condition.params;
		return function(trigger) {
			if(trigger._hx_index == 5) {
				var triggerParams = trigger.params;
				return com_nevosoft_waw_logic_CommonMatching.idSet(params6.actionIds,triggerParams.actionId);
			} else {
				return false;
			}
		};
	case 7:
		var params7 = condition.params;
		return function(trigger) {
			if(trigger._hx_index == 6) {
				var triggerParams = trigger.params;
				return com_nevosoft_waw_logic_CommonMatching.idSet(params7.actionIds,triggerParams.actionId);
			} else {
				return false;
			}
		};
	case 8:
		var params8 = condition.params;
		return function(trigger) {
			if(trigger._hx_index == 63) {
				var _g = trigger.params;
				var _g1 = _g.templateId;
				var _g1 = _g.slotId;
				var _g1 = _g.power;
				var _g1 = _g.goldIncreased;
				var sold = _g.demand;
				var result = false;
				var _g = 0;
				var _g1 = params8.resourceIds;
				while(_g < _g1.length) {
					var resId = _g1[_g];
					++_g;
					if(com_nevosoft_waw_data_types_TCost.hasKey(sold,resId)) {
						result = true;
						break;
					}
				}
				return result;
			} else {
				return false;
			}
		};
	case 9:
		var resource = condition.params.id;
		return function(trigger) {
			if(trigger._hx_index == 37) {
				var _g = trigger.params;
				var _g1 = _g.space;
				var _g1 = _g.reason;
				if(_g.sign == -1) {
					var cost = _g.cost;
					return com_nevosoft_waw_data_types_TCost.hasKey(cost,resource);
				} else {
					return false;
				}
			} else {
				return false;
			}
		};
	case 10:
		var id = condition.params.id;
		return function(trigger) {
			if(trigger._hx_index == 41) {
				var _g = trigger.params;
				var _g1 = _g.id;
				var _g1 = _g.category;
				var _g1 = _g.amount;
				var _g1 = _g.actionType;
				var cost = _g.cost;
				return com_nevosoft_waw_data_types_TCost.hasKey(cost,id);
			} else {
				return false;
			}
		};
	case 11:
		var params9 = condition.params;
		return function(trigger) {
			if(trigger._hx_index == 52) {
				var id = trigger.params.id;
				return params9.id == id;
			} else {
				return false;
			}
		};
	case 12:
		var inputId = condition.params.id;
		return function(trigger) {
			if(trigger._hx_index == 50) {
				var params = trigger.params;
				return params.id == inputId;
			} else {
				return false;
			}
		};
	case 13:
		var id1 = condition.params.id;
		return function(trigger) {
			if(trigger._hx_index == 42) {
				var _g = trigger.params;
				var _g1 = _g.sectorObjs;
				var inputId = _g.id;
				return id1 == inputId;
			} else {
				return false;
			}
		};
	case 14:
		var id2 = condition.params.id;
		return function(trigger) {
			if(trigger._hx_index == 23) {
				var _g = trigger.params;
				var _g1 = _g.taskState;
				var inputId = _g.id;
				return id2 == inputId;
			} else {
				return false;
			}
		};
	case 15:
		var _g = condition.params;
		return function(trigger) {
			return false;
		};
	case 16:
		var id3 = condition.params.id;
		return function(trigger) {
			if(trigger._hx_index == 27) {
				var inputId = trigger.params.id;
				if(id3 != 0) {
					return inputId == id3;
				} else {
					return true;
				}
			} else {
				return false;
			}
		};
	case 17:
		var id4 = condition.params.id;
		return function(trigger) {
			if(trigger._hx_index == 59) {
				var animalId = trigger.params.id;
				return id4 == animalId;
			} else {
				return false;
			}
		};
	case 18:
		var resource1 = condition.params.id;
		return function(trigger) {
			if(trigger._hx_index == 37) {
				var _g = trigger.params;
				var _g1 = _g.space;
				var _g1 = _g.reason;
				if(_g1._hx_index == 9) {
					var _g2 = _g1.id;
					if(_g.sign == -1) {
						var cost = _g.cost;
						return com_nevosoft_waw_data_types_TCost.hasKey(cost,resource1);
					} else {
						return false;
					}
				} else {
					return false;
				}
			} else {
				return false;
			}
		};
	case 19:
		var params10 = condition.params;
		return function(trigger) {
			if(params10.includePending) {
				switch(trigger._hx_index) {
				case 1:
					var triggerParams = trigger.params;
					if(com_nevosoft_waw_data_types_meta_EActionType.inUpgradeGroup(triggerParams.actionType) && triggerParams.actionType != 2) {
						return com_nevosoft_waw_logic_MapObjectMatching.levelRestrictions(params10.obj,{ metaId : triggerParams.metaId, level : triggerParams.level + 1});
					} else {
						return false;
					}
					break;
				case 15:
					var _g = trigger.params;
					var _g1 = _g.y;
					var _g1 = _g.x;
					var _g1 = _g.reason;
					var _g1 = _g.id;
					var _g1 = _g.category;
					var metaId = _g.metaId;
					var level = _g.level;
					return com_nevosoft_waw_logic_MapObjectMatching.levelRestrictions(params10.obj,{ metaId : metaId, level : level + 1});
				default:
					return false;
				}
			} else {
				switch(trigger._hx_index) {
				case 6:
					var triggerParams = trigger.params;
					if(com_nevosoft_waw_data_types_meta_EActionType.inUpgradeGroup(triggerParams.actionType) && triggerParams.actionType != 2) {
						return com_nevosoft_waw_logic_MapObjectMatching.levelRestrictions(params10.obj,{ metaId : triggerParams.metaId, level : triggerParams.level});
					} else {
						return false;
					}
					break;
				case 15:
					var _g = trigger.params;
					var _g1 = _g.y;
					var _g1 = _g.x;
					var _g1 = _g.reason;
					var _g1 = _g.id;
					var _g1 = _g.category;
					var metaId = _g.metaId;
					var level = _g.level;
					return com_nevosoft_waw_logic_MapObjectMatching.levelRestrictions(params10.obj,{ metaId : metaId, level : level});
				case 42:
					var _g = trigger.params;
					var _g1 = _g.id;
					var objs = _g.sectorObjs;
					var _g = 0;
					while(_g < objs.length) {
						var obj = objs[_g];
						++_g;
						if(com_nevosoft_waw_logic_MapObjectMatching.levelRestrictions(params10.obj,{ metaId : obj.metaId, level : 1})) {
							return true;
						}
					}
					return false;
				default:
					return false;
				}
			}
		};
	case 20:
		var params11 = condition.params;
		return function(trigger) {
			if(trigger._hx_index == 6) {
				var triggerParams = trigger.params;
				var result = false;
				var _g = 0;
				var _g1 = params11.resourceIds;
				while(_g < _g1.length) {
					var resId = _g1[_g];
					++_g;
					if(com_nevosoft_waw_data_types_TCost.hasKey(triggerParams.reward,resId)) {
						result = true;
						break;
					}
				}
				return result;
			} else {
				return false;
			}
		};
	case 21:
		var params12 = condition.params;
		return function(trigger) {
			if(trigger._hx_index == 37) {
				var _g = trigger.params;
				var _g1 = _g.space;
				var _g1 = _g.sign;
				var _g1 = _g.reason;
				var cost = _g.cost;
				var result = false;
				var _g = 0;
				var _g1 = params12.resourceIds;
				while(_g < _g1.length) {
					var resId = _g1[_g];
					++_g;
					if(com_nevosoft_waw_data_types_TCost.hasKey(cost,resId)) {
						result = true;
						break;
					}
				}
				return result;
			} else {
				return false;
			}
		};
	case 22:
		var params13 = condition.params;
		return function(trigger) {
			if(trigger._hx_index == 37) {
				var _g = trigger.params;
				var _g1 = _g.space;
				if(_g.sign == 1) {
					var cost = _g.cost;
					var reason = _g.reason;
					var result = false;
					var _g = 0;
					var _g1 = params13.resourceIds;
					while(_g < _g1.length) {
						var resId = _g1[_g];
						++_g;
						if(com_nevosoft_waw_data_types_TCost.hasKey(cost,resId)) {
							result = true;
							break;
						}
					}
					return result;
				} else {
					return false;
				}
			} else {
				return false;
			}
		};
	case 23:
		var params14 = condition.params;
		return function(trigger) {
			if(trigger._hx_index == 37) {
				var _g = trigger.params;
				var _g1 = _g.space;
				var _g1 = _g.reason;
				if(_g.sign == 1) {
					var cost = _g.cost;
					return com_nevosoft_waw_data_types_TCost.hasKey(cost,params14.resource);
				} else {
					return false;
				}
			} else {
				return false;
			}
		};
	case 24:
		var inputCategory = condition.params.category;
		return function(trigger) {
			if(trigger._hx_index == 41) {
				var _g = trigger.params;
				var _g1 = _g.id;
				var _g1 = _g.cost;
				var _g1 = _g.amount;
				var _g1 = _g.actionType;
				var category = _g.category;
				return category == inputCategory;
			} else {
				return false;
			}
		};
	case 25:
		var inputCategory1 = condition.params.category;
		return function(trigger) {
			if(trigger._hx_index == 41) {
				var _g = trigger.params;
				var _g1 = _g.id;
				var _g1 = _g.amount;
				var _g1 = _g.actionType;
				var cost = _g.cost;
				var itemCategory = _g.category;
				if(com_nevosoft_waw_data_types_TCost.hasKey(cost,-1)) {
					return itemCategory == inputCategory1;
				} else {
					return false;
				}
			} else {
				return false;
			}
		};
	case 26:
		var _g = condition.params;
		return function(trigger) {
			return false;
		};
	case 27:
		var inputStageNum = condition.params.stageNum;
		return function(trigger) {
			if(trigger._hx_index == 34) {
				var stageNum = trigger.params.id;
				if(stageNum == inputStageNum - 1) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		};
	case 28:
		var params15 = condition.params;
		return function(trigger) {
			if(trigger._hx_index == 63) {
				var _g = trigger.params;
				var _g1 = _g.slotId;
				var _g1 = _g.power;
				var _g1 = _g.goldIncreased;
				var _g1 = _g.demand;
				var gotId = _g.templateId;
				if(!(params15.id == null || params15.id < 0)) {
					return params15.id == gotId;
				} else {
					return true;
				}
			} else {
				return false;
			}
		};
	case 29:
		var params16 = condition.params;
		return function(trigger) {
			switch(trigger._hx_index) {
			case 63:
				var _g = trigger.params;
				var _g1 = _g.slotId;
				var _g1 = _g.power;
				var _g1 = _g.goldIncreased;
				var _g1 = _g.demand;
				var gotId = _g.templateId;
				if(params16.templateIds.length == 0) {
					return true;
				} else {
					return com_nevosoft_waw_logic_CommonMatching.idSet(params16.templateIds,gotId);
				}
				break;
			case 71:
				var _g = trigger.params;
				var _g1 = _g.resourceId;
				var _g1 = _g.amount;
				var gotId = _g.templateId;
				if(params16.templateIds.length == 0) {
					return true;
				} else {
					return com_nevosoft_waw_logic_CommonMatching.idSet(params16.templateIds,gotId);
				}
				break;
			case 74:
				var _g = trigger.params;
				var _g1 = _g.power;
				var _g1 = _g.hostId;
				var _g1 = _g.demand;
				var gotId = _g.templateId;
				if(params16.templateIds.length == 0) {
					return true;
				} else {
					return com_nevosoft_waw_logic_CommonMatching.idSet(params16.templateIds,gotId);
				}
				break;
			default:
				return false;
			}
		};
	case 30:
		var params17 = condition.params;
		return function(trigger) {
			if(trigger._hx_index == 75) {
				var id = trigger.params.id;
				return params17.id == id;
			} else {
				return false;
			}
		};
	case 31:
		return function(trigger) {
			if(trigger._hx_index == 6) {
				var _g = trigger.params;
				var _g1 = _g.tags;
				var _g1 = _g.reward;
				var _g1 = _g.metaId;
				var _g1 = _g.id;
				var _g1 = _g.actionId;
				if(_g.category == "COMMON_BUILDING") {
					if(_g.level == 1) {
						var actionType = _g.actionType;
						if(com_nevosoft_waw_data_types_meta_EActionType.inUpgradeGroup(actionType)) {
							return true;
						} else {
							return false;
						}
					} else {
						return false;
					}
				} else {
					return false;
				}
			} else {
				return false;
			}
		};
	case 32:
		return function(trigger) {
			if(trigger._hx_index == 6) {
				var _g = trigger.params;
				var _g1 = _g.tags;
				var _g1 = _g.reward;
				var _g1 = _g.metaId;
				var _g1 = _g.id;
				var _g1 = _g.actionId;
				var level = _g.level;
				var category = _g.category;
				var actionType = _g.actionType;
				if(com_nevosoft_waw_data_types_meta_EActionType.inUpgradeGroup(actionType) && level > 1 && category == "COMMON_BUILDING" || category == "STORAGE_COMMON") {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		};
	case 33:
		return function(trigger) {
			if(trigger._hx_index == 42) {
				var _g = trigger.params;
				var _g1 = _g.sectorObjs;
				var id = _g.id;
				return id != 0;
			} else {
				return false;
			}
		};
	case 34:
		var required = com_nevosoft_waw_data_types_EGameTrigger.TriggerMarketSell(null);
		return function(input) {
			return com_nevosoft_waw_logic_CommonMatching.triggerTypeCmp(required,input);
		};
	case 35:
		var required1 = com_nevosoft_waw_data_types_EGameTrigger.TriggerZeppelinLoad(null);
		return function(input) {
			return com_nevosoft_waw_logic_CommonMatching.triggerTypeCmp(required1,input);
		};
	case 36:
		var required2 = com_nevosoft_waw_data_types_EGameTrigger.TriggerZeppelinComplete(null);
		return function(input) {
			return com_nevosoft_waw_logic_CommonMatching.triggerTypeCmp(required2,input);
		};
	case 37:
		var required3 = com_nevosoft_waw_data_types_EGameTrigger.TriggerSpell(null);
		return function(input) {
			return com_nevosoft_waw_logic_CommonMatching.triggerTypeCmp(required3,input);
		};
	case 38:
		var required4 = com_nevosoft_waw_data_types_EGameTrigger.TriggerPlayWithShmu(null);
		return function(input) {
			return com_nevosoft_waw_logic_CommonMatching.triggerTypeCmp(required4,input);
		};
	case 39:
		var required5 = com_nevosoft_waw_data_types_EGameTrigger.TriggerPlayWithAnimal(null);
		return function(input) {
			return com_nevosoft_waw_logic_CommonMatching.triggerTypeCmp(required5,input);
		};
	case 40:
		var required6 = com_nevosoft_waw_data_types_EGameTrigger.TriggerGotDailyBonusReward;
		return function(input) {
			return com_nevosoft_waw_logic_CommonMatching.triggerTypeCmp(required6,input);
		};
	case 41:
		var required7 = com_nevosoft_waw_data_types_EGameTrigger.TriggerNewLevel(null);
		return function(input) {
			return com_nevosoft_waw_logic_CommonMatching.triggerTypeCmp(required7,input);
		};
	case 49:
		return function(trigger) {
			if(trigger._hx_index == 33) {
				var _g = trigger.params;
				return true;
			} else {
				return false;
			}
		};
	case 50:
		return function(trigger) {
			if(trigger._hx_index == 14) {
				var _g = trigger.params;
				var _g1 = _g.metaId;
				var _g1 = _g.level;
				var _g1 = _g.id;
				if(_g.category == "ANIMAL") {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		};
	case 42:case 43:case 44:case 45:case 46:case 47:case 48:case 51:case 52:case 53:case 54:
		return function(trigger) {
			return false;
		};
	case 55:
		return function(trigger) {
			switch(trigger._hx_index) {
			case 19:
				var _g = trigger.params;
				return true;
			case 22:
				var _g = trigger.params;
				return true;
			default:
				return false;
			}
		};
	case 56:
		var required8 = com_nevosoft_waw_data_types_EGameTrigger.TriggerBuyBuff(null);
		return function(input) {
			return com_nevosoft_waw_logic_CommonMatching.triggerTypeCmp(required8,input);
		};
	}
};
var com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory = function() { };
com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.__name__ = true;
com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.isStateMoveHandler = function(condition) {
	switch(condition._hx_index) {
	case 7:
		var _g = condition.params;
		var _g1 = _g.actionIds;
		if(_g.includeAlreadyApplied == true) {
			return true;
		} else {
			return false;
		}
		break;
	case 13:
		var _g = condition.params;
		return true;
	case 19:
		var _g = condition.params;
		return true;
	case 21:
		var _g = condition.params;
		return true;
	case 23:
		var _g = condition.params;
		return true;
	case 55:
		return true;
	default:
		return false;
	}
};
com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.create = function(condition) {
	switch(condition._hx_index) {
	case 7:
		var params = condition.params;
		if(params.includeAlreadyApplied) {
			var params1 = params;
			return function(dataProvider,trigger) {
				return com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.appliedActions(params1,dataProvider,trigger);
			};
		} else {
			return com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.simpleIncrement;
		}
		break;
	case 8:
		var params = condition.params;
		var resourceIds = params.resourceIds;
		return function(data,trigger) {
			return com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.incrementResourceMoveValueMultiple(resourceIds,data,trigger);
		};
	case 9:
		var params = condition.params;
		var resourceId = params.id;
		return function(data,trigger) {
			return com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.incrementResourceMoveValue(resourceId,data,trigger);
		};
	case 10:
		var params = condition.params;
		var resourceId1 = params.id;
		return function(data,trigger) {
			return com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.incrementResourceMoveValue(resourceId1,data,trigger);
		};
	case 13:
		var params = condition.params;
		var sectorId = params.id;
		return function(dataProvider,trigger) {
			return com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.sectorState(sectorId,dataProvider,trigger);
		};
	case 19:
		var params = condition.params;
		var params2 = params;
		return function(dataProvider,trigger) {
			return com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.locationState(params2,dataProvider,trigger);
		};
	case 20:
		var params = condition.params;
		var resourceIds1 = params.resourceIds;
		return function(data,trigger) {
			return com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.incrementResourceMoveValueMultiple(resourceIds1,data,trigger);
		};
	case 21:
		var params = condition.params;
		var resourceIds2 = params.resourceIds;
		return function(dataProvider,trigger) {
			return com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.resourceStateMultiple(resourceIds2,dataProvider,trigger);
		};
	case 22:
		var params = condition.params;
		var resourceIds3 = params.resourceIds;
		return function(data,trigger) {
			return com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.incrementResourceMoveValueMultiple(resourceIds3,data,trigger);
		};
	case 23:
		var params = condition.params;
		var resourceId2 = params.resource;
		return function(dataProvider,trigger) {
			return com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.resourceState(resourceId2,dataProvider,trigger);
		};
	case 24:
		var params = condition.params;
		return com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.incrementByAmount;
	case 25:
		var params = condition.params;
		var resourceId3 = -1;
		return function(data,trigger) {
			return com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.incrementResourceMoveValue(resourceId3,data,trigger);
		};
	case 55:
		return com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.shmusTotal;
	default:
		return com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.simpleIncrement;
	}
};
com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.simpleIncrement = function(data,trigger) {
	return 1;
};
com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.incrementByAmount = function(data,trigger) {
	var amount;
	if(trigger._hx_index == 41) {
		var _g = trigger.params;
		var _g1 = _g.id;
		var _g1 = _g.cost;
		var _g1 = _g.category;
		var _g1 = _g.actionType;
		var amount1 = _g.amount;
		amount = amount1;
	} else {
		throw haxe_Exception.thrown("got wrong trigger");
	}
	return amount;
};
com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.incrementResourceMoveValueMultiple = function(resourceIds,data,trigger) {
	var moveValue = 0;
	var _g = 0;
	while(_g < resourceIds.length) {
		var resId = resourceIds[_g];
		++_g;
		moveValue += com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.incrementResourceMoveValue(resId,data,trigger);
	}
	return moveValue;
};
com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.incrementResourceMoveValue = function(resourceId,data,trigger) {
	var cost;
	switch(trigger._hx_index) {
	case 6:
		var params = trigger.params;
		cost = params.reward;
		break;
	case 37:
		var params = trigger.params;
		cost = params.cost;
		break;
	case 41:
		var params = trigger.params;
		cost = params.cost;
		break;
	case 63:
		var params = trigger.params;
		cost = params.demand;
		break;
	default:
		throw haxe_Exception.thrown("got wrong trigger");
	}
	var this1 = cost;
	if(com_nevosoft_waw_data_types_TCost.hasKey(this1,resourceId)) {
		return Reflect.field(this1,resourceId == null ? "null" : "" + resourceId);
	} else {
		return 0;
	}
};
com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.resourceStateMultiple = function(resourceIds,dataProvider,trigger) {
	var count = 0;
	var _g = 0;
	while(_g < resourceIds.length) {
		var resId = resourceIds[_g];
		++_g;
		count += com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.resourceState(resId,dataProvider,trigger);
	}
	return count;
};
com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.resourceState = function(resourceId,dataProvider,trigger) {
	var count = dataProvider.serverResources.AvailableAmount(resourceId);
	return count;
};
com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.sectorState = function(sectorId,dataProvider,trigger) {
	if(dataProvider.location.getOpenedSectorsIds().indexOf(sectorId) >= 0) {
		return 1;
	} else {
		return 0;
	}
};
com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory._isPassRestiction = function(obj,restrictions) {
	var lvl = obj.cUpgradable == null ? 1 : obj.cUpgradable.level;
	var _g = 0;
	while(_g < restrictions.length) {
		var r = restrictions[_g];
		++_g;
		var cmp = r.cmp;
		if(r.id == obj.metaId && com_nevosoft_waw_data_constants_CmpOp.compare(cmp,lvl,r.lvl)) {
			return true;
		}
	}
	return false;
};
com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.locationState = function(params,dataProvider,trigger) {
	var locationDataProvider = dataProvider.location;
	var mapObjectsDataProvider = dataProvider.mapObjects;
	var actionsDataProvider = dataProvider.actions;
	var count = 0;
	var _g = 0;
	var _g1 = params.obj;
	while(_g < _g1.length) {
		var lvlRestriction = _g1[_g];
		++_g;
		var objects = locationDataProvider.filterMapObjects({ metaId : lvlRestriction.id});
		var cmp = lvlRestriction.cmp;
		var _g2 = 0;
		while(_g2 < objects.length) {
			var obj = objects[_g2];
			++_g2;
			var lvl = mapObjectsDataProvider.getLevel(obj,params.includePending);
			if(com_nevosoft_waw_data_constants_CmpOp.compare(cmp,lvl,lvlRestriction.lvl)) {
				++count;
			}
		}
	}
	return count;
};
com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.appliedActions = function(params,dataProvider,trigger) {
	var resultCount = 0;
	var _g = 0;
	var _g1 = params.actionIds;
	while(_g < _g1.length) {
		var actId = _g1[_g];
		++_g;
		resultCount += dataProvider.location.getDoneActionsCount(actId);
	}
	return resultCount;
};
com_nevosoft_waw_logic_systems_quests_StageMoveHandlersFactory.shmusTotal = function(dataProvider,trigger) {
	return dataProvider.location.getShmuCount();
};
var com_nevosoft_waw_logic_systems_rewardChoice_IChooseRewardStrategy = function() { };
com_nevosoft_waw_logic_systems_rewardChoice_IChooseRewardStrategy.__name__ = true;
com_nevosoft_waw_logic_systems_rewardChoice_IChooseRewardStrategy.__isInterface__ = true;
com_nevosoft_waw_logic_systems_rewardChoice_IChooseRewardStrategy.prototype = {
	__class__: com_nevosoft_waw_logic_systems_rewardChoice_IChooseRewardStrategy
};
var com_nevosoft_waw_logic_systems_rewardChoice_ConsiderDemandRewardChoice = function(config,dataProvider,randomProvider) {
	this.config = config;
	this.simpleImpl = new com_nevosoft_waw_logic_systems_rewardChoice_RandomRewardChoice(randomProvider);
	this.dataProvider = dataProvider;
	this.randomProvider = randomProvider;
	this.resIdToDemand = new haxe_ds_IntMap();
};
com_nevosoft_waw_logic_systems_rewardChoice_ConsiderDemandRewardChoice.__name__ = true;
com_nevosoft_waw_logic_systems_rewardChoice_ConsiderDemandRewardChoice.__interfaces__ = [com_nevosoft_waw_logic_systems_rewardChoice_IChooseRewardStrategy];
com_nevosoft_waw_logic_systems_rewardChoice_ConsiderDemandRewardChoice.prototype = {
	getName: function() {
		return "consider demand";
	}
	,forDailyQuest: function(template) {
		if(com_nevosoft_isoframework_utils_MathUtils.getRandomValue2(0,1,this.randomProvider) <= this.config.dailyQuestChance) {
			return this.fromTemplate(template);
		}
		return this.simpleImpl.forDailyQuest(template);
	}
	,forMarket: function(template) {
		if(com_nevosoft_isoframework_utils_MathUtils.getRandomValue2(0,1,this.randomProvider) <= this.config.marketChance) {
			return this.fromTemplate(template);
		}
		return this.simpleImpl.forMarket(template);
	}
	,forCamping: function(template) {
		if(com_nevosoft_isoframework_utils_MathUtils.getRandomValue2(0,1,this.randomProvider) <= this.config.campChance) {
			return this.fromTemplate(template);
		}
		return this.simpleImpl.fromTemplate(template);
	}
	,forZeppelin: function(rewardLength,choiceSet,weights) {
		if(com_nevosoft_isoframework_utils_MathUtils.getRandomValue2(0,1,this.randomProvider) <= this.config.zeppelinChance) {
			return this.fromChoiceSetWeighted(rewardLength,choiceSet,weights);
		}
		return this.simpleImpl.forZeppelin(rewardLength,choiceSet,weights);
	}
	,forDropPack: function(pack) {
		if(com_nevosoft_isoframework_utils_MathUtils.getRandomValue2(0,1,this.randomProvider) <= this.config.actionDropChance) {
			return this.fromDropPack(pack);
		}
		return this.simpleImpl.forDropPack(pack);
	}
	,fromTemplate: function(template) {
		var choiceSetDemanded = [];
		var choiceSetLeft = [];
		var rewardLength = template.slotsCount;
		var choiceSet = com_nevosoft_waw_data_types_TCost.keys(template.reward);
		this.splitChoiceSet(choiceSetDemanded,choiceSetLeft,choiceSet);
		var rewardDemanded = this.fromChoiceSetRandom(Math.floor(Math.min(rewardLength,choiceSetDemanded.length)),choiceSetDemanded,function(resId) {
			var this1 = template.reward;
			if(com_nevosoft_waw_data_types_TCost.hasKey(this1,resId)) {
				return Reflect.field(this1,resId == null ? "null" : "" + resId);
			} else {
				return 0;
			}
		});
		if(com_nevosoft_waw_data_types_TCost.keys(rewardDemanded).length < rewardLength) {
			var rewardLeft = this.simpleImpl.fromTemplate(template);
			this.addNecessaryCount(rewardDemanded,rewardLeft,rewardLength - com_nevosoft_waw_data_types_TCost.keys(rewardDemanded).length);
		}
		return rewardDemanded;
	}
	,fromChoiceSet: function(rewardLength,choiceSet) {
		var choiceSetDemanded = [];
		var choiceSetLeft = [];
		this.splitChoiceSet(choiceSetDemanded,choiceSetLeft,choiceSet);
		var rewardDemanded = this.fromChoiceSetRandom(Math.floor(Math.min(rewardLength,choiceSetDemanded.length)),choiceSetDemanded,function(resId) {
			return 1;
		});
		if(com_nevosoft_waw_data_types_TCost.keys(rewardDemanded).length < rewardLength) {
			var rewardLeft = this.simpleImpl.fromChoiceSet(rewardLength - com_nevosoft_waw_data_types_TCost.keys(rewardDemanded).length,choiceSetLeft);
			this.addNecessaryCount(rewardDemanded,rewardLeft,rewardLength - com_nevosoft_waw_data_types_TCost.keys(rewardDemanded).length);
		}
		return rewardDemanded;
	}
	,fromChoiceSetWeighted: function(rewardLength,choiceSet,weights) {
		var choiceSetDemanded = [];
		var choiceSetLeft = [];
		this.splitChoiceSet(choiceSetDemanded,choiceSetLeft,choiceSet);
		var weightsLeft = [];
		var _g = 0;
		while(_g < choiceSet.length) {
			var resId = choiceSet[_g];
			++_g;
			if(choiceSetDemanded.indexOf(resId) < 0) {
				weightsLeft.push(weights[choiceSet.indexOf(resId)]);
			}
		}
		var rewardDemanded = this.fromChoiceSetRandom(Math.floor(Math.min(rewardLength,choiceSetDemanded.length)),choiceSetDemanded,function(resId) {
			return 1;
		});
		if(com_nevosoft_waw_data_types_TCost.keys(rewardDemanded).length < rewardLength) {
			var rewardLeft = this.simpleImpl.fromChoiceSetWeighted(rewardLength - com_nevosoft_waw_data_types_TCost.keys(rewardDemanded).length,choiceSetLeft,weightsLeft);
			this.addNecessaryCount(rewardDemanded,rewardLeft,rewardLength - com_nevosoft_waw_data_types_TCost.keys(rewardDemanded).length);
		}
		return rewardDemanded;
	}
	,fromDropPack: function(pack) {
		var _gthis = this;
		if(pack.data.elements.length == 1) {
			return this.simpleImpl.fromDropPack(pack);
		}
		var choiceSet = [];
		var resIdToCounts_h = { };
		var resIdToWeights_h = { };
		var _g = 0;
		var _g1 = pack.data.elements;
		while(_g < _g1.length) {
			var element = _g1[_g];
			++_g;
			choiceSet.push(element.resourceId);
			if(!resIdToCounts_h.hasOwnProperty(element.resourceId)) {
				resIdToCounts_h[element.resourceId] = [];
				resIdToWeights_h[element.resourceId] = [];
			}
			resIdToCounts_h[element.resourceId].push(element.count);
			resIdToWeights_h[element.resourceId].push(element.chance);
		}
		var choiceSetDemanded = [];
		var choiceSetLeft = [];
		this.splitChoiceSet(choiceSetDemanded,choiceSetLeft,choiceSet);
		var rewardDemanded = this.fromChoiceSetRandom(Math.floor(Math.min(pack.data.count,choiceSetDemanded.length)),choiceSetDemanded,function(resId) {
			return com_nevosoft_isoframework_utils_MathUtils.randomWeightedChoice(resIdToCounts_h[resId],resIdToWeights_h[resId],_gthis.randomProvider);
		});
		if(choiceSetDemanded.length < pack.data.count) {
			var packLeft = this.dropPackFromChoiceSet(choiceSetLeft,pack.data.count - choiceSetDemanded.length,pack);
			var rewardLeft = this.simpleImpl.fromDropPack(packLeft);
			this.addNecessaryCount(rewardDemanded,rewardLeft,pack.data.count - com_nevosoft_waw_data_types_TCost.keys(rewardDemanded).length);
		}
		return rewardDemanded;
	}
	,fromChoiceSetRandom: function(rewardLength,choiceSet,amountProvider) {
		var reward = { };
		com_nevosoft_isoframework_utils_MathUtils.shuffleArray_Int(choiceSet,choiceSet.length,this.randomProvider);
		var _g = 0;
		var _g1 = rewardLength;
		while(_g < _g1) {
			var i = _g++;
			var resId = choiceSet[i];
			var value = amountProvider(resId);
			reward[resId == null ? "null" : "" + resId] = value;
		}
		return reward;
	}
	,splitChoiceSet: function(choiceSetDemanded,choiceSetLeft,choiceSet) {
		this.recalculateDemand();
		var _g = 0;
		while(_g < choiceSet.length) {
			var resId = choiceSet[_g];
			++_g;
			if(this.resIdToDemand.h.hasOwnProperty(resId)) {
				choiceSetDemanded.push(resId);
			} else {
				choiceSetLeft.push(resId);
			}
		}
	}
	,dropPackFromChoiceSet: function(choiceSet,count,sourcePack) {
		var packData = { id : -1, count : count, restrictions : sourcePack.data.restrictions, triggers : sourcePack.data.triggers, elements : [], gameEventsComponent : sourcePack.data.gameEventsComponent};
		var _g = 0;
		var _g1 = sourcePack.data.elements;
		while(_g < _g1.length) {
			var element = _g1[_g];
			++_g;
			if(choiceSet.indexOf(element.resourceId) >= 0) {
				packData.elements.push(element);
			}
		}
		return new com_nevosoft_waw_logic_systems_drop_DropPack(packData);
	}
	,recalculateDemand: function() {
		this.resIdToDemand = this.dataProvider.pointsOfSale.calculateDemand();
		return this.resIdToDemand;
	}
	,addNecessaryCount: function(rewardDemanded,rewardLeft,numToAdd) {
		if(numToAdd > 0) {
			var iterator = new com_nevosoft_waw_data_types_TCostIterator(rewardLeft);
			var _g = 0;
			var _g1 = numToAdd;
			while(_g < _g1) {
				var i = _g++;
				if(iterator.hasNext()) {
					com_nevosoft_waw_data_types_TCost.push(rewardDemanded,iterator.next());
				}
			}
		}
	}
	,__class__: com_nevosoft_waw_logic_systems_rewardChoice_ConsiderDemandRewardChoice
};
var com_nevosoft_waw_logic_systems_rewardChoice_RandomRewardChoice = function(randomProvider) {
	this.randomProvider = randomProvider;
};
com_nevosoft_waw_logic_systems_rewardChoice_RandomRewardChoice.__name__ = true;
com_nevosoft_waw_logic_systems_rewardChoice_RandomRewardChoice.__interfaces__ = [com_nevosoft_waw_logic_systems_rewardChoice_IChooseRewardStrategy];
com_nevosoft_waw_logic_systems_rewardChoice_RandomRewardChoice.prototype = {
	getName: function() {
		return "random";
	}
	,forDailyQuest: function(template) {
		return this.fromTemplate(template);
	}
	,forMarket: function(template) {
		return this.fromTemplate(template);
	}
	,forCamping: function(template) {
		return this.fromTemplate(template);
	}
	,forZeppelin: function(rewardLength,choiceSet,weights) {
		return this.fromChoiceSetWeighted(rewardLength,choiceSet,weights);
	}
	,forDropPack: function(pack) {
		return this.fromDropPack(pack);
	}
	,fromTemplate: function(template) {
		return com_nevosoft_waw_logic_systems_autoOrders_rewardGenerators_RewardByTemplate.generate(template,this.randomProvider);
	}
	,fromChoiceSet: function(rewardLength,choiceSet) {
		var reward = { };
		com_nevosoft_isoframework_utils_MathUtils.shuffleArray_Int(choiceSet,choiceSet.length,this.randomProvider);
		var _g = 0;
		var _g1 = rewardLength;
		while(_g < _g1) {
			var i = _g++;
			var key = choiceSet[i];
			reward[key == null ? "null" : "" + key] = 1;
		}
		return reward;
	}
	,fromChoiceSetWeighted: function(rewardLength,choiceSet,weights) {
		var reward = { };
		var _g = 0;
		var _g1 = rewardLength;
		while(_g < _g1) {
			var i = _g++;
			var resourceId = com_nevosoft_isoframework_utils_MathUtils.randomWeightedChoice(choiceSet,weights,this.randomProvider);
			var this1 = reward;
			var this2 = this1;
			var current = com_nevosoft_waw_data_types_TCost.hasKey(this2,resourceId) ? Reflect.field(this2,resourceId == null ? "null" : "" + resourceId) : 0;
			var value = current + 1;
			this1[resourceId == null ? "null" : "" + resourceId] = value;
		}
		return reward;
	}
	,fromDropPack: function(pack) {
		var reward = { };
		var _g = 0;
		var _g1 = pack.data.count;
		while(_g < _g1) {
			var i = _g++;
			var element = com_nevosoft_isoframework_utils_MathUtils.randomWeightedChoice2(pack.data.elements,$bind(this,this.dropElementWeightProvider),this.randomProvider);
			if(element.count > 0) {
				reward = com_nevosoft_waw_data_types_TCost.sum(reward,com_nevosoft_waw_data_types_TCost.fromIdValue(element.resourceId,element.count));
			}
			if(element.oneItem) {
				break;
			}
		}
		return reward;
	}
	,dropElementWeightProvider: function(element) {
		return element.chance;
	}
	,__class__: com_nevosoft_waw_logic_systems_rewardChoice_RandomRewardChoice
};
var com_nevosoft_waw_logic_systems_rewardChoice_RewardStrategyPicker = function(dataProvider,randomProvider) {
	if(dataProvider.meta.getGameEventMeta(dataProvider.getCurrentEventId()).attributes.specialResStrategy == null) {
		this.implementation = new com_nevosoft_waw_logic_systems_rewardChoice_RandomRewardChoice(randomProvider);
	} else {
		switch(dataProvider.meta.getGameEventMeta(dataProvider.getCurrentEventId()).attributes.specialResStrategy.algorithm) {
		case "consider_demand":
			this.implementation = new com_nevosoft_waw_logic_systems_rewardChoice_ConsiderDemandRewardChoice(dataProvider.meta.getGameEventMeta(dataProvider.getCurrentEventId()).attributes.specialResStrategy.config,dataProvider,randomProvider);
			break;
		case "random":
			this.implementation = new com_nevosoft_waw_logic_systems_rewardChoice_RandomRewardChoice(randomProvider);
			break;
		default:
			this.implementation = new com_nevosoft_waw_logic_systems_rewardChoice_RandomRewardChoice(randomProvider);
		}
	}
};
com_nevosoft_waw_logic_systems_rewardChoice_RewardStrategyPicker.__name__ = true;
com_nevosoft_waw_logic_systems_rewardChoice_RewardStrategyPicker.__interfaces__ = [com_nevosoft_waw_logic_systems_rewardChoice_IChooseRewardStrategy];
com_nevosoft_waw_logic_systems_rewardChoice_RewardStrategyPicker.prototype = {
	getName: function() {
		return this.implementation.getName();
	}
	,forDailyQuest: function(template) {
		return this.implementation.forDailyQuest(template);
	}
	,forMarket: function(template) {
		return this.implementation.forMarket(template);
	}
	,forCamping: function(template) {
		return this.implementation.forCamping(template);
	}
	,forZeppelin: function(rewardLength,choiceSet,weights) {
		return this.implementation.forZeppelin(rewardLength,choiceSet,weights);
	}
	,forDropPack: function(pack) {
		return this.implementation.forDropPack(pack);
	}
	,__class__: com_nevosoft_waw_logic_systems_rewardChoice_RewardStrategyPicker
};
var com_nevosoft_waw_stats_EStatEvent = $hxEnums["com.nevosoft.waw.stats.EStatEvent"] = { __ename__ : true, __constructs__ : ["GameInstall","GameEnter","GameLoadStep","AssetsLoadStep","ProfileGetStepBatchSend","ProfileGetStepBatchObsolete","ProfileGetStepGet","ProfileGetStepGetSuccess","ProfileGetStepCreate","ProfileGetStepCreateSuccess","ProfileGetStepFailed","TimeDiff","AssetsLoadStepBegin","RemoteAssetsStepBegin","AssetsLoadStepFailed","RemoteLoadStepFailed","MainQuestStart","MainQuestTaskStart","MainQuestTaskComplete","MainQuestComplete","DailyQuestStart","DailyQuestStageStart","DailyQuestStageComplete","DailyQuestComplete","DailyQuestStageSkip","GetLevel","GetVipLevel","Spell","ZeppelinOrder","ZeppelinHelp","ZeppelinSaleDir","Achivements","MarketSale","MarketSkip","MarketSkipCooldown","MarketRvSkip","OrdersHostSell","OrdersHostSkip","OrdersHostSkipNpc","OrdersHostSkipCooldown","DailyBonus","InApp","InAppError","InAppInitFailed","Offer","RubyShop","GetRuby","GetGold","GetResources","SpendRuby","SpendGold","SpendResources","SectorBuy","CampDone","CampOrder","CampSkip","TutorialCheckPoint","TutorialFinished","TutorialScenario","TutorialScenarioStep","SwitchMap","RewardedVideo","SocialNetworkLogin","RVsystemView","RVsystemClick"]
	,GameInstall: {_hx_index:0,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}
	,GameEnter: {_hx_index:1,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}
	,GameLoadStep: ($_=function(id,firstRun,len) { return {_hx_index:2,id:id,firstRun:firstRun,len:len,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["id","firstRun","len"],$_)
	,AssetsLoadStep: ($_=function(id,preogress,len) { return {_hx_index:3,id:id,preogress:preogress,len:len,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["id","preogress","len"],$_)
	,ProfileGetStepBatchSend: ($_=function(id) { return {_hx_index:4,id:id,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["id"],$_)
	,ProfileGetStepBatchObsolete: ($_=function(id) { return {_hx_index:5,id:id,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["id"],$_)
	,ProfileGetStepGet: ($_=function(id) { return {_hx_index:6,id:id,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["id"],$_)
	,ProfileGetStepGetSuccess: ($_=function(id) { return {_hx_index:7,id:id,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["id"],$_)
	,ProfileGetStepCreate: ($_=function(id) { return {_hx_index:8,id:id,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["id"],$_)
	,ProfileGetStepCreateSuccess: ($_=function(id) { return {_hx_index:9,id:id,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["id"],$_)
	,ProfileGetStepFailed: ($_=function(id,error) { return {_hx_index:10,id:id,error:error,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["id","error"],$_)
	,TimeDiff: ($_=function(dt) { return {_hx_index:11,dt:dt,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["dt"],$_)
	,AssetsLoadStepBegin: {_hx_index:12,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}
	,RemoteAssetsStepBegin: {_hx_index:13,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}
	,AssetsLoadStepFailed: ($_=function(error) { return {_hx_index:14,error:error,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["error"],$_)
	,RemoteLoadStepFailed: ($_=function(error) { return {_hx_index:15,error:error,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["error"],$_)
	,MainQuestStart: ($_=function(common) { return {_hx_index:16,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,MainQuestTaskStart: ($_=function(common) { return {_hx_index:17,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,MainQuestTaskComplete: ($_=function(common) { return {_hx_index:18,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,MainQuestComplete: ($_=function(common) { return {_hx_index:19,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,DailyQuestStart: ($_=function(common) { return {_hx_index:20,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,DailyQuestStageStart: ($_=function(common) { return {_hx_index:21,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,DailyQuestStageComplete: ($_=function(common) { return {_hx_index:22,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,DailyQuestComplete: ($_=function(common) { return {_hx_index:23,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,DailyQuestStageSkip: ($_=function(common) { return {_hx_index:24,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,GetLevel: ($_=function(levelId) { return {_hx_index:25,levelId:levelId,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["levelId"],$_)
	,GetVipLevel: ($_=function(levelId) { return {_hx_index:26,levelId:levelId,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["levelId"],$_)
	,Spell: ($_=function(spellType) { return {_hx_index:27,spellType:spellType,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["spellType"],$_)
	,ZeppelinOrder: ($_=function(objectId,amount) { return {_hx_index:28,objectId:objectId,amount:amount,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["objectId","amount"],$_)
	,ZeppelinHelp: ($_=function(objectId,amount) { return {_hx_index:29,objectId:objectId,amount:amount,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["objectId","amount"],$_)
	,ZeppelinSaleDir: ($_=function(common) { return {_hx_index:30,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,Achivements: ($_=function(id,achivLevel) { return {_hx_index:31,id:id,achivLevel:achivLevel,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["id","achivLevel"],$_)
	,MarketSale: ($_=function(common) { return {_hx_index:32,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,MarketSkip: ($_=function(common) { return {_hx_index:33,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,MarketSkipCooldown: {_hx_index:34,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}
	,MarketRvSkip: ($_=function(objectId) { return {_hx_index:35,objectId:objectId,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["objectId"],$_)
	,OrdersHostSell: ($_=function(common) { return {_hx_index:36,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,OrdersHostSkip: ($_=function(common) { return {_hx_index:37,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,OrdersHostSkipNpc: ($_=function(objectId) { return {_hx_index:38,objectId:objectId,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["objectId"],$_)
	,OrdersHostSkipCooldown: ($_=function(objectId) { return {_hx_index:39,objectId:objectId,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["objectId"],$_)
	,DailyBonus: ($_=function(common) { return {_hx_index:40,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,InApp: ($_=function(common,reason) { return {_hx_index:41,common:common,reason:reason,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common","reason"],$_)
	,InAppError: ($_=function(error) { return {_hx_index:42,error:error,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["error"],$_)
	,InAppInitFailed: ($_=function(errorMessage) { return {_hx_index:43,errorMessage:errorMessage,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["errorMessage"],$_)
	,Offer: ($_=function(common) { return {_hx_index:44,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,RubyShop: ($_=function(action,seconds,lot) { return {_hx_index:45,action:action,seconds:seconds,lot:lot,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["action","seconds","lot"],$_)
	,GetRuby: ($_=function(source,amount) { return {_hx_index:46,source:source,amount:amount,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["source","amount"],$_)
	,GetGold: ($_=function(source,amount,objectId) { return {_hx_index:47,source:source,amount:amount,objectId:objectId,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["source","amount","objectId"],$_)
	,GetResources: ($_=function(common) { return {_hx_index:48,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,SpendRuby: ($_=function(common) { return {_hx_index:49,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,SpendGold: ($_=function(common) { return {_hx_index:50,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,SpendResources: ($_=function(common) { return {_hx_index:51,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,SectorBuy: ($_=function(sectorId,openedAmount) { return {_hx_index:52,sectorId:sectorId,openedAmount:openedAmount,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["sectorId","openedAmount"],$_)
	,CampDone: ($_=function(amount,helpAmount) { return {_hx_index:53,amount:amount,helpAmount:helpAmount,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["amount","helpAmount"],$_)
	,CampOrder: ($_=function(resourceId,amount) { return {_hx_index:54,resourceId:resourceId,amount:amount,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["resourceId","amount"],$_)
	,CampSkip: ($_=function(common) { return {_hx_index:55,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,TutorialCheckPoint: ($_=function(id) { return {_hx_index:56,id:id,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["id"],$_)
	,TutorialFinished: {_hx_index:57,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}
	,TutorialScenario: ($_=function(id,finished) { return {_hx_index:58,id:id,finished:finished,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["id","finished"],$_)
	,TutorialScenarioStep: ($_=function(scenarioId,stepId) { return {_hx_index:59,scenarioId:scenarioId,stepId:stepId,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["scenarioId","stepId"],$_)
	,SwitchMap: ($_=function(common) { return {_hx_index:60,common:common,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["common"],$_)
	,RewardedVideo: ($_=function(reason) { return {_hx_index:61,reason:reason,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["reason"],$_)
	,SocialNetworkLogin: ($_=function(network) { return {_hx_index:62,network:network,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["network"],$_)
	,RVsystemView: ($_=function(network) { return {_hx_index:63,network:network,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["network"],$_)
	,RVsystemClick: ($_=function(network) { return {_hx_index:64,network:network,__enum__:"com.nevosoft.waw.stats.EStatEvent",toString:$estr}; },$_.__params__ = ["network"],$_)
};
var com_nevosoft_waw_tutorial_ETutorCheckpoints = {};
com_nevosoft_waw_tutorial_ETutorCheckpoints.getTutorCompleteCheckpoint = function() {
	return 13;
};
com_nevosoft_waw_tutorial_ETutorCheckpoints.getMaxCheckpoint = function() {
	return 15;
};
var haxe_IMap = function() { };
haxe_IMap.__name__ = true;
haxe_IMap.__isInterface__ = true;
haxe_IMap.prototype = {
	__class__: haxe_IMap
};
var haxe_Exception = function(message,previous,native) {
	Error.call(this,message);
	this.message = message;
	this.__previousException = previous;
	this.__nativeException = native != null ? native : this;
};
haxe_Exception.__name__ = true;
haxe_Exception.caught = function(value) {
	if(((value) instanceof haxe_Exception)) {
		return value;
	} else if(((value) instanceof Error)) {
		return new haxe_Exception(value.message,null,value);
	} else {
		return new haxe_ValueException(value,null,value);
	}
};
haxe_Exception.thrown = function(value) {
	if(((value) instanceof haxe_Exception)) {
		return value.get_native();
	} else if(((value) instanceof Error)) {
		return value;
	} else {
		var e = new haxe_ValueException(value);
		return e;
	}
};
haxe_Exception.__super__ = Error;
haxe_Exception.prototype = $extend(Error.prototype,{
	unwrap: function() {
		return this.__nativeException;
	}
	,get_native: function() {
		return this.__nativeException;
	}
	,__class__: haxe_Exception
	,__properties__: {get_native:"get_native"}
});
var haxe__$Template_TemplateExpr = $hxEnums["haxe._Template.TemplateExpr"] = { __ename__ : true, __constructs__ : ["OpVar","OpExpr","OpIf","OpStr","OpBlock","OpForeach","OpMacro"]
	,OpVar: ($_=function(v) { return {_hx_index:0,v:v,__enum__:"haxe._Template.TemplateExpr",toString:$estr}; },$_.__params__ = ["v"],$_)
	,OpExpr: ($_=function(expr) { return {_hx_index:1,expr:expr,__enum__:"haxe._Template.TemplateExpr",toString:$estr}; },$_.__params__ = ["expr"],$_)
	,OpIf: ($_=function(expr,eif,eelse) { return {_hx_index:2,expr:expr,eif:eif,eelse:eelse,__enum__:"haxe._Template.TemplateExpr",toString:$estr}; },$_.__params__ = ["expr","eif","eelse"],$_)
	,OpStr: ($_=function(str) { return {_hx_index:3,str:str,__enum__:"haxe._Template.TemplateExpr",toString:$estr}; },$_.__params__ = ["str"],$_)
	,OpBlock: ($_=function(l) { return {_hx_index:4,l:l,__enum__:"haxe._Template.TemplateExpr",toString:$estr}; },$_.__params__ = ["l"],$_)
	,OpForeach: ($_=function(expr,loop) { return {_hx_index:5,expr:expr,loop:loop,__enum__:"haxe._Template.TemplateExpr",toString:$estr}; },$_.__params__ = ["expr","loop"],$_)
	,OpMacro: ($_=function(name,params) { return {_hx_index:6,name:name,params:params,__enum__:"haxe._Template.TemplateExpr",toString:$estr}; },$_.__params__ = ["name","params"],$_)
};
var haxe_iterators_ArrayIterator = function(array) {
	this.current = 0;
	this.array = array;
};
haxe_iterators_ArrayIterator.__name__ = true;
haxe_iterators_ArrayIterator.prototype = {
	hasNext: function() {
		return this.current < this.array.length;
	}
	,next: function() {
		return this.array[this.current++];
	}
	,__class__: haxe_iterators_ArrayIterator
};
var haxe_Template = function(str) {
	var tokens = this.parseTokens(str);
	this.expr = this.parseBlock(tokens);
	if(!tokens.isEmpty()) {
		throw haxe_Exception.thrown("Unexpected '" + Std.string(tokens.first().s) + "'");
	}
};
haxe_Template.__name__ = true;
haxe_Template.prototype = {
	execute: function(context,macros) {
		this.macros = macros == null ? { } : macros;
		this.context = context;
		this.stack = new haxe_ds_List();
		this.buf = new StringBuf();
		this.run(this.expr);
		return this.buf.b;
	}
	,resolve: function(v) {
		if(v == "__current__") {
			return this.context;
		}
		var value = Reflect.getProperty(this.context,v);
		if(value != null || Object.prototype.hasOwnProperty.call(this.context,v)) {
			return value;
		}
		var _g_head = this.stack.h;
		while(_g_head != null) {
			var val = _g_head.item;
			_g_head = _g_head.next;
			var ctx = val;
			value = Reflect.getProperty(ctx,v);
			if(value != null || Object.prototype.hasOwnProperty.call(ctx,v)) {
				return value;
			}
		}
		return Reflect.field(haxe_Template.globals,v);
	}
	,parseTokens: function(data) {
		var tokens = new haxe_ds_List();
		while(haxe_Template.splitter.match(data)) {
			var p = haxe_Template.splitter.matchedPos();
			if(p.pos > 0) {
				tokens.add({ p : HxOverrides.substr(data,0,p.pos), s : true, l : null});
			}
			if(HxOverrides.cca(data,p.pos) == 58) {
				tokens.add({ p : HxOverrides.substr(data,p.pos + 2,p.len - 4), s : false, l : null});
				data = haxe_Template.splitter.matchedRight();
				continue;
			}
			var parp = p.pos + p.len;
			var npar = 1;
			var params = [];
			var part = "";
			while(true) {
				var c = HxOverrides.cca(data,parp);
				++parp;
				if(c == 40) {
					++npar;
				} else if(c == 41) {
					--npar;
					if(npar <= 0) {
						break;
					}
				} else if(c == null) {
					throw haxe_Exception.thrown("Unclosed macro parenthesis");
				}
				if(c == 44 && npar == 1) {
					params.push(part);
					part = "";
				} else {
					part += String.fromCodePoint(c);
				}
			}
			params.push(part);
			tokens.add({ p : haxe_Template.splitter.matched(2), s : false, l : params});
			data = HxOverrides.substr(data,parp,data.length - parp);
		}
		if(data.length > 0) {
			tokens.add({ p : data, s : true, l : null});
		}
		return tokens;
	}
	,parseBlock: function(tokens) {
		var l = new haxe_ds_List();
		while(true) {
			var t = tokens.first();
			if(t == null) {
				break;
			}
			if(!t.s && (t.p == "end" || t.p == "else" || HxOverrides.substr(t.p,0,7) == "elseif ")) {
				break;
			}
			l.add(this.parse(tokens));
		}
		if(l.length == 1) {
			return l.first();
		}
		return haxe__$Template_TemplateExpr.OpBlock(l);
	}
	,parse: function(tokens) {
		var t = tokens.pop();
		var p = t.p;
		if(t.s) {
			return haxe__$Template_TemplateExpr.OpStr(p);
		}
		if(t.l != null) {
			var pe = new haxe_ds_List();
			var _g = 0;
			var _g1 = t.l;
			while(_g < _g1.length) {
				var p1 = _g1[_g];
				++_g;
				pe.add(this.parseBlock(this.parseTokens(p1)));
			}
			return haxe__$Template_TemplateExpr.OpMacro(p,pe);
		}
		var kwdEnd = function(kwd) {
			var pos = -1;
			var length = kwd.length;
			if(HxOverrides.substr(p,0,length) == kwd) {
				pos = length;
				var _g_offset = 0;
				var _g_s = HxOverrides.substr(p,length,null);
				while(_g_offset < _g_s.length) {
					var c = _g_s.charCodeAt(_g_offset++);
					if(c == 32) {
						++pos;
					} else {
						break;
					}
				}
			}
			return pos;
		};
		var pos = kwdEnd("if");
		if(pos > 0) {
			p = HxOverrides.substr(p,pos,p.length - pos);
			var e = this.parseExpr(p);
			var eif = this.parseBlock(tokens);
			var t = tokens.first();
			var eelse;
			if(t == null) {
				throw haxe_Exception.thrown("Unclosed 'if'");
			}
			if(t.p == "end") {
				tokens.pop();
				eelse = null;
			} else if(t.p == "else") {
				tokens.pop();
				eelse = this.parseBlock(tokens);
				t = tokens.pop();
				if(t == null || t.p != "end") {
					throw haxe_Exception.thrown("Unclosed 'else'");
				}
			} else {
				t.p = HxOverrides.substr(t.p,4,t.p.length - 4);
				eelse = this.parse(tokens);
			}
			return haxe__$Template_TemplateExpr.OpIf(e,eif,eelse);
		}
		var pos = kwdEnd("foreach");
		if(pos >= 0) {
			p = HxOverrides.substr(p,pos,p.length - pos);
			var e = this.parseExpr(p);
			var efor = this.parseBlock(tokens);
			var t = tokens.pop();
			if(t == null || t.p != "end") {
				throw haxe_Exception.thrown("Unclosed 'foreach'");
			}
			return haxe__$Template_TemplateExpr.OpForeach(e,efor);
		}
		if(haxe_Template.expr_splitter.match(p)) {
			return haxe__$Template_TemplateExpr.OpExpr(this.parseExpr(p));
		}
		return haxe__$Template_TemplateExpr.OpVar(p);
	}
	,parseExpr: function(data) {
		var l = new haxe_ds_List();
		var expr = data;
		while(haxe_Template.expr_splitter.match(data)) {
			var p = haxe_Template.expr_splitter.matchedPos();
			var k = p.pos + p.len;
			if(p.pos != 0) {
				l.add({ p : HxOverrides.substr(data,0,p.pos), s : true});
			}
			var p1 = haxe_Template.expr_splitter.matched(0);
			l.add({ p : p1, s : p1.indexOf("\"") >= 0});
			data = haxe_Template.expr_splitter.matchedRight();
		}
		if(data.length != 0) {
			var _g_offset = 0;
			var _g_s = data;
			while(_g_offset < _g_s.length) {
				var _g1_key = _g_offset;
				var _g1_value = _g_s.charCodeAt(_g_offset++);
				var i = _g1_key;
				var c = _g1_value;
				if(c != 32) {
					l.add({ p : HxOverrides.substr(data,i,null), s : true});
					break;
				}
			}
		}
		var e;
		try {
			e = this.makeExpr(l);
			if(!l.isEmpty()) {
				throw haxe_Exception.thrown(l.first().p);
			}
		} catch( _g ) {
			var _g1 = haxe_Exception.caught(_g).unwrap();
			if(typeof(_g1) == "string") {
				var s = _g1;
				throw haxe_Exception.thrown("Unexpected '" + s + "' in " + expr);
			} else {
				throw _g;
			}
		}
		return function() {
			try {
				return e();
			} catch( _g ) {
				var exc = haxe_Exception.caught(_g).unwrap();
				throw haxe_Exception.thrown("Error : " + Std.string(exc) + " in " + expr);
			}
		};
	}
	,makeConst: function(v) {
		haxe_Template.expr_trim.match(v);
		v = haxe_Template.expr_trim.matched(1);
		if(HxOverrides.cca(v,0) == 34) {
			var str = HxOverrides.substr(v,1,v.length - 2);
			return function() {
				return str;
			};
		}
		if(haxe_Template.expr_int.match(v)) {
			var i = Std.parseInt(v);
			return function() {
				return i;
			};
		}
		if(haxe_Template.expr_float.match(v)) {
			var f = parseFloat(v);
			return function() {
				return f;
			};
		}
		var me = this;
		return function() {
			return me.resolve(v);
		};
	}
	,makePath: function(e,l) {
		var p = l.first();
		if(p == null || p.p != ".") {
			return e;
		}
		l.pop();
		var field = l.pop();
		if(field == null || !field.s) {
			throw haxe_Exception.thrown(field.p);
		}
		var f = field.p;
		haxe_Template.expr_trim.match(f);
		f = haxe_Template.expr_trim.matched(1);
		return this.makePath(function() {
			return Reflect.field(e(),f);
		},l);
	}
	,makeExpr: function(l) {
		return this.makePath(this.makeExpr2(l),l);
	}
	,skipSpaces: function(l) {
		var p = l.first();
		while(p != null) {
			var _g_offset = 0;
			var _g_s = p.p;
			while(_g_offset < _g_s.length) {
				var c = _g_s.charCodeAt(_g_offset++);
				if(c != 32) {
					return;
				}
			}
			l.pop();
			p = l.first();
		}
	}
	,makeExpr2: function(l) {
		this.skipSpaces(l);
		var p = l.pop();
		this.skipSpaces(l);
		if(p == null) {
			throw haxe_Exception.thrown("<eof>");
		}
		if(p.s) {
			return this.makeConst(p.p);
		}
		switch(p.p) {
		case "!":
			var e = this.makeExpr(l);
			return function() {
				var v = e();
				if(v != null) {
					return v == false;
				} else {
					return true;
				}
			};
		case "(":
			this.skipSpaces(l);
			var e1 = this.makeExpr(l);
			this.skipSpaces(l);
			var p1 = l.pop();
			if(p1 == null || p1.s) {
				throw haxe_Exception.thrown(p1);
			}
			if(p1.p == ")") {
				return e1;
			}
			this.skipSpaces(l);
			var e2 = this.makeExpr(l);
			this.skipSpaces(l);
			var p2 = l.pop();
			this.skipSpaces(l);
			if(p2 == null || p2.p != ")") {
				throw haxe_Exception.thrown(p2);
			}
			switch(p1.p) {
			case "!=":
				return function() {
					return e1() != e2();
				};
			case "&&":
				return function() {
					return e1() && e2();
				};
			case "*":
				return function() {
					return e1() * e2();
				};
			case "+":
				return function() {
					return e1() + e2();
				};
			case "-":
				return function() {
					return e1() - e2();
				};
			case "/":
				return function() {
					return e1() / e2();
				};
			case "<":
				return function() {
					return e1() < e2();
				};
			case "<=":
				return function() {
					return e1() <= e2();
				};
			case "==":
				return function() {
					return e1() == e2();
				};
			case ">":
				return function() {
					return e1() > e2();
				};
			case ">=":
				return function() {
					return e1() >= e2();
				};
			case "||":
				return function() {
					return e1() || e2();
				};
			default:
				throw haxe_Exception.thrown("Unknown operation " + p1.p);
			}
			break;
		case "-":
			var e3 = this.makeExpr(l);
			return function() {
				return -e3();
			};
		}
		throw haxe_Exception.thrown(p.p);
	}
	,run: function(e) {
		switch(e._hx_index) {
		case 0:
			var v = e.v;
			var _this = this.buf;
			var x = Std.string(this.resolve(v));
			_this.b += Std.string(x);
			break;
		case 1:
			var e1 = e.expr;
			var _this = this.buf;
			var x = Std.string(e1());
			_this.b += Std.string(x);
			break;
		case 2:
			var eelse = e.eelse;
			var eif = e.eif;
			var e1 = e.expr;
			var v = e1();
			if(v == null || v == false) {
				if(eelse != null) {
					this.run(eelse);
				}
			} else {
				this.run(eif);
			}
			break;
		case 3:
			var str = e.str;
			this.buf.b += str == null ? "null" : "" + str;
			break;
		case 4:
			var l = e.l;
			var _g_head = l.h;
			while(_g_head != null) {
				var val = _g_head.item;
				_g_head = _g_head.next;
				var e1 = val;
				this.run(e1);
			}
			break;
		case 5:
			var loop = e.loop;
			var e1 = e.expr;
			var v = e1();
			try {
				var x = $getIterator(v);
				if(x.hasNext == null) {
					throw haxe_Exception.thrown(null);
				}
				v = x;
			} catch( _g ) {
				try {
					if(v.hasNext == null) {
						throw haxe_Exception.thrown(null);
					}
				} catch( _g1 ) {
					throw haxe_Exception.thrown("Cannot iter on " + Std.string(v));
				}
			}
			this.stack.push(this.context);
			var v1 = v;
			var ctx = v1;
			while(ctx.hasNext()) {
				var ctx1 = ctx.next();
				this.context = ctx1;
				this.run(loop);
			}
			this.context = this.stack.pop();
			break;
		case 6:
			var params = e.params;
			var m = e.name;
			var v = Reflect.field(this.macros,m);
			var pl = [];
			var old = this.buf;
			pl.push($bind(this,this.resolve));
			var _g_head = params.h;
			while(_g_head != null) {
				var val = _g_head.item;
				_g_head = _g_head.next;
				var p = val;
				if(p._hx_index == 0) {
					var v1 = p.v;
					pl.push(this.resolve(v1));
				} else {
					this.buf = new StringBuf();
					this.run(p);
					pl.push(this.buf.b);
				}
			}
			this.buf = old;
			try {
				var _this = this.buf;
				var x = Std.string(v.apply(this.macros,pl));
				_this.b += Std.string(x);
			} catch( _g ) {
				var e = haxe_Exception.caught(_g).unwrap();
				var plstr;
				try {
					plstr = pl.join(",");
				} catch( _g1 ) {
					plstr = "???";
				}
				var msg = "Macro call " + m + "(" + plstr + ") failed (" + Std.string(e) + ")";
				throw haxe_Exception.thrown(msg);
			}
			break;
		}
	}
	,__class__: haxe_Template
};
var haxe_Timer = function(time_ms) {
	var me = this;
	this.id = setInterval(function() {
		me.run();
	},time_ms);
};
haxe_Timer.__name__ = true;
haxe_Timer.delay = function(f,time_ms) {
	var t = new haxe_Timer(time_ms);
	t.run = function() {
		t.stop();
		f();
	};
	return t;
};
haxe_Timer.prototype = {
	stop: function() {
		if(this.id == null) {
			return;
		}
		clearInterval(this.id);
		this.id = null;
	}
	,run: function() {
	}
	,__class__: haxe_Timer
};
var haxe_ValueException = function(value,previous,native) {
	haxe_Exception.call(this,String(value),previous,native);
	this.value = value;
};
haxe_ValueException.__name__ = true;
haxe_ValueException.__super__ = haxe_Exception;
haxe_ValueException.prototype = $extend(haxe_Exception.prototype,{
	unwrap: function() {
		return this.value;
	}
	,__class__: haxe_ValueException
});
var haxe_io_Bytes = function(data) {
	this.length = data.byteLength;
	this.b = new Uint8Array(data);
	this.b.bufferValue = data;
	data.hxBytes = this;
	data.bytes = this.b;
};
haxe_io_Bytes.__name__ = true;
haxe_io_Bytes.ofString = function(s,encoding) {
	if(encoding == haxe_io_Encoding.RawNative) {
		var buf = new Uint8Array(s.length << 1);
		var _g = 0;
		var _g1 = s.length;
		while(_g < _g1) {
			var i = _g++;
			var c = s.charCodeAt(i);
			buf[i << 1] = c & 255;
			buf[i << 1 | 1] = c >> 8;
		}
		return new haxe_io_Bytes(buf.buffer);
	}
	var a = [];
	var i = 0;
	while(i < s.length) {
		var c = s.charCodeAt(i++);
		if(55296 <= c && c <= 56319) {
			c = c - 55232 << 10 | s.charCodeAt(i++) & 1023;
		}
		if(c <= 127) {
			a.push(c);
		} else if(c <= 2047) {
			a.push(192 | c >> 6);
			a.push(128 | c & 63);
		} else if(c <= 65535) {
			a.push(224 | c >> 12);
			a.push(128 | c >> 6 & 63);
			a.push(128 | c & 63);
		} else {
			a.push(240 | c >> 18);
			a.push(128 | c >> 12 & 63);
			a.push(128 | c >> 6 & 63);
			a.push(128 | c & 63);
		}
	}
	return new haxe_io_Bytes(new Uint8Array(a).buffer);
};
haxe_io_Bytes.prototype = {
	getFloat: function(pos) {
		if(this.data == null) {
			this.data = new DataView(this.b.buffer,this.b.byteOffset,this.b.byteLength);
		}
		return this.data.getFloat32(pos,true);
	}
	,getString: function(pos,len,encoding) {
		if(pos < 0 || len < 0 || pos + len > this.length) {
			throw haxe_Exception.thrown(haxe_io_Error.OutsideBounds);
		}
		if(encoding == null) {
			encoding = haxe_io_Encoding.UTF8;
		}
		var s = "";
		var b = this.b;
		var i = pos;
		var max = pos + len;
		switch(encoding._hx_index) {
		case 0:
			var debug = pos > 0;
			while(i < max) {
				var c = b[i++];
				if(c < 128) {
					if(c == 0) {
						break;
					}
					s += String.fromCodePoint(c);
				} else if(c < 224) {
					var code = (c & 63) << 6 | b[i++] & 127;
					s += String.fromCodePoint(code);
				} else if(c < 240) {
					var c2 = b[i++];
					var code1 = (c & 31) << 12 | (c2 & 127) << 6 | b[i++] & 127;
					s += String.fromCodePoint(code1);
				} else {
					var c21 = b[i++];
					var c3 = b[i++];
					var u = (c & 15) << 18 | (c21 & 127) << 12 | (c3 & 127) << 6 | b[i++] & 127;
					s += String.fromCodePoint(u);
				}
			}
			break;
		case 1:
			while(i < max) {
				var c = b[i++] | b[i++] << 8;
				s += String.fromCodePoint(c);
			}
			break;
		}
		return s;
	}
	,__class__: haxe_io_Bytes
};
var haxe_io_Encoding = $hxEnums["haxe.io.Encoding"] = { __ename__ : true, __constructs__ : ["UTF8","RawNative"]
	,UTF8: {_hx_index:0,__enum__:"haxe.io.Encoding",toString:$estr}
	,RawNative: {_hx_index:1,__enum__:"haxe.io.Encoding",toString:$estr}
};
var haxe_crypto_Base64 = function() { };
haxe_crypto_Base64.__name__ = true;
haxe_crypto_Base64.decode = function(str,complement) {
	if(complement == null) {
		complement = true;
	}
	if(complement) {
		while(HxOverrides.cca(str,str.length - 1) == 61) str = HxOverrides.substr(str,0,-1);
	}
	return new haxe_crypto_BaseCode(haxe_crypto_Base64.BYTES).decodeBytes(haxe_io_Bytes.ofString(str));
};
var haxe_crypto_BaseCode = function(base) {
	var len = base.length;
	var nbits = 1;
	while(len > 1 << nbits) ++nbits;
	if(nbits > 8 || len != 1 << nbits) {
		throw haxe_Exception.thrown("BaseCode : base length must be a power of two.");
	}
	this.base = base;
	this.nbits = nbits;
};
haxe_crypto_BaseCode.__name__ = true;
haxe_crypto_BaseCode.prototype = {
	initTable: function() {
		var tbl = [];
		var _g = 0;
		while(_g < 256) {
			var i = _g++;
			tbl[i] = -1;
		}
		var _g = 0;
		var _g1 = this.base.length;
		while(_g < _g1) {
			var i = _g++;
			tbl[this.base.b[i]] = i;
		}
		this.tbl = tbl;
	}
	,decodeBytes: function(b) {
		var nbits = this.nbits;
		var base = this.base;
		if(this.tbl == null) {
			this.initTable();
		}
		var tbl = this.tbl;
		var size = b.length * nbits >> 3;
		var out = new haxe_io_Bytes(new ArrayBuffer(size));
		var buf = 0;
		var curbits = 0;
		var pin = 0;
		var pout = 0;
		while(pout < size) {
			while(curbits < 8) {
				curbits += nbits;
				buf <<= nbits;
				var i = tbl[b.b[pin++]];
				if(i == -1) {
					throw haxe_Exception.thrown("BaseCode : invalid encoded char");
				}
				buf |= i;
			}
			curbits -= 8;
			out.b[pout++] = buf >> curbits & 255;
		}
		return out;
	}
	,__class__: haxe_crypto_BaseCode
};
var haxe_crypto_Md5 = function() {
};
haxe_crypto_Md5.__name__ = true;
haxe_crypto_Md5.encode = function(s) {
	var m = new haxe_crypto_Md5();
	var h = m.doEncode(haxe_crypto_Md5.str2blks(s));
	return m.hex(h);
};
haxe_crypto_Md5.str2blks = function(str) {
	var str1 = haxe_io_Bytes.ofString(str);
	var nblk = (str1.length + 8 >> 6) + 1;
	var blks = [];
	var blksSize = nblk * 16;
	var _g = 0;
	var _g1 = blksSize;
	while(_g < _g1) {
		var i = _g++;
		blks[i] = 0;
	}
	var i = 0;
	var max = str1.length;
	var l = max * 8;
	while(i < max) {
		blks[i >> 2] |= str1.b[i] << (l + i) % 4 * 8;
		++i;
	}
	blks[i >> 2] |= 128 << (l + i) % 4 * 8;
	var k = nblk * 16 - 2;
	blks[k] = l & 255;
	blks[k] |= (l >>> 8 & 255) << 8;
	blks[k] |= (l >>> 16 & 255) << 16;
	blks[k] |= (l >>> 24 & 255) << 24;
	return blks;
};
haxe_crypto_Md5.prototype = {
	bitOR: function(a,b) {
		var lsb = a & 1 | b & 1;
		var msb31 = a >>> 1 | b >>> 1;
		return msb31 << 1 | lsb;
	}
	,bitXOR: function(a,b) {
		var lsb = a & 1 ^ b & 1;
		var msb31 = a >>> 1 ^ b >>> 1;
		return msb31 << 1 | lsb;
	}
	,bitAND: function(a,b) {
		var lsb = a & 1 & (b & 1);
		var msb31 = a >>> 1 & b >>> 1;
		return msb31 << 1 | lsb;
	}
	,addme: function(x,y) {
		var lsw = (x & 65535) + (y & 65535);
		var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
		return msw << 16 | lsw & 65535;
	}
	,hex: function(a) {
		var str = "";
		var hex_chr = "0123456789abcdef";
		var _g = 0;
		while(_g < a.length) {
			var num = a[_g];
			++_g;
			str += hex_chr.charAt(num >> 4 & 15) + hex_chr.charAt(num & 15);
			str += hex_chr.charAt(num >> 12 & 15) + hex_chr.charAt(num >> 8 & 15);
			str += hex_chr.charAt(num >> 20 & 15) + hex_chr.charAt(num >> 16 & 15);
			str += hex_chr.charAt(num >> 28 & 15) + hex_chr.charAt(num >> 24 & 15);
		}
		return str;
	}
	,rol: function(num,cnt) {
		return num << cnt | num >>> 32 - cnt;
	}
	,cmn: function(q,a,b,x,s,t) {
		return this.addme(this.rol(this.addme(this.addme(a,q),this.addme(x,t)),s),b);
	}
	,ff: function(a,b,c,d,x,s,t) {
		return this.cmn(this.bitOR(this.bitAND(b,c),this.bitAND(~b,d)),a,b,x,s,t);
	}
	,gg: function(a,b,c,d,x,s,t) {
		return this.cmn(this.bitOR(this.bitAND(b,d),this.bitAND(c,~d)),a,b,x,s,t);
	}
	,hh: function(a,b,c,d,x,s,t) {
		return this.cmn(this.bitXOR(this.bitXOR(b,c),d),a,b,x,s,t);
	}
	,ii: function(a,b,c,d,x,s,t) {
		return this.cmn(this.bitXOR(c,this.bitOR(b,~d)),a,b,x,s,t);
	}
	,doEncode: function(x) {
		var a = 1732584193;
		var b = -271733879;
		var c = -1732584194;
		var d = 271733878;
		var step;
		var i = 0;
		while(i < x.length) {
			var olda = a;
			var oldb = b;
			var oldc = c;
			var oldd = d;
			step = 0;
			a = this.ff(a,b,c,d,x[i],7,-680876936);
			d = this.ff(d,a,b,c,x[i + 1],12,-389564586);
			c = this.ff(c,d,a,b,x[i + 2],17,606105819);
			b = this.ff(b,c,d,a,x[i + 3],22,-1044525330);
			a = this.ff(a,b,c,d,x[i + 4],7,-176418897);
			d = this.ff(d,a,b,c,x[i + 5],12,1200080426);
			c = this.ff(c,d,a,b,x[i + 6],17,-1473231341);
			b = this.ff(b,c,d,a,x[i + 7],22,-45705983);
			a = this.ff(a,b,c,d,x[i + 8],7,1770035416);
			d = this.ff(d,a,b,c,x[i + 9],12,-1958414417);
			c = this.ff(c,d,a,b,x[i + 10],17,-42063);
			b = this.ff(b,c,d,a,x[i + 11],22,-1990404162);
			a = this.ff(a,b,c,d,x[i + 12],7,1804603682);
			d = this.ff(d,a,b,c,x[i + 13],12,-40341101);
			c = this.ff(c,d,a,b,x[i + 14],17,-1502002290);
			b = this.ff(b,c,d,a,x[i + 15],22,1236535329);
			a = this.gg(a,b,c,d,x[i + 1],5,-165796510);
			d = this.gg(d,a,b,c,x[i + 6],9,-1069501632);
			c = this.gg(c,d,a,b,x[i + 11],14,643717713);
			b = this.gg(b,c,d,a,x[i],20,-373897302);
			a = this.gg(a,b,c,d,x[i + 5],5,-701558691);
			d = this.gg(d,a,b,c,x[i + 10],9,38016083);
			c = this.gg(c,d,a,b,x[i + 15],14,-660478335);
			b = this.gg(b,c,d,a,x[i + 4],20,-405537848);
			a = this.gg(a,b,c,d,x[i + 9],5,568446438);
			d = this.gg(d,a,b,c,x[i + 14],9,-1019803690);
			c = this.gg(c,d,a,b,x[i + 3],14,-187363961);
			b = this.gg(b,c,d,a,x[i + 8],20,1163531501);
			a = this.gg(a,b,c,d,x[i + 13],5,-1444681467);
			d = this.gg(d,a,b,c,x[i + 2],9,-51403784);
			c = this.gg(c,d,a,b,x[i + 7],14,1735328473);
			b = this.gg(b,c,d,a,x[i + 12],20,-1926607734);
			a = this.hh(a,b,c,d,x[i + 5],4,-378558);
			d = this.hh(d,a,b,c,x[i + 8],11,-2022574463);
			c = this.hh(c,d,a,b,x[i + 11],16,1839030562);
			b = this.hh(b,c,d,a,x[i + 14],23,-35309556);
			a = this.hh(a,b,c,d,x[i + 1],4,-1530992060);
			d = this.hh(d,a,b,c,x[i + 4],11,1272893353);
			c = this.hh(c,d,a,b,x[i + 7],16,-155497632);
			b = this.hh(b,c,d,a,x[i + 10],23,-1094730640);
			a = this.hh(a,b,c,d,x[i + 13],4,681279174);
			d = this.hh(d,a,b,c,x[i],11,-358537222);
			c = this.hh(c,d,a,b,x[i + 3],16,-722521979);
			b = this.hh(b,c,d,a,x[i + 6],23,76029189);
			a = this.hh(a,b,c,d,x[i + 9],4,-640364487);
			d = this.hh(d,a,b,c,x[i + 12],11,-421815835);
			c = this.hh(c,d,a,b,x[i + 15],16,530742520);
			b = this.hh(b,c,d,a,x[i + 2],23,-995338651);
			a = this.ii(a,b,c,d,x[i],6,-198630844);
			d = this.ii(d,a,b,c,x[i + 7],10,1126891415);
			c = this.ii(c,d,a,b,x[i + 14],15,-1416354905);
			b = this.ii(b,c,d,a,x[i + 5],21,-57434055);
			a = this.ii(a,b,c,d,x[i + 12],6,1700485571);
			d = this.ii(d,a,b,c,x[i + 3],10,-1894986606);
			c = this.ii(c,d,a,b,x[i + 10],15,-1051523);
			b = this.ii(b,c,d,a,x[i + 1],21,-2054922799);
			a = this.ii(a,b,c,d,x[i + 8],6,1873313359);
			d = this.ii(d,a,b,c,x[i + 15],10,-30611744);
			c = this.ii(c,d,a,b,x[i + 6],15,-1560198380);
			b = this.ii(b,c,d,a,x[i + 13],21,1309151649);
			a = this.ii(a,b,c,d,x[i + 4],6,-145523070);
			d = this.ii(d,a,b,c,x[i + 11],10,-1120210379);
			c = this.ii(c,d,a,b,x[i + 2],15,718787259);
			b = this.ii(b,c,d,a,x[i + 9],21,-343485551);
			a = this.addme(a,olda);
			b = this.addme(b,oldb);
			c = this.addme(c,oldc);
			d = this.addme(d,oldd);
			i += 16;
		}
		return [a,b,c,d];
	}
	,__class__: haxe_crypto_Md5
};
var haxe_ds_IntMap = function() {
	this.h = { };
};
haxe_ds_IntMap.__name__ = true;
haxe_ds_IntMap.__interfaces__ = [haxe_IMap];
haxe_ds_IntMap.prototype = {
	set: function(key,value) {
		this.h[key] = value;
	}
	,get: function(key) {
		return this.h[key];
	}
	,exists: function(key) {
		return this.h.hasOwnProperty(key);
	}
	,remove: function(key) {
		if(!this.h.hasOwnProperty(key)) {
			return false;
		}
		delete(this.h[key]);
		return true;
	}
	,keys: function() {
		var a = [];
		for( var key in this.h ) if(this.h.hasOwnProperty(key)) a.push(key | 0);
		return new haxe_iterators_ArrayIterator(a);
	}
	,iterator: function() {
		return { ref : this.h, it : this.keys(), hasNext : function() {
			return this.it.hasNext();
		}, next : function() {
			var i = this.it.next();
			return this.ref[i];
		}};
	}
	,__class__: haxe_ds_IntMap
};
var haxe_ds_List = function() {
	this.length = 0;
};
haxe_ds_List.__name__ = true;
haxe_ds_List.prototype = {
	add: function(item) {
		var x = new haxe_ds__$List_ListNode(item,null);
		if(this.h == null) {
			this.h = x;
		} else {
			this.q.next = x;
		}
		this.q = x;
		this.length++;
	}
	,push: function(item) {
		var x = new haxe_ds__$List_ListNode(item,this.h);
		this.h = x;
		if(this.q == null) {
			this.q = x;
		}
		this.length++;
	}
	,first: function() {
		if(this.h == null) {
			return null;
		} else {
			return this.h.item;
		}
	}
	,pop: function() {
		if(this.h == null) {
			return null;
		}
		var x = this.h.item;
		this.h = this.h.next;
		if(this.h == null) {
			this.q = null;
		}
		this.length--;
		return x;
	}
	,isEmpty: function() {
		return this.h == null;
	}
	,toString: function() {
		var s_b = "";
		var first = true;
		var l = this.h;
		s_b += "{";
		while(l != null) {
			if(first) {
				first = false;
			} else {
				s_b += ", ";
			}
			s_b += Std.string(Std.string(l.item));
			l = l.next;
		}
		s_b += "}";
		return s_b;
	}
	,__class__: haxe_ds_List
};
var haxe_ds__$List_ListNode = function(item,next) {
	this.item = item;
	this.next = next;
};
haxe_ds__$List_ListNode.__name__ = true;
haxe_ds__$List_ListNode.prototype = {
	__class__: haxe_ds__$List_ListNode
};
var haxe_ds_Option = $hxEnums["haxe.ds.Option"] = { __ename__ : true, __constructs__ : ["Some","None"]
	,Some: ($_=function(v) { return {_hx_index:0,v:v,__enum__:"haxe.ds.Option",toString:$estr}; },$_.__params__ = ["v"],$_)
	,None: {_hx_index:1,__enum__:"haxe.ds.Option",toString:$estr}
};
var haxe_ds_StringMap = function() {
	this.h = Object.create(null);
};
haxe_ds_StringMap.__name__ = true;
haxe_ds_StringMap.__interfaces__ = [haxe_IMap];
haxe_ds_StringMap.keysIterator = function(h) {
	var keys = Object.keys(h);
	var len = keys.length;
	var idx = 0;
	return { hasNext : function() {
		return idx < len;
	}, next : function() {
		idx += 1;
		return keys[idx - 1];
	}};
};
haxe_ds_StringMap.valueIterator = function(h) {
	var keys = Object.keys(h);
	var len = keys.length;
	var idx = 0;
	return { hasNext : function() {
		return idx < len;
	}, next : function() {
		idx += 1;
		return h[keys[idx - 1]];
	}};
};
haxe_ds_StringMap.prototype = {
	exists: function(key) {
		return Object.prototype.hasOwnProperty.call(this.h,key);
	}
	,get: function(key) {
		return this.h[key];
	}
	,set: function(key,value) {
		this.h[key] = value;
	}
	,__class__: haxe_ds_StringMap
};
var haxe_io_Input = function() { };
haxe_io_Input.__name__ = true;
haxe_io_Input.prototype = {
	readByte: function() {
		throw haxe_Exception.thrown("Not implemented");
	}
	,readBytes: function(s,pos,len) {
		var k = len;
		var b = s.b;
		if(pos < 0 || len < 0 || pos + len > s.length) {
			throw haxe_Exception.thrown(haxe_io_Error.OutsideBounds);
		}
		try {
			while(k > 0) {
				b[pos] = this.readByte();
				++pos;
				--k;
			}
		} catch( _g ) {
			if(!((haxe_Exception.caught(_g).unwrap()) instanceof haxe_io_Eof)) {
				throw _g;
			}
		}
		return len - k;
	}
	,__class__: haxe_io_Input
};
var haxe_io_BytesInput = function(b,pos,len) {
	if(pos == null) {
		pos = 0;
	}
	if(len == null) {
		len = b.length - pos;
	}
	if(pos < 0 || len < 0 || pos + len > b.length) {
		throw haxe_Exception.thrown(haxe_io_Error.OutsideBounds);
	}
	this.b = b.b;
	this.pos = pos;
	this.len = len;
	this.totlen = len;
};
haxe_io_BytesInput.__name__ = true;
haxe_io_BytesInput.__super__ = haxe_io_Input;
haxe_io_BytesInput.prototype = $extend(haxe_io_Input.prototype,{
	readByte: function() {
		if(this.len == 0) {
			throw haxe_Exception.thrown(new haxe_io_Eof());
		}
		this.len--;
		return this.b[this.pos++];
	}
	,readBytes: function(buf,pos,len) {
		if(pos < 0 || len < 0 || pos + len > buf.length) {
			throw haxe_Exception.thrown(haxe_io_Error.OutsideBounds);
		}
		if(this.len == 0 && len > 0) {
			throw haxe_Exception.thrown(new haxe_io_Eof());
		}
		if(this.len < len) {
			len = this.len;
		}
		var b1 = this.b;
		var b2 = buf.b;
		var _g = 0;
		var _g1 = len;
		while(_g < _g1) {
			var i = _g++;
			b2[pos + i] = b1[this.pos + i];
		}
		this.pos += len;
		this.len -= len;
		return len;
	}
	,__class__: haxe_io_BytesInput
});
var haxe_io_Eof = function() {
};
haxe_io_Eof.__name__ = true;
haxe_io_Eof.prototype = {
	toString: function() {
		return "Eof";
	}
	,__class__: haxe_io_Eof
};
var haxe_io_Error = $hxEnums["haxe.io.Error"] = { __ename__ : true, __constructs__ : ["Blocked","Overflow","OutsideBounds","Custom"]
	,Blocked: {_hx_index:0,__enum__:"haxe.io.Error",toString:$estr}
	,Overflow: {_hx_index:1,__enum__:"haxe.io.Error",toString:$estr}
	,OutsideBounds: {_hx_index:2,__enum__:"haxe.io.Error",toString:$estr}
	,Custom: ($_=function(e) { return {_hx_index:3,e:e,__enum__:"haxe.io.Error",toString:$estr}; },$_.__params__ = ["e"],$_)
};
var haxe_io_Path = function(path) {
	switch(path) {
	case ".":case "..":
		this.dir = path;
		this.file = "";
		return;
	}
	var c1 = path.lastIndexOf("/");
	var c2 = path.lastIndexOf("\\");
	if(c1 < c2) {
		this.dir = HxOverrides.substr(path,0,c2);
		path = HxOverrides.substr(path,c2 + 1,null);
		this.backslash = true;
	} else if(c2 < c1) {
		this.dir = HxOverrides.substr(path,0,c1);
		path = HxOverrides.substr(path,c1 + 1,null);
	} else {
		this.dir = null;
	}
	var cp = path.lastIndexOf(".");
	if(cp != -1) {
		this.ext = HxOverrides.substr(path,cp + 1,null);
		this.file = HxOverrides.substr(path,0,cp);
	} else {
		this.ext = null;
		this.file = path;
	}
};
haxe_io_Path.__name__ = true;
haxe_io_Path.prototype = {
	__class__: haxe_io_Path
};
var js_Boot = function() { };
js_Boot.__name__ = true;
js_Boot.getClass = function(o) {
	if(o == null) {
		return null;
	} else if(((o) instanceof Array)) {
		return Array;
	} else {
		var cl = o.__class__;
		if(cl != null) {
			return cl;
		}
		var name = js_Boot.__nativeClassName(o);
		if(name != null) {
			return js_Boot.__resolveNativeClass(name);
		}
		return null;
	}
};
js_Boot.__string_rec = function(o,s) {
	if(o == null) {
		return "null";
	}
	if(s.length >= 5) {
		return "<...>";
	}
	var t = typeof(o);
	if(t == "function" && (o.__name__ || o.__ename__)) {
		t = "object";
	}
	switch(t) {
	case "function":
		return "<function>";
	case "object":
		if(o.__enum__) {
			var e = $hxEnums[o.__enum__];
			var n = e.__constructs__[o._hx_index];
			var con = e[n];
			if(con.__params__) {
				s = s + "\t";
				return n + "(" + ((function($this) {
					var $r;
					var _g = [];
					{
						var _g1 = 0;
						var _g2 = con.__params__;
						while(true) {
							if(!(_g1 < _g2.length)) {
								break;
							}
							var p = _g2[_g1];
							_g1 = _g1 + 1;
							_g.push(js_Boot.__string_rec(o[p],s));
						}
					}
					$r = _g;
					return $r;
				}(this))).join(",") + ")";
			} else {
				return n;
			}
		}
		if(((o) instanceof Array)) {
			var str = "[";
			s += "\t";
			var _g = 0;
			var _g1 = o.length;
			while(_g < _g1) {
				var i = _g++;
				str += (i > 0 ? "," : "") + js_Boot.__string_rec(o[i],s);
			}
			str += "]";
			return str;
		}
		var tostr;
		try {
			tostr = o.toString;
		} catch( _g ) {
			return "???";
		}
		if(tostr != null && tostr != Object.toString && typeof(tostr) == "function") {
			var s2 = o.toString();
			if(s2 != "[object Object]") {
				return s2;
			}
		}
		var str = "{\n";
		s += "\t";
		var hasp = o.hasOwnProperty != null;
		var k = null;
		for( k in o ) {
		if(hasp && !o.hasOwnProperty(k)) {
			continue;
		}
		if(k == "prototype" || k == "__class__" || k == "__super__" || k == "__interfaces__" || k == "__properties__") {
			continue;
		}
		if(str.length != 2) {
			str += ", \n";
		}
		str += s + k + " : " + js_Boot.__string_rec(o[k],s);
		}
		s = s.substring(1);
		str += "\n" + s + "}";
		return str;
	case "string":
		return o;
	default:
		return String(o);
	}
};
js_Boot.__interfLoop = function(cc,cl) {
	if(cc == null) {
		return false;
	}
	if(cc == cl) {
		return true;
	}
	var intf = cc.__interfaces__;
	if(intf != null) {
		var _g = 0;
		var _g1 = intf.length;
		while(_g < _g1) {
			var i = _g++;
			var i1 = intf[i];
			if(i1 == cl || js_Boot.__interfLoop(i1,cl)) {
				return true;
			}
		}
	}
	return js_Boot.__interfLoop(cc.__super__,cl);
};
js_Boot.__instanceof = function(o,cl) {
	if(cl == null) {
		return false;
	}
	switch(cl) {
	case Array:
		return ((o) instanceof Array);
	case Bool:
		return typeof(o) == "boolean";
	case Dynamic:
		return o != null;
	case Float:
		return typeof(o) == "number";
	case Int:
		if(typeof(o) == "number") {
			return ((o | 0) === o);
		} else {
			return false;
		}
		break;
	case String:
		return typeof(o) == "string";
	default:
		if(o != null) {
			if(typeof(cl) == "function") {
				if(js_Boot.__downcastCheck(o,cl)) {
					return true;
				}
			} else if(typeof(cl) == "object" && js_Boot.__isNativeObj(cl)) {
				if(((o) instanceof cl)) {
					return true;
				}
			}
		} else {
			return false;
		}
		if(cl == Class ? o.__name__ != null : false) {
			return true;
		}
		if(cl == Enum ? o.__ename__ != null : false) {
			return true;
		}
		return o.__enum__ != null ? $hxEnums[o.__enum__] == cl : false;
	}
};
js_Boot.__downcastCheck = function(o,cl) {
	if(!((o) instanceof cl)) {
		if(cl.__isInterface__) {
			return js_Boot.__interfLoop(js_Boot.getClass(o),cl);
		} else {
			return false;
		}
	} else {
		return true;
	}
};
js_Boot.__implements = function(o,iface) {
	return js_Boot.__interfLoop(js_Boot.getClass(o),iface);
};
js_Boot.__cast = function(o,t) {
	if(o == null || js_Boot.__instanceof(o,t)) {
		return o;
	} else {
		throw haxe_Exception.thrown("Cannot cast " + Std.string(o) + " to " + Std.string(t));
	}
};
js_Boot.__nativeClassName = function(o) {
	var name = js_Boot.__toStr.call(o).slice(8,-1);
	if(name == "Object" || name == "Function" || name == "Math" || name == "JSON") {
		return null;
	}
	return name;
};
js_Boot.__isNativeObj = function(o) {
	return js_Boot.__nativeClassName(o) != null;
};
js_Boot.__resolveNativeClass = function(name) {
	return $global[name];
};
var msignal_Signal = function(valueClasses) {
	if(valueClasses == null) {
		valueClasses = [];
	}
	this.valueClasses = valueClasses;
	this.slots = msignal_SlotList.NIL;
	this.priorityBased = false;
};
msignal_Signal.__name__ = true;
msignal_Signal.prototype = {
	add: function(listener) {
		return this.registerListener(listener);
	}
	,addOnce: function(listener) {
		return this.registerListener(listener,true);
	}
	,addWithPriority: function(listener,priority) {
		if(priority == null) {
			priority = 0;
		}
		return this.registerListener(listener,false,priority);
	}
	,addOnceWithPriority: function(listener,priority) {
		if(priority == null) {
			priority = 0;
		}
		return this.registerListener(listener,true,priority);
	}
	,remove: function(listener) {
		var slot = this.slots.find(listener);
		if(slot == null) {
			return null;
		}
		this.slots = this.slots.filterNot(listener);
		return slot;
	}
	,removeAll: function() {
		this.slots = msignal_SlotList.NIL;
	}
	,registerListener: function(listener,once,priority) {
		if(priority == null) {
			priority = 0;
		}
		if(once == null) {
			once = false;
		}
		if(this.registrationPossible(listener,once)) {
			var newSlot = this.createSlot(listener,once,priority);
			if(!this.priorityBased && priority != 0) {
				this.priorityBased = true;
			}
			if(!this.priorityBased && priority == 0) {
				this.slots = this.slots.prepend(newSlot);
			} else {
				this.slots = this.slots.insertWithPriority(newSlot);
			}
			return newSlot;
		}
		return this.slots.find(listener);
	}
	,registrationPossible: function(listener,once) {
		if(!this.slots.nonEmpty) {
			return true;
		}
		var existingSlot = this.slots.find(listener);
		if(existingSlot == null) {
			return true;
		}
		return false;
	}
	,createSlot: function(listener,once,priority) {
		if(priority == null) {
			priority = 0;
		}
		if(once == null) {
			once = false;
		}
		return null;
	}
	,get_numListeners: function() {
		return this.slots.get_length();
	}
	,__class__: msignal_Signal
	,__properties__: {get_numListeners:"get_numListeners"}
};
var msignal_EventSignal = function(target) {
	msignal_Signal.call(this,[msignal_Event]);
	this.target = target;
};
msignal_EventSignal.__name__ = true;
msignal_EventSignal.__super__ = msignal_Signal;
msignal_EventSignal.prototype = $extend(msignal_Signal.prototype,{
	dispatch: function(event) {
		if(event.target == null) {
			event.target = this.target;
			event.signal = this;
		}
		event.currentTarget = this.target;
		var slotsToProcess = this.slots;
		while(slotsToProcess.nonEmpty) {
			slotsToProcess.head.execute(event);
			slotsToProcess = slotsToProcess.tail;
		}
	}
	,dispatchType: function(type) {
		this.dispatch(new msignal_Event(type));
	}
	,bubble: function(event) {
		this.dispatch(event);
		var currentTarget = this.target;
		while(currentTarget != null && Object.prototype.hasOwnProperty.call(currentTarget,"parent")) {
			currentTarget = Reflect.field(currentTarget,"parent");
			if(js_Boot.__implements(currentTarget,msignal_EventDispatcher)) {
				event.currentTarget = currentTarget;
				var dispatcher = js_Boot.__cast(currentTarget , msignal_EventDispatcher);
				if(!dispatcher.dispatchEvent(event)) {
					break;
				}
			}
		}
	}
	,bubbleType: function(type) {
		this.bubble(new msignal_Event(type));
	}
	,createSlot: function(listener,once,priority) {
		if(priority == null) {
			priority = 0;
		}
		if(once == null) {
			once = false;
		}
		return new msignal_EventSlot(this,listener,once,priority);
	}
	,__class__: msignal_EventSignal
});
var msignal_Slot = function(signal,listener,once,priority) {
	if(priority == null) {
		priority = 0;
	}
	if(once == null) {
		once = false;
	}
	this.signal = signal;
	this.set_listener(listener);
	this.once = once;
	this.priority = priority;
	this.enabled = true;
};
msignal_Slot.__name__ = true;
msignal_Slot.prototype = {
	remove: function() {
		this.signal.remove(this.listener);
	}
	,set_listener: function(value) {
		return this.listener = value;
	}
	,__class__: msignal_Slot
	,__properties__: {set_listener:"set_listener"}
};
var msignal_EventSlot = function(signal,listener,once,priority) {
	if(priority == null) {
		priority = 0;
	}
	if(once == null) {
		once = false;
	}
	msignal_Slot.call(this,signal,listener,once,priority);
};
msignal_EventSlot.__name__ = true;
msignal_EventSlot.typeEq = function(a,b) {
	if(a == b) {
		return true;
	}
	var _g = Type.typeof(a);
	if(_g._hx_index == 7) {
		var _g1 = _g.e;
		return msignal_EventSlot.enumTypeEq(a,b);
	} else {
		return false;
	}
};
msignal_EventSlot.enumTypeEq = function(a,b) {
	if(a == b) {
		return true;
	}
	if(Type.getEnum(a) != Type.getEnum(b)) {
		return false;
	}
	if(a._hx_index != b._hx_index) {
		return false;
	}
	var aParams = Type.enumParameters(a);
	if(aParams.length == 0) {
		return true;
	}
	var bParams = Type.enumParameters(b);
	var _g = 0;
	var _g1 = aParams.length;
	while(_g < _g1) {
		var i = _g++;
		var aParam = aParams[i];
		var bParam = bParams[i];
		if(aParam == null) {
			continue;
		}
		if(!msignal_EventSlot.typeEq(aParam,bParam)) {
			return false;
		}
	}
	return true;
};
msignal_EventSlot.__super__ = msignal_Slot;
msignal_EventSlot.prototype = $extend(msignal_Slot.prototype,{
	execute: function(value1) {
		if(!this.enabled) {
			return;
		}
		if(this.filterType != null && !msignal_EventSlot.typeEq(this.filterType,value1.type)) {
			return;
		}
		if(this.once) {
			this.remove();
		}
		this.listener(value1);
	}
	,forType: function(value) {
		this.filterType = value;
	}
	,__class__: msignal_EventSlot
});
var msignal_Event = function(type) {
	this.type = type;
};
msignal_Event.__name__ = true;
msignal_Event.prototype = {
	__class__: msignal_Event
};
var msignal_EventDispatcher = function() { };
msignal_EventDispatcher.__name__ = true;
msignal_EventDispatcher.__isInterface__ = true;
msignal_EventDispatcher.prototype = {
	__class__: msignal_EventDispatcher
};
var msignal_Signal0 = function() {
	msignal_Signal.call(this);
};
msignal_Signal0.__name__ = true;
msignal_Signal0.__super__ = msignal_Signal;
msignal_Signal0.prototype = $extend(msignal_Signal.prototype,{
	dispatch: function() {
		var slotsToProcess = this.slots;
		while(slotsToProcess.nonEmpty) {
			slotsToProcess.head.execute();
			slotsToProcess = slotsToProcess.tail;
		}
	}
	,createSlot: function(listener,once,priority) {
		if(priority == null) {
			priority = 0;
		}
		if(once == null) {
			once = false;
		}
		return new msignal_Slot0(this,listener,once,priority);
	}
	,__class__: msignal_Signal0
});
var msignal_Signal1 = function(type) {
	msignal_Signal.call(this,[type]);
};
msignal_Signal1.__name__ = true;
msignal_Signal1.__super__ = msignal_Signal;
msignal_Signal1.prototype = $extend(msignal_Signal.prototype,{
	dispatch: function(value) {
		var slotsToProcess = this.slots;
		while(slotsToProcess.nonEmpty) {
			slotsToProcess.head.execute(value);
			slotsToProcess = slotsToProcess.tail;
		}
	}
	,createSlot: function(listener,once,priority) {
		if(priority == null) {
			priority = 0;
		}
		if(once == null) {
			once = false;
		}
		return new msignal_Slot1(this,listener,once,priority);
	}
	,__class__: msignal_Signal1
});
var msignal_Signal2 = function(type1,type2) {
	msignal_Signal.call(this,[type1,type2]);
};
msignal_Signal2.__name__ = true;
msignal_Signal2.__super__ = msignal_Signal;
msignal_Signal2.prototype = $extend(msignal_Signal.prototype,{
	dispatch: function(value1,value2) {
		var slotsToProcess = this.slots;
		while(slotsToProcess.nonEmpty) {
			slotsToProcess.head.execute(value1,value2);
			slotsToProcess = slotsToProcess.tail;
		}
	}
	,createSlot: function(listener,once,priority) {
		if(priority == null) {
			priority = 0;
		}
		if(once == null) {
			once = false;
		}
		return new msignal_Slot2(this,listener,once,priority);
	}
	,__class__: msignal_Signal2
});
var msignal_Slot0 = function(signal,listener,once,priority) {
	if(priority == null) {
		priority = 0;
	}
	if(once == null) {
		once = false;
	}
	msignal_Slot.call(this,signal,listener,once,priority);
};
msignal_Slot0.__name__ = true;
msignal_Slot0.__super__ = msignal_Slot;
msignal_Slot0.prototype = $extend(msignal_Slot.prototype,{
	execute: function() {
		if(!this.enabled) {
			return;
		}
		if(this.once) {
			this.remove();
		}
		this.listener();
	}
	,__class__: msignal_Slot0
});
var msignal_Slot1 = function(signal,listener,once,priority) {
	if(priority == null) {
		priority = 0;
	}
	if(once == null) {
		once = false;
	}
	msignal_Slot.call(this,signal,listener,once,priority);
};
msignal_Slot1.__name__ = true;
msignal_Slot1.__super__ = msignal_Slot;
msignal_Slot1.prototype = $extend(msignal_Slot.prototype,{
	execute: function(value1) {
		if(!this.enabled) {
			return;
		}
		if(this.once) {
			this.remove();
		}
		if(this.param != null) {
			value1 = this.param;
		}
		this.listener(value1);
	}
	,__class__: msignal_Slot1
});
var msignal_Slot2 = function(signal,listener,once,priority) {
	if(priority == null) {
		priority = 0;
	}
	if(once == null) {
		once = false;
	}
	msignal_Slot.call(this,signal,listener,once,priority);
};
msignal_Slot2.__name__ = true;
msignal_Slot2.__super__ = msignal_Slot;
msignal_Slot2.prototype = $extend(msignal_Slot.prototype,{
	execute: function(value1,value2) {
		if(!this.enabled) {
			return;
		}
		if(this.once) {
			this.remove();
		}
		if(this.param1 != null) {
			value1 = this.param1;
		}
		if(this.param2 != null) {
			value2 = this.param2;
		}
		this.listener(value1,value2);
	}
	,__class__: msignal_Slot2
});
var msignal_SlotList = function(head,tail) {
	this.nonEmpty = false;
	if(head == null && tail == null) {
		this.nonEmpty = false;
	} else if(head != null) {
		this.head = head;
		this.tail = tail == null ? msignal_SlotList.NIL : tail;
		this.nonEmpty = true;
	}
};
msignal_SlotList.__name__ = true;
msignal_SlotList.prototype = {
	get_length: function() {
		if(!this.nonEmpty) {
			return 0;
		}
		if(this.tail == msignal_SlotList.NIL) {
			return 1;
		}
		var result = 0;
		var p = this;
		while(p.nonEmpty) {
			++result;
			p = p.tail;
		}
		return result;
	}
	,prepend: function(slot) {
		return new msignal_SlotList(slot,this);
	}
	,append: function(slot) {
		if(slot == null) {
			return this;
		}
		if(!this.nonEmpty) {
			return new msignal_SlotList(slot);
		}
		if(this.tail == msignal_SlotList.NIL) {
			return new msignal_SlotList(slot).prepend(this.head);
		}
		var wholeClone = new msignal_SlotList(this.head);
		var subClone = wholeClone;
		var current = this.tail;
		while(current.nonEmpty) {
			subClone = subClone.tail = new msignal_SlotList(current.head);
			current = current.tail;
		}
		subClone.tail = new msignal_SlotList(slot);
		return wholeClone;
	}
	,insertWithPriority: function(slot) {
		if(!this.nonEmpty) {
			return new msignal_SlotList(slot);
		}
		var priority = slot.priority;
		if(priority >= this.head.priority) {
			return this.prepend(slot);
		}
		var wholeClone = new msignal_SlotList(this.head);
		var subClone = wholeClone;
		var current = this.tail;
		while(current.nonEmpty) {
			if(priority > current.head.priority) {
				subClone.tail = current.prepend(slot);
				return wholeClone;
			}
			subClone = subClone.tail = new msignal_SlotList(current.head);
			current = current.tail;
		}
		subClone.tail = new msignal_SlotList(slot);
		return wholeClone;
	}
	,filterNot: function(listener) {
		if(!this.nonEmpty || listener == null) {
			return this;
		}
		if(Reflect.compareMethods(this.head.listener,listener)) {
			return this.tail;
		}
		var wholeClone = new msignal_SlotList(this.head);
		var subClone = wholeClone;
		var current = this.tail;
		while(current.nonEmpty) {
			if(Reflect.compareMethods(current.head.listener,listener)) {
				subClone.tail = current.tail;
				return wholeClone;
			}
			subClone = subClone.tail = new msignal_SlotList(current.head);
			current = current.tail;
		}
		return this;
	}
	,contains: function(listener) {
		if(!this.nonEmpty) {
			return false;
		}
		var p = this;
		while(p.nonEmpty) {
			if(Reflect.compareMethods(p.head.listener,listener)) {
				return true;
			}
			p = p.tail;
		}
		return false;
	}
	,find: function(listener) {
		if(!this.nonEmpty) {
			return null;
		}
		var p = this;
		while(p.nonEmpty) {
			if(Reflect.compareMethods(p.head.listener,listener)) {
				return p.head;
			}
			p = p.tail;
		}
		return null;
	}
	,__class__: msignal_SlotList
	,__properties__: {get_length:"get_length"}
};
var spine_ArrayUtils = function() { };
spine_ArrayUtils.__name__ = true;
spine_ArrayUtils.allocFloat = function(n) {
	var this1 = new Array(n);
	var v = this1;
	var _g = 0;
	var _g1 = n;
	while(_g < _g1) {
		var i = _g++;
		v[i] = 0;
	}
	return v;
};
spine_ArrayUtils.allocString = function(n) {
	var this1 = new Array(n);
	return this1;
};
var spine_Updatable = function() {
};
spine_Updatable.__name__ = true;
spine_Updatable.prototype = {
	update: function() {
	}
	,__class__: spine_Updatable
};
var spine_Bone = function(data,skeleton,parent) {
	this._children = [];
	spine_Updatable.call(this);
	if(data == null) {
		throw haxe_Exception.thrown("data cannot be null.");
	}
	if(skeleton == null) {
		throw haxe_Exception.thrown("skeleton cannot be null.");
	}
	this._data = data;
	this._skeleton = skeleton;
	this._parent = parent;
	this.setToSetupPose();
};
spine_Bone.__name__ = true;
spine_Bone.__super__ = spine_Updatable;
spine_Bone.prototype = $extend(spine_Updatable.prototype,{
	update: function() {
		this.updateWorldTransformWith(this.x,this.y,this.rotation,this.scaleX,this.scaleY,this.shearX,this.shearY);
	}
	,updateWorldTransform: function() {
		this.updateWorldTransformWith(this.x,this.y,this.rotation,this.scaleX,this.scaleY,this.shearX,this.shearY);
	}
	,updateWorldTransformWith: function(x,y,rotation,scaleX,scaleY,shearX,shearY) {
		this.ax = x;
		this.ay = y;
		this.arotation = rotation;
		this.ascaleX = scaleX;
		this.ascaleY = scaleY;
		this.ashearX = shearX;
		this.ashearY = shearY;
		this.appliedValid = true;
		var rotationY = 0;
		var la = 0;
		var lb = 0;
		var lc = 0;
		var ld = 0;
		var sin = 0;
		var cos = 0;
		var s = 0;
		var parent = this._parent;
		if(parent == null) {
			rotationY = rotation + 90 + shearY;
			la = Math.cos((rotation + shearX) * spine_MathUtils.degRad) * scaleX;
			lb = Math.cos(rotationY * spine_MathUtils.degRad) * scaleY;
			lc = Math.sin((rotation + shearX) * spine_MathUtils.degRad) * scaleX;
			ld = Math.sin(rotationY * spine_MathUtils.degRad) * scaleY;
			var skeleton = this._skeleton;
			if(skeleton.flipX) {
				x = -x;
				la = -la;
				lb = -lb;
			}
			if(skeleton.flipY != spine_Bone.yDown) {
				y = -y;
				lc = -lc;
				ld = -ld;
			}
			this._a = la;
			this._b = lb;
			this._c = lc;
			this._d = ld;
			this._worldX = x + skeleton.x;
			this._worldY = y + skeleton.y;
			return;
		}
		var pa = parent._a;
		var pb = parent._b;
		var pc = parent._c;
		var pd = parent._d;
		this._worldX = pa * x + pb * y + parent._worldX;
		this._worldY = pc * x + pd * y + parent._worldY;
		switch(this._data.transformMode) {
		case 0:
			rotationY = rotation + 90 + shearY;
			la = Math.cos((rotation + shearX) * spine_MathUtils.degRad) * scaleX;
			lb = Math.cos(rotationY * spine_MathUtils.degRad) * scaleY;
			lc = Math.sin((rotation + shearX) * spine_MathUtils.degRad) * scaleX;
			ld = Math.sin(rotationY * spine_MathUtils.degRad) * scaleY;
			this._a = pa * la + pb * lc;
			this._b = pa * lb + pb * ld;
			this._c = pc * la + pd * lc;
			this._d = pc * lb + pd * ld;
			return;
		case 1:
			rotationY = rotation + 90 + shearY;
			this._a = Math.cos((rotation + shearX) * spine_MathUtils.degRad) * scaleX;
			this._b = Math.cos(rotationY * spine_MathUtils.degRad) * scaleY;
			this._c = Math.sin((rotation + shearX) * spine_MathUtils.degRad) * scaleX;
			this._d = Math.sin(rotationY * spine_MathUtils.degRad) * scaleY;
			break;
		case 2:
			s = pa * pa + pc * pc;
			var prx = 0;
			if(s > 0.0001) {
				s = Math.abs(pa * pd - pb * pc) / s;
				pb = pc * s;
				pd = pa * s;
				prx = Math.atan2(pc,pa) * spine_MathUtils.radDeg;
			} else {
				pa = 0;
				pc = 0;
				prx = 90 - Math.atan2(pd,pb) * spine_MathUtils.radDeg;
			}
			var rx = rotation + shearX - prx;
			var ry = rotation + shearY - prx + 90;
			la = Math.cos(rx * spine_MathUtils.degRad) * scaleX;
			lb = Math.cos(ry * spine_MathUtils.degRad) * scaleY;
			lc = Math.sin(rx * spine_MathUtils.degRad) * scaleX;
			ld = Math.sin(ry * spine_MathUtils.degRad) * scaleY;
			this._a = pa * la - pb * lc;
			this._b = pa * lb - pb * ld;
			this._c = pc * la + pd * lc;
			this._d = pc * lb + pd * ld;
			break;
		case 3:case 4:
			cos = Math.cos(rotation * spine_MathUtils.degRad);
			sin = Math.sin(rotation * spine_MathUtils.degRad);
			var za = pa * cos + pb * sin;
			var zc = pc * cos + pd * sin;
			s = Math.sqrt(za * za + zc * zc);
			if(s > 0.00001) {
				s = 1 / s;
			}
			za *= s;
			zc *= s;
			s = Math.sqrt(za * za + zc * zc);
			var r = Math.PI / 2 + Math.atan2(zc,za);
			var zb = Math.cos(r) * s;
			var zd = Math.sin(r) * s;
			la = Math.cos(shearX * spine_MathUtils.degRad) * scaleX;
			lb = Math.cos((90 + shearY) * spine_MathUtils.degRad) * scaleY;
			lc = Math.sin(shearX * spine_MathUtils.degRad) * scaleX;
			ld = Math.sin((90 + shearY) * spine_MathUtils.degRad) * scaleY;
			this._a = za * la + zb * lc;
			this._b = za * lb + zb * ld;
			this._c = zc * la + zd * lc;
			this._d = zc * lb + zd * ld;
			if(this._data.transformMode != 4 ? pa * pd - pb * pc < 0 : this._skeleton.flipX != this._skeleton.flipY) {
				this._b = -this._b;
				this._d = -this._d;
			}
			return;
		}
		if(this._skeleton.flipX) {
			this._a = -this._a;
			this._b = -this._b;
		}
		if(this._skeleton.flipY != spine_Bone.yDown) {
			this._c = -this._c;
			this._d = -this._d;
		}
	}
	,setToSetupPose: function() {
		this.x = this._data.x;
		this.y = this._data.y;
		this.rotation = this._data.rotation;
		this.scaleX = this._data.scaleX;
		this.scaleY = this._data.scaleY;
		this.shearX = this._data.shearX;
		this.shearY = this._data.shearY;
	}
	,worldToLocalRotationX: function() {
		var parent = this._parent;
		if(parent == null) {
			return this.arotation;
		}
		var pa = parent._a;
		var pb = parent._b;
		var pc = parent._c;
		var pd = parent._d;
		var a = this._a;
		var c = this._c;
		return Math.atan2(pa * c - pc * a,pd * a - pb * c) * spine_MathUtils.radDeg;
	}
	,worldToLocalRotationY: function() {
		var parent = this._parent;
		if(parent == null) {
			return this.arotation;
		}
		var pa = parent._a;
		var pb = parent._b;
		var pc = parent._c;
		var pd = parent._d;
		var b = this._b;
		var d = this._d;
		return Math.atan2(pa * d - pc * b,pd * b - pb * d) * spine_MathUtils.radDeg;
	}
	,rotateWorld: function(degrees) {
		var a = this._a;
		var b = this._b;
		var c = this._c;
		var d = this._d;
		var cos = Math.cos(degrees * spine_MathUtils.degRad);
		var sin = Math.sin(degrees * spine_MathUtils.degRad);
		this._a = cos * a - sin * c;
		this._b = cos * b - sin * d;
		this._c = sin * a + cos * c;
		this._d = sin * b + cos * d;
		this.appliedValid = false;
	}
	,updateAppliedTransform: function() {
		this.appliedValid = true;
		var parent = this._parent;
		if(parent == null) {
			this.ax = this._worldX;
			this.ay = this._worldY;
			this.arotation = Math.atan2(this._c,this._a) * spine_MathUtils.radDeg;
			this.ascaleX = Math.sqrt(this._a * this._a + this._c * this._c);
			this.ascaleY = Math.sqrt(this._b * this._b + this._d * this._d);
			this.ashearX = 0;
			this.ashearY = Math.atan2(this._a * this._b + this._c * this._d,this._a * this._d - this._b * this._c) * spine_MathUtils.radDeg;
			return;
		}
		var pa = parent._a;
		var pb = parent._b;
		var pc = parent._c;
		var pd = parent._d;
		var pid = 1 / (pa * pd - pb * pc);
		var dx = this._worldX - parent._worldX;
		var dy = this._worldY - parent._worldY;
		this.ax = dx * pd * pid - dy * pb * pid;
		this.ay = dy * pa * pid - dx * pc * pid;
		var ia = pid * pd;
		var id = pid * pa;
		var ib = pid * pb;
		var ic = pid * pc;
		var ra = ia * this._a - ib * this._c;
		var rb = ia * this._b - ib * this._d;
		var rc = id * this._c - ic * this._a;
		var rd = id * this._d - ic * this._b;
		this.ashearX = 0;
		this.ascaleX = Math.sqrt(ra * ra + rc * rc);
		if(this.scaleX > 0.0001) {
			var det = ra * rd - rb * rc;
			this.ascaleY = det / this.ascaleX;
			this.ashearY = Math.atan2(ra * rb + rc * rd,det) * spine_MathUtils.radDeg;
			this.arotation = Math.atan2(rc,ra) * spine_MathUtils.radDeg;
		} else {
			this.ascaleX = 0;
			this.ascaleY = Math.sqrt(rb * rb + rd * rd);
			this.ashearY = 0;
			this.arotation = 90 - Math.atan2(rd,rb) * spine_MathUtils.radDeg;
		}
	}
	,worldToLocal: function(world) {
		var a = this._a;
		var b = this._b;
		var c = this._c;
		var d = this._d;
		var invDet = 1 / (a * d - b * c);
		var x = world[0] - this._worldX;
		var y = world[1] - this._worldY;
		world[0] = x * d * invDet - y * b * invDet;
		world[1] = y * a * invDet - x * c * invDet;
	}
	,localToWorld: function(local) {
		var localX = local[0];
		var localY = local[1];
		local[0] = localX * this._a + localY * this._b + this._worldX;
		local[1] = localX * this._c + localY * this._d + this._worldY;
	}
	,toString: function() {
		return this._data._name;
	}
	,get_data: function() {
		return this._data;
	}
	,get_skeleton: function() {
		return this._skeleton;
	}
	,get_parent: function() {
		return this._parent;
	}
	,get_children: function() {
		return this._children;
	}
	,get_a: function() {
		return this._a;
	}
	,get_b: function() {
		return this._b;
	}
	,get_c: function() {
		return this._c;
	}
	,get_d: function() {
		return this._d;
	}
	,get_worldX: function() {
		return this._worldX;
	}
	,get_worldY: function() {
		return this._worldY;
	}
	,get_worldRotationX: function() {
		return Math.atan2(this._c,this._a) * spine_MathUtils.radDeg;
	}
	,get_worldRotationY: function() {
		return Math.atan2(this._d,this._b) * spine_MathUtils.radDeg;
	}
	,get_worldScaleX: function() {
		return Math.sqrt(this._a * this._a + this._c * this._c);
	}
	,get_worldScaleY: function() {
		return Math.sqrt(this._b * this._b + this._d * this._d);
	}
	,__class__: spine_Bone
	,__properties__: {get_worldScaleY:"get_worldScaleY",get_worldScaleX:"get_worldScaleX",get_worldRotationY:"get_worldRotationY",get_worldRotationX:"get_worldRotationX",get_worldY:"get_worldY",get_worldX:"get_worldX",get_d:"get_d",get_c:"get_c",get_b:"get_b",get_a:"get_a",get_children:"get_children",get_parent:"get_parent",get_skeleton:"get_skeleton",get_data:"get_data"}
});
var spine_BoneData = function(index,name,parent) {
	this.transformMode = 0;
	this.scaleY = 1.0;
	this.scaleX = 1.0;
	if(index < 0) {
		throw haxe_Exception.thrown("index must be >= 0");
	}
	if(name == null) {
		throw haxe_Exception.thrown("name cannot be null.");
	}
	this._index = index;
	this._name = name;
	this._parent = parent;
};
spine_BoneData.__name__ = true;
spine_BoneData.prototype = {
	toString: function() {
		return this._name;
	}
	,get_index: function() {
		return this._index;
	}
	,get_name: function() {
		return this._name;
	}
	,get_parent: function() {
		return this._parent;
	}
	,__class__: spine_BoneData
	,__properties__: {get_parent:"get_parent",get_name:"get_name",get_index:"get_index"}
};
var spine_Constraint = function() {
	spine_Updatable.call(this);
};
spine_Constraint.__name__ = true;
spine_Constraint.__super__ = spine_Updatable;
spine_Constraint.prototype = $extend(spine_Updatable.prototype,{
	getOrder: function() {
		return 0.0;
	}
	,__class__: spine_Constraint
});
var spine_Event = function(time,data) {
	if(data == null) {
		throw haxe_Exception.thrown("data cannot be null.");
	}
	this.time = time;
	this._data = data;
};
spine_Event.__name__ = true;
spine_Event.prototype = {
	toString: function() {
		return this._data._name;
	}
	,get_data: function() {
		return this._data;
	}
	,__class__: spine_Event
	,__properties__: {get_data:"get_data"}
};
var spine_EventData = function(name) {
	if(name == null) {
		throw haxe_Exception.thrown("name cannot be null.");
	}
	this._name = name;
};
spine_EventData.__name__ = true;
spine_EventData.prototype = {
	toString: function() {
		return this._name;
	}
	,get_name: function() {
		return this._name;
	}
	,__class__: spine_EventData
	,__properties__: {get_name:"get_name"}
};
var spine_IkConstraint = function(data,skeleton) {
	spine_Constraint.call(this);
	if(data == null) {
		throw haxe_Exception.thrown("data cannot be null.");
	}
	var tmp = skeleton == null;
	this._data = data;
	this.mix = data.mix;
	this.bendDirection = data.bendDirection;
	this.bones = [];
	var _g = 0;
	var _g1 = data.bones;
	while(_g < _g1.length) {
		var boneData = _g1[_g];
		++_g;
		this.bones[this.bones.length] = skeleton.findBone(boneData._name);
	}
	this.target = skeleton.findBone(data.target._name);
};
spine_IkConstraint.__name__ = true;
spine_IkConstraint.apply1 = function(bone,targetX,targetY,alpha) {
	if(!bone.appliedValid) {
		bone.updateAppliedTransform();
	}
	var p = bone._parent;
	var id = 1 / (p._a * p._d - p._b * p._c);
	var x = targetX - p._worldX;
	var y = targetY - p._worldY;
	var tx = (x * p._d - y * p._b) * id - bone.ax;
	var ty = (y * p._a - x * p._c) * id - bone.ay;
	var rotationIK = Math.atan2(ty,tx) * spine_MathUtils.radDeg - bone.ashearX - bone.arotation;
	if(bone.ascaleX < 0) {
		rotationIK += 180;
	}
	if(rotationIK > 180) {
		rotationIK -= 360;
	} else if(rotationIK < -180) {
		rotationIK += 360;
	}
	bone.updateWorldTransformWith(bone.ax,bone.ay,bone.arotation + rotationIK * alpha,bone.ascaleX,bone.ascaleY,bone.ashearX,bone.ashearY);
};
spine_IkConstraint.apply2 = function(parent,child,targetX,targetY,bendDir,alpha) {
	if(alpha == 0) {
		child.updateWorldTransform();
		return;
	}
	if(!parent.appliedValid) {
		parent.updateAppliedTransform();
	}
	if(!child.appliedValid) {
		child.updateAppliedTransform();
	}
	var px = parent.ax;
	var py = parent.ay;
	var psx = parent.ascaleX;
	var psy = parent.ascaleY;
	var csx = child.ascaleX;
	var os1;
	var os2;
	var s2;
	if(psx < 0) {
		psx = -psx;
		os1 = 180;
		s2 = -1;
	} else {
		os1 = 0;
		s2 = 1;
	}
	if(psy < 0) {
		psy = -psy;
		s2 = -s2;
	}
	if(csx < 0) {
		csx = -csx;
		os2 = 180;
	} else {
		os2 = 0;
	}
	var cx = child.ax;
	var cy;
	var cwx;
	var cwy;
	var a = parent._a;
	var b = parent._b;
	var c = parent._c;
	var d = parent._d;
	var u = Math.abs(psx - psy) <= 0.0001;
	if(!u) {
		cy = 0;
		cwx = a * cx + parent._worldX;
		cwy = c * cx + parent._worldY;
	} else {
		cy = child.ay;
		cwx = a * cx + b * cy + parent._worldX;
		cwy = c * cx + d * cy + parent._worldY;
	}
	var pp = parent._parent;
	a = pp._a;
	b = pp._b;
	c = pp._c;
	d = pp._d;
	var id = 1 / (a * d - b * c);
	var x = targetX - pp._worldX;
	var y = targetY - pp._worldY;
	var tx = (x * d - y * b) * id - px;
	var ty = (y * a - x * c) * id - py;
	x = cwx - pp._worldX;
	y = cwy - pp._worldY;
	var dx = (x * d - y * b) * id - px;
	var dy = (y * a - x * c) * id - py;
	var l1 = Math.sqrt(dx * dx + dy * dy);
	var l2 = child._data.length * csx;
	var a1 = 0.0;
	var a2 = 0.0;
	var breaker = false;
	if(u) {
		l2 *= psx;
		var cos = (tx * tx + ty * ty - l1 * l1 - l2 * l2) / (2 * l1 * l2);
		if(cos < -1) {
			cos = -1;
		} else if(cos > 1) {
			cos = 1;
		}
		a2 = Math.acos(cos) * bendDir;
		a = l1 + l2 * cos;
		b = l2 * Math.sin(a2);
		a1 = Math.atan2(ty * a - tx * b,tx * a + ty * b);
	} else {
		a = psx * l2;
		b = psy * l2;
		var aa = a * a;
		var bb = b * b;
		var dd = tx * tx + ty * ty;
		var ta = Math.atan2(ty,tx);
		c = bb * l1 * l1 + aa * dd - aa * bb;
		var c1 = -2 * bb * l1;
		var c2 = bb - aa;
		d = c1 * c1 - 4 * c2 * c;
		if(d >= 0) {
			var q = Math.sqrt(d);
			if(c1 < 0) {
				q = -q;
			}
			q = -(c1 + q) / 2;
			var r0 = q / c2;
			var r1 = c / q;
			var r = Math.abs(r0) < Math.abs(r1) ? r0 : r1;
			if(r * r <= dd) {
				y = Math.sqrt(dd - r * r) * bendDir;
				a1 = ta - Math.atan2(y,r);
				a2 = Math.atan2(y / psy,(r - l1) / psx);
				breaker = true;
			}
		}
		if(!breaker) {
			var minAngle = 0;
			var minDist = Infinity;
			var minX = 0;
			var minY = 0;
			var maxAngle = 0;
			var maxDist = 0;
			var maxX = 0;
			var maxY = 0;
			x = l1 + a;
			d = x * x;
			if(d > maxDist) {
				maxAngle = 0;
				maxDist = d;
				maxX = x;
			}
			x = l1 - a;
			d = x * x;
			if(d < minDist) {
				minAngle = Math.PI;
				minDist = d;
				minX = x;
			}
			var angle = Math.acos(-a * l1 / (aa - bb));
			x = a * Math.cos(angle) + l1;
			y = b * Math.sin(angle);
			d = x * x + y * y;
			if(d < minDist) {
				minAngle = angle;
				minDist = d;
				minX = x;
				minY = y;
			}
			if(d > maxDist) {
				maxAngle = angle;
				maxDist = d;
				maxX = x;
				maxY = y;
			}
			if(dd <= (minDist + maxDist) / 2) {
				a1 = ta - Math.atan2(minY * bendDir,minX);
				a2 = minAngle * bendDir;
			} else {
				a1 = ta - Math.atan2(maxY * bendDir,maxX);
				a2 = maxAngle * bendDir;
			}
		}
	}
	var os = Math.atan2(cy,cx) * s2;
	var rotation = parent.arotation;
	a1 = (a1 - os) * spine_MathUtils.radDeg + os1 - rotation;
	if(a1 > 180) {
		a1 -= 360;
	} else if(a1 < -180) {
		a1 += 360;
	}
	parent.updateWorldTransformWith(px,py,rotation + a1 * alpha,parent.ascaleX,parent.ascaleY,0,0);
	rotation = child.arotation;
	a2 = ((a2 + os) * spine_MathUtils.radDeg - child.ashearX) * s2 + os2 - rotation;
	if(a2 > 180) {
		a2 -= 360;
	} else if(a2 < -180) {
		a2 += 360;
	}
	child.updateWorldTransformWith(cx,cy,rotation + a2 * alpha,child.ascaleX,child.ascaleY,child.ashearX,child.ashearY);
};
spine_IkConstraint.__super__ = spine_Constraint;
spine_IkConstraint.prototype = $extend(spine_Constraint.prototype,{
	apply: function() {
		this.update();
	}
	,update: function() {
		switch(this.bones.length) {
		case 1:
			spine_IkConstraint.apply1(this.bones[0],this.target._worldX,this.target._worldY,this.mix);
			break;
		case 2:
			spine_IkConstraint.apply2(this.bones[0],this.bones[1],this.target._worldX,this.target._worldY,this.bendDirection,this.mix);
			break;
		}
	}
	,getOrder: function() {
		return this._data.order;
	}
	,toString: function() {
		return this._data._name;
	}
	,get_data: function() {
		return this._data;
	}
	,__class__: spine_IkConstraint
	,__properties__: {get_data:"get_data"}
});
var spine_IkConstraintData = function(name) {
	this.mix = 1;
	this.bendDirection = 1;
	this.bones = [];
	var tmp = name == null;
	this._name = name;
};
spine_IkConstraintData.__name__ = true;
spine_IkConstraintData.prototype = {
	toString: function() {
		return this._name;
	}
	,get_name: function() {
		return this._name;
	}
	,__class__: spine_IkConstraintData
	,__properties__: {get_name:"get_name"}
};
var spine_MathUtils = function() { };
spine_MathUtils.__name__ = true;
spine_MathUtils.cosDeg = function(degrees) {
	return Math.cos(degrees * spine_MathUtils.degRad);
};
spine_MathUtils.sinDeg = function(degrees) {
	return Math.sin(degrees * spine_MathUtils.degRad);
};
spine_MathUtils.clamp = function(value,min,max) {
	if(value < min) {
		return min;
	} else if(value > max) {
		return max;
	} else {
		return value;
	}
};
spine_MathUtils.maxInt = function() {
	return Math.floor(UInt.toFloat(js_Boot.__cast(-1 , Int)) / UInt.toFloat(2));
};
spine_MathUtils.signum = function(value) {
	if(value > 0) {
		return 1;
	} else if(value < 0) {
		return -1;
	} else {
		return 0;
	}
};
var spine_Maybe = {};
spine_Maybe.exists = function(this1) {
	return this1 != null;
};
spine_Maybe.sure = function(this1) {
	if(this1 != null) {
		return this1;
	} else {
		throw haxe_Exception.thrown("No value");
	}
};
spine_Maybe.or = function(this1,def) {
	if(this1 != null) {
		return this1;
	} else {
		return def;
	}
};
spine_Maybe.may = function(this1,fn) {
	if(this1 != null) {
		fn(this1);
	}
};
spine_Maybe.map = function(this1,fn) {
	if(this1 != null) {
		return fn(this1);
	} else {
		return null;
	}
};
spine_Maybe.mapDefault = function(this1,fn,def) {
	if(this1 != null) {
		return fn(this1);
	} else {
		return def;
	}
};
var spine_PathConstraint = function(data,skeleton) {
	spine_Constraint.call(this);
	if(data == null) {
		throw haxe_Exception.thrown("data cannot be null.");
	}
	if(skeleton == null) {
		throw haxe_Exception.thrown("skeleton cannot be null.");
	}
	this._data = data;
	this._bones = [];
	var _g = 0;
	var _g1 = data.get_bones();
	while(_g < _g1.length) {
		var boneData = _g1[_g];
		++_g;
		this._bones.push(skeleton.findBone(boneData._name));
	}
	this.target = skeleton.findSlot(data.target._name);
	this.position = data.position;
	this.spacing = data.spacing;
	this.rotateMix = data.rotateMix;
	this.translateMix = data.translateMix;
	var this1 = new Array(10);
	var v = this1;
	var _g = 0;
	var _g1 = 10;
	while(_g < _g1) {
		var i = _g++;
		v[i] = 0;
	}
	this._segments = v;
};
spine_PathConstraint.__name__ = true;
spine_PathConstraint.__super__ = spine_Constraint;
spine_PathConstraint.prototype = $extend(spine_Constraint.prototype,{
	apply: function() {
		this.update();
	}
	,update: function() {
		var attachment = this.target._attachment;
		if(attachment == null) {
			return;
		}
		var rotateMix = this.rotateMix;
		var translateMix = this.translateMix;
		var translate = translateMix > 0;
		var rotate = rotateMix > 0;
		if(!translate && !rotate) {
			return;
		}
		var data = this._data;
		var spacingMode = data.spacingMode;
		var lengthSpacing = spacingMode == "length";
		var rotateMode = data.rotateMode;
		var tangents = rotateMode == "tangent";
		var scale = rotateMode == "chainScale";
		var boneCount = this._bones.length;
		var spacesCount = tangents ? boneCount : boneCount + 1;
		var bones = this._bones;
		if(this._spaces == null || this._spaces.length != spacesCount) {
			var this1 = new Array(spacesCount);
			var v = this1;
			var _g = 0;
			var _g1 = spacesCount;
			while(_g < _g1) {
				var i = _g++;
				v[i] = 0;
			}
			this._spaces = v;
		}
		var spaces = this._spaces;
		var lengths = null;
		var spacing = this.spacing;
		if(scale || lengthSpacing) {
			if(scale) {
				if(this._lengths == null || this._lengths.length != boneCount) {
					var this1 = new Array(boneCount);
					var v = this1;
					var _g = 0;
					var _g1 = boneCount;
					while(_g < _g1) {
						var i = _g++;
						v[i] = 0;
					}
					this._lengths = v;
				}
				lengths = this._lengths;
			}
			var i = 0;
			var n = spacesCount - 1;
			while(i < n) {
				var bone = bones[i];
				var length = bone._data.length;
				var x = length * bone._a;
				var y = length * bone._c;
				length = Math.sqrt(x * x + y * y);
				if(scale) {
					lengths[i] = length;
				}
				spaces[++i] = lengthSpacing ? Math.max(0,length + spacing) : spacing;
			}
		} else {
			var _g = 1;
			var _g1 = spacesCount;
			while(_g < _g1) {
				var i = _g++;
				spaces[i] = spacing;
			}
		}
		var positions = this.computeWorldPositions(attachment,spacesCount,tangents,data.positionMode == "percent",spacingMode == "percent");
		var boneX = positions[0];
		var boneY = positions[1];
		var offsetRotation = data.offsetRotation;
		var tip = false;
		if(offsetRotation == 0) {
			tip = rotateMode == "chain";
		} else {
			tip = false;
			var pa = this.target._bone;
			offsetRotation *= pa._a * pa._d - pa._b * pa._c > 0 ? spine_MathUtils.degRad : -spine_MathUtils.degRad;
		}
		var p = 3;
		var i = 0;
		while(i < boneCount) {
			var bone = bones[i];
			bone._worldX += (boneX - bone._worldX) * translateMix;
			bone._worldY += (boneY - bone._worldY) * translateMix;
			var x = positions[p];
			var y = positions[p + 1];
			var dx = x - boneX;
			var dy = y - boneY;
			if(scale) {
				var length = lengths[i];
				if(length != 0) {
					var s = (Math.sqrt(dx * dx + dy * dy) / length - 1) * rotateMix + 1;
					bone._a *= s;
					bone._c *= s;
				}
			}
			boneX = x;
			boneY = y;
			if(rotate) {
				var a = bone._a;
				var b = bone._b;
				var c = bone._c;
				var d = bone._d;
				var r;
				var cos;
				var sin;
				if(tangents) {
					r = positions[p - 1];
				} else if(spaces[i + 1] == 0) {
					r = positions[p + 2];
				} else {
					r = Math.atan2(dy,dx);
				}
				r -= Math.atan2(c,a);
				if(tip) {
					cos = Math.cos(r);
					sin = Math.sin(r);
					var length1 = bone._data.length;
					boneX += (length1 * (cos * a - sin * c) - dx) * rotateMix;
					boneY += (length1 * (sin * a + cos * c) - dy) * rotateMix;
				} else {
					r += offsetRotation;
				}
				if(r > Math.PI) {
					r -= Math.PI * 2;
				} else if(r < -Math.PI) {
					r += Math.PI * 2;
				}
				r *= rotateMix;
				cos = Math.cos(r);
				sin = Math.sin(r);
				bone._a = cos * a - sin * c;
				bone._b = cos * b - sin * d;
				bone._c = sin * a + cos * c;
				bone._d = sin * b + cos * d;
			}
			bone.appliedValid = false;
			bone.updateAppliedTransform();
			++i;
			p += 3;
		}
	}
	,computeWorldPositions: function(path,spacesCount,tangents,percentPosition,percentSpacing) {
		var target = this.target;
		var position = this.position;
		var spaces = this._spaces;
		if(this._positions == null || this._positions.length != spacesCount * 3 + 2) {
			var n = spacesCount * 3 + 2;
			var this1 = new Array(n);
			var v = this1;
			var _g = 0;
			var _g1 = n;
			while(_g < _g1) {
				var i = _g++;
				v[i] = 0;
			}
			this._positions = v;
		}
		var out = this._positions;
		var world;
		var closed = path.closed;
		var verticesLength = path.worldVerticesLength;
		var curveCount = Math.floor(verticesLength / 6);
		var prevCurve = -1;
		if(!path.constantSpeed) {
			var lengths = path.lengths;
			curveCount -= closed ? 1 : 2;
			var pathLength = lengths[curveCount];
			if(percentPosition) {
				position *= pathLength;
			}
			if(percentSpacing) {
				var _g = 0;
				var _g1 = spacesCount;
				while(_g < _g1) {
					var i = _g++;
					spaces[i] *= pathLength;
				}
			}
			if(this._world == null || this._world.length != 8) {
				var this1 = new Array(8);
				var v = this1;
				var _g = 0;
				var _g1 = 8;
				while(_g < _g1) {
					var i = _g++;
					v[i] = 0;
				}
				this._world = v;
			}
			world = this._world;
			var o = 0;
			var curve = 0;
			var i = 0;
			while(i < spacesCount) {
				var space = spaces[i];
				var p = position += space;
				if(closed) {
					p %= pathLength;
					if(p < 0) {
						p += pathLength;
					}
					curve = 0;
				} else if(p < 0) {
					if(prevCurve != -2) {
						prevCurve = -2;
						path.computeWorldVertices2(target,2,4,world,0);
					}
					this.addBeforePosition(p,world,0,out,o);
					++i;
					o += 3;
					continue;
				} else if(p > pathLength) {
					if(prevCurve != -3) {
						prevCurve = -3;
						path.computeWorldVertices2(target,verticesLength - 6,4,world,0);
					}
					this.addAfterPosition(p - pathLength,world,0,out,o);
					++i;
					o += 3;
					continue;
				}
				while(true) {
					var length = lengths[curve];
					if(p > length) {
						++curve;
						continue;
					}
					if(curve == 0) {
						p /= length;
					} else {
						var prev = lengths[curve - 1];
						p = (p - prev) / (length - prev);
					}
					break;
				}
				if(curve != prevCurve) {
					prevCurve = curve;
					if(closed && curve == curveCount) {
						path.computeWorldVertices2(target,verticesLength - 4,4,world,0);
						path.computeWorldVertices2(target,0,4,world,4);
					} else {
						path.computeWorldVertices2(target,curve * 6 + 2,8,world,0);
					}
				}
				this.addCurvePosition(p,world[0],world[1],world[2],world[3],world[4],world[5],world[6],world[7],out,o,tangents || i > 0 && space == 0);
				++i;
				o += 3;
			}
			return out;
		}
		if(closed) {
			verticesLength += 2;
			if(this._world == null || this._world.length != verticesLength) {
				var this1 = new Array(verticesLength);
				var v = this1;
				var _g = 0;
				var _g1 = verticesLength;
				while(_g < _g1) {
					var i = _g++;
					v[i] = 0;
				}
				this._world = v;
			}
			world = this._world;
			path.computeWorldVertices2(target,2,verticesLength - 4,world,0);
			path.computeWorldVertices2(target,0,2,world,verticesLength - 4);
			world[verticesLength - 2] = world[0];
			world[verticesLength - 1] = world[1];
		} else {
			--curveCount;
			verticesLength -= 4;
			if(this._world == null || this._world.length != verticesLength) {
				var this1 = new Array(verticesLength);
				var v = this1;
				var _g = 0;
				var _g1 = verticesLength;
				while(_g < _g1) {
					var i = _g++;
					v[i] = 0;
				}
				this._world = v;
			}
			world = this._world;
			path.computeWorldVertices2(target,2,verticesLength,world,0);
		}
		if(this._curves == null || this._curves.length != curveCount) {
			var this1 = new Array(curveCount);
			var v = this1;
			var _g = 0;
			var _g1 = curveCount;
			while(_g < _g1) {
				var i = _g++;
				v[i] = 0;
			}
			this._curves = v;
		}
		var curves = this._curves;
		var pathLength = 0.0;
		var x1 = world[0];
		var y1 = world[1];
		var cx1 = 0;
		var cy1 = 0;
		var cx2 = 0;
		var cy2 = 0;
		var x2 = 0;
		var y2 = 0;
		var tmpx;
		var tmpy;
		var dddfx;
		var dddfy;
		var ddfx;
		var ddfy;
		var dfx;
		var dfy;
		var w = 2;
		var i = 0;
		while(i < curveCount) {
			cx1 = world[w];
			cy1 = world[w + 1];
			cx2 = world[w + 2];
			cy2 = world[w + 3];
			x2 = world[w + 4];
			y2 = world[w + 5];
			tmpx = (x1 - cx1 * 2 + cx2) * 0.1875;
			tmpy = (y1 - cy1 * 2 + cy2) * 0.1875;
			dddfx = ((cx1 - cx2) * 3 - x1 + x2) * 0.09375;
			dddfy = ((cy1 - cy2) * 3 - y1 + y2) * 0.09375;
			ddfx = tmpx * 2 + dddfx;
			ddfy = tmpy * 2 + dddfy;
			dfx = (cx1 - x1) * 0.75 + tmpx + dddfx * 0.16666667;
			dfy = (cy1 - y1) * 0.75 + tmpy + dddfy * 0.16666667;
			pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
			dfx += ddfx;
			dfy += ddfy;
			ddfx += dddfx;
			ddfy += dddfy;
			pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
			dfx += ddfx;
			dfy += ddfy;
			pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
			dfx += ddfx + dddfx;
			dfy += ddfy + dddfy;
			pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
			curves[i] = pathLength;
			x1 = x2;
			y1 = y2;
			++i;
			w += 6;
		}
		if(percentPosition) {
			position *= pathLength;
		}
		if(percentSpacing) {
			var _g = 0;
			var _g1 = spacesCount;
			while(_g < _g1) {
				var i1 = _g++;
				spaces[i1] *= pathLength;
			}
		}
		var segments = this._segments;
		var curveLength = 0;
		i = 0;
		var o = 0;
		var curve = 0;
		var segment = 0;
		while(i < spacesCount) {
			var space = spaces[i];
			var p = position += space;
			if(closed) {
				p %= pathLength;
				if(p < 0) {
					p += pathLength;
				}
				curve = 0;
			} else if(p < 0) {
				this.addBeforePosition(p,world,0,out,o);
				++i;
				o += 3;
				continue;
			} else if(p > pathLength) {
				this.addAfterPosition(p - pathLength,world,verticesLength - 4,out,o);
				++i;
				o += 3;
				continue;
			}
			while(true) {
				var length = curves[curve];
				if(p > length) {
					++curve;
					continue;
				}
				if(curve == 0) {
					p /= length;
				} else {
					var prev = curves[curve - 1];
					p = (p - prev) / (length - prev);
				}
				break;
			}
			if(curve != prevCurve) {
				prevCurve = curve;
				var ii = curve * 6;
				x1 = world[ii];
				y1 = world[ii + 1];
				cx1 = world[ii + 2];
				cy1 = world[ii + 3];
				cx2 = world[ii + 4];
				cy2 = world[ii + 5];
				x2 = world[ii + 6];
				y2 = world[ii + 7];
				tmpx = (x1 - cx1 * 2 + cx2) * 0.03;
				tmpy = (y1 - cy1 * 2 + cy2) * 0.03;
				dddfx = ((cx1 - cx2) * 3 - x1 + x2) * 0.006;
				dddfy = ((cy1 - cy2) * 3 - y1 + y2) * 0.006;
				ddfx = tmpx * 2 + dddfx;
				ddfy = tmpy * 2 + dddfy;
				dfx = (cx1 - x1) * 0.3 + tmpx + dddfx * 0.16666667;
				dfy = (cy1 - y1) * 0.3 + tmpy + dddfy * 0.16666667;
				curveLength = Math.sqrt(dfx * dfx + dfy * dfy);
				segments[0] = curveLength;
				dfx += ddfx;
				dfy += ddfy;
				ddfx += dddfx;
				ddfy += dddfy;
				curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
				segments[1] = curveLength;
				dfx += ddfx;
				dfy += ddfy;
				ddfx += dddfx;
				ddfy += dddfy;
				curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
				segments[2] = curveLength;
				dfx += ddfx;
				dfy += ddfy;
				ddfx += dddfx;
				ddfy += dddfy;
				curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
				segments[3] = curveLength;
				dfx += ddfx;
				dfy += ddfy;
				ddfx += dddfx;
				ddfy += dddfy;
				curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
				segments[4] = curveLength;
				dfx += ddfx;
				dfy += ddfy;
				ddfx += dddfx;
				ddfy += dddfy;
				curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
				segments[5] = curveLength;
				dfx += ddfx;
				dfy += ddfy;
				ddfx += dddfx;
				ddfy += dddfy;
				curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
				segments[6] = curveLength;
				dfx += ddfx;
				dfy += ddfy;
				ddfx += dddfx;
				ddfy += dddfy;
				curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
				segments[7] = curveLength;
				dfx += ddfx;
				dfy += ddfy;
				curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
				segments[8] = curveLength;
				dfx += ddfx + dddfx;
				dfy += ddfy + dddfy;
				curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
				segments[9] = curveLength;
				segment = 0;
			}
			p *= curveLength;
			while(true) {
				var length1 = segments[segment];
				if(p > length1) {
					++segment;
					continue;
				}
				if(segment == 0) {
					p /= length1;
				} else {
					var prev1 = segments[segment - 1];
					p = segment + (p - prev1) / (length1 - prev1);
				}
				break;
			}
			this.addCurvePosition(p * 0.1,x1,y1,cx1,cy1,cx2,cy2,x2,y2,out,o,tangents || i > 0 && space == 0);
			++i;
			o += 3;
		}
		return out;
	}
	,addBeforePosition: function(p,temp,i,out,o) {
		var x1 = temp[i];
		var y1 = temp[i + 1];
		var dx = temp[i + 2] - x1;
		var dy = temp[i + 3] - y1;
		var r = Math.atan2(dy,dx);
		out[o] = x1 + p * Math.cos(r);
		out[o + 1] = y1 + p * Math.sin(r);
		out[o + 2] = r;
	}
	,addAfterPosition: function(p,temp,i,out,o) {
		var x1 = temp[i + 2];
		var y1 = temp[i + 3];
		var dx = x1 - temp[i];
		var dy = y1 - temp[i + 1];
		var r = Math.atan2(dy,dx);
		out[o] = x1 + p * Math.cos(r);
		out[o + 1] = y1 + p * Math.sin(r);
		out[o + 2] = r;
	}
	,addCurvePosition: function(p,x1,y1,cx1,cy1,cx2,cy2,x2,y2,out,o,tangents) {
		if(p == 0 || isNaN(p)) {
			p = 0.0001;
		}
		var tt = p * p;
		var ttt = tt * p;
		var u = 1 - p;
		var uu = u * u;
		var uuu = uu * u;
		var ut = u * p;
		var ut3 = ut * 3;
		var uut3 = u * ut3;
		var utt3 = ut3 * p;
		var x = x1 * uuu + cx1 * uut3 + cx2 * utt3 + x2 * ttt;
		var y = y1 * uuu + cy1 * uut3 + cy2 * utt3 + y2 * ttt;
		out[o] = x;
		out[o + 1] = y;
		if(tangents) {
			out[o + 2] = Math.atan2(y - (y1 * uu + cy1 * ut * 2 + cy2 * tt),x - (x1 * uu + cx1 * ut * 2 + cx2 * tt));
		}
	}
	,getOrder: function() {
		return this._data.order;
	}
	,toString: function() {
		return this._data.get_name();
	}
	,get_bones: function() {
		return this._bones;
	}
	,get_data: function() {
		return this._data;
	}
	,__class__: spine_PathConstraint
	,__properties__: {get_bones:"get_bones",get_data:"get_data"}
});
var spine_PathConstraintData = function(name) {
	this._bones = [];
	if(name == null) {
		throw haxe_Exception.thrown("name cannot be null.");
	}
	this._name = name;
};
spine_PathConstraintData.__name__ = true;
spine_PathConstraintData.prototype = {
	toString: function() {
		return this.get_name();
	}
	,get_name: function() {
		return this._name;
	}
	,get_bones: function() {
		return this._bones;
	}
	,__class__: spine_PathConstraintData
	,__properties__: {get_bones:"get_bones",get_name:"get_name"}
};
var spine_Skeleton = function(data) {
	this._updateCacheReset = [];
	this._updateCache = [];
	this.y = 0;
	this.x = 0;
	this.time = 0;
	this.a = 1;
	this.b = 1;
	this.g = 1;
	this.r = 1;
	if(data == null) {
		throw haxe_Exception.thrown("data cannot be null.");
	}
	this._data = data;
	this.bones = [];
	var _g = 0;
	var _g1 = data.bones;
	while(_g < _g1.length) {
		var boneData = _g1[_g];
		++_g;
		var bone;
		if(boneData._parent == null) {
			bone = new spine_Bone(boneData,this,null);
		} else {
			var parent = this.bones[boneData._parent._index];
			bone = new spine_Bone(boneData,this,parent);
			parent._children.push(bone);
		}
		this.bones.push(bone);
	}
	this.slots = [];
	this.drawOrder = [];
	var _g = 0;
	var _g1 = data.slots;
	while(_g < _g1.length) {
		var slotData = _g1[_g];
		++_g;
		var bone = this.bones[slotData._boneData._index];
		var slot = new spine_Slot(slotData,bone);
		this.slots.push(slot);
		this.drawOrder[this.drawOrder.length] = slot;
	}
	this.ikConstraints = [];
	var _g = 0;
	var _g1 = data.ikConstraints;
	while(_g < _g1.length) {
		var ikConstraintData = _g1[_g];
		++_g;
		this.ikConstraints.push(new spine_IkConstraint(ikConstraintData,this));
	}
	this.transformConstraints = [];
	var _g = 0;
	var _g1 = data.transformConstraints;
	while(_g < _g1.length) {
		var transformConstraintData = _g1[_g];
		++_g;
		this.transformConstraints.push(new spine_TransformConstraint(transformConstraintData,this));
	}
	this.pathConstraints = [];
	var _g = 0;
	var _g1 = data.pathConstraints;
	while(_g < _g1.length) {
		var pathConstraintData = _g1[_g];
		++_g;
		this.pathConstraints.push(new spine_PathConstraint(pathConstraintData,this));
	}
	this.updateCache();
};
spine_Skeleton.__name__ = true;
spine_Skeleton.prototype = {
	updateCache: function() {
		this._updateCache = [];
		var updateCache = this._updateCache;
		var _g = 0;
		var _g1 = this.bones.length;
		while(_g < _g1) {
			var i = _g++;
			this.bones[i]._sorted = false;
		}
		var ikCount = this.ikConstraints.length;
		var transformCount = this.transformConstraints.length;
		var pathCount = this.pathConstraints.length;
		var constraintCount = ikCount + transformCount + pathCount;
		var _g = 0;
		var _g1 = constraintCount;
		while(_g < _g1) {
			var i = _g++;
			var outerContinue = false;
			var _g2 = 0;
			var _g3 = ikCount;
			while(_g2 < _g3) {
				var ii = _g2++;
				var ikConstraint = this.ikConstraints[ii];
				if(ikConstraint._data.order == i) {
					this.sortIkConstraint(ikConstraint);
					outerContinue = true;
					break;
				}
			}
			if(outerContinue) {
				continue;
			}
			var _g4 = 0;
			var _g5 = transformCount;
			while(_g4 < _g5) {
				var ii1 = _g4++;
				var transformConstraint = this.transformConstraints[ii1];
				if(transformConstraint._data.order == i) {
					this.sortTransformConstraint(transformConstraint);
					outerContinue = true;
					break;
				}
			}
			if(outerContinue) {
				continue;
			}
			var _g6 = 0;
			var _g7 = pathCount;
			while(_g6 < _g7) {
				var ii2 = _g6++;
				var pathConstraint = this.pathConstraints[ii2];
				if(pathConstraint._data.order == i) {
					this.sortPathConstraint(pathConstraint);
					outerContinue = true;
					break;
				}
			}
			if(outerContinue) {
				continue;
			}
		}
		var boneCount = this.bones.length;
		var _g = 0;
		var _g1 = boneCount;
		while(_g < _g1) {
			var i = _g++;
			this.sortBone(this.bones[i]);
		}
	}
	,sortIkConstraint: function(constraint) {
		var target = constraint.target;
		this.sortBone(target);
		var constrained = constraint.bones;
		var parent = constrained[0];
		this.sortBone(parent);
		if(constrained.length > 1) {
			var child = constrained[constrained.length - 1];
			if(this._updateCache.indexOf(child) <= -1) {
				this._updateCacheReset.push(child);
			}
		}
		this._updateCache.push(constraint);
		this.sortReset(parent._children);
		constrained[constrained.length - 1]._sorted = true;
	}
	,sortPathConstraint: function(constraint) {
		var slot = constraint.target;
		var slotIndex = slot._data._index;
		var slotBone = slot._bone;
		if(this._skin != null) {
			this.sortPathConstraintAttachment(this._skin,slotIndex,slotBone);
		}
		if(this._data.defaultSkin != null && this._data.defaultSkin != this._skin) {
			this.sortPathConstraintAttachment(this._data.defaultSkin,slotIndex,slotBone);
		}
		var nn = this._data.skins.length;
		var _g = 0;
		var _g1 = nn;
		while(_g < _g1) {
			var ii = _g++;
			this.sortPathConstraintAttachment(this._data.skins[ii],slotIndex,slotBone);
		}
		var attachment = slot._attachment;
		if(attachment != null && attachment.type == 4) {
			this.sortPathConstraintAttachment2(attachment,slotBone);
		}
		var constrained = constraint._bones;
		var boneCount = constrained.length;
		var _g = 0;
		var _g1 = boneCount;
		while(_g < _g1) {
			var ii = _g++;
			this.sortBone(constrained[ii]);
		}
		this._updateCache.push(constraint);
		var _g = 0;
		var _g1 = boneCount;
		while(_g < _g1) {
			var ii = _g++;
			this.sortReset(constrained[ii]._children);
		}
		var _g = 0;
		var _g1 = boneCount;
		while(_g < _g1) {
			var ii = _g++;
			constrained[ii]._sorted = true;
		}
	}
	,sortTransformConstraint: function(constraint) {
		this.sortBone(constraint.target);
		var constrained = constraint._bones;
		var boneCount = constrained.length;
		var _g = 0;
		var _g1 = boneCount;
		while(_g < _g1) {
			var ii = _g++;
			this.sortBone(constrained[ii]);
		}
		this._updateCache.push(constraint);
		var _g = 0;
		var _g1 = boneCount;
		while(_g < _g1) {
			var ii = _g++;
			this.sortReset(constrained[ii]._children);
		}
		var _g = 0;
		var _g1 = boneCount;
		while(_g < _g1) {
			var ii = _g++;
			constrained[ii]._sorted = true;
		}
	}
	,sortPathConstraintAttachment: function(skin,slotIndex,slotBone) {
		var dict = skin._attachments[slotIndex];
		if(dict == null) {
			return;
		}
		var value = haxe_ds_StringMap.valueIterator(dict.h);
		while(value.hasNext()) {
			var value1 = value.next();
			this.sortPathConstraintAttachment2(value1,slotBone);
		}
	}
	,sortPathConstraintAttachment2: function(attachment,slotBone) {
		var pathAttachment = attachment.type == 4 ? attachment : null;
		if(pathAttachment == null) {
			return;
		}
		var pathBones = pathAttachment.bones;
		if(pathBones == null) {
			this.sortBone(slotBone);
		} else {
			var bones = this.bones;
			var i = 0;
			while(i < pathBones.length) {
				var boneCount = pathBones[i++];
				var n = i + boneCount;
				while(i < n) {
					this.sortBone(bones[pathBones[i]]);
					++i;
				}
			}
		}
	}
	,sortBone: function(bone) {
		if(bone._sorted) {
			return;
		}
		var parent = bone._parent;
		if(parent != null) {
			this.sortBone(parent);
		}
		bone._sorted = true;
		this._updateCache.push(bone);
	}
	,sortReset: function(bones) {
		var _g = 0;
		var _g1 = bones.length;
		while(_g < _g1) {
			var i = _g++;
			var bone = bones[i];
			if(bone._sorted) {
				this.sortReset(bone._children);
			}
			bone._sorted = false;
		}
	}
	,updateWorldTransform: function() {
		var updateCacheReset = this._updateCacheReset;
		var _g = 0;
		while(_g < updateCacheReset.length) {
			var bone = updateCacheReset[_g];
			++_g;
			bone.ax = bone.x;
			bone.ay = bone.y;
			bone.arotation = bone.rotation;
			bone.ascaleX = bone.scaleX;
			bone.ascaleY = bone.scaleY;
			bone.ashearX = bone.shearX;
			bone.ashearY = bone.shearY;
			bone.appliedValid = true;
		}
		var _g = 0;
		var _g1 = this._updateCache;
		while(_g < _g1.length) {
			var updatable = _g1[_g];
			++_g;
			updatable.update();
		}
	}
	,setToSetupPose: function() {
		this.setBonesToSetupPose();
		this.setSlotsToSetupPose();
	}
	,setBonesToSetupPose: function() {
		var _g = 0;
		var _g1 = this.bones;
		while(_g < _g1.length) {
			var bone = _g1[_g];
			++_g;
			bone.setToSetupPose();
		}
		var _g = 0;
		var _g1 = this.ikConstraints;
		while(_g < _g1.length) {
			var ikConstraint = _g1[_g];
			++_g;
			ikConstraint.bendDirection = ikConstraint._data.bendDirection;
			ikConstraint.mix = ikConstraint._data.mix;
		}
		var _g = 0;
		var _g1 = this.transformConstraints;
		while(_g < _g1.length) {
			var transformConstraint = _g1[_g];
			++_g;
			transformConstraint.rotateMix = transformConstraint._data.rotateMix;
			transformConstraint.translateMix = transformConstraint._data.translateMix;
			transformConstraint.scaleMix = transformConstraint._data.scaleMix;
			transformConstraint.shearMix = transformConstraint._data.shearMix;
		}
		var _g = 0;
		var _g1 = this.pathConstraints;
		while(_g < _g1.length) {
			var pathConstraint = _g1[_g];
			++_g;
			pathConstraint.position = pathConstraint._data.position;
			pathConstraint.spacing = pathConstraint._data.spacing;
			pathConstraint.rotateMix = pathConstraint._data.rotateMix;
			pathConstraint.translateMix = pathConstraint._data.translateMix;
		}
	}
	,setSlotsToSetupPose: function() {
		var i = 0;
		var _g = 0;
		var _g1 = this.slots;
		while(_g < _g1.length) {
			var slot = _g1[_g];
			++_g;
			this.drawOrder[i++] = slot;
			slot.setToSetupPose();
		}
	}
	,findBone: function(boneName) {
		if(boneName == null) {
			throw haxe_Exception.thrown("boneName cannot be null.");
		}
		var _g = 0;
		var _g1 = this.bones;
		while(_g < _g1.length) {
			var bone = _g1[_g];
			++_g;
			if(bone._data._name == boneName) {
				return bone;
			}
		}
		return null;
	}
	,findBoneIndex: function(boneName) {
		if(boneName == null) {
			throw haxe_Exception.thrown("boneName cannot be null.");
		}
		var i = 0;
		var _g = 0;
		var _g1 = this.bones;
		while(_g < _g1.length) {
			var bone = _g1[_g];
			++_g;
			if(bone._data._name == boneName) {
				return i;
			}
			++i;
		}
		return -1;
	}
	,findSlot: function(slotName) {
		if(slotName == null) {
			throw haxe_Exception.thrown("slotName cannot be null.");
		}
		var _g = 0;
		var _g1 = this.slots;
		while(_g < _g1.length) {
			var slot = _g1[_g];
			++_g;
			if(slot._data._name == slotName) {
				return slot;
			}
		}
		return null;
	}
	,findSlotIndex: function(slotName) {
		if(slotName == null) {
			throw haxe_Exception.thrown("slotName cannot be null.");
		}
		var i = 0;
		var _g = 0;
		var _g1 = this.slots;
		while(_g < _g1.length) {
			var slot = _g1[_g];
			++_g;
			if(slot._data._name == slotName) {
				return i;
			}
			++i;
		}
		return -1;
	}
	,getAttachmentForSlotName: function(slotName,attachmentName) {
		return this.getAttachmentForSlotIndex(this._data.findSlotIndex(slotName),attachmentName);
	}
	,getAttachmentForSlotIndex: function(slotIndex,attachmentName) {
		if(attachmentName == null) {
			throw haxe_Exception.thrown("attachmentName cannot be null.");
		}
		if(this._skin != null) {
			var attachment = this._skin.getAttachment(slotIndex,attachmentName);
			if(attachment != null) {
				return attachment;
			}
		}
		if(this._data.defaultSkin != null) {
			return this._data.defaultSkin.getAttachment(slotIndex,attachmentName);
		}
		return null;
	}
	,setAttachment: function(slotName,attachmentName) {
		if(slotName == null) {
			throw haxe_Exception.thrown("slotName cannot be null.");
		}
		var i = 0;
		var _g = 0;
		var _g1 = this.slots;
		while(_g < _g1.length) {
			var slot = _g1[_g];
			++_g;
			if(slot._data._name == slotName) {
				var attachment = null;
				if(attachmentName != null) {
					attachment = this.getAttachmentForSlotIndex(i,attachmentName);
					if(attachment == null) {
						throw haxe_Exception.thrown("Attachment not found: " + attachmentName + ", for slot: " + slotName);
					}
				}
				if(slot._attachment != attachment) {
					slot._attachment = attachment;
					slot._attachmentTime = slot._bone._skeleton.time;
					slot.attachmentVerticesLength = 0;
				}
				return;
			}
			++i;
		}
		throw haxe_Exception.thrown("Slot not found: " + slotName);
	}
	,findIkConstraint: function(constraintName) {
		if(constraintName == null) {
			throw haxe_Exception.thrown("constraintName cannot be null.");
		}
		var _g = 0;
		var _g1 = this.ikConstraints;
		while(_g < _g1.length) {
			var ikConstraint = _g1[_g];
			++_g;
			if(ikConstraint._data._name == constraintName) {
				return ikConstraint;
			}
		}
		return null;
	}
	,findTransformConstraint: function(constraintName) {
		if(constraintName == null) {
			throw haxe_Exception.thrown("constraintName cannot be null.");
		}
		var _g = 0;
		var _g1 = this.transformConstraints;
		while(_g < _g1.length) {
			var transformConstraint = _g1[_g];
			++_g;
			if(transformConstraint._data._name == constraintName) {
				return transformConstraint;
			}
		}
		return null;
	}
	,findPathConstraint: function(constraintName) {
		if(constraintName == null) {
			throw haxe_Exception.thrown("constraintName cannot be null.");
		}
		var _g = 0;
		var _g1 = this.pathConstraints;
		while(_g < _g1.length) {
			var pathConstraint = _g1[_g];
			++_g;
			if(pathConstraint._data._name == constraintName) {
				return pathConstraint;
			}
		}
		return null;
	}
	,update: function(delta) {
		this.time += delta;
	}
	,toString: function() {
		return this._data.name;
	}
	,get_data: function() {
		return this._data;
	}
	,get_getUpdateCache: function() {
		return this._updateCache;
	}
	,get_rootBone: function() {
		if(this.bones.length == 0) {
			return null;
		}
		return this.bones[0];
	}
	,get_skin: function() {
		return this._skin;
	}
	,get_skinName: function() {
		if(this._skin == null) {
			return null;
		} else {
			return this._skin._name;
		}
	}
	,set_skin: function(newSkin) {
		if(newSkin != null) {
			if(this._skin != null) {
				newSkin.attachAll(this,this._skin);
			} else {
				var i = 0;
				var _g = 0;
				var _g1 = this.slots;
				while(_g < _g1.length) {
					var slot = _g1[_g];
					++_g;
					var name = slot._data.attachmentName;
					if(name != null) {
						var attachment = newSkin.getAttachment(i,name);
						if(attachment != null) {
							if(slot._attachment != attachment) {
								slot._attachment = attachment;
								slot._attachmentTime = slot._bone._skeleton.time;
								slot.attachmentVerticesLength = 0;
							}
						}
					}
					++i;
				}
			}
		}
		this._skin = newSkin;
		return newSkin;
	}
	,set_skinName: function(skinName) {
		var skin = this._data.findSkin(skinName);
		if(skin == null) {
			throw haxe_Exception.thrown("Skin not found: " + skinName);
		}
		this.set_skin(skin);
		return skinName;
	}
	,__class__: spine_Skeleton
	,__properties__: {set_skinName:"set_skinName",get_skinName:"get_skinName",set_skin:"set_skin",get_skin:"get_skin",get_rootBone:"get_rootBone",get_getUpdateCache:"get_getUpdateCache",get_data:"get_data"}
};
var spine_SkeletonBinary = function(attachmentLoader) {
	this.skipNewFeatures = false;
	this.linkedMeshes = [];
	this.attachmentLoader = attachmentLoader;
	this.scale = 1;
	this.floatBuffer = new haxe_io_Bytes(new ArrayBuffer(4));
	this.buffer = new haxe_io_Bytes(new ArrayBuffer(32));
	this.rgba = new spine_RGBA();
};
spine_SkeletonBinary.__name__ = true;
spine_SkeletonBinary.prototype = {
	readSkeletonDataFromPath: function(path) {
		return null;
	}
	,readSkeletonDataFromBytes: function(bytes,name) {
		var input = new haxe_io_BytesInput(bytes);
		var skeletonData = this.readSkeletonDataFromInput(input);
		skeletonData.name = name;
		return skeletonData;
	}
	,readSkeletonDataFromInput: function(input) {
		var scale = this.scale;
		var skeletonData = new spine_SkeletonData();
		skeletonData.hash = this.ReadString(input);
		if(skeletonData.hash.length == 0) {
			skeletonData.hash = null;
		}
		skeletonData.version = this.ReadString(input);
		if(skeletonData.version.length == 0) {
			skeletonData.version = null;
		}
		this.skipNewFeatures = false;
		if(skeletonData.version != null) {
			if(Std.parseInt(skeletonData.version.charAt(2)) > 5) {
				this.skipNewFeatures = true;
			}
		}
		skeletonData.width = this.ReadFloat(input);
		skeletonData.height = this.ReadFloat(input);
		var nonessential = this.ReadBoolean(input);
		if(nonessential) {
			skeletonData.fps = this.ReadFloat(input);
			skeletonData.imagesPath = this.ReadString(input);
			if(skeletonData.imagesPath.length == 0) {
				skeletonData.imagesPath = null;
			}
		}
		var n = this.ReadVarint(input,true);
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			var name = this.ReadString(input);
			var parent = i == 0 ? null : skeletonData.bones[this.ReadVarint(input,true)];
			var data = new spine_BoneData(i,name,parent);
			data.rotation = this.ReadFloat(input);
			data.x = this.ReadFloat(input) * scale;
			data.y = this.ReadFloat(input) * scale;
			data.scaleX = this.ReadFloat(input);
			data.scaleY = this.ReadFloat(input);
			data.shearX = this.ReadFloat(input);
			data.shearY = this.ReadFloat(input);
			data.length = this.ReadFloat(input) * scale;
			data.transformMode = this.ReadVarint(input,true);
			if(nonessential) {
				this.ReadInt(input);
			}
			skeletonData.bones.push(data);
		}
		n = this.ReadVarint(input,true);
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			var slotName = this.ReadString(input);
			var boneData = skeletonData.bones[this.ReadVarint(input,true)];
			var slotData = new spine_SlotData(i,slotName,boneData);
			var color = this.ReadInt(input);
			slotData.r = color.r / 255;
			slotData.g = color.g / 255;
			slotData.b = color.b / 255;
			slotData.a = color.a / 255;
			if(this.skipNewFeatures) {
				var darkColor = this.ReadInt(input);
			}
			slotData.attachmentName = this.ReadString(input);
			slotData.blendMode = this.ReadVarint(input,true);
			skeletonData.slots.push(slotData);
		}
		n = this.ReadVarint(input,true);
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			var data = new spine_IkConstraintData(this.ReadString(input));
			data.order = this.ReadVarint(input,true);
			var nn = this.ReadVarint(input,true);
			var _g2 = 0;
			var _g3 = nn;
			while(_g2 < _g3) {
				var ii = _g2++;
				data.bones.push(skeletonData.bones[this.ReadVarint(input,true)]);
			}
			data.target = skeletonData.bones[this.ReadVarint(input,true)];
			data.mix = this.ReadFloat(input);
			data.bendDirection = this.ReadSByte(input);
			skeletonData.ikConstraints.push(data);
		}
		n = this.ReadVarint(input,true);
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			var data = new spine_TransformConstraintData(this.ReadString(input));
			data.order = this.ReadVarint(input,true);
			var nn = this.ReadVarint(input,true);
			var _g2 = 0;
			var _g3 = nn;
			while(_g2 < _g3) {
				var ii = _g2++;
				data._bones.push(skeletonData.bones[this.ReadVarint(input,true)]);
			}
			data.target = skeletonData.bones[this.ReadVarint(input,true)];
			if(this.skipNewFeatures) {
				this.ReadBoolean(input);
				this.ReadBoolean(input);
			}
			data.offsetRotation = this.ReadFloat(input);
			data.offsetX = this.ReadFloat(input) * scale;
			data.offsetY = this.ReadFloat(input) * scale;
			data.offsetScaleX = this.ReadFloat(input);
			data.offsetScaleY = this.ReadFloat(input);
			data.offsetShearY = this.ReadFloat(input);
			data.rotateMix = this.ReadFloat(input);
			data.translateMix = this.ReadFloat(input);
			data.scaleMix = this.ReadFloat(input);
			data.shearMix = this.ReadFloat(input);
			skeletonData.transformConstraints.push(data);
		}
		n = this.ReadVarint(input,true);
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			var data = new spine_PathConstraintData(this.ReadString(input));
			data.order = this.ReadVarint(input,true);
			var nn = this.ReadVarint(input,true);
			var _g2 = 0;
			var _g3 = nn;
			while(_g2 < _g3) {
				var ii = _g2++;
				data.get_bones().push(skeletonData.bones[this.ReadVarint(input,true)]);
			}
			data.target = skeletonData.slots[this.ReadVarint(input,true)];
			data.positionMode = this.ReadVarint(input,true) == 0 ? "fixed" : "percent";
			var tmp;
			switch(this.ReadVarint(input,true)) {
			case 0:
				tmp = "length";
				break;
			case 1:
				tmp = "fixed";
				break;
			default:
				tmp = "percent";
			}
			data.spacingMode = tmp;
			var tmp1;
			switch(this.ReadVarint(input,true)) {
			case 0:
				tmp1 = "tangent";
				break;
			case 1:
				tmp1 = "chain";
				break;
			default:
				tmp1 = "chainScale";
			}
			data.rotateMode = tmp1;
			data.offsetRotation = this.ReadFloat(input);
			data.position = this.ReadFloat(input);
			if(data.positionMode == "fixed") {
				data.position *= scale;
			}
			data.spacing = this.ReadFloat(input);
			if(data.spacingMode == "length" || data.spacingMode == "fixed") {
				data.spacing *= scale;
			}
			data.rotateMix = this.ReadFloat(input);
			data.translateMix = this.ReadFloat(input);
			skeletonData.pathConstraints.push(data);
		}
		var defaultSkin = this.ReadSkin(input,"default",nonessential);
		if(defaultSkin != null) {
			skeletonData.defaultSkin = defaultSkin;
			skeletonData.skins.push(defaultSkin);
		}
		n = this.ReadVarint(input,true);
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			skeletonData.skins.push(this.ReadSkin(input,this.ReadString(input),nonessential));
		}
		var _g = 0;
		var _g1 = this.linkedMeshes.length;
		while(_g < _g1) {
			var i = _g++;
			var linkedMesh = this.linkedMeshes[i];
			var skin = linkedMesh.skin == null ? skeletonData.defaultSkin : skeletonData.findSkin(linkedMesh.skin);
			if(skin == null) {
				throw haxe_Exception.thrown("Skin not found: " + linkedMesh.skin);
			}
			var parent = skin.getAttachment(linkedMesh.slotIndex,linkedMesh.parent);
			if(parent == null) {
				throw haxe_Exception.thrown("Parent mesh not found: " + linkedMesh.parent);
			}
			var _this = linkedMesh.mesh;
			var parentMesh = parent;
			_this._parentMesh = parentMesh;
			if(parentMesh != null) {
				_this.bones = parentMesh.bones;
				_this.vertices = parentMesh.vertices;
				_this.worldVerticesLength = parentMesh.worldVerticesLength;
				_this.regionUVs = parentMesh.regionUVs;
				_this.triangles = parentMesh.triangles;
				_this.hullLength = parentMesh.hullLength;
				_this.edges = parentMesh.edges;
				_this.width = parentMesh.width;
				_this.height = parentMesh.height;
			}
			linkedMesh.mesh.updateUVs();
		}
		this.linkedMeshes = [];
		n = this.ReadVarint(input,true);
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			var data = new spine_EventData(this.ReadString(input));
			data.intValue = this.ReadVarint(input,false);
			data.floatValue = this.ReadFloat(input);
			data.stringValue = this.ReadString(input);
			skeletonData.events.push(data);
		}
		n = this.ReadVarint(input,true);
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			this.ReadAnimation(this.ReadString(input),input,skeletonData);
		}
		return skeletonData;
	}
	,ReadSkin: function(input,skinName,nonessential) {
		var slotCount = this.ReadVarint(input,true);
		if(slotCount == 0) {
			return null;
		}
		var skin = new spine_Skin(skinName);
		var _g = 0;
		var _g1 = slotCount;
		while(_g < _g1) {
			var i = _g++;
			var slotIndex = this.ReadVarint(input,true);
			var nn = this.ReadVarint(input,true);
			var _g2 = 0;
			var _g3 = nn;
			while(_g2 < _g3) {
				var ii = _g2++;
				var name = this.ReadString(input);
				var attachment = this.ReadAttachment(input,skin,slotIndex,name,nonessential);
				if(attachment != null) {
					skin.addAttachment(slotIndex,name,attachment);
				}
			}
		}
		return skin;
	}
	,ReadAttachment: function(input,skin,slotIndex,attachmentName,nonessential) {
		var scale = this.scale;
		var name = this.ReadString(input);
		if(name == null) {
			name = attachmentName;
		}
		var type = input.readByte();
		switch(type) {
		case 0:
			var path = this.ReadString(input);
			var rotation = this.ReadFloat(input);
			var x = this.ReadFloat(input);
			var y = this.ReadFloat(input);
			var scaleX = this.ReadFloat(input);
			var scaleY = this.ReadFloat(input);
			var width = this.ReadFloat(input);
			var height = this.ReadFloat(input);
			var color = this.ReadInt(input);
			if(path == null) {
				path = name;
			}
			var region = this.attachmentLoader.newRegionAttachment(skin,name,path);
			if(region == null) {
				return null;
			}
			region.path = path;
			region.x = x * scale;
			region.y = y * scale;
			region.scaleX = scaleX;
			region.scaleY = scaleY;
			region.rotation = rotation;
			region.width = width * scale;
			region.height = height * scale;
			region.r = color.r / 255;
			region.g = color.g / 255;
			region.b = color.b / 255;
			region.a = color.a / 255;
			region.updateOffset();
			return region;
		case 1:
			var vertexCount = this.ReadVarint(input,true);
			var vertices = this.ReadVertices(input,vertexCount);
			if(nonessential) {
				this.ReadInt(input);
			}
			var box = this.attachmentLoader.newBoundingBoxAttachment(skin,name);
			if(box == null) {
				return null;
			}
			box.worldVerticesLength = vertexCount << 1;
			box.vertices = vertices.vertices;
			box.bones = vertices.bones;
			return box;
		case 2:
			var path = this.ReadString(input);
			var color = this.ReadInt(input);
			var vertexCount = this.ReadVarint(input,true);
			var uvs = this.ReadFloatArray(input,vertexCount << 1,1);
			var triangles = this.ReadShortArray(input);
			var vertices = this.ReadVertices(input,vertexCount);
			var hullLength = this.ReadVarint(input,true);
			var edges = null;
			var width = 0;
			var height = 0;
			if(nonessential) {
				edges = this.ReadShortArray(input);
				width = this.ReadFloat(input);
				height = this.ReadFloat(input);
			}
			if(path == null) {
				path = name;
			}
			var mesh = this.attachmentLoader.newMeshAttachment(skin,name,path);
			if(mesh == null) {
				return null;
			}
			mesh.path = path;
			mesh.r = color.r / 255;
			mesh.g = color.g / 255;
			mesh.b = color.b / 255;
			mesh.a = color.a / 255;
			mesh.bones = vertices.bones;
			mesh.vertices = vertices.vertices;
			mesh.worldVerticesLength = vertexCount << 1;
			mesh.triangles = triangles;
			mesh.regionUVs = uvs;
			mesh.updateUVs();
			mesh.hullLength = hullLength << 1;
			if(nonessential) {
				mesh.edges = edges;
				mesh.width = width * scale;
				mesh.height = height * scale;
			}
			return mesh;
		case 3:
			var path = this.ReadString(input);
			var color = this.ReadInt(input);
			var skinName = this.ReadString(input);
			var parent = this.ReadString(input);
			var inheritDeform = this.ReadBoolean(input);
			var width = 0;
			var height = 0;
			if(nonessential) {
				width = this.ReadFloat(input);
				height = this.ReadFloat(input);
			}
			if(path == null) {
				path = name;
			}
			var mesh = this.attachmentLoader.newMeshAttachment(skin,name,path);
			if(mesh == null) {
				return null;
			}
			mesh.path = path;
			mesh.r = color.r / 255;
			mesh.g = color.g / 255;
			mesh.b = color.b / 255;
			mesh.a = color.a / 255;
			mesh.inheritDeform = inheritDeform;
			if(nonessential) {
				mesh.width = width * scale;
				mesh.height = height * scale;
			}
			this.linkedMeshes.push(new spine_LinkedMesh(mesh,skinName,slotIndex,parent));
			return mesh;
		case 4:
			var closed = this.ReadBoolean(input);
			var constantSpeed = this.ReadBoolean(input);
			var vertexCount = this.ReadVarint(input,true);
			var vertices = this.ReadVertices(input,vertexCount);
			var n = vertexCount / 3 | 0;
			var this1 = new Array(n);
			var v = this1;
			var _g = 0;
			var _g1 = n;
			while(_g < _g1) {
				var i = _g++;
				v[i] = 0;
			}
			var lengths = v;
			var _g = 0;
			var _g1 = n;
			while(_g < _g1) {
				var i = _g++;
				lengths[i] = this.ReadFloat(input) * scale;
			}
			if(nonessential) {
				this.ReadInt(input);
			}
			var path = this.attachmentLoader.newPathAttachment(skin,name);
			if(path == null) {
				return null;
			}
			path.closed = closed;
			path.constantSpeed = constantSpeed;
			path.worldVerticesLength = vertexCount << 1;
			path.vertices = vertices.vertices;
			path.bones = vertices.bones;
			path.lengths = lengths;
			return path;
		case 5:
			this.ReadFloat(input);
			this.ReadFloat(input);
			this.ReadFloat(input);
			if(nonessential) {
				this.ReadInt(input);
			}
			break;
		case 6:
			this.ReadVarint(input,true);
			var vertexCount = this.ReadVarint(input,true);
			var vertices = this.ReadVertices(input,vertexCount);
			if(nonessential) {
				this.ReadInt(input);
			}
			break;
		default:
		}
		return null;
	}
	,ReadVertices: function(input,vertexCount) {
		var scale = this.scale;
		var verticesLength = vertexCount << 1;
		var vertices = new spine_Vertices();
		if(!this.ReadBoolean(input)) {
			vertices.vertices = this.ReadFloatArray(input,verticesLength,scale);
			return vertices;
		}
		var n = verticesLength * 3 * 3;
		var this1 = new Array(n);
		var v = this1;
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			v[i] = 0;
		}
		var weights = v;
		var bonesArray = [];
		var weightsIndex = 0;
		var _g = 0;
		var _g1 = vertexCount;
		while(_g < _g1) {
			var i = _g++;
			var boneCount = this.ReadVarint(input,true);
			bonesArray.push(boneCount);
			var _g2 = 0;
			var _g3 = boneCount;
			while(_g2 < _g3) {
				var ii = _g2++;
				bonesArray.push(this.ReadVarint(input,true));
				weights[weightsIndex++] = this.ReadFloat(input) * scale;
				weights[weightsIndex++] = this.ReadFloat(input) * scale;
				weights[weightsIndex++] = this.ReadFloat(input);
			}
		}
		vertices.vertices = weights;
		vertices.bones = bonesArray;
		return vertices;
	}
	,ReadFloatArray: function(input,n,scale) {
		var this1 = new Array(n);
		var v = this1;
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			v[i] = 0;
		}
		var array = v;
		if(scale == 1) {
			var _g = 0;
			var _g1 = n;
			while(_g < _g1) {
				var i = _g++;
				array[i] = this.ReadFloat(input);
			}
		} else {
			var _g = 0;
			var _g1 = n;
			while(_g < _g1) {
				var i = _g++;
				array[i] = this.ReadFloat(input) * scale;
			}
		}
		return array;
	}
	,ReadShortArray: function(input) {
		var n = this.ReadVarint(input,true);
		var array = [];
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			array[i] = input.readByte() << 8 | input.readByte();
		}
		return array;
	}
	,ReadAnimation: function(name,input,skeletonData) {
		var timelines = [];
		var scale = this.scale;
		var duration = 0;
		var n = this.ReadVarint(input,true);
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			var slotIndex = this.ReadVarint(input,true);
			var nn = this.ReadVarint(input,true);
			var _g2 = 0;
			var _g3 = nn;
			while(_g2 < _g3) {
				var ii = _g2++;
				var timelineType = input.readByte();
				var frameCount = this.ReadVarint(input,true);
				switch(timelineType) {
				case 0:
					var timeline = new spine_animation_AttachmentTimeline(frameCount);
					timeline.slotIndex = slotIndex;
					var _g4 = 0;
					var _g5 = frameCount;
					while(_g4 < _g5) {
						var frameIndex = _g4++;
						var time = this.ReadFloat(input);
						var attachmentName = this.ReadString(input);
						timeline.frames[frameIndex] = time;
						timeline.attachmentNames[frameIndex] = attachmentName;
					}
					timelines.push(timeline);
					duration = Math.max(duration,timeline.frames[frameCount - 1]);
					break;
				case 1:
					var timeline1 = new spine_animation_ColorTimeline(frameCount);
					timeline1.slotIndex = slotIndex;
					var _g6 = 0;
					var _g7 = frameCount;
					while(_g6 < _g7) {
						var frameIndex1 = _g6++;
						var time1 = this.ReadFloat(input);
						var color = this.ReadInt(input);
						var r = color.r / 255;
						var g = color.g / 255;
						var b = color.b / 255;
						var a = color.a / 255;
						timeline1.setFrame(frameIndex1,time1,r,g,b,a);
						if(frameIndex1 < frameCount - 1) {
							this.ReadCurve(input,frameIndex1,timeline1);
						}
					}
					timelines.push(timeline1);
					duration = Math.max(duration,timeline1.frames[(Math.floor(timeline1.curves.length / spine_animation_CurveTimeline.BEZIER_SIZE + 1) - 1) * 5]);
					break;
				default:
				}
			}
		}
		n = this.ReadVarint(input,true);
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			var boneIndex = this.ReadVarint(input,true);
			var nn = this.ReadVarint(input,true);
			var _g2 = 0;
			var _g3 = nn;
			while(_g2 < _g3) {
				var ii = _g2++;
				var timelineType = input.readByte();
				var frameCount = this.ReadVarint(input,true);
				switch(timelineType) {
				case 0:
					var timeline = new spine_animation_RotateTimeline(frameCount);
					timeline.boneIndex = boneIndex;
					var _g4 = 0;
					var _g5 = frameCount;
					while(_g4 < _g5) {
						var frameIndex = _g4++;
						timeline.setFrame(frameIndex,this.ReadFloat(input),this.ReadFloat(input));
						if(frameIndex < frameCount - 1) {
							this.ReadCurve(input,frameIndex,timeline);
						}
					}
					timelines.push(timeline);
					duration = Math.max(duration,timeline.frames[(frameCount - 1) * 2]);
					break;
				case 1:case 2:case 3:
					var timeline1 = null;
					var timelineScale = 1;
					if(timelineType == 2) {
						timeline1 = new spine_animation_ScaleTimeline(frameCount);
					} else if(timelineType == 3) {
						timeline1 = new spine_animation_ShearTimeline(frameCount);
					} else {
						timeline1 = new spine_animation_TranslateTimeline(frameCount);
						timelineScale = scale;
					}
					timeline1.boneIndex = boneIndex;
					var _g6 = 0;
					var _g7 = frameCount;
					while(_g6 < _g7) {
						var frameIndex1 = _g6++;
						timeline1.setFrame(frameIndex1,this.ReadFloat(input),this.ReadFloat(input) * timelineScale,this.ReadFloat(input) * timelineScale);
						if(frameIndex1 < frameCount - 1) {
							this.ReadCurve(input,frameIndex1,timeline1);
						}
					}
					timelines.push(timeline1);
					duration = Math.max(duration,timeline1.frames[(frameCount - 1) * 3]);
					break;
				default:
				}
			}
		}
		n = this.ReadVarint(input,true);
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			var index = this.ReadVarint(input,true);
			var frameCount = this.ReadVarint(input,true);
			var timeline = new spine_animation_IkConstraintTimeline(frameCount);
			timeline.ikConstraintIndex = index;
			var _g2 = 0;
			var _g3 = frameCount;
			while(_g2 < _g3) {
				var frameIndex = _g2++;
				timeline.setFrame(frameIndex,this.ReadFloat(input),this.ReadFloat(input),this.ReadSByte(input));
				if(frameIndex < frameCount - 1) {
					this.ReadCurve(input,frameIndex,timeline);
				}
			}
			timelines.push(timeline);
			duration = Math.max(duration,timeline.frames[(frameCount - 1) * 3]);
		}
		n = this.ReadVarint(input,true);
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			var index = this.ReadVarint(input,true);
			var frameCount = this.ReadVarint(input,true);
			var timeline = new spine_animation_TransformConstraintTimeline(frameCount);
			timeline.transformConstraintIndex = index;
			var _g2 = 0;
			var _g3 = frameCount;
			while(_g2 < _g3) {
				var frameIndex = _g2++;
				timeline.setFrame(frameIndex,this.ReadFloat(input),this.ReadFloat(input),this.ReadFloat(input),this.ReadFloat(input),this.ReadFloat(input));
				if(frameIndex < frameCount - 1) {
					this.ReadCurve(input,frameIndex,timeline);
				}
			}
			timelines.push(timeline);
			duration = Math.max(duration,timeline.frames[(frameCount - 1) * 5]);
		}
		n = this.ReadVarint(input,true);
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			var index = this.ReadVarint(input,true);
			var data = skeletonData.pathConstraints[index];
			var nn = this.ReadVarint(input,true);
			var _g2 = 0;
			var _g3 = nn;
			while(_g2 < _g3) {
				var ii = _g2++;
				var timelineType = input.readByte();
				var frameCount = this.ReadVarint(input,true);
				switch(timelineType) {
				case 0:case 1:
					var timeline;
					var timelineScale = 1;
					if(timelineType == 1) {
						timeline = new spine_animation_PathConstraintSpacingTimeline(frameCount);
						if(data.spacingMode == "length" || data.spacingMode == "fixed") {
							timelineScale = scale;
						}
					} else {
						timeline = new spine_animation_PathConstraintPositionTimeline(frameCount);
						if(data.positionMode == "fixed") {
							timelineScale = scale;
						}
					}
					timeline.pathConstraintIndex = index;
					var _g4 = 0;
					var _g5 = frameCount;
					while(_g4 < _g5) {
						var frameIndex = _g4++;
						timeline.setFrame(frameIndex,this.ReadFloat(input),this.ReadFloat(input) * timelineScale);
						if(frameIndex < frameCount - 1) {
							this.ReadCurve(input,frameIndex,timeline);
						}
					}
					timelines.push(timeline);
					duration = Math.max(duration,timeline.frames[(frameCount - 1) * 2]);
					break;
				case 2:
					var timeline1 = new spine_animation_PathConstraintMixTimeline(frameCount);
					timeline1.pathConstraintIndex = index;
					var _g6 = 0;
					var _g7 = frameCount;
					while(_g6 < _g7) {
						var frameIndex1 = _g6++;
						timeline1.setFrame(frameIndex1,this.ReadFloat(input),this.ReadFloat(input),this.ReadFloat(input));
						if(frameIndex1 < frameCount - 1) {
							this.ReadCurve(input,frameIndex1,timeline1);
						}
					}
					timelines.push(timeline1);
					duration = Math.max(duration,timeline1.frames[(frameCount - 1) * 3]);
					break;
				default:
				}
			}
		}
		n = this.ReadVarint(input,true);
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			var skin = skeletonData.skins[this.ReadVarint(input,true)];
			var nn = this.ReadVarint(input,true);
			var _g2 = 0;
			var _g3 = nn;
			while(_g2 < _g3) {
				var ii = _g2++;
				var slotIndex = this.ReadVarint(input,true);
				var nnn = this.ReadVarint(input,true);
				var _g4 = 0;
				var _g5 = nnn;
				while(_g4 < _g5) {
					var iii = _g4++;
					var attachment = skin.getAttachment(slotIndex,this.ReadString(input));
					var weighted = attachment.bones != null;
					var vertices = attachment.vertices;
					var deformLength = weighted ? vertices.length / 3 * 2 | 0 : vertices.length;
					var frameCount = this.ReadVarint(input,true);
					var timeline = new spine_animation_DeformTimeline(frameCount);
					timeline.slotIndex = slotIndex;
					timeline.attachment = attachment;
					var _g6 = 0;
					var _g7 = frameCount;
					while(_g6 < _g7) {
						var frameIndex = _g6++;
						var time = this.ReadFloat(input);
						var deform = null;
						var end = this.ReadVarint(input,true);
						if(end == 0) {
							if(weighted) {
								var this1 = new Array(deformLength);
								var v = this1;
								var _g8 = 0;
								var _g9 = deformLength;
								while(_g8 < _g9) {
									var i1 = _g8++;
									v[i1] = 0;
								}
								deform = v;
							} else {
								deform = vertices;
							}
						} else {
							var this2 = new Array(deformLength);
							var v1 = this2;
							var _g10 = 0;
							var _g11 = deformLength;
							while(_g10 < _g11) {
								var i2 = _g10++;
								v1[i2] = 0;
							}
							deform = v1;
							var start = this.ReadVarint(input,true);
							end += start;
							if(scale == 1) {
								var _g12 = start;
								var _g13 = end;
								while(_g12 < _g13) {
									var v2 = _g12++;
									deform[v2] = this.ReadFloat(input);
								}
							} else {
								var _g14 = start;
								var _g15 = end;
								while(_g14 < _g15) {
									var v3 = _g14++;
									deform[v3] = this.ReadFloat(input) * scale;
								}
							}
							if(!weighted) {
								var vn = deform.length;
								var _g16 = 0;
								var _g17 = vn;
								while(_g16 < _g17) {
									var v4 = _g16++;
									deform[v4] += vertices[v4];
								}
							}
						}
						timeline.setFrame(frameIndex,time,deform);
						if(frameIndex < frameCount - 1) {
							this.ReadCurve(input,frameIndex,timeline);
						}
					}
					timelines.push(timeline);
					duration = Math.max(duration,timeline.frames[frameCount - 1]);
				}
			}
		}
		var drawOrderCount = this.ReadVarint(input,true);
		if(drawOrderCount > 0) {
			var timeline = new spine_animation_DrawOrderTimeline(drawOrderCount);
			var slotCount = skeletonData.slots.length;
			var _g = 0;
			var _g1 = drawOrderCount;
			while(_g < _g1) {
				var i = _g++;
				var time = this.ReadFloat(input);
				var offsetCount = this.ReadVarint(input,true);
				var drawOrder = [];
				var ii = slotCount - 1;
				while(ii >= 0) {
					drawOrder[ii] = -1;
					--ii;
				}
				var unchanged = [];
				var originalIndex = 0;
				var unchangedIndex = 0;
				var _g2 = 0;
				var _g3 = offsetCount;
				while(_g2 < _g3) {
					var ii1 = _g2++;
					var slotIndex = this.ReadVarint(input,true);
					while(originalIndex != slotIndex) unchanged[unchangedIndex++] = originalIndex++;
					drawOrder[originalIndex++ + this.ReadVarint(input,true)] = originalIndex - 1;
				}
				while(originalIndex < slotCount) unchanged[unchangedIndex++] = originalIndex++;
				var ii2 = slotCount - 1;
				while(ii2 >= 0) {
					if(drawOrder[ii2] == -1) {
						drawOrder[ii2] = unchanged[--unchangedIndex];
					}
					--ii2;
				}
				timeline.frames[i] = time;
				timeline.drawOrders[i] = drawOrder;
			}
			timelines.push(timeline);
			duration = Math.max(duration,timeline.frames[drawOrderCount - 1]);
		}
		var eventCount = this.ReadVarint(input,true);
		if(eventCount > 0) {
			var timeline = new spine_animation_EventTimeline(eventCount);
			var _g = 0;
			var _g1 = eventCount;
			while(_g < _g1) {
				var i = _g++;
				var time = this.ReadFloat(input);
				var eventData = skeletonData.events[this.ReadVarint(input,true)];
				var e = new spine_Event(time,eventData);
				e.intValue = this.ReadVarint(input,false);
				e.floatValue = this.ReadFloat(input);
				e.stringValue = this.ReadBoolean(input) ? this.ReadString(input) : eventData.stringValue;
				timeline.frames[i] = e.time;
				timeline.events[i] = e;
			}
			timelines.push(timeline);
			duration = Math.max(duration,timeline.frames[eventCount - 1]);
		}
		skeletonData.animations.push(new spine_animation_Animation(name,timelines,duration));
	}
	,ReadCurve: function(input,frameIndex,timeline) {
		switch(input.readByte()) {
		case 1:
			timeline.curves[frameIndex * spine_animation_CurveTimeline.BEZIER_SIZE] = 1;
			break;
		case 2:
			timeline.setCurve(frameIndex,this.ReadFloat(input),this.ReadFloat(input),this.ReadFloat(input),this.ReadFloat(input));
			break;
		default:
		}
	}
	,ReadByte: function(input) {
		return input.readByte();
	}
	,ReadSByte: function(input) {
		var value = input.readByte();
		if(value == -1) {
			throw haxe_Exception.thrown("End of stream exception");
		}
		if(value > 127) {
			return -1;
		} else {
			return 1;
		}
	}
	,ReadBoolean: function(input) {
		return input.readByte() != 0;
	}
	,ReadFloat: function(input) {
		var _this = this.floatBuffer;
		var v = input.readByte();
		_this.b[3] = v;
		var _this = this.floatBuffer;
		var v = input.readByte();
		_this.b[2] = v;
		var _this = this.floatBuffer;
		var v = input.readByte();
		_this.b[1] = v;
		var _this = this.floatBuffer;
		var v = input.readByte();
		_this.b[0] = v;
		return this.floatBuffer.getFloat(0);
	}
	,ReadInt: function(input) {
		var r = input.readByte();
		var g = input.readByte();
		var b = input.readByte();
		var a = input.readByte();
		var _this = this.rgba;
		_this.r = r;
		_this.g = g;
		_this.b = b;
		_this.a = a;
		return this.rgba;
	}
	,ReadVarint: function(input,optimizePositive) {
		var b = input.readByte();
		var result = b & 127;
		if((b & 128) != 0) {
			b = input.readByte();
			result |= (b & 127) << 7;
			if((b & 128) != 0) {
				b = input.readByte();
				result |= (b & 127) << 14;
				if((b & 128) != 0) {
					b = input.readByte();
					result |= (b & 127) << 21;
					if((b & 128) != 0) {
						result |= (input.readByte() & 127) << 28;
					}
				}
			}
		}
		if(optimizePositive) {
			return result;
		} else {
			return result >> 1 ^ -(result & 1);
		}
	}
	,ReadString: function(input) {
		var byteCount = this.ReadVarint(input,true);
		switch(byteCount) {
		case 0:
			return null;
		case 1:
			return "";
		default:
		}
		--byteCount;
		if(this.buffer.length < byteCount) {
			this.buffer = new haxe_io_Bytes(new ArrayBuffer(byteCount));
		}
		this.ReadFully(input,this.buffer,0,byteCount);
		return this.buffer.getString(0,byteCount);
	}
	,ReadFully: function(input,buffer,offset,length) {
		while(length > 0) {
			var count = input.readBytes(buffer,offset,length);
			if(count <= 0) {
				throw haxe_Exception.thrown("End of stream exception");
			}
			offset += count;
			length -= count;
		}
	}
	,__class__: spine_SkeletonBinary
};
var spine_Vertices = function() {
};
spine_Vertices.__name__ = true;
spine_Vertices.prototype = {
	__class__: spine_Vertices
};
var spine_RGBA = function() {
	this.a = 0;
	this.b = 0;
	this.g = 0;
	this.r = 0;
};
spine_RGBA.__name__ = true;
spine_RGBA.prototype = {
	set: function(r,g,b,a) {
		this.r = r;
		this.g = g;
		this.b = b;
		this.a = a;
	}
	,__class__: spine_RGBA
};
var spine_SkeletonData = function() {
	this.pathConstraints = [];
	this.transformConstraints = [];
	this.ikConstraints = [];
	this.animations = [];
	this.events = [];
	this.skins = [];
	this.slots = [];
	this.bones = [];
};
spine_SkeletonData.__name__ = true;
spine_SkeletonData.prototype = {
	findBone: function(boneName) {
		if(boneName == null) {
			throw haxe_Exception.thrown("boneName cannot be null.");
		}
		var _g = 0;
		var _g1 = this.bones.length;
		while(_g < _g1) {
			var i = _g++;
			var bone = this.bones[i];
			if(bone._name == boneName) {
				return bone;
			}
		}
		return null;
	}
	,findBoneIndex: function(boneName) {
		if(boneName == null) {
			throw haxe_Exception.thrown("boneName cannot be null.");
		}
		var _g = 0;
		var _g1 = this.bones.length;
		while(_g < _g1) {
			var i = _g++;
			if(this.bones[i]._name == boneName) {
				return i;
			}
		}
		return -1;
	}
	,findSlot: function(slotName) {
		if(slotName == null) {
			throw haxe_Exception.thrown("slotName cannot be null.");
		}
		var _g = 0;
		var _g1 = this.slots.length;
		while(_g < _g1) {
			var i = _g++;
			var slot = this.slots[i];
			if(slot._name == slotName) {
				return slot;
			}
		}
		return null;
	}
	,findSlotIndex: function(slotName) {
		if(slotName == null) {
			throw haxe_Exception.thrown("slotName cannot be null.");
		}
		var _g = 0;
		var _g1 = this.slots.length;
		while(_g < _g1) {
			var i = _g++;
			if(this.slots[i]._name == slotName) {
				return i;
			}
		}
		return -1;
	}
	,findSkin: function(skinName) {
		if(skinName == null) {
			throw haxe_Exception.thrown("skinName cannot be null.");
		}
		var _g = 0;
		var _g1 = this.skins;
		while(_g < _g1.length) {
			var skin = _g1[_g];
			++_g;
			if(skin._name == skinName) {
				return skin;
			}
		}
		return null;
	}
	,findEvent: function(eventName) {
		if(eventName == null) {
			throw haxe_Exception.thrown("eventName cannot be null.");
		}
		var _g = 0;
		var _g1 = this.events;
		while(_g < _g1.length) {
			var eventData = _g1[_g];
			++_g;
			if(eventData._name == eventName) {
				return eventData;
			}
		}
		return null;
	}
	,findAnimation: function(animationName) {
		if(animationName == null) {
			throw haxe_Exception.thrown("animationName cannot be null.");
		}
		var _g = 0;
		var _g1 = this.animations;
		while(_g < _g1.length) {
			var animation = _g1[_g];
			++_g;
			if(animation.name == animationName) {
				return animation;
			}
		}
		return null;
	}
	,findIkConstraint: function(constraintName) {
		if(constraintName == null) {
			throw haxe_Exception.thrown("constraintName cannot be null.");
		}
		var _g = 0;
		var _g1 = this.ikConstraints;
		while(_g < _g1.length) {
			var ikConstraintData = _g1[_g];
			++_g;
			if(ikConstraintData._name == constraintName) {
				return ikConstraintData;
			}
		}
		return null;
	}
	,findTransformConstraint: function(constraintName) {
		if(constraintName == null) {
			throw haxe_Exception.thrown("constraintName cannot be null.");
		}
		var _g = 0;
		var _g1 = this.transformConstraints;
		while(_g < _g1.length) {
			var transformConstraintData = _g1[_g];
			++_g;
			if(transformConstraintData._name == constraintName) {
				return transformConstraintData;
			}
		}
		return null;
	}
	,findTransformConstraintIndex: function(transformConstraintName) {
		if(transformConstraintName == null) {
			throw haxe_Exception.thrown("transformConstraintName cannot be null.");
		}
		var transformConstraints = this.transformConstraints;
		var _g = 0;
		var _g1 = transformConstraints.length;
		while(_g < _g1) {
			var i = _g++;
			if(transformConstraints[i]._name == transformConstraintName) {
				return i;
			}
		}
		return -1;
	}
	,findPathConstraint: function(constraintName) {
		if(constraintName == null) {
			throw haxe_Exception.thrown("constraintName cannot be null.");
		}
		var pathConstraints = this.pathConstraints;
		var _g = 0;
		var _g1 = pathConstraints.length;
		while(_g < _g1) {
			var i = _g++;
			var constraint = pathConstraints[i];
			if(constraint.get_name() == constraintName) {
				return constraint;
			}
		}
		return null;
	}
	,findPathConstraintIndex: function(pathConstraintName) {
		if(pathConstraintName == null) {
			throw haxe_Exception.thrown("pathConstraintName cannot be null.");
		}
		var pathConstraints = this.pathConstraints;
		var _g = 0;
		var _g1 = pathConstraints.length;
		while(_g < _g1) {
			var i = _g++;
			if(pathConstraints[i].get_name() == pathConstraintName) {
				return i;
			}
		}
		return -1;
	}
	,toString: function() {
		return this.name;
	}
	,__class__: spine_SkeletonData
};
var spine_SkeletonJson = function(attachmentLoader) {
	this.scale = 1;
	this.attachmentLoader = attachmentLoader;
	this.linkedMeshes = [];
};
spine_SkeletonJson.__name__ = true;
spine_SkeletonJson.readCurve = function(map,timeline,frameIndex) {
	var curve = map.curve;
	if(curve == null) {
		return;
	}
	if(typeof(curve) == "string" && js_Boot.__cast(curve , String) == "stepped") {
		timeline.curves[frameIndex * spine_animation_CurveTimeline.BEZIER_SIZE] = 1;
	} else if(((curve) instanceof Array)) {
		var array = curve;
		timeline.setCurve(frameIndex,array[0],array[1],array[2],array[3]);
	} else {
		throw haxe_Exception.thrown("Unknown curve type!");
	}
};
spine_SkeletonJson.toColor = function(hexString,colorIndex) {
	if(hexString.length != 8) {
		throw haxe_Exception.thrown("Color hexidecimal length must be 8, recieved: " + hexString);
	}
	return Std.parseInt("0x" + hexString.substring(colorIndex * 2,colorIndex * 2 + 2)) / 255;
};
spine_SkeletonJson.getFloatArray = function(raw,scale) {
	var n = raw.length;
	var this1 = new Array(n);
	var v = this1;
	var _g = 0;
	var _g1 = n;
	while(_g < _g1) {
		var i = _g++;
		v[i] = 0;
	}
	var result = v;
	if(scale == 1) {
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			result[i] = raw[i];
		}
	} else {
		var _g = 0;
		var _g1 = n;
		while(_g < _g1) {
			var i = _g++;
			result[i] = raw[i] * scale;
		}
	}
	return result;
};
spine_SkeletonJson.prototype = {
	readSkeletonData: function(object,name) {
		if(object == null) {
			throw haxe_Exception.thrown("object cannot be null.");
		}
		var root = JSON.parse(object == null ? "null" : "" + object);
		var skeletonData = new spine_SkeletonData();
		skeletonData.name = name;
		var skeletonMap = root.skeleton;
		if(skeletonMap != null) {
			skeletonData.hash = skeletonMap.hash;
			skeletonData.version = skeletonMap.spine;
			var this1 = skeletonMap.width;
			skeletonData.width = this1 != null ? this1 : 0.0;
			var this1 = skeletonMap.height;
			skeletonData.height = this1 != null ? this1 : 0.0;
			var this1 = skeletonMap.fps;
			skeletonData.fps = this1 != null ? this1 : 0.0;
			skeletonData.imagesPath = skeletonMap.images;
		}
		var boneData;
		var _g = 0;
		var _g1 = root.bones;
		while(_g < _g1.length) {
			var boneMap = _g1[_g];
			++_g;
			var parent = null;
			var parentName = boneMap.parent;
			if(parentName != null) {
				parent = skeletonData.findBone(parentName);
				if(parent == null) {
					throw haxe_Exception.thrown("Parent bone not found: " + parentName);
				}
			}
			boneData = new spine_BoneData(skeletonData.bones.length,boneMap.name,parent);
			var this1 = boneMap.length;
			boneData.length = (this1 != null ? this1 : 0.0) * this.scale;
			var this2 = boneMap.x;
			boneData.x = (this2 != null ? this2 : 0.0) * this.scale;
			var this3 = boneMap.y;
			boneData.y = (this3 != null ? this3 : 0.0) * this.scale;
			var this4 = boneMap.rotation;
			boneData.rotation = this4 != null ? this4 : 0.0;
			var this5 = boneMap.scaleX;
			boneData.scaleX = this5 != null ? this5 : 1.0;
			var this6 = boneMap.scaleY;
			boneData.scaleY = this6 != null ? this6 : 1.0;
			var this7 = boneMap.shearX;
			boneData.shearX = this7 != null ? this7 : 0.0;
			var this8 = boneMap.shearY;
			boneData.shearY = this8 != null ? this8 : 0.0;
			var this9 = boneMap.transform;
			var transformMode = this9 != null ? this9 : "normal";
			var tmp;
			switch(transformMode) {
			case "noRotationOrReflection":
				tmp = 2;
				break;
			case "noScale":
				tmp = 3;
				break;
			case "noScaleOrReflection":
				tmp = 4;
				break;
			case "onlyTranslation":
				tmp = 1;
				break;
			default:
				tmp = 0;
			}
			boneData.transformMode = tmp;
			skeletonData.bones.push(boneData);
		}
		if(root.slots != null) {
			var _g = 0;
			var _g1 = root.slots;
			while(_g < _g1.length) {
				var slotMap = _g1[_g];
				++_g;
				var slotName = slotMap.name;
				var boneName = slotMap.bone;
				boneData = skeletonData.findBone(boneName);
				if(boneData == null) {
					throw haxe_Exception.thrown("Slot bone not found: " + boneName);
				}
				var slotData = new spine_SlotData(skeletonData.slots.length,slotName,boneData);
				var color = slotMap.color;
				if(color != null) {
					slotData.r = spine_SkeletonJson.toColor(color,0);
					slotData.g = spine_SkeletonJson.toColor(color,1);
					slotData.b = spine_SkeletonJson.toColor(color,2);
					slotData.a = spine_SkeletonJson.toColor(color,3);
				}
				slotData.attachmentName = slotMap.attachment;
				var this1 = slotMap.blend;
				slotData.blendMode = this1 != null ? this1 : 0;
				skeletonData.slots.push(slotData);
			}
		}
		if(root.ik != null) {
			var _g = 0;
			var _g1 = root.ik;
			while(_g < _g1.length) {
				var constraintMap = _g1[_g];
				++_g;
				var ikConstraintData = new spine_IkConstraintData(constraintMap.name);
				var this1 = constraintMap.order;
				ikConstraintData.order = this1 != null ? this1 : 0.0;
				var _g2 = 0;
				var _g3 = constraintMap.bones;
				while(_g2 < _g3.length) {
					var boneName = _g3[_g2];
					++_g2;
					var bone = skeletonData.findBone(boneName);
					if(bone == null) {
						throw haxe_Exception.thrown("IK constraint bone not found: " + boneName);
					}
					ikConstraintData.bones.push(bone);
				}
				ikConstraintData.target = skeletonData.findBone(constraintMap.target);
				if(ikConstraintData.target == null) {
					throw haxe_Exception.thrown("Target bone not found: " + constraintMap.target);
				}
				var this2 = constraintMap.bendPositive;
				ikConstraintData.bendDirection = (this2 != null ? this2 : true) ? 1 : -1;
				var this3 = constraintMap.mix;
				ikConstraintData.mix = this3 != null ? this3 : 1.0;
				skeletonData.ikConstraints.push(ikConstraintData);
			}
		}
		if(root.transform != null) {
			var _g = 0;
			var _g1 = root.transform;
			while(_g < _g1.length) {
				var constraintMap = _g1[_g];
				++_g;
				var transformConstraintData = new spine_TransformConstraintData(constraintMap.name);
				var this1 = constraintMap.order;
				transformConstraintData.order = this1 != null ? this1 : 0.0;
				var _g2 = 0;
				var _g3 = constraintMap.bones;
				while(_g2 < _g3.length) {
					var boneName = _g3[_g2];
					++_g2;
					var bone = skeletonData.findBone(boneName);
					if(bone == null) {
						throw haxe_Exception.thrown("Transform constraint bone not found: " + boneName);
					}
					transformConstraintData._bones.push(bone);
				}
				transformConstraintData.target = skeletonData.findBone(constraintMap.target);
				if(transformConstraintData.target == null) {
					throw haxe_Exception.thrown("Target bone not found: " + constraintMap.target);
				}
				var this2 = constraintMap.rotation;
				transformConstraintData.offsetRotation = this2 != null ? this2 : 0.0;
				var this3 = constraintMap.x;
				transformConstraintData.offsetX = (this3 != null ? this3 : 0.0) * this.scale;
				var this4 = constraintMap.y;
				transformConstraintData.offsetY = (this4 != null ? this4 : 0.0) * this.scale;
				var this5 = constraintMap.scaleX;
				transformConstraintData.offsetScaleX = this5 != null ? this5 : 0.0;
				var this6 = constraintMap.scaleY;
				transformConstraintData.offsetScaleY = this6 != null ? this6 : 0.0;
				var this7 = constraintMap.shearY;
				transformConstraintData.offsetShearY = this7 != null ? this7 : 0.0;
				var this8 = constraintMap.rotateMix;
				transformConstraintData.rotateMix = this8 != null ? this8 : 1.0;
				var this9 = constraintMap.translateMix;
				transformConstraintData.translateMix = this9 != null ? this9 : 1.0;
				var this10 = constraintMap.scaleMix;
				transformConstraintData.scaleMix = this10 != null ? this10 : 1.0;
				var this11 = constraintMap.shearMix;
				transformConstraintData.shearMix = this11 != null ? this11 : 1.0;
				skeletonData.transformConstraints.push(transformConstraintData);
			}
		}
		if(root.path != null) {
			var _g = 0;
			var _g1 = root.path;
			while(_g < _g1.length) {
				var constraintMap = _g1[_g];
				++_g;
				var pathConstraintData = new spine_PathConstraintData(constraintMap.name);
				var this1 = constraintMap.order;
				pathConstraintData.order = this1 != null ? this1 : 0.0;
				var _g2 = 0;
				var _g3 = constraintMap.bones;
				while(_g2 < _g3.length) {
					var boneName = _g3[_g2];
					++_g2;
					var bone = skeletonData.findBone(boneName);
					if(bone == null) {
						throw haxe_Exception.thrown("Path constraint bone not found: " + boneName);
					}
					pathConstraintData.get_bones().push(bone);
				}
				pathConstraintData.target = skeletonData.findSlot(constraintMap.target);
				if(pathConstraintData.target == null) {
					throw haxe_Exception.thrown("Path target slot not found: " + constraintMap.target);
				}
				var this2 = constraintMap.positionMode;
				pathConstraintData.positionMode = this2 != null ? this2 : "percent";
				var this3 = constraintMap.spacingMode;
				pathConstraintData.spacingMode = this3 != null ? this3 : "length";
				var this4 = constraintMap.rotateMode;
				pathConstraintData.rotateMode = this4 != null ? this4 : "tangent";
				var this5 = constraintMap.rotation;
				pathConstraintData.offsetRotation = this5 != null ? this5 : 0.0;
				var this6 = constraintMap.position;
				pathConstraintData.position = this6 != null ? this6 : 0.0;
				if(pathConstraintData.positionMode == "fixed") {
					pathConstraintData.position *= this.scale;
				}
				var this7 = constraintMap.spacing;
				pathConstraintData.spacing = this7 != null ? this7 : 0.0;
				if(pathConstraintData.spacingMode == "length" || pathConstraintData.spacingMode == "fixed") {
					pathConstraintData.spacing *= this.scale;
				}
				var this8 = constraintMap.rotateMix;
				pathConstraintData.rotateMix = this8 != null ? this8 : 1.0;
				var this9 = constraintMap.translateMix;
				pathConstraintData.translateMix = this9 != null ? this9 : 1.0;
				skeletonData.pathConstraints.push(pathConstraintData);
			}
		}
		var skins = root.skins;
		if(skins != null) {
			var _g = 0;
			var _g1 = Reflect.fields(skins);
			while(_g < _g1.length) {
				var skinName = _g1[_g];
				++_g;
				var skinMap = skins[skinName];
				var skin = new spine_Skin(skinName);
				var _g2 = 0;
				var _g3 = Reflect.fields(skinMap);
				while(_g2 < _g3.length) {
					var slotName = _g3[_g2];
					++_g2;
					var slotIndex = skeletonData.findSlotIndex(slotName);
					var slotEntry = skinMap[slotName];
					var _g4 = 0;
					var _g5 = Reflect.fields(slotEntry);
					while(_g4 < _g5.length) {
						var attachmentName = _g5[_g4];
						++_g4;
						var attachment = this.readAttachment(slotEntry[attachmentName],skin,slotIndex,attachmentName);
						if(attachment != null) {
							skin.addAttachment(slotIndex,attachmentName,attachment);
						}
					}
				}
				skeletonData.skins[skeletonData.skins.length] = skin;
				if(skin._name == "default") {
					skeletonData.defaultSkin = skin;
				}
			}
		}
		var linkedMeshes = this.linkedMeshes;
		var _g = 0;
		while(_g < linkedMeshes.length) {
			var linkedMesh = linkedMeshes[_g];
			++_g;
			var parentSkin = linkedMesh.skin == null ? skeletonData.defaultSkin : skeletonData.findSkin(linkedMesh.skin);
			if(parentSkin == null) {
				throw haxe_Exception.thrown("Skin not found: " + linkedMesh.skin);
			}
			var parentMesh = parentSkin.getAttachment(linkedMesh.slotIndex,linkedMesh.parent);
			if(parentMesh == null) {
				throw haxe_Exception.thrown("Parent mesh not found: " + linkedMesh.parent);
			}
			var _this = linkedMesh.mesh;
			var parentMesh1 = parentMesh;
			_this._parentMesh = parentMesh1;
			if(parentMesh1 != null) {
				_this.bones = parentMesh1.bones;
				_this.vertices = parentMesh1.vertices;
				_this.worldVerticesLength = parentMesh1.worldVerticesLength;
				_this.regionUVs = parentMesh1.regionUVs;
				_this.triangles = parentMesh1.triangles;
				_this.hullLength = parentMesh1.hullLength;
				_this.edges = parentMesh1.edges;
				_this.width = parentMesh1.width;
				_this.height = parentMesh1.height;
			}
			linkedMesh.mesh.updateUVs();
		}
		linkedMeshes = [];
		var events = root.events;
		if(events != null) {
			var _g = 0;
			var _g1 = Reflect.fields(events);
			while(_g < _g1.length) {
				var eventName = _g1[_g];
				++_g;
				var eventMap = events[eventName];
				var eventData = new spine_EventData(eventName);
				var this1 = eventMap.int;
				eventData.intValue = this1 != null ? this1 : 0;
				var this2 = eventMap.float;
				eventData.floatValue = this2 != null ? this2 : 0.0;
				var this3 = eventMap.string;
				eventData.stringValue = this3 != null ? this3 : "";
				skeletonData.events.push(eventData);
			}
		}
		var animations = root.animations;
		if(animations != null) {
			var _g = 0;
			var _g1 = Reflect.fields(animations);
			while(_g < _g1.length) {
				var animationName = _g1[_g];
				++_g;
				this.readAnimation(animations[animationName],animationName,skeletonData);
			}
		}
		return skeletonData;
	}
	,readAttachment: function(map,skin,slotIndex,name) {
		var this1 = map.name;
		if(this1 != null) {
			name = this1;
		}
		var this1 = map.type;
		var type = this1 != null ? this1 : "region";
		var scale = this.scale;
		var color;
		switch(type) {
		case "boundingbox":
			var box = this.attachmentLoader.newBoundingBoxAttachment(skin,name);
			if(box == null) {
				return null;
			}
			var this1 = map.vertexCount;
			this.readVertices(map,box,(this1 != null ? this1 : 0) << 1);
			return box;
		case "linkedmesh":case "mesh":
			var this1 = map.path;
			var mesh = this.attachmentLoader.newMeshAttachment(skin,name,this1 != null ? this1 : name);
			if(mesh == null) {
				return null;
			}
			var this1 = map.path;
			mesh.path = this1 != null ? this1 : name;
			color = map.color;
			if(color != null) {
				mesh.r = spine_SkeletonJson.toColor(color,0);
				mesh.g = spine_SkeletonJson.toColor(color,1);
				mesh.b = spine_SkeletonJson.toColor(color,2);
				mesh.a = spine_SkeletonJson.toColor(color,3);
			}
			var this1 = map.width;
			mesh.width = (this1 != null ? this1 : 0.0) * scale;
			var this1 = map.height;
			mesh.height = (this1 != null ? this1 : 0.0) * scale;
			if(map.parent != null) {
				var this1 = map.deform;
				mesh.inheritDeform = this1 != null ? this1 : true;
				this.linkedMeshes.push(new spine_LinkedMesh(mesh,map.skin,slotIndex,map.parent));
				return mesh;
			}
			var uvs = spine_SkeletonJson.getFloatArray(map.uvs,1);
			this.readVertices(map,mesh,uvs.length);
			mesh.triangles = map.triangles.slice();
			mesh.regionUVs = uvs;
			mesh.updateUVs();
			var this1 = map.hull;
			mesh.hullLength = (this1 != null ? this1 : 0) * 2;
			if(map.edges != null) {
				mesh.edges = map.edges.slice();
			}
			return mesh;
		case "path":
			var path = this.attachmentLoader.newPathAttachment(skin,name);
			if(path == null) {
				return null;
			}
			var this1 = map.closed;
			path.closed = this1 != null && this1;
			var this1 = map.constantSpeed;
			path.constantSpeed = this1 != null ? this1 : true;
			var this1 = map.vertexCount;
			var vertexCount = this1 != null ? this1 : 0;
			this.readVertices(map,path,vertexCount << 1);
			path.lengths = spine_SkeletonJson.getFloatArray(map.lengths,scale);
			return path;
		case "region":
			var this1 = map.path;
			var region = this.attachmentLoader.newRegionAttachment(skin,name,this1 != null ? this1 : name);
			if(region == null) {
				return null;
			}
			var this1 = map.path;
			region.path = this1 != null ? this1 : name;
			var this1 = map.x;
			region.x = (this1 != null ? this1 : 0.0) * scale;
			var this1 = map.y;
			region.y = (this1 != null ? this1 : 0.0) * scale;
			var this1 = map.scaleX;
			region.scaleX = this1 != null ? this1 : 1.0;
			var this1 = map.scaleY;
			region.scaleY = this1 != null ? this1 : 1.0;
			var this1 = map.rotation;
			region.rotation = this1 != null ? this1 : 0.0;
			var this1 = map.width;
			region.width = (this1 != null ? this1 : 0.0) * scale;
			var this1 = map.height;
			region.height = (this1 != null ? this1 : 0.0) * scale;
			color = map.color;
			if(color != null) {
				region.r = spine_SkeletonJson.toColor(color,0);
				region.g = spine_SkeletonJson.toColor(color,1);
				region.b = spine_SkeletonJson.toColor(color,2);
				region.a = spine_SkeletonJson.toColor(color,3);
			}
			region.updateOffset();
			return region;
		default:
			return null;
		}
	}
	,readVertices: function(map,attachment,verticesLength) {
		attachment.worldVerticesLength = verticesLength;
		var vertices = spine_SkeletonJson.getFloatArray(map.vertices,1.0);
		if(verticesLength == vertices.length) {
			if(this.scale != 1) {
				var _g = 0;
				var _g1 = vertices.length;
				while(_g < _g1) {
					var i = _g++;
					vertices[i] *= this.scale;
				}
			}
			attachment.vertices = vertices;
			return;
		}
		var weights = [];
		var bones = [];
		var i = 0;
		while(i < vertices.length) {
			var boneCount = Math.floor(vertices[i++]);
			bones.push(boneCount);
			var nn = i + boneCount * 4;
			while(i < nn) {
				bones.push(Math.floor(vertices[i]));
				weights.push(vertices[i + 1] * this.scale);
				weights.push(vertices[i + 2] * this.scale);
				weights.push(vertices[i + 3]);
				i += 4;
			}
		}
		attachment.bones = bones;
		attachment.vertices = spine_SkeletonJson.getFloatArray(weights,1);
	}
	,readAnimation: function(map,name,skeletonData) {
		var scale = this.scale;
		var timelines = [];
		var duration = 0;
		var slotIndex;
		var slotName;
		var values;
		var valueMap;
		var frameIndex;
		var i;
		var timelineName;
		var slots = map.slots;
		var _g = 0;
		var _g1 = Reflect.fields(slots);
		while(_g < _g1.length) {
			var slotName = _g1[_g];
			++_g;
			var slotMap = slots[slotName];
			slotIndex = skeletonData.findSlotIndex(slotName);
			var _g2 = 0;
			var _g3 = Reflect.fields(slotMap);
			while(_g2 < _g3.length) {
				var timelineName = _g3[_g2];
				++_g2;
				values = slotMap[timelineName];
				if(timelineName == "color") {
					var colorTimeline = new spine_animation_ColorTimeline(values.length);
					colorTimeline.slotIndex = slotIndex;
					frameIndex = 0;
					var _g4 = 0;
					while(_g4 < values.length) {
						var valueMap = values[_g4];
						++_g4;
						var colorValue = valueMap;
						var color = colorValue.color;
						var r = spine_SkeletonJson.toColor(color,0);
						var g = spine_SkeletonJson.toColor(color,1);
						var b = spine_SkeletonJson.toColor(color,2);
						var a = spine_SkeletonJson.toColor(color,3);
						colorTimeline.setFrame(frameIndex,colorValue.time,r,g,b,a);
						spine_SkeletonJson.readCurve(colorValue,colorTimeline,frameIndex);
						++frameIndex;
					}
					timelines[timelines.length] = colorTimeline;
					duration = Math.max(duration,colorTimeline.frames[(Math.floor(colorTimeline.curves.length / spine_animation_CurveTimeline.BEZIER_SIZE + 1) - 1) * 5]);
				} else if(timelineName == "attachment") {
					var attachmentTimeline = new spine_animation_AttachmentTimeline(values.length);
					attachmentTimeline.slotIndex = slotIndex;
					frameIndex = 0;
					var _g5 = 0;
					while(_g5 < values.length) {
						var valueMap1 = values[_g5];
						++_g5;
						var attachmentValue = valueMap1;
						var frameIndex1 = frameIndex++;
						attachmentTimeline.frames[frameIndex1] = attachmentValue.time;
						attachmentTimeline.attachmentNames[frameIndex1] = attachmentValue.name;
					}
					timelines[timelines.length] = attachmentTimeline;
					duration = Math.max(duration,attachmentTimeline.frames[attachmentTimeline.frames.length - 1]);
				} else {
					throw haxe_Exception.thrown("Invalid timeline type for a slot: " + timelineName + " (" + slotName + ")");
				}
			}
		}
		var bones = map.bones;
		var _g = 0;
		var _g1 = Reflect.fields(bones);
		while(_g < _g1.length) {
			var boneName = _g1[_g];
			++_g;
			var boneIndex = skeletonData.findBoneIndex(boneName);
			if(boneIndex == -1) {
				throw haxe_Exception.thrown("Bone not found: " + boneName);
			}
			var boneMap = bones[boneName];
			var _g2 = 0;
			var _g3 = Reflect.fields(boneMap);
			while(_g2 < _g3.length) {
				var timelineName = _g3[_g2];
				++_g2;
				values = boneMap[timelineName];
				if(timelineName == "rotate") {
					var rotateTimeline = new spine_animation_RotateTimeline(values.length);
					rotateTimeline.boneIndex = boneIndex;
					frameIndex = 0;
					var _g4 = 0;
					while(_g4 < values.length) {
						var valueMap = values[_g4];
						++_g4;
						var rotateValue = valueMap;
						rotateTimeline.setFrame(frameIndex,rotateValue.time,rotateValue.angle);
						spine_SkeletonJson.readCurve(rotateValue,rotateTimeline,frameIndex);
						++frameIndex;
					}
					timelines[timelines.length] = rotateTimeline;
					duration = Math.max(duration,rotateTimeline.frames[(Math.floor(rotateTimeline.curves.length / spine_animation_CurveTimeline.BEZIER_SIZE + 1) - 1) * 2]);
				} else if(timelineName == "translate" || timelineName == "scale" || timelineName == "shear") {
					var translateTimeline;
					var timelineScale = 1.0;
					if(timelineName == "scale") {
						translateTimeline = new spine_animation_ScaleTimeline(values.length);
					} else if(timelineName == "shear") {
						translateTimeline = new spine_animation_ShearTimeline(values.length);
					} else {
						translateTimeline = new spine_animation_TranslateTimeline(values.length);
						timelineScale = scale;
					}
					translateTimeline.boneIndex = boneIndex;
					frameIndex = 0;
					var _g5 = 0;
					while(_g5 < values.length) {
						var valueMap1 = values[_g5];
						++_g5;
						var translateValue = valueMap1;
						var this1 = translateValue.x;
						var x = (this1 != null ? this1 : 0.0) * timelineScale;
						var this2 = translateValue.y;
						var y = (this2 != null ? this2 : 0.0) * timelineScale;
						translateTimeline.setFrame(frameIndex,translateValue.time,x,y);
						spine_SkeletonJson.readCurve(translateValue,translateTimeline,frameIndex);
						++frameIndex;
					}
					timelines[timelines.length] = translateTimeline;
					duration = Math.max(duration,translateTimeline.frames[(Math.floor(translateTimeline.curves.length / spine_animation_CurveTimeline.BEZIER_SIZE + 1) - 1) * 3]);
				} else {
					throw haxe_Exception.thrown("Invalid timeline type for a bone: " + timelineName + " (" + boneName + ")");
				}
			}
		}
		var ikMap = Reflect.field(map,"ik");
		var _g = 0;
		var _g1 = Reflect.fields(ikMap);
		while(_g < _g1.length) {
			var ikConstraintName = _g1[_g];
			++_g;
			var ikConstraint = skeletonData.findIkConstraint(ikConstraintName);
			values = ikMap[ikConstraintName];
			var ikTimeline = new spine_animation_IkConstraintTimeline(values.length);
			ikTimeline.ikConstraintIndex = skeletonData.ikConstraints.indexOf(ikConstraint);
			frameIndex = 0;
			var _g2 = 0;
			while(_g2 < values.length) {
				var valueMap = values[_g2];
				++_g2;
				var ikConstraintValue = valueMap;
				var this1 = ikConstraintValue.mix;
				var mix = this1 != null ? this1 : 1.0;
				var bendDirection = ikConstraintValue.bendPositive != null ? 1 : -1;
				ikTimeline.setFrame(frameIndex,ikConstraintValue.time,mix,bendDirection);
				spine_SkeletonJson.readCurve(ikConstraintValue,ikTimeline,frameIndex);
				++frameIndex;
			}
			timelines[timelines.length] = ikTimeline;
			duration = Math.max(duration,ikTimeline.frames[(Math.floor(ikTimeline.curves.length / spine_animation_CurveTimeline.BEZIER_SIZE + 1) - 1) * 3]);
		}
		var transformMap = map.transform;
		var _g = 0;
		var _g1 = Reflect.fields(transformMap);
		while(_g < _g1.length) {
			var transformName = _g1[_g];
			++_g;
			var transformConstraint = skeletonData.findTransformConstraint(transformName);
			values = transformMap[transformName];
			var transformTimeline = new spine_animation_TransformConstraintTimeline(values.length);
			transformTimeline.transformConstraintIndex = skeletonData.transformConstraints.indexOf(transformConstraint);
			frameIndex = 0;
			var _g2 = 0;
			while(_g2 < values.length) {
				var valueMap = values[_g2];
				++_g2;
				var transformConstraintValue = valueMap;
				var this1 = transformConstraintValue.rotateMix;
				var rotateMix = this1 != null ? this1 : 1.0;
				var this2 = transformConstraintValue.translateMix;
				var translateMix = this2 != null ? this2 : 1.0;
				var this3 = transformConstraintValue.scaleMix;
				var scaleMix = this3 != null ? this3 : 1.0;
				var this4 = transformConstraintValue.shearMix;
				var shearMix = this4 != null ? this4 : 1.0;
				transformTimeline.setFrame(frameIndex,transformConstraintValue.time,rotateMix,translateMix,scaleMix,shearMix);
				spine_SkeletonJson.readCurve(transformConstraintValue,transformTimeline,frameIndex);
				++frameIndex;
			}
			timelines.push(transformTimeline);
			duration = Math.max(duration,transformTimeline.frames[(Math.floor(transformTimeline.curves.length / spine_animation_CurveTimeline.BEZIER_SIZE + 1) - 1) * 5]);
		}
		var paths = map.paths;
		var _g = 0;
		var _g1 = Reflect.fields(paths);
		while(_g < _g1.length) {
			var pathName = _g1[_g];
			++_g;
			var index = skeletonData.findPathConstraintIndex(pathName);
			if(index == -1) {
				throw haxe_Exception.thrown("Path constraint not found: " + pathName);
			}
			var data = skeletonData.pathConstraints[index];
			var pathMap = paths[pathName];
			var _g2 = 0;
			var _g3 = Reflect.fields(pathMap);
			while(_g2 < _g3.length) {
				var timelineName = _g3[_g2];
				++_g2;
				values = pathMap[timelineName];
				if(timelineName == "position" || timelineName == "spacing") {
					var pathTimeline;
					var timelineScale = 1.0;
					if(timelineName == "spacing") {
						pathTimeline = new spine_animation_PathConstraintSpacingTimeline(values.length);
						if(data.spacingMode == "length" || data.spacingMode == "fixed") {
							timelineScale = scale;
						}
					} else {
						pathTimeline = new spine_animation_PathConstraintPositionTimeline(values.length);
						if(data.positionMode == "fixed") {
							timelineScale = scale;
						}
					}
					pathTimeline.pathConstraintIndex = index;
					frameIndex = 0;
					var _g4 = 0;
					while(_g4 < values.length) {
						var valueMap = values[_g4];
						++_g4;
						var pathConstraintValue = valueMap;
						var value;
						if(timelineName == "position") {
							var this1 = pathConstraintValue.position;
							value = this1 != null ? this1 : 0.0;
						} else {
							var this2 = pathConstraintValue.spacing;
							value = this2 != null ? this2 : 0.0;
						}
						pathTimeline.setFrame(frameIndex,pathConstraintValue.time,value * timelineScale);
						spine_SkeletonJson.readCurve(pathConstraintValue,pathTimeline,frameIndex);
						++frameIndex;
					}
					timelines.push(pathTimeline);
					duration = Math.max(duration,pathTimeline.frames[(Math.floor(pathTimeline.curves.length / spine_animation_CurveTimeline.BEZIER_SIZE + 1) - 1) * 2]);
				} else if(timelineName == "mix") {
					var pathMixTimeline = new spine_animation_PathConstraintMixTimeline(values.length);
					pathMixTimeline.pathConstraintIndex = index;
					frameIndex = 0;
					var _g5 = 0;
					while(_g5 < values.length) {
						var valueMap1 = values[_g5];
						++_g5;
						var pathConstraintMixValue = valueMap1;
						var this3 = pathConstraintMixValue.rotateMix;
						var rotateMix = this3 != null ? this3 : 1.0;
						var this4 = pathConstraintMixValue.translateMix;
						var translateMix = this4 != null ? this4 : 1.0;
						pathMixTimeline.setFrame(frameIndex,pathConstraintMixValue.time,rotateMix,translateMix);
						spine_SkeletonJson.readCurve(pathConstraintMixValue,pathMixTimeline,frameIndex);
						++frameIndex;
					}
					timelines.push(pathMixTimeline);
					duration = Math.max(duration,pathMixTimeline.frames[(Math.floor(pathMixTimeline.curves.length / spine_animation_CurveTimeline.BEZIER_SIZE + 1) - 1) * 3]);
				}
			}
		}
		var deformMap = Reflect.field(map,"deform");
		var _g = 0;
		var _g1 = Reflect.fields(deformMap);
		while(_g < _g1.length) {
			var skinName = _g1[_g];
			++_g;
			var skin = skeletonData.findSkin(skinName);
			var slotMap = deformMap[skinName];
			var _g2 = 0;
			var _g3 = Reflect.fields(slotMap);
			while(_g2 < _g3.length) {
				var slotName = _g3[_g2];
				++_g2;
				slotIndex = skeletonData.findSlotIndex(slotName);
				var timelineMap = slotMap[slotName];
				var _g4 = 0;
				var _g5 = Reflect.fields(timelineMap);
				while(_g4 < _g5.length) {
					var timelineName = _g5[_g4];
					++_g4;
					values = timelineMap[timelineName];
					var attachment = ((skin.getAttachment(slotIndex,timelineName)) instanceof spine_attachments_VertexAttachment) ? skin.getAttachment(slotIndex,timelineName) : null;
					if(attachment == null) {
						throw haxe_Exception.thrown("Deform attachment not found: " + timelineName);
					}
					var weighted = attachment.bones != null;
					var vertices = attachment.vertices;
					var deformLength = weighted ? Math.floor(vertices.length / 3 * 2) : vertices.length;
					var deformTimeline = new spine_animation_DeformTimeline(values.length);
					deformTimeline.slotIndex = slotIndex;
					deformTimeline.attachment = attachment;
					frameIndex = 0;
					var _g6 = 0;
					while(_g6 < values.length) {
						var valueMap = values[_g6];
						++_g6;
						var deformValue = valueMap;
						var deform;
						var verticesValue = deformValue.vertices;
						if(verticesValue == null) {
							if(weighted) {
								var this1 = new Array(deformLength);
								var v = this1;
								var _g7 = 0;
								var _g8 = deformLength;
								while(_g7 < _g8) {
									var i1 = _g7++;
									v[i1] = 0;
								}
								deform = v;
							} else {
								deform = vertices;
							}
						} else {
							var this2 = new Array(deformLength);
							var v1 = this2;
							var _g9 = 0;
							var _g10 = deformLength;
							while(_g9 < _g10) {
								var i2 = _g9++;
								v1[i2] = 0;
							}
							deform = v1;
							var this3 = deformValue.offset;
							var start = Math.floor(this3 != null ? this3 : 0.0);
							var temp = spine_SkeletonJson.getFloatArray(verticesValue,1.0);
							var _g11 = 0;
							var _g12 = temp.length;
							while(_g11 < _g12) {
								var i3 = _g11++;
								deform[start + i3] = temp[i3];
							}
							if(scale != 1) {
								var n = start + temp.length;
								var _g13 = start;
								var _g14 = n;
								while(_g13 < _g14) {
									var i4 = _g13++;
									deform[i4] *= scale;
								}
							}
							if(!weighted) {
								var _g15 = 0;
								var _g16 = deformLength;
								while(_g15 < _g16) {
									var i5 = _g15++;
									deform[i5] += vertices[i5];
								}
							}
						}
						deformTimeline.setFrame(frameIndex,deformValue.time,deform);
						spine_SkeletonJson.readCurve(deformValue,deformTimeline,frameIndex);
						++frameIndex;
					}
					timelines[timelines.length] = deformTimeline;
					duration = Math.max(duration,deformTimeline.frames[Math.floor(deformTimeline.curves.length / spine_animation_CurveTimeline.BEZIER_SIZE + 1) - 1]);
				}
			}
		}
		var drawOrderValues = map.drawOrder;
		if(drawOrderValues == null) {
			drawOrderValues = map.draworder;
		}
		if(drawOrderValues != null) {
			var drawOrderTimeline = new spine_animation_DrawOrderTimeline(drawOrderValues.length);
			var slotCount = skeletonData.slots.length;
			frameIndex = 0;
			var _g = 0;
			while(_g < drawOrderValues.length) {
				var drawOrderMap = drawOrderValues[_g];
				++_g;
				var drawOrderValue = drawOrderMap;
				var drawOrder = null;
				if(drawOrderValue.offsets != null) {
					drawOrder = [];
					i = slotCount - 1;
					while(i >= 0) {
						drawOrder[i] = -1;
						--i;
					}
					var offsets = drawOrderValue.offsets;
					var unchanged = [];
					var originalIndex = 0;
					var unchangedIndex = 0;
					var _g1 = 0;
					while(_g1 < offsets.length) {
						var offsetMap = offsets[_g1];
						++_g1;
						slotIndex = skeletonData.findSlotIndex(offsetMap.slot);
						if(slotIndex == -1) {
							throw haxe_Exception.thrown("Slot not found: " + offsetMap.slot);
						}
						while(originalIndex != slotIndex) unchanged[unchangedIndex++] = originalIndex++;
						drawOrder[originalIndex++ + offsetMap.offset] = originalIndex - 1;
					}
					while(originalIndex < slotCount) unchanged[unchangedIndex++] = originalIndex++;
					i = slotCount - 1;
					while(i >= 0) {
						if(drawOrder[i] == -1) {
							drawOrder[i] = unchanged[--unchangedIndex];
						}
						--i;
					}
				}
				var frameIndex1 = frameIndex++;
				drawOrderTimeline.frames[frameIndex1] = drawOrderValue.time;
				drawOrderTimeline.drawOrders[frameIndex1] = drawOrder;
			}
			timelines[timelines.length] = drawOrderTimeline;
			duration = Math.max(duration,drawOrderTimeline.frames[drawOrderTimeline.frames.length - 1]);
		}
		var eventsMap = map.events;
		if(eventsMap != null) {
			var eventTimeline = new spine_animation_EventTimeline(eventsMap.length);
			frameIndex = 0;
			var _g = 0;
			while(_g < eventsMap.length) {
				var eventMap = eventsMap[_g];
				++_g;
				var eventValue = eventMap;
				var eventData = skeletonData.findEvent(eventValue.name);
				if(eventData == null) {
					throw haxe_Exception.thrown("Event not found: " + eventValue.name);
				}
				var event = new spine_Event(eventValue.time,eventData);
				var this1 = eventValue.int;
				event.intValue = this1 != null ? this1 : eventData.intValue;
				var this2 = eventValue.float;
				event.floatValue = this2 != null ? this2 : eventData.floatValue;
				var this3 = eventValue.string;
				event.stringValue = this3 != null ? this3 : eventData.stringValue;
				var frameIndex1 = frameIndex++;
				eventTimeline.frames[frameIndex1] = event.time;
				eventTimeline.events[frameIndex1] = event;
			}
			timelines[timelines.length] = eventTimeline;
			duration = Math.max(duration,eventTimeline.frames[eventTimeline.frames.length - 1]);
		}
		skeletonData.animations[skeletonData.animations.length] = new spine_animation_Animation(name,timelines,duration);
	}
	,__class__: spine_SkeletonJson
};
var spine_LinkedMesh = function(mesh,skin,slotIndex,parent) {
	this.mesh = mesh;
	this.skin = skin;
	this.slotIndex = slotIndex;
	this.parent = parent;
};
spine_LinkedMesh.__name__ = true;
spine_LinkedMesh.prototype = {
	__class__: spine_LinkedMesh
};
var spine_Skin = function(name) {
	if(name == null) {
		throw haxe_Exception.thrown("name cannot be null.");
	}
	this._name = name;
	this._attachments = [];
};
spine_Skin.__name__ = true;
spine_Skin.prototype = {
	addAttachment: function(slotIndex,name,attachment) {
		if(attachment == null) {
			throw haxe_Exception.thrown("attachment cannot be null.");
		}
		if(this._attachments[slotIndex] == null) {
			this._attachments[slotIndex] = new haxe_ds_StringMap();
		}
		this._attachments[slotIndex].h[name] = attachment;
	}
	,getAttachment: function(slotIndex,name) {
		if(slotIndex >= this._attachments.length) {
			return null;
		}
		var map = this._attachments[slotIndex];
		if(map != null) {
			return map.h[name];
		} else {
			return null;
		}
	}
	,toString: function() {
		return this._name;
	}
	,attachAll: function(skeleton,oldSkin) {
		var slotIndex = 0;
		var _g = 0;
		var _g1 = skeleton.slots;
		while(_g < _g1.length) {
			var slot = _g1[_g];
			++_g;
			var slotAttachment = slot._attachment;
			if(slotAttachment != null && slotIndex < oldSkin._attachments.length) {
				var map = oldSkin._attachments[slotIndex];
				if(map == null) {
					continue;
				}
				var name = haxe_ds_StringMap.keysIterator(map.h);
				while(name.hasNext()) {
					var name1 = name.next();
					var skinAttachment = map.h[name1];
					if(slotAttachment == skinAttachment) {
						var attachment = this.getAttachment(slotIndex,name1);
						if(attachment != null) {
							if(slot._attachment != attachment) {
								slot._attachment = attachment;
								slot._attachmentTime = slot._bone._skeleton.time;
								slot.attachmentVerticesLength = 0;
							}
						}
						break;
					}
				}
			}
			++slotIndex;
		}
	}
	,get_name: function() {
		return this._name;
	}
	,get_attachments: function() {
		return this._attachments;
	}
	,__class__: spine_Skin
	,__properties__: {get_attachments:"get_attachments",get_name:"get_name"}
};
var spine_Slot = function(data,bone) {
	this.attachmentVerticesLength = 0;
	this.attachmentVertices = [];
	if(data == null) {
		throw haxe_Exception.thrown("data cannot be null.");
	}
	if(bone == null) {
		throw haxe_Exception.thrown("bone cannot be null.");
	}
	this._data = data;
	this._bone = bone;
	this.setToSetupPose();
};
spine_Slot.__name__ = true;
spine_Slot.prototype = {
	setToSetupPose: function() {
		this.r = this._data.r;
		this.g = this._data.g;
		this.b = this._data.b;
		this.a = this._data.a;
		if(this._data.attachmentName == null) {
			var attachment = null;
			if(this._attachment != attachment) {
				this._attachment = attachment;
				this._attachmentTime = this._bone._skeleton.time;
				this.attachmentVerticesLength = 0;
			}
		} else {
			this._attachment = null;
			var attachment = this._bone._skeleton.getAttachmentForSlotIndex(this._data._index,this._data.attachmentName);
			if(this._attachment != attachment) {
				this._attachment = attachment;
				this._attachmentTime = this._bone._skeleton.time;
				this.attachmentVerticesLength = 0;
			}
		}
	}
	,toString: function() {
		return this._data._name;
	}
	,get_data: function() {
		return this._data;
	}
	,get_bone: function() {
		return this._bone;
	}
	,get_attachment: function() {
		return this._attachment;
	}
	,get_attachmentTime: function() {
		return this._bone._skeleton.time - this._attachmentTime;
	}
	,get_skeleton: function() {
		return this._bone._skeleton;
	}
	,set_attachment: function(attachment) {
		if(this._attachment != attachment) {
			this._attachment = attachment;
			this._attachmentTime = this._bone._skeleton.time;
			this.attachmentVerticesLength = 0;
		}
		return attachment;
	}
	,set_attachmentTime: function(time) {
		this._attachmentTime = this._bone._skeleton.time - time;
		return time;
	}
	,__class__: spine_Slot
	,__properties__: {set_attachmentTime:"set_attachmentTime",get_attachmentTime:"get_attachmentTime",set_attachment:"set_attachment",get_attachment:"get_attachment",get_skeleton:"get_skeleton",get_bone:"get_bone",get_data:"get_data"}
};
var spine_SlotData = function(index,name,boneData) {
	this.a = 1;
	this.b = 1;
	this.g = 1;
	this.r = 1;
	if(index < 0) {
		throw haxe_Exception.thrown("index must be >= 0.");
	}
	if(name == null) {
		throw haxe_Exception.thrown("name cannot be null.");
	}
	if(boneData == null) {
		throw haxe_Exception.thrown("boneData cannot be null.");
	}
	this._index = index;
	this._name = name;
	this._boneData = boneData;
};
spine_SlotData.__name__ = true;
spine_SlotData.prototype = {
	toString: function() {
		return this._name;
	}
	,get_index: function() {
		return this._index;
	}
	,get_name: function() {
		return this._name;
	}
	,get_boneData: function() {
		return this._boneData;
	}
	,__class__: spine_SlotData
	,__properties__: {get_boneData:"get_boneData",get_name:"get_name",get_index:"get_index"}
};
var spine_TransformConstraint = function(data,skeleton) {
	this._temp = [];
	spine_Constraint.call(this);
	if(data == null) {
		throw haxe_Exception.thrown("data cannot be null.");
	}
	if(skeleton == null) {
		throw haxe_Exception.thrown("skeleton cannot be null.");
	}
	this._data = data;
	this.rotateMix = data.rotateMix;
	this.translateMix = data.translateMix;
	this.scaleMix = data.scaleMix;
	this.shearMix = data.shearMix;
	this._bones = [];
	var _g = 0;
	var _g1 = data._bones;
	while(_g < _g1.length) {
		var boneData = _g1[_g];
		++_g;
		this._bones.push(skeleton.findBone(boneData._name));
	}
	this.target = skeleton.findBone(data.target._name);
};
spine_TransformConstraint.__name__ = true;
spine_TransformConstraint.__super__ = spine_Constraint;
spine_TransformConstraint.prototype = $extend(spine_Constraint.prototype,{
	apply: function() {
		this.update();
	}
	,update: function() {
		var rotateMix = this.rotateMix;
		var translateMix = this.translateMix;
		var scaleMix = this.scaleMix;
		var shearMix = this.shearMix;
		var target = this.target;
		var ta = target._a;
		var tb = target._b;
		var tc = target._c;
		var td = target._d;
		var degRadReflect = ta * td - tb * tc > 0 ? spine_MathUtils.degRad : -spine_MathUtils.degRad;
		var offsetRotation = this._data.offsetRotation * degRadReflect;
		var offsetShearY = this._data.offsetShearY * degRadReflect;
		var bones = this._bones;
		var _g = 0;
		var _g1 = bones.length;
		while(_g < _g1) {
			var i = _g++;
			var bone = bones[i];
			var modified = false;
			if(rotateMix != 0) {
				var a = bone._a;
				var b = bone._b;
				var c = bone._c;
				var d = bone._d;
				var r = Math.atan2(tc,ta) - Math.atan2(c,a) + offsetRotation;
				if(r > Math.PI) {
					r -= Math.PI * 2;
				} else if(r < -Math.PI) {
					r += Math.PI * 2;
				}
				r *= rotateMix;
				var cos = Math.cos(r);
				var sin = Math.sin(r);
				bone._a = cos * a - sin * c;
				bone._b = cos * b - sin * d;
				bone._c = sin * a + cos * c;
				bone._d = sin * b + cos * d;
				modified = true;
			}
			if(translateMix != 0) {
				this._temp[0] = this._data.offsetX;
				this._temp[1] = this._data.offsetY;
				target.localToWorld(this._temp);
				bone._worldX += (this._temp[0] - bone._worldX) * translateMix;
				bone._worldY += (this._temp[1] - bone._worldY) * translateMix;
				modified = true;
			}
			if(scaleMix > 0) {
				var s = Math.sqrt(bone._a * bone._a + bone._c * bone._c);
				var ts = Math.sqrt(ta * ta + tc * tc);
				if(s > 0.00001) {
					s = (s + (ts - s + this._data.offsetScaleX) * scaleMix) / s;
				}
				bone._a *= s;
				bone._c *= s;
				s = Math.sqrt(bone._b * bone._b + bone._d * bone._d);
				ts = Math.sqrt(tb * tb + td * td);
				if(s > 0.00001) {
					s = (s + (ts - s + this._data.offsetScaleY) * scaleMix) / s;
				}
				bone._b *= s;
				bone._d *= s;
				modified = true;
			}
			if(shearMix > 0) {
				var b1 = bone._b;
				var d1 = bone._d;
				var by = Math.atan2(d1,b1);
				var r1 = Math.atan2(td,tb) - Math.atan2(tc,ta) - (by - Math.atan2(bone._c,bone._a));
				if(r1 > Math.PI) {
					r1 -= Math.PI * 2;
				} else if(r1 < -Math.PI) {
					r1 += Math.PI * 2;
				}
				r1 = by + (r1 + offsetShearY) * shearMix;
				var s1 = Math.sqrt(b1 * b1 + d1 * d1);
				bone._b = Math.cos(r1) * s1;
				bone._d = Math.sin(r1) * s1;
				modified = true;
			}
			if(modified) {
				bone.appliedValid = false;
			}
		}
	}
	,getOrder: function() {
		return this._data.order;
	}
	,toString: function() {
		return this._data._name;
	}
	,get_data: function() {
		return this._data;
	}
	,get_bones: function() {
		return this._bones;
	}
	,__class__: spine_TransformConstraint
	,__properties__: {get_bones:"get_bones",get_data:"get_data"}
});
var spine_TransformConstraintData = function(name) {
	this._bones = [];
	if(name == null) {
		throw haxe_Exception.thrown("name cannot be null.");
	}
	this._name = name;
};
spine_TransformConstraintData.__name__ = true;
spine_TransformConstraintData.prototype = {
	toString: function() {
		return this._name;
	}
	,get_name: function() {
		return this._name;
	}
	,get_bones: function() {
		return this._bones;
	}
	,__class__: spine_TransformConstraintData
	,__properties__: {get_bones:"get_bones",get_name:"get_name"}
};
var spine_animation_Animation = function(name,timelines,duration) {
	if(name == null) {
		throw haxe_Exception.thrown("name cannot be null.");
	}
	if(timelines == null) {
		throw haxe_Exception.thrown("timelines cannot be null.");
	}
	this.name = name;
	this._timelines = timelines;
	this.duration = duration;
};
spine_animation_Animation.__name__ = true;
spine_animation_Animation.binarySearch = function(values,target,step) {
	var low = 0;
	var high = Math.floor(values.length / step - 2);
	if(high == 0) {
		return step;
	}
	var current = high >>> 1;
	while(true) {
		if(values[(current + 1) * step] <= target) {
			low = current + 1;
		} else {
			high = current;
		}
		if(low == high) {
			return (low + 1) * step;
		}
		current = low + high >>> 1;
	}
};
spine_animation_Animation.binarySearch1 = function(values,target) {
	var low = 0;
	var high = values.length - 2;
	if(high == 0) {
		return 1;
	}
	var current = high >>> 1;
	while(true) {
		if(values[current + 1] <= target) {
			low = current + 1;
		} else {
			high = current;
		}
		if(low == high) {
			return low + 1;
		}
		current = low + high >>> 1;
	}
};
spine_animation_Animation.linearSearch = function(values,target,step) {
	var i = 0;
	var last = values.length - step;
	while(i <= last) {
		if(values[i] > target) {
			return i;
		}
		i += step;
	}
	return -1;
};
spine_animation_Animation.prototype = {
	apply: function(skeleton,lastTime,time,loop,events,alpha,setupPose,mixingOut) {
		if(skeleton == null) {
			throw haxe_Exception.thrown("skeleton cannot be null.");
		}
		if(loop && this.duration != 0) {
			time %= this.duration;
			if(lastTime > 0) {
				lastTime %= this.duration;
			}
		}
		var _g = 0;
		var _g1 = this._timelines.length;
		while(_g < _g1) {
			var i = _g++;
			this._timelines[i].apply(skeleton,lastTime,time,events,alpha,setupPose,mixingOut);
		}
	}
	,toString: function() {
		return this.name;
	}
	,get_timelines: function() {
		return this._timelines;
	}
	,__class__: spine_animation_Animation
	,__properties__: {get_timelines:"get_timelines"}
};
var spine_animation_Timeline = function() {
};
spine_animation_Timeline.__name__ = true;
spine_animation_Timeline.prototype = {
	apply: function(skeleton,lastTime,time,firedEvents,alpha,setupPose,mixingOut) {
	}
	,getPropertyId: function() {
		return -1;
	}
	,__class__: spine_animation_Timeline
};
var spine_animation_AttachmentTimeline = function(frameCount) {
	spine_animation_Timeline.call(this);
	this.frames = [];
	this.attachmentNames = [];
	this.type = 4;
};
spine_animation_AttachmentTimeline.__name__ = true;
spine_animation_AttachmentTimeline.__super__ = spine_animation_Timeline;
spine_animation_AttachmentTimeline.prototype = $extend(spine_animation_Timeline.prototype,{
	getPropertyId: function() {
		var value = 4;
		return (value << 24) + this.slotIndex;
	}
	,setFrame: function(frameIndex,time,attachmentName) {
		this.frames[frameIndex] = time;
		this.attachmentNames[frameIndex] = attachmentName;
	}
	,apply: function(skeleton,lastTime,time,firedEvents,alpha,setupPose,mixingOut) {
		var attachmentName;
		var slot = skeleton.slots[this.slotIndex];
		if(mixingOut && setupPose) {
			attachmentName = slot._data.attachmentName;
			var attachment = attachmentName == null ? null : skeleton.getAttachmentForSlotIndex(this.slotIndex,attachmentName);
			if(slot._attachment != attachment) {
				slot._attachment = attachment;
				slot._attachmentTime = slot._bone._skeleton.time;
				slot.attachmentVerticesLength = 0;
			}
			return;
		}
		if(time < this.frames[0]) {
			if(setupPose) {
				attachmentName = slot._data.attachmentName;
				var attachment = attachmentName == null ? null : skeleton.getAttachmentForSlotIndex(this.slotIndex,attachmentName);
				if(slot._attachment != attachment) {
					slot._attachment = attachment;
					slot._attachmentTime = slot._bone._skeleton.time;
					slot.attachmentVerticesLength = 0;
				}
			}
			return;
		}
		var frameIndex;
		if(time >= this.frames[this.frames.length - 1]) {
			frameIndex = this.frames.length - 1;
		} else {
			frameIndex = spine_animation_Animation.binarySearch(this.frames,time,1) - 1;
		}
		attachmentName = this.attachmentNames[frameIndex];
		var _this = skeleton.slots[this.slotIndex];
		var attachment = attachmentName == null ? null : skeleton.getAttachmentForSlotIndex(this.slotIndex,attachmentName);
		if(_this._attachment != attachment) {
			_this._attachment = attachment;
			_this._attachmentTime = _this._bone._skeleton.time;
			_this.attachmentVerticesLength = 0;
		}
	}
	,get_frameCount: function() {
		return this.frames.length;
	}
	,__class__: spine_animation_AttachmentTimeline
	,__properties__: {get_frameCount:"get_frameCount"}
});
var spine_animation_CurveTimeline = function(frameCount) {
	spine_animation_Timeline.call(this);
	var n = (frameCount - 1) * spine_animation_CurveTimeline.BEZIER_SIZE;
	var this1 = new Array(n);
	var v = this1;
	var _g = 0;
	var _g1 = n;
	while(_g < _g1) {
		var i = _g++;
		v[i] = 0;
	}
	this.curves = v;
	this.type = 14;
};
spine_animation_CurveTimeline.__name__ = true;
spine_animation_CurveTimeline.__super__ = spine_animation_Timeline;
spine_animation_CurveTimeline.prototype = $extend(spine_animation_Timeline.prototype,{
	getPropertyId: function() {
		return 0;
	}
	,apply: function(skeleton,lastTime,time,firedEvents,alpha,setupPose,mixingOut) {
	}
	,get_frameCount: function() {
		return Math.floor(this.curves.length / spine_animation_CurveTimeline.BEZIER_SIZE + 1);
	}
	,setLinear: function(frameIndex) {
		this.curves[frameIndex * spine_animation_CurveTimeline.BEZIER_SIZE] = 0;
	}
	,setStepped: function(frameIndex) {
		this.curves[frameIndex * spine_animation_CurveTimeline.BEZIER_SIZE] = 1;
	}
	,setCurve: function(frameIndex,cx1,cy1,cx2,cy2) {
		var tmpx = (-cx1 * 2 + cx2) * 0.03;
		var tmpy = (-cy1 * 2 + cy2) * 0.03;
		var dddfx = ((cx1 - cx2) * 3 + 1) * 0.006;
		var dddfy = ((cy1 - cy2) * 3 + 1) * 0.006;
		var ddfx = tmpx * 2 + dddfx;
		var ddfy = tmpy * 2 + dddfy;
		var dfx = cx1 * 0.3 + tmpx + dddfx * 0.16666667;
		var dfy = cy1 * 0.3 + tmpy + dddfy * 0.16666667;
		var i = frameIndex * spine_animation_CurveTimeline.BEZIER_SIZE;
		this.curves[i++] = 2;
		var x = dfx;
		var y = dfy;
		var n = i + spine_animation_CurveTimeline.BEZIER_SIZE - 1;
		while(i < n) {
			this.curves[i] = x;
			this.curves[i + 1] = y;
			dfx += ddfx;
			dfy += ddfy;
			ddfx += dddfx;
			ddfy += dddfy;
			x += dfx;
			y += dfy;
			i += 2;
		}
	}
	,getCurvePercent: function(frameIndex,percent) {
		percent = spine_MathUtils.clamp(percent,0,1);
		var i = frameIndex * spine_animation_CurveTimeline.BEZIER_SIZE;
		var type = this.curves[i];
		if(type == 0) {
			return percent;
		}
		if(type == 1) {
			return 0;
		}
		++i;
		var x = 0;
		var start = i;
		var n = i + spine_animation_CurveTimeline.BEZIER_SIZE - 1;
		while(i < n) {
			x = this.curves[i];
			if(x >= percent) {
				var prevX;
				var prevY;
				if(i == start) {
					prevX = 0;
					prevY = 0;
				} else {
					prevX = this.curves[i - 2];
					prevY = this.curves[i - 1];
				}
				return prevY + (this.curves[i + 1] - prevY) * (percent - prevX) / (x - prevX);
			}
			i += 2;
		}
		var y = this.curves[i - 1];
		return y + (1 - y) * (percent - x) / (1 - x);
	}
	,__class__: spine_animation_CurveTimeline
	,__properties__: {get_frameCount:"get_frameCount"}
});
var spine_animation_ColorTimeline = function(frameCount) {
	spine_animation_CurveTimeline.call(this,frameCount);
	this.frames = [];
	this.type = 5;
};
spine_animation_ColorTimeline.__name__ = true;
spine_animation_ColorTimeline.__super__ = spine_animation_CurveTimeline;
spine_animation_ColorTimeline.prototype = $extend(spine_animation_CurveTimeline.prototype,{
	getPropertyId: function() {
		var value = 5;
		return (value << 24) + this.slotIndex;
	}
	,setFrame: function(frameIndex,time,r,g,b,a) {
		frameIndex *= 5;
		this.frames[frameIndex] = time;
		this.frames[frameIndex + 1] = r;
		this.frames[frameIndex + 2] = g;
		this.frames[frameIndex + 3] = b;
		this.frames[frameIndex + 4] = a;
	}
	,apply: function(skeleton,lastTime,time,firedEvents,alpha,setupPose,mixingOut) {
		var slot = skeleton.slots[this.slotIndex];
		if(time < this.frames[0]) {
			if(setupPose) {
				slot.r = slot._data.r;
				slot.g = slot._data.g;
				slot.b = slot._data.b;
				slot.a = slot._data.a;
			}
			return;
		}
		var r;
		var g;
		var b;
		var a;
		if(time >= this.frames[this.frames.length - 5]) {
			var i = this.frames.length;
			r = this.frames[i + (-4)];
			g = this.frames[i + (-3)];
			b = this.frames[i + (-2)];
			a = this.frames[i + (-1)];
		} else {
			var frame = spine_animation_Animation.binarySearch(this.frames,time,5);
			r = this.frames[frame + (-4)];
			g = this.frames[frame + (-3)];
			b = this.frames[frame + (-2)];
			a = this.frames[frame + (-1)];
			var frameTime = this.frames[frame];
			var percent = this.getCurvePercent(Math.floor(frame / 5 - 1),1 - (time - frameTime) / (this.frames[frame + (-5)] - frameTime));
			r += (this.frames[frame + 1] - r) * percent;
			g += (this.frames[frame + 2] - g) * percent;
			b += (this.frames[frame + 3] - b) * percent;
			a += (this.frames[frame + 4] - a) * percent;
		}
		if(alpha == 1) {
			slot.r = r;
			slot.g = g;
			slot.b = b;
			slot.a = a;
		} else {
			if(setupPose) {
				slot.r = slot._data.r;
				slot.g = slot._data.g;
				slot.b = slot._data.b;
				slot.a = slot._data.a;
			}
			slot.r += (r - slot.r) * alpha;
			slot.g += (g - slot.g) * alpha;
			slot.b += (b - slot.b) * alpha;
			slot.a += (a - slot.a) * alpha;
		}
	}
	,__class__: spine_animation_ColorTimeline
});
var spine_animation_DeformTimeline = function(frameCount) {
	spine_animation_CurveTimeline.call(this,frameCount);
	var this1 = new Array(frameCount);
	var v = this1;
	var _g = 0;
	var _g1 = frameCount;
	while(_g < _g1) {
		var i = _g++;
		v[i] = 0;
	}
	this.frames = v;
	var this1 = new Array(frameCount);
	this.frameVertices = this1;
	this.type = 6;
};
spine_animation_DeformTimeline.__name__ = true;
spine_animation_DeformTimeline.__super__ = spine_animation_CurveTimeline;
spine_animation_DeformTimeline.prototype = $extend(spine_animation_CurveTimeline.prototype,{
	getPropertyId: function() {
		var value = 6;
		return (value << 24) + this.slotIndex;
	}
	,setFrame: function(frameIndex,time,vertices) {
		this.frames[frameIndex] = time;
		this.frameVertices[frameIndex] = vertices;
	}
	,apply: function(skeleton,lastTime,time,firedEvents,alpha,setupPose,mixingOut) {
		var slot = skeleton.slots[this.slotIndex];
		var slotAttachment = slot._attachment;
		var tmp;
		if(slotAttachment != null) {
			var type = slotAttachment.type;
			tmp = !(type == 2 || type == 1 || type == 4);
		} else {
			tmp = true;
		}
		if(tmp || js_Boot.__cast(slotAttachment , spine_attachments_VertexAttachment) != this.attachment) {
			return;
		}
		var verticesArray = slot.attachmentVertices;
		if(time < this.frames[0]) {
			if(setupPose) {
				slot.attachmentVerticesLength = 0;
			}
			return;
		}
		var vertexCount = this.frameVertices[0].length;
		if(slot.attachmentVerticesLength != vertexCount) {
			alpha = 1;
		}
		slot.attachmentVerticesLength = vertexCount;
		var vertices = verticesArray;
		var i;
		var n;
		var vertexAttachment;
		var setupVertices;
		var setup;
		var prev;
		if(time >= this.frames[this.frames.length - 1]) {
			var lastVertices = this.frameVertices[this.frames.length - 1];
			if(alpha == 1) {
				var _g = 0;
				var _g1 = vertexCount;
				while(_g < _g1) {
					var i = _g++;
					vertices[i] = lastVertices[i];
				}
			} else if(setupPose) {
				vertexAttachment = slotAttachment;
				if(vertexAttachment.bones == null) {
					setupVertices = vertexAttachment.vertices;
					var _g = 0;
					var _g1 = vertexCount;
					while(_g < _g1) {
						var i = _g++;
						setup = setupVertices[i];
						vertices[i] = setup + (lastVertices[i] - setup) * alpha;
					}
				} else {
					var _g = 0;
					var _g1 = vertexCount;
					while(_g < _g1) {
						var i = _g++;
						vertices[i] = lastVertices[i] * alpha;
					}
				}
			} else {
				var _g = 0;
				var _g1 = vertexCount;
				while(_g < _g1) {
					var i = _g++;
					vertices[i] += (lastVertices[i] - vertices[i]) * alpha;
				}
			}
			return;
		}
		var frame = spine_animation_Animation.binarySearch1(this.frames,time);
		var prevVertices = this.frameVertices[frame - 1];
		var nextVertices = this.frameVertices[frame];
		var frameTime = this.frames[frame];
		var percent = this.getCurvePercent(frame - 1,1 - (time - frameTime) / (this.frames[frame - 1] - frameTime));
		if(alpha == 1) {
			var _g = 0;
			var _g1 = vertexCount;
			while(_g < _g1) {
				var i = _g++;
				prev = prevVertices[i];
				vertices[i] = prev + (nextVertices[i] - prev) * percent;
			}
		} else if(setupPose) {
			vertexAttachment = slotAttachment;
			if(vertexAttachment.bones == null) {
				setupVertices = vertexAttachment.vertices;
				var _g = 0;
				var _g1 = vertexCount;
				while(_g < _g1) {
					var i = _g++;
					prev = prevVertices[i];
					setup = setupVertices[i];
					vertices[i] = setup + (prev + (nextVertices[i] - prev) * percent - setup) * alpha;
				}
			} else {
				var _g = 0;
				var _g1 = vertexCount;
				while(_g < _g1) {
					var i = _g++;
					prev = prevVertices[i];
					vertices[i] = (prev + (nextVertices[i] - prev) * percent) * alpha;
				}
			}
		} else {
			var _g = 0;
			var _g1 = vertexCount;
			while(_g < _g1) {
				var i = _g++;
				prev = prevVertices[i];
				vertices[i] += (prev + (nextVertices[i] - prev) * percent - vertices[i]) * alpha;
			}
		}
	}
	,__class__: spine_animation_DeformTimeline
});
var spine_animation_DrawOrderTimeline = function(frameCount) {
	spine_animation_Timeline.call(this);
	var this1 = new Array(frameCount);
	var v = this1;
	var _g = 0;
	var _g1 = frameCount;
	while(_g < _g1) {
		var i = _g++;
		v[i] = 0;
	}
	this.frames = v;
	var this1 = new Array(frameCount);
	this.drawOrders = this1;
	this.type = 8;
};
spine_animation_DrawOrderTimeline.__name__ = true;
spine_animation_DrawOrderTimeline.__super__ = spine_animation_Timeline;
spine_animation_DrawOrderTimeline.prototype = $extend(spine_animation_Timeline.prototype,{
	getPropertyId: function() {
		var value = 8;
		return value << 24;
	}
	,setFrame: function(frameIndex,time,drawOrder) {
		this.frames[frameIndex] = time;
		this.drawOrders[frameIndex] = drawOrder;
	}
	,apply: function(skeleton,lastTime,time,firedEvents,alpha,setupPose,mixingOut) {
		if(mixingOut && setupPose) {
			var _g = 0;
			var _g1 = skeleton.slots.length;
			while(_g < _g1) {
				var ii = _g++;
				skeleton.drawOrder[ii] = skeleton.slots[ii];
			}
			return;
		}
		var drawOrder = skeleton.drawOrder;
		var slots = skeleton.slots;
		var slot;
		var i = 0;
		if(time < this.frames[0]) {
			if(setupPose) {
				var _g = 0;
				while(_g < slots.length) {
					var slot = slots[_g];
					++_g;
					drawOrder[i++] = slot;
				}
			}
			return;
		}
		var frameIndex;
		if(time >= this.frames[this.frames.length - 1]) {
			frameIndex = this.frames.length - 1;
		} else {
			frameIndex = spine_animation_Animation.binarySearch1(this.frames,time) - 1;
		}
		var drawOrderToSetupIndex = this.drawOrders[frameIndex];
		i = 0;
		if(drawOrderToSetupIndex == null) {
			var _g = 0;
			while(_g < slots.length) {
				var slot = slots[_g];
				++_g;
				drawOrder[i++] = slot;
			}
		} else {
			var _g = 0;
			while(_g < drawOrderToSetupIndex.length) {
				var setupIndex = drawOrderToSetupIndex[_g];
				++_g;
				drawOrder[i++] = slots[setupIndex];
			}
		}
	}
	,get_frameCount: function() {
		return this.frames.length;
	}
	,__class__: spine_animation_DrawOrderTimeline
	,__properties__: {get_frameCount:"get_frameCount"}
});
var spine_animation_EventTimeline = function(frameCount) {
	spine_animation_Timeline.call(this);
	var this1 = new Array(frameCount);
	var v = this1;
	var _g = 0;
	var _g1 = frameCount;
	while(_g < _g1) {
		var i = _g++;
		v[i] = 0;
	}
	this.frames = v;
	var this1 = new Array(frameCount);
	this.events = this1;
	this.type = 7;
};
spine_animation_EventTimeline.__name__ = true;
spine_animation_EventTimeline.__super__ = spine_animation_Timeline;
spine_animation_EventTimeline.prototype = $extend(spine_animation_Timeline.prototype,{
	getPropertyId: function() {
		var value = 7;
		return value << 24;
	}
	,setFrame: function(frameIndex,event) {
		this.frames[frameIndex] = event.time;
		this.events[frameIndex] = event;
	}
	,apply: function(skeleton,lastTime,time,firedEvents,alpha,setupPose,mixingOut) {
		if(firedEvents == null) {
			return;
		}
		if(lastTime > time) {
			this.apply(skeleton,lastTime,Math.floor(UInt.toFloat(js_Boot.__cast(-1 , Int)) / UInt.toFloat(2)),firedEvents,alpha,setupPose,mixingOut);
			lastTime = -1;
		} else if(lastTime >= this.frames[this.frames.length - 1]) {
			return;
		}
		if(time < this.frames[0]) {
			return;
		}
		var frame;
		if(lastTime < this.frames[0]) {
			frame = 0;
		} else {
			frame = spine_animation_Animation.binarySearch1(this.frames,lastTime);
			var frameTime = this.frames[frame];
			while(frame > 0) {
				if(this.frames[frame - 1] != frameTime) {
					break;
				}
				--frame;
			}
		}
		while(frame < this.frames.length && time >= this.frames[frame]) {
			firedEvents[firedEvents.length] = this.events[frame];
			++frame;
		}
	}
	,get_frameCount: function() {
		return this.frames.length;
	}
	,__class__: spine_animation_EventTimeline
	,__properties__: {get_frameCount:"get_frameCount"}
});
var spine_animation_IkConstraintTimeline = function(frameCount) {
	spine_animation_CurveTimeline.call(this,frameCount);
	this.frames = [];
	this.type = 9;
};
spine_animation_IkConstraintTimeline.__name__ = true;
spine_animation_IkConstraintTimeline.__super__ = spine_animation_CurveTimeline;
spine_animation_IkConstraintTimeline.prototype = $extend(spine_animation_CurveTimeline.prototype,{
	getPropertyId: function() {
		var value = 9;
		return (value << 24) + this.ikConstraintIndex;
	}
	,setFrame: function(frameIndex,time,mix,bendDirection) {
		frameIndex *= 3;
		this.frames[frameIndex] = time;
		this.frames[frameIndex + 1] = mix;
		this.frames[frameIndex + 2] = bendDirection;
	}
	,apply: function(skeleton,lastTime,time,firedEvents,alpha,setupPose,mixingOut) {
		var constraint = skeleton.ikConstraints[this.ikConstraintIndex];
		if(time < this.frames[0]) {
			if(setupPose) {
				constraint.mix = constraint._data.mix;
				constraint.bendDirection = constraint._data.bendDirection;
			}
			return;
		}
		if(time >= this.frames[this.frames.length - 3]) {
			if(setupPose) {
				constraint.mix = constraint._data.mix + (this.frames[this.frames.length + (-2)] - constraint._data.mix) * alpha;
				constraint.bendDirection = mixingOut ? constraint._data.bendDirection : Math.floor(this.frames[this.frames.length + (-1)]);
			} else {
				constraint.mix += (this.frames[this.frames.length + (-2)] - constraint.mix) * alpha;
				if(!mixingOut) {
					constraint.bendDirection = Math.floor(this.frames[this.frames.length + (-1)]);
				}
			}
			return;
		}
		var frame = spine_animation_Animation.binarySearch(this.frames,time,3);
		var mix = this.frames[frame + (-2)];
		var frameTime = this.frames[frame];
		var percent = this.getCurvePercent(Math.floor(frame / 3 - 1),1 - (time - frameTime) / (this.frames[frame + (-3)] - frameTime));
		if(setupPose) {
			constraint.mix = constraint._data.mix + (mix + (this.frames[frame + 1] - mix) * percent - constraint._data.mix) * alpha;
			constraint.bendDirection = mixingOut ? constraint._data.bendDirection : Math.floor(this.frames[frame + (-1)]);
		} else {
			constraint.mix += (mix + (this.frames[frame + 1] - mix) * percent - constraint.mix) * alpha;
			if(!mixingOut) {
				constraint.bendDirection = Math.floor(this.frames[frame + (-1)]);
			}
		}
	}
	,__class__: spine_animation_IkConstraintTimeline
});
var spine_animation_PathConstraintMixTimeline = function(frameCount) {
	spine_animation_CurveTimeline.call(this,frameCount);
	this.frames = [];
	this.type = 13;
};
spine_animation_PathConstraintMixTimeline.__name__ = true;
spine_animation_PathConstraintMixTimeline.__super__ = spine_animation_CurveTimeline;
spine_animation_PathConstraintMixTimeline.prototype = $extend(spine_animation_CurveTimeline.prototype,{
	getPropertyId: function() {
		var value = 13;
		return (value << 24) + this.pathConstraintIndex;
	}
	,setFrame: function(frameIndex,time,rotateMix,translateMix) {
		frameIndex *= 3;
		this.frames[frameIndex] = time;
		this.frames[frameIndex + 1] = rotateMix;
		this.frames[frameIndex + 2] = translateMix;
	}
	,apply: function(skeleton,lastTime,time,firedEvents,alpha,setupPose,mixingOut) {
		var constraint = skeleton.pathConstraints[this.pathConstraintIndex];
		if(time < this.frames[0]) {
			if(setupPose) {
				constraint.rotateMix = constraint._data.rotateMix;
				constraint.translateMix = constraint._data.translateMix;
			}
			return;
		}
		var rotate;
		var translate;
		if(time >= this.frames[this.frames.length - 3]) {
			rotate = this.frames[this.frames.length + (-2)];
			translate = this.frames[this.frames.length + (-1)];
		} else {
			var frame = spine_animation_Animation.binarySearch(this.frames,time,3);
			rotate = this.frames[frame + (-2)];
			translate = this.frames[frame + (-1)];
			var frameTime = this.frames[frame];
			var percent = this.getCurvePercent(Math.floor(frame / 3) - 1,1 - (time - frameTime) / (this.frames[frame + (-3)] - frameTime));
			rotate += (this.frames[frame + 1] - rotate) * percent;
			translate += (this.frames[frame + 2] - translate) * percent;
		}
		if(setupPose) {
			constraint.rotateMix = constraint._data.rotateMix + (rotate - constraint._data.rotateMix) * alpha;
			constraint.translateMix = constraint._data.translateMix + (translate - constraint._data.translateMix) * alpha;
		} else {
			constraint.rotateMix += (rotate - constraint.rotateMix) * alpha;
			constraint.translateMix += (translate - constraint.translateMix) * alpha;
		}
	}
	,__class__: spine_animation_PathConstraintMixTimeline
});
var spine_animation_PathConstraintPositionTimeline = function(frameCount) {
	spine_animation_CurveTimeline.call(this,frameCount);
	this.frames = [];
	this.type = 11;
};
spine_animation_PathConstraintPositionTimeline.__name__ = true;
spine_animation_PathConstraintPositionTimeline.__super__ = spine_animation_CurveTimeline;
spine_animation_PathConstraintPositionTimeline.prototype = $extend(spine_animation_CurveTimeline.prototype,{
	getPropertyId: function() {
		var value = 11;
		return (value << 24) + this.pathConstraintIndex;
	}
	,setFrame: function(frameIndex,time,value) {
		frameIndex *= 2;
		this.frames[frameIndex] = time;
		this.frames[frameIndex + 1] = value;
	}
	,apply: function(skeleton,lastTime,time,firedEvents,alpha,setupPose,mixingOut) {
		var constraint = skeleton.pathConstraints[this.pathConstraintIndex];
		if(time < this.frames[0]) {
			if(setupPose) {
				constraint.position = constraint._data.position;
			}
			return;
		}
		var position;
		if(time >= this.frames[this.frames.length - 2]) {
			position = this.frames[this.frames.length + (-1)];
		} else {
			var frame = spine_animation_Animation.binarySearch(this.frames,time,2);
			position = this.frames[frame + (-1)];
			var frameTime = this.frames[frame];
			var percent = this.getCurvePercent(Math.floor(frame / 2) - 1,1 - (time - frameTime) / (this.frames[frame + (-2)] - frameTime));
			position += (this.frames[frame + 1] - position) * percent;
		}
		if(setupPose) {
			constraint.position = constraint._data.position + (position - constraint._data.position) * alpha;
		} else {
			constraint.position += (position - constraint.position) * alpha;
		}
	}
	,__class__: spine_animation_PathConstraintPositionTimeline
});
var spine_animation_PathConstraintSpacingTimeline = function(frameCount) {
	spine_animation_PathConstraintPositionTimeline.call(this,frameCount);
	this.type = 12;
};
spine_animation_PathConstraintSpacingTimeline.__name__ = true;
spine_animation_PathConstraintSpacingTimeline.__super__ = spine_animation_PathConstraintPositionTimeline;
spine_animation_PathConstraintSpacingTimeline.prototype = $extend(spine_animation_PathConstraintPositionTimeline.prototype,{
	getPropertyId: function() {
		var value = 12;
		return (value << 24) + this.pathConstraintIndex;
	}
	,apply: function(skeleton,lastTime,time,firedEvents,alpha,setupPose,mixingOut) {
		var constraint = skeleton.pathConstraints[this.pathConstraintIndex];
		if(time < this.frames[0]) {
			if(setupPose) {
				constraint.spacing = constraint._data.spacing;
			}
			return;
		}
		var spacing;
		if(time >= this.frames[this.frames.length - 2]) {
			spacing = this.frames[this.frames.length + (-1)];
		} else {
			var frame = spine_animation_Animation.binarySearch(this.frames,time,2);
			spacing = this.frames[frame + (-1)];
			var frameTime = this.frames[frame];
			var percent = this.getCurvePercent(Math.floor(frame / 2) - 1,1 - (time - frameTime) / (this.frames[frame + (-2)] - frameTime));
			spacing += (this.frames[frame + 1] - spacing) * percent;
		}
		if(setupPose) {
			constraint.spacing = constraint._data.spacing + (spacing - constraint._data.spacing) * alpha;
		} else {
			constraint.spacing += (spacing - constraint.spacing) * alpha;
		}
	}
	,__class__: spine_animation_PathConstraintSpacingTimeline
});
var spine_animation_RotateTimeline = function(frameCount) {
	spine_animation_CurveTimeline.call(this,frameCount);
	this.frames = [];
	this.type = 0;
};
spine_animation_RotateTimeline.__name__ = true;
spine_animation_RotateTimeline.__super__ = spine_animation_CurveTimeline;
spine_animation_RotateTimeline.prototype = $extend(spine_animation_CurveTimeline.prototype,{
	getPropertyId: function() {
		var value = 0;
		return (value << 24) + this.boneIndex;
	}
	,setFrame: function(frameIndex,time,degrees) {
		frameIndex <<= 1;
		this.frames[frameIndex] = time;
		this.frames[frameIndex + 1] = degrees;
	}
	,apply: function(skeleton,lastTime,time,firedEvents,alpha,setupPose,mixingOut) {
		var bone = skeleton.bones[this.boneIndex];
		var r;
		if(time < this.frames[0]) {
			if(setupPose) {
				bone.rotation = bone._data.rotation;
			}
			return;
		}
		if(time >= this.frames[this.frames.length - 2]) {
			if(setupPose) {
				bone.rotation = bone._data.rotation + this.frames[this.frames.length + (-1)] * alpha;
			} else {
				r = bone._data.rotation + this.frames[this.frames.length + (-1)] - bone.rotation;
				r -= (16384 - Math.floor(16384.499999999996 - r / 360)) * 360;
				bone.rotation += r * alpha;
			}
			return;
		}
		var frame = spine_animation_Animation.binarySearch(this.frames,time,2);
		var prevRotation = this.frames[frame + (-1)];
		var frameTime = this.frames[frame];
		var percent = this.getCurvePercent((frame >> 1) - 1,1 - (time - frameTime) / (this.frames[frame + (-2)] - frameTime));
		r = this.frames[frame + 1] - prevRotation;
		r -= (16384 - Math.floor(16384.499999999996 - r / 360)) * 360;
		r = prevRotation + r * percent;
		if(setupPose) {
			r -= (16384 - Math.floor(16384.499999999996 - r / 360)) * 360;
			bone.rotation = bone._data.rotation + r * alpha;
		} else {
			r = bone._data.rotation + r - bone.rotation;
			r -= (16384 - Math.floor(16384.499999999996 - r / 360)) * 360;
			bone.rotation += r * alpha;
		}
	}
	,__class__: spine_animation_RotateTimeline
});
var spine_animation_TranslateTimeline = function(frameCount) {
	spine_animation_CurveTimeline.call(this,frameCount);
	this.frames = [];
	this.type = 1;
};
spine_animation_TranslateTimeline.__name__ = true;
spine_animation_TranslateTimeline.__super__ = spine_animation_CurveTimeline;
spine_animation_TranslateTimeline.prototype = $extend(spine_animation_CurveTimeline.prototype,{
	getPropertyId: function() {
		var value = 1;
		return (value << 24) + this.boneIndex;
	}
	,setFrame: function(frameIndex,time,x,y) {
		frameIndex *= 3;
		this.frames[frameIndex] = time;
		this.frames[frameIndex + 1] = x;
		this.frames[frameIndex + 2] = y;
	}
	,apply: function(skeleton,lastTime,time,firedEvents,alpha,setupPose,mixingOut) {
		var bone = skeleton.bones[this.boneIndex];
		if(time < this.frames[0]) {
			if(setupPose) {
				bone.x = bone._data.x;
				bone.y = bone._data.y;
			}
			return;
		}
		var x;
		var y;
		if(time >= this.frames[this.frames.length - 3]) {
			x = this.frames[this.frames.length + (-2)];
			y = this.frames[this.frames.length + (-1)];
		} else {
			var frame = spine_animation_Animation.binarySearch(this.frames,time,3);
			x = this.frames[frame + (-2)];
			y = this.frames[frame + (-1)];
			var frameTime = this.frames[frame];
			var percent = this.getCurvePercent(Math.floor(frame / 3) - 1,1 - (time - frameTime) / (this.frames[frame + (-3)] - frameTime));
			x += (this.frames[frame + 1] - x) * percent;
			y += (this.frames[frame + 2] - y) * percent;
		}
		if(setupPose) {
			bone.x = bone._data.x + x * alpha;
			bone.y = bone._data.y + y * alpha;
		} else {
			bone.x += (bone._data.x + x - bone.x) * alpha;
			bone.y += (bone._data.y + y - bone.y) * alpha;
		}
	}
	,__class__: spine_animation_TranslateTimeline
});
var spine_animation_ScaleTimeline = function(frameCount) {
	spine_animation_TranslateTimeline.call(this,frameCount);
	this.type = 2;
};
spine_animation_ScaleTimeline.__name__ = true;
spine_animation_ScaleTimeline.__super__ = spine_animation_TranslateTimeline;
spine_animation_ScaleTimeline.prototype = $extend(spine_animation_TranslateTimeline.prototype,{
	getPropertyId: function() {
		var value = 2;
		return (value << 24) + this.boneIndex;
	}
	,apply: function(skeleton,lastTime,time,firedEvents,alpha,setupPose,mixingOut) {
		var bone = skeleton.bones[this.boneIndex];
		if(time < this.frames[0]) {
			if(setupPose) {
				bone.scaleX = bone._data.scaleX;
				bone.scaleY = bone._data.scaleY;
			}
			return;
		}
		var x;
		var y;
		if(time >= this.frames[this.frames.length - 3]) {
			x = this.frames[this.frames.length + (-2)] * bone._data.scaleX;
			y = this.frames[this.frames.length + (-1)] * bone._data.scaleY;
		} else {
			var frame = spine_animation_Animation.binarySearch(this.frames,time,3);
			x = this.frames[frame + (-2)];
			y = this.frames[frame + (-1)];
			var frameTime = this.frames[frame];
			var percent = this.getCurvePercent(Math.floor(frame / 3) - 1,1 - (time - frameTime) / (this.frames[frame + (-3)] - frameTime));
			x = (x + (this.frames[frame + 1] - x) * percent) * bone._data.scaleX;
			y = (y + (this.frames[frame + 2] - y) * percent) * bone._data.scaleY;
		}
		if(alpha == 1) {
			bone.scaleX = x;
			bone.scaleY = y;
		} else {
			var bx;
			var by;
			if(setupPose) {
				bx = bone._data.scaleX;
				by = bone._data.scaleY;
			} else {
				bx = bone.scaleX;
				by = bone.scaleY;
			}
			if(mixingOut) {
				x = Math.abs(x) * (bx > 0 ? 1 : bx < 0 ? -1 : 0);
				y = Math.abs(y) * (by > 0 ? 1 : by < 0 ? -1 : 0);
			} else {
				bx = Math.abs(bx) * (x > 0 ? 1 : x < 0 ? -1 : 0);
				by = Math.abs(by) * (y > 0 ? 1 : y < 0 ? -1 : 0);
			}
			bone.scaleX = bx + (x - bx) * alpha;
			bone.scaleY = by + (y - by) * alpha;
		}
	}
	,__class__: spine_animation_ScaleTimeline
});
var spine_animation_ShearTimeline = function(frameCount) {
	spine_animation_TranslateTimeline.call(this,frameCount);
	this.type = 3;
};
spine_animation_ShearTimeline.__name__ = true;
spine_animation_ShearTimeline.__super__ = spine_animation_TranslateTimeline;
spine_animation_ShearTimeline.prototype = $extend(spine_animation_TranslateTimeline.prototype,{
	getPropertyId: function() {
		var value = 3;
		return (value << 24) + this.boneIndex;
	}
	,apply: function(skeleton,lastTime,time,firedEvents,alpha,setupPose,mixingOut) {
		var bone = skeleton.bones[this.boneIndex];
		if(time < this.frames[0]) {
			if(setupPose) {
				bone.shearX = bone._data.shearX;
				bone.shearY = bone._data.shearY;
			}
			return;
		}
		var x;
		var y;
		if(time >= this.frames[this.frames.length - 3]) {
			x = this.frames[this.frames.length + (-2)];
			y = this.frames[this.frames.length + (-1)];
		} else {
			var frame = spine_animation_Animation.binarySearch(this.frames,time,3);
			x = this.frames[frame + (-2)];
			y = this.frames[frame + (-1)];
			var frameTime = this.frames[frame];
			var percent = this.getCurvePercent(Math.floor(frame / 3) - 1,1 - (time - frameTime) / (this.frames[frame + (-3)] - frameTime));
			x += (this.frames[frame + 1] - x) * percent;
			y += (this.frames[frame + 2] - y) * percent;
		}
		if(setupPose) {
			bone.shearX = bone._data.shearX + x * alpha;
			bone.shearY = bone._data.shearY + y * alpha;
		} else {
			bone.shearX += (bone._data.shearX + x - bone.shearX) * alpha;
			bone.shearY += (bone._data.shearY + y - bone.shearY) * alpha;
		}
	}
	,__class__: spine_animation_ShearTimeline
});
var spine_animation_TransformConstraintTimeline = function(frameCount) {
	spine_animation_CurveTimeline.call(this,frameCount);
	this.frames = [];
	this.type = 10;
};
spine_animation_TransformConstraintTimeline.__name__ = true;
spine_animation_TransformConstraintTimeline.__super__ = spine_animation_CurveTimeline;
spine_animation_TransformConstraintTimeline.prototype = $extend(spine_animation_CurveTimeline.prototype,{
	getPropertyId: function() {
		var value = 10;
		return (value << 24) + this.transformConstraintIndex;
	}
	,setFrame: function(frameIndex,time,rotateMix,translateMix,scaleMix,shearMix) {
		frameIndex *= 5;
		this.frames[frameIndex] = time;
		this.frames[frameIndex + 1] = rotateMix;
		this.frames[frameIndex + 2] = translateMix;
		this.frames[frameIndex + 3] = scaleMix;
		this.frames[frameIndex + 4] = shearMix;
	}
	,apply: function(skeleton,lastTime,time,firedEvents,alpha,setupPose,mixingOut) {
		var constraint = skeleton.transformConstraints[this.transformConstraintIndex];
		var data;
		if(time < this.frames[0]) {
			if(setupPose) {
				data = constraint._data;
				constraint.rotateMix = constraint._data.rotateMix;
				constraint.translateMix = constraint._data.translateMix;
				constraint.scaleMix = constraint._data.scaleMix;
				constraint.shearMix = constraint._data.shearMix;
			}
			return;
		}
		var rotate;
		var translate;
		var scale;
		var shear;
		if(time >= this.frames[this.frames.length - 5]) {
			var i = this.frames.length;
			rotate = this.frames[i + (-4)];
			translate = this.frames[i + (-3)];
			scale = this.frames[i + (-2)];
			shear = this.frames[i + (-1)];
		} else {
			var frame = spine_animation_Animation.binarySearch(this.frames,time,5);
			rotate = this.frames[frame + (-4)];
			translate = this.frames[frame + (-3)];
			scale = this.frames[frame + (-2)];
			shear = this.frames[frame + (-1)];
			var frameTime = this.frames[frame];
			var percent = this.getCurvePercent(Math.floor(frame / 5) - 1,1 - (time - frameTime) / (this.frames[frame + (-5)] - frameTime));
			rotate += (this.frames[frame + 1] - rotate) * percent;
			translate += (this.frames[frame + 2] - translate) * percent;
			scale += (this.frames[frame + 3] - scale) * percent;
			shear += (this.frames[frame + 4] - shear) * percent;
		}
		if(setupPose) {
			data = constraint._data;
			constraint.rotateMix = data.rotateMix + (rotate - data.rotateMix) * alpha;
			constraint.translateMix = data.translateMix + (translate - data.translateMix) * alpha;
			constraint.scaleMix = data.scaleMix + (scale - data.scaleMix) * alpha;
			constraint.shearMix = data.shearMix + (shear - data.shearMix) * alpha;
		} else {
			constraint.rotateMix += (rotate - constraint.rotateMix) * alpha;
			constraint.translateMix += (translate - constraint.translateMix) * alpha;
			constraint.scaleMix += (scale - constraint.scaleMix) * alpha;
			constraint.shearMix += (shear - constraint.shearMix) * alpha;
		}
	}
	,__class__: spine_animation_TransformConstraintTimeline
});
var spine_attachments_Attachment = function(name) {
	if(name == null) {
		throw haxe_Exception.thrown("name cannot be null.");
	}
	this._name = name;
};
spine_attachments_Attachment.__name__ = true;
spine_attachments_Attachment.prototype = {
	toString: function() {
		return this._name;
	}
	,get_name: function() {
		return this._name;
	}
	,__class__: spine_attachments_Attachment
	,__properties__: {get_name:"get_name"}
};
var spine_attachments_AttachmentLoader = function() { };
spine_attachments_AttachmentLoader.__name__ = true;
spine_attachments_AttachmentLoader.__isInterface__ = true;
spine_attachments_AttachmentLoader.prototype = {
	__class__: spine_attachments_AttachmentLoader
};
var spine_attachments_VertexAttachment = function(name) {
	spine_attachments_Attachment.call(this,name);
};
spine_attachments_VertexAttachment.__name__ = true;
spine_attachments_VertexAttachment.isVertexAttachment = function(attachment) {
	var type = attachment.type;
	if(!(type == 2 || type == 1)) {
		return type == 4;
	} else {
		return true;
	}
};
spine_attachments_VertexAttachment.__super__ = spine_attachments_Attachment;
spine_attachments_VertexAttachment.prototype = $extend(spine_attachments_Attachment.prototype,{
	computeWorldVertices: function(slot,worldVertices) {
		this.computeWorldVertices2(slot,0,this.worldVerticesLength,worldVertices,0);
	}
	,computeWorldVertices2: function(slot,start,count,worldVertices,offset) {
		count += offset;
		var skeleton = slot._bone._skeleton;
		var deformArray = slot.attachmentVertices;
		var bones = this.bones;
		var deform;
		var v;
		var w;
		var n;
		var b;
		var f;
		var vx;
		var vy;
		var wx;
		var wy;
		var bone;
		if(bones == null) {
			bone = slot._bone;
			var x = bone._worldX;
			var y = bone._worldY;
			var a = bone._a;
			var bb = bone._b;
			var c = bone._c;
			var d = bone._d;
			v = start;
			w = offset;
			if(slot.attachmentVerticesLength > 0) {
				while(w < count) {
					vx = deformArray[v];
					vy = deformArray[v + 1];
					worldVertices[w] = vx * a + vy * bb + x;
					worldVertices[w + 1] = vx * c + vy * d + y;
					v += 2;
					w += 2;
				}
			} else {
				while(w < count) {
					vx = this.vertices[v];
					vy = this.vertices[v + 1];
					worldVertices[w] = vx * a + vy * bb + x;
					worldVertices[w + 1] = vx * c + vy * d + y;
					v += 2;
					w += 2;
				}
			}
			return;
		}
		v = 0;
		var skip = 0;
		var i = 0;
		while(i < start) {
			n = bones[v];
			v += n + 1;
			skip += n;
			i += 2;
		}
		var skeletonBones = skeleton.bones;
		if(slot.attachmentVerticesLength == 0) {
			w = offset;
			b = skip * 3;
			while(w < count) {
				wx = 0;
				wy = 0;
				n = bones[v++];
				n += v;
				while(v < n) {
					bone = skeletonBones[bones[v]];
					vx = this.vertices[b];
					vy = this.vertices[b + 1];
					var weight = this.vertices[b + 2];
					wx += (vx * bone._a + vy * bone._b + bone._worldX) * weight;
					wy += (vx * bone._c + vy * bone._d + bone._worldY) * weight;
					++v;
					b += 3;
				}
				worldVertices[w] = wx;
				worldVertices[w + 1] = wy;
				w += 2;
			}
		} else {
			deform = deformArray;
			w = offset;
			b = skip * 3;
			f = skip << 1;
			while(w < count) {
				wx = 0;
				wy = 0;
				n = bones[v++];
				n += v;
				while(v < n) {
					bone = skeletonBones[bones[v]];
					vx = this.vertices[b] + deform[f];
					vy = this.vertices[b + 1] + deform[f + 1];
					var weight = this.vertices[b + 2];
					wx += (vx * bone._a + vy * bone._b + bone._worldX) * weight;
					wy += (vx * bone._c + vy * bone._d + bone._worldY) * weight;
					++v;
					b += 3;
					f += 2;
				}
				worldVertices[w] = wx;
				worldVertices[w + 1] = wy;
				w += 2;
			}
		}
	}
	,applyDeform: function(sourceAttachment) {
		return this == sourceAttachment;
	}
	,__class__: spine_attachments_VertexAttachment
});
var spine_attachments_BoundingBoxAttachment = function(name) {
	spine_attachments_VertexAttachment.call(this,name);
	this.type = 1;
};
spine_attachments_BoundingBoxAttachment.__name__ = true;
spine_attachments_BoundingBoxAttachment.__super__ = spine_attachments_VertexAttachment;
spine_attachments_BoundingBoxAttachment.prototype = $extend(spine_attachments_VertexAttachment.prototype,{
	__class__: spine_attachments_BoundingBoxAttachment
});
var spine_attachments_EmptyAttachmentLoader = function() {
};
spine_attachments_EmptyAttachmentLoader.__name__ = true;
spine_attachments_EmptyAttachmentLoader.__interfaces__ = [spine_attachments_AttachmentLoader];
spine_attachments_EmptyAttachmentLoader.prototype = {
	newRegionAttachment: function(skin,name,path) {
		var attachment = new spine_attachments_RegionAttachment(name);
		return attachment;
	}
	,newMeshAttachment: function(skin,name,path) {
		var attachment = new spine_attachments_MeshAttachment(name);
		return attachment;
	}
	,newBoundingBoxAttachment: function(skin,name) {
		return new spine_attachments_BoundingBoxAttachment(name);
	}
	,newPathAttachment: function(skin,name) {
		return new spine_attachments_PathAttachment(name);
	}
	,__class__: spine_attachments_EmptyAttachmentLoader
};
var spine_attachments_MeshAttachment = function(name) {
	this.a = 1;
	this.b = 1;
	this.g = 1;
	this.r = 1;
	spine_attachments_VertexAttachment.call(this,name);
	this.type = 2;
};
spine_attachments_MeshAttachment.__name__ = true;
spine_attachments_MeshAttachment.__super__ = spine_attachments_VertexAttachment;
spine_attachments_MeshAttachment.prototype = $extend(spine_attachments_VertexAttachment.prototype,{
	updateUVs: function() {
		var width = this.regionU2 - this.regionU;
		var height = this.regionV2 - this.regionV;
		var n = this.regionUVs.length;
		if(this.uvs == null || this.uvs.length != n) {
			var this1 = new Array(n);
			var v = this1;
			var _g = 0;
			var _g1 = n;
			while(_g < _g1) {
				var i = _g++;
				v[i] = 0;
			}
			this.uvs = v;
		}
		if(this.regionRotate) {
			var i = 0;
			while(i < n) {
				this.uvs[i] = this.regionU + this.regionUVs[i + 1] * width;
				this.uvs[i + 1] = this.regionV + height - this.regionUVs[i] * height;
				i += 2;
			}
		} else {
			var i = 0;
			while(i < n) {
				this.uvs[i] = this.regionU + this.regionUVs[i] * width;
				this.uvs[i + 1] = this.regionV + this.regionUVs[i + 1] * height;
				i += 2;
			}
		}
	}
	,applyFFD: function(sourceAttachment) {
		if(this != sourceAttachment) {
			if(this.inheritDeform) {
				return this._parentMesh == sourceAttachment;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
	,get_parentMesh: function() {
		return this._parentMesh;
	}
	,set_parentMesh: function(parentMesh) {
		this._parentMesh = parentMesh;
		if(parentMesh != null) {
			this.bones = parentMesh.bones;
			this.vertices = parentMesh.vertices;
			this.worldVerticesLength = parentMesh.worldVerticesLength;
			this.regionUVs = parentMesh.regionUVs;
			this.triangles = parentMesh.triangles;
			this.hullLength = parentMesh.hullLength;
			this.edges = parentMesh.edges;
			this.width = parentMesh.width;
			this.height = parentMesh.height;
		}
		return parentMesh;
	}
	,__class__: spine_attachments_MeshAttachment
	,__properties__: $extend(spine_attachments_VertexAttachment.prototype.__properties__,{set_parentMesh:"set_parentMesh",get_parentMesh:"get_parentMesh"})
});
var spine_attachments_PathAttachment = function(name) {
	spine_attachments_VertexAttachment.call(this,name);
	this.type = 4;
};
spine_attachments_PathAttachment.__name__ = true;
spine_attachments_PathAttachment.__super__ = spine_attachments_VertexAttachment;
spine_attachments_PathAttachment.prototype = $extend(spine_attachments_VertexAttachment.prototype,{
	__class__: spine_attachments_PathAttachment
});
var spine_attachments_RegionAttachment = function(name) {
	this.uvs = [];
	this.offset = [];
	this.a = 1;
	this.b = 1;
	this.g = 1;
	this.r = 1;
	this.scaleY = 1;
	this.scaleX = 1;
	this.Y4 = 7;
	this.X4 = 6;
	this.Y3 = 5;
	this.X3 = 4;
	this.Y2 = 3;
	this.X2 = 2;
	this.Y1 = 1;
	this.X1 = 0;
	spine_attachments_Attachment.call(this,name);
	this.type = 0;
};
spine_attachments_RegionAttachment.__name__ = true;
spine_attachments_RegionAttachment.__super__ = spine_attachments_Attachment;
spine_attachments_RegionAttachment.prototype = $extend(spine_attachments_Attachment.prototype,{
	setUVs: function(u,v,u2,v2,rotate) {
		if(rotate) {
			this.uvs[this.X2] = u;
			this.uvs[this.Y2] = v2;
			this.uvs[this.X3] = u;
			this.uvs[this.Y3] = v;
			this.uvs[this.X4] = u2;
			this.uvs[this.Y4] = v;
			this.uvs[this.X1] = u2;
			this.uvs[this.Y1] = v2;
		} else {
			this.uvs[this.X1] = u;
			this.uvs[this.Y1] = v2;
			this.uvs[this.X2] = u;
			this.uvs[this.Y2] = v;
			this.uvs[this.X3] = u2;
			this.uvs[this.Y3] = v;
			this.uvs[this.X4] = u2;
			this.uvs[this.Y4] = v2;
		}
	}
	,updateOffset: function() {
		var regionScaleX = this.width / this.regionOriginalWidth * this.scaleX;
		var regionScaleY = this.height / this.regionOriginalHeight * this.scaleY;
		var localX = -this.width / 2 * this.scaleX + this.regionOffsetX * regionScaleX;
		var localY = -this.height / 2 * this.scaleY + this.regionOffsetY * regionScaleY;
		var localX2 = localX + this.regionWidth * regionScaleX;
		var localY2 = localY + this.regionHeight * regionScaleY;
		var radians = this.rotation * Math.PI / 180;
		var cos = Math.cos(radians);
		var sin = Math.sin(radians);
		var localXCos = localX * cos + this.x;
		var localXSin = localX * sin;
		var localYCos = localY * cos + this.y;
		var localYSin = localY * sin;
		var localX2Cos = localX2 * cos + this.x;
		var localX2Sin = localX2 * sin;
		var localY2Cos = localY2 * cos + this.y;
		var localY2Sin = localY2 * sin;
		this.offset[this.X1] = localXCos - localYSin;
		this.offset[this.Y1] = localYCos + localXSin;
		this.offset[this.X2] = localXCos - localY2Sin;
		this.offset[this.Y2] = localY2Cos + localXSin;
		this.offset[this.X3] = localX2Cos - localY2Sin;
		this.offset[this.Y3] = localY2Cos + localX2Sin;
		this.offset[this.X4] = localX2Cos - localYSin;
		this.offset[this.Y4] = localYCos + localX2Sin;
	}
	,computeWorldVertices: function(x,y,bone,worldVertices) {
		x += bone._worldX;
		y += bone._worldY;
		var m00 = bone._a;
		var m01 = bone._b;
		var m10 = bone._c;
		var m11 = bone._d;
		var x1 = this.offset[this.X1];
		var y1 = this.offset[this.Y1];
		var x2 = this.offset[this.X2];
		var y2 = this.offset[this.Y2];
		var x3 = this.offset[this.X3];
		var y3 = this.offset[this.Y3];
		var x4 = this.offset[this.X4];
		var y4 = this.offset[this.Y4];
		worldVertices[this.X1] = x1 * m00 + y1 * m01 + x;
		worldVertices[this.Y1] = x1 * m10 + y1 * m11 + y;
		worldVertices[this.X2] = x2 * m00 + y2 * m01 + x;
		worldVertices[this.Y2] = x2 * m10 + y2 * m11 + y;
		worldVertices[this.X3] = x3 * m00 + y3 * m01 + x;
		worldVertices[this.Y3] = x3 * m10 + y3 * m11 + y;
		worldVertices[this.X4] = x4 * m00 + y4 * m01 + x;
		worldVertices[this.Y4] = x4 * m10 + y4 * m11 + y;
	}
	,__class__: spine_attachments_RegionAttachment
});
var utils_AnimationDataGenerator = function() { };
utils_AnimationDataGenerator.__name__ = true;
utils_AnimationDataGenerator.getAnimationDataString = function(category,object) {
	return JSON.stringify(utils_AnimationDataGenerator.getAnimationData(category,object));
};
utils_AnimationDataGenerator.getAnimationData = function(category,object) {
	var config = null;
	switch(category) {
	case "ACHIEVEMENT_HOUSE":
		config = utils_AnimationDataGenerator.createAchievementHouse(object);
		break;
	case "ANIMAL":
		config = utils_AnimationDataGenerator.createAnimal(object);
		break;
	case "COMMON_BUILDING":case "HOUSE":case "ZEPPELIN":
		if(com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged("go_camp",object)) {
			config = utils_AnimationDataGenerator.createCamp(object);
		} else if(com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged("go_daily_quest",object)) {
			config = utils_AnimationDataGenerator.createDailyQuestBuilding(object);
		} else {
			config = utils_AnimationDataGenerator.createBuilding(category,object);
		}
		break;
	case "DECOR":
		config = utils_AnimationDataGenerator.createDecor(object);
		break;
	case "DIRIGIBLE":
		config = utils_AnimationDataGenerator.createDirigible(object);
		break;
	case "EVENT_STARTER":
		config = utils_AnimationDataGenerator.createEventStarter(object);
		break;
	case "FARM_CELL":
		config = utils_AnimationDataGenerator.createFarmCell(object);
		break;
	case "FLYING_CAT":
		config = utils_AnimationDataGenerator.createFlyingCat(object);
		break;
	case "GARBAGE":
		config = utils_AnimationDataGenerator.createGarbage(object);
		break;
	case "LAIR":
		config = utils_AnimationDataGenerator.createLair(object);
		break;
	case "LANDSCAPE":
		config = utils_AnimationDataGenerator.createLandscape(object);
		break;
	case "LIVE_DECOR":
		config = utils_AnimationDataGenerator.createLiveDecor(object);
		break;
	case "MARKET":
		config = utils_AnimationDataGenerator.createMarket(object);
		break;
	case "NUT":
		config = utils_AnimationDataGenerator.createNut(object);
		break;
	case "ORDERS_HOST":
		config = utils_AnimationDataGenerator.createOrdersHost(object);
		break;
	case "PASTURE":
		config = utils_AnimationDataGenerator.createPasture(object);
		break;
	case "PLANT":
		config = utils_AnimationDataGenerator.createPlant(object);
		break;
	case "SHMU":
		config = utils_AnimationDataGenerator.createShmoo(object);
		break;
	case "STORAGE_COMMON":
		config = utils_AnimationDataGenerator.createStorage(object);
		break;
	case "FENCE":case "ROAD":case "SHOP_KEEPER":case "STUFF":
		break;
	case "TALKING_HEAD":
		config = utils_AnimationDataGenerator.createTalkingHead(object);
		break;
	case "TREE":
		config = utils_AnimationDataGenerator.createTree(object);
		break;
	default:
	}
	if(config == null) {
		var animData = [];
		var format = 1;
		var hasVBB = true;
		var hasTBB = true;
		var useFallback = false;
		return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
	}
	var _g = 0;
	var _g1 = config.animationData;
	while(_g < _g1.length) {
		var anim = _g1[_g];
		++_g;
		anim.animationName = anim.animationName.toUpperCase();
		if(anim.fallbackAnimationName != null) {
			anim.fallbackAnimationName = anim.fallbackAnimationName.toUpperCase();
		}
	}
	return config;
};
utils_AnimationDataGenerator.createEventStarter = function(object) {
	var animData = [];
	var format = 3;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	animData.push({ skeletonName : "r1", animationName : "repair", resolverName : "repair"});
	animData.push({ skeletonName : "r1", animationName : "repair", resolverName : "ruins"});
	var maxLevel = utils_AnimationDataGenerator.getInitialLevel(object) + 1;
	if(object != null && object.workComponent != null && object.workComponent.upgradeActions.length > 0) {
		maxLevel += object.workComponent.upgradeActions.length;
	}
	var _g = 0;
	var _g1 = maxLevel;
	while(_g < _g1) {
		var i = _g++;
		var l = i + 1;
		animData.push({ skeletonName : "idle" + l, animationName : "idle", resolverName : "level_" + l});
		animData.push({ skeletonName : "stage" + l, animationName : "tap_idle", resolverName : "tap_" + l, fallbackSkeletonName : "idle" + l, fallbackAnimationName : "idle"});
		animData.push({ skeletonName : "stage" + l, animationName : "production", resolverName : "working_" + l});
		animData.push({ skeletonName : "stage" + l, animationName : "tap_production", resolverName : "tap_working_" + l});
	}
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createOrdersHost = function(object) {
	var animData = [];
	var format = 3;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	if(object.workComponent != null) {
		if(object.workComponent.repairAction != null) {
			animData.push({ skeletonName : "r1", animationName : "repair", resolverName : "repair"});
			animData.push({ skeletonName : "r1", animationName : "repair", resolverName : "ruins"});
		}
	}
	animData.push({ skeletonName : "r1", animationName : "repair", resolverName : "repair"});
	animData.push({ skeletonName : "idle1", animationName : "idle", resolverName : "level_1"});
	animData.push({ skeletonName : "stage1", animationName : "tap_idle", resolverName : "tap1", fallbackSkeletonName : "idle1", fallbackAnimationName : "idle"});
	animData.push({ skeletonName : "stage1", animationName : "production", resolverName : "working_1"});
	animData.push({ skeletonName : "stage1", animationName : "tap_production", resolverName : "tap_working_1"});
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createDailyQuestBuilding = function(object) {
	var animData = [];
	var format = 3;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	var levels = utils_AnimationDataGenerator.getLevels(object);
	var maxLevel = levels.length;
	animData.push({ skeletonName : "r1", animationName : "repair", resolverName : "repair"});
	animData.push({ skeletonName : "r1", animationName : "repair", resolverName : "ruins"});
	var _g = 0;
	var _g1 = maxLevel;
	while(_g < _g1) {
		var i = _g++;
		var l = i + 1;
		animData.push({ skeletonName : "idle" + l, animationName : "idle", resolverName : "level_" + l});
	}
	var numStages = 3;
	var _g = 0;
	var _g1 = numStages;
	while(_g < _g1) {
		var i = _g++;
		var l = i + 1;
		animData.push({ skeletonName : "stage" + l, animationName : "production", resolverName : "production_" + l});
		animData.push({ skeletonName : "stage" + l, animationName : "ready_to_collect", resolverName : "ready_to_collect_" + l});
		animData.push({ skeletonName : "stage" + l, animationName : "tap_production", resolverName : "tap_production_" + l});
		animData.push({ skeletonName : "stage" + l, animationName : "tap_ready_to_collect", resolverName : "tap_ready_to_collect_" + l});
	}
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createCamp = function(object) {
	var animData = [];
	var format = 3;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	var requiredSlots = [];
	animData.push({ skeletonName : "r1", animationName : "repair", resolverName : "repair"});
	animData.push({ skeletonName : "r1", animationName : "repair", resolverName : "ruins"});
	animData.push({ skeletonName : "idle1", animationName : "idle", resolverName : "camp_empty"});
	animData.push({ skeletonName : "stage1", animationName : "production", resolverName : "first_shmu_ready"});
	animData.push({ skeletonName : "stage1", animationName : "tap_production", resolverName : "first_shmu_ready_tap"});
	animData.push({ skeletonName : "stage2", animationName : "production", resolverName : "second_shmu_ready"});
	animData.push({ skeletonName : "stage2", animationName : "tap_production", resolverName : "second_shmu_ready_tap"});
	animData.push({ skeletonName : "stage3", animationName : "production", resolverName : "exploring"});
	animData.push({ skeletonName : "stage3", animationName : "tap_production", resolverName : "exploring_tap"});
	animData.push({ skeletonName : "stage4", animationName : "production", resolverName : "finished"});
	animData.push({ skeletonName : "stage4", animationName : "tap_production", resolverName : "finished_tap"});
	requiredSlots.push({ skeletonName : "idle1", requiredSlotNames : utils_AnimationDataGenerator.getOpeningComponentSlots()});
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback, requiredSlots : requiredSlots};
};
utils_AnimationDataGenerator.createFarmCell = function(object) {
	var animData = [];
	var format = 3;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	if(object.workComponent != null) {
		if(object.workComponent.repairAction != null) {
			animData.push({ skeletonName : "r1", animationName : "repair", resolverName : "repair"});
			animData.push({ skeletonName : "r1", animationName : "repair", resolverName : "ruins"});
		}
	}
	animData.push({ skeletonName : "idle1", animationName : "idle", resolverName : "level_1"});
	animData.push({ skeletonName : "idle1", animationName : "tap", resolverName : "demo_idle_1"});
	animData.push({ skeletonName : "idle1", animationName : "tap", resolverName : "demo_working_1"});
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createLair = function(object) {
	var animData = [];
	var format = 1;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	animData.push({ skeletonName : "idle0", animationName : "idle"});
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createDecor = function(object) {
	var animData = [];
	var format = 3;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	animData.push({ skeletonName : "idle1", animationName : "tap", resolverName : "demo_idle_"});
	animData.push({ skeletonName : "idle1", animationName : "idle", resolverName : "idle"});
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createLiveDecor = function(object) {
	var animData = [];
	var format = 2;
	if(object.id == 648) {
		format = 1;
	}
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	var skeletonName = "stage1";
	var animations = ["idle","walk","tap"];
	var _g = 0;
	var _g1 = animations.length;
	while(_g < _g1) {
		var i = _g++;
		animData.push({ skeletonName : skeletonName, animationName : animations[i]});
	}
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createStorage = function(object) {
	var animData = [];
	var format = 3;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	var requiredSlots = [];
	var levels = utils_AnimationDataGenerator.getLevels(object);
	var maxLevel = levels.length;
	var maxAnimations = 5;
	var _g = 0;
	var _g1 = maxLevel;
	while(_g < _g1) {
		var i = _g++;
		var l = i + 1;
		var _g2 = 0;
		var _g3 = maxAnimations;
		while(_g2 < _g3) {
			var j = _g2++;
			var a = j + 1;
			animData.push({ skeletonName : "idle" + l, animationName : "IDLE" + a, resolverName : "level_" + l + "_" + a});
		}
		requiredSlots.push({ skeletonName : "idle" + l, requiredSlotNames : utils_AnimationDataGenerator.getOpeningComponentSlots()});
	}
	animData.push({ skeletonName : "r1", animationName : "repair", resolverName : "repair"});
	animData.push({ skeletonName : "r1", animationName : "repair", resolverName : "ruins"});
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback, requiredSlots : requiredSlots};
};
utils_AnimationDataGenerator.createAchievementHouse = function(object) {
	var animData = [];
	var format = 3;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	animData.push({ skeletonName : "stage1", animationName : "production", resolverName : "inactivity1"});
	animData.push({ skeletonName : "stage1", animationName : "tap_production", resolverName : "demo_idle_1"});
	animData.push({ skeletonName : "stage1", animationName : "tap_idle", resolverName : "demo_idle_2"});
	animData.push({ skeletonName : "idle1", animationName : "idle", resolverName : "level_1"});
	animData.push({ skeletonName : "r1", animationName : "repair", resolverName : "ruins"});
	animData.push({ skeletonName : "r1", animationName : "tap_repair", resolverName : "repair"});
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createMarket = function(object) {
	var animData = [];
	var format = 3;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	animData.push({ skeletonName : "stage1", animationName : "production", resolverName : "inactivity1"});
	animData.push({ skeletonName : "stage1", animationName : "tap_production", resolverName : "demo_idle_1"});
	animData.push({ skeletonName : "idle1", animationName : "idle", resolverName : "level_1"});
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createPasture = function(object) {
	var animData = [];
	var format = 3;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	var requiredSlots = [];
	var levels = utils_AnimationDataGenerator.getLevels(object);
	var maxLevel = levels.length;
	animData.push({ skeletonName : "b1", animationName : "building", resolverName : "building_1"});
	animData.push({ skeletonName : "b2", animationName : "building", resolverName : "building_2"});
	var _g = 0;
	var _g1 = maxLevel;
	while(_g < _g1) {
		var i = _g++;
		var level = i + 1;
		animData.push({ skeletonName : "idle" + level, animationName : "idle", resolverName : "level_" + level});
		requiredSlots.push({ skeletonName : "idle" + level, requiredSlotNames : utils_AnimationDataGenerator.getOpeningComponentSlots()});
		if(level < maxLevel) {
			requiredSlots.push({ skeletonName : "idle" + level, requiredSlotNames : utils_AnimationDataGenerator.getUpgradeIndicationSlots()});
		}
	}
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback, requiredSlots : requiredSlots};
};
utils_AnimationDataGenerator.createAnimal = function(object) {
	var animData = [];
	var format = 2;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	var skeletonName = "stage1";
	var animations = ["feeding","idle","starvation","starvation_idle","stuffed","tap","walk"];
	var _g = 0;
	var _g1 = animations.length;
	while(_g < _g1) {
		var i = _g++;
		animData.push({ skeletonName : skeletonName, animationName : animations[i]});
	}
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createPlant = function(object) {
	var animData = [];
	var format = 1;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	animData.push({ skeletonName : "idle0", animationName : "stage" + 1});
	animData.push({ skeletonName : "idle0", animationName : "stage" + 2});
	animData.push({ skeletonName : "idle0", animationName : "stage" + 3});
	animData.push({ skeletonName : "idle0", animationName : "stage" + 4});
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createFlyingCat = function(object) {
	var animData = [];
	var format = 4;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	animData.push({ skeletonName : "cat_front", animationName : "empty", resolverName : "flight_empty"});
	animData.push({ skeletonName : "cat_front", animationName : "full", resolverName : "flight_full"});
	animData.push({ skeletonName : "idle1", animationName : "idle", resolverName : "landed"});
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createDirigible = function(object) {
	var animData = [];
	var format = 2;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	animData.push({ skeletonName : "stage1", animationName : "flight"});
	animData.push({ skeletonName : "stage1", animationName : "landed"});
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createShmoo = function(object) {
	var animData = [];
	var format = 4;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	animData.push({ skeletonName : "walk_side_down", animationName : "stage1", resolverName : "walk0"});
	animData.push({ skeletonName : "walk_front", animationName : "stage1", resolverName : "walk45"});
	animData.push({ skeletonName : "walk_side_down", animationName : "stage1", resolverName : "walk90"});
	animData.push({ skeletonName : "walk_side", animationName : "stage1", resolverName : "walk135"});
	animData.push({ skeletonName : "walk_side_up", animationName : "stage1", resolverName : "walk180"});
	animData.push({ skeletonName : "walk_back", animationName : "stage1", resolverName : "walk225"});
	animData.push({ skeletonName : "walk_side_up", animationName : "stage1", resolverName : "walk270"});
	animData.push({ skeletonName : "walk_side", animationName : "stage1", resolverName : "walk315"});
	animData.push({ skeletonName : "idle_side_down", animationName : "stage1", resolverName : "idle0"});
	animData.push({ skeletonName : "idle_front", animationName : "stage1", resolverName : "idle45"});
	animData.push({ skeletonName : "idle_side_down", animationName : "stage1", resolverName : "idle90"});
	animData.push({ skeletonName : "idle_side", animationName : "stage1", resolverName : "idle135"});
	animData.push({ skeletonName : "idle_side_up", animationName : "stage1", resolverName : "idle180"});
	animData.push({ skeletonName : "idle_back", animationName : "stage1", resolverName : "idle225"});
	animData.push({ skeletonName : "idle_side_up", animationName : "stage1", resolverName : "idle270"});
	animData.push({ skeletonName : "idle_side", animationName : "stage1", resolverName : "idle315"});
	animData.push({ skeletonName : "idle_side_down", animationName : "stage1", resolverName : "idle_b0"});
	animData.push({ skeletonName : "idle_front", animationName : "stage1", resolverName : "idle_b45"});
	animData.push({ skeletonName : "idle_side_down", animationName : "stage1", resolverName : "idle_b90"});
	animData.push({ skeletonName : "idle_side", animationName : "stage1", resolverName : "idle_b135"});
	animData.push({ skeletonName : "idle_side_up", animationName : "stage1", resolverName : "idle_b180"});
	animData.push({ skeletonName : "idle_back", animationName : "stage1", resolverName : "idle_b225"});
	animData.push({ skeletonName : "idle_side_up", animationName : "stage1", resolverName : "idle_b270"});
	animData.push({ skeletonName : "idle_side", animationName : "stage1", resolverName : "idle_b315"});
	animData.push({ skeletonName : "idle_dialog1_side_down", animationName : "stage1", resolverName : "idle_dialog1_0"});
	animData.push({ skeletonName : "idle_dialog1_side_down", animationName : "stage1", resolverName : "idle_dialog1_90"});
	animData.push({ skeletonName : "idle_dialog1_side", animationName : "stage1", resolverName : "idle_dialog1_135"});
	animData.push({ skeletonName : "idle_dialog1_side_up", animationName : "stage1", resolverName : "idle_dialog1_180"});
	animData.push({ skeletonName : "idle_dialog1_side_up", animationName : "stage1", resolverName : "idle_dialog1_270"});
	animData.push({ skeletonName : "idle_dialog1_side", animationName : "stage1", resolverName : "idle_dialog1_315"});
	animData.push({ skeletonName : "idle_dialog2_side_down", animationName : "stage1", resolverName : "idle_dialog2_0"});
	animData.push({ skeletonName : "idle_dialog2_side_down", animationName : "stage1", resolverName : "idle_dialog2_90"});
	animData.push({ skeletonName : "idle_dialog2_side", animationName : "stage1", resolverName : "idle_dialog2_135"});
	animData.push({ skeletonName : "idle_dialog2_side_up", animationName : "stage1", resolverName : "idle_dialog2_180"});
	animData.push({ skeletonName : "idle_dialog2_side_up", animationName : "stage1", resolverName : "idle_dialog2_270"});
	animData.push({ skeletonName : "idle_dialog2_side", animationName : "stage1", resolverName : "idle_dialog2_315"});
	animData.push({ skeletonName : "idle_dialog3_side_down", animationName : "stage1", resolverName : "idle_dialog3_0"});
	animData.push({ skeletonName : "idle_dialog3_side_down", animationName : "stage1", resolverName : "idle_dialog3_90"});
	animData.push({ skeletonName : "idle_dialog3_side", animationName : "stage1", resolverName : "idle_dialog3_135"});
	animData.push({ skeletonName : "idle_dialog3_side_up", animationName : "stage1", resolverName : "idle_dialog3_180"});
	animData.push({ skeletonName : "idle_dialog3_side_up", animationName : "stage1", resolverName : "idle_dialog3_270"});
	animData.push({ skeletonName : "idle_dialog3_side", animationName : "stage1", resolverName : "idle_dialog3_315"});
	animData.push({ skeletonName : "run_side_down", animationName : "stage1", resolverName : "run0"});
	animData.push({ skeletonName : "run_front", animationName : "stage1", resolverName : "run45"});
	animData.push({ skeletonName : "run_side_down", animationName : "stage1", resolverName : "run90"});
	animData.push({ skeletonName : "run_side", animationName : "stage1", resolverName : "run135"});
	animData.push({ skeletonName : "run_side_up", animationName : "stage1", resolverName : "run180"});
	animData.push({ skeletonName : "run_back", animationName : "stage1", resolverName : "run225"});
	animData.push({ skeletonName : "run_side_up", animationName : "stage1", resolverName : "run270"});
	animData.push({ skeletonName : "run_side", animationName : "stage1", resolverName : "run315"});
	animData.push({ skeletonName : "chopping_side", animationName : "stage1", resolverName : "chopping135"});
	animData.push({ skeletonName : "chopping_side", animationName : "stage1", resolverName : "chopping315"});
	animData.push({ skeletonName : "cleaning_side_down", animationName : "stage1", resolverName : "cleaning135"});
	animData.push({ skeletonName : "cleaning_side_down", animationName : "stage1", resolverName : "cleaning315"});
	animData.push({ skeletonName : "construction_side", animationName : "stage1", resolverName : "construction135"});
	animData.push({ skeletonName : "construction_back", animationName : "stage1", resolverName : "construction225"});
	animData.push({ skeletonName : "construction_side", animationName : "stage1", resolverName : "construction315"});
	animData.push({ skeletonName : "tap1_front", animationName : "stage1", resolverName : "tap1_45"});
	animData.push({ skeletonName : "tap2_front", animationName : "stage1", resolverName : "tap2_45"});
	animData.push({ skeletonName : "tap3_front", animationName : "stage1", resolverName : "tap3_45"});
	animData.push({ skeletonName : "tap4_front", animationName : "stage1", resolverName : "tap4_45"});
	animData.push({ skeletonName : "tap5_front", animationName : "stage1", resolverName : "tap5_45"});
	animData.push({ skeletonName : "happy_front", animationName : "stage1", resolverName : "fun45"});
	animData.push({ skeletonName : "watering_front", animationName : "stage1", resolverName : "watering45"});
	animData.push({ skeletonName : "camping_digging", animationName : "stage1", resolverName : "camping_digging135"});
	animData.push({ skeletonName : "camping_digging", animationName : "stage1", resolverName : "camping_digging315"});
	animData.push({ skeletonName : "camping_idle_side_down", animationName : "stage1", resolverName : "camping_idle0"});
	animData.push({ skeletonName : "camping_idle_front", animationName : "stage1", resolverName : "camping_idle45"});
	animData.push({ skeletonName : "camping_idle_side_down", animationName : "stage1", resolverName : "camping_idle90"});
	animData.push({ skeletonName : "camping_idle_side", animationName : "stage1", resolverName : "camping_idle135"});
	animData.push({ skeletonName : "camping_idle_side_up", animationName : "stage1", resolverName : "camping_idle180"});
	animData.push({ skeletonName : "camping_idle_back", animationName : "stage1", resolverName : "camping_idle225"});
	animData.push({ skeletonName : "camping_idle_side_up", animationName : "stage1", resolverName : "camping_idle270"});
	animData.push({ skeletonName : "camping_idle_side", animationName : "stage1", resolverName : "camping_idle315"});
	animData.push({ skeletonName : "camping_lookout_side_down", animationName : "stage1", resolverName : "camping_lookout0"});
	animData.push({ skeletonName : "camping_lookout_front", animationName : "stage1", resolverName : "camping_lookout45"});
	animData.push({ skeletonName : "camping_lookout_side_down", animationName : "stage1", resolverName : "camping_lookout90"});
	animData.push({ skeletonName : "camping_lookout_side", animationName : "stage1", resolverName : "camping_lookout135"});
	animData.push({ skeletonName : "camping_lookout_side_up", animationName : "stage1", resolverName : "camping_lookout180"});
	animData.push({ skeletonName : "camping_lookout_back", animationName : "stage1", resolverName : "camping_lookout225"});
	animData.push({ skeletonName : "camping_lookout_side_up", animationName : "stage1", resolverName : "camping_lookout270"});
	animData.push({ skeletonName : "camping_lookout_side", animationName : "stage1", resolverName : "camping_lookout315"});
	animData.push({ skeletonName : "camping_walk_side_down", animationName : "stage1", resolverName : "camping_walk0"});
	animData.push({ skeletonName : "camping_walk_front", animationName : "stage1", resolverName : "camping_walk45"});
	animData.push({ skeletonName : "camping_walk_side_down", animationName : "stage1", resolverName : "camping_walk90"});
	animData.push({ skeletonName : "camping_walk_side", animationName : "stage1", resolverName : "camping_walk135"});
	animData.push({ skeletonName : "camping_walk_side_up", animationName : "stage1", resolverName : "camping_walk180"});
	animData.push({ skeletonName : "camping_walk_back", animationName : "stage1", resolverName : "camping_walk225"});
	animData.push({ skeletonName : "camping_walk_side_up", animationName : "stage1", resolverName : "camping_walk270"});
	animData.push({ skeletonName : "camping_walk_side", animationName : "stage1", resolverName : "camping_walk315"});
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createNut = function(object) {
	var animData = [];
	var format = 4;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	animData.push({ skeletonName : "walk_side", animationName : "stage1", resolverName : "walk0"});
	animData.push({ skeletonName : "walk_front", animationName : "stage1", resolverName : "walk45"});
	animData.push({ skeletonName : "walk_side", animationName : "stage1", resolverName : "walk90"});
	animData.push({ skeletonName : "walk_side", animationName : "stage1", resolverName : "walk135"});
	animData.push({ skeletonName : "walk_side", animationName : "stage1", resolverName : "walk180"});
	animData.push({ skeletonName : "walk_back", animationName : "stage1", resolverName : "walk225"});
	animData.push({ skeletonName : "walk_side", animationName : "stage1", resolverName : "walk270"});
	animData.push({ skeletonName : "walk_side", animationName : "stage1", resolverName : "walk315"});
	animData.push({ skeletonName : "idle_side", animationName : "stage1", resolverName : "idle0"});
	animData.push({ skeletonName : "idle_front", animationName : "stage1", resolverName : "idle45"});
	animData.push({ skeletonName : "idle_side", animationName : "stage1", resolverName : "idle90"});
	animData.push({ skeletonName : "idle_side", animationName : "stage1", resolverName : "idle135"});
	animData.push({ skeletonName : "idle_side", animationName : "stage1", resolverName : "idle180"});
	animData.push({ skeletonName : "idle_back", animationName : "stage1", resolverName : "idle225"});
	animData.push({ skeletonName : "idle_side", animationName : "stage1", resolverName : "idle270"});
	animData.push({ skeletonName : "idle_side", animationName : "stage1", resolverName : "idle315"});
	animData.push({ skeletonName : "idle2_side", animationName : "stage1", resolverName : "idle_b0"});
	animData.push({ skeletonName : "idle2_front", animationName : "stage1", resolverName : "idle_b45"});
	animData.push({ skeletonName : "idle2_side", animationName : "stage1", resolverName : "idle_b90"});
	animData.push({ skeletonName : "idle2_side", animationName : "stage1", resolverName : "idle_b135"});
	animData.push({ skeletonName : "idle2_side", animationName : "stage1", resolverName : "idle_b180"});
	animData.push({ skeletonName : "idle2_back", animationName : "stage1", resolverName : "idle_b225"});
	animData.push({ skeletonName : "idle2_side", animationName : "stage1", resolverName : "idle_b270"});
	animData.push({ skeletonName : "idle2_side", animationName : "stage1", resolverName : "idle_b315"});
	animData.push({ skeletonName : "scare_side", animationName : "stage2", resolverName : "hunt0"});
	animData.push({ skeletonName : "scare_front", animationName : "stage2", resolverName : "hunt45"});
	animData.push({ skeletonName : "scare_side", animationName : "stage2", resolverName : "hunt90"});
	animData.push({ skeletonName : "scare_side", animationName : "stage2", resolverName : "hunt135"});
	animData.push({ skeletonName : "scare_side", animationName : "stage2", resolverName : "hunt180"});
	animData.push({ skeletonName : "scare_back", animationName : "stage2", resolverName : "hunt225"});
	animData.push({ skeletonName : "scare_side", animationName : "stage2", resolverName : "hunt270"});
	animData.push({ skeletonName : "scare_side", animationName : "stage2", resolverName : "hunt315"});
	animData.push({ skeletonName : "scare_side", animationName : "stage3", resolverName : "scare0"});
	animData.push({ skeletonName : "scare_front", animationName : "stage3", resolverName : "scare45"});
	animData.push({ skeletonName : "scare_side", animationName : "stage3", resolverName : "scare90"});
	animData.push({ skeletonName : "scare_side", animationName : "stage3", resolverName : "scare135"});
	animData.push({ skeletonName : "scare_side", animationName : "stage3", resolverName : "scare180"});
	animData.push({ skeletonName : "scare_back", animationName : "stage3", resolverName : "scare225"});
	animData.push({ skeletonName : "scare_side", animationName : "stage3", resolverName : "scare270"});
	animData.push({ skeletonName : "scare_side", animationName : "stage3", resolverName : "scare315"});
	animData.push({ skeletonName : "burn_side", animationName : "stage1", resolverName : "burn135"});
	animData.push({ skeletonName : "burn_back", animationName : "stage1", resolverName : "burn225"});
	animData.push({ skeletonName : "burn_side", animationName : "stage1", resolverName : "burn315"});
	animData.push({ skeletonName : "death_front", animationName : "STAGE1+STAGE2", resolverName : "death45"});
	animData.push({ skeletonName : "tap_front", animationName : "stage1", resolverName : "tap45"});
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createTalkingHead = function(object) {
	var animData = [];
	var format = 4;
	var hasVBB = true;
	var hasTBB = false;
	var useFallback = false;
	var _g = 0;
	var _g1 = com_nevosoft_waw_data_types_meta_story_EmotionType.getStringList();
	while(_g < _g1.length) {
		var emotion = _g1[_g];
		++_g;
		var resolvedName = object.id + "_" + emotion;
		animData.push({ skeletonName : emotion.toLowerCase(), animationName : emotion, resolverName : resolvedName});
	}
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createBuilding = function(category,object) {
	var animData = [];
	var format = 3;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	var requiredSlots = [];
	var levels = utils_AnimationDataGenerator.getLevels(object);
	var maxLevel = levels.length;
	var _g = 0;
	var _g1 = maxLevel;
	while(_g < _g1) {
		var i = _g++;
		var l = i + 1;
		animData.push({ skeletonName : "idle" + l, animationName : "idle", resolverName : "level_" + l});
		requiredSlots.push({ skeletonName : "idle" + l, requiredSlotNames : utils_AnimationDataGenerator.getOpeningComponentSlots()});
		if(l < maxLevel) {
			requiredSlots.push({ skeletonName : "idle" + l, requiredSlotNames : utils_AnimationDataGenerator.getUpgradeIndicationSlots()});
		}
	}
	if(object.workComponent != null) {
		if(object.workComponent.repairAction != null) {
			animData.push({ skeletonName : "r1", animationName : "repair", resolverName : "repair"});
			animData.push({ skeletonName : "r1", animationName : "repair", resolverName : "ruins"});
		}
		if(utils_AnimationDataGenerator.hasProductions(object) || object.category == "HOUSE") {
			animData.push({ skeletonName : "stage1", animationName : "PRODUCTION", resolverName : "inactivity1"});
			var _g = 0;
			var _g1 = maxLevel;
			while(_g < _g1) {
				var i = _g++;
				var l = i + 1;
				animData.push({ skeletonName : "stage" + l, animationName : "TAP_IDLE", resolverName : "demo_idle_" + l});
				animData.push({ skeletonName : "stage" + l, animationName : "PRODUCTION", resolverName : "working_" + l});
				animData.push({ skeletonName : "stage" + l, animationName : "TAP_PRODUCTION", resolverName : "demo_working_" + l});
			}
		}
		if(object.shopComponent != null && object.shopComponent.category != "hidden" && object.resTransactionComponent == null) {
			animData.push({ skeletonName : "b1", animationName : "building", resolverName : "building_1"});
			animData.push({ skeletonName : "b2", animationName : "building", resolverName : "building_2"});
		}
	}
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback, requiredSlots : requiredSlots};
};
utils_AnimationDataGenerator.createLandscape = function(object) {
	var animData = [];
	var format = 3;
	var hasVBB = true;
	var hasTBB = false;
	var useFallback = false;
	animData.push({ skeletonName : "idle1", animationName : "idle", resolverName : "level_1"});
	animData.push({ skeletonName : "idle1", animationName : "tap", resolverName : "tap_1", needFallback : false});
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createTree = function(object) {
	var animData = [];
	var format = 3;
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = false;
	var maxLevel = utils_AnimationDataGenerator.getLevels(object).length;
	var _g = 0;
	var _g1 = maxLevel;
	while(_g < _g1) {
		var i = _g++;
		animData.push({ skeletonName : "idle" + i, animationName : "idle", resolverName : "level_" + i});
		animData.push({ skeletonName : "chopping" + i, animationName : "chopping", resolverName : "removing_" + i});
		animData.push({ skeletonName : "chopping" + i, animationName : "tap", resolverName : "tap_" + i});
	}
	animData.push({ skeletonName : "stage" + (maxLevel - 1), animationName : "idle", resolverName : "working_" + (maxLevel - 1)});
	animData.push({ skeletonName : "grow", animationName : "grow", resolverName : "grow"});
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.createGarbage = function(object) {
	var animData = [];
	var format = 3;
	if(com_nevosoft_waw_data_constants_GameObjectTag.isObjectTagged("mesh_animation",object)) {
		format = 4;
	}
	var hasVBB = true;
	var hasTBB = true;
	var useFallback = true;
	var levels = utils_AnimationDataGenerator.getLevels(object);
	var maxLevel = levels.length;
	var _g = 0;
	var _g1 = maxLevel;
	while(_g < _g1) {
		var i = _g++;
		animData.push({ skeletonName : "idle" + i, animationName : "idle", resolverName : "level_" + i});
		animData.push({ skeletonName : "idle" + i, animationName : "tap", resolverName : "tap_" + i, fallbackSkeletonName : "idle" + i, fallbackAnimationName : "idle"});
		animData.push({ skeletonName : "grow", animationName : "remove", resolverName : "removing_" + i, fallbackSkeletonName : "idle" + i, fallbackAnimationName : "idle"});
	}
	animData.push({ skeletonName : "stage" + (maxLevel - 1), animationName : "idle", resolverName : "working_" + (maxLevel - 1), fallbackSkeletonName : "idle" + (maxLevel - 1), fallbackAnimationName : "idle"});
	animData.push({ skeletonName : "grow", animationName : "grow", resolverName : "grow", fallbackSkeletonName : "idle0", fallbackAnimationName : "idle"});
	return { format : format, animationData : animData, hasVBB : hasVBB, hasTBB : hasTBB, useFallback : useFallback};
};
utils_AnimationDataGenerator.getLevels = function(object) {
	var startLevel = utils_AnimationDataGenerator.getInitialLevel(object);
	var endLevel = startLevel + 1;
	if(object != null && object.workComponent != null && object.workComponent.upgradeActions.length > 0) {
		var upgradesCount = object.workComponent.upgradeActions.length;
		endLevel += upgradesCount - 1;
	}
	var _g = [];
	var _g1 = startLevel;
	var _g2 = endLevel;
	while(_g1 < _g2) {
		var i = _g1++;
		_g.push(i);
	}
	return _g;
};
utils_AnimationDataGenerator.getInitialLevel = function(meta) {
	return com_nevosoft_waw_helpers_GameObjectHelper.getInitialLevel(meta);
};
utils_AnimationDataGenerator.hasProductions = function(object) {
	if(object.workComponent != null && object.workComponent.actions.length > 0) {
		var _g = 0;
		var _g1 = object.workComponent.actions;
		while(_g < _g1.length) {
			var action = _g1[_g];
			++_g;
			if(action.type == 3) {
				return true;
			}
		}
	}
	return false;
};
utils_AnimationDataGenerator.getOpeningComponentSlots = function() {
	return ["b3_balloon_left","b3_balloon_right"];
};
utils_AnimationDataGenerator.getUpgradeIndicationSlots = function() {
	return ["indication"];
};
var utils_SpineDataExtractor = function() { };
utils_SpineDataExtractor.__name__ = true;
utils_SpineDataExtractor.__isInterface__ = true;
utils_SpineDataExtractor.prototype = {
	__class__: utils_SpineDataExtractor
};
var utils_BinarySpineDataExtractor = function(data) {
	this.extractData(data);
};
utils_BinarySpineDataExtractor.__name__ = true;
utils_BinarySpineDataExtractor.__interfaces__ = [utils_SpineDataExtractor];
utils_BinarySpineDataExtractor.prototype = {
	extractData: function(data) {
		this.images = [];
		this.animations = [];
		this.boundingBoxes = [];
		this.slots = [];
		this.events = [];
		this.meshes = [];
		this.blendModes = new haxe_ds_IntMap();
		this.rootPosition = { x : 0.0, y : 0.0};
		if(data == null) {
			return;
		}
		var skeletonBinary = new spine_SkeletonBinary(new spine_attachments_EmptyAttachmentLoader());
		var skeletonData = skeletonBinary.readSkeletonDataFromBytes(data,"");
		var _g = 0;
		var _g1 = skeletonData.skins;
		while(_g < _g1.length) {
			var skin = _g1[_g];
			++_g;
			var skinAttachments = skin._attachments;
			var _g2 = 0;
			while(_g2 < skinAttachments.length) {
				var map = skinAttachments[_g2];
				++_g2;
				if(map == null) {
					continue;
				}
				var attachment = haxe_ds_StringMap.valueIterator(map.h);
				while(attachment.hasNext()) {
					var attachment1 = attachment.next();
					switch(attachment1.type) {
					case 1:
						this.boundingBoxes.push(attachment1._name);
						this.tBBPoints = [];
						var box = attachment1;
						var _g3 = 0;
						var _g4 = box.vertices.length;
						while(_g3 < _g4) {
							var i = _g3++;
							this.tBBPoints.push(box.vertices[i]);
						}
						break;
					case 0:case 2:case 3:
						this.images.push(Reflect.field(attachment1,"path"));
						if(attachment1.type != 0) {
							this.meshes.push(attachment1._name);
						}
						break;
					default:
					}
				}
			}
		}
		var _g = 0;
		var _g1 = skeletonData.animations;
		while(_g < _g1.length) {
			var animation = _g1[_g];
			++_g;
			this.animations.push(animation.name.toUpperCase());
		}
		var _g = 0;
		var _g1 = skeletonData.slots;
		while(_g < _g1.length) {
			var slot = _g1[_g];
			++_g;
			this.slots.push(slot._name);
			this.blendModes.h[slot.blendMode] = slot.blendMode;
		}
		var _g = 0;
		var _g1 = skeletonData.events;
		while(_g < _g1.length) {
			var event = _g1[_g];
			++_g;
			if(this.events.indexOf(event._name) < 0) {
				this.events.push(event._name);
			}
		}
		var _g = 0;
		var _g1 = skeletonData.bones;
		while(_g < _g1.length) {
			var bone = _g1[_g];
			++_g;
			if(bone._parent == null) {
				this.rootPosition.x = bone.x;
				this.rootPosition.y = bone.y;
				break;
			}
		}
	}
	,__class__: utils_BinarySpineDataExtractor
};
var utils_JsonSpineDataExtractor = function(data) {
	this.extractData(data);
};
utils_JsonSpineDataExtractor.__name__ = true;
utils_JsonSpineDataExtractor.__interfaces__ = [utils_SpineDataExtractor];
utils_JsonSpineDataExtractor.prototype = {
	extractData: function(data) {
		this.images = [];
		this.animations = [];
		this.boundingBoxes = [];
		this.slots = [];
		this.meshes = [];
		this.blendModes = new haxe_ds_IntMap();
		this.rootPosition = { x : 0.0, y : 0.0};
		if(data == null) {
			return;
		}
		var skeleton = JSON.parse(data);
		if(skeleton != null) {
			var skins = skeleton.skins;
			if(skins != null) {
				var _g = 0;
				var _g1 = Reflect.fields(skins);
				while(_g < _g1.length) {
					var skinName = _g1[_g];
					++_g;
					var skinMap = skins[skinName];
					var _g2 = 0;
					var _g3 = Reflect.fields(skinMap);
					while(_g2 < _g3.length) {
						var slotName = _g3[_g2];
						++_g2;
						var slotEntry = skinMap[slotName];
						var _g4 = 0;
						var _g5 = Reflect.fields(slotEntry);
						while(_g4 < _g5.length) {
							var attachmentName = _g5[_g4];
							++_g4;
							var attachment = slotEntry[attachmentName];
							if(attachment != null) {
								var this1 = attachment.type;
								var type = this1 != null ? this1 : "region";
								switch(type) {
								case "boundingbox":
									var this2 = attachment.path;
									var boxName = this2 != null ? this2 : attachmentName;
									this.boundingBoxes.push(boxName);
									if(boxName == "TBB") {
										this.tBBPoints = attachment.vertices;
									}
									break;
								case "linkedmesh":case "mesh":case "region":
									var this3 = attachment.path;
									this.images.push(this3 != null ? this3 : attachmentName);
									if(type != "region") {
										this.meshes.push(attachmentName);
									}
									break;
								default:
								}
							}
						}
					}
				}
			}
			var skeletonAnimations = skeleton.animations;
			if(skeletonAnimations != null) {
				var _g = 0;
				var _g1 = Reflect.fields(skeletonAnimations);
				while(_g < _g1.length) {
					var animationName = _g1[_g];
					++_g;
					this.animations.push(animationName.toUpperCase());
				}
			}
			var _g = 0;
			var _g1 = skeleton.slots;
			while(_g < _g1.length) {
				var slot = _g1[_g];
				++_g;
				this.slots.push(slot.name);
				var this1 = slot.blend;
				var blendMode = this1 != null ? this1 : 0;
				this.blendModes.h[blendMode] = blendMode;
			}
			var spineEvents = skeleton.events;
			if(spineEvents != null) {
				var _g = 0;
				var _g1 = Reflect.fields(spineEvents);
				while(_g < _g1.length) {
					var eventName = _g1[_g];
					++_g;
					if(this.events.indexOf(eventName) < 0) {
						this.events.push(eventName);
					}
				}
			}
			var _g = 0;
			var _g1 = skeleton.bones;
			while(_g < _g1.length) {
				var bone = _g1[_g];
				++_g;
				if(!Object.prototype.hasOwnProperty.call(bone,"parent")) {
					var this1 = bone.x;
					this.rootPosition.x = this1 != null ? this1 : 0.0;
					var this2 = bone.y;
					this.rootPosition.y = this2 != null ? this2 : 0.0;
					break;
				}
			}
		}
	}
	,__class__: utils_JsonSpineDataExtractor
};
function $getIterator(o) { if( o instanceof Array ) return new haxe_iterators_ArrayIterator(o); else return o.iterator(); }
function $bind(o,m) { if( m == null ) return null; if( m.__id__ == null ) m.__id__ = $global.$haxeUID++; var f; if( o.hx__closures__ == null ) o.hx__closures__ = {}; else f = o.hx__closures__[m.__id__]; if( f == null ) { f = m.bind(o); o.hx__closures__[m.__id__] = f; } return f; }
$global.$haxeUID |= 0;
if(typeof(performance) != "undefined" ? typeof(performance.now) == "function" : false) {
	HxOverrides.now = performance.now.bind(performance);
}
if( String.fromCodePoint == null ) String.fromCodePoint = function(c) { return c < 0x10000 ? String.fromCharCode(c) : String.fromCharCode((c>>10)+0xD7C0)+String.fromCharCode((c&0x3FF)+0xDC00); }
String.prototype.__class__ = String;
String.__name__ = true;
Array.__name__ = true;
Date.prototype.__class__ = Date;
Date.__name__ = "Date";
var Int = { };
var Dynamic = { };
var Float = Number;
var Bool = Boolean;
var Class = { };
var Enum = { };
js_Boot.__toStr = ({ }).toString;
msignal_SlotList.NIL = new msignal_SlotList(null,null);
Log.LEVEL_INFO = 0;
Log.LEVEL_WARNING = 1;
Log.LEVEL_ERROR = 2;
Log.LEVEL_DEBUG = 3;
com_nevosoft_isoframework_WorkManager._lastSessionID = 0;
com_nevosoft_isoframework_space_PassabilityMap.enabled = true;
com_nevosoft_isoframework_space__$PassabilityMap_PassTile.UNKNOWN = 0;
com_nevosoft_isoframework_space__$PassabilityMap_PassTile.OPENED = 1;
com_nevosoft_isoframework_space__$PassabilityMap_PassTile.CLOSED = 2;
com_nevosoft_waw_core_localization_Locale.GAME_OBJECTS = "/gameObjects";
com_nevosoft_waw_core_localization_Locale.GAME_SPELLS = "/spells";
com_nevosoft_waw_core_localization_Locale.GAME_OTHER = "/other";
com_nevosoft_waw_core_localization_Locale.MERKET_ORDERS = "/market_orders";
com_nevosoft_waw_core_localization_Locale.UI = "/ui";
com_nevosoft_waw_core_localization_Locale.ZEPPELIN = "/zeppelin";
com_nevosoft_waw_core_localization_Locale.ARCS = "/questArcs";
com_nevosoft_waw_core_localization_Locale.GAME_EVENTS = "/gameEvents";
com_nevosoft_waw_core_localization_Locale.GAME_EVENT_MAP = "/gameEventMap";
com_nevosoft_waw_core_localization_Locale.QUESTS = "/quests";
com_nevosoft_waw_core_localization_Locale.OFFERS = "/offers";
com_nevosoft_waw_core_localization_Locale.BUFFS = "/buffs";
com_nevosoft_waw_core_localization_Locale.ACHIEVEMENTS = "/achievements";
com_nevosoft_waw_core_localization_Locale.AUTO_TEXTS = "/autotexts";
com_nevosoft_waw_core_localization_Locale.NOTIFICATIONS = "/notifications";
com_nevosoft_waw_core_localization_Locale.ERROR = "/error";
com_nevosoft_waw_core_localization_Locale.MARKET_ORDER_KEYS = [];
com_nevosoft_waw_data_constants_CmpOp.ge = ">=";
com_nevosoft_waw_data_constants_CmpOp.eq = "=";
com_nevosoft_waw_data_constants_CmpOp.le = "<=";
com_nevosoft_waw_data_constants_CollisionConst.WALKABLE_TILE = 1;
com_nevosoft_waw_data_constants_CollisionConst.HAS_STRUCTURE_TILE = 2;
com_nevosoft_waw_data_constants_CollisionConst.LOCKED_TILE = 4;
com_nevosoft_waw_data_constants_CollisionConst.UNDER_INFLUENCE_TILE = 16;
com_nevosoft_waw_data_constants_CollisionConst.PASSABILITY_BLOCKER_TILE = 32;
com_nevosoft_waw_data_constants_CollisionConst.ROAD_TILE = 64;
com_nevosoft_waw_data_constants_CollisionConst.NOT_PASSABLE_TILE = 8;
com_nevosoft_waw_data_constants_CollisionConst.DESIGN_DISABLED_TILE = 128;
com_nevosoft_waw_data_constants_CollisionConst.blockedTileMask = 14;
com_nevosoft_waw_data_constants_CollisionConst.notDesignableTileMask = com_nevosoft_waw_data_constants_CollisionConst.blockedTileMask | 128 | 64;
com_nevosoft_waw_data_constants_ECharacter.SHMU = 324;
com_nevosoft_waw_data_constants_ECharacter.KAYA = 325;
com_nevosoft_waw_data_constants_ECharacter.CAT = 326;
com_nevosoft_waw_data_constants_ECharacter.CAPTAIN = 327;
com_nevosoft_waw_data_constants_ECharacter.SHMU_FARMER = 413;
com_nevosoft_waw_data_constants_ECharacter.GARP = 422;
com_nevosoft_waw_data_constants_ECharacter.SHMU_ZAVHOZ = 424;
com_nevosoft_waw_data_constants_ECharacter.CAT_REWARD = 444;
com_nevosoft_waw_data_constants_ECharacter.LLAMA = 452;
com_nevosoft_waw_data_constants_ECharacter.SHMU_NERD = 454;
com_nevosoft_waw_data_constants_ECharacter.SHMU_TRADER = 596;
com_nevosoft_waw_data_constants_ECharacter.W_LIGHT = 666;
com_nevosoft_waw_data_constants_ECharacter.FROSTY_SPIRIT = 788;
com_nevosoft_waw_data_constants_ECharacter.NONE = -1;
com_nevosoft_waw_data_constants_EModificatorType.ACTION_TIME = 1;
com_nevosoft_waw_data_constants_EModificatorType.ACTION_INCOME = 2;
com_nevosoft_waw_data_constants_EModificatorType.NOT_WORKING = 3;
com_nevosoft_waw_data_constants_EModificatorType.ACCELERATE_COST = 4;
com_nevosoft_waw_data_constants_EModificatorType.ACTION_TIME_FIXED = 5;
com_nevosoft_waw_data_constants_EModificatorType.EXPLOSION = 6;
com_nevosoft_waw_data_constants_EWeightType.EWT_NONE = -1;
com_nevosoft_waw_data_constants_EWeightType.EWT_REWARD = 0;
com_nevosoft_waw_data_constants_EWeightType.EWT_COLLECT = 1;
com_nevosoft_waw_data_constants_EWeightType.EWT_RECEIVE = 6;
com_nevosoft_waw_data_constants_EWeightType.EWT_SAVE_UP = 7;
com_nevosoft_waw_data_constants_EWeightType.EWT_SELL = 8;
com_nevosoft_waw_data_constants_EWeightType.EWT_SPEND = 9;
com_nevosoft_waw_data_constants_EWeightType.EWT_BUY = 10;
com_nevosoft_waw_data_constants_EWeightType.EWT_SPELL = 11;
com_nevosoft_waw_data_constants_EWeightType.EWT_AUTO_QUEST_CONDITION = 12;
com_nevosoft_waw_data_constants_EWeightType.EWT_MARKET_ORDER = 13;
com_nevosoft_waw_data_constants_EWeightType.EWT_ZEPPELIN_ORDER = 14;
com_nevosoft_waw_data_constants_EWeightType.EWT_COLLECT_ANY_PRODUCTION = 15;
com_nevosoft_waw_data_constants_EWeightType.EWT_SPEND_ON_ANIMAL = 16;
com_nevosoft_waw_data_constants_EWeightType.EWT_HARVEST = 17;
com_nevosoft_waw_data_constants_GameConst.MAX_INACTIVE_TIME = 90;
com_nevosoft_waw_data_constants_GameObjectTag.THORN = "go_thorn";
com_nevosoft_waw_data_constants_GameObjectTag.CHEST = "go_chest";
com_nevosoft_waw_data_constants_GameObjectTag.SPECIAL = "go_lit_up";
com_nevosoft_waw_data_constants_GameObjectTag.DAILY_QUEST = "go_daily_quest";
com_nevosoft_waw_data_constants_GameObjectTag.CAMP = "go_camp";
com_nevosoft_waw_data_constants_GameObjectTag.CHEST_SPAWN_TRIGGER = "go_chest_resp";
com_nevosoft_waw_data_constants_GameObjectTag.DAILY_QUEST_REWARD = "res_daily_quest_reward";
com_nevosoft_waw_data_constants_GameObjectTag.ZEPPELIN_REWARD = "res_zeppelin";
com_nevosoft_waw_data_constants_GameObjectTag.CAMP_REWARD = "res_camp_reward";
com_nevosoft_waw_data_constants_GameObjectTag.MARKET_REWARD = "res_market_reward";
com_nevosoft_waw_data_constants_GameObjectTag.VIDEO_TOKEN = "res_videotoken";
com_nevosoft_waw_data_constants_GameObjectTag.GO_HAS_REWARDED_VIDEO = "go_has_rewarded_video";
com_nevosoft_waw_data_constants_GameObjectTag.RES_REWARDED_VIDEO = "res_rewarded_video";
com_nevosoft_waw_data_constants_GameObjectTag.TOWNHALL = "go_townhall";
com_nevosoft_waw_data_constants_GameObjectTag.SHMU_RESPAWN = "go_shmu_respawn";
com_nevosoft_waw_data_constants_GameObjectTag.GARBAGE_TREE = "garbage_tree";
com_nevosoft_waw_data_constants_GameObjectTag.GARBAGE_STONE = "garbage_stone";
com_nevosoft_waw_data_constants_GameObjectTag.GARBAGE_BLOCKING = "garbage_blocking";
com_nevosoft_waw_data_constants_GameObjectTag.GARBAGE_COMPLEX = "garbage_complex";
com_nevosoft_waw_data_constants_GameObjectTag.GARBAGE_NPC = "garbage_npc";
com_nevosoft_waw_data_constants_GameObjectTag.GARBAGE_DOOR = "garbage_door";
com_nevosoft_waw_data_constants_GameObjectTag.GARBAGE_CRATE = "garbage_crate";
com_nevosoft_waw_data_constants_GameObjectTag.GARBAGE_CAPTAIN = "garbage_captain";
com_nevosoft_waw_data_constants_GameObjectTag.GO_NOT_PASSABLE = "go_not_passable";
com_nevosoft_waw_data_constants_GameObjectTag.GO_PASSABLE_ON_REPAIR = "go_passable_on_repair";
com_nevosoft_waw_data_constants_GameObjectTag.GO_EVENT_STARTER = "go_event_starter";
com_nevosoft_waw_data_constants_GameObjectTag.GO_GARBAGE_ALL = "go_garbage_all";
com_nevosoft_waw_data_constants_GameObjectTag.GO_NOT_TAPABLE = "go_not_tapable";
com_nevosoft_waw_data_constants_GameObjectTag.GO_LIT_ONCE = "go_lit_once";
com_nevosoft_waw_data_constants_GameObjectTag.GO_TALKING = "go_talking";
com_nevosoft_waw_data_constants_GameObjectTag.GO_GROUND_LAYER = "go_ground_layer";
com_nevosoft_waw_data_constants_GameObjectTag.GARBAGE_AUTOCOLLECT_IMMEDIATELY = "garbage_autocollect_immediately";
com_nevosoft_waw_data_constants_GameObjectTag.GARBAGE_AUTOCOLLECT_FX = "garbage_autocollect_fx";
com_nevosoft_waw_data_constants_GameObjectTag.GO_IN_TRAP = "go_in_trap";
com_nevosoft_waw_data_constants_GameObjectTag.GO_QUEST_HIGHLIGHT = "go_quest_hint";
com_nevosoft_waw_data_constants_GameObjectTag.GO_WAREHOUSE = "go_warehouse";
com_nevosoft_waw_data_constants_GameObjectTag.GO_TEMPORARY_BUILDING = "go_temporary_building";
com_nevosoft_waw_data_constants_GameObjectTag.QUEST_SPECIAL = "quest_special";
com_nevosoft_waw_data_constants_GameObjectTag.QUEST_ONMAP_DIALOGS = "quest_onmap_dialogs";
com_nevosoft_waw_data_constants_GameObjectTag.MESH_ANIMATION = "mesh_animation";
com_nevosoft_waw_data_constants_GameObjectTag.GO_NO_PROD_SPEEDUP = "go_no_prod_speedup";
com_nevosoft_waw_data_constants_GameObjectTag.GO_NO_PROD_SPEEDUP_VIDEO = "go_no_prod_speedup_video";
com_nevosoft_waw_data_constants_GameObjectTag.GO_NO_UPGRADE_SPEEDUP = "go_no_upgrade_speedup";
com_nevosoft_waw_data_constants_GameObjectTag.GO_NO_UPGRADE_SPEEDUP_VIDEO = "go_no_upgrade_speedup_video";
com_nevosoft_waw_data_constants_GameObjectTag.RES_ENERGY = "res_energy";
com_nevosoft_waw_data_constants_GameObjectTag.GO_ALLOW_COLLECT_REWARD_OVER_LIMIT = "go_allow_collect_reward_over_limit";
com_nevosoft_waw_data_constants_GameObjectTag.GO_ANIM_DECOR = "go_anim_decor";
com_nevosoft_waw_data_constants_GameObjectTag.GO_TAP_ANIM_DECOR = "go_tap_anim_decor";
com_nevosoft_waw_data_constants_GameObjectTag.GO_NO_TAP_TEASE_ANIMATION = "go_no_tap_tease_animation";
com_nevosoft_waw_data_constants_GameObjectTag.ENERGY_POT = "go_energy_pot";
com_nevosoft_waw_data_constants_GameObjectTag.GO_FOCUS_ON_ENTER = "go_focus_on_enter";
com_nevosoft_waw_data_constants_GameObjectTag.GO_PET = "go_pet";
com_nevosoft_waw_data_constants_GameObjectTag.GO_TOWHALL_NPC = "go_townhall_npc";
com_nevosoft_waw_data_constants_GameObjectTag.RES_SHOW_ON_HUD = "res_show_on_hud";
com_nevosoft_waw_data_constants_GameObjectTag.RES_BUFF = "res_buff";
com_nevosoft_waw_data_constants_GameObjectTag.GO_UPGRADE_VASSAL_ANIMATION_CONSTRUCTION = "go_upgrade_vassal_animation_construction";
com_nevosoft_waw_data_constants_GameObjectTag.GO_UPGRADE_VASSAL_ANIMATION_CLEANING = "go_upgrade_vassal_animation_cleaning";
com_nevosoft_waw_data_constants_GameObjectTag.GO_UPGRADE_VASSAL_ANIMATION_CHOPPING = "go_upgrade_vassal_animation_chopping";
com_nevosoft_waw_data_constants_GameObjectTag.GO_NO_SHOP = "go_no_shop";
com_nevosoft_waw_data_constants_GameObjectTag.GO_NOT_EXPLODED = "go_not_exploded";
com_nevosoft_waw_data_constants_GameObjectTag.GO_DRAGON_PASTURE = "go_dragon_pasture";
com_nevosoft_waw_data_constants_GameObjectTag.GO_PERIODICAL_REWARD = "go_periodical_reward";
com_nevosoft_waw_data_constants_GameObjectType.PRODUCTION_BUILDING = "COMMON_BUILDING";
com_nevosoft_waw_data_constants_GameObjectType.HOUSE = "HOUSE";
com_nevosoft_waw_data_constants_GameObjectType.FARM_CELL = "FARM_CELL";
com_nevosoft_waw_data_constants_GameObjectType.MARKET = "MARKET";
com_nevosoft_waw_data_constants_GameObjectType.PASTURE = "PASTURE";
com_nevosoft_waw_data_constants_GameObjectType.STORAGE_COMMON = "STORAGE_COMMON";
com_nevosoft_waw_data_constants_GameObjectType.GARBAGE = "GARBAGE";
com_nevosoft_waw_data_constants_GameObjectType.TREE = "TREE";
com_nevosoft_waw_data_constants_GameObjectType.ANIMAL = "ANIMAL";
com_nevosoft_waw_data_constants_GameObjectType.DECOR = "DECOR";
com_nevosoft_waw_data_constants_GameObjectType.LAIR = "LAIR";
com_nevosoft_waw_data_constants_GameObjectType.ZEPPELIN = "ZEPPELIN";
com_nevosoft_waw_data_constants_GameObjectType.SHOP_KEEPER = "SHOP_KEEPER";
com_nevosoft_waw_data_constants_GameObjectType.LANDSCAPE = "LANDSCAPE";
com_nevosoft_waw_data_constants_GameObjectType.PLANT = "PLANT";
com_nevosoft_waw_data_constants_GameObjectType.ROAD = "ROAD";
com_nevosoft_waw_data_constants_GameObjectType.FENCE = "FENCE";
com_nevosoft_waw_data_constants_GameObjectType.SHMU = "SHMU";
com_nevosoft_waw_data_constants_GameObjectType.NUT = "NUT";
com_nevosoft_waw_data_constants_GameObjectType.STUFF = "STUFF";
com_nevosoft_waw_data_constants_GameObjectType.RESOURCE_PACK = "STUFF_PACK";
com_nevosoft_waw_data_constants_GameObjectType.SPELL = "SPELL";
com_nevosoft_waw_data_constants_GameObjectType.ACHIEVEMENT_HOUSE = "ACHIEVEMENT_HOUSE";
com_nevosoft_waw_data_constants_GameObjectType.TALKING_HEAD = "TALKING_HEAD";
com_nevosoft_waw_data_constants_GameObjectType.DIRIGIBLE = "DIRIGIBLE";
com_nevosoft_waw_data_constants_GameObjectType.FLYING_CAT = "FLYING_CAT";
com_nevosoft_waw_data_constants_GameObjectType.LIVE_DECOR = "LIVE_DECOR";
com_nevosoft_waw_data_constants_GameObjectType.EVENT_STARTER = "EVENT_STARTER";
com_nevosoft_waw_data_constants_GameObjectType.ORDERS_HOST = "ORDERS_HOST";
com_nevosoft_waw_data_constants_ResourceType.RESOURCE_TYPE_PREMIUM_XP = -6;
com_nevosoft_waw_data_constants_ResourceType.RESOURCE_TYPE_SHMU = -5;
com_nevosoft_waw_data_constants_ResourceType.RESOURCE_TYPE_XP = -4;
com_nevosoft_waw_data_constants_ResourceType.RESOURCE_TYPE_RUBIES = -3;
com_nevosoft_waw_data_constants_ResourceType.RESOURCE_TYPE_GOLD = -1;
com_nevosoft_waw_data_constants_ResourceType.RESOURCE_TYPE_VOID = 0;
com_nevosoft_waw_data_constants_ResourceType.RESOURCE_TYPE_VIDEO_TOKEN = -500;
com_nevosoft_waw_data_constants_ResourceType.WRONG_RESOURCE_ID = -500;
com_nevosoft_waw_data_types_ConditionType.ESellStuff = 1;
com_nevosoft_waw_data_types_ConditionType.ESellAny = 2;
com_nevosoft_waw_data_types_ConditionType.ECompleteMarketOrder = 3;
com_nevosoft_waw_data_types_ConditionType.ECompleteZeppelinSubOrder = 4;
com_nevosoft_waw_data_types_ConditionType.ECompleteZeppelinOrder = 5;
com_nevosoft_waw_data_types_ConditionType.EReceiveIncome = 11;
com_nevosoft_waw_data_types_ConditionType.ESaveUpResource = 12;
com_nevosoft_waw_data_types_ConditionType.EAnySpell = 13;
com_nevosoft_waw_data_types_ConditionType.EAccelerateSpell = 17;
com_nevosoft_waw_data_types_ConditionType.ESpendStuffAny = 19;
com_nevosoft_waw_data_types_ConditionType.EBuyInAppLot = 20;
com_nevosoft_waw_data_types_ConditionType.EOwnSector = 27;
com_nevosoft_waw_data_types_ConditionType.EInteractWithShmu = 28;
com_nevosoft_waw_data_types_ConditionType.EInteractWithAnimalAny = 29;
com_nevosoft_waw_data_types_ConditionType.EQuestComplete = 30;
com_nevosoft_waw_data_types_ConditionType.EDaylyBonusGot = 31;
com_nevosoft_waw_data_types_ConditionType.EOwnLevel = 32;
com_nevosoft_waw_data_types_ConditionType.ERichResourceLimit = 33;
com_nevosoft_waw_data_types_ConditionType.EBuyStuffCategory = 36;
com_nevosoft_waw_data_types_ConditionType.EBuff = 37;
com_nevosoft_waw_data_types_ConditionType.EGoldLoteryTicket = 38;
com_nevosoft_waw_data_types_ConditionType.EQuestDiller = 39;
com_nevosoft_waw_data_types_ConditionType.EVendor = 40;
com_nevosoft_waw_data_types_ConditionType.EFriends = 41;
com_nevosoft_waw_data_types_ConditionType.EFriendActions = 42;
com_nevosoft_waw_data_types_ConditionType.EKillFriendsNuts = 43;
com_nevosoft_waw_data_types_ConditionType.EFriendZeppelin = 45;
com_nevosoft_waw_data_types_ConditionType.EDailyQuest = 46;
com_nevosoft_waw_data_types_ConditionType.EAnimalEscape = 47;
com_nevosoft_waw_data_types_ConditionType.EShmuFear = 48;
com_nevosoft_waw_data_types_ConditionType.EAnimalFear = 49;
com_nevosoft_waw_data_types_ConditionType.EFireBuilding = 50;
com_nevosoft_waw_data_types_ConditionType.ENutsOnMap = 51;
com_nevosoft_waw_data_types_ConditionType.EShmuOnMap = 52;
com_nevosoft_waw_data_types_ConditionType.EInteractWithAnimal = 55;
com_nevosoft_waw_data_types_ConditionType.EReceiveStuff = 56;
com_nevosoft_waw_data_types_ConditionType.ESaveUpAndClean = 57;
com_nevosoft_waw_data_types_ConditionType.EBuffAny = 60;
com_nevosoft_waw_data_types_ConditionType.ESpell = 61;
com_nevosoft_waw_data_types_ConditionType.ESpendStuffShop = 62;
com_nevosoft_waw_data_types_ConditionType.EStartAction = 63;
com_nevosoft_waw_data_types_ConditionType.EQueueAction = 64;
com_nevosoft_waw_data_types_ConditionType.EFinishAction = 65;
com_nevosoft_waw_data_types_ConditionType.EApplyAction = 66;
com_nevosoft_waw_data_types_ConditionType.EStartProductionOn = 67;
com_nevosoft_waw_data_types_ConditionType.EApplyProductionOn = 68;
com_nevosoft_waw_data_types_ConditionType.EOwnMapObject = 69;
com_nevosoft_waw_data_types_ConditionType.ECollectFromObject = 70;
com_nevosoft_waw_data_types_ConditionType.ESpendGoldOnCategory = 71;
com_nevosoft_waw_data_types_ConditionType.ERichDailyQuestStage = 72;
com_nevosoft_waw_data_types_ConditionType.EBuildAny = 73;
com_nevosoft_waw_data_types_ConditionType.EUpgradeAny = 74;
com_nevosoft_waw_data_types_ConditionType.ESectorUnlockAny = 75;
com_nevosoft_waw_data_types_ConditionType.ECollectFromTag = 76;
com_nevosoft_waw_data_types_ConditionType.ECompleteAnyOfOrders = 77;
com_nevosoft_waw_data_types_ConditionType.EEnterGameEvent = 78;
com_nevosoft_waw_data_types_ConditionType.ESpendStuffAnyShop = 79;
com_nevosoft_waw_data_types_meta_EActionType.EAT_Place = 0;
com_nevosoft_waw_data_types_meta_EActionType.EAT_LevelUp = 1;
com_nevosoft_waw_data_types_meta_EActionType.EAT_Remove = 2;
com_nevosoft_waw_data_types_meta_EActionType.EAT_Produce = 3;
com_nevosoft_waw_data_types_meta_EActionType.EAT_Repair = 4;
com_nevosoft_waw_data_types_meta_EActionType.EAT_Sowing = 5;
com_nevosoft_waw_data_types_meta_EActionType.EAT_Explore = 6;
com_nevosoft_waw_data_types_meta_EActionType.EAT_LevelDown = 7;
com_nevosoft_waw_data_types_meta_story_EmotionType.IDLE = 0;
com_nevosoft_waw_data_types_meta_story_EmotionType.LAUGHING = 1;
com_nevosoft_waw_data_types_meta_story_EmotionType.HAPPY = 2;
com_nevosoft_waw_data_types_meta_story_EmotionType.SURPRIZED = 3;
com_nevosoft_waw_data_types_meta_story_EmotionType.DISPLEASED = 4;
com_nevosoft_waw_data_types_meta_story_EmotionType.THINKING = 5;
com_nevosoft_waw_data_types_meta_story_EmotionType.PANIC = 6;
com_nevosoft_waw_data_types_meta_story_EmotionType.SAD = 7;
com_nevosoft_waw_data_types_meta_story_SceneTypes.Dialog = 0;
com_nevosoft_waw_data_types_meta_story_SceneTypes.RewardDialog = 2;
com_nevosoft_waw_data_types_meta_story_SceneTypes.Comics = 3;
com_nevosoft_waw_data_types_meta_story_SceneTypes.StateDialog = 4;
com_nevosoft_waw_data_vo_OnMapStorage._checkToken = 0;
com_nevosoft_waw_logic_Transaction._inc = 0;
com_nevosoft_waw_logic_api_TutorAPI.MARKET_EMPTY = -1;
com_nevosoft_waw_logic_api_TutorAPI.MARKET_TUTORIAL_HIGH = 0;
com_nevosoft_waw_logic_api_TutorAPI.TUTOR_INIT = 1001;
com_nevosoft_waw_logic_api_TutorAPI.MARKET_SELL = 1002;
com_nevosoft_waw_logic_api_TutorAPI.MARKET_SLOT_ELIXIR = 1006;
com_nevosoft_waw_logic_api_TutorAPI.MARKET_SLOT = 1007;
com_nevosoft_waw_logic_api_TutorAPI.GIVE_QUEST = 1008;
com_nevosoft_waw_logic_api_TutorAPI.MARKET_SLOT_PLANT = 1009;
com_nevosoft_waw_logic_api_TutorAPI.MARKET_SLOT_FIREWOOD = 1010;
com_nevosoft_waw_logic_api_TutorAPI.MARKET_RELEASE_SLOTS = 1011;
com_nevosoft_waw_logic_api_TutorAPI.ACCELERATE_FARMS = 1012;
com_nevosoft_waw_logic_api_TutorAPI.ACCELERATE_SAWMILL = 1013;
com_nevosoft_waw_logic_api_TutorAPI.PLACE_ACHIEVEMENT_HOUSE = 1014;
com_nevosoft_waw_logic_api_TutorAPI.PLACE_GARBAGE = 1015;
com_nevosoft_waw_logic_api_TutorAPI.ACCELERATE_FORGE_PROD = 1016;
com_nevosoft_waw_logic_api_TutorAPI.ACCELERATE_BULLS = 1017;
com_nevosoft_waw_logic_api_TutorAPI.ACCELERATE_SAWMILL_PROD = 1018;
com_nevosoft_waw_logic_api_TutorAPI.RESET_GOLD_SPELLS = 1019;
com_nevosoft_waw_logic_api_TutorAPI.RESET_GOLD_FEED_FACTORY = 1021;
com_nevosoft_waw_logic_api_TutorAPI.SHOW_NEED_RES_HINT_1 = 1020;
com_nevosoft_waw_logic_api_TutorAPI.SHOW_NEED_RES_HINT_7 = 1026;
com_nevosoft_waw_logic_api_TutorAPI.SHOW_RATE_APP = 1030;
com_nevosoft_waw_logic_api_TutorAPI.FIRST_CAMP_INIT = 1031;
com_nevosoft_waw_logic_api_TutorAPI.EVENT_6_SPAWN_THORN = 1032;
com_nevosoft_waw_logic_api_TutorAPI.EVENT_6_TUTOR_INIT = 1033;
com_nevosoft_waw_logic_api_TutorAPI.EVENT_6_ACCELERATE_ENERGY_POT = 1034;
com_nevosoft_waw_logic_api_TutorAPI.NEW_LEVEL_COLLECT_REWARD_COUNTER = 0;
com_nevosoft_waw_logic_api_TutorAPI.QUEST_GROUP_COLLECT_REWARD_COUNTER = 1;
com_nevosoft_waw_logic_api_TutorAPI.QUEST_GROUP_FINISH_COLLECT_REWARD_COUNTER = 2;
com_nevosoft_waw_logic_api_TutorAPI.DAILY_QUEST_COLLECT_REWARD_COUNTER = 3;
com_nevosoft_waw_logic_api_TutorAPI.CAMP_COLLECT_REWARD_COUNTER = 4;
com_nevosoft_waw_logic_api_TutorAPI.ADDITIONAL_PURCHASE_NEED_RESOURCES_COUNTER = 5;
com_nevosoft_waw_logic_api_TutorAPI.MARKET_ORDER_NEED_RESOURCES_COUNTER = 6;
com_nevosoft_waw_logic_api_TutorAPI.UPGRADE_BUILDING_NEED_RESOURCES_COUNTER = 7;
com_nevosoft_waw_logic_api_TutorAPI.BUY_SECTOR_NEED_RESOURCES_COUNTER = 8;
com_nevosoft_waw_logic_api_TutorAPI.CAMP_NEED_RESOURCES_COUNTER = 9;
com_nevosoft_waw_logic_api_TutorAPI.QUEST_COUNTER = 10;
com_nevosoft_waw_logic_api_TutorAPI.CAMP_INIT_COUNTER = 11;
com_nevosoft_waw_logic_api_TutorAPI.SPAWN_NUT = 12;
com_nevosoft_waw_logic_api_TutorAPI.ACHIEVEMENT_HOUSE_TILE_X = 5;
com_nevosoft_waw_logic_api_TutorAPI.ACHIEVEMENT_HOUSE_TILE_Y = 30;
com_nevosoft_waw_logic_api_TutorAPI.HOUSE_META_ID = 156;
com_nevosoft_waw_logic_api_TutorAPI.ACHIEVEMENT_HOUSE_META_ID = 288;
com_nevosoft_waw_logic_api_TutorAPI.SAWMILL_META_ID = 106;
com_nevosoft_waw_logic_api_TutorAPI.FORGE_META_ID = 94;
com_nevosoft_waw_logic_api_TutorAPI.BULL_META_ID = 171;
com_nevosoft_waw_logic_api_TutorAPI.GARBAGE_META_ID = 420;
com_nevosoft_waw_logic_api_TutorAPI.GARBAGE_CPOSITIONS = [{ x : 22, y : 22},{ x : 22, y : 20},{ x : 20, y : 23}];
com_nevosoft_waw_logic_api_TutorAPI.EVENT_6_THORN_META_ID = 682;
com_nevosoft_waw_logic_api_TutorAPI.EVENT_6_THORN_CPOSITIONS = [{ x : 20, y : 91},{ x : 20, y : 94},{ x : 20, y : 98},{ x : 21, y : 96},{ x : 22, y : 94}];
com_nevosoft_waw_logic_api_TutorAPI.MAP_TILE_SIZE = 32;
com_nevosoft_waw_logic_api_TutorAPI.GOLD_RES_ID = -1;
com_nevosoft_waw_logic_api_TutorAPI.GOLD_RES_VALUE_SPELLS = 47;
com_nevosoft_waw_logic_api_TutorAPI.GOLD_RES_VALUE_FEED_FACTORY = 60;
com_nevosoft_waw_logic_api_TutorAPI.INIT_PLANTS_META_ID = 252;
com_nevosoft_waw_logic_api_TutorAPI.FARM_CELL = 159;
com_nevosoft_waw_logic_api_TutorAPI.ABANDONED_FARM_CELL = 606;
com_nevosoft_waw_logic_api_TutorAPI.CRYSTAL_MUSHROOM_META_ID = 691;
com_nevosoft_waw_logic_api_TutorAPI.ENERGY_POT_META_ID = 715;
com_nevosoft_waw_logic_api_TutorAPI.FIRST_QUEST_ID = 16;
com_nevosoft_waw_logic_systems_Restrictions.LEVEL_GREATER_THAN_OR_EQUAL = "1";
com_nevosoft_waw_logic_systems_Restrictions.QUEST_COMPLETE = "2";
com_nevosoft_waw_logic_systems_Restrictions.BUILDING_LEVEL = "3";
com_nevosoft_waw_logic_systems_Restrictions.QUEST_ACTIVE = "5";
com_nevosoft_waw_logic_systems_Restrictions.LEVEL_RANGE = "6";
com_nevosoft_waw_logic_systems_Restrictions.HAS_ITEM = "7";
com_nevosoft_waw_logic_systems_Restrictions.PAYER = "8";
com_nevosoft_waw_logic_systems_Restrictions.BIG_PAYER = "9";
com_nevosoft_waw_logic_systems_Restrictions.ACTION_DONE = "10";
com_nevosoft_waw_logic_systems_Restrictions.SECTOR_OPENED = "11";
com_nevosoft_waw_logic_systems_Restrictions.RESOURCE_GOT = "12";
com_nevosoft_waw_logic_systems_Restrictions.TUTOR_CHECKPOINT_GE_THAN = "13";
com_nevosoft_waw_logic_systems_Restrictions.COMMING_SOON = "14";
com_nevosoft_waw_logic_systems_Restrictions.PAY_AVG_MONETARY = "15";
com_nevosoft_waw_logic_systems_Restrictions.PAY_MONETARY = "16";
com_nevosoft_waw_logic_systems_Restrictions.PAY_RECENCY = "17";
com_nevosoft_waw_logic_systems_Restrictions.PAY_FREQUENCY = "18";
com_nevosoft_waw_logic_systems_Restrictions.LOT_IN_OFFER_BOUGHT = "19";
com_nevosoft_waw_logic_systems_Restrictions.AFTER_OFFER_DEACTIVATED = "20";
com_nevosoft_waw_logic_systems_Restrictions.WAS_OFFLINE_FOR = "21";
com_nevosoft_waw_logic_systems_Restrictions.LEVEL_LESS_THAN_OR_EQUAL = "22";
com_nevosoft_waw_logic_systems_Restrictions.LEVEL_EQUAL = "23";
com_nevosoft_waw_logic_systems_Restrictions.AFTER_LAST_OFFER_DEACTIVATED = "24";
com_nevosoft_waw_logic_systems_Restrictions.RESOURCE_AMOUNT_LESS_THAN = "25";
com_nevosoft_waw_logic_systems_Restrictions.BUILDING_LEVEL_PENDING = "26";
com_nevosoft_waw_logic_systems_Restrictions.LEVEL_EQUALS_ONE_OF = "27";
com_nevosoft_waw_logic_systems_Restrictions.OFFER_WAS_ACTIVATED = "28";
com_nevosoft_waw_logic_systems_Restrictions.ONE_OF_OFFER_LOTS_BOUGHT = "29";
com_nevosoft_waw_logic_systems_Restrictions.EVENT_EQUALS = "30";
com_nevosoft_waw_logic_systems_Restrictions.BUILDING_EXISTS = "31";
com_nevosoft_waw_logic_systems_Restrictions.EVENT_COMPLETE = "32";
com_nevosoft_waw_logic_systems_Restrictions.LIMIT_REACHED = "33";
com_nevosoft_waw_logic_systems_Restrictions.LAST_PERIODICAL_REWARD_COLLECTED = "34";
com_nevosoft_waw_logic_systems_Restrictions.INV_LEVEL_GE_THAN = "-1";
com_nevosoft_waw_logic_systems_Restrictions.INV_QUEST_COMPLETE = "-2";
com_nevosoft_waw_logic_systems_Restrictions.INV_BUILDING_LEVEL = "-3";
com_nevosoft_waw_logic_systems_Restrictions.INV_QUEST_ACTIVE = "-5";
com_nevosoft_waw_logic_systems_Restrictions.INV_LEVEL_RANGE = "-6";
com_nevosoft_waw_logic_systems_Restrictions.INV_HAS_ITEM = "-7";
com_nevosoft_waw_logic_systems_Restrictions.INV_PAYER = "-8";
com_nevosoft_waw_logic_systems_Restrictions.INV_BIG_PAYER = "-9";
com_nevosoft_waw_logic_systems_Restrictions.INV_ACTION_DONE = "-10";
com_nevosoft_waw_logic_systems_Restrictions.INV_SECTOR_OPENED = "-11";
com_nevosoft_waw_logic_systems_Restrictions.INV_RESOURCE_GOT = "-12";
com_nevosoft_waw_logic_systems_Restrictions.INV_TUTOR_CHECKPOINT_GE_THAN = "-13";
com_nevosoft_waw_logic_systems_Restrictions.INV_COMMING_SOON = "-14";
com_nevosoft_waw_logic_systems_Restrictions.INV_LOT_IN_OFFER_BOUGHT = "-19";
com_nevosoft_waw_logic_systems_Restrictions.INV_BUILDING_EXISTS = "-31";
com_nevosoft_waw_logic_systems_Restrictions.INV_EVENT_COMPLETE = "-32";
com_nevosoft_waw_logic_systems_Restrictions.INV_LIMIT_REACHED = "-33";
com_nevosoft_waw_logic_systems_Restrictions.PAYER_THRESHOLD = 100;
com_nevosoft_waw_logic_systems_Restrictions.BIG_PAYER_THRESHOLD = 1000;
com_nevosoft_waw_logic_systems_quests_DailyQuestEntity.DAILY_QUEST_ID = -1;
com_nevosoft_waw_tutorial_ETutorCheckpoints.START = 0;
com_nevosoft_waw_tutorial_ETutorCheckpoints.INTRO_SCENE = 1;
com_nevosoft_waw_tutorial_ETutorCheckpoints.FIX_HOUSES_SCENE = 2;
com_nevosoft_waw_tutorial_ETutorCheckpoints.PLANTS_SCENE = 3;
com_nevosoft_waw_tutorial_ETutorCheckpoints.ANIMALS_SCENE = 4;
com_nevosoft_waw_tutorial_ETutorCheckpoints.PRODUCE_IRON_SCENE = 5;
com_nevosoft_waw_tutorial_ETutorCheckpoints.MARKET_SELL_SCENE = 6;
com_nevosoft_waw_tutorial_ETutorCheckpoints.FIRST_QUEST_SCENE = 7;
com_nevosoft_waw_tutorial_ETutorCheckpoints.MAIN_PART_END = 8;
com_nevosoft_waw_tutorial_ETutorCheckpoints.SPELLS_SCENE = 9;
com_nevosoft_waw_tutorial_ETutorCheckpoints.SPELLS_SCENE_FINISHED = 10;
com_nevosoft_waw_tutorial_ETutorCheckpoints.ANIMALS_COLLECT_SCENE = 11;
com_nevosoft_waw_tutorial_ETutorCheckpoints.MARKET_RELEASED = 12;
com_nevosoft_waw_tutorial_ETutorCheckpoints.TUTORIAL_FINISHED = 13;
com_nevosoft_waw_tutorial_ETutorCheckpoints.BUY_FARM_CELL_FINISHED = 14;
com_nevosoft_waw_tutorial_ETutorCheckpoints.ALL_FOLLOWING_SCENARIOS_FINISHED = 15;
haxe_Template.splitter = new EReg("(::[A-Za-z0-9_ ()&|!+=/><*.\"-]+::|\\$\\$([A-Za-z0-9_-]+)\\()","");
haxe_Template.expr_splitter = new EReg("(\\(|\\)|[ \r\n\t]*\"[^\"]*\"[ \r\n\t]*|[!+=/><*.&|-]+)","");
haxe_Template.expr_trim = new EReg("^[ ]*([^ ]+)[ ]*$","");
haxe_Template.expr_int = new EReg("^[0-9]+$","");
haxe_Template.expr_float = new EReg("^([+-]?)(?=\\d|,\\d)\\d*(,\\d*)?([Ee]([+-]?\\d+))?$","");
haxe_Template.globals = { };
haxe_Template.hxKeepArrayIterator = new haxe_iterators_ArrayIterator([]);
haxe_crypto_Base64.CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
haxe_crypto_Base64.BYTES = haxe_io_Bytes.ofString(haxe_crypto_Base64.CHARS);
spine_MathUtils.radDeg = 180 / Math.PI;
spine_MathUtils.degRad = Math.PI / 180;
spine_PathConstraint.NONE = -1;
spine_PathConstraint.BEFORE = -2;
spine_PathConstraint.AFTER = -3;
spine_SkeletonBinary.BONE_ROTATE = 0;
spine_SkeletonBinary.BONE_TRANSLATE = 1;
spine_SkeletonBinary.BONE_SCALE = 2;
spine_SkeletonBinary.BONE_SHEAR = 3;
spine_SkeletonBinary.SLOT_ATTACHMENT = 0;
spine_SkeletonBinary.SLOT_COLOR = 1;
spine_SkeletonBinary.SLOT_TWO_COLOR = 2;
spine_SkeletonBinary.PATH_POSITION = 0;
spine_SkeletonBinary.PATH_SPACING = 1;
spine_SkeletonBinary.PATH_MIX = 2;
spine_SkeletonBinary.CURVE_LINEAR = 0;
spine_SkeletonBinary.CURVE_STEPPED = 1;
spine_SkeletonBinary.CURVE_BEZIER = 2;
spine_animation_CurveTimeline.LINEAR = 0;
spine_animation_CurveTimeline.STEPPED = 1;
spine_animation_CurveTimeline.BEZIER = 2;
spine_animation_CurveTimeline.BEZIER_SIZE = 19;
spine_animation_ColorTimeline.ENTRIES = 5;
spine_animation_ColorTimeline.PREV_TIME = -5;
spine_animation_ColorTimeline.PREV_R = -4;
spine_animation_ColorTimeline.PREV_G = -3;
spine_animation_ColorTimeline.PREV_B = -2;
spine_animation_ColorTimeline.PREV_A = -1;
spine_animation_ColorTimeline.R = 1;
spine_animation_ColorTimeline.G = 2;
spine_animation_ColorTimeline.B = 3;
spine_animation_ColorTimeline.A = 4;
spine_animation_IkConstraintTimeline.ENTRIES = 3;
spine_animation_IkConstraintTimeline.PREV_TIME = -3;
spine_animation_IkConstraintTimeline.PREV_MIX = -2;
spine_animation_IkConstraintTimeline.PREV_BEND_DIRECTION = -1;
spine_animation_IkConstraintTimeline.MIX = 1;
spine_animation_IkConstraintTimeline.BEND_DIRECTION = 2;
spine_animation_PathConstraintMixTimeline.ENTRIES = 3;
spine_animation_PathConstraintMixTimeline.PREV_TIME = -3;
spine_animation_PathConstraintMixTimeline.PREV_ROTATE = -2;
spine_animation_PathConstraintMixTimeline.PREV_TRANSLATE = -1;
spine_animation_PathConstraintMixTimeline.ROTATE = 1;
spine_animation_PathConstraintMixTimeline.TRANSLATE = 2;
spine_animation_PathConstraintPositionTimeline.ENTRIES = 2;
spine_animation_PathConstraintPositionTimeline.PREV_TIME = -2;
spine_animation_PathConstraintPositionTimeline.PREV_VALUE = -1;
spine_animation_PathConstraintPositionTimeline.VALUE = 1;
spine_animation_RotateTimeline.ENTRIES = 2;
spine_animation_RotateTimeline.PREV_TIME = -2;
spine_animation_RotateTimeline.PREV_ROTATION = -1;
spine_animation_RotateTimeline.ROTATION = 1;
spine_animation_TranslateTimeline.ENTRIES = 3;
spine_animation_TranslateTimeline.PREV_TIME = -3;
spine_animation_TranslateTimeline.PREV_X = -2;
spine_animation_TranslateTimeline.PREV_Y = -1;
spine_animation_TranslateTimeline.X = 1;
spine_animation_TranslateTimeline.Y = 2;
spine_animation_TransformConstraintTimeline.ENTRIES = 5;
spine_animation_TransformConstraintTimeline.PREV_TIME = -5;
spine_animation_TransformConstraintTimeline.PREV_ROTATE = -4;
spine_animation_TransformConstraintTimeline.PREV_TRANSLATE = -3;
spine_animation_TransformConstraintTimeline.PREV_SCALE = -2;
spine_animation_TransformConstraintTimeline.PREV_SHEAR = -1;
spine_animation_TransformConstraintTimeline.ROTATE = 1;
spine_animation_TransformConstraintTimeline.TRANSLATE = 2;
spine_animation_TransformConstraintTimeline.SCALE = 3;
spine_animation_TransformConstraintTimeline.SHEAR = 4;
})(typeof exports != "undefined" ? exports : typeof window != "undefined" ? window : typeof self != "undefined" ? self : this, typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this);



//////////////////
// WEBPACK FOOTER
// /opt/app/util/spine-validator/dist/spine-validator.js
// module id = ../../../../../../util/spine-validator/dist/spine-validator.js
// module chunks = 0